//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.0.2.0 (NJsonSchema v11.0.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import { Router } from '@angular/router';
import { AccountManageService } from 'src/app/services/accountManage.service';
import { ApiConfigService } from './api-config.service';
import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, from as _observableFrom, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

import moment from 'moment';
import 'moment-duration-format';

export const API_BASE_URL = new InjectionToken<string>('API_BASE_URL');

export class ServiceBase {
    constructor(protected apiConfigService: ApiConfigService) {}
    protected transformOptions(options: any) {
        return Promise.resolve(options);
    }

    protected transformResult(url: string, response: any, processor: (response: HttpResponse<Blob>) => any): Observable<any> {
        if ((response['name'] === 'HttpErrorResponse' && response['status'] === 0) || response['status'] === 401) {
            console.log(response);
            this.apiConfigService.handleInvalidRequest();
            return;
        }
        return processor(response);
    }
}

@Injectable()
export class AccountService extends ServiceBase {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(ApiConfigService) configuration: ApiConfigService, @Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super(configuration);
        this.http = http;
        this.baseUrl = baseUrl ?? "https://";
    }

    isCookieValid(): Observable<UserDto> {
        let url_ = this.baseUrl + "/api/accounts/isCookieValid";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processIsCookieValid(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processIsCookieValid(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserDto>;
        }));
    }

    protected processIsCookieValid(response: HttpResponseBase): Observable<UserDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                this.apiConfigService.selectAnyTranslations(resultData200);       
            }
            result200 = UserDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("A server error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    logout(): Observable<void> {
        let url_ = this.baseUrl + "/api/accounts/logout";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processLogout(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processLogout(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processLogout(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("A server error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    employeeProfile(): Observable<EmployeeViewModel> {
        let url_ = this.baseUrl + "/api/accounts/EmployeeProfile";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processEmployeeProfile(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processEmployeeProfile(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EmployeeViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EmployeeViewModel>;
        }));
    }

    protected processEmployeeProfile(response: HttpResponseBase): Observable<EmployeeViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                this.apiConfigService.selectAnyTranslations(resultData200);       
            }
            result200 = EmployeeViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData400) {
                this.apiConfigService.selectAnyTranslations(resultData400);       
            }
            result400 = SerializableError.fromJS(resultData400);
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    editEmployeeProfile(command: UpdateProfileCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/accounts/EditEmployeeProfile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("put", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processEditEmployeeProfile(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processEditEmployeeProfile(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processEditEmployeeProfile(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData400) {
                this.apiConfigService.selectAnyTranslations(resultData400);       
            }
            result400 = SerializableError.fromJS(resultData400);
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    login(loginViewModel: LoginViewModel): Observable<UserDto> {
        let url_ = this.baseUrl + "/api/accounts/login";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(loginViewModel);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processLogin(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processLogin(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserDto>;
        }));
    }

    protected processLogin(response: HttpResponseBase): Observable<UserDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                this.apiConfigService.selectAnyTranslations(resultData200);       
            }
            result200 = UserDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData400) {
                this.apiConfigService.selectAnyTranslations(resultData400);       
            }
            result400 = SerializableError.fromJS(resultData400);
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    changePassword(model: ChangePasswordViewModel): Observable<IdentityResult> {
        let url_ = this.baseUrl + "/api/accounts/changePassword";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processChangePassword(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processChangePassword(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IdentityResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IdentityResult>;
        }));
    }

    protected processChangePassword(response: HttpResponseBase): Observable<IdentityResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                this.apiConfigService.selectAnyTranslations(resultData200);       
            }
            result200 = IdentityResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData400) {
                this.apiConfigService.selectAnyTranslations(resultData400);       
            }
            result400 = SerializableError.fromJS(resultData400);
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    refreshUser(): Observable<UserDto> {
        let url_ = this.baseUrl + "/api/accounts/refreshUser";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processRefreshUser(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processRefreshUser(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserDto>;
        }));
    }

    protected processRefreshUser(response: HttpResponseBase): Observable<UserDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                this.apiConfigService.selectAnyTranslations(resultData200);       
            }
            result200 = UserDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData400) {
                this.apiConfigService.selectAnyTranslations(resultData400);       
            }
            result400 = SerializableError.fromJS(resultData400);
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ApplianceRegionsService extends ServiceBase {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(ApiConfigService) configuration: ApiConfigService, @Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super(configuration);
        this.http = http;
        this.baseUrl = baseUrl ?? "https://";
    }

    applianceRegions(query: GetAppliancesRegionsQuery): Observable<PaginatedResultOfAppliancesRegionDto> {
        let url_ = this.baseUrl + "/api/applianceRegions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processApplianceRegions(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processApplianceRegions(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PaginatedResultOfAppliancesRegionDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PaginatedResultOfAppliancesRegionDto>;
        }));
    }

    protected processApplianceRegions(response: HttpResponseBase): Observable<PaginatedResultOfAppliancesRegionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                this.apiConfigService.selectAnyTranslations(resultData200);       
            }
            result200 = PaginatedResultOfAppliancesRegionDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData400) {
                this.apiConfigService.selectAnyTranslations(resultData400);       
            }
            result400 = SerializableError.fromJS(resultData400);
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    applianceRegion(id: number): Observable<AppliancesRegionDto> {
        let url_ = this.baseUrl + "/api/applianceRegions/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processApplianceRegion(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processApplianceRegion(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AppliancesRegionDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AppliancesRegionDto>;
        }));
    }

    protected processApplianceRegion(response: HttpResponseBase): Observable<AppliancesRegionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                this.apiConfigService.selectAnyTranslations(resultData200);       
            }
            result200 = AppliancesRegionDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData400) {
                this.apiConfigService.selectAnyTranslations(resultData400);       
            }
            result400 = SerializableError.fromJS(resultData400);
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    create(command: CreateAppliancesRegionCommand): Observable<string> {
        let url_ = this.baseUrl + "/api/applianceRegions/create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processCreate(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processCreate(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                this.apiConfigService.selectAnyTranslations(resultData200);       
            }
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData400) {
                this.apiConfigService.selectAnyTranslations(resultData400);       
            }
            result400 = SerializableError.fromJS(resultData400);
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    edit(command: EditAppliancesRegionCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/applianceRegions/edit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("put", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processEdit(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processEdit(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData400) {
                this.apiConfigService.selectAnyTranslations(resultData400);       
            }
            result400 = SerializableError.fromJS(resultData400);
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    addSectorToAppliancesRegion(command: AddSectorToAppliancesRegionCommand): Observable<string> {
        let url_ = this.baseUrl + "/api/applianceRegions/addSectorToAppliancesRegion";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processAddSectorToAppliancesRegion(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processAddSectorToAppliancesRegion(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processAddSectorToAppliancesRegion(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                this.apiConfigService.selectAnyTranslations(resultData200);       
            }
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData400) {
                this.apiConfigService.selectAnyTranslations(resultData400);       
            }
            result400 = SerializableError.fromJS(resultData400);
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    changeAppliancesRegionActive(command: ChangeAppliancesRegionActiveCommand): Observable<string> {
        let url_ = this.baseUrl + "/api/applianceRegions/changeAppliancesRegionActive";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("put", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processChangeAppliancesRegionActive(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processChangeAppliancesRegionActive(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processChangeAppliancesRegionActive(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                this.apiConfigService.selectAnyTranslations(resultData200);       
            }
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData400) {
                this.apiConfigService.selectAnyTranslations(resultData400);       
            }
            result400 = SerializableError.fromJS(resultData400);
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteAppliancesRegionSector(command: DeleteApplianceRegionSectorCommand): Observable<string> {
        let url_ = this.baseUrl + "/api/applianceRegions/deleteAppliancesRegionSector";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processDeleteAppliancesRegionSector(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processDeleteAppliancesRegionSector(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processDeleteAppliancesRegionSector(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                this.apiConfigService.selectAnyTranslations(resultData200);       
            }
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData400) {
                this.apiConfigService.selectAnyTranslations(resultData400);       
            }
            result400 = SerializableError.fromJS(resultData400);
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class AppliancesService extends ServiceBase {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(ApiConfigService) configuration: ApiConfigService, @Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super(configuration);
        this.http = http;
        this.baseUrl = baseUrl ?? "https://";
    }

    appliances(query: GetApplianceListQuery): Observable<PaginatedResultOfApplianceLookupDto> {
        let url_ = this.baseUrl + "/api/Appliances/Appliances";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processAppliances(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processAppliances(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PaginatedResultOfApplianceLookupDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PaginatedResultOfApplianceLookupDto>;
        }));
    }

    protected processAppliances(response: HttpResponseBase): Observable<PaginatedResultOfApplianceLookupDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                this.apiConfigService.selectAnyTranslations(resultData200);       
            }
            result200 = PaginatedResultOfApplianceLookupDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData400) {
                this.apiConfigService.selectAnyTranslations(resultData400);       
            }
            result400 = SerializableError.fromJS(resultData400);
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    appliance(id: string): Observable<ApplianceDto> {
        let url_ = this.baseUrl + "/api/Appliances/Appliance/appliance/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processAppliance(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processAppliance(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplianceDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplianceDto>;
        }));
    }

    protected processAppliance(response: HttpResponseBase): Observable<ApplianceDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                this.apiConfigService.selectAnyTranslations(resultData200);       
            }
            result200 = ApplianceDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData400) {
                this.apiConfigService.selectAnyTranslations(resultData400);       
            }
            result400 = SerializableError.fromJS(resultData400);
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    edit(command: EditApplianceCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/Appliances/Edit/edit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("put", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processEdit(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processEdit(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData400) {
                this.apiConfigService.selectAnyTranslations(resultData400);       
            }
            result400 = SerializableError.fromJS(resultData400);
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    create(command: CreateApplianceCommand): Observable<string> {
        let url_ = this.baseUrl + "/api/Appliances/Create/create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processCreate(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processCreate(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                this.apiConfigService.selectAnyTranslations(resultData200);       
            }
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData400) {
                this.apiConfigService.selectAnyTranslations(resultData400);       
            }
            result400 = SerializableError.fromJS(resultData400);
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    applianceRegions(): Observable<ApplianceRegionDto[]> {
        let url_ = this.baseUrl + "/api/Appliances/ApplianceRegions/applianceRegions";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processApplianceRegions(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processApplianceRegions(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplianceRegionDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplianceRegionDto[]>;
        }));
    }

    protected processApplianceRegions(response: HttpResponseBase): Observable<ApplianceRegionDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                this.apiConfigService.selectAnyTranslations(resultData200);       
            }
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ApplianceRegionDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData400) {
                this.apiConfigService.selectAnyTranslations(resultData400);       
            }
            result400 = SerializableError.fromJS(resultData400);
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    activateAppliance(command: ActivateApplianceCommand): Observable<ApplianceDto> {
        let url_ = this.baseUrl + "/api/Appliances/ActivateAppliance/activateAppliance";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processActivateAppliance(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processActivateAppliance(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplianceDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplianceDto>;
        }));
    }

    protected processActivateAppliance(response: HttpResponseBase): Observable<ApplianceDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                this.apiConfigService.selectAnyTranslations(resultData200);       
            }
            result200 = ApplianceDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData400) {
                this.apiConfigService.selectAnyTranslations(resultData400);       
            }
            result400 = SerializableError.fromJS(resultData400);
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deactivateAppliance(command: DeactivateApplianceCommand): Observable<ApplianceDto> {
        let url_ = this.baseUrl + "/api/Appliances/DeactivateAppliance/deactivateAppliance";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processDeactivateAppliance(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processDeactivateAppliance(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplianceDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplianceDto>;
        }));
    }

    protected processDeactivateAppliance(response: HttpResponseBase): Observable<ApplianceDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                this.apiConfigService.selectAnyTranslations(resultData200);       
            }
            result200 = ApplianceDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData400) {
                this.apiConfigService.selectAnyTranslations(resultData400);       
            }
            result400 = SerializableError.fromJS(resultData400);
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class AppointmentQualificationsService extends ServiceBase {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(ApiConfigService) configuration: ApiConfigService, @Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super(configuration);
        this.http = http;
        this.baseUrl = baseUrl ?? "https://";
    }

    appointmentQualifications(query: GetAppointmentQualificationsListQuery): Observable<PaginatedResultOfAppointmentQualificationLookupDto> {
        let url_ = this.baseUrl + "/api/appointmentqualifications";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processAppointmentQualifications(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processAppointmentQualifications(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PaginatedResultOfAppointmentQualificationLookupDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PaginatedResultOfAppointmentQualificationLookupDto>;
        }));
    }

    protected processAppointmentQualifications(response: HttpResponseBase): Observable<PaginatedResultOfAppointmentQualificationLookupDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                this.apiConfigService.selectAnyTranslations(resultData200);       
            }
            result200 = PaginatedResultOfAppointmentQualificationLookupDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData400) {
                this.apiConfigService.selectAnyTranslations(resultData400);       
            }
            result400 = SerializableError.fromJS(resultData400);
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    appointmentQualification(callNo: number): Observable<AppointmentQualificationDto> {
        let url_ = this.baseUrl + "/api/appointmentqualifications/{callNo}";
        if (callNo === undefined || callNo === null)
            throw new Error("The parameter 'callNo' must be defined.");
        url_ = url_.replace("{callNo}", encodeURIComponent("" + callNo));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processAppointmentQualification(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processAppointmentQualification(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AppointmentQualificationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AppointmentQualificationDto>;
        }));
    }

    protected processAppointmentQualification(response: HttpResponseBase): Observable<AppointmentQualificationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                this.apiConfigService.selectAnyTranslations(resultData200);       
            }
            result200 = AppointmentQualificationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData400) {
                this.apiConfigService.selectAnyTranslations(resultData400);       
            }
            result400 = SerializableError.fromJS(resultData400);
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateQualification(command: UpdateQualificationCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/appointmentqualifications/updateQualification";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processUpdateQualification(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processUpdateQualification(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processUpdateQualification(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                this.apiConfigService.selectAnyTranslations(resultData200);       
            }
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData400) {
                this.apiConfigService.selectAnyTranslations(resultData400);       
            }
            result400 = SerializableError.fromJS(resultData400);
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    putUpForReview(command: PutUpForReviewCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/appointmentqualifications/putUpForReview";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processPutUpForReview(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processPutUpForReview(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processPutUpForReview(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData400) {
                this.apiConfigService.selectAnyTranslations(resultData400);       
            }
            result400 = SerializableError.fromJS(resultData400);
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class AppointmentsService extends ServiceBase {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(ApiConfigService) configuration: ApiConfigService, @Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super(configuration);
        this.http = http;
        this.baseUrl = baseUrl ?? "https://";
    }

    appointments(query: GetLegacyAppointmentListQuery): Observable<PaginatedResultOfAppointmentLookupDto> {
        let url_ = this.baseUrl + "/api/appointments";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processAppointments(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processAppointments(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PaginatedResultOfAppointmentLookupDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PaginatedResultOfAppointmentLookupDto>;
        }));
    }

    protected processAppointments(response: HttpResponseBase): Observable<PaginatedResultOfAppointmentLookupDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                this.apiConfigService.selectAnyTranslations(resultData200);       
            }
            result200 = PaginatedResultOfAppointmentLookupDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData400) {
                this.apiConfigService.selectAnyTranslations(resultData400);       
            }
            result400 = SerializableError.fromJS(resultData400);
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    edit(command: EditLegacyAppointmentCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/appointments";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("put", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processEdit(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processEdit(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData400) {
                this.apiConfigService.selectAnyTranslations(resultData400);       
            }
            result400 = SerializableError.fromJS(resultData400);
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    appointment(id: string): Observable<AppointmentDto> {
        let url_ = this.baseUrl + "/api/appointments/appointment/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processAppointment(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processAppointment(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AppointmentDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AppointmentDto>;
        }));
    }

    protected processAppointment(response: HttpResponseBase): Observable<AppointmentDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                this.apiConfigService.selectAnyTranslations(resultData200);       
            }
            result200 = AppointmentDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData400) {
                this.apiConfigService.selectAnyTranslations(resultData400);       
            }
            result400 = SerializableError.fromJS(resultData400);
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    clientLeadProfile(clientLeadId: number): Observable<AppointmentDto> {
        let url_ = this.baseUrl + "/api/appointments/clientLeadProfile/{clientLeadId}";
        if (clientLeadId === undefined || clientLeadId === null)
            throw new Error("The parameter 'clientLeadId' must be defined.");
        url_ = url_.replace("{clientLeadId}", encodeURIComponent("" + clientLeadId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processClientLeadProfile(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processClientLeadProfile(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AppointmentDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AppointmentDto>;
        }));
    }

    protected processClientLeadProfile(response: HttpResponseBase): Observable<AppointmentDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                this.apiConfigService.selectAnyTranslations(resultData200);       
            }
            result200 = AppointmentDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData400) {
                this.apiConfigService.selectAnyTranslations(resultData400);       
            }
            result400 = SerializableError.fromJS(resultData400);
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    legacyAppointment(callNo: number): Observable<AppointmentDto> {
        let url_ = this.baseUrl + "/api/appointments/legacyAppointment/{callNo}";
        if (callNo === undefined || callNo === null)
            throw new Error("The parameter 'callNo' must be defined.");
        url_ = url_.replace("{callNo}", encodeURIComponent("" + callNo));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processLegacyAppointment(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processLegacyAppointment(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AppointmentDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AppointmentDto>;
        }));
    }

    protected processLegacyAppointment(response: HttpResponseBase): Observable<AppointmentDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                this.apiConfigService.selectAnyTranslations(resultData200);       
            }
            result200 = AppointmentDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData400) {
                this.apiConfigService.selectAnyTranslations(resultData400);       
            }
            result400 = SerializableError.fromJS(resultData400);
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    delete(id: string): Observable<void> {
        let url_ = this.baseUrl + "/api/appointments/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("delete", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processDelete(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processDelete(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData400) {
                this.apiConfigService.selectAnyTranslations(resultData400);       
            }
            result400 = SerializableError.fromJS(resultData400);
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    legacyDelete(callNo: number): Observable<void> {
        let url_ = this.baseUrl + "/api/appointments/legacyDelete/{callNo}";
        if (callNo === undefined || callNo === null)
            throw new Error("The parameter 'callNo' must be defined.");
        url_ = url_.replace("{callNo}", encodeURIComponent("" + callNo));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("delete", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processLegacyDelete(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processLegacyDelete(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processLegacyDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData400) {
                this.apiConfigService.selectAnyTranslations(resultData400);       
            }
            result400 = SerializableError.fromJS(resultData400);
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    create(command: CreateLegacyAppointmentCommand): Observable<string> {
        let url_ = this.baseUrl + "/api/appointments/create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processCreate(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processCreate(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                this.apiConfigService.selectAnyTranslations(resultData200);       
            }
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData400) {
                this.apiConfigService.selectAnyTranslations(resultData400);       
            }
            result400 = SerializableError.fromJS(resultData400);
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    createOrEditClientLeadProfile(command: CreateOrEditClientLeadProfileCommand): Observable<string> {
        let url_ = this.baseUrl + "/api/appointments/createOrEditClientLeadProfile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processCreateOrEditClientLeadProfile(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processCreateOrEditClientLeadProfile(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processCreateOrEditClientLeadProfile(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                this.apiConfigService.selectAnyTranslations(resultData200);       
            }
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData400) {
                this.apiConfigService.selectAnyTranslations(resultData400);       
            }
            result400 = SerializableError.fromJS(resultData400);
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    addToDoNotCallList(command: AddToDoNotCallListCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/appointments/addToDoNotCallList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processAddToDoNotCallList(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processAddToDoNotCallList(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAddToDoNotCallList(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData400) {
                this.apiConfigService.selectAnyTranslations(resultData400);       
            }
            result400 = SerializableError.fromJS(resultData400);
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    calculateRating(command: CalculateAppointmentRatingCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/appointments/calculateRating";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processCalculateRating(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processCalculateRating(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCalculateRating(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                this.apiConfigService.selectAnyTranslations(resultData200);       
            }
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData400) {
                this.apiConfigService.selectAnyTranslations(resultData400);       
            }
            result400 = SerializableError.fromJS(resultData400);
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    generateTestAppointment(): Observable<void> {
        let url_ = this.baseUrl + "/api/appointments/generateTestAppointment";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processGenerateTestAppointment(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGenerateTestAppointment(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processGenerateTestAppointment(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData400) {
                this.apiConfigService.selectAnyTranslations(resultData400);       
            }
            result400 = SerializableError.fromJS(resultData400);
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class AuthService extends ServiceBase {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(ApiConfigService) configuration: ApiConfigService, @Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super(configuration);
        this.http = http;
        this.baseUrl = baseUrl ?? "https://";
    }

    get(): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/Auth";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processGet(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGet(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: <any>responseBlob, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    post(credentials: CredentialsViewModel): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/Auth/login";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(credentials);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processPost(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processPost(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processPost(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: <any>responseBlob, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class BackgroundJobService extends ServiceBase {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(ApiConfigService) configuration: ApiConfigService, @Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super(configuration);
        this.http = http;
        this.baseUrl = baseUrl ?? "https://";
    }

    get(id: string): Observable<BackgroundJobDto> {
        let url_ = this.baseUrl + "/api/appointments/backgroundJob/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processGet(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGet(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BackgroundJobDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BackgroundJobDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<BackgroundJobDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                this.apiConfigService.selectAnyTranslations(resultData200);       
            }
            result200 = BackgroundJobDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData400) {
                this.apiConfigService.selectAnyTranslations(resultData400);       
            }
            result400 = SerializableError.fromJS(resultData400);
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class BlanketOrderMgmtService extends ServiceBase {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(ApiConfigService) configuration: ApiConfigService, @Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super(configuration);
        this.http = http;
        this.baseUrl = baseUrl ?? "https://";
    }

    getBlanketOrdersFromQuery(query: GetBlanketOrdersQuery): Observable<ErpSalesOrderDto[]> {
        let url_ = this.baseUrl + "/api/blanketOrderMgmt/getBlanketOrdersFromQuery";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processGetBlanketOrdersFromQuery(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetBlanketOrdersFromQuery(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ErpSalesOrderDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ErpSalesOrderDto[]>;
        }));
    }

    protected processGetBlanketOrdersFromQuery(response: HttpResponseBase): Observable<ErpSalesOrderDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                this.apiConfigService.selectAnyTranslations(resultData200);       
            }
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ErpSalesOrderDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData400) {
                this.apiConfigService.selectAnyTranslations(resultData400);       
            }
            result400 = SerializableError.fromJS(resultData400);
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getBlanketOrderByOrderNbr(query: GetBlanketOrderByOrderNbrQuery): Observable<ErpSalesOrderDto> {
        let url_ = this.baseUrl + "/api/blanketOrderMgmt/getBlanketOrderByOrderNbr";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processGetBlanketOrderByOrderNbr(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetBlanketOrderByOrderNbr(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ErpSalesOrderDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ErpSalesOrderDto>;
        }));
    }

    protected processGetBlanketOrderByOrderNbr(response: HttpResponseBase): Observable<ErpSalesOrderDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                this.apiConfigService.selectAnyTranslations(resultData200);       
            }
            result200 = ErpSalesOrderDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData400) {
                this.apiConfigService.selectAnyTranslations(resultData400);       
            }
            result400 = SerializableError.fromJS(resultData400);
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getBlanketOrderByOrderNbrWithChildOrders(query: GetBlanketOrderByOrderNbrWithChildOrders): Observable<BlanketOrderWithChildOrdersDto> {
        let url_ = this.baseUrl + "/api/blanketOrderMgmt/getBlanketOrderByOrderNbrWithChildOrders";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processGetBlanketOrderByOrderNbrWithChildOrders(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetBlanketOrderByOrderNbrWithChildOrders(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BlanketOrderWithChildOrdersDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BlanketOrderWithChildOrdersDto>;
        }));
    }

    protected processGetBlanketOrderByOrderNbrWithChildOrders(response: HttpResponseBase): Observable<BlanketOrderWithChildOrdersDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                this.apiConfigService.selectAnyTranslations(resultData200);       
            }
            result200 = BlanketOrderWithChildOrdersDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData400) {
                this.apiConfigService.selectAnyTranslations(resultData400);       
            }
            result400 = SerializableError.fromJS(resultData400);
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getSalesOrdersUnderBlanketOrder(query: GetSalesOrdersUnderBlanketOrderQuery): Observable<ErpSalesOrderDto[]> {
        let url_ = this.baseUrl + "/api/blanketOrderMgmt/getSalesOrdersUnderBlanketOrder";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processGetSalesOrdersUnderBlanketOrder(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetSalesOrdersUnderBlanketOrder(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ErpSalesOrderDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ErpSalesOrderDto[]>;
        }));
    }

    protected processGetSalesOrdersUnderBlanketOrder(response: HttpResponseBase): Observable<ErpSalesOrderDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                this.apiConfigService.selectAnyTranslations(resultData200);       
            }
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ErpSalesOrderDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData400) {
                this.apiConfigService.selectAnyTranslations(resultData400);       
            }
            result400 = SerializableError.fromJS(resultData400);
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    createChildSalesOrdersUnderBlanketOrder(command: CreateChildSalesOrdersUnderBlanketOrderCommand): Observable<boolean> {
        let url_ = this.baseUrl + "/api/blanketOrderMgmt/createChildSalesOrdersUnderBlanketOrder";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processCreateChildSalesOrdersUnderBlanketOrder(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processCreateChildSalesOrdersUnderBlanketOrder(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processCreateChildSalesOrdersUnderBlanketOrder(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                this.apiConfigService.selectAnyTranslations(resultData200);       
            }
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData400) {
                this.apiConfigService.selectAnyTranslations(resultData400);       
            }
            result400 = SerializableError.fromJS(resultData400);
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateChildOrdersUnderBlanketOrder(command: UpdateChildOrdersUnderBlanketOrderCommand): Observable<boolean> {
        let url_ = this.baseUrl + "/api/blanketOrderMgmt/updateChildOrdersUnderBlanketOrder";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processUpdateChildOrdersUnderBlanketOrder(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processUpdateChildOrdersUnderBlanketOrder(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processUpdateChildOrdersUnderBlanketOrder(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                this.apiConfigService.selectAnyTranslations(resultData200);       
            }
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData400) {
                this.apiConfigService.selectAnyTranslations(resultData400);       
            }
            result400 = SerializableError.fromJS(resultData400);
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    createChildOrder(command: CreateChildOrderCommand): Observable<boolean> {
        let url_ = this.baseUrl + "/api/blanketOrderMgmt/createChildOrder";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processCreateChildOrder(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processCreateChildOrder(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processCreateChildOrder(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                this.apiConfigService.selectAnyTranslations(resultData200);       
            }
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData400) {
                this.apiConfigService.selectAnyTranslations(resultData400);       
            }
            result400 = SerializableError.fromJS(resultData400);
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteSalesOrder(command: DeleteSalesOrderCommand): Observable<boolean> {
        let url_ = this.baseUrl + "/api/blanketOrderMgmt/deleteSalesOrder";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processDeleteSalesOrder(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processDeleteSalesOrder(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processDeleteSalesOrder(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                this.apiConfigService.selectAnyTranslations(resultData200);       
            }
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData400) {
                this.apiConfigService.selectAnyTranslations(resultData400);       
            }
            result400 = SerializableError.fromJS(resultData400);
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getReturnOrdersAssociatedWithSalesOrders(query: GetReturnOrdersQuery): Observable<ErpSalesOrderDto[]> {
        let url_ = this.baseUrl + "/api/blanketOrderMgmt/getReturnOrdersAssociatedWithSalesOrders";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processGetReturnOrdersAssociatedWithSalesOrders(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetReturnOrdersAssociatedWithSalesOrders(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ErpSalesOrderDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ErpSalesOrderDto[]>;
        }));
    }

    protected processGetReturnOrdersAssociatedWithSalesOrders(response: HttpResponseBase): Observable<ErpSalesOrderDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                this.apiConfigService.selectAnyTranslations(resultData200);       
            }
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ErpSalesOrderDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData400) {
                this.apiConfigService.selectAnyTranslations(resultData400);       
            }
            result400 = SerializableError.fromJS(resultData400);
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getCustomer(query: GetCustomerQuery): Observable<ErpCustomerDto> {
        let url_ = this.baseUrl + "/api/blanketOrderMgmt/getCustomer";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processGetCustomer(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetCustomer(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ErpCustomerDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ErpCustomerDto>;
        }));
    }

    protected processGetCustomer(response: HttpResponseBase): Observable<ErpCustomerDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                this.apiConfigService.selectAnyTranslations(resultData200);       
            }
            result200 = ErpCustomerDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData400) {
                this.apiConfigService.selectAnyTranslations(resultData400);       
            }
            result400 = SerializableError.fromJS(resultData400);
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getInactiveStockItems(): Observable<string[]> {
        let url_ = this.baseUrl + "/api/blanketOrderMgmt/getInactiveStockItems";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processGetInactiveStockItems(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetInactiveStockItems(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string[]>;
        }));
    }

    protected processGetInactiveStockItems(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                this.apiConfigService.selectAnyTranslations(resultData200);       
            }
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData400) {
                this.apiConfigService.selectAnyTranslations(resultData400);       
            }
            result400 = SerializableError.fromJS(resultData400);
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getErpUrl(): Observable<string> {
        let url_ = this.baseUrl + "/api/blanketOrderMgmt/getErpUrl";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processGetErpUrl(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetErpUrl(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetErpUrl(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                this.apiConfigService.selectAnyTranslations(resultData200);       
            }
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData400) {
                this.apiConfigService.selectAnyTranslations(resultData400);       
            }
            result400 = SerializableError.fromJS(resultData400);
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class CallbackService extends ServiceBase {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(ApiConfigService) configuration: ApiConfigService, @Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super(configuration);
        this.http = http;
        this.baseUrl = baseUrl ?? "https://";
    }

    callbacks(query: GetCallBackClientLeadsQuery): Observable<PaginatedResultOfCallbackClientLeadLookupDto> {
        let url_ = this.baseUrl + "/api/callbacks/callbacks";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processCallbacks(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processCallbacks(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PaginatedResultOfCallbackClientLeadLookupDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PaginatedResultOfCallbackClientLeadLookupDto>;
        }));
    }

    protected processCallbacks(response: HttpResponseBase): Observable<PaginatedResultOfCallbackClientLeadLookupDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                this.apiConfigService.selectAnyTranslations(resultData200);       
            }
            result200 = PaginatedResultOfCallbackClientLeadLookupDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData400) {
                this.apiConfigService.selectAnyTranslations(resultData400);       
            }
            result400 = SerializableError.fromJS(resultData400);
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    myCallbacks(query: GetMyAssignedCallbackClientLeadsQuery): Observable<PaginatedResultOfCallbackClientLeadLookupDto> {
        let url_ = this.baseUrl + "/api/callbacks/myCallbacks";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processMyCallbacks(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processMyCallbacks(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PaginatedResultOfCallbackClientLeadLookupDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PaginatedResultOfCallbackClientLeadLookupDto>;
        }));
    }

    protected processMyCallbacks(response: HttpResponseBase): Observable<PaginatedResultOfCallbackClientLeadLookupDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                this.apiConfigService.selectAnyTranslations(resultData200);       
            }
            result200 = PaginatedResultOfCallbackClientLeadLookupDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData400) {
                this.apiConfigService.selectAnyTranslations(resultData400);       
            }
            result400 = SerializableError.fromJS(resultData400);
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    callbacksForCalendar(fromDateTime: moment.Moment | undefined, toDateTime: moment.Moment | undefined, all: boolean | undefined): Observable<CallbackClientLeadLookupDto[]> {
        let url_ = this.baseUrl + "/api/callbacks/calendarCallbacks?";
        if (fromDateTime === null)
            throw new Error("The parameter 'fromDateTime' cannot be null.");
        else if (fromDateTime !== undefined)
            url_ += "FromDateTime=" + encodeURIComponent(fromDateTime ? "" + fromDateTime.toISOString() : "") + "&";
        if (toDateTime === null)
            throw new Error("The parameter 'toDateTime' cannot be null.");
        else if (toDateTime !== undefined)
            url_ += "ToDateTime=" + encodeURIComponent(toDateTime ? "" + toDateTime.toISOString() : "") + "&";
        if (all === null)
            throw new Error("The parameter 'all' cannot be null.");
        else if (all !== undefined)
            url_ += "All=" + encodeURIComponent("" + all) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processCallbacksForCalendar(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processCallbacksForCalendar(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CallbackClientLeadLookupDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CallbackClientLeadLookupDto[]>;
        }));
    }

    protected processCallbacksForCalendar(response: HttpResponseBase): Observable<CallbackClientLeadLookupDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                this.apiConfigService.selectAnyTranslations(resultData200);       
            }
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CallbackClientLeadLookupDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData400) {
                this.apiConfigService.selectAnyTranslations(resultData400);       
            }
            result400 = SerializableError.fromJS(resultData400);
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    callback(id: number): Observable<CallBackClientLeadDto> {
        let url_ = this.baseUrl + "/api/callbacks/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processCallback(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processCallback(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CallBackClientLeadDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CallBackClientLeadDto>;
        }));
    }

    protected processCallback(response: HttpResponseBase): Observable<CallBackClientLeadDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                this.apiConfigService.selectAnyTranslations(resultData200);       
            }
            result200 = CallBackClientLeadDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData400) {
                this.apiConfigService.selectAnyTranslations(resultData400);       
            }
            result400 = SerializableError.fromJS(resultData400);
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getCallbackRatings(query: GetCallBackClientLeadsAggregatedRatingsQuery): Observable<GetCallBackClientLeadsAggregatedRatingsQueryResponse> {
        let url_ = this.baseUrl + "/api/callbacks/getRatingsCount";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processGetCallbackRatings(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetCallbackRatings(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetCallBackClientLeadsAggregatedRatingsQueryResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetCallBackClientLeadsAggregatedRatingsQueryResponse>;
        }));
    }

    protected processGetCallbackRatings(response: HttpResponseBase): Observable<GetCallBackClientLeadsAggregatedRatingsQueryResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                this.apiConfigService.selectAnyTranslations(resultData200);       
            }
            result200 = GetCallBackClientLeadsAggregatedRatingsQueryResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData400) {
                this.apiConfigService.selectAnyTranslations(resultData400);       
            }
            result400 = SerializableError.fromJS(resultData400);
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getMyCallbackRatings(query: GetMyCallBackClientLeadsAggregatedRatingsQuery): Observable<GetMyCallBackClientLeadsAggregatedRatingsQueryResponse> {
        let url_ = this.baseUrl + "/api/callbacks/getMyRatingsCount";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processGetMyCallbackRatings(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetMyCallbackRatings(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetMyCallBackClientLeadsAggregatedRatingsQueryResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetMyCallBackClientLeadsAggregatedRatingsQueryResponse>;
        }));
    }

    protected processGetMyCallbackRatings(response: HttpResponseBase): Observable<GetMyCallBackClientLeadsAggregatedRatingsQueryResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                this.apiConfigService.selectAnyTranslations(resultData200);       
            }
            result200 = GetMyCallBackClientLeadsAggregatedRatingsQueryResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData400) {
                this.apiConfigService.selectAnyTranslations(resultData400);       
            }
            result400 = SerializableError.fromJS(resultData400);
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    assignEmployeeToCallbackClientLead(command: AssignEmployeeToCallbackClientLeadsCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/callbacks/assignEmployeeToCallbackClientLead";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processAssignEmployeeToCallbackClientLead(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processAssignEmployeeToCallbackClientLead(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAssignEmployeeToCallbackClientLead(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData400) {
                this.apiConfigService.selectAnyTranslations(resultData400);       
            }
            result400 = SerializableError.fromJS(resultData400);
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    unassignEmployeeToCallbackClientLead(command: UnassignEmployeeToCallbackClientLeadCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/callbacks/unassignEmployeeToCallbackClientLead";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processUnassignEmployeeToCallbackClientLead(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processUnassignEmployeeToCallbackClientLead(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUnassignEmployeeToCallbackClientLead(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData400) {
                this.apiConfigService.selectAnyTranslations(resultData400);       
            }
            result400 = SerializableError.fromJS(resultData400);
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    postponeCallback(command: PostponeCallbackClientLeadCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/callbacks/postponeCallback";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processPostponeCallback(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processPostponeCallback(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processPostponeCallback(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData400) {
                this.apiConfigService.selectAnyTranslations(resultData400);       
            }
            result400 = SerializableError.fromJS(resultData400);
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    callbackClientLeadNotes(id: number): Observable<CallbackClientLeadNoteDto[]> {
        let url_ = this.baseUrl + "/api/callbacks/callbackClientLeadNotes/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processCallbackClientLeadNotes(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processCallbackClientLeadNotes(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CallbackClientLeadNoteDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CallbackClientLeadNoteDto[]>;
        }));
    }

    protected processCallbackClientLeadNotes(response: HttpResponseBase): Observable<CallbackClientLeadNoteDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                this.apiConfigService.selectAnyTranslations(resultData200);       
            }
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CallbackClientLeadNoteDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData400) {
                this.apiConfigService.selectAnyTranslations(resultData400);       
            }
            result400 = SerializableError.fromJS(resultData400);
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    addCallbackClientLeadNote(command: AddCallbackClientLeadNoteCommand): Observable<CallbackClientLeadNoteDto> {
        let url_ = this.baseUrl + "/api/callbacks/addCallbackClientLeadNote";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processAddCallbackClientLeadNote(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processAddCallbackClientLeadNote(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CallbackClientLeadNoteDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CallbackClientLeadNoteDto>;
        }));
    }

    protected processAddCallbackClientLeadNote(response: HttpResponseBase): Observable<CallbackClientLeadNoteDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                this.apiConfigService.selectAnyTranslations(resultData200);       
            }
            result200 = CallbackClientLeadNoteDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData400) {
                this.apiConfigService.selectAnyTranslations(resultData400);       
            }
            result400 = SerializableError.fromJS(resultData400);
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    editCallbackClientLeadNote(command: EditCallbackClientLeadNoteCommand): Observable<CallbackClientLeadNoteDto> {
        let url_ = this.baseUrl + "/api/callbacks/editClientLeadNote";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processEditCallbackClientLeadNote(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processEditCallbackClientLeadNote(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CallbackClientLeadNoteDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CallbackClientLeadNoteDto>;
        }));
    }

    protected processEditCallbackClientLeadNote(response: HttpResponseBase): Observable<CallbackClientLeadNoteDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                this.apiConfigService.selectAnyTranslations(resultData200);       
            }
            result200 = CallbackClientLeadNoteDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData400) {
                this.apiConfigService.selectAnyTranslations(resultData400);       
            }
            result400 = SerializableError.fromJS(resultData400);
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteCallbackClientLeadNote(callbackClientLeadNoteId: string): Observable<void> {
        let url_ = this.baseUrl + "/api/callbacks/deleteCallbackClientLeadNote/{callbackClientLeadNoteId}";
        if (callbackClientLeadNoteId === undefined || callbackClientLeadNoteId === null)
            throw new Error("The parameter 'callbackClientLeadNoteId' must be defined.");
        url_ = url_.replace("{callbackClientLeadNoteId}", encodeURIComponent("" + callbackClientLeadNoteId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("delete", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processDeleteCallbackClientLeadNote(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processDeleteCallbackClientLeadNote(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteCallbackClientLeadNote(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData400) {
                this.apiConfigService.selectAnyTranslations(resultData400);       
            }
            result400 = SerializableError.fromJS(resultData400);
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    renewalWithinDateRange(query: GetCallbackRenewalClientLeadsQuery): Observable<NonRenouveleVocalComDto[]> {
        let url_ = this.baseUrl + "/api/callbacks/renewal/withinDateRange";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processRenewalWithinDateRange(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processRenewalWithinDateRange(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NonRenouveleVocalComDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NonRenouveleVocalComDto[]>;
        }));
    }

    protected processRenewalWithinDateRange(response: HttpResponseBase): Observable<NonRenouveleVocalComDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                this.apiConfigService.selectAnyTranslations(resultData200);       
            }
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(NonRenouveleVocalComDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData400) {
                this.apiConfigService.selectAnyTranslations(resultData400);       
            }
            result400 = SerializableError.fromJS(resultData400);
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    importRenewalCallbacksFromClientNos(command: ImportRenewalCallbacksFromClientNosCommand): Observable<NonRenouveleVocalComDto> {
        let url_ = this.baseUrl + "/api/callbacks/import/renewalCallbacksFromClientNos";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processImportRenewalCallbacksFromClientNos(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processImportRenewalCallbacksFromClientNos(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NonRenouveleVocalComDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NonRenouveleVocalComDto>;
        }));
    }

    protected processImportRenewalCallbacksFromClientNos(response: HttpResponseBase): Observable<NonRenouveleVocalComDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                this.apiConfigService.selectAnyTranslations(resultData200);       
            }
            result200 = NonRenouveleVocalComDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData400) {
                this.apiConfigService.selectAnyTranslations(resultData400);       
            }
            result400 = SerializableError.fromJS(resultData400);
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    importWinbackCallbacksFromClientNoCsv(): Observable<void> {
        let url_ = this.baseUrl + "/api/callbacks/import/winbackCallbacksFromClientNoCsv";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processImportWinbackCallbacksFromClientNoCsv(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processImportWinbackCallbacksFromClientNoCsv(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processImportWinbackCallbacksFromClientNoCsv(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData400) {
                this.apiConfigService.selectAnyTranslations(resultData400);       
            }
            result400 = SerializableError.fromJS(resultData400);
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class CallCenterConfigurationService extends ServiceBase {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(ApiConfigService) configuration: ApiConfigService, @Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super(configuration);
        this.http = http;
        this.baseUrl = baseUrl ?? "https://";
    }

    getConfig(query: GetCallCenterConfigurationQuery): Observable<CallCenterConfigurationsDto> {
        let url_ = this.baseUrl + "/api/call-center-configurations/getConfig";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processGetConfig(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetConfig(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CallCenterConfigurationsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CallCenterConfigurationsDto>;
        }));
    }

    protected processGetConfig(response: HttpResponseBase): Observable<CallCenterConfigurationsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                this.apiConfigService.selectAnyTranslations(resultData200);       
            }
            result200 = CallCenterConfigurationsDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData400) {
                this.apiConfigService.selectAnyTranslations(resultData400);       
            }
            result400 = SerializableError.fromJS(resultData400);
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAllConfigs(): Observable<CallCenterDepartmentDto[]> {
        let url_ = this.baseUrl + "/api/call-center-configurations/getAllConfigs";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processGetAllConfigs(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetAllConfigs(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CallCenterDepartmentDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CallCenterDepartmentDto[]>;
        }));
    }

    protected processGetAllConfigs(response: HttpResponseBase): Observable<CallCenterDepartmentDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                this.apiConfigService.selectAnyTranslations(resultData200);       
            }
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CallCenterDepartmentDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData400) {
                this.apiConfigService.selectAnyTranslations(resultData400);       
            }
            result400 = SerializableError.fromJS(resultData400);
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    createConfig(dto: CallCenterConfigurationsDto): Observable<Unit> {
        let url_ = this.baseUrl + "/api/call-center-configurations/createConfig";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processCreateConfig(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processCreateConfig(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Unit>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Unit>;
        }));
    }

    protected processCreateConfig(response: HttpResponseBase): Observable<Unit> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                this.apiConfigService.selectAnyTranslations(resultData200);       
            }
            result200 = Unit.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData400) {
                this.apiConfigService.selectAnyTranslations(resultData400);       
            }
            result400 = SerializableError.fromJS(resultData400);
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateConfig(dto: CallCenterConfigurationsDto): Observable<Unit> {
        let url_ = this.baseUrl + "/api/call-center-configurations/updateConfig";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processUpdateConfig(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processUpdateConfig(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Unit>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Unit>;
        }));
    }

    protected processUpdateConfig(response: HttpResponseBase): Observable<Unit> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                this.apiConfigService.selectAnyTranslations(resultData200);       
            }
            result200 = Unit.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData400) {
                this.apiConfigService.selectAnyTranslations(resultData400);       
            }
            result400 = SerializableError.fromJS(resultData400);
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    addHoursOfOperationsRecording(command: AddHoursOfOperationsRecordingCommand): Observable<string> {
        let url_ = this.baseUrl + "/api/call-center-configurations/addHoursOfOperationsRecording";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processAddHoursOfOperationsRecording(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processAddHoursOfOperationsRecording(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processAddHoursOfOperationsRecording(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                this.apiConfigService.selectAnyTranslations(resultData200);       
            }
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData400) {
                this.apiConfigService.selectAnyTranslations(resultData400);       
            }
            result400 = SerializableError.fromJS(resultData400);
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAllStatutoryHolidays(query: GetStatutoryHolidaysQuery): Observable<PaginatedResultOfStatutoryHolidayDto> {
        let url_ = this.baseUrl + "/api/call-center-configurations/getAllStatutoryHolidays";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processGetAllStatutoryHolidays(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetAllStatutoryHolidays(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PaginatedResultOfStatutoryHolidayDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PaginatedResultOfStatutoryHolidayDto>;
        }));
    }

    protected processGetAllStatutoryHolidays(response: HttpResponseBase): Observable<PaginatedResultOfStatutoryHolidayDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                this.apiConfigService.selectAnyTranslations(resultData200);       
            }
            result200 = PaginatedResultOfStatutoryHolidayDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData400) {
                this.apiConfigService.selectAnyTranslations(resultData400);       
            }
            result400 = SerializableError.fromJS(resultData400);
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getStatutoryHoliday(query: GetStatutoryHolidayQuery): Observable<StatutoryHolidayDto> {
        let url_ = this.baseUrl + "/api/call-center-configurations/getStatutoryHoliday";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processGetStatutoryHoliday(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetStatutoryHoliday(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StatutoryHolidayDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StatutoryHolidayDto>;
        }));
    }

    protected processGetStatutoryHoliday(response: HttpResponseBase): Observable<StatutoryHolidayDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                this.apiConfigService.selectAnyTranslations(resultData200);       
            }
            result200 = StatutoryHolidayDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData400) {
                this.apiConfigService.selectAnyTranslations(resultData400);       
            }
            result400 = SerializableError.fromJS(resultData400);
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteStatutoryHoliday(command: DeleteStatutoryHolidayCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/call-center-configurations/deleteStatutoryHoliday";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processDeleteStatutoryHoliday(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processDeleteStatutoryHoliday(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteStatutoryHoliday(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData400) {
                this.apiConfigService.selectAnyTranslations(resultData400);       
            }
            result400 = SerializableError.fromJS(resultData400);
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateStatutoryHoliday(command: UpdateStatutoryHolidayCommand): Observable<Unit> {
        let url_ = this.baseUrl + "/api/call-center-configurations/updateStatutoryHoliday";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processUpdateStatutoryHoliday(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processUpdateStatutoryHoliday(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Unit>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Unit>;
        }));
    }

    protected processUpdateStatutoryHoliday(response: HttpResponseBase): Observable<Unit> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                this.apiConfigService.selectAnyTranslations(resultData200);       
            }
            result200 = Unit.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData400) {
                this.apiConfigService.selectAnyTranslations(resultData400);       
            }
            result400 = SerializableError.fromJS(resultData400);
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    createStatutoryHoliday(command: CreateStatutoryHolidayCommand): Observable<Unit> {
        let url_ = this.baseUrl + "/api/call-center-configurations/createStatutoryHoliday";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processCreateStatutoryHoliday(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processCreateStatutoryHoliday(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Unit>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Unit>;
        }));
    }

    protected processCreateStatutoryHoliday(response: HttpResponseBase): Observable<Unit> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                this.apiConfigService.selectAnyTranslations(resultData200);       
            }
            result200 = Unit.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData400) {
                this.apiConfigService.selectAnyTranslations(resultData400);       
            }
            result400 = SerializableError.fromJS(resultData400);
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAllCallCenterCommondRecordings(): Observable<TwilioCommonRecordingsDto[]> {
        let url_ = this.baseUrl + "/api/call-center-configurations/getAllCallCenterCommonRecordings";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processGetAllCallCenterCommondRecordings(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetAllCallCenterCommondRecordings(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TwilioCommonRecordingsDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TwilioCommonRecordingsDto[]>;
        }));
    }

    protected processGetAllCallCenterCommondRecordings(response: HttpResponseBase): Observable<TwilioCommonRecordingsDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                this.apiConfigService.selectAnyTranslations(resultData200);       
            }
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TwilioCommonRecordingsDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData400) {
                this.apiConfigService.selectAnyTranslations(resultData400);       
            }
            result400 = SerializableError.fromJS(resultData400);
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateCallCenterCommondRecordings(command: UpdateTwilioCommondRecordingsCommand): Observable<Unit> {
        let url_ = this.baseUrl + "/api/call-center-configurations/updateCallCenterCommondRecordings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processUpdateCallCenterCommondRecordings(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processUpdateCallCenterCommondRecordings(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Unit>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Unit>;
        }));
    }

    protected processUpdateCallCenterCommondRecordings(response: HttpResponseBase): Observable<Unit> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                this.apiConfigService.selectAnyTranslations(resultData200);       
            }
            result200 = Unit.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData400) {
                this.apiConfigService.selectAnyTranslations(resultData400);       
            }
            result400 = SerializableError.fromJS(resultData400);
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class CampaignsService extends ServiceBase {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(ApiConfigService) configuration: ApiConfigService, @Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super(configuration);
        this.http = http;
        this.baseUrl = baseUrl ?? "https://";
    }

    getCampaigns(): Observable<CampaignDto[]> {
        let url_ = this.baseUrl + "/api/campaigns";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processGetCampaigns(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetCampaigns(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CampaignDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CampaignDto[]>;
        }));
    }

    protected processGetCampaigns(response: HttpResponseBase): Observable<CampaignDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                this.apiConfigService.selectAnyTranslations(resultData200);       
            }
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CampaignDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData400) {
                this.apiConfigService.selectAnyTranslations(resultData400);       
            }
            result400 = SerializableError.fromJS(resultData400);
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getCampaignList(query: GetCampaignListQuery): Observable<PaginatedResultOfCampaignLookUpDto> {
        let url_ = this.baseUrl + "/api/campaigns/getCampaignList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processGetCampaignList(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetCampaignList(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PaginatedResultOfCampaignLookUpDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PaginatedResultOfCampaignLookUpDto>;
        }));
    }

    protected processGetCampaignList(response: HttpResponseBase): Observable<PaginatedResultOfCampaignLookUpDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                this.apiConfigService.selectAnyTranslations(resultData200);       
            }
            result200 = PaginatedResultOfCampaignLookUpDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData400) {
                this.apiConfigService.selectAnyTranslations(resultData400);       
            }
            result400 = SerializableError.fromJS(resultData400);
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAgentCampaignsList(query: GetAgentCampaignsListQuery): Observable<PaginatedResultOfAgentCampaignsLookUpDto> {
        let url_ = this.baseUrl + "/api/campaigns/getAgentCampaignsList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processGetAgentCampaignsList(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetAgentCampaignsList(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PaginatedResultOfAgentCampaignsLookUpDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PaginatedResultOfAgentCampaignsLookUpDto>;
        }));
    }

    protected processGetAgentCampaignsList(response: HttpResponseBase): Observable<PaginatedResultOfAgentCampaignsLookUpDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                this.apiConfigService.selectAnyTranslations(resultData200);       
            }
            result200 = PaginatedResultOfAgentCampaignsLookUpDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData400) {
                this.apiConfigService.selectAnyTranslations(resultData400);       
            }
            result400 = SerializableError.fromJS(resultData400);
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getCampaign(id: number): Observable<CampaignDto> {
        let url_ = this.baseUrl + "/api/campaigns/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processGetCampaign(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetCampaign(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CampaignDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CampaignDto>;
        }));
    }

    protected processGetCampaign(response: HttpResponseBase): Observable<CampaignDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                this.apiConfigService.selectAnyTranslations(resultData200);       
            }
            result200 = CampaignDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData400) {
                this.apiConfigService.selectAnyTranslations(resultData400);       
            }
            result400 = SerializableError.fromJS(resultData400);
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getClientLeadCampaigns(): Observable<CampaignDto[]> {
        let url_ = this.baseUrl + "/api/campaigns/getClientLeadCampaigns";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processGetClientLeadCampaigns(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetClientLeadCampaigns(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CampaignDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CampaignDto[]>;
        }));
    }

    protected processGetClientLeadCampaigns(response: HttpResponseBase): Observable<CampaignDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                this.apiConfigService.selectAnyTranslations(resultData200);       
            }
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CampaignDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData400) {
                this.apiConfigService.selectAnyTranslations(resultData400);       
            }
            result400 = SerializableError.fromJS(resultData400);
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAgentIncludedInCampaignsQuery(): Observable<CampaignDto[]> {
        let url_ = this.baseUrl + "/api/campaigns/getAgentIncludedInCampaignsQuery";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processGetAgentIncludedInCampaignsQuery(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetAgentIncludedInCampaignsQuery(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CampaignDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CampaignDto[]>;
        }));
    }

    protected processGetAgentIncludedInCampaignsQuery(response: HttpResponseBase): Observable<CampaignDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                this.apiConfigService.selectAnyTranslations(resultData200);       
            }
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CampaignDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData400) {
                this.apiConfigService.selectAnyTranslations(resultData400);       
            }
            result400 = SerializableError.fromJS(resultData400);
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    upsert(command: UpsertCampaignCommand): Observable<string> {
        let url_ = this.baseUrl + "/api/campaigns/upsertCampaign";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processUpsert(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processUpsert(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processUpsert(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                this.apiConfigService.selectAnyTranslations(resultData200);       
            }
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData400) {
                this.apiConfigService.selectAnyTranslations(resultData400);       
            }
            result400 = SerializableError.fromJS(resultData400);
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    removeCampaignAgents(command: RemoveCampaignAgentsCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/campaigns/removeCampaignAgents";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processRemoveCampaignAgents(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processRemoveCampaignAgents(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processRemoveCampaignAgents(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData400) {
                this.apiConfigService.selectAnyTranslations(resultData400);       
            }
            result400 = SerializableError.fromJS(resultData400);
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    assignAgentsToCampaignCommand(command: AssignAgentsToCampaignCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/campaigns/assignAgentsToCampaign";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processAssignAgentsToCampaignCommand(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processAssignAgentsToCampaignCommand(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAssignAgentsToCampaignCommand(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData400) {
                this.apiConfigService.selectAnyTranslations(resultData400);       
            }
            result400 = SerializableError.fromJS(resultData400);
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class CategoriesService extends ServiceBase {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(ApiConfigService) configuration: ApiConfigService, @Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super(configuration);
        this.http = http;
        this.baseUrl = baseUrl ?? "https://";
    }

    allCategories(): Observable<CategoryDto[]> {
        let url_ = this.baseUrl + "/api/categories";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processAllCategories(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processAllCategories(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CategoryDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CategoryDto[]>;
        }));
    }

    protected processAllCategories(response: HttpResponseBase): Observable<CategoryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                this.apiConfigService.selectAnyTranslations(resultData200);       
            }
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CategoryDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData400) {
                this.apiConfigService.selectAnyTranslations(resultData400);       
            }
            result400 = SerializableError.fromJS(resultData400);
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    categories(model: GetCategoriesListQuery): Observable<PaginatedResultOfCategoryLookupDto> {
        let url_ = this.baseUrl + "/api/categories";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processCategories(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processCategories(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PaginatedResultOfCategoryLookupDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PaginatedResultOfCategoryLookupDto>;
        }));
    }

    protected processCategories(response: HttpResponseBase): Observable<PaginatedResultOfCategoryLookupDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                this.apiConfigService.selectAnyTranslations(resultData200);       
            }
            result200 = PaginatedResultOfCategoryLookupDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData400) {
                this.apiConfigService.selectAnyTranslations(resultData400);       
            }
            result400 = SerializableError.fromJS(resultData400);
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    edit(command: EditCategoryCommand): Observable<CategoryDto> {
        let url_ = this.baseUrl + "/api/categories";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("put", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processEdit(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processEdit(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CategoryDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CategoryDto>;
        }));
    }

    protected processEdit(response: HttpResponseBase): Observable<CategoryDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                this.apiConfigService.selectAnyTranslations(resultData200);       
            }
            result200 = CategoryDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData400) {
                this.apiConfigService.selectAnyTranslations(resultData400);       
            }
            result400 = SerializableError.fromJS(resultData400);
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    category(id: string): Observable<CategoryDto> {
        let url_ = this.baseUrl + "/api/categories/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processCategory(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processCategory(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CategoryDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CategoryDto>;
        }));
    }

    protected processCategory(response: HttpResponseBase): Observable<CategoryDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                this.apiConfigService.selectAnyTranslations(resultData200);       
            }
            result200 = CategoryDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData400) {
                this.apiConfigService.selectAnyTranslations(resultData400);       
            }
            result400 = SerializableError.fromJS(resultData400);
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    delete(id: string): Observable<void> {
        let url_ = this.baseUrl + "/api/categories/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("delete", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processDelete(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processDelete(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData400) {
                this.apiConfigService.selectAnyTranslations(resultData400);       
            }
            result400 = SerializableError.fromJS(resultData400);
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    create(command: CreateCategoryCommand): Observable<string> {
        let url_ = this.baseUrl + "/api/categories/create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processCreate(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processCreate(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                this.apiConfigService.selectAnyTranslations(resultData200);       
            }
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData400) {
                this.apiConfigService.selectAnyTranslations(resultData400);       
            }
            result400 = SerializableError.fromJS(resultData400);
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getMenuOrderList(categoryId: string | null | undefined): Observable<CategoryReorderDto[]> {
        let url_ = this.baseUrl + "/api/categories/menuOrder?";
        if (categoryId !== undefined && categoryId !== null)
            url_ += "CategoryId=" + encodeURIComponent("" + categoryId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processGetMenuOrderList(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetMenuOrderList(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CategoryReorderDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CategoryReorderDto[]>;
        }));
    }

    protected processGetMenuOrderList(response: HttpResponseBase): Observable<CategoryReorderDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                this.apiConfigService.selectAnyTranslations(resultData200);       
            }
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CategoryReorderDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData400) {
                this.apiConfigService.selectAnyTranslations(resultData400);       
            }
            result400 = SerializableError.fromJS(resultData400);
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAssignedProductsCount(id: string | null | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/categories/assignedProducts?";
        if (id !== undefined && id !== null)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processGetAssignedProductsCount(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetAssignedProductsCount(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processGetAssignedProductsCount(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                this.apiConfigService.selectAnyTranslations(resultData200);       
            }
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData400) {
                this.apiConfigService.selectAnyTranslations(resultData400);       
            }
            result400 = SerializableError.fromJS(resultData400);
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateMenuOrder(command: ReorderCategoriesCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/categories/updateMenuOrder";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("put", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processUpdateMenuOrder(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processUpdateMenuOrder(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateMenuOrder(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData400) {
                this.apiConfigService.selectAnyTranslations(resultData400);       
            }
            result400 = SerializableError.fromJS(resultData400);
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    setCategoryStatus(command: SetCategoryStatusCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/categories/setCategoryStatus";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("put", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processSetCategoryStatus(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processSetCategoryStatus(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSetCategoryStatus(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData400) {
                this.apiConfigService.selectAnyTranslations(resultData400);       
            }
            result400 = SerializableError.fromJS(resultData400);
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class CircuitOrderService extends ServiceBase {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(ApiConfigService) configuration: ApiConfigService, @Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super(configuration);
        this.http = http;
        this.baseUrl = baseUrl ?? "https://";
    }

    productsByDepartments(query: GetProductsByDepartmentsQuery): Observable<PaginatedResultOfProductLookupDto> {
        let url_ = this.baseUrl + "/api/circuitorder/productsByDepartments";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processProductsByDepartments(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processProductsByDepartments(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PaginatedResultOfProductLookupDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PaginatedResultOfProductLookupDto>;
        }));
    }

    protected processProductsByDepartments(response: HttpResponseBase): Observable<PaginatedResultOfProductLookupDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                this.apiConfigService.selectAnyTranslations(resultData200);       
            }
            result200 = PaginatedResultOfProductLookupDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData400) {
                this.apiConfigService.selectAnyTranslations(resultData400);       
            }
            result400 = SerializableError.fromJS(resultData400);
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateProducts(command: UpdateCrmProductCircuitOrderCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/circuitorder/updateProducts";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processUpdateProducts(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processUpdateProducts(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateProducts(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData400) {
                this.apiConfigService.selectAnyTranslations(resultData400);       
            }
            result400 = SerializableError.fromJS(resultData400);
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    seedCircuitOrderNumber(productDataList: ProductData[]): Observable<void> {
        let url_ = this.baseUrl + "/api/circuitorder/seedCircuitOrder";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(productDataList);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processSeedCircuitOrderNumber(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processSeedCircuitOrderNumber(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSeedCircuitOrderNumber(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData400) {
                this.apiConfigService.selectAnyTranslations(resultData400);       
            }
            result400 = SerializableError.fromJS(resultData400);
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ClientDeliveryScheduleService extends ServiceBase {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(ApiConfigService) configuration: ApiConfigService, @Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super(configuration);
        this.http = http;
        this.baseUrl = baseUrl ?? "https://";
    }

    get(clientNo: number): Observable<ClientDeliveryScheduleDto> {
        let url_ = this.baseUrl + "/api/ClientDeliverySchedule/{clientNo}";
        if (clientNo === undefined || clientNo === null)
            throw new Error("The parameter 'clientNo' must be defined.");
        url_ = url_.replace("{clientNo}", encodeURIComponent("" + clientNo));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processGet(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGet(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ClientDeliveryScheduleDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ClientDeliveryScheduleDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<ClientDeliveryScheduleDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                this.apiConfigService.selectAnyTranslations(resultData200);       
            }
            result200 = ClientDeliveryScheduleDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData400) {
                this.apiConfigService.selectAnyTranslations(resultData400);       
            }
            result400 = SerializableError.fromJS(resultData400);
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    createOrUpdate(command: CreateOrUpdateClientDeliveryScheduleCommand): Observable<string> {
        let url_ = this.baseUrl + "/api/ClientDeliverySchedule/createOrUpdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processCreateOrUpdate(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processCreateOrUpdate(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processCreateOrUpdate(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                this.apiConfigService.selectAnyTranslations(resultData200);       
            }
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData400) {
                this.apiConfigService.selectAnyTranslations(resultData400);       
            }
            result400 = SerializableError.fromJS(resultData400);
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ClientLeadsService extends ServiceBase {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(ApiConfigService) configuration: ApiConfigService, @Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super(configuration);
        this.http = http;
        this.baseUrl = baseUrl ?? "https://";
    }

    clientLeadsQuery(query: GetClientLeadsListQuery): Observable<PaginatedResultOfClientLeadLookUpDto> {
        let url_ = this.baseUrl + "/api/clientLeads/clientLeadsQuery";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processClientLeadsQuery(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processClientLeadsQuery(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PaginatedResultOfClientLeadLookUpDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PaginatedResultOfClientLeadLookUpDto>;
        }));
    }

    protected processClientLeadsQuery(response: HttpResponseBase): Observable<PaginatedResultOfClientLeadLookUpDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                this.apiConfigService.selectAnyTranslations(resultData200);       
            }
            result200 = PaginatedResultOfClientLeadLookUpDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData400) {
                this.apiConfigService.selectAnyTranslations(resultData400);       
            }
            result400 = SerializableError.fromJS(resultData400);
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    myAssignedClientLeadsQuery(query: GetMyAssignedClientLeadsListQuery): Observable<PaginatedResultOfClientLeadLookUpDto> {
        let url_ = this.baseUrl + "/api/clientLeads/myAssignedClientLeadsQuery";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processMyAssignedClientLeadsQuery(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processMyAssignedClientLeadsQuery(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PaginatedResultOfClientLeadLookUpDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PaginatedResultOfClientLeadLookUpDto>;
        }));
    }

    protected processMyAssignedClientLeadsQuery(response: HttpResponseBase): Observable<PaginatedResultOfClientLeadLookUpDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                this.apiConfigService.selectAnyTranslations(resultData200);       
            }
            result200 = PaginatedResultOfClientLeadLookUpDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData400) {
                this.apiConfigService.selectAnyTranslations(resultData400);       
            }
            result400 = SerializableError.fromJS(resultData400);
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    clientLead(id: number): Observable<ClientLeadDto> {
        let url_ = this.baseUrl + "/api/clientLeads/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processClientLead(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processClientLead(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ClientLeadDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ClientLeadDto>;
        }));
    }

    protected processClientLead(response: HttpResponseBase): Observable<ClientLeadDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                this.apiConfigService.selectAnyTranslations(resultData200);       
            }
            result200 = ClientLeadDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData400) {
                this.apiConfigService.selectAnyTranslations(resultData400);       
            }
            result400 = SerializableError.fromJS(resultData400);
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    delete(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/clientLeads/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("delete", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processDelete(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processDelete(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData400) {
                this.apiConfigService.selectAnyTranslations(resultData400);       
            }
            result400 = SerializableError.fromJS(resultData400);
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    clientLeadNotes(id: number): Observable<ClientLeadNoteDto[]> {
        let url_ = this.baseUrl + "/api/clientLeads/clientLeadNotes/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processClientLeadNotes(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processClientLeadNotes(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ClientLeadNoteDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ClientLeadNoteDto[]>;
        }));
    }

    protected processClientLeadNotes(response: HttpResponseBase): Observable<ClientLeadNoteDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                this.apiConfigService.selectAnyTranslations(resultData200);       
            }
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ClientLeadNoteDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData400) {
                this.apiConfigService.selectAnyTranslations(resultData400);       
            }
            result400 = SerializableError.fromJS(resultData400);
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    allClientLeadNotes(query: GetAllClientLeadsNotesListQuery): Observable<ClientLeadNoteDto[]> {
        let url_ = this.baseUrl + "/api/clientLeads/allClientLeadNotes";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processAllClientLeadNotes(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processAllClientLeadNotes(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ClientLeadNoteDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ClientLeadNoteDto[]>;
        }));
    }

    protected processAllClientLeadNotes(response: HttpResponseBase): Observable<ClientLeadNoteDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                this.apiConfigService.selectAnyTranslations(resultData200);       
            }
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ClientLeadNoteDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData400) {
                this.apiConfigService.selectAnyTranslations(resultData400);       
            }
            result400 = SerializableError.fromJS(resultData400);
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteClientLeadNote(clientLeadNoteId: string): Observable<void> {
        let url_ = this.baseUrl + "/api/clientLeads/deleteClientLeadNote/{clientLeadNoteId}";
        if (clientLeadNoteId === undefined || clientLeadNoteId === null)
            throw new Error("The parameter 'clientLeadNoteId' must be defined.");
        url_ = url_.replace("{clientLeadNoteId}", encodeURIComponent("" + clientLeadNoteId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("delete", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processDeleteClientLeadNote(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processDeleteClientLeadNote(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteClientLeadNote(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData400) {
                this.apiConfigService.selectAnyTranslations(resultData400);       
            }
            result400 = SerializableError.fromJS(resultData400);
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    create(clientLead: ClientLead): Observable<ClientLead> {
        let url_ = this.baseUrl + "/api/clientLeads";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(clientLead);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processCreate(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processCreate(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ClientLead>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ClientLead>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<ClientLead> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                this.apiConfigService.selectAnyTranslations(resultData200);       
            }
            result200 = ClientLead.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData400) {
                this.apiConfigService.selectAnyTranslations(resultData400);       
            }
            result400 = SerializableError.fromJS(resultData400);
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    edit(updatedClientLeads: ClientLead): Observable<ClientLead> {
        let url_ = this.baseUrl + "/api/clientLeads";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(updatedClientLeads);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("put", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processEdit(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processEdit(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ClientLead>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ClientLead>;
        }));
    }

    protected processEdit(response: HttpResponseBase): Observable<ClientLead> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                this.apiConfigService.selectAnyTranslations(resultData200);       
            }
            result200 = ClientLead.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData400) {
                this.apiConfigService.selectAnyTranslations(resultData400);       
            }
            result400 = SerializableError.fromJS(resultData400);
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    addClientLeadNote(command: AddClientLeadNoteCommand): Observable<ClientLeadNoteDto> {
        let url_ = this.baseUrl + "/api/clientLeads/addClientLeadNote";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processAddClientLeadNote(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processAddClientLeadNote(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ClientLeadNoteDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ClientLeadNoteDto>;
        }));
    }

    protected processAddClientLeadNote(response: HttpResponseBase): Observable<ClientLeadNoteDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                this.apiConfigService.selectAnyTranslations(resultData200);       
            }
            result200 = ClientLeadNoteDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData400) {
                this.apiConfigService.selectAnyTranslations(resultData400);       
            }
            result400 = SerializableError.fromJS(resultData400);
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    editClientLeadNote(command: EditClientLeadNoteCommand): Observable<ClientLeadNoteDto> {
        let url_ = this.baseUrl + "/api/clientLeads/editClientLeadNote";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processEditClientLeadNote(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processEditClientLeadNote(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ClientLeadNoteDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ClientLeadNoteDto>;
        }));
    }

    protected processEditClientLeadNote(response: HttpResponseBase): Observable<ClientLeadNoteDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                this.apiConfigService.selectAnyTranslations(resultData200);       
            }
            result200 = ClientLeadNoteDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData400) {
                this.apiConfigService.selectAnyTranslations(resultData400);       
            }
            result400 = SerializableError.fromJS(resultData400);
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    assignEmployeeToClientLead(command: AssignEmployeeToClientLeadCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/clientLeads/assignEmployeeToClientLead";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processAssignEmployeeToClientLead(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processAssignEmployeeToClientLead(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAssignEmployeeToClientLead(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData400) {
                this.apiConfigService.selectAnyTranslations(resultData400);       
            }
            result400 = SerializableError.fromJS(resultData400);
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    unassignEmployeeToClientLead(command: UnassignEmployeeToClientLeadCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/clientLeads/unassignEmployeeToClientLead";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processUnassignEmployeeToClientLead(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processUnassignEmployeeToClientLead(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUnassignEmployeeToClientLead(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData400) {
                this.apiConfigService.selectAnyTranslations(resultData400);       
            }
            result400 = SerializableError.fromJS(resultData400);
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    changeClientLeadStatus(statusCommand: ChangeClientLeadsStatusCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/clientLeads/changeClientLeadStatus";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(statusCommand);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processChangeClientLeadStatus(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processChangeClientLeadStatus(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processChangeClientLeadStatus(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData400) {
                this.apiConfigService.selectAnyTranslations(resultData400);       
            }
            result400 = SerializableError.fromJS(resultData400);
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    notInterestedClientLead(command: NotInterestedClientLeadCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/clientLeads/notInterestedClientLead";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processNotInterestedClientLead(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processNotInterestedClientLead(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processNotInterestedClientLead(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData400) {
                this.apiConfigService.selectAnyTranslations(resultData400);       
            }
            result400 = SerializableError.fromJS(resultData400);
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    importedClientLeadsFromOrdersRecords(query: GetImportedClientLeadsFromOrdersRecordListQuery): Observable<ImportedClientLeadsFromOrdersRecordDto[]> {
        let url_ = this.baseUrl + "/api/clientLeads/importedClientLeadsFromOrdersRecords";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processImportedClientLeadsFromOrdersRecords(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processImportedClientLeadsFromOrdersRecords(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ImportedClientLeadsFromOrdersRecordDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ImportedClientLeadsFromOrdersRecordDto[]>;
        }));
    }

    protected processImportedClientLeadsFromOrdersRecords(response: HttpResponseBase): Observable<ImportedClientLeadsFromOrdersRecordDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                this.apiConfigService.selectAnyTranslations(resultData200);       
            }
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ImportedClientLeadsFromOrdersRecordDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData400) {
                this.apiConfigService.selectAnyTranslations(resultData400);       
            }
            result400 = SerializableError.fromJS(resultData400);
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    importClientLeadsFromOrderReferences(command: ImportClientLeadsFromOrderReferencesCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/clientLeads/importClientLeadsFromOrderReferences";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processImportClientLeadsFromOrderReferences(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processImportClientLeadsFromOrderReferences(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processImportClientLeadsFromOrderReferences(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData400) {
                this.apiConfigService.selectAnyTranslations(resultData400);       
            }
            result400 = SerializableError.fromJS(resultData400);
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getOrderReferencesCount(orderNo: number): Observable<number> {
        let url_ = this.baseUrl + "/api/clientLeads/orderReferencesCount/{orderNo}";
        if (orderNo === undefined || orderNo === null)
            throw new Error("The parameter 'orderNo' must be defined.");
        url_ = url_.replace("{orderNo}", encodeURIComponent("" + orderNo));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processGetOrderReferencesCount(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetOrderReferencesCount(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processGetOrderReferencesCount(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                this.apiConfigService.selectAnyTranslations(resultData200);       
            }
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData400) {
                this.apiConfigService.selectAnyTranslations(resultData400);       
            }
            result400 = SerializableError.fromJS(resultData400);
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    removeOrderReferences(command: RemoveOrderReferencesCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/clientLeads/removeOrderReferences";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processRemoveOrderReferences(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processRemoveOrderReferences(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processRemoveOrderReferences(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData400) {
                this.apiConfigService.selectAnyTranslations(resultData400);       
            }
            result400 = SerializableError.fromJS(resultData400);
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    setAllSelectedClientLeadsAsUnbookable(command: SetAsUnbookableCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/clientLeads/setAllSelectedClientLeadsAsUnbookable";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processSetAllSelectedClientLeadsAsUnbookable(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processSetAllSelectedClientLeadsAsUnbookable(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSetAllSelectedClientLeadsAsUnbookable(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData400) {
                this.apiConfigService.selectAnyTranslations(resultData400);       
            }
            result400 = SerializableError.fromJS(resultData400);
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    assignCampaignToClientLead(command: AssignCampaignToClientLeadCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/clientLeads/assignCampaignToClientLead";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processAssignCampaignToClientLead(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processAssignCampaignToClientLead(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAssignCampaignToClientLead(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData400) {
                this.apiConfigService.selectAnyTranslations(resultData400);       
            }
            result400 = SerializableError.fromJS(resultData400);
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    releaseClientLeadFromCampaignCommand(command: ReleaseClientLeadFromCampaignCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/clientLeads/releaseClientLeadFromCampaignCommand";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processReleaseClientLeadFromCampaignCommand(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processReleaseClientLeadFromCampaignCommand(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processReleaseClientLeadFromCampaignCommand(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData400) {
                this.apiConfigService.selectAnyTranslations(resultData400);       
            }
            result400 = SerializableError.fromJS(resultData400);
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    importClientLeadsFromSMSReferralTest(): Observable<void> {
        let url_ = this.baseUrl + "/api/clientLeads/importClientLeadsFromSMSReferralTest";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processImportClientLeadsFromSMSReferralTest(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processImportClientLeadsFromSMSReferralTest(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processImportClientLeadsFromSMSReferralTest(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData400) {
                this.apiConfigService.selectAnyTranslations(resultData400);       
            }
            result400 = SerializableError.fromJS(resultData400);
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    importClientLeadsFromSMSReferral(command: ImportClientLeadsFromSmsReferralCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/clientLeads/importClientLeadsFromSMSReferral";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processImportClientLeadsFromSMSReferral(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processImportClientLeadsFromSMSReferral(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processImportClientLeadsFromSMSReferral(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData400) {
                this.apiConfigService.selectAnyTranslations(resultData400);       
            }
            result400 = SerializableError.fromJS(resultData400);
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    importedClientLeadsFromSMSRecords(query: GetImportedClientLeadsFromSMSRecordListQuery): Observable<ImportedClientLeadsFromSMSRecordDto[]> {
        let url_ = this.baseUrl + "/api/clientLeads/importedClientLeadsFromSMSReferralRecords";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processImportedClientLeadsFromSMSRecords(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processImportedClientLeadsFromSMSRecords(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ImportedClientLeadsFromSMSRecordDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ImportedClientLeadsFromSMSRecordDto[]>;
        }));
    }

    protected processImportedClientLeadsFromSMSRecords(response: HttpResponseBase): Observable<ImportedClientLeadsFromSMSRecordDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                this.apiConfigService.selectAnyTranslations(resultData200);       
            }
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ImportedClientLeadsFromSMSRecordDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData400) {
                this.apiConfigService.selectAnyTranslations(resultData400);       
            }
            result400 = SerializableError.fromJS(resultData400);
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ClientLeadSourcesService extends ServiceBase {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(ApiConfigService) configuration: ApiConfigService, @Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super(configuration);
        this.http = http;
        this.baseUrl = baseUrl ?? "https://";
    }

    clientLeadSources(): Observable<ClientLeadSourceTypeDto[]> {
        let url_ = this.baseUrl + "/api/clientLeadSources";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processClientLeadSources(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processClientLeadSources(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ClientLeadSourceTypeDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ClientLeadSourceTypeDto[]>;
        }));
    }

    protected processClientLeadSources(response: HttpResponseBase): Observable<ClientLeadSourceTypeDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                this.apiConfigService.selectAnyTranslations(resultData200);       
            }
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ClientLeadSourceTypeDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData400) {
                this.apiConfigService.selectAnyTranslations(resultData400);       
            }
            result400 = SerializableError.fromJS(resultData400);
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ClientNextDeliveryTaskService extends ServiceBase {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(ApiConfigService) configuration: ApiConfigService, @Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super(configuration);
        this.http = http;
        this.baseUrl = baseUrl ?? "https://";
    }

    clientNextDeliveryTasks(query: GetClientNextDeliveryTasksQuery): Observable<PaginatedResultOfClientNextDeliveryTaskLookupDto> {
        let url_ = this.baseUrl + "/api/ClientNextDeliveryTask/clientNextDeliveryTasks";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processClientNextDeliveryTasks(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processClientNextDeliveryTasks(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PaginatedResultOfClientNextDeliveryTaskLookupDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PaginatedResultOfClientNextDeliveryTaskLookupDto>;
        }));
    }

    protected processClientNextDeliveryTasks(response: HttpResponseBase): Observable<PaginatedResultOfClientNextDeliveryTaskLookupDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                this.apiConfigService.selectAnyTranslations(resultData200);       
            }
            result200 = PaginatedResultOfClientNextDeliveryTaskLookupDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData400) {
                this.apiConfigService.selectAnyTranslations(resultData400);       
            }
            result400 = SerializableError.fromJS(resultData400);
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    myClientNextDeliveryTasks(query: GetMyAssignedClientNextDeliveryTasksQuery): Observable<PaginatedResultOfClientNextDeliveryTaskLookupDto> {
        let url_ = this.baseUrl + "/api/ClientNextDeliveryTask/myClientNextDeliveryTasks";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processMyClientNextDeliveryTasks(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processMyClientNextDeliveryTasks(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PaginatedResultOfClientNextDeliveryTaskLookupDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PaginatedResultOfClientNextDeliveryTaskLookupDto>;
        }));
    }

    protected processMyClientNextDeliveryTasks(response: HttpResponseBase): Observable<PaginatedResultOfClientNextDeliveryTaskLookupDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                this.apiConfigService.selectAnyTranslations(resultData200);       
            }
            result200 = PaginatedResultOfClientNextDeliveryTaskLookupDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData400) {
                this.apiConfigService.selectAnyTranslations(resultData400);       
            }
            result400 = SerializableError.fromJS(resultData400);
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    activeAndAssignedNextDeliveryTaskAgents(query: GetActiveAndAssignedNextDeliveryTaskAgentsQuery): Observable<EmployeeDto[]> {
        let url_ = this.baseUrl + "/api/ClientNextDeliveryTask/activeAndAssignedNextDeliveryTaskAgents";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processActiveAndAssignedNextDeliveryTaskAgents(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processActiveAndAssignedNextDeliveryTaskAgents(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EmployeeDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EmployeeDto[]>;
        }));
    }

    protected processActiveAndAssignedNextDeliveryTaskAgents(response: HttpResponseBase): Observable<EmployeeDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                this.apiConfigService.selectAnyTranslations(resultData200);       
            }
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(EmployeeDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData400) {
                this.apiConfigService.selectAnyTranslations(resultData400);       
            }
            result400 = SerializableError.fromJS(resultData400);
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    calendarEntries(fromDateTime: moment.Moment | undefined, toDateTime: moment.Moment | undefined): Observable<ClientNextDeliveryTaskLookupDto[]> {
        let url_ = this.baseUrl + "/api/ClientNextDeliveryTask/calendar?";
        if (fromDateTime === null)
            throw new Error("The parameter 'fromDateTime' cannot be null.");
        else if (fromDateTime !== undefined)
            url_ += "FromDateTime=" + encodeURIComponent(fromDateTime ? "" + fromDateTime.toISOString() : "") + "&";
        if (toDateTime === null)
            throw new Error("The parameter 'toDateTime' cannot be null.");
        else if (toDateTime !== undefined)
            url_ += "ToDateTime=" + encodeURIComponent(toDateTime ? "" + toDateTime.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processCalendarEntries(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processCalendarEntries(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ClientNextDeliveryTaskLookupDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ClientNextDeliveryTaskLookupDto[]>;
        }));
    }

    protected processCalendarEntries(response: HttpResponseBase): Observable<ClientNextDeliveryTaskLookupDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                this.apiConfigService.selectAnyTranslations(resultData200);       
            }
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ClientNextDeliveryTaskLookupDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData400) {
                this.apiConfigService.selectAnyTranslations(resultData400);       
            }
            result400 = SerializableError.fromJS(resultData400);
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    withinDateRange(query: GetNextDeliveryTasksWithinDateRangeQuery): Observable<NextDeliveryTaskDto[]> {
        let url_ = this.baseUrl + "/api/ClientNextDeliveryTask/withinDateRange";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processWithinDateRange(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processWithinDateRange(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NextDeliveryTaskDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NextDeliveryTaskDto[]>;
        }));
    }

    protected processWithinDateRange(response: HttpResponseBase): Observable<NextDeliveryTaskDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                this.apiConfigService.selectAnyTranslations(resultData200);       
            }
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(NextDeliveryTaskDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData400) {
                this.apiConfigService.selectAnyTranslations(resultData400);       
            }
            result400 = SerializableError.fromJS(resultData400);
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    import(command: ImportNextDeliveryTasksCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/ClientNextDeliveryTask/import";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processImport(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processImport(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processImport(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData400) {
                this.apiConfigService.selectAnyTranslations(resultData400);       
            }
            result400 = SerializableError.fromJS(resultData400);
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    executeCommand(command: ImportNextDeliveryTasksCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/ClientNextDeliveryTask";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processExecuteCommand(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processExecuteCommand(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processExecuteCommand(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    clientNextDeliveryTask(id: number): Observable<ClientNextDeliveryTaskDto> {
        let url_ = this.baseUrl + "/api/ClientNextDeliveryTask/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processClientNextDeliveryTask(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processClientNextDeliveryTask(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ClientNextDeliveryTaskDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ClientNextDeliveryTaskDto>;
        }));
    }

    protected processClientNextDeliveryTask(response: HttpResponseBase): Observable<ClientNextDeliveryTaskDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                this.apiConfigService.selectAnyTranslations(resultData200);       
            }
            result200 = ClientNextDeliveryTaskDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData400) {
                this.apiConfigService.selectAnyTranslations(resultData400);       
            }
            result400 = SerializableError.fromJS(resultData400);
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    closeTask(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/ClientNextDeliveryTask/{id}/close";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("put", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processCloseTask(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processCloseTask(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCloseTask(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData400) {
                this.apiConfigService.selectAnyTranslations(resultData400);       
            }
            result400 = SerializableError.fromJS(resultData400);
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    assignEmployee(command: AssignEmployeeClientNextDeliveryTaskCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/ClientNextDeliveryTask/assignEmployee";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("put", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processAssignEmployee(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processAssignEmployee(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAssignEmployee(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData400) {
                this.apiConfigService.selectAnyTranslations(resultData400);       
            }
            result400 = SerializableError.fromJS(resultData400);
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    unassignEmployee(command: UnassignEmployeeClientNextDeliveryTaskCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/ClientNextDeliveryTask/unassignEmployee";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("put", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processUnassignEmployee(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processUnassignEmployee(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUnassignEmployee(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData400) {
                this.apiConfigService.selectAnyTranslations(resultData400);       
            }
            result400 = SerializableError.fromJS(resultData400);
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    notes(id: number): Observable<ClientNextDeliveryTaskNoteDto[]> {
        let url_ = this.baseUrl + "/api/ClientNextDeliveryTask/{id}/notes";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processNotes(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processNotes(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ClientNextDeliveryTaskNoteDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ClientNextDeliveryTaskNoteDto[]>;
        }));
    }

    protected processNotes(response: HttpResponseBase): Observable<ClientNextDeliveryTaskNoteDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                this.apiConfigService.selectAnyTranslations(resultData200);       
            }
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ClientNextDeliveryTaskNoteDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData400) {
                this.apiConfigService.selectAnyTranslations(resultData400);       
            }
            result400 = SerializableError.fromJS(resultData400);
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    addNote(id: number, command: AddClientNextDeliveryTaskNoteCommand): Observable<ClientNextDeliveryTaskNoteDto> {
        let url_ = this.baseUrl + "/api/ClientNextDeliveryTask/{id}/notes";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processAddNote(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processAddNote(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ClientNextDeliveryTaskNoteDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ClientNextDeliveryTaskNoteDto>;
        }));
    }

    protected processAddNote(response: HttpResponseBase): Observable<ClientNextDeliveryTaskNoteDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                this.apiConfigService.selectAnyTranslations(resultData200);       
            }
            result200 = ClientNextDeliveryTaskNoteDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData400) {
                this.apiConfigService.selectAnyTranslations(resultData400);       
            }
            result400 = SerializableError.fromJS(resultData400);
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    editNote(id: string, command: EditClientNextDeliveryTaskNoteCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/ClientNextDeliveryTask/notes/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("put", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processEditNote(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processEditNote(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processEditNote(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData400) {
                this.apiConfigService.selectAnyTranslations(resultData400);       
            }
            result400 = SerializableError.fromJS(resultData400);
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteNote(id: string): Observable<void> {
        let url_ = this.baseUrl + "/api/ClientNextDeliveryTask/notes/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("delete", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processDeleteNote(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processDeleteNote(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteNote(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData400) {
                this.apiConfigService.selectAnyTranslations(resultData400);       
            }
            result400 = SerializableError.fromJS(resultData400);
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    generateMockData(counter: number): Observable<void> {
        let url_ = this.baseUrl + "/api/ClientNextDeliveryTask/genMockData/{counter}";
        if (counter === undefined || counter === null)
            throw new Error("The parameter 'counter' must be defined.");
        url_ = url_.replace("{counter}", encodeURIComponent("" + counter));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processGenerateMockData(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGenerateMockData(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processGenerateMockData(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData400) {
                this.apiConfigService.selectAnyTranslations(resultData400);       
            }
            result400 = SerializableError.fromJS(resultData400);
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ClientsService extends ServiceBase {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(ApiConfigService) configuration: ApiConfigService, @Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super(configuration);
        this.http = http;
        this.baseUrl = baseUrl ?? "https://";
    }

    clients(query: GetClientsListQuery): Observable<PaginatedResultOfClientLookupDto> {
        let url_ = this.baseUrl + "/api/clients/clients";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processClients(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processClients(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PaginatedResultOfClientLookupDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PaginatedResultOfClientLookupDto>;
        }));
    }

    protected processClients(response: HttpResponseBase): Observable<PaginatedResultOfClientLookupDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                this.apiConfigService.selectAnyTranslations(resultData200);       
            }
            result200 = PaginatedResultOfClientLookupDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData400) {
                this.apiConfigService.selectAnyTranslations(resultData400);       
            }
            result400 = SerializableError.fromJS(resultData400);
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    client(id: string): Observable<ClientDto> {
        let url_ = this.baseUrl + "/api/clients/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processClient(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processClient(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ClientDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ClientDto>;
        }));
    }

    protected processClient(response: HttpResponseBase): Observable<ClientDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                this.apiConfigService.selectAnyTranslations(resultData200);       
            }
            result200 = ClientDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData400) {
                this.apiConfigService.selectAnyTranslations(resultData400);       
            }
            result400 = SerializableError.fromJS(resultData400);
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    delete(id: string): Observable<void> {
        let url_ = this.baseUrl + "/api/clients/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("delete", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processDelete(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processDelete(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData400) {
                this.apiConfigService.selectAnyTranslations(resultData400);       
            }
            result400 = SerializableError.fromJS(resultData400);
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    clientFromClientNo(clientNo: number): Observable<ClientAndLastRepDto> {
        let url_ = this.baseUrl + "/api/clients/getClient/{clientNo}";
        if (clientNo === undefined || clientNo === null)
            throw new Error("The parameter 'clientNo' must be defined.");
        url_ = url_.replace("{clientNo}", encodeURIComponent("" + clientNo));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processClientFromClientNo(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processClientFromClientNo(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ClientAndLastRepDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ClientAndLastRepDto>;
        }));
    }

    protected processClientFromClientNo(response: HttpResponseBase): Observable<ClientAndLastRepDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                this.apiConfigService.selectAnyTranslations(resultData200);       
            }
            result200 = ClientAndLastRepDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData400) {
                this.apiConfigService.selectAnyTranslations(resultData400);       
            }
            result400 = SerializableError.fromJS(resultData400);
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    edit(clientDto: ClientDto): Observable<void> {
        let url_ = this.baseUrl + "/api/clients";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(clientDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("put", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processEdit(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processEdit(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData400) {
                this.apiConfigService.selectAnyTranslations(resultData400);       
            }
            result400 = SerializableError.fromJS(resultData400);
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class CreditTaskCampaignService extends ServiceBase {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(ApiConfigService) configuration: ApiConfigService, @Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super(configuration);
        this.http = http;
        this.baseUrl = baseUrl ?? "https://";
    }

    getCreditTaskCampaignList(query: GetCreditTaskCampaignListQuery): Observable<PaginatedResultOfCreditTaskCampaignLookUpDto> {
        let url_ = this.baseUrl + "/api/creditTaskCampaign/getCreditTaskCampaignList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processGetCreditTaskCampaignList(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetCreditTaskCampaignList(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PaginatedResultOfCreditTaskCampaignLookUpDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PaginatedResultOfCreditTaskCampaignLookUpDto>;
        }));
    }

    protected processGetCreditTaskCampaignList(response: HttpResponseBase): Observable<PaginatedResultOfCreditTaskCampaignLookUpDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                this.apiConfigService.selectAnyTranslations(resultData200);       
            }
            result200 = PaginatedResultOfCreditTaskCampaignLookUpDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData400) {
                this.apiConfigService.selectAnyTranslations(resultData400);       
            }
            result400 = SerializableError.fromJS(resultData400);
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAgentCreditTaskList(query: GetAgentCreditTaskListQuery): Observable<PaginatedResultOfAgentCreditTasksDto> {
        let url_ = this.baseUrl + "/api/creditTaskCampaign/getAgentCreditTaskList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processGetAgentCreditTaskList(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetAgentCreditTaskList(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PaginatedResultOfAgentCreditTasksDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PaginatedResultOfAgentCreditTasksDto>;
        }));
    }

    protected processGetAgentCreditTaskList(response: HttpResponseBase): Observable<PaginatedResultOfAgentCreditTasksDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                this.apiConfigService.selectAnyTranslations(resultData200);       
            }
            result200 = PaginatedResultOfAgentCreditTasksDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData400) {
                this.apiConfigService.selectAnyTranslations(resultData400);       
            }
            result400 = SerializableError.fromJS(resultData400);
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getCreditTaskCampaignAgents(type: CreditTaskType): Observable<CreditTaskCampaignAgentsDto> {
        let url_ = this.baseUrl + "/api/creditTaskCampaign/{type}";
        if (type === undefined || type === null)
            throw new Error("The parameter 'type' must be defined.");
        url_ = url_.replace("{type}", encodeURIComponent("" + type));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processGetCreditTaskCampaignAgents(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetCreditTaskCampaignAgents(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreditTaskCampaignAgentsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreditTaskCampaignAgentsDto>;
        }));
    }

    protected processGetCreditTaskCampaignAgents(response: HttpResponseBase): Observable<CreditTaskCampaignAgentsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                this.apiConfigService.selectAnyTranslations(resultData200);       
            }
            result200 = CreditTaskCampaignAgentsDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData400) {
                this.apiConfigService.selectAnyTranslations(resultData400);       
            }
            result400 = SerializableError.fromJS(resultData400);
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    assignAgentsToCreditTaskCampaign(command: AssignAgentsToCreditTaskCampaignCommand): Observable<string> {
        let url_ = this.baseUrl + "/api/creditTaskCampaign/assignAgentsToCreditTaskCampaign";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processAssignAgentsToCreditTaskCampaign(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processAssignAgentsToCreditTaskCampaign(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processAssignAgentsToCreditTaskCampaign(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                this.apiConfigService.selectAnyTranslations(resultData200);       
            }
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData400) {
                this.apiConfigService.selectAnyTranslations(resultData400);       
            }
            result400 = SerializableError.fromJS(resultData400);
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    consolidateAllFailedOrNsfCreditTasks(command: ConsolidateAllFailedOrNsfCreditTasksCommand): Observable<string> {
        let url_ = this.baseUrl + "/api/creditTaskCampaign/consolidateAllFailedOrNsfCreditTasks";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processConsolidateAllFailedOrNsfCreditTasks(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processConsolidateAllFailedOrNsfCreditTasks(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processConsolidateAllFailedOrNsfCreditTasks(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                this.apiConfigService.selectAnyTranslations(resultData200);       
            }
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData400) {
                this.apiConfigService.selectAnyTranslations(resultData400);       
            }
            result400 = SerializableError.fromJS(resultData400);
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class DataSynchronizerService extends ServiceBase {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(ApiConfigService) configuration: ApiConfigService, @Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super(configuration);
        this.http = http;
        this.baseUrl = baseUrl ?? "https://";
    }

    pullAppointmentEntityUpdates(): Observable<void> {
        let url_ = this.baseUrl + "/api/dataSynchronizer/pullAppointmentEntityUpdates";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processPullAppointmentEntityUpdates(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processPullAppointmentEntityUpdates(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processPullAppointmentEntityUpdates(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData400) {
                this.apiConfigService.selectAnyTranslations(resultData400);       
            }
            result400 = SerializableError.fromJS(resultData400);
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    importReps(): Observable<void> {
        let url_ = this.baseUrl + "/api/dataSynchronizer/importSaleReps";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processImportReps(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processImportReps(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processImportReps(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData400) {
                this.apiConfigService.selectAnyTranslations(resultData400);       
            }
            result400 = SerializableError.fromJS(resultData400);
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    importFreezers(): Observable<void> {
        let url_ = this.baseUrl + "/api/dataSynchronizer/importFreezers";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processImportFreezers(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processImportFreezers(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processImportFreezers(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData400) {
                this.apiConfigService.selectAnyTranslations(resultData400);       
            }
            result400 = SerializableError.fromJS(resultData400);
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class DispatchedAppointmentsService extends ServiceBase {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(ApiConfigService) configuration: ApiConfigService, @Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super(configuration);
        this.http = http;
        this.baseUrl = baseUrl ?? "https://";
    }

    send(command: DispatchedAppointmentCommand): Observable<AppointmentDispatchedRecordDto> {
        let url_ = this.baseUrl + "/api/dispatchedAppointments";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processSend(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processSend(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AppointmentDispatchedRecordDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AppointmentDispatchedRecordDto>;
        }));
    }

    protected processSend(response: HttpResponseBase): Observable<AppointmentDispatchedRecordDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                this.apiConfigService.selectAnyTranslations(resultData200);       
            }
            result200 = AppointmentDispatchedRecordDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData400) {
                this.apiConfigService.selectAnyTranslations(resultData400);       
            }
            result400 = SerializableError.fromJS(resultData400);
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class EmployeesService extends ServiceBase {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(ApiConfigService) configuration: ApiConfigService, @Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super(configuration);
        this.http = http;
        this.baseUrl = baseUrl ?? "https://";
    }

    employees(query: GetEmployeesListQuery): Observable<EmployeeDto[]> {
        let url_ = this.baseUrl + "/api/employees";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processEmployees(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processEmployees(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EmployeeDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EmployeeDto[]>;
        }));
    }

    protected processEmployees(response: HttpResponseBase): Observable<EmployeeDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                this.apiConfigService.selectAnyTranslations(resultData200);       
            }
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(EmployeeDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData400) {
                this.apiConfigService.selectAnyTranslations(resultData400);       
            }
            result400 = SerializableError.fromJS(resultData400);
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    employee(id: string): Observable<EmployeeDto> {
        let url_ = this.baseUrl + "/api/employees/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processEmployee(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processEmployee(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EmployeeDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EmployeeDto>;
        }));
    }

    protected processEmployee(response: HttpResponseBase): Observable<EmployeeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                this.apiConfigService.selectAnyTranslations(resultData200);       
            }
            result200 = EmployeeDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData400) {
                this.apiConfigService.selectAnyTranslations(resultData400);       
            }
            result400 = SerializableError.fromJS(resultData400);
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    delete(id: string): Observable<void> {
        let url_ = this.baseUrl + "/api/employees/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("delete", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processDelete(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processDelete(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData400) {
                this.apiConfigService.selectAnyTranslations(resultData400);       
            }
            result400 = SerializableError.fromJS(resultData400);
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    edit(command: EditEmployeeCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/employees/edit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("put", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processEdit(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processEdit(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData400) {
                this.apiConfigService.selectAnyTranslations(resultData400);       
            }
            result400 = SerializableError.fromJS(resultData400);
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    create(employeeViewModel: EmployeeViewModel): Observable<EmployeeViewModel> {
        let url_ = this.baseUrl + "/api/employees/create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(employeeViewModel);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processCreate(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processCreate(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EmployeeViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EmployeeViewModel>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<EmployeeViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                this.apiConfigService.selectAnyTranslations(resultData200);       
            }
            result200 = EmployeeViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData400) {
                this.apiConfigService.selectAnyTranslations(resultData400);       
            }
            result400 = SerializableError.fromJS(resultData400);
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    resetUserPassword(userId: string): Observable<string> {
        let url_ = this.baseUrl + "/api/employees/{userId}/resetPassword";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("put", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processResetUserPassword(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processResetUserPassword(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processResetUserPassword(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                this.apiConfigService.selectAnyTranslations(resultData200);       
            }
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData400) {
                this.apiConfigService.selectAnyTranslations(resultData400);       
            }
            result400 = SerializableError.fromJS(resultData400);
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ErpIntegrationMgmtService extends ServiceBase {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(ApiConfigService) configuration: ApiConfigService, @Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super(configuration);
        this.http = http;
        this.baseUrl = baseUrl ?? "https://";
    }

    getErpOrdersSyncStatus(query: GetErpOrdersSyncStatusQuery): Observable<PaginatedResultOfCommandeErpStatusDto> {
        let url_ = this.baseUrl + "/api/ErpIntegrationMgmtController/getErpOrdersSyncStatusQuery";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processGetErpOrdersSyncStatus(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetErpOrdersSyncStatus(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PaginatedResultOfCommandeErpStatusDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PaginatedResultOfCommandeErpStatusDto>;
        }));
    }

    protected processGetErpOrdersSyncStatus(response: HttpResponseBase): Observable<PaginatedResultOfCommandeErpStatusDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                this.apiConfigService.selectAnyTranslations(resultData200);       
            }
            result200 = PaginatedResultOfCommandeErpStatusDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData400) {
                this.apiConfigService.selectAnyTranslations(resultData400);       
            }
            result400 = SerializableError.fromJS(resultData400);
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    pushSalesOrdersToOptimoRoute(command: PushSalesOrdersToOptimoRouteCommand): Observable<BaseResponseOfBoolean> {
        let url_ = this.baseUrl + "/api/ErpIntegrationMgmtController/pushSalesOrdersToOptimoRoute";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processPushSalesOrdersToOptimoRoute(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processPushSalesOrdersToOptimoRoute(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BaseResponseOfBoolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BaseResponseOfBoolean>;
        }));
    }

    protected processPushSalesOrdersToOptimoRoute(response: HttpResponseBase): Observable<BaseResponseOfBoolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                this.apiConfigService.selectAnyTranslations(resultData200);       
            }
            result200 = BaseResponseOfBoolean.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData400) {
                this.apiConfigService.selectAnyTranslations(resultData400);       
            }
            result400 = SerializableError.fromJS(resultData400);
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    pushRoutesToERP(command: PushOptimoRoutesToERPCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/ErpIntegrationMgmtController/pushRoutesToERP";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processPushRoutesToERP(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processPushRoutesToERP(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processPushRoutesToERP(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData400) {
                this.apiConfigService.selectAnyTranslations(resultData400);       
            }
            result400 = SerializableError.fromJS(resultData400);
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    processCompletedOrders(command: ProcessCompletedOrdersCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/ErpIntegrationMgmtController/processCompletedOrders";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processProcessCompletedOrders(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processProcessCompletedOrders(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processProcessCompletedOrders(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData400) {
                this.apiConfigService.selectAnyTranslations(resultData400);       
            }
            result400 = SerializableError.fromJS(resultData400);
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    importOrderIntoErp(command: ImportOrdersInERPCommand): Observable<CommandeErpStatusDto> {
        let url_ = this.baseUrl + "/api/ErpIntegrationMgmtController/importOrderIntoErp";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processImportOrderIntoErp(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processImportOrderIntoErp(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CommandeErpStatusDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CommandeErpStatusDto>;
        }));
    }

    protected processImportOrderIntoErp(response: HttpResponseBase): Observable<CommandeErpStatusDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                this.apiConfigService.selectAnyTranslations(resultData200);       
            }
            result200 = CommandeErpStatusDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData400) {
                this.apiConfigService.selectAnyTranslations(resultData400);       
            }
            result400 = SerializableError.fromJS(resultData400);
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    reimportOrderIntoErp(command: ReimportOrdersInERPCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/ErpIntegrationMgmtController/reimportOrderIntoErp";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processReimportOrderIntoErp(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processReimportOrderIntoErp(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processReimportOrderIntoErp(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData400) {
                this.apiConfigService.selectAnyTranslations(resultData400);       
            }
            result400 = SerializableError.fromJS(resultData400);
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteOrderFromErp(command: DeleteClientAndOrdersCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/ErpIntegrationMgmtController/deleteOrderFromErp";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processDeleteOrderFromErp(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processDeleteOrderFromErp(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteOrderFromErp(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData400) {
                this.apiConfigService.selectAnyTranslations(resultData400);       
            }
            result400 = SerializableError.fromJS(resultData400);
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteAllOrdersFromErp(command: DeleteClientAndOrdersCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/ErpIntegrationMgmtController/deleteAllOrdersFromErp";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processDeleteAllOrdersFromErp(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processDeleteAllOrdersFromErp(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteAllOrdersFromErp(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData400) {
                this.apiConfigService.selectAnyTranslations(resultData400);       
            }
            result400 = SerializableError.fromJS(resultData400);
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    uploadPaymentsToERP(command: UploadPaymentsToERPCommand): Observable<BaseResponseOfBoolean> {
        let url_ = this.baseUrl + "/api/ErpIntegrationMgmtController/uploadPaymentsToERP";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processUploadPaymentsToERP(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processUploadPaymentsToERP(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BaseResponseOfBoolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BaseResponseOfBoolean>;
        }));
    }

    protected processUploadPaymentsToERP(response: HttpResponseBase): Observable<BaseResponseOfBoolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                this.apiConfigService.selectAnyTranslations(resultData200);       
            }
            result200 = BaseResponseOfBoolean.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData400) {
                this.apiConfigService.selectAnyTranslations(resultData400);       
            }
            if (Array.isArray(resultData400)) {
                result400 = [] as any;
                for (let item of resultData400)
                    result400!.push(item);
            }
            else {
                result400 = <any>null;
            }
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    stressTestErpPayments(command: StressTestPaymentsCommand): Observable<BaseResponseOfBoolean> {
        let url_ = this.baseUrl + "/api/ErpIntegrationMgmtController/stressTestErpPayments";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processStressTestErpPayments(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processStressTestErpPayments(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BaseResponseOfBoolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BaseResponseOfBoolean>;
        }));
    }

    protected processStressTestErpPayments(response: HttpResponseBase): Observable<BaseResponseOfBoolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                this.apiConfigService.selectAnyTranslations(resultData200);       
            }
            result200 = BaseResponseOfBoolean.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData400) {
                this.apiConfigService.selectAnyTranslations(resultData400);       
            }
            result400 = SerializableError.fromJS(resultData400);
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    removeStressTestData(command: RemoveStressTestDataCommand): Observable<BaseResponseOfBoolean> {
        let url_ = this.baseUrl + "/api/ErpIntegrationMgmtController/removeStressTestData";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processRemoveStressTestData(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processRemoveStressTestData(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BaseResponseOfBoolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BaseResponseOfBoolean>;
        }));
    }

    protected processRemoveStressTestData(response: HttpResponseBase): Observable<BaseResponseOfBoolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                this.apiConfigService.selectAnyTranslations(resultData200);       
            }
            result200 = BaseResponseOfBoolean.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData400) {
                this.apiConfigService.selectAnyTranslations(resultData400);       
            }
            result400 = SerializableError.fromJS(resultData400);
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getRouteOrdersERPSyncStatus(query: GetRouteOrdersERPSyncStatusQuery): Observable<PaginatedResultOfCommandeErpStatusDto> {
        let url_ = this.baseUrl + "/api/ErpIntegrationMgmtController/getRouteOrdersERPSyncStatus";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processGetRouteOrdersERPSyncStatus(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetRouteOrdersERPSyncStatus(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PaginatedResultOfCommandeErpStatusDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PaginatedResultOfCommandeErpStatusDto>;
        }));
    }

    protected processGetRouteOrdersERPSyncStatus(response: HttpResponseBase): Observable<PaginatedResultOfCommandeErpStatusDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                this.apiConfigService.selectAnyTranslations(resultData200);       
            }
            result200 = PaginatedResultOfCommandeErpStatusDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData400) {
                this.apiConfigService.selectAnyTranslations(resultData400);       
            }
            result400 = SerializableError.fromJS(resultData400);
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    importLastOrdersByClientStatus(command: ImportLastOrdersByClientStatusCommand): Observable<BaseResponseOfBoolean> {
        let url_ = this.baseUrl + "/api/ErpIntegrationMgmtController/importLastOrdersByClientStatus";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processImportLastOrdersByClientStatus(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processImportLastOrdersByClientStatus(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BaseResponseOfBoolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BaseResponseOfBoolean>;
        }));
    }

    protected processImportLastOrdersByClientStatus(response: HttpResponseBase): Observable<BaseResponseOfBoolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                this.apiConfigService.selectAnyTranslations(resultData200);       
            }
            result200 = BaseResponseOfBoolean.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData400) {
                this.apiConfigService.selectAnyTranslations(resultData400);       
            }
            result400 = SerializableError.fromJS(resultData400);
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getEligibleClientsToImport(command: GetEligibleClientsToImportCommand): Observable<number[]> {
        let url_ = this.baseUrl + "/api/ErpIntegrationMgmtController/getEligibleClientsToImport";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processGetEligibleClientsToImport(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetEligibleClientsToImport(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number[]>;
        }));
    }

    protected processGetEligibleClientsToImport(response: HttpResponseBase): Observable<number[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                this.apiConfigService.selectAnyTranslations(resultData200);       
            }
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData400) {
                this.apiConfigService.selectAnyTranslations(resultData400);       
            }
            result400 = SerializableError.fromJS(resultData400);
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    importRouteOrdersInERP(command: ImportRouteOrdersInERPCommand): Observable<CommandeErpStatusDto> {
        let url_ = this.baseUrl + "/api/ErpIntegrationMgmtController/importRouteOrdersInERP";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processImportRouteOrdersInERP(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processImportRouteOrdersInERP(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CommandeErpStatusDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CommandeErpStatusDto>;
        }));
    }

    protected processImportRouteOrdersInERP(response: HttpResponseBase): Observable<CommandeErpStatusDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                this.apiConfigService.selectAnyTranslations(resultData200);       
            }
            result200 = CommandeErpStatusDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData400) {
                this.apiConfigService.selectAnyTranslations(resultData400);       
            }
            result400 = SerializableError.fromJS(resultData400);
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getOrderContent(command: GetOrderContentCommand): Observable<CommandeDto> {
        let url_ = this.baseUrl + "/api/ErpIntegrationMgmtController/getOrderContent";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processGetOrderContent(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetOrderContent(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CommandeDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CommandeDto>;
        }));
    }

    protected processGetOrderContent(response: HttpResponseBase): Observable<CommandeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                this.apiConfigService.selectAnyTranslations(resultData200);       
            }
            result200 = CommandeDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData400) {
                this.apiConfigService.selectAnyTranslations(resultData400);       
            }
            result400 = SerializableError.fromJS(resultData400);
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getUnimportedOrders(command: GetUnimportedOrdersCommand): Observable<CommandeDto[]> {
        let url_ = this.baseUrl + "/api/ErpIntegrationMgmtController/getUnimportedOrders";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processGetUnimportedOrders(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetUnimportedOrders(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CommandeDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CommandeDto[]>;
        }));
    }

    protected processGetUnimportedOrders(response: HttpResponseBase): Observable<CommandeDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                this.apiConfigService.selectAnyTranslations(resultData200);       
            }
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CommandeDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData400) {
                this.apiConfigService.selectAnyTranslations(resultData400);       
            }
            result400 = SerializableError.fromJS(resultData400);
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getEligibilityDiagnosisForClient(clientNo: number): Observable<string> {
        let url_ = this.baseUrl + "/api/ErpIntegrationMgmtController/getEligibilityDiagnosisForClient";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(clientNo);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processGetEligibilityDiagnosisForClient(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetEligibilityDiagnosisForClient(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetEligibilityDiagnosisForClient(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                this.apiConfigService.selectAnyTranslations(resultData200);       
            }
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData400) {
                this.apiConfigService.selectAnyTranslations(resultData400);       
            }
            result400 = SerializableError.fromJS(resultData400);
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class FederalDnclService extends ServiceBase {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(ApiConfigService) configuration: ApiConfigService, @Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super(configuration);
        this.http = http;
        this.baseUrl = baseUrl ?? "https://";
    }

    federalDncls(query: GetFederalDnclListQuery): Observable<PaginatedResultOfFederalDnclDto> {
        let url_ = this.baseUrl + "/api/federal-dncl";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processFederalDncls(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processFederalDncls(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PaginatedResultOfFederalDnclDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PaginatedResultOfFederalDnclDto>;
        }));
    }

    protected processFederalDncls(response: HttpResponseBase): Observable<PaginatedResultOfFederalDnclDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                this.apiConfigService.selectAnyTranslations(resultData200);       
            }
            result200 = PaginatedResultOfFederalDnclDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData400) {
                this.apiConfigService.selectAnyTranslations(resultData400);       
            }
            result400 = SerializableError.fromJS(resultData400);
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    federalDncl(phoneNumber: string): Observable<FederalDnclDto> {
        let url_ = this.baseUrl + "/api/federal-dncl/{phoneNumber}";
        if (phoneNumber === undefined || phoneNumber === null)
            throw new Error("The parameter 'phoneNumber' must be defined.");
        url_ = url_.replace("{phoneNumber}", encodeURIComponent("" + phoneNumber));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processFederalDncl(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processFederalDncl(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FederalDnclDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FederalDnclDto>;
        }));
    }

    protected processFederalDncl(response: HttpResponseBase): Observable<FederalDnclDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                this.apiConfigService.selectAnyTranslations(resultData200);       
            }
            result200 = FederalDnclDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData400) {
                this.apiConfigService.selectAnyTranslations(resultData400);       
            }
            result400 = SerializableError.fromJS(resultData400);
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    import(): Observable<void> {
        let url_ = this.baseUrl + "/api/federal-dncl/import";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processImport(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processImport(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processImport(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData400) {
                this.apiConfigService.selectAnyTranslations(resultData400);       
            }
            result400 = SerializableError.fromJS(resultData400);
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class FreezerRegionsService extends ServiceBase {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(ApiConfigService) configuration: ApiConfigService, @Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super(configuration);
        this.http = http;
        this.baseUrl = baseUrl ?? "https://";
    }

    freezerRegions(query: GetFreezerRegionsQuery): Observable<PaginatedResultOfFreezerRegionDto> {
        let url_ = this.baseUrl + "/api/freezerRegions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processFreezerRegions(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processFreezerRegions(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PaginatedResultOfFreezerRegionDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PaginatedResultOfFreezerRegionDto>;
        }));
    }

    protected processFreezerRegions(response: HttpResponseBase): Observable<PaginatedResultOfFreezerRegionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                this.apiConfigService.selectAnyTranslations(resultData200);       
            }
            result200 = PaginatedResultOfFreezerRegionDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData400) {
                this.apiConfigService.selectAnyTranslations(resultData400);       
            }
            result400 = SerializableError.fromJS(resultData400);
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    freezerRegion(id: number): Observable<FreezerRegionDto> {
        let url_ = this.baseUrl + "/api/freezerRegions/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processFreezerRegion(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processFreezerRegion(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FreezerRegionDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FreezerRegionDto>;
        }));
    }

    protected processFreezerRegion(response: HttpResponseBase): Observable<FreezerRegionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                this.apiConfigService.selectAnyTranslations(resultData200);       
            }
            result200 = FreezerRegionDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData400) {
                this.apiConfigService.selectAnyTranslations(resultData400);       
            }
            result400 = SerializableError.fromJS(resultData400);
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    create(command: CreateFreezerRegionCommand): Observable<string> {
        let url_ = this.baseUrl + "/api/freezerRegions/create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processCreate(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processCreate(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                this.apiConfigService.selectAnyTranslations(resultData200);       
            }
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData400) {
                this.apiConfigService.selectAnyTranslations(resultData400);       
            }
            result400 = SerializableError.fromJS(resultData400);
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    edit(command: EditFreezerRegionCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/freezerRegions/edit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("put", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processEdit(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processEdit(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData400) {
                this.apiConfigService.selectAnyTranslations(resultData400);       
            }
            result400 = SerializableError.fromJS(resultData400);
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    addSectorToFreezerRegion(command: AddSectorToFreezerRegionCommand): Observable<string> {
        let url_ = this.baseUrl + "/api/freezerRegions/addSectorToFreezerRegion";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processAddSectorToFreezerRegion(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processAddSectorToFreezerRegion(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processAddSectorToFreezerRegion(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                this.apiConfigService.selectAnyTranslations(resultData200);       
            }
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData400) {
                this.apiConfigService.selectAnyTranslations(resultData400);       
            }
            result400 = SerializableError.fromJS(resultData400);
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    changeFreezerRegionActive(command: ChangeFreezerRegionActiveCommand): Observable<string> {
        let url_ = this.baseUrl + "/api/freezerRegions/changeFreezerRegionActive";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("put", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processChangeFreezerRegionActive(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processChangeFreezerRegionActive(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processChangeFreezerRegionActive(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                this.apiConfigService.selectAnyTranslations(resultData200);       
            }
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData400) {
                this.apiConfigService.selectAnyTranslations(resultData400);       
            }
            result400 = SerializableError.fromJS(resultData400);
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class FreezersService extends ServiceBase {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(ApiConfigService) configuration: ApiConfigService, @Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super(configuration);
        this.http = http;
        this.baseUrl = baseUrl ?? "https://";
    }

    freezers(query: GetFreezerListQuery): Observable<PaginatedResultOfFreezerLookupDto> {
        let url_ = this.baseUrl + "/api/Freezers/Freezers";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processFreezers(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processFreezers(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PaginatedResultOfFreezerLookupDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PaginatedResultOfFreezerLookupDto>;
        }));
    }

    protected processFreezers(response: HttpResponseBase): Observable<PaginatedResultOfFreezerLookupDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                this.apiConfigService.selectAnyTranslations(resultData200);       
            }
            result200 = PaginatedResultOfFreezerLookupDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData400) {
                this.apiConfigService.selectAnyTranslations(resultData400);       
            }
            result400 = SerializableError.fromJS(resultData400);
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    freezer(id: string): Observable<FreezerDto> {
        let url_ = this.baseUrl + "/api/Freezers/Freezer/freezer/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processFreezer(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processFreezer(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FreezerDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FreezerDto>;
        }));
    }

    protected processFreezer(response: HttpResponseBase): Observable<FreezerDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                this.apiConfigService.selectAnyTranslations(resultData200);       
            }
            result200 = FreezerDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData400) {
                this.apiConfigService.selectAnyTranslations(resultData400);       
            }
            result400 = SerializableError.fromJS(resultData400);
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    edit(command: EditFreezerCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/Freezers/Edit/edit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("put", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processEdit(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processEdit(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData400) {
                this.apiConfigService.selectAnyTranslations(resultData400);       
            }
            result400 = SerializableError.fromJS(resultData400);
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    create(command: CreateFreezerCommand): Observable<string> {
        let url_ = this.baseUrl + "/api/Freezers/Create/create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processCreate(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processCreate(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                this.apiConfigService.selectAnyTranslations(resultData200);       
            }
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData400) {
                this.apiConfigService.selectAnyTranslations(resultData400);       
            }
            result400 = SerializableError.fromJS(resultData400);
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    freezerRegions(): Observable<FreezerRegionDto2[]> {
        let url_ = this.baseUrl + "/api/Freezers/FreezerRegions/freezerRegions";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processFreezerRegions(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processFreezerRegions(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FreezerRegionDto2[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FreezerRegionDto2[]>;
        }));
    }

    protected processFreezerRegions(response: HttpResponseBase): Observable<FreezerRegionDto2[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                this.apiConfigService.selectAnyTranslations(resultData200);       
            }
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FreezerRegionDto2.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData400) {
                this.apiConfigService.selectAnyTranslations(resultData400);       
            }
            result400 = SerializableError.fromJS(resultData400);
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    activateFreezer(command: ActivateFreezerCommand): Observable<FreezerDto> {
        let url_ = this.baseUrl + "/api/Freezers/ActivateFreezer/activateFreezer";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processActivateFreezer(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processActivateFreezer(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FreezerDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FreezerDto>;
        }));
    }

    protected processActivateFreezer(response: HttpResponseBase): Observable<FreezerDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                this.apiConfigService.selectAnyTranslations(resultData200);       
            }
            result200 = FreezerDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData400) {
                this.apiConfigService.selectAnyTranslations(resultData400);       
            }
            result400 = SerializableError.fromJS(resultData400);
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deactivateFreezer(command: DeactivateFreezerCommand): Observable<FreezerDto> {
        let url_ = this.baseUrl + "/api/Freezers/DeactivateFreezer/deactivateFreezer";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processDeactivateFreezer(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processDeactivateFreezer(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FreezerDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FreezerDto>;
        }));
    }

    protected processDeactivateFreezer(response: HttpResponseBase): Observable<FreezerDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                this.apiConfigService.selectAnyTranslations(resultData200);       
            }
            result200 = FreezerDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData400) {
                this.apiConfigService.selectAnyTranslations(resultData400);       
            }
            result400 = SerializableError.fromJS(resultData400);
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class HelperService extends ServiceBase {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(ApiConfigService) configuration: ApiConfigService, @Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super(configuration);
        this.http = http;
        this.baseUrl = baseUrl ?? "https://";
    }

    sendTemplateEmailCommand(command: SendTemplateEmailCommand): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/helperController/SendTemplateEmailCommand";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processSendTemplateEmailCommand(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processSendTemplateEmailCommand(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processSendTemplateEmailCommand(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: <any>responseBlob, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    sendClientPortalEmail(): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/helperController/SendClientPortalEmail";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processSendClientPortalEmail(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processSendClientPortalEmail(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processSendClientPortalEmail(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: <any>responseBlob, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ImageService extends ServiceBase {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(ApiConfigService) configuration: ApiConfigService, @Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super(configuration);
        this.http = http;
        this.baseUrl = baseUrl ?? "https://";
    }

    images(): Observable<ImageMediaDto[]> {
        let url_ = this.baseUrl + "/api/Image/Images";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processImages(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processImages(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ImageMediaDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ImageMediaDto[]>;
        }));
    }

    protected processImages(response: HttpResponseBase): Observable<ImageMediaDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                this.apiConfigService.selectAnyTranslations(resultData200);       
            }
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ImageMediaDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData400) {
                this.apiConfigService.selectAnyTranslations(resultData400);       
            }
            result400 = SerializableError.fromJS(resultData400);
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    image(id: string): Observable<ImageMediaDto> {
        let url_ = this.baseUrl + "/api/Image/Image/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processImage(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processImage(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ImageMediaDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ImageMediaDto>;
        }));
    }

    protected processImage(response: HttpResponseBase): Observable<ImageMediaDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                this.apiConfigService.selectAnyTranslations(resultData200);       
            }
            result200 = ImageMediaDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData400) {
                this.apiConfigService.selectAnyTranslations(resultData400);       
            }
            result400 = SerializableError.fromJS(resultData400);
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    create(command: CreateImageCommand): Observable<ImageMediaDto> {
        let url_ = this.baseUrl + "/api/Image/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processCreate(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processCreate(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ImageMediaDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ImageMediaDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<ImageMediaDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                this.apiConfigService.selectAnyTranslations(resultData200);       
            }
            result200 = ImageMediaDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData400) {
                this.apiConfigService.selectAnyTranslations(resultData400);       
            }
            result400 = SerializableError.fromJS(resultData400);
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class LocalDnclService extends ServiceBase {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(ApiConfigService) configuration: ApiConfigService, @Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super(configuration);
        this.http = http;
        this.baseUrl = baseUrl ?? "https://";
    }

    localDncls(query: GetLocalDnclListQuery): Observable<PaginatedResultOfLocalDnclDto> {
        let url_ = this.baseUrl + "/api/local-dncl";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processLocalDncls(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processLocalDncls(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PaginatedResultOfLocalDnclDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PaginatedResultOfLocalDnclDto>;
        }));
    }

    protected processLocalDncls(response: HttpResponseBase): Observable<PaginatedResultOfLocalDnclDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                this.apiConfigService.selectAnyTranslations(resultData200);       
            }
            result200 = PaginatedResultOfLocalDnclDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData400) {
                this.apiConfigService.selectAnyTranslations(resultData400);       
            }
            result400 = SerializableError.fromJS(resultData400);
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteLocalDnclNumber(phoneNumber: string): Observable<void> {
        let url_ = this.baseUrl + "/api/local-dncl/{phoneNumber}";
        if (phoneNumber === undefined || phoneNumber === null)
            throw new Error("The parameter 'phoneNumber' must be defined.");
        url_ = url_.replace("{phoneNumber}", encodeURIComponent("" + phoneNumber));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("delete", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processDeleteLocalDnclNumber(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processDeleteLocalDnclNumber(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteLocalDnclNumber(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData400) {
                this.apiConfigService.selectAnyTranslations(resultData400);       
            }
            result400 = SerializableError.fromJS(resultData400);
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class LoginPageManagementService extends ServiceBase {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(ApiConfigService) configuration: ApiConfigService, @Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super(configuration);
        this.http = http;
        this.baseUrl = baseUrl ?? "https://";
    }

    loginPage(): Observable<LoginPageDto> {
        let url_ = this.baseUrl + "/api/loginpagemanagement";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processLoginPage(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processLoginPage(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LoginPageDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LoginPageDto>;
        }));
    }

    protected processLoginPage(response: HttpResponseBase): Observable<LoginPageDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                this.apiConfigService.selectAnyTranslations(resultData200);       
            }
            result200 = LoginPageDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData400) {
                this.apiConfigService.selectAnyTranslations(resultData400);       
            }
            result400 = SerializableError.fromJS(resultData400);
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateLoginPage(command: UpdateLoginPageCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/loginpagemanagement";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processUpdateLoginPage(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processUpdateLoginPage(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateLoginPage(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData400) {
                this.apiConfigService.selectAnyTranslations(resultData400);       
            }
            result400 = SerializableError.fromJS(resultData400);
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ManagementAppointmentsService extends ServiceBase {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(ApiConfigService) configuration: ApiConfigService, @Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super(configuration);
        this.http = http;
        this.baseUrl = baseUrl ?? "https://";
    }

    legacyAppointmentManagement(callNo: number): Observable<AppointmentManagementDto> {
        let url_ = this.baseUrl + "/api/managementAppointments/{callNo}";
        if (callNo === undefined || callNo === null)
            throw new Error("The parameter 'callNo' must be defined.");
        url_ = url_.replace("{callNo}", encodeURIComponent("" + callNo));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processLegacyAppointmentManagement(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processLegacyAppointmentManagement(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AppointmentManagementDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AppointmentManagementDto>;
        }));
    }

    protected processLegacyAppointmentManagement(response: HttpResponseBase): Observable<AppointmentManagementDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                this.apiConfigService.selectAnyTranslations(resultData200);       
            }
            result200 = AppointmentManagementDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData400) {
                this.apiConfigService.selectAnyTranslations(resultData400);       
            }
            result400 = SerializableError.fromJS(resultData400);
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    edit(command: EditLegacyAppointmentCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/managementAppointments";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("put", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processEdit(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processEdit(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData400) {
                this.apiConfigService.selectAnyTranslations(resultData400);       
            }
            result400 = SerializableError.fromJS(resultData400);
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    appointmentManagements(query: GetAppointmentManagementListQuery): Observable<PaginatedResultOfAppointmentManagementLookupDto> {
        let url_ = this.baseUrl + "/api/managementAppointments";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processAppointmentManagements(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processAppointmentManagements(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PaginatedResultOfAppointmentManagementLookupDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PaginatedResultOfAppointmentManagementLookupDto>;
        }));
    }

    protected processAppointmentManagements(response: HttpResponseBase): Observable<PaginatedResultOfAppointmentManagementLookupDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                this.apiConfigService.selectAnyTranslations(resultData200);       
            }
            result200 = PaginatedResultOfAppointmentManagementLookupDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData400) {
                this.apiConfigService.selectAnyTranslations(resultData400);       
            }
            result400 = SerializableError.fromJS(resultData400);
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    sendAppointmentDetailEmails(command: SendAppointmentDetailEmailsCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/managementAppointments/sendAppointmentDetailEmails";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processSendAppointmentDetailEmails(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processSendAppointmentDetailEmails(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSendAppointmentDetailEmails(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData400) {
                this.apiConfigService.selectAnyTranslations(resultData400);       
            }
            result400 = SerializableError.fromJS(resultData400);
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    confirm(command: ConfirmAppointmentCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/managementAppointments/confirmAppointment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("put", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processConfirm(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processConfirm(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processConfirm(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                this.apiConfigService.selectAnyTranslations(resultData200);       
            }
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData400) {
                this.apiConfigService.selectAnyTranslations(resultData400);       
            }
            result400 = SerializableError.fromJS(resultData400);
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    pastAppointmentsList(clientNo: number): Observable<PastAppointmentDto[]> {
        let url_ = this.baseUrl + "/api/managementAppointments/pastAppointments/{clientNo}";
        if (clientNo === undefined || clientNo === null)
            throw new Error("The parameter 'clientNo' must be defined.");
        url_ = url_.replace("{clientNo}", encodeURIComponent("" + clientNo));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processPastAppointmentsList(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processPastAppointmentsList(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PastAppointmentDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PastAppointmentDto[]>;
        }));
    }

    protected processPastAppointmentsList(response: HttpResponseBase): Observable<PastAppointmentDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                this.apiConfigService.selectAnyTranslations(resultData200);       
            }
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PastAppointmentDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData400) {
                this.apiConfigService.selectAnyTranslations(resultData400);       
            }
            result400 = SerializableError.fromJS(resultData400);
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    appointmentCounts(command: GetFilterCountsQuery): Observable<AppointmentSearchFilterCountsDto> {
        let url_ = this.baseUrl + "/api/managementAppointments/appointmentCounts";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processAppointmentCounts(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processAppointmentCounts(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AppointmentSearchFilterCountsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AppointmentSearchFilterCountsDto>;
        }));
    }

    protected processAppointmentCounts(response: HttpResponseBase): Observable<AppointmentSearchFilterCountsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                this.apiConfigService.selectAnyTranslations(resultData200);       
            }
            result200 = AppointmentSearchFilterCountsDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData400) {
                this.apiConfigService.selectAnyTranslations(resultData400);       
            }
            result400 = SerializableError.fromJS(resultData400);
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class MediaService extends ServiceBase {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(ApiConfigService) configuration: ApiConfigService, @Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super(configuration);
        this.http = http;
        this.baseUrl = baseUrl ?? "https://";
    }

    allMedia(command: GetAllMediaListQuery): Observable<PaginatedResultOfMediaDto> {
        let url_ = this.baseUrl + "/api/medias";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processAllMedia(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processAllMedia(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PaginatedResultOfMediaDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PaginatedResultOfMediaDto>;
        }));
    }

    protected processAllMedia(response: HttpResponseBase): Observable<PaginatedResultOfMediaDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                this.apiConfigService.selectAnyTranslations(resultData200);       
            }
            result200 = PaginatedResultOfMediaDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData400) {
                this.apiConfigService.selectAnyTranslations(resultData400);       
            }
            result400 = SerializableError.fromJS(resultData400);
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    upload(): Observable<string> {
        let url_ = this.baseUrl + "/api/medias/upload";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processUpload(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processUpload(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processUpload(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                this.apiConfigService.selectAnyTranslations(resultData200);       
            }
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData400) {
                this.apiConfigService.selectAnyTranslations(resultData400);       
            }
            result400 = SerializableError.fromJS(resultData400);
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class MenusService extends ServiceBase {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(ApiConfigService) configuration: ApiConfigService, @Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super(configuration);
        this.http = http;
        this.baseUrl = baseUrl ?? "https://";
    }

    webCrmMenuCleaning(): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/menus/WebCrmMenuCleaning";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processWebCrmMenuCleaning(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processWebCrmMenuCleaning(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processWebCrmMenuCleaning(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: <any>responseBlob, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    menus(model: GetMenusListQuery): Observable<PaginatedResultOfMenuLookupDto> {
        let url_ = this.baseUrl + "/api/menus";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processMenus(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processMenus(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PaginatedResultOfMenuLookupDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PaginatedResultOfMenuLookupDto>;
        }));
    }

    protected processMenus(response: HttpResponseBase): Observable<PaginatedResultOfMenuLookupDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                this.apiConfigService.selectAnyTranslations(resultData200);       
            }
            result200 = PaginatedResultOfMenuLookupDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData400) {
                this.apiConfigService.selectAnyTranslations(resultData400);       
            }
            result400 = SerializableError.fromJS(resultData400);
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    edit(command: EditMenuCommand): Observable<MenuDto> {
        let url_ = this.baseUrl + "/api/menus";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("put", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processEdit(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processEdit(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MenuDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MenuDto>;
        }));
    }

    protected processEdit(response: HttpResponseBase): Observable<MenuDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                this.apiConfigService.selectAnyTranslations(resultData200);       
            }
            result200 = MenuDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData400) {
                this.apiConfigService.selectAnyTranslations(resultData400);       
            }
            result400 = SerializableError.fromJS(resultData400);
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    refreshNamesAndPrices(): Observable<void> {
        let url_ = this.baseUrl + "/api/menus/UpdatePrices";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processRefreshNamesAndPrices(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processRefreshNamesAndPrices(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processRefreshNamesAndPrices(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData400) {
                this.apiConfigService.selectAnyTranslations(resultData400);       
            }
            result400 = SerializableError.fromJS(resultData400);
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    defaultMenu(): Observable<MenuDto> {
        let url_ = this.baseUrl + "/api/menus/DefaultMenu";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processDefaultMenu(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processDefaultMenu(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MenuDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MenuDto>;
        }));
    }

    protected processDefaultMenu(response: HttpResponseBase): Observable<MenuDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                this.apiConfigService.selectAnyTranslations(resultData200);       
            }
            result200 = MenuDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData400) {
                this.apiConfigService.selectAnyTranslations(resultData400);       
            }
            result400 = SerializableError.fromJS(resultData400);
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    cloneMenu(id: string | null | undefined): Observable<MenuDto> {
        let url_ = this.baseUrl + "/api/menus/CloneMenu?";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processCloneMenu(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processCloneMenu(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MenuDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MenuDto>;
        }));
    }

    protected processCloneMenu(response: HttpResponseBase): Observable<MenuDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                this.apiConfigService.selectAnyTranslations(resultData200);       
            }
            result200 = MenuDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData400) {
                this.apiConfigService.selectAnyTranslations(resultData400);       
            }
            result400 = SerializableError.fromJS(resultData400);
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    menu(id: string): Observable<MenuDto> {
        let url_ = this.baseUrl + "/api/menus/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processMenu(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processMenu(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MenuDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MenuDto>;
        }));
    }

    protected processMenu(response: HttpResponseBase): Observable<MenuDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                this.apiConfigService.selectAnyTranslations(resultData200);       
            }
            result200 = MenuDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData400) {
                this.apiConfigService.selectAnyTranslations(resultData400);       
            }
            result400 = SerializableError.fromJS(resultData400);
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    delete(id: string): Observable<void> {
        let url_ = this.baseUrl + "/api/menus/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("delete", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processDelete(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processDelete(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData400) {
                this.apiConfigService.selectAnyTranslations(resultData400);       
            }
            result400 = SerializableError.fromJS(resultData400);
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    create(command: CreateMenuCommand): Observable<string> {
        let url_ = this.baseUrl + "/api/menus/create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processCreate(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processCreate(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                this.apiConfigService.selectAnyTranslations(resultData200);       
            }
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData400) {
                this.apiConfigService.selectAnyTranslations(resultData400);       
            }
            result400 = SerializableError.fromJS(resultData400);
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    toggleActiveStatus(command: ToggleActiveStatusCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/menus/toggleActiveStatus";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("put", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processToggleActiveStatus(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processToggleActiveStatus(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processToggleActiveStatus(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData400) {
                this.apiConfigService.selectAnyTranslations(resultData400);       
            }
            result400 = SerializableError.fromJS(resultData400);
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class MigrationService extends ServiceBase {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(ApiConfigService) configuration: ApiConfigService, @Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super(configuration);
        this.http = http;
        this.baseUrl = baseUrl ?? "https://";
    }

    pushMenus(): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/migrations/PushMenus";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processPushMenus(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processPushMenus(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processPushMenus(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: <any>responseBlob, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    pushCategories(): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/migrations/PushCategories";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processPushCategories(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processPushCategories(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processPushCategories(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: <any>responseBlob, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    pushProducts(): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/migrations/PushProducts";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processPushProducts(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processPushProducts(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processPushProducts(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: <any>responseBlob, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    pushAllInventoryEntities(): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/migrations/PushAllInventoryEntities";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processPushAllInventoryEntities(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processPushAllInventoryEntities(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processPushAllInventoryEntities(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: <any>responseBlob, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    pullInventoryEntityUpdates(): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/migrations/PullInventoryEntityUpdates";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processPullInventoryEntityUpdates(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processPullInventoryEntityUpdates(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processPullInventoryEntityUpdates(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: <any>responseBlob, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    pullFreezers(): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/migrations/PullFreezers";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processPullFreezers(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processPullFreezers(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processPullFreezers(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: <any>responseBlob, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class NotificationConfigurationService extends ServiceBase {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(ApiConfigService) configuration: ApiConfigService, @Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super(configuration);
        this.http = http;
        this.baseUrl = baseUrl ?? "https://";
    }

    notificationContacts(): Observable<NotificationContacts[]> {
        let url_ = this.baseUrl + "/api/notification-configuration/notificationContacts";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processNotificationContacts(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processNotificationContacts(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NotificationContacts[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NotificationContacts[]>;
        }));
    }

    protected processNotificationContacts(response: HttpResponseBase): Observable<NotificationContacts[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                this.apiConfigService.selectAnyTranslations(resultData200);       
            }
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(NotificationContacts.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData400) {
                this.apiConfigService.selectAnyTranslations(resultData400);       
            }
            result400 = SerializableError.fromJS(resultData400);
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    addEmployee(command: AddEmployeeInNotificationConfigurationCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/notification-configuration/addEmployee";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processAddEmployee(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processAddEmployee(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAddEmployee(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData400) {
                this.apiConfigService.selectAnyTranslations(resultData400);       
            }
            result400 = SerializableError.fromJS(resultData400);
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    addPhoneNumber(command: AddPhoneNumberInNotificationConfigurationCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/notification-configuration/addPhoneNumber";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processAddPhoneNumber(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processAddPhoneNumber(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAddPhoneNumber(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData400) {
                this.apiConfigService.selectAnyTranslations(resultData400);       
            }
            result400 = SerializableError.fromJS(resultData400);
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteEmailFromNotificationConfiguration(command: DeleteEmailFromNotificationConfigurationCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/notification-configuration/deleteEmailFromNotificationConfiguration";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processDeleteEmailFromNotificationConfiguration(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processDeleteEmailFromNotificationConfiguration(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteEmailFromNotificationConfiguration(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData400) {
                this.apiConfigService.selectAnyTranslations(resultData400);       
            }
            result400 = SerializableError.fromJS(resultData400);
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deletePhoneNumberFromNotificationConfiguration(command: DeletePhoneNumberFromNotificationConfigurationCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/notification-configuration/deletePhoneNumberFromNotificationConfiguration";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processDeletePhoneNumberFromNotificationConfiguration(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processDeletePhoneNumberFromNotificationConfiguration(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeletePhoneNumberFromNotificationConfiguration(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData400) {
                this.apiConfigService.selectAnyTranslations(resultData400);       
            }
            result400 = SerializableError.fromJS(resultData400);
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    syncRecipientEmailsInNotificationEmployeeContacts(): Observable<NotificationContacts[]> {
        let url_ = this.baseUrl + "/api/notification-configuration/syncRecipientEmailsInNotificationEmployeeContacts";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processSyncRecipientEmailsInNotificationEmployeeContacts(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processSyncRecipientEmailsInNotificationEmployeeContacts(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NotificationContacts[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NotificationContacts[]>;
        }));
    }

    protected processSyncRecipientEmailsInNotificationEmployeeContacts(response: HttpResponseBase): Observable<NotificationContacts[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                this.apiConfigService.selectAnyTranslations(resultData200);       
            }
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(NotificationContacts.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData400) {
                this.apiConfigService.selectAnyTranslations(resultData400);       
            }
            result400 = SerializableError.fromJS(resultData400);
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class OptimoConfigService extends ServiceBase {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(ApiConfigService) configuration: ApiConfigService, @Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super(configuration);
        this.http = http;
        this.baseUrl = baseUrl ?? "https://";
    }

    optimoConfig(): Observable<OptimoConfigDto> {
        let url_ = this.baseUrl + "/api/optimo-config/optimoConfig";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processOptimoConfig(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processOptimoConfig(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OptimoConfigDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OptimoConfigDto>;
        }));
    }

    protected processOptimoConfig(response: HttpResponseBase): Observable<OptimoConfigDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                this.apiConfigService.selectAnyTranslations(resultData200);       
            }
            result200 = OptimoConfigDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData400) {
                this.apiConfigService.selectAnyTranslations(resultData400);       
            }
            result400 = SerializableError.fromJS(resultData400);
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateOptimoConfig(command: UpdateOptimoConfigCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/optimo-config/updateOptimoConfig";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processUpdateOptimoConfig(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processUpdateOptimoConfig(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateOptimoConfig(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData400) {
                this.apiConfigService.selectAnyTranslations(resultData400);       
            }
            result400 = SerializableError.fromJS(resultData400);
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class PhoneNumberPrefixService extends ServiceBase {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(ApiConfigService) configuration: ApiConfigService, @Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super(configuration);
        this.http = http;
        this.baseUrl = baseUrl ?? "https://";
    }

    getZones(): Observable<ZoneDto[]> {
        let url_ = this.baseUrl + "/api/phoneNumberPrefix/zones";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processGetZones(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetZones(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ZoneDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ZoneDto[]>;
        }));
    }

    protected processGetZones(response: HttpResponseBase): Observable<ZoneDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                this.apiConfigService.selectAnyTranslations(resultData200);       
            }
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ZoneDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData400) {
                this.apiConfigService.selectAnyTranslations(resultData400);       
            }
            result400 = SerializableError.fromJS(resultData400);
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ProductGroupsService extends ServiceBase {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(ApiConfigService) configuration: ApiConfigService, @Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super(configuration);
        this.http = http;
        this.baseUrl = baseUrl ?? "https://";
    }

    allProductGroups(): Observable<ProductGroupDto[]> {
        let url_ = this.baseUrl + "/api/productGroups";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processAllProductGroups(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processAllProductGroups(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProductGroupDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProductGroupDto[]>;
        }));
    }

    protected processAllProductGroups(response: HttpResponseBase): Observable<ProductGroupDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                this.apiConfigService.selectAnyTranslations(resultData200);       
            }
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProductGroupDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData400) {
                this.apiConfigService.selectAnyTranslations(resultData400);       
            }
            result400 = SerializableError.fromJS(resultData400);
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    productGroups(model: GetProductGroupsListQuery): Observable<PaginatedResultOfProductGroupsLookupViewModel> {
        let url_ = this.baseUrl + "/api/productGroups";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processProductGroups(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processProductGroups(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PaginatedResultOfProductGroupsLookupViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PaginatedResultOfProductGroupsLookupViewModel>;
        }));
    }

    protected processProductGroups(response: HttpResponseBase): Observable<PaginatedResultOfProductGroupsLookupViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                this.apiConfigService.selectAnyTranslations(resultData200);       
            }
            result200 = PaginatedResultOfProductGroupsLookupViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData400) {
                this.apiConfigService.selectAnyTranslations(resultData400);       
            }
            result400 = SerializableError.fromJS(resultData400);
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    edit(command: EditProductGroupCommand): Observable<EditProductGroupCommand> {
        let url_ = this.baseUrl + "/api/productGroups";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("put", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processEdit(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processEdit(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EditProductGroupCommand>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EditProductGroupCommand>;
        }));
    }

    protected processEdit(response: HttpResponseBase): Observable<EditProductGroupCommand> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                this.apiConfigService.selectAnyTranslations(resultData200);       
            }
            result200 = EditProductGroupCommand.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData400) {
                this.apiConfigService.selectAnyTranslations(resultData400);       
            }
            result400 = SerializableError.fromJS(resultData400);
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    productGroup(id: string): Observable<ProductGroupDto> {
        let url_ = this.baseUrl + "/api/productGroups/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processProductGroup(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processProductGroup(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProductGroupDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProductGroupDto>;
        }));
    }

    protected processProductGroup(response: HttpResponseBase): Observable<ProductGroupDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                this.apiConfigService.selectAnyTranslations(resultData200);       
            }
            result200 = ProductGroupDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData400) {
                this.apiConfigService.selectAnyTranslations(resultData400);       
            }
            result400 = SerializableError.fromJS(resultData400);
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    delete(id: string): Observable<void> {
        let url_ = this.baseUrl + "/api/productGroups/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("delete", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processDelete(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processDelete(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData400) {
                this.apiConfigService.selectAnyTranslations(resultData400);       
            }
            result400 = SerializableError.fromJS(resultData400);
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    create(command: CreateProductGroupCommand): Observable<CreateProductGroupCommand> {
        let url_ = this.baseUrl + "/api/productGroups/create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processCreate(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processCreate(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateProductGroupCommand>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateProductGroupCommand>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<CreateProductGroupCommand> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                this.apiConfigService.selectAnyTranslations(resultData200);       
            }
            result200 = CreateProductGroupCommand.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData400) {
                this.apiConfigService.selectAnyTranslations(resultData400);       
            }
            result400 = SerializableError.fromJS(resultData400);
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ProductsService extends ServiceBase {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(ApiConfigService) configuration: ApiConfigService, @Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super(configuration);
        this.http = http;
        this.baseUrl = baseUrl ?? "https://";
    }

    cleanupMissingMenus(): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/products/CleanupMissingMenus";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processCleanupMissingMenus(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processCleanupMissingMenus(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processCleanupMissingMenus(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: <any>responseBlob, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    allProducts(): Observable<ProductDto[]> {
        let url_ = this.baseUrl + "/api/products";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processAllProducts(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processAllProducts(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProductDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProductDto[]>;
        }));
    }

    protected processAllProducts(response: HttpResponseBase): Observable<ProductDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                this.apiConfigService.selectAnyTranslations(resultData200);       
            }
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProductDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData400) {
                this.apiConfigService.selectAnyTranslations(resultData400);       
            }
            result400 = SerializableError.fromJS(resultData400);
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    products(query: GetProductsListQuery): Observable<PaginatedResultOfProductLookupDto> {
        let url_ = this.baseUrl + "/api/products";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processProducts(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processProducts(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PaginatedResultOfProductLookupDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PaginatedResultOfProductLookupDto>;
        }));
    }

    protected processProducts(response: HttpResponseBase): Observable<PaginatedResultOfProductLookupDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                this.apiConfigService.selectAnyTranslations(resultData200);       
            }
            result200 = PaginatedResultOfProductLookupDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData400) {
                this.apiConfigService.selectAnyTranslations(resultData400);       
            }
            result400 = SerializableError.fromJS(resultData400);
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    edit(command: EditProductCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/products";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("put", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processEdit(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processEdit(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData400) {
                this.apiConfigService.selectAnyTranslations(resultData400);       
            }
            result400 = SerializableError.fromJS(resultData400);
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    product(id: string): Observable<ProductDto> {
        let url_ = this.baseUrl + "/api/products/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processProduct(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processProduct(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProductDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProductDto>;
        }));
    }

    protected processProduct(response: HttpResponseBase): Observable<ProductDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                this.apiConfigService.selectAnyTranslations(resultData200);       
            }
            result200 = ProductDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData400) {
                this.apiConfigService.selectAnyTranslations(resultData400);       
            }
            result400 = SerializableError.fromJS(resultData400);
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    delete(id: string): Observable<void> {
        let url_ = this.baseUrl + "/api/products/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("delete", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processDelete(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processDelete(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData400) {
                this.apiConfigService.selectAnyTranslations(resultData400);       
            }
            result400 = SerializableError.fromJS(resultData400);
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    create(command: CreateProductCommand): Observable<ProductDto> {
        let url_ = this.baseUrl + "/api/products/create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processCreate(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processCreate(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProductDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProductDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<ProductDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                this.apiConfigService.selectAnyTranslations(resultData200);       
            }
            result200 = ProductDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData400) {
                this.apiConfigService.selectAnyTranslations(resultData400);       
            }
            result400 = SerializableError.fromJS(resultData400);
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    activateProduct(andAddToMenuCommand: ActivateProductAndAddToMenuCommand): Observable<ProductDto> {
        let url_ = this.baseUrl + "/api/products/activateProduct";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(andAddToMenuCommand);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processActivateProduct(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processActivateProduct(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProductDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProductDto>;
        }));
    }

    protected processActivateProduct(response: HttpResponseBase): Observable<ProductDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                this.apiConfigService.selectAnyTranslations(resultData200);       
            }
            result200 = ProductDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData400) {
                this.apiConfigService.selectAnyTranslations(resultData400);       
            }
            result400 = SerializableError.fromJS(resultData400);
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deactivateProduct(command: DeactivateProductAndRemoveFromMenusCommand): Observable<ProductDto> {
        let url_ = this.baseUrl + "/api/products/deactivateProduct";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processDeactivateProduct(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processDeactivateProduct(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProductDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProductDto>;
        }));
    }

    protected processDeactivateProduct(response: HttpResponseBase): Observable<ProductDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                this.apiConfigService.selectAnyTranslations(resultData200);       
            }
            result200 = ProductDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData400) {
                this.apiConfigService.selectAnyTranslations(resultData400);       
            }
            result400 = SerializableError.fromJS(resultData400);
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getProductsReorderList(command: GetProductReorderingListQuery): Observable<ProductReorderDto> {
        let url_ = this.baseUrl + "/api/products/productReorderList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processGetProductsReorderList(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetProductsReorderList(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProductReorderDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProductReorderDto>;
        }));
    }

    protected processGetProductsReorderList(response: HttpResponseBase): Observable<ProductReorderDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                this.apiConfigService.selectAnyTranslations(resultData200);       
            }
            result200 = ProductReorderDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData400) {
                this.apiConfigService.selectAnyTranslations(resultData400);       
            }
            result400 = SerializableError.fromJS(resultData400);
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    reorderProducts(command: ReorderProductsCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/products/productReorder";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processReorderProducts(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processReorderProducts(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processReorderProducts(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData400) {
                this.apiConfigService.selectAnyTranslations(resultData400);       
            }
            result400 = SerializableError.fromJS(resultData400);
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    downloadProducts(): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/products/download";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processDownloadProducts(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processDownloadProducts(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processDownloadProducts(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: <any>responseBlob, status: status, headers: _headers });
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData400) {
                this.apiConfigService.selectAnyTranslations(resultData400);       
            }
            result400 = SerializableError.fromJS(resultData400);
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ReferralCatalogService extends ServiceBase {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(ApiConfigService) configuration: ApiConfigService, @Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super(configuration);
        this.http = http;
        this.baseUrl = baseUrl ?? "https://";
    }

    referralCatalogs(model: GetReferralCatalogListQuery): Observable<PaginatedResultOfReferralCatalogLookupViewModel> {
        let url_ = this.baseUrl + "/api/referralCatalog";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processReferralCatalogs(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processReferralCatalogs(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PaginatedResultOfReferralCatalogLookupViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PaginatedResultOfReferralCatalogLookupViewModel>;
        }));
    }

    protected processReferralCatalogs(response: HttpResponseBase): Observable<PaginatedResultOfReferralCatalogLookupViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                this.apiConfigService.selectAnyTranslations(resultData200);       
            }
            result200 = PaginatedResultOfReferralCatalogLookupViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData400) {
                this.apiConfigService.selectAnyTranslations(resultData400);       
            }
            result400 = SerializableError.fromJS(resultData400);
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    edit(command: EditReferralCatalogCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/referralCatalog";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("put", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processEdit(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processEdit(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData400) {
                this.apiConfigService.selectAnyTranslations(resultData400);       
            }
            result400 = SerializableError.fromJS(resultData400);
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    referralCatalog(id: string): Observable<ReferralCatalogDto> {
        let url_ = this.baseUrl + "/api/referralCatalog/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processReferralCatalog(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processReferralCatalog(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReferralCatalogDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReferralCatalogDto>;
        }));
    }

    protected processReferralCatalog(response: HttpResponseBase): Observable<ReferralCatalogDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                this.apiConfigService.selectAnyTranslations(resultData200);       
            }
            result200 = ReferralCatalogDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData400) {
                this.apiConfigService.selectAnyTranslations(resultData400);       
            }
            result400 = SerializableError.fromJS(resultData400);
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    delete(id: string): Observable<void> {
        let url_ = this.baseUrl + "/api/referralCatalog/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("delete", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processDelete(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processDelete(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData400) {
                this.apiConfigService.selectAnyTranslations(resultData400);       
            }
            result400 = SerializableError.fromJS(resultData400);
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    create(command: CreateReferralCatalogCommand): Observable<string> {
        let url_ = this.baseUrl + "/api/referralCatalog/create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processCreate(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processCreate(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                this.apiConfigService.selectAnyTranslations(resultData200);       
            }
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData400) {
                this.apiConfigService.selectAnyTranslations(resultData400);       
            }
            result400 = SerializableError.fromJS(resultData400);
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class RfbService extends ServiceBase {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(ApiConfigService) configuration: ApiConfigService, @Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super(configuration);
        this.http = http;
        this.baseUrl = baseUrl ?? "https://";
    }

    check(): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/rfb";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processCheck(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processCheck(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processCheck(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: <any>responseBlob, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class RolesService extends ServiceBase {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(ApiConfigService) configuration: ApiConfigService, @Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super(configuration);
        this.http = http;
        this.baseUrl = baseUrl ?? "https://";
    }

    roles(): Observable<SelectListItem[]> {
        let url_ = this.baseUrl + "/api/roles";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processRoles(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processRoles(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SelectListItem[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SelectListItem[]>;
        }));
    }

    protected processRoles(response: HttpResponseBase): Observable<SelectListItem[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                this.apiConfigService.selectAnyTranslations(resultData200);       
            }
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SelectListItem.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData400) {
                this.apiConfigService.selectAnyTranslations(resultData400);       
            }
            result400 = SerializableError.fromJS(resultData400);
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    policiesRoleMapping(): Observable<RolePoliciesMapping[]> {
        let url_ = this.baseUrl + "/api/roles/policiesRoleMapping";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processPoliciesRoleMapping(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processPoliciesRoleMapping(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RolePoliciesMapping[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RolePoliciesMapping[]>;
        }));
    }

    protected processPoliciesRoleMapping(response: HttpResponseBase): Observable<RolePoliciesMapping[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                this.apiConfigService.selectAnyTranslations(resultData200);       
            }
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RolePoliciesMapping.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData400) {
                this.apiConfigService.selectAnyTranslations(resultData400);       
            }
            result400 = SerializableError.fromJS(resultData400);
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class SalesRepAppointmentsService extends ServiceBase {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(ApiConfigService) configuration: ApiConfigService, @Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super(configuration);
        this.http = http;
        this.baseUrl = baseUrl ?? "https://";
    }

    salesRepAppointment(callNo: number): Observable<SalesRepAppointmentDto> {
        let url_ = this.baseUrl + "/api/salesRepAppointments/{callNo}";
        if (callNo === undefined || callNo === null)
            throw new Error("The parameter 'callNo' must be defined.");
        url_ = url_.replace("{callNo}", encodeURIComponent("" + callNo));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processSalesRepAppointment(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processSalesRepAppointment(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SalesRepAppointmentDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SalesRepAppointmentDto>;
        }));
    }

    protected processSalesRepAppointment(response: HttpResponseBase): Observable<SalesRepAppointmentDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                this.apiConfigService.selectAnyTranslations(resultData200);       
            }
            result200 = SalesRepAppointmentDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData400) {
                this.apiConfigService.selectAnyTranslations(resultData400);       
            }
            result400 = SerializableError.fromJS(resultData400);
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    salesRepAppointments(query: GetUsersAssignedAppointmentListQuery): Observable<PaginatedResultOfAppointmentManagementLookupDto> {
        let url_ = this.baseUrl + "/api/salesRepAppointments";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processSalesRepAppointments(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processSalesRepAppointments(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PaginatedResultOfAppointmentManagementLookupDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PaginatedResultOfAppointmentManagementLookupDto>;
        }));
    }

    protected processSalesRepAppointments(response: HttpResponseBase): Observable<PaginatedResultOfAppointmentManagementLookupDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                this.apiConfigService.selectAnyTranslations(resultData200);       
            }
            result200 = PaginatedResultOfAppointmentManagementLookupDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData400) {
                this.apiConfigService.selectAnyTranslations(resultData400);       
            }
            result400 = SerializableError.fromJS(resultData400);
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class SalesRepDashboardService extends ServiceBase {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(ApiConfigService) configuration: ApiConfigService, @Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super(configuration);
        this.http = http;
        this.baseUrl = baseUrl ?? "https://";
    }

    dashboard(query: GetSalesRepDashboardMetricQuery): Observable<SalesRepDashboardDto> {
        let url_ = this.baseUrl + "/api/salesRepDashboard/dashboard";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processDashboard(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processDashboard(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SalesRepDashboardDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SalesRepDashboardDto>;
        }));
    }

    protected processDashboard(response: HttpResponseBase): Observable<SalesRepDashboardDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                this.apiConfigService.selectAnyTranslations(resultData200);       
            }
            result200 = SalesRepDashboardDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData400) {
                this.apiConfigService.selectAnyTranslations(resultData400);       
            }
            result400 = SerializableError.fromJS(resultData400);
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    salesForRepByMonth(query: GetSalesForRepByMonth): Observable<RepsSaleDto[]> {
        let url_ = this.baseUrl + "/api/salesRepDashboard/salesForRepByMonth";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processSalesForRepByMonth(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processSalesForRepByMonth(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RepsSaleDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RepsSaleDto[]>;
        }));
    }

    protected processSalesForRepByMonth(response: HttpResponseBase): Observable<RepsSaleDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                this.apiConfigService.selectAnyTranslations(resultData200);       
            }
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RepsSaleDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData400) {
                this.apiConfigService.selectAnyTranslations(resultData400);       
            }
            result400 = SerializableError.fromJS(resultData400);
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class SalesRepsService extends ServiceBase {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(ApiConfigService) configuration: ApiConfigService, @Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super(configuration);
        this.http = http;
        this.baseUrl = baseUrl ?? "https://";
    }

    salesReps(getSalesRepDispatchList: boolean | undefined): Observable<SalesRepDto[]> {
        let url_ = this.baseUrl + "/api/salesReps?";
        if (getSalesRepDispatchList === null)
            throw new Error("The parameter 'getSalesRepDispatchList' cannot be null.");
        else if (getSalesRepDispatchList !== undefined)
            url_ += "GetSalesRepDispatchList=" + encodeURIComponent("" + getSalesRepDispatchList) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processSalesReps(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processSalesReps(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SalesRepDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SalesRepDto[]>;
        }));
    }

    protected processSalesReps(response: HttpResponseBase): Observable<SalesRepDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                this.apiConfigService.selectAnyTranslations(resultData200);       
            }
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SalesRepDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData400) {
                this.apiConfigService.selectAnyTranslations(resultData400);       
            }
            result400 = SerializableError.fromJS(resultData400);
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    salesDirectors(): Observable<SalesDirectorDto[]> {
        let url_ = this.baseUrl + "/api/salesReps/directors";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processSalesDirectors(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processSalesDirectors(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SalesDirectorDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SalesDirectorDto[]>;
        }));
    }

    protected processSalesDirectors(response: HttpResponseBase): Observable<SalesDirectorDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                this.apiConfigService.selectAnyTranslations(resultData200);       
            }
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SalesDirectorDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData400) {
                this.apiConfigService.selectAnyTranslations(resultData400);       
            }
            result400 = SerializableError.fromJS(resultData400);
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ScheduledJobsService extends ServiceBase {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(ApiConfigService) configuration: ApiConfigService, @Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super(configuration);
        this.http = http;
        this.baseUrl = baseUrl ?? "https://";
    }

    scheduledJob(name: string): Observable<ScheduledJobsDto> {
        let url_ = this.baseUrl + "/api/scheduledJobs/{name}";
        if (name === undefined || name === null)
            throw new Error("The parameter 'name' must be defined.");
        url_ = url_.replace("{name}", encodeURIComponent("" + name));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processScheduledJob(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processScheduledJob(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ScheduledJobsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ScheduledJobsDto>;
        }));
    }

    protected processScheduledJob(response: HttpResponseBase): Observable<ScheduledJobsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                this.apiConfigService.selectAnyTranslations(resultData200);       
            }
            result200 = ScheduledJobsDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData400) {
                this.apiConfigService.selectAnyTranslations(resultData400);       
            }
            result400 = SerializableError.fromJS(resultData400);
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    update(command: UpdateScheduledJobCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/scheduledJobs/update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("put", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processUpdate(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processUpdate(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData400) {
                this.apiConfigService.selectAnyTranslations(resultData400);       
            }
            result400 = SerializableError.fromJS(resultData400);
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ScheduleManagementService extends ServiceBase {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(ApiConfigService) configuration: ApiConfigService, @Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super(configuration);
        this.http = http;
        this.baseUrl = baseUrl ?? "https://";
    }

    getSalesRepScheduleForTheWeek(query: GetSalesRepScheduleQuery): Observable<SalesRepScheduleDto[]> {
        let url_ = this.baseUrl + "/api/scheduleManagement/getSalesRepScheduleForTheWeek";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processGetSalesRepScheduleForTheWeek(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetSalesRepScheduleForTheWeek(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SalesRepScheduleDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SalesRepScheduleDto[]>;
        }));
    }

    protected processGetSalesRepScheduleForTheWeek(response: HttpResponseBase): Observable<SalesRepScheduleDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                this.apiConfigService.selectAnyTranslations(resultData200);       
            }
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SalesRepScheduleDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData400) {
                this.apiConfigService.selectAnyTranslations(resultData400);       
            }
            result400 = SerializableError.fromJS(resultData400);
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getMySalesRepDefaultLocation(query: GetMySalesRepDefaultLocationQuery): Observable<SalesRepLocationDto> {
        let url_ = this.baseUrl + "/api/scheduleManagement/getMySalesRepDefaultLocation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processGetMySalesRepDefaultLocation(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetMySalesRepDefaultLocation(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SalesRepLocationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SalesRepLocationDto>;
        }));
    }

    protected processGetMySalesRepDefaultLocation(response: HttpResponseBase): Observable<SalesRepLocationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                this.apiConfigService.selectAnyTranslations(resultData200);       
            }
            result200 = SalesRepLocationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData400) {
                this.apiConfigService.selectAnyTranslations(resultData400);       
            }
            result400 = SerializableError.fromJS(resultData400);
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateSalesRepSchedule(command: UpdateSalesRepScheduleCommand): Observable<Unit> {
        let url_ = this.baseUrl + "/api/scheduleManagement/updateSalesRepSchedule";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processUpdateSalesRepSchedule(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processUpdateSalesRepSchedule(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Unit>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Unit>;
        }));
    }

    protected processUpdateSalesRepSchedule(response: HttpResponseBase): Observable<Unit> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                this.apiConfigService.selectAnyTranslations(resultData200);       
            }
            result200 = Unit.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData400) {
                this.apiConfigService.selectAnyTranslations(resultData400);       
            }
            result400 = SerializableError.fromJS(resultData400);
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getSalesRepLocations(query: GetSalesRepLocationsQuery): Observable<SalesRepLocationDto[]> {
        let url_ = this.baseUrl + "/api/scheduleManagement/getSalesRepLocations";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processGetSalesRepLocations(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetSalesRepLocations(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SalesRepLocationDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SalesRepLocationDto[]>;
        }));
    }

    protected processGetSalesRepLocations(response: HttpResponseBase): Observable<SalesRepLocationDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                this.apiConfigService.selectAnyTranslations(resultData200);       
            }
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SalesRepLocationDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData400) {
                this.apiConfigService.selectAnyTranslations(resultData400);       
            }
            result400 = SerializableError.fromJS(resultData400);
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getSalesRepLocationGroups(query: GetSalesRepLocationGroupsQuery): Observable<SalesRepLocationGroupDto[]> {
        let url_ = this.baseUrl + "/api/scheduleManagement/getSalesRepLocationGroups";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processGetSalesRepLocationGroups(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetSalesRepLocationGroups(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SalesRepLocationGroupDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SalesRepLocationGroupDto[]>;
        }));
    }

    protected processGetSalesRepLocationGroups(response: HttpResponseBase): Observable<SalesRepLocationGroupDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                this.apiConfigService.selectAnyTranslations(resultData200);       
            }
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SalesRepLocationGroupDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData400) {
                this.apiConfigService.selectAnyTranslations(resultData400);       
            }
            result400 = SerializableError.fromJS(resultData400);
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getMySalesRepProfile(query: GetMySalesRepProfileQuery): Observable<SalesRepProfileDto> {
        let url_ = this.baseUrl + "/api/scheduleManagement/getMySalesRepProfile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processGetMySalesRepProfile(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetMySalesRepProfile(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SalesRepProfileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SalesRepProfileDto>;
        }));
    }

    protected processGetMySalesRepProfile(response: HttpResponseBase): Observable<SalesRepProfileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                this.apiConfigService.selectAnyTranslations(resultData200);       
            }
            result200 = SalesRepProfileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData400) {
                this.apiConfigService.selectAnyTranslations(resultData400);       
            }
            result400 = SerializableError.fromJS(resultData400);
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAllSalesRepProfiles(query: GetAllSalesRepProfileQuery): Observable<SalesRepProfileDto[]> {
        let url_ = this.baseUrl + "/api/scheduleManagement/getAllSalesRepProfile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processGetAllSalesRepProfiles(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetAllSalesRepProfiles(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SalesRepProfileDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SalesRepProfileDto[]>;
        }));
    }

    protected processGetAllSalesRepProfiles(response: HttpResponseBase): Observable<SalesRepProfileDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                this.apiConfigService.selectAnyTranslations(resultData200);       
            }
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SalesRepProfileDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData400) {
                this.apiConfigService.selectAnyTranslations(resultData400);       
            }
            result400 = SerializableError.fromJS(resultData400);
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getSalesRepUnderManagement(query: GetSalesRepUnderManagementQuery): Observable<SalesRepProfileDto[]> {
        let url_ = this.baseUrl + "/api/scheduleManagement/getSalesRepUnderManagement";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processGetSalesRepUnderManagement(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetSalesRepUnderManagement(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SalesRepProfileDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SalesRepProfileDto[]>;
        }));
    }

    protected processGetSalesRepUnderManagement(response: HttpResponseBase): Observable<SalesRepProfileDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                this.apiConfigService.selectAnyTranslations(resultData200);       
            }
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SalesRepProfileDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData400) {
                this.apiConfigService.selectAnyTranslations(resultData400);       
            }
            result400 = SerializableError.fromJS(resultData400);
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getScheduledAppointments(query: GetScheduledAppointmentsQuery): Observable<ScheduledAppointmentDto[]> {
        let url_ = this.baseUrl + "/api/scheduleManagement/getScheduledAppointments";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processGetScheduledAppointments(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetScheduledAppointments(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ScheduledAppointmentDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ScheduledAppointmentDto[]>;
        }));
    }

    protected processGetScheduledAppointments(response: HttpResponseBase): Observable<ScheduledAppointmentDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                this.apiConfigService.selectAnyTranslations(resultData200);       
            }
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ScheduledAppointmentDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData400) {
                this.apiConfigService.selectAnyTranslations(resultData400);       
            }
            result400 = SerializableError.fromJS(resultData400);
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getScheduledAppointmentsFromRepsUnderMgmt(query: GetScheduledAppointmentsFromRepsUnderMgmtQuery): Observable<ScheduledAppointmentDto[]> {
        let url_ = this.baseUrl + "/api/scheduleManagement/getScheduledAppointmentsFromRepsUnderMgmt";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processGetScheduledAppointmentsFromRepsUnderMgmt(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetScheduledAppointmentsFromRepsUnderMgmt(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ScheduledAppointmentDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ScheduledAppointmentDto[]>;
        }));
    }

    protected processGetScheduledAppointmentsFromRepsUnderMgmt(response: HttpResponseBase): Observable<ScheduledAppointmentDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                this.apiConfigService.selectAnyTranslations(resultData200);       
            }
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ScheduledAppointmentDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData400) {
                this.apiConfigService.selectAnyTranslations(resultData400);       
            }
            result400 = SerializableError.fromJS(resultData400);
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAllSalesRepInRegionByWeek(query: GetAllSalesRepInRegionByWeekQuery): Observable<SalesRepProfileDto[]> {
        let url_ = this.baseUrl + "/api/scheduleManagement/getAllSalesRepInRegionByWeek";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processGetAllSalesRepInRegionByWeek(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetAllSalesRepInRegionByWeek(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SalesRepProfileDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SalesRepProfileDto[]>;
        }));
    }

    protected processGetAllSalesRepInRegionByWeek(response: HttpResponseBase): Observable<SalesRepProfileDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                this.apiConfigService.selectAnyTranslations(resultData200);       
            }
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SalesRepProfileDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData400) {
                this.apiConfigService.selectAnyTranslations(resultData400);       
            }
            result400 = SerializableError.fromJS(resultData400);
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ServiceTicketsService extends ServiceBase {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(ApiConfigService) configuration: ApiConfigService, @Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super(configuration);
        this.http = http;
        this.baseUrl = baseUrl ?? "https://";
    }

    serviceTicketsQuery(query: GetServiceTicketListQuery): Observable<PaginatedResultOfServiceTicketLookupDto> {
        let url_ = this.baseUrl + "/api/serviceTickets/serviceTicketsQuery";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processServiceTicketsQuery(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processServiceTicketsQuery(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PaginatedResultOfServiceTicketLookupDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PaginatedResultOfServiceTicketLookupDto>;
        }));
    }

    protected processServiceTicketsQuery(response: HttpResponseBase): Observable<PaginatedResultOfServiceTicketLookupDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                this.apiConfigService.selectAnyTranslations(resultData200);       
            }
            result200 = PaginatedResultOfServiceTicketLookupDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData400) {
                this.apiConfigService.selectAnyTranslations(resultData400);       
            }
            result400 = SerializableError.fromJS(resultData400);
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    myServiceTicketsQuery(query: GetMyServiceTicketsListQuery): Observable<PaginatedResultOfServiceTicketLookupDto> {
        let url_ = this.baseUrl + "/api/serviceTickets/myServiceTicketsQuery";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processMyServiceTicketsQuery(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processMyServiceTicketsQuery(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PaginatedResultOfServiceTicketLookupDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PaginatedResultOfServiceTicketLookupDto>;
        }));
    }

    protected processMyServiceTicketsQuery(response: HttpResponseBase): Observable<PaginatedResultOfServiceTicketLookupDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                this.apiConfigService.selectAnyTranslations(resultData200);       
            }
            result200 = PaginatedResultOfServiceTicketLookupDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData400) {
                this.apiConfigService.selectAnyTranslations(resultData400);       
            }
            result400 = SerializableError.fromJS(resultData400);
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    create(command: CreateServiceTicketCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/serviceTickets";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processCreate(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processCreate(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                this.apiConfigService.selectAnyTranslations(resultData200);       
            }
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData400) {
                this.apiConfigService.selectAnyTranslations(resultData400);       
            }
            result400 = SerializableError.fromJS(resultData400);
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    edit(id: number, command: EditServiceTicketCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/serviceTickets/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("put", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processEdit(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processEdit(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData400) {
                this.apiConfigService.selectAnyTranslations(resultData400);       
            }
            result400 = SerializableError.fromJS(resultData400);
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    serviceTicket(id: number): Observable<ServiceTicketDto> {
        let url_ = this.baseUrl + "/api/serviceTickets/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processServiceTicket(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processServiceTicket(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ServiceTicketDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ServiceTicketDto>;
        }));
    }

    protected processServiceTicket(response: HttpResponseBase): Observable<ServiceTicketDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                this.apiConfigService.selectAnyTranslations(resultData200);       
            }
            result200 = ServiceTicketDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData400) {
                this.apiConfigService.selectAnyTranslations(resultData400);       
            }
            result400 = SerializableError.fromJS(resultData400);
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    createServiceTicketNote(command: CreateServiceTicketNoteCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/serviceTickets/note";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processCreateServiceTicketNote(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processCreateServiceTicketNote(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreateServiceTicketNote(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                this.apiConfigService.selectAnyTranslations(resultData200);       
            }
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData400) {
                this.apiConfigService.selectAnyTranslations(resultData400);       
            }
            result400 = SerializableError.fromJS(resultData400);
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    serviceTicketNotes(id: number): Observable<ServiceTicketNoteDto[]> {
        let url_ = this.baseUrl + "/api/serviceTickets/{id}/note";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processServiceTicketNotes(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processServiceTicketNotes(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ServiceTicketNoteDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ServiceTicketNoteDto[]>;
        }));
    }

    protected processServiceTicketNotes(response: HttpResponseBase): Observable<ServiceTicketNoteDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                this.apiConfigService.selectAnyTranslations(resultData200);       
            }
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ServiceTicketNoteDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData400) {
                this.apiConfigService.selectAnyTranslations(resultData400);       
            }
            result400 = SerializableError.fromJS(resultData400);
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    serviceTicketNote(id: number): Observable<ServiceTicketNoteDto> {
        let url_ = this.baseUrl + "/api/serviceTickets/note/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processServiceTicketNote(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processServiceTicketNote(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ServiceTicketNoteDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ServiceTicketNoteDto>;
        }));
    }

    protected processServiceTicketNote(response: HttpResponseBase): Observable<ServiceTicketNoteDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                this.apiConfigService.selectAnyTranslations(resultData200);       
            }
            result200 = ServiceTicketNoteDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData400) {
                this.apiConfigService.selectAnyTranslations(resultData400);       
            }
            result400 = SerializableError.fromJS(resultData400);
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    attachFileToNote(id: number, files: FileParameter[] | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/serviceTickets/note/attachment/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (files !== null && files !== undefined)
            files.forEach(item_ => content_.append("files", item_.data, item_.fileName ? item_.fileName : "files") );

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processAttachFileToNote(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processAttachFileToNote(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAttachFileToNote(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData400) {
                this.apiConfigService.selectAnyTranslations(resultData400);       
            }
            result400 = SerializableError.fromJS(resultData400);
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    attachFileToTicket(id: number, files: FileParameter[] | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/serviceTickets/attachment/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (files !== null && files !== undefined)
            files.forEach(item_ => content_.append("files", item_.data, item_.fileName ? item_.fileName : "files") );

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processAttachFileToTicket(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processAttachFileToTicket(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAttachFileToTicket(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData400) {
                this.apiConfigService.selectAnyTranslations(resultData400);       
            }
            result400 = SerializableError.fromJS(resultData400);
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAttachment(id: number): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/serviceTickets/attachment/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processGetAttachment(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetAttachment(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processGetAttachment(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: <any>responseBlob, status: status, headers: _headers });
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData400) {
                this.apiConfigService.selectAnyTranslations(resultData400);       
            }
            result400 = SerializableError.fromJS(resultData400);
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    serviceTicketCategories(): Observable<ServiceTicketCategoryDto[]> {
        let url_ = this.baseUrl + "/api/serviceTickets/serviceTicketCategories";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processServiceTicketCategories(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processServiceTicketCategories(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ServiceTicketCategoryDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ServiceTicketCategoryDto[]>;
        }));
    }

    protected processServiceTicketCategories(response: HttpResponseBase): Observable<ServiceTicketCategoryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                this.apiConfigService.selectAnyTranslations(resultData200);       
            }
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ServiceTicketCategoryDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData400) {
                this.apiConfigService.selectAnyTranslations(resultData400);       
            }
            result400 = SerializableError.fromJS(resultData400);
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    assignEmployeeToClientLead(command: AssignEmployeeToServiceTicketCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/serviceTickets/assignEmployeeToClientLead";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processAssignEmployeeToClientLead(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processAssignEmployeeToClientLead(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAssignEmployeeToClientLead(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData400) {
                this.apiConfigService.selectAnyTranslations(resultData400);       
            }
            result400 = SerializableError.fromJS(resultData400);
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    unassignEmployeeToClientLead(command: UnassignEmployeeOnServiceTicketCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/serviceTickets/unassignEmployeeToClientLead";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processUnassignEmployeeToClientLead(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processUnassignEmployeeToClientLead(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUnassignEmployeeToClientLead(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData400) {
                this.apiConfigService.selectAnyTranslations(resultData400);       
            }
            result400 = SerializableError.fromJS(resultData400);
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    changeStatus(command: ChangeServiceTicketStatusCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/serviceTickets/changeStatus";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("put", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processChangeStatus(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processChangeStatus(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processChangeStatus(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData400) {
                this.apiConfigService.selectAnyTranslations(resultData400);       
            }
            result400 = SerializableError.fromJS(resultData400);
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    cancelTicket(command: CancelServiceTicketCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/serviceTickets/cancel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("put", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processCancelTicket(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processCancelTicket(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCancelTicket(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData400) {
                this.apiConfigService.selectAnyTranslations(resultData400);       
            }
            result400 = SerializableError.fromJS(resultData400);
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    typeExporter(contentType: string | null | undefined, contentDisposition: string | null | undefined, headers: any[] | null | undefined, length: number | undefined, name: string | null | undefined, fileName: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/serviceTickets/typeResolver";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (contentType !== null && contentType !== undefined)
            content_.append("ContentType", contentType.toString());
        if (contentDisposition !== null && contentDisposition !== undefined)
            content_.append("ContentDisposition", contentDisposition.toString());
        if (headers !== null && headers !== undefined)
            headers.forEach(item_ => content_.append("Headers", item_.toString()));
        if (length === null || length === undefined)
            throw new Error("The parameter 'length' cannot be null.");
        else
            content_.append("Length", length.toString());
        if (name !== null && name !== undefined)
            content_.append("Name", name.toString());
        if (fileName !== null && fileName !== undefined)
            content_.append("FileName", fileName.toString());

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processTypeExporter(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processTypeExporter(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processTypeExporter(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    serviceTicketsAssignedEmployees(): Observable<EmployeeDto[]> {
        let url_ = this.baseUrl + "/api/serviceTickets/serviceTicketsAssignedEmployees";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processServiceTicketsAssignedEmployees(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processServiceTicketsAssignedEmployees(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EmployeeDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EmployeeDto[]>;
        }));
    }

    protected processServiceTicketsAssignedEmployees(response: HttpResponseBase): Observable<EmployeeDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                this.apiConfigService.selectAnyTranslations(resultData200);       
            }
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(EmployeeDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData400) {
                this.apiConfigService.selectAnyTranslations(resultData400);       
            }
            result400 = SerializableError.fromJS(resultData400);
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class SmsService extends ServiceBase {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(ApiConfigService) configuration: ApiConfigService, @Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super(configuration);
        this.http = http;
        this.baseUrl = baseUrl ?? "https://";
    }

    sendSmsToSpecifiedNumbersCommand(command: SendSmsToSpecifiedNumbersCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/sms/sendSmsToSpecifiedNumbers";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processSendSmsToSpecifiedNumbersCommand(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processSendSmsToSpecifiedNumbersCommand(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSendSmsToSpecifiedNumbersCommand(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData400) {
                this.apiConfigService.selectAnyTranslations(resultData400);       
            }
            result400 = SerializableError.fromJS(resultData400);
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    convertNumbersCSVToJsonCommand(command: ConvertNumbersCSVToJsonCommand): Observable<string[]> {
        let url_ = this.baseUrl + "/api/sms/convertNumbersCSVToJson";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processConvertNumbersCSVToJsonCommand(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processConvertNumbersCSVToJsonCommand(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string[]>;
        }));
    }

    protected processConvertNumbersCSVToJsonCommand(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                this.apiConfigService.selectAnyTranslations(resultData200);       
            }
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData400) {
                this.apiConfigService.selectAnyTranslations(resultData400);       
            }
            result400 = SerializableError.fromJS(resultData400);
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class TabletCatalogService extends ServiceBase {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(ApiConfigService) configuration: ApiConfigService, @Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super(configuration);
        this.http = http;
        this.baseUrl = baseUrl ?? "https://";
    }

    pushProductCatalog(): Observable<void> {
        let url_ = this.baseUrl + "/api/tabletCatalog/pushProductCatalog";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processPushProductCatalog(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processPushProductCatalog(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processPushProductCatalog(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData400) {
                this.apiConfigService.selectAnyTranslations(resultData400);       
            }
            result400 = SerializableError.fromJS(resultData400);
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    pushReferralCatalog(): Observable<void> {
        let url_ = this.baseUrl + "/api/tabletCatalog/pushReferralCatalog";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processPushReferralCatalog(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processPushReferralCatalog(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processPushReferralCatalog(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData400) {
                this.apiConfigService.selectAnyTranslations(resultData400);       
            }
            result400 = SerializableError.fromJS(resultData400);
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    pushFreezerCatalog(): Observable<void> {
        let url_ = this.baseUrl + "/api/tabletCatalog/pushFreezerCatalog";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processPushFreezerCatalog(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processPushFreezerCatalog(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processPushFreezerCatalog(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData400) {
                this.apiConfigService.selectAnyTranslations(resultData400);       
            }
            result400 = SerializableError.fromJS(resultData400);
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    pushApplianceCatalog(): Observable<void> {
        let url_ = this.baseUrl + "/api/tabletCatalog/pushApplianceCatalog";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processPushApplianceCatalog(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processPushApplianceCatalog(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processPushApplianceCatalog(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData400) {
                this.apiConfigService.selectAnyTranslations(resultData400);       
            }
            result400 = SerializableError.fromJS(resultData400);
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class TestDataGeneratorService extends ServiceBase {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(ApiConfigService) configuration: ApiConfigService, @Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super(configuration);
        this.http = http;
        this.baseUrl = baseUrl ?? "https://";
    }

    populateDeliveredAmount(): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/TestDataGenerator/PopulateDeliveredAmount";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processPopulateDeliveredAmount(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processPopulateDeliveredAmount(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processPopulateDeliveredAmount(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: <any>responseBlob, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    createTestServiceTickets(): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/TestDataGenerator/CreateTestServiceTickets";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processCreateTestServiceTickets(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processCreateTestServiceTickets(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processCreateTestServiceTickets(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: <any>responseBlob, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    createTestSalesRepMonthlyPerformanceRecords(): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/TestDataGenerator/CreateTestSalesRepMonthlyPerformanceRecords";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processCreateTestSalesRepMonthlyPerformanceRecords(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processCreateTestSalesRepMonthlyPerformanceRecords(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processCreateTestSalesRepMonthlyPerformanceRecords(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: <any>responseBlob, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    createTestFreezerRegions(): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/TestDataGenerator/CreateTestFreezerRegions";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processCreateTestFreezerRegions(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processCreateTestFreezerRegions(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processCreateTestFreezerRegions(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: <any>responseBlob, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    createNonRenouveleVocalComs(): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/TestDataGenerator/CreateTestNonRenouveleVocalComs";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processCreateNonRenouveleVocalComs(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processCreateNonRenouveleVocalComs(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processCreateNonRenouveleVocalComs(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: <any>responseBlob, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    testEftGeneratedEmail(): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/TestDataGenerator/TestEmails/eft-generated";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processTestEftGeneratedEmail(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processTestEftGeneratedEmail(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processTestEftGeneratedEmail(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: <any>responseBlob, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    createTestClientLeads(numberOfClientLeads: number | undefined, phoneNumber: string | null | undefined, addTestNotes: boolean | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/TestDataGenerator/CreateTestClientLeads?";
        if (numberOfClientLeads === null)
            throw new Error("The parameter 'numberOfClientLeads' cannot be null.");
        else if (numberOfClientLeads !== undefined)
            url_ += "numberOfClientLeads=" + encodeURIComponent("" + numberOfClientLeads) + "&";
        if (phoneNumber !== undefined && phoneNumber !== null)
            url_ += "phoneNumber=" + encodeURIComponent("" + phoneNumber) + "&";
        if (addTestNotes === null)
            throw new Error("The parameter 'addTestNotes' cannot be null.");
        else if (addTestNotes !== undefined)
            url_ += "addTestNotes=" + encodeURIComponent("" + addTestNotes) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processCreateTestClientLeads(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processCreateTestClientLeads(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processCreateTestClientLeads(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: <any>responseBlob, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    testSanatizePhoneNumbers(phoneNumbers: string[]): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/TestDataGenerator/TestSanitizePhoneNumbers";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(phoneNumbers);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processTestSanatizePhoneNumbers(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processTestSanatizePhoneNumbers(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processTestSanatizePhoneNumbers(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: <any>responseBlob, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAppsetting(): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/TestDataGenerator/GetAppsetting";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processGetAppsetting(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetAppsetting(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processGetAppsetting(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: <any>responseBlob, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class TMDashboardService extends ServiceBase {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(ApiConfigService) configuration: ApiConfigService, @Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super(configuration);
        this.http = http;
        this.baseUrl = baseUrl ?? "https://";
    }

    dashboard(query: GetTmDashboardMetricQuery): Observable<TmDashboardDto> {
        let url_ = this.baseUrl + "/api/tmDashboard/dashboard";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processDashboard(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processDashboard(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TmDashboardDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TmDashboardDto>;
        }));
    }

    protected processDashboard(response: HttpResponseBase): Observable<TmDashboardDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                this.apiConfigService.selectAnyTranslations(resultData200);       
            }
            result200 = TmDashboardDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData400) {
                this.apiConfigService.selectAnyTranslations(resultData400);       
            }
            result400 = SerializableError.fromJS(resultData400);
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class VideoService extends ServiceBase {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(ApiConfigService) configuration: ApiConfigService, @Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super(configuration);
        this.http = http;
        this.baseUrl = baseUrl ?? "https://";
    }

    video(id: string): Observable<VideoMediaDto> {
        let url_ = this.baseUrl + "/api/Video/Video/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processVideo(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processVideo(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<VideoMediaDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<VideoMediaDto>;
        }));
    }

    protected processVideo(response: HttpResponseBase): Observable<VideoMediaDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                this.apiConfigService.selectAnyTranslations(resultData200);       
            }
            result200 = VideoMediaDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData400) {
                this.apiConfigService.selectAnyTranslations(resultData400);       
            }
            result400 = SerializableError.fromJS(resultData400);
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    create(command: CreateVideoCommand): Observable<VideoMediaDto> {
        let url_ = this.baseUrl + "/api/Video/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processCreate(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processCreate(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<VideoMediaDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<VideoMediaDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<VideoMediaDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                this.apiConfigService.selectAnyTranslations(resultData200);       
            }
            result200 = VideoMediaDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData400) {
                this.apiConfigService.selectAnyTranslations(resultData400);       
            }
            result400 = SerializableError.fromJS(resultData400);
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class BaseAccountService extends ServiceBase {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(ApiConfigService) configuration: ApiConfigService, @Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super(configuration);
        this.http = http;
        this.baseUrl = baseUrl ?? "https://";
    }

    setLanguage(culture: string | null | undefined, returnUrl: string | null | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/BaseAccount/SetLanguage?";
        if (culture !== undefined && culture !== null)
            url_ += "culture=" + encodeURIComponent("" + culture) + "&";
        if (returnUrl !== undefined && returnUrl !== null)
            url_ += "returnUrl=" + encodeURIComponent("" + returnUrl) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processSetLanguage(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processSetLanguage(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processSetLanguage(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: <any>responseBlob, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    lockout(): Observable<FileResponse> {
        let url_ = this.baseUrl + "/BaseAccount/Lockout";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processLockout(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processLockout(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processLockout(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: <any>responseBlob, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    logout(): Observable<FileResponse> {
        let url_ = this.baseUrl + "/BaseAccount/Logout";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processLogout(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processLogout(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processLogout(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: <any>responseBlob, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    forgotPasswordGET(): Observable<FileResponse> {
        let url_ = this.baseUrl + "/BaseAccount/ForgotPassword";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processForgotPasswordGET(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processForgotPasswordGET(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processForgotPasswordGET(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: <any>responseBlob, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    forgotPasswordPOST(email: string | null | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/BaseAccount/ForgotPassword?";
        if (email !== undefined && email !== null)
            url_ += "Email=" + encodeURIComponent("" + email) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processForgotPasswordPOST(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processForgotPasswordPOST(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processForgotPasswordPOST(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: <any>responseBlob, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    forgotPasswordConfirmation(): Observable<FileResponse> {
        let url_ = this.baseUrl + "/BaseAccount/ForgotPasswordConfirmation";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processForgotPasswordConfirmation(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processForgotPasswordConfirmation(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processForgotPasswordConfirmation(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: <any>responseBlob, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    resetPasswordGET(userId: string | null | undefined, code: string | null | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/BaseAccount/ResetPassword?";
        if (userId !== undefined && userId !== null)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (code !== undefined && code !== null)
            url_ += "code=" + encodeURIComponent("" + code) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processResetPasswordGET(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processResetPasswordGET(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processResetPasswordGET(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: <any>responseBlob, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    resetPasswordPOST(email: string | null | undefined, password: string | null | undefined, confirmPassword: string | null | undefined, code: string | null | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/BaseAccount/ResetPassword?";
        if (email !== undefined && email !== null)
            url_ += "Email=" + encodeURIComponent("" + email) + "&";
        if (password !== undefined && password !== null)
            url_ += "Password=" + encodeURIComponent("" + password) + "&";
        if (confirmPassword !== undefined && confirmPassword !== null)
            url_ += "ConfirmPassword=" + encodeURIComponent("" + confirmPassword) + "&";
        if (code !== undefined && code !== null)
            url_ += "Code=" + encodeURIComponent("" + code) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processResetPasswordPOST(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processResetPasswordPOST(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processResetPasswordPOST(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: <any>responseBlob, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    resetClientPassword(id: string | null | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/BaseAccount/ResetClientPassword?";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processResetClientPassword(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processResetClientPassword(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processResetClientPassword(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: <any>responseBlob, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    resetPasswordConfirmation(): Observable<FileResponse> {
        let url_ = this.baseUrl + "/BaseAccount/ResetPasswordConfirmation";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processResetPasswordConfirmation(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processResetPasswordConfirmation(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processResetPasswordConfirmation(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: <any>responseBlob, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    accessDenied(): Observable<FileResponse> {
        let url_ = this.baseUrl + "/BaseAccount/AccessDenied";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processAccessDenied(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processAccessDenied(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processAccessDenied(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: <any>responseBlob, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export class UserDto implements IUserDto {
    id?: string | null;
    name?: string | null;
    assignedRoles?: string[] | null;
    assignedPolicies?: string[] | null;
    personalEmail!: string;
    phoneNumber!: string;
    phoneExtensionNumber?: string | null;
    alternatePhoneNumber?: string | null;
    alternatePhoneExtensionNumber?: string | null;
    socialSecurityNumber?: string | null;
    title?: Title | null;
    address?: Address | null;
    userType?: UserType | null;
    lastPasswordChangedDate?: moment.Moment | null;
    deactivated?: boolean;
    passwordAlmostExpired?: boolean;
    passwordExpired?: boolean;
    daysLeftToChangePassword?: number;
    image?: ImageMediaViewModel | null;

    constructor(data?: IUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            if (Array.isArray(_data["assignedRoles"])) {
                this.assignedRoles = [] as any;
                for (let item of _data["assignedRoles"])
                    this.assignedRoles!.push(item);
            }
            else {
                this.assignedRoles = <any>null;
            }
            if (Array.isArray(_data["assignedPolicies"])) {
                this.assignedPolicies = [] as any;
                for (let item of _data["assignedPolicies"])
                    this.assignedPolicies!.push(item);
            }
            else {
                this.assignedPolicies = <any>null;
            }
            this.personalEmail = _data["personalEmail"] !== undefined ? _data["personalEmail"] : <any>null;
            this.phoneNumber = _data["phoneNumber"] !== undefined ? _data["phoneNumber"] : <any>null;
            this.phoneExtensionNumber = _data["phoneExtensionNumber"] !== undefined ? _data["phoneExtensionNumber"] : <any>null;
            this.alternatePhoneNumber = _data["alternatePhoneNumber"] !== undefined ? _data["alternatePhoneNumber"] : <any>null;
            this.alternatePhoneExtensionNumber = _data["alternatePhoneExtensionNumber"] !== undefined ? _data["alternatePhoneExtensionNumber"] : <any>null;
            this.socialSecurityNumber = _data["socialSecurityNumber"] !== undefined ? _data["socialSecurityNumber"] : <any>null;
            this.title = _data["title"] !== undefined ? _data["title"] : <any>null;
            this.address = _data["address"] ? Address.fromJS(_data["address"]) : <any>null;
            this.userType = _data["userType"] !== undefined ? _data["userType"] : <any>null;
            this.lastPasswordChangedDate = _data["lastPasswordChangedDate"] ? moment(_data["lastPasswordChangedDate"].toString()) : <any>null;
            this.deactivated = _data["deactivated"] !== undefined ? _data["deactivated"] : <any>null;
            this.passwordAlmostExpired = _data["passwordAlmostExpired"] !== undefined ? _data["passwordAlmostExpired"] : <any>null;
            this.passwordExpired = _data["passwordExpired"] !== undefined ? _data["passwordExpired"] : <any>null;
            this.daysLeftToChangePassword = _data["daysLeftToChangePassword"] !== undefined ? _data["daysLeftToChangePassword"] : <any>null;
            this.image = _data["image"] ? ImageMediaViewModel.fromJS(_data["image"]) : <any>null;
        }
    }

    static fromJS(data: any): UserDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        if (Array.isArray(this.assignedRoles)) {
            data["assignedRoles"] = [];
            for (let item of this.assignedRoles)
                data["assignedRoles"].push(item);
        }
        if (Array.isArray(this.assignedPolicies)) {
            data["assignedPolicies"] = [];
            for (let item of this.assignedPolicies)
                data["assignedPolicies"].push(item);
        }
        data["personalEmail"] = this.personalEmail !== undefined ? this.personalEmail : <any>null;
        data["phoneNumber"] = this.phoneNumber !== undefined ? this.phoneNumber : <any>null;
        data["phoneExtensionNumber"] = this.phoneExtensionNumber !== undefined ? this.phoneExtensionNumber : <any>null;
        data["alternatePhoneNumber"] = this.alternatePhoneNumber !== undefined ? this.alternatePhoneNumber : <any>null;
        data["alternatePhoneExtensionNumber"] = this.alternatePhoneExtensionNumber !== undefined ? this.alternatePhoneExtensionNumber : <any>null;
        data["socialSecurityNumber"] = this.socialSecurityNumber !== undefined ? this.socialSecurityNumber : <any>null;
        data["title"] = this.title !== undefined ? this.title : <any>null;
        data["address"] = this.address ? this.address.toJSON() : <any>null;
        data["userType"] = this.userType !== undefined ? this.userType : <any>null;
        data["lastPasswordChangedDate"] = this.lastPasswordChangedDate ? this.lastPasswordChangedDate.toISOString() : <any>null;
        data["deactivated"] = this.deactivated !== undefined ? this.deactivated : <any>null;
        data["passwordAlmostExpired"] = this.passwordAlmostExpired !== undefined ? this.passwordAlmostExpired : <any>null;
        data["passwordExpired"] = this.passwordExpired !== undefined ? this.passwordExpired : <any>null;
        data["daysLeftToChangePassword"] = this.daysLeftToChangePassword !== undefined ? this.daysLeftToChangePassword : <any>null;
        data["image"] = this.image ? this.image.toJSON() : <any>null;
        return data;
    }
}

export interface IUserDto {
    id?: string | null;
    name?: string | null;
    assignedRoles?: string[] | null;
    assignedPolicies?: string[] | null;
    personalEmail: string;
    phoneNumber: string;
    phoneExtensionNumber?: string | null;
    alternatePhoneNumber?: string | null;
    alternatePhoneExtensionNumber?: string | null;
    socialSecurityNumber?: string | null;
    title?: Title | null;
    address?: Address | null;
    userType?: UserType | null;
    lastPasswordChangedDate?: moment.Moment | null;
    deactivated?: boolean;
    passwordAlmostExpired?: boolean;
    passwordExpired?: boolean;
    daysLeftToChangePassword?: number;
    image?: ImageMediaViewModel | null;
}

export enum Title {
    None = "none",
    Ms = "ms",
    Mr = "mr",
}

export abstract class EntityOfInteger implements IEntityOfInteger {
    id?: number;

    constructor(data?: IEntityOfInteger) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
        }
    }

    static fromJS(data: any): EntityOfInteger {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'EntityOfInteger' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        return data;
    }
}

export interface IEntityOfInteger {
    id?: number;
}

export class Address extends EntityOfInteger implements IAddress {
    street?: string | null;
    apartment?: string | null;
    city?: string | null;
    province?: string | null;
    neighborhood?: string | null;
    postalCode?: string | null;
    country?: string | null;
    fullAddress?: string | null;
    latitude?: string | null;
    longitude?: string | null;
    sector?: number | null;

    constructor(data?: IAddress) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.street = _data["street"] !== undefined ? _data["street"] : <any>null;
            this.apartment = _data["apartment"] !== undefined ? _data["apartment"] : <any>null;
            this.city = _data["city"] !== undefined ? _data["city"] : <any>null;
            this.province = _data["province"] !== undefined ? _data["province"] : <any>null;
            this.neighborhood = _data["neighborhood"] !== undefined ? _data["neighborhood"] : <any>null;
            this.postalCode = _data["postalCode"] !== undefined ? _data["postalCode"] : <any>null;
            this.country = _data["country"] !== undefined ? _data["country"] : <any>null;
            this.fullAddress = _data["fullAddress"] !== undefined ? _data["fullAddress"] : <any>null;
            this.latitude = _data["latitude"] !== undefined ? _data["latitude"] : <any>null;
            this.longitude = _data["longitude"] !== undefined ? _data["longitude"] : <any>null;
            this.sector = _data["sector"] !== undefined ? _data["sector"] : <any>null;
        }
    }

    static override fromJS(data: any): Address {
        data = typeof data === 'object' ? data : {};
        let result = new Address();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["street"] = this.street !== undefined ? this.street : <any>null;
        data["apartment"] = this.apartment !== undefined ? this.apartment : <any>null;
        data["city"] = this.city !== undefined ? this.city : <any>null;
        data["province"] = this.province !== undefined ? this.province : <any>null;
        data["neighborhood"] = this.neighborhood !== undefined ? this.neighborhood : <any>null;
        data["postalCode"] = this.postalCode !== undefined ? this.postalCode : <any>null;
        data["country"] = this.country !== undefined ? this.country : <any>null;
        data["fullAddress"] = this.fullAddress !== undefined ? this.fullAddress : <any>null;
        data["latitude"] = this.latitude !== undefined ? this.latitude : <any>null;
        data["longitude"] = this.longitude !== undefined ? this.longitude : <any>null;
        data["sector"] = this.sector !== undefined ? this.sector : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IAddress extends IEntityOfInteger {
    street?: string | null;
    apartment?: string | null;
    city?: string | null;
    province?: string | null;
    neighborhood?: string | null;
    postalCode?: string | null;
    country?: string | null;
    fullAddress?: string | null;
    latitude?: string | null;
    longitude?: string | null;
    sector?: number | null;
}

export enum UserType {
    Client = "client",
    Employee = "employee",
}

export class ImageMediaViewModel implements IImageMediaViewModel {
    id?: string | null;
    imageUrl?: string | null;

    constructor(data?: IImageMediaViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.imageUrl = _data["imageUrl"] !== undefined ? _data["imageUrl"] : <any>null;
        }
    }

    static fromJS(data: any): ImageMediaViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ImageMediaViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["imageUrl"] = this.imageUrl !== undefined ? this.imageUrl : <any>null;
        return data;
    }
}

export interface IImageMediaViewModel {
    id?: string | null;
    imageUrl?: string | null;
}

export class EmployeeViewModel extends UserDto implements IEmployeeViewModel {
    employeeNumber?: number;
    workEmail!: string;
    socialSecurityNumber?: string | null;
    birthDate?: moment.Moment | null;
    martialStatus?: MartialStatus | null;
    spousesName?: string | null;
    spousesEmployer?: string | null;
    spousesWorkPhone?: string | null;
    spousesWorkPhoneExtensionNumber?: string | null;
    emergencyContactInformation?: EmergencyContactInformation | null;
    jobInformation?: JobInformation | null;
    sid?: string | null;

    constructor(data?: IEmployeeViewModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.employeeNumber = _data["employeeNumber"] !== undefined ? _data["employeeNumber"] : <any>null;
            this.workEmail = _data["workEmail"] !== undefined ? _data["workEmail"] : <any>null;
            this.socialSecurityNumber = _data["socialSecurityNumber"] !== undefined ? _data["socialSecurityNumber"] : <any>null;
            this.birthDate = _data["birthDate"] ? moment(_data["birthDate"].toString()) : <any>null;
            this.martialStatus = _data["martialStatus"] !== undefined ? _data["martialStatus"] : <any>null;
            this.spousesName = _data["spousesName"] !== undefined ? _data["spousesName"] : <any>null;
            this.spousesEmployer = _data["spousesEmployer"] !== undefined ? _data["spousesEmployer"] : <any>null;
            this.spousesWorkPhone = _data["spousesWorkPhone"] !== undefined ? _data["spousesWorkPhone"] : <any>null;
            this.spousesWorkPhoneExtensionNumber = _data["spousesWorkPhoneExtensionNumber"] !== undefined ? _data["spousesWorkPhoneExtensionNumber"] : <any>null;
            this.emergencyContactInformation = _data["emergencyContactInformation"] ? EmergencyContactInformation.fromJS(_data["emergencyContactInformation"]) : <any>null;
            this.jobInformation = _data["jobInformation"] ? JobInformation.fromJS(_data["jobInformation"]) : <any>null;
            this.sid = _data["sid"] !== undefined ? _data["sid"] : <any>null;
        }
    }

    static override fromJS(data: any): EmployeeViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeViewModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["employeeNumber"] = this.employeeNumber !== undefined ? this.employeeNumber : <any>null;
        data["workEmail"] = this.workEmail !== undefined ? this.workEmail : <any>null;
        data["socialSecurityNumber"] = this.socialSecurityNumber !== undefined ? this.socialSecurityNumber : <any>null;
        data["birthDate"] = this.birthDate ? this.birthDate.format('YYYY-MM-DD') : <any>null;
        data["martialStatus"] = this.martialStatus !== undefined ? this.martialStatus : <any>null;
        data["spousesName"] = this.spousesName !== undefined ? this.spousesName : <any>null;
        data["spousesEmployer"] = this.spousesEmployer !== undefined ? this.spousesEmployer : <any>null;
        data["spousesWorkPhone"] = this.spousesWorkPhone !== undefined ? this.spousesWorkPhone : <any>null;
        data["spousesWorkPhoneExtensionNumber"] = this.spousesWorkPhoneExtensionNumber !== undefined ? this.spousesWorkPhoneExtensionNumber : <any>null;
        data["emergencyContactInformation"] = this.emergencyContactInformation ? this.emergencyContactInformation.toJSON() : <any>null;
        data["jobInformation"] = this.jobInformation ? this.jobInformation.toJSON() : <any>null;
        data["sid"] = this.sid !== undefined ? this.sid : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IEmployeeViewModel extends IUserDto {
    employeeNumber?: number;
    workEmail: string;
    socialSecurityNumber?: string | null;
    birthDate?: moment.Moment | null;
    martialStatus?: MartialStatus | null;
    spousesName?: string | null;
    spousesEmployer?: string | null;
    spousesWorkPhone?: string | null;
    spousesWorkPhoneExtensionNumber?: string | null;
    emergencyContactInformation?: EmergencyContactInformation | null;
    jobInformation?: JobInformation | null;
    sid?: string | null;
}

export enum MartialStatus {
    Single = "single",
    Married = "married",
    Divoreced = "divoreced",
    Windowed = "windowed",
    Other = "other",
    PreferNotToSay = "preferNotToSay",
}

export class EmergencyContactInformation implements IEmergencyContactInformation {
    employeeId?: string | null;
    firstName?: string | null;
    lastName?: string | null;
    phoneNumber?: string | null;
    phoneExtensionNumber?: string | null;
    mobileNumber?: string | null;
    relationship?: string | null;

    constructor(data?: IEmergencyContactInformation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.employeeId = _data["employeeId"] !== undefined ? _data["employeeId"] : <any>null;
            this.firstName = _data["firstName"] !== undefined ? _data["firstName"] : <any>null;
            this.lastName = _data["lastName"] !== undefined ? _data["lastName"] : <any>null;
            this.phoneNumber = _data["phoneNumber"] !== undefined ? _data["phoneNumber"] : <any>null;
            this.phoneExtensionNumber = _data["phoneExtensionNumber"] !== undefined ? _data["phoneExtensionNumber"] : <any>null;
            this.mobileNumber = _data["mobileNumber"] !== undefined ? _data["mobileNumber"] : <any>null;
            this.relationship = _data["relationship"] !== undefined ? _data["relationship"] : <any>null;
        }
    }

    static fromJS(data: any): EmergencyContactInformation {
        data = typeof data === 'object' ? data : {};
        let result = new EmergencyContactInformation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["employeeId"] = this.employeeId !== undefined ? this.employeeId : <any>null;
        data["firstName"] = this.firstName !== undefined ? this.firstName : <any>null;
        data["lastName"] = this.lastName !== undefined ? this.lastName : <any>null;
        data["phoneNumber"] = this.phoneNumber !== undefined ? this.phoneNumber : <any>null;
        data["phoneExtensionNumber"] = this.phoneExtensionNumber !== undefined ? this.phoneExtensionNumber : <any>null;
        data["mobileNumber"] = this.mobileNumber !== undefined ? this.mobileNumber : <any>null;
        data["relationship"] = this.relationship !== undefined ? this.relationship : <any>null;
        return data;
    }
}

export interface IEmergencyContactInformation {
    employeeId?: string | null;
    firstName?: string | null;
    lastName?: string | null;
    phoneNumber?: string | null;
    phoneExtensionNumber?: string | null;
    mobileNumber?: string | null;
    relationship?: string | null;
}

export class JobInformation implements IJobInformation {
    employeeId?: string | null;
    title?: string | null;
    employeeNumber?: number | null;
    supervisor?: string | null;
    workLocation?: string | null;
    workPhone?: string | null;
    workPhoneExtensionNumber?: string | null;
    mobilePhone?: string | null;
    startDate?: moment.Moment | null;
    salary?: number | null;

    constructor(data?: IJobInformation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.employeeId = _data["employeeId"] !== undefined ? _data["employeeId"] : <any>null;
            this.title = _data["title"] !== undefined ? _data["title"] : <any>null;
            this.employeeNumber = _data["employeeNumber"] !== undefined ? _data["employeeNumber"] : <any>null;
            this.supervisor = _data["supervisor"] !== undefined ? _data["supervisor"] : <any>null;
            this.workLocation = _data["workLocation"] !== undefined ? _data["workLocation"] : <any>null;
            this.workPhone = _data["workPhone"] !== undefined ? _data["workPhone"] : <any>null;
            this.workPhoneExtensionNumber = _data["workPhoneExtensionNumber"] !== undefined ? _data["workPhoneExtensionNumber"] : <any>null;
            this.mobilePhone = _data["mobilePhone"] !== undefined ? _data["mobilePhone"] : <any>null;
            this.startDate = _data["startDate"] ? moment(_data["startDate"].toString()) : <any>null;
            this.salary = _data["salary"] !== undefined ? _data["salary"] : <any>null;
        }
    }

    static fromJS(data: any): JobInformation {
        data = typeof data === 'object' ? data : {};
        let result = new JobInformation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["employeeId"] = this.employeeId !== undefined ? this.employeeId : <any>null;
        data["title"] = this.title !== undefined ? this.title : <any>null;
        data["employeeNumber"] = this.employeeNumber !== undefined ? this.employeeNumber : <any>null;
        data["supervisor"] = this.supervisor !== undefined ? this.supervisor : <any>null;
        data["workLocation"] = this.workLocation !== undefined ? this.workLocation : <any>null;
        data["workPhone"] = this.workPhone !== undefined ? this.workPhone : <any>null;
        data["workPhoneExtensionNumber"] = this.workPhoneExtensionNumber !== undefined ? this.workPhoneExtensionNumber : <any>null;
        data["mobilePhone"] = this.mobilePhone !== undefined ? this.mobilePhone : <any>null;
        data["startDate"] = this.startDate ? this.startDate.format('YYYY-MM-DD') : <any>null;
        data["salary"] = this.salary !== undefined ? this.salary : <any>null;
        return data;
    }
}

export interface IJobInformation {
    employeeId?: string | null;
    title?: string | null;
    employeeNumber?: number | null;
    supervisor?: string | null;
    workLocation?: string | null;
    workPhone?: string | null;
    workPhoneExtensionNumber?: string | null;
    mobilePhone?: string | null;
    startDate?: moment.Moment | null;
    salary?: number | null;
}

export class SerializableError implements ISerializableError {

    [key: string]: any;

    constructor(data?: ISerializableError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
        }
    }

    static fromJS(data: any): SerializableError {
        data = typeof data === 'object' ? data : {};
        let result = new SerializableError();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        return data;
    }
}

export interface ISerializableError {

    [key: string]: any;
}

export class UpdateProfileCommand implements IUpdateProfileCommand {
    email?: string | null;
    phoneNumber?: string | null;
    image?: ImageMediaDto | null;

    constructor(data?: IUpdateProfileCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"] !== undefined ? _data["email"] : <any>null;
            this.phoneNumber = _data["phoneNumber"] !== undefined ? _data["phoneNumber"] : <any>null;
            this.image = _data["image"] ? ImageMediaDto.fromJS(_data["image"]) : <any>null;
        }
    }

    static fromJS(data: any): UpdateProfileCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateProfileCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email !== undefined ? this.email : <any>null;
        data["phoneNumber"] = this.phoneNumber !== undefined ? this.phoneNumber : <any>null;
        data["image"] = this.image ? this.image.toJSON() : <any>null;
        return data;
    }
}

export interface IUpdateProfileCommand {
    email?: string | null;
    phoneNumber?: string | null;
    image?: ImageMediaDto | null;
}

export class ImageMediaDto implements IImageMediaDto {
    id?: string | null;
    imageUrl?: string | null;

    constructor(data?: IImageMediaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.imageUrl = _data["imageUrl"] !== undefined ? _data["imageUrl"] : <any>null;
        }
    }

    static fromJS(data: any): ImageMediaDto {
        data = typeof data === 'object' ? data : {};
        let result = new ImageMediaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["imageUrl"] = this.imageUrl !== undefined ? this.imageUrl : <any>null;
        return data;
    }
}

export interface IImageMediaDto {
    id?: string | null;
    imageUrl?: string | null;
}

export class LoginViewModel implements ILoginViewModel {
    email?: string | null;
    password?: string | null;

    constructor(data?: ILoginViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"] !== undefined ? _data["email"] : <any>null;
            this.password = _data["password"] !== undefined ? _data["password"] : <any>null;
        }
    }

    static fromJS(data: any): LoginViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new LoginViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email !== undefined ? this.email : <any>null;
        data["password"] = this.password !== undefined ? this.password : <any>null;
        return data;
    }
}

export interface ILoginViewModel {
    email?: string | null;
    password?: string | null;
}

export class IdentityResult implements IIdentityResult {
    succeeded?: boolean;
    errors?: IdentityError[];

    constructor(data?: IIdentityResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.succeeded = _data["succeeded"] !== undefined ? _data["succeeded"] : <any>null;
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(IdentityError.fromJS(item));
            }
            else {
                this.errors = <any>null;
            }
        }
    }

    static fromJS(data: any): IdentityResult {
        data = typeof data === 'object' ? data : {};
        let result = new IdentityResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["succeeded"] = this.succeeded !== undefined ? this.succeeded : <any>null;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item.toJSON());
        }
        return data;
    }
}

export interface IIdentityResult {
    succeeded?: boolean;
    errors?: IdentityError[];
}

export class IdentityError implements IIdentityError {
    code?: string;
    description?: string;

    constructor(data?: IIdentityError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"] !== undefined ? _data["code"] : <any>null;
            this.description = _data["description"] !== undefined ? _data["description"] : <any>null;
        }
    }

    static fromJS(data: any): IdentityError {
        data = typeof data === 'object' ? data : {};
        let result = new IdentityError();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code !== undefined ? this.code : <any>null;
        data["description"] = this.description !== undefined ? this.description : <any>null;
        return data;
    }
}

export interface IIdentityError {
    code?: string;
    description?: string;
}

export class ChangePasswordViewModel implements IChangePasswordViewModel {
    currentPassword!: string;
    newPassword!: string;
    confirmPassword?: string | null;
    statusMessage?: string | null;

    constructor(data?: IChangePasswordViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.currentPassword = _data["currentPassword"] !== undefined ? _data["currentPassword"] : <any>null;
            this.newPassword = _data["newPassword"] !== undefined ? _data["newPassword"] : <any>null;
            this.confirmPassword = _data["confirmPassword"] !== undefined ? _data["confirmPassword"] : <any>null;
            this.statusMessage = _data["statusMessage"] !== undefined ? _data["statusMessage"] : <any>null;
        }
    }

    static fromJS(data: any): ChangePasswordViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ChangePasswordViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currentPassword"] = this.currentPassword !== undefined ? this.currentPassword : <any>null;
        data["newPassword"] = this.newPassword !== undefined ? this.newPassword : <any>null;
        data["confirmPassword"] = this.confirmPassword !== undefined ? this.confirmPassword : <any>null;
        data["statusMessage"] = this.statusMessage !== undefined ? this.statusMessage : <any>null;
        return data;
    }
}

export interface IChangePasswordViewModel {
    currentPassword: string;
    newPassword: string;
    confirmPassword?: string | null;
    statusMessage?: string | null;
}

export class PaginationModel implements IPaginationModel {
    sortOrder?: string | null;
    searchString?: string | null;
    page?: number | null;
    ascSortDirection?: boolean;
    pageSize?: number;

    constructor(data?: IPaginationModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sortOrder = _data["sortOrder"] !== undefined ? _data["sortOrder"] : <any>null;
            this.searchString = _data["searchString"] !== undefined ? _data["searchString"] : <any>null;
            this.page = _data["page"] !== undefined ? _data["page"] : <any>null;
            this.ascSortDirection = _data["ascSortDirection"] !== undefined ? _data["ascSortDirection"] : <any>null;
            this.pageSize = _data["pageSize"] !== undefined ? _data["pageSize"] : <any>null;
        }
    }

    static fromJS(data: any): PaginationModel {
        data = typeof data === 'object' ? data : {};
        let result = new PaginationModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sortOrder"] = this.sortOrder !== undefined ? this.sortOrder : <any>null;
        data["searchString"] = this.searchString !== undefined ? this.searchString : <any>null;
        data["page"] = this.page !== undefined ? this.page : <any>null;
        data["ascSortDirection"] = this.ascSortDirection !== undefined ? this.ascSortDirection : <any>null;
        data["pageSize"] = this.pageSize !== undefined ? this.pageSize : <any>null;
        return data;
    }
}

export interface IPaginationModel {
    sortOrder?: string | null;
    searchString?: string | null;
    page?: number | null;
    ascSortDirection?: boolean;
    pageSize?: number;
}

export class PaginatedResult extends PaginationModel implements IPaginatedResult {
    count?: number;
    totalPages?: number;

    constructor(data?: IPaginatedResult) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.count = _data["count"] !== undefined ? _data["count"] : <any>null;
            this.totalPages = _data["totalPages"] !== undefined ? _data["totalPages"] : <any>null;
        }
    }

    static override fromJS(data: any): PaginatedResult {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResult();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["count"] = this.count !== undefined ? this.count : <any>null;
        data["totalPages"] = this.totalPages !== undefined ? this.totalPages : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IPaginatedResult extends IPaginationModel {
    count?: number;
    totalPages?: number;
}

export class PaginatedResultOfAppliancesRegionDto extends PaginatedResult implements IPaginatedResultOfAppliancesRegionDto {
    entities?: AppliancesRegionDto[] | null;

    constructor(data?: IPaginatedResultOfAppliancesRegionDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["entities"])) {
                this.entities = [] as any;
                for (let item of _data["entities"])
                    this.entities!.push(AppliancesRegionDto.fromJS(item));
            }
            else {
                this.entities = <any>null;
            }
        }
    }

    static override fromJS(data: any): PaginatedResultOfAppliancesRegionDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResultOfAppliancesRegionDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.entities)) {
            data["entities"] = [];
            for (let item of this.entities)
                data["entities"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IPaginatedResultOfAppliancesRegionDto extends IPaginatedResult {
    entities?: AppliancesRegionDto[] | null;
}

export class AppliancesRegionDto implements IAppliancesRegionDto {
    index?: number;
    id?: number;
    name?: string | null;
    isActive?: boolean;
    numberOfSectors?: number;
    sectors?: AppliancesRegionSectorsDto[] | null;

    constructor(data?: IAppliancesRegionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.index = _data["index"] !== undefined ? _data["index"] : <any>null;
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.isActive = _data["isActive"] !== undefined ? _data["isActive"] : <any>null;
            this.numberOfSectors = _data["numberOfSectors"] !== undefined ? _data["numberOfSectors"] : <any>null;
            if (Array.isArray(_data["sectors"])) {
                this.sectors = [] as any;
                for (let item of _data["sectors"])
                    this.sectors!.push(AppliancesRegionSectorsDto.fromJS(item));
            }
            else {
                this.sectors = <any>null;
            }
        }
    }

    static fromJS(data: any): AppliancesRegionDto {
        data = typeof data === 'object' ? data : {};
        let result = new AppliancesRegionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["index"] = this.index !== undefined ? this.index : <any>null;
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["isActive"] = this.isActive !== undefined ? this.isActive : <any>null;
        data["numberOfSectors"] = this.numberOfSectors !== undefined ? this.numberOfSectors : <any>null;
        if (Array.isArray(this.sectors)) {
            data["sectors"] = [];
            for (let item of this.sectors)
                data["sectors"].push(item.toJSON());
        }
        return data;
    }
}

export interface IAppliancesRegionDto {
    index?: number;
    id?: number;
    name?: string | null;
    isActive?: boolean;
    numberOfSectors?: number;
    sectors?: AppliancesRegionSectorsDto[] | null;
}

export class AppliancesRegionSectorsDto implements IAppliancesRegionSectorsDto {
    id?: number;
    applianceRegionId?: number;
    sector?: ApplianceSectors;

    constructor(data?: IAppliancesRegionSectorsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.applianceRegionId = _data["applianceRegionId"] !== undefined ? _data["applianceRegionId"] : <any>null;
            this.sector = _data["sector"] !== undefined ? _data["sector"] : <any>null;
        }
    }

    static fromJS(data: any): AppliancesRegionSectorsDto {
        data = typeof data === 'object' ? data : {};
        let result = new AppliancesRegionSectorsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["applianceRegionId"] = this.applianceRegionId !== undefined ? this.applianceRegionId : <any>null;
        data["sector"] = this.sector !== undefined ? this.sector : <any>null;
        return data;
    }
}

export interface IAppliancesRegionSectorsDto {
    id?: number;
    applianceRegionId?: number;
    sector?: ApplianceSectors;
}

export enum ApplianceSectors {
    Abitibi = "abitibi",
    CoteNord = "coteNord",
    NewBrunswick = "newBrunswick",
    Montreal = "montreal",
    Quebec = "quebec",
    OttawaAndGatineau = "ottawaAndGatineau",
    GaspesieAndBasStlaurent = "gaspesieAndBasStlaurent",
    Saguenay = "saguenay",
}

export class GetAppliancesRegionsQuery extends PaginationModel implements IGetAppliancesRegionsQuery {
    isActive?: boolean;
    isDeactivated?: boolean;

    constructor(data?: IGetAppliancesRegionsQuery) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.isActive = _data["isActive"] !== undefined ? _data["isActive"] : <any>null;
            this.isDeactivated = _data["isDeactivated"] !== undefined ? _data["isDeactivated"] : <any>null;
        }
    }

    static override fromJS(data: any): GetAppliancesRegionsQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetAppliancesRegionsQuery();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isActive"] = this.isActive !== undefined ? this.isActive : <any>null;
        data["isDeactivated"] = this.isDeactivated !== undefined ? this.isDeactivated : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IGetAppliancesRegionsQuery extends IPaginationModel {
    isActive?: boolean;
    isDeactivated?: boolean;
}

export class CreateAppliancesRegionCommand implements ICreateAppliancesRegionCommand {
    name?: string | null;

    constructor(data?: ICreateAppliancesRegionCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
        }
    }

    static fromJS(data: any): CreateAppliancesRegionCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateAppliancesRegionCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : <any>null;
        return data;
    }
}

export interface ICreateAppliancesRegionCommand {
    name?: string | null;
}

export class EditAppliancesRegionCommand implements IEditAppliancesRegionCommand {
    id?: number;
    name?: string | null;

    constructor(data?: IEditAppliancesRegionCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
        }
    }

    static fromJS(data: any): EditAppliancesRegionCommand {
        data = typeof data === 'object' ? data : {};
        let result = new EditAppliancesRegionCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        return data;
    }
}

export interface IEditAppliancesRegionCommand {
    id?: number;
    name?: string | null;
}

export class AddSectorToAppliancesRegionCommand implements IAddSectorToAppliancesRegionCommand {
    appliancesRegionId?: number;
    sector?: ApplianceSectors;

    constructor(data?: IAddSectorToAppliancesRegionCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.appliancesRegionId = _data["appliancesRegionId"] !== undefined ? _data["appliancesRegionId"] : <any>null;
            this.sector = _data["sector"] !== undefined ? _data["sector"] : <any>null;
        }
    }

    static fromJS(data: any): AddSectorToAppliancesRegionCommand {
        data = typeof data === 'object' ? data : {};
        let result = new AddSectorToAppliancesRegionCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["appliancesRegionId"] = this.appliancesRegionId !== undefined ? this.appliancesRegionId : <any>null;
        data["sector"] = this.sector !== undefined ? this.sector : <any>null;
        return data;
    }
}

export interface IAddSectorToAppliancesRegionCommand {
    appliancesRegionId?: number;
    sector?: ApplianceSectors;
}

export class ChangeAppliancesRegionActiveCommand implements IChangeAppliancesRegionActiveCommand {
    appliancesRegionId?: number;

    constructor(data?: IChangeAppliancesRegionActiveCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.appliancesRegionId = _data["appliancesRegionId"] !== undefined ? _data["appliancesRegionId"] : <any>null;
        }
    }

    static fromJS(data: any): ChangeAppliancesRegionActiveCommand {
        data = typeof data === 'object' ? data : {};
        let result = new ChangeAppliancesRegionActiveCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["appliancesRegionId"] = this.appliancesRegionId !== undefined ? this.appliancesRegionId : <any>null;
        return data;
    }
}

export interface IChangeAppliancesRegionActiveCommand {
    appliancesRegionId?: number;
}

export class DeleteApplianceRegionSectorCommand implements IDeleteApplianceRegionSectorCommand {
    id?: number;

    constructor(data?: IDeleteApplianceRegionSectorCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
        }
    }

    static fromJS(data: any): DeleteApplianceRegionSectorCommand {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteApplianceRegionSectorCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        return data;
    }
}

export interface IDeleteApplianceRegionSectorCommand {
    id?: number;
}

export class PaginatedResultOfApplianceLookupDto extends PaginatedResult implements IPaginatedResultOfApplianceLookupDto {
    entities?: ApplianceLookupDto[] | null;

    constructor(data?: IPaginatedResultOfApplianceLookupDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["entities"])) {
                this.entities = [] as any;
                for (let item of _data["entities"])
                    this.entities!.push(ApplianceLookupDto.fromJS(item));
            }
            else {
                this.entities = <any>null;
            }
        }
    }

    static override fromJS(data: any): PaginatedResultOfApplianceLookupDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResultOfApplianceLookupDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.entities)) {
            data["entities"] = [];
            for (let item of this.entities)
                data["entities"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IPaginatedResultOfApplianceLookupDto extends IPaginatedResult {
    entities?: ApplianceLookupDto[] | null;
}

export class ApplianceLookupDto implements IApplianceLookupDto {
    index?: number;
    id?: string | null;
    code?: string | null;
    type?: ApplianceType;
    brand?: string | null;
    model?: string | null;
    capacity?: number;
    heightInches?: number;
    widthInches?: number;
    depthInches?: number;
    description?: string | null;
    cost?: number;
    price?: number;
    active?: boolean;
    applianceRegions?: ApplianceRegionDto[] | null;

    constructor(data?: IApplianceLookupDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.index = _data["index"] !== undefined ? _data["index"] : <any>null;
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.code = _data["code"] !== undefined ? _data["code"] : <any>null;
            this.type = _data["type"] !== undefined ? _data["type"] : <any>null;
            this.brand = _data["brand"] !== undefined ? _data["brand"] : <any>null;
            this.model = _data["model"] !== undefined ? _data["model"] : <any>null;
            this.capacity = _data["capacity"] !== undefined ? _data["capacity"] : <any>null;
            this.heightInches = _data["heightInches"] !== undefined ? _data["heightInches"] : <any>null;
            this.widthInches = _data["widthInches"] !== undefined ? _data["widthInches"] : <any>null;
            this.depthInches = _data["depthInches"] !== undefined ? _data["depthInches"] : <any>null;
            this.description = _data["description"] !== undefined ? _data["description"] : <any>null;
            this.cost = _data["cost"] !== undefined ? _data["cost"] : <any>null;
            this.price = _data["price"] !== undefined ? _data["price"] : <any>null;
            this.active = _data["active"] !== undefined ? _data["active"] : <any>null;
            if (Array.isArray(_data["applianceRegions"])) {
                this.applianceRegions = [] as any;
                for (let item of _data["applianceRegions"])
                    this.applianceRegions!.push(ApplianceRegionDto.fromJS(item));
            }
            else {
                this.applianceRegions = <any>null;
            }
        }
    }

    static fromJS(data: any): ApplianceLookupDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApplianceLookupDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["index"] = this.index !== undefined ? this.index : <any>null;
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["code"] = this.code !== undefined ? this.code : <any>null;
        data["type"] = this.type !== undefined ? this.type : <any>null;
        data["brand"] = this.brand !== undefined ? this.brand : <any>null;
        data["model"] = this.model !== undefined ? this.model : <any>null;
        data["capacity"] = this.capacity !== undefined ? this.capacity : <any>null;
        data["heightInches"] = this.heightInches !== undefined ? this.heightInches : <any>null;
        data["widthInches"] = this.widthInches !== undefined ? this.widthInches : <any>null;
        data["depthInches"] = this.depthInches !== undefined ? this.depthInches : <any>null;
        data["description"] = this.description !== undefined ? this.description : <any>null;
        data["cost"] = this.cost !== undefined ? this.cost : <any>null;
        data["price"] = this.price !== undefined ? this.price : <any>null;
        data["active"] = this.active !== undefined ? this.active : <any>null;
        if (Array.isArray(this.applianceRegions)) {
            data["applianceRegions"] = [];
            for (let item of this.applianceRegions)
                data["applianceRegions"].push(item.toJSON());
        }
        return data;
    }
}

export interface IApplianceLookupDto {
    index?: number;
    id?: string | null;
    code?: string | null;
    type?: ApplianceType;
    brand?: string | null;
    model?: string | null;
    capacity?: number;
    heightInches?: number;
    widthInches?: number;
    depthInches?: number;
    description?: string | null;
    cost?: number;
    price?: number;
    active?: boolean;
    applianceRegions?: ApplianceRegionDto[] | null;
}

export enum ApplianceType {
    Freezer = "freezer",
    BBQ = "bbq",
    Oven = "oven",
    Microwave = "microwave",
    Refrigerator = "refrigerator",
    Dishwasher = "dishwasher",
    Stove = "stove",
    Cooktop = "cooktop",
    Range = "range",
    Toaster = "toaster",
    Blender = "blender",
    CoffeeMaker = "coffeeMaker",
    AirFryer = "airFryer",
    SlowCooker = "slowCooker",
    Mixer = "mixer",
    FoodProcessor = "foodProcessor",
    WineCooler = "wineCooler",
    IceMaker = "iceMaker",
    Grill = "grill",
    DeepFryer = "deepFryer",
}

export class ApplianceRegionDto implements IApplianceRegionDto {
    id?: number;
    name?: string | null;
    value?: number | null;

    constructor(data?: IApplianceRegionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.value = _data["value"] !== undefined ? _data["value"] : <any>null;
        }
    }

    static fromJS(data: any): ApplianceRegionDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApplianceRegionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["value"] = this.value !== undefined ? this.value : <any>null;
        return data;
    }
}

export interface IApplianceRegionDto {
    id?: number;
    name?: string | null;
    value?: number | null;
}

export class GetApplianceListQuery extends PaginationModel implements IGetApplianceListQuery {
    isActive?: boolean;
    isDeactivated?: boolean;

    constructor(data?: IGetApplianceListQuery) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.isActive = _data["isActive"] !== undefined ? _data["isActive"] : <any>null;
            this.isDeactivated = _data["isDeactivated"] !== undefined ? _data["isDeactivated"] : <any>null;
        }
    }

    static override fromJS(data: any): GetApplianceListQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetApplianceListQuery();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isActive"] = this.isActive !== undefined ? this.isActive : <any>null;
        data["isDeactivated"] = this.isDeactivated !== undefined ? this.isDeactivated : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IGetApplianceListQuery extends IPaginationModel {
    isActive?: boolean;
    isDeactivated?: boolean;
}

export class ApplianceDto implements IApplianceDto {
    id?: string | null;
    code?: string | null;
    type?: ApplianceType;
    typeName?: string | null;
    brand?: string | null;
    model?: string | null;
    capacity?: number;
    heightInches?: number;
    widthInches?: number;
    depthInches?: number;
    description?: string | null;
    descriptionEn?: string | null;
    cost?: number;
    priceDetails?: AppliancePriceDto | null;
    applianceRegions?: ApplianceRegionDto[] | null;
    active?: boolean;
    defaultForRegion?: boolean;
    image?: ImageMediaDto | null;

    constructor(data?: IApplianceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.code = _data["code"] !== undefined ? _data["code"] : <any>null;
            this.type = _data["type"] !== undefined ? _data["type"] : <any>null;
            this.typeName = _data["typeName"] !== undefined ? _data["typeName"] : <any>null;
            this.brand = _data["brand"] !== undefined ? _data["brand"] : <any>null;
            this.model = _data["model"] !== undefined ? _data["model"] : <any>null;
            this.capacity = _data["capacity"] !== undefined ? _data["capacity"] : <any>null;
            this.heightInches = _data["heightInches"] !== undefined ? _data["heightInches"] : <any>null;
            this.widthInches = _data["widthInches"] !== undefined ? _data["widthInches"] : <any>null;
            this.depthInches = _data["depthInches"] !== undefined ? _data["depthInches"] : <any>null;
            this.description = _data["description"] !== undefined ? _data["description"] : <any>null;
            this.descriptionEn = _data["descriptionEn"] !== undefined ? _data["descriptionEn"] : <any>null;
            this.cost = _data["cost"] !== undefined ? _data["cost"] : <any>null;
            this.priceDetails = _data["priceDetails"] ? AppliancePriceDto.fromJS(_data["priceDetails"]) : <any>null;
            if (Array.isArray(_data["applianceRegions"])) {
                this.applianceRegions = [] as any;
                for (let item of _data["applianceRegions"])
                    this.applianceRegions!.push(ApplianceRegionDto.fromJS(item));
            }
            else {
                this.applianceRegions = <any>null;
            }
            this.active = _data["active"] !== undefined ? _data["active"] : <any>null;
            this.defaultForRegion = _data["defaultForRegion"] !== undefined ? _data["defaultForRegion"] : <any>null;
            this.image = _data["image"] ? ImageMediaDto.fromJS(_data["image"]) : <any>null;
        }
    }

    static fromJS(data: any): ApplianceDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApplianceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["code"] = this.code !== undefined ? this.code : <any>null;
        data["type"] = this.type !== undefined ? this.type : <any>null;
        data["typeName"] = this.typeName !== undefined ? this.typeName : <any>null;
        data["brand"] = this.brand !== undefined ? this.brand : <any>null;
        data["model"] = this.model !== undefined ? this.model : <any>null;
        data["capacity"] = this.capacity !== undefined ? this.capacity : <any>null;
        data["heightInches"] = this.heightInches !== undefined ? this.heightInches : <any>null;
        data["widthInches"] = this.widthInches !== undefined ? this.widthInches : <any>null;
        data["depthInches"] = this.depthInches !== undefined ? this.depthInches : <any>null;
        data["description"] = this.description !== undefined ? this.description : <any>null;
        data["descriptionEn"] = this.descriptionEn !== undefined ? this.descriptionEn : <any>null;
        data["cost"] = this.cost !== undefined ? this.cost : <any>null;
        data["priceDetails"] = this.priceDetails ? this.priceDetails.toJSON() : <any>null;
        if (Array.isArray(this.applianceRegions)) {
            data["applianceRegions"] = [];
            for (let item of this.applianceRegions)
                data["applianceRegions"].push(item.toJSON());
        }
        data["active"] = this.active !== undefined ? this.active : <any>null;
        data["defaultForRegion"] = this.defaultForRegion !== undefined ? this.defaultForRegion : <any>null;
        data["image"] = this.image ? this.image.toJSON() : <any>null;
        return data;
    }
}

export interface IApplianceDto {
    id?: string | null;
    code?: string | null;
    type?: ApplianceType;
    typeName?: string | null;
    brand?: string | null;
    model?: string | null;
    capacity?: number;
    heightInches?: number;
    widthInches?: number;
    depthInches?: number;
    description?: string | null;
    descriptionEn?: string | null;
    cost?: number;
    priceDetails?: AppliancePriceDto | null;
    applianceRegions?: ApplianceRegionDto[] | null;
    active?: boolean;
    defaultForRegion?: boolean;
    image?: ImageMediaDto | null;
}

export class AppliancePriceDto implements IAppliancePriceDto {
    id?: string | null;
    fullPrice?: number;
    term12Price?: number;
    term24Price?: number;
    term36Price?: number;
    enableFullPrice?: boolean;
    enableTerm12Price?: boolean;
    enableTerm24Price?: boolean;
    enableTerm36Price?: boolean;

    constructor(data?: IAppliancePriceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.fullPrice = _data["fullPrice"] !== undefined ? _data["fullPrice"] : <any>null;
            this.term12Price = _data["term12Price"] !== undefined ? _data["term12Price"] : <any>null;
            this.term24Price = _data["term24Price"] !== undefined ? _data["term24Price"] : <any>null;
            this.term36Price = _data["term36Price"] !== undefined ? _data["term36Price"] : <any>null;
            this.enableFullPrice = _data["enableFullPrice"] !== undefined ? _data["enableFullPrice"] : <any>null;
            this.enableTerm12Price = _data["enableTerm12Price"] !== undefined ? _data["enableTerm12Price"] : <any>null;
            this.enableTerm24Price = _data["enableTerm24Price"] !== undefined ? _data["enableTerm24Price"] : <any>null;
            this.enableTerm36Price = _data["enableTerm36Price"] !== undefined ? _data["enableTerm36Price"] : <any>null;
        }
    }

    static fromJS(data: any): AppliancePriceDto {
        data = typeof data === 'object' ? data : {};
        let result = new AppliancePriceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["fullPrice"] = this.fullPrice !== undefined ? this.fullPrice : <any>null;
        data["term12Price"] = this.term12Price !== undefined ? this.term12Price : <any>null;
        data["term24Price"] = this.term24Price !== undefined ? this.term24Price : <any>null;
        data["term36Price"] = this.term36Price !== undefined ? this.term36Price : <any>null;
        data["enableFullPrice"] = this.enableFullPrice !== undefined ? this.enableFullPrice : <any>null;
        data["enableTerm12Price"] = this.enableTerm12Price !== undefined ? this.enableTerm12Price : <any>null;
        data["enableTerm24Price"] = this.enableTerm24Price !== undefined ? this.enableTerm24Price : <any>null;
        data["enableTerm36Price"] = this.enableTerm36Price !== undefined ? this.enableTerm36Price : <any>null;
        return data;
    }
}

export interface IAppliancePriceDto {
    id?: string | null;
    fullPrice?: number;
    term12Price?: number;
    term24Price?: number;
    term36Price?: number;
    enableFullPrice?: boolean;
    enableTerm12Price?: boolean;
    enableTerm24Price?: boolean;
    enableTerm36Price?: boolean;
}

export class EditApplianceCommand implements IEditApplianceCommand {
    applianceDto?: ApplianceDto | null;

    constructor(data?: IEditApplianceCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.applianceDto = _data["applianceDto"] ? ApplianceDto.fromJS(_data["applianceDto"]) : <any>null;
        }
    }

    static fromJS(data: any): EditApplianceCommand {
        data = typeof data === 'object' ? data : {};
        let result = new EditApplianceCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["applianceDto"] = this.applianceDto ? this.applianceDto.toJSON() : <any>null;
        return data;
    }
}

export interface IEditApplianceCommand {
    applianceDto?: ApplianceDto | null;
}

export class CreateApplianceCommand implements ICreateApplianceCommand {
    applianceDto?: ApplianceDto | null;

    constructor(data?: ICreateApplianceCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.applianceDto = _data["applianceDto"] ? ApplianceDto.fromJS(_data["applianceDto"]) : <any>null;
        }
    }

    static fromJS(data: any): CreateApplianceCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateApplianceCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["applianceDto"] = this.applianceDto ? this.applianceDto.toJSON() : <any>null;
        return data;
    }
}

export interface ICreateApplianceCommand {
    applianceDto?: ApplianceDto | null;
}

export class ActivateApplianceCommand implements IActivateApplianceCommand {
    id?: string | null;

    constructor(data?: IActivateApplianceCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
        }
    }

    static fromJS(data: any): ActivateApplianceCommand {
        data = typeof data === 'object' ? data : {};
        let result = new ActivateApplianceCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        return data;
    }
}

export interface IActivateApplianceCommand {
    id?: string | null;
}

export class DeactivateApplianceCommand implements IDeactivateApplianceCommand {
    id?: string | null;

    constructor(data?: IDeactivateApplianceCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
        }
    }

    static fromJS(data: any): DeactivateApplianceCommand {
        data = typeof data === 'object' ? data : {};
        let result = new DeactivateApplianceCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        return data;
    }
}

export interface IDeactivateApplianceCommand {
    id?: string | null;
}

export class PaginatedResultOfAppointmentQualificationLookupDto extends PaginatedResult implements IPaginatedResultOfAppointmentQualificationLookupDto {
    entities?: AppointmentQualificationLookupDto[] | null;

    constructor(data?: IPaginatedResultOfAppointmentQualificationLookupDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["entities"])) {
                this.entities = [] as any;
                for (let item of _data["entities"])
                    this.entities!.push(AppointmentQualificationLookupDto.fromJS(item));
            }
            else {
                this.entities = <any>null;
            }
        }
    }

    static override fromJS(data: any): PaginatedResultOfAppointmentQualificationLookupDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResultOfAppointmentQualificationLookupDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.entities)) {
            data["entities"] = [];
            for (let item of this.entities)
                data["entities"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IPaginatedResultOfAppointmentQualificationLookupDto extends IPaginatedResult {
    entities?: AppointmentQualificationLookupDto[] | null;
}

export class AppointmentQualificationLookupDto implements IAppointmentQualificationLookupDto {
    index?: number;
    callNo?: number;
    tmName?: string | null;
    callDate?: moment.Moment | null;
    appointmentDate?: moment.Moment | null;
    city?: string | null;
    qualified?: boolean;
    promo?: boolean;
    edited?: boolean;

    constructor(data?: IAppointmentQualificationLookupDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.index = _data["index"] !== undefined ? _data["index"] : <any>null;
            this.callNo = _data["callNo"] !== undefined ? _data["callNo"] : <any>null;
            this.tmName = _data["tmName"] !== undefined ? _data["tmName"] : <any>null;
            this.callDate = _data["callDate"] ? moment(_data["callDate"].toString()) : <any>null;
            this.appointmentDate = _data["appointmentDate"] ? moment(_data["appointmentDate"].toString()) : <any>null;
            this.city = _data["city"] !== undefined ? _data["city"] : <any>null;
            this.qualified = _data["qualified"] !== undefined ? _data["qualified"] : <any>null;
            this.promo = _data["promo"] !== undefined ? _data["promo"] : <any>null;
            this.edited = _data["edited"] !== undefined ? _data["edited"] : <any>null;
        }
    }

    static fromJS(data: any): AppointmentQualificationLookupDto {
        data = typeof data === 'object' ? data : {};
        let result = new AppointmentQualificationLookupDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["index"] = this.index !== undefined ? this.index : <any>null;
        data["callNo"] = this.callNo !== undefined ? this.callNo : <any>null;
        data["tmName"] = this.tmName !== undefined ? this.tmName : <any>null;
        data["callDate"] = this.callDate ? this.callDate.toISOString() : <any>null;
        data["appointmentDate"] = this.appointmentDate ? this.appointmentDate.toISOString() : <any>null;
        data["city"] = this.city !== undefined ? this.city : <any>null;
        data["qualified"] = this.qualified !== undefined ? this.qualified : <any>null;
        data["promo"] = this.promo !== undefined ? this.promo : <any>null;
        data["edited"] = this.edited !== undefined ? this.edited : <any>null;
        return data;
    }
}

export interface IAppointmentQualificationLookupDto {
    index?: number;
    callNo?: number;
    tmName?: string | null;
    callDate?: moment.Moment | null;
    appointmentDate?: moment.Moment | null;
    city?: string | null;
    qualified?: boolean;
    promo?: boolean;
    edited?: boolean;
}

export class GetAppointmentQualificationsListQuery extends PaginationModel implements IGetAppointmentQualificationsListQuery {
    searchDateUtcRange?: (moment.Moment | null)[] | null;
    fromDate?: moment.Moment;
    toDate?: moment.Moment;

    constructor(data?: IGetAppointmentQualificationsListQuery) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["searchDateUtcRange"])) {
                this.searchDateUtcRange = [] as any;
                for (let item of _data["searchDateUtcRange"])
                    this.searchDateUtcRange!.push(moment(item));
            }
            else {
                this.searchDateUtcRange = <any>null;
            }
            this.fromDate = _data["fromDate"] ? moment(_data["fromDate"].toString()) : <any>null;
            this.toDate = _data["toDate"] ? moment(_data["toDate"].toString()) : <any>null;
        }
    }

    static override fromJS(data: any): GetAppointmentQualificationsListQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetAppointmentQualificationsListQuery();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.searchDateUtcRange)) {
            data["searchDateUtcRange"] = [];
            for (let item of this.searchDateUtcRange)
                data["searchDateUtcRange"].push(item.toISOString());
        }
        data["fromDate"] = this.fromDate ? this.fromDate.toISOString() : <any>null;
        data["toDate"] = this.toDate ? this.toDate.toISOString() : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IGetAppointmentQualificationsListQuery extends IPaginationModel {
    searchDateUtcRange?: (moment.Moment | null)[] | null;
    fromDate?: moment.Moment;
    toDate?: moment.Moment;
}

export class AppointmentDto implements IAppointmentDto {
    buysMeatAtOther?: boolean | null;
    callDateTime?: moment.Moment | null;
    tmName?: string | null;
    appointmentStatus?: AppointmentStatus;
    callNo?: number | null;
    id?: string | null;
    clientNo?: number | null;
    referredBy?: SalesRepDto | null;
    noVendeur?: number | null;
    gender?: AppointmentClientGender | null;
    buysMeatAtButcher?: boolean | null;
    buysMeatAtSupermarket?: boolean | null;
    buysMeatAtExotic?: boolean | null;
    buysMeatAtHalal?: boolean | null;
    other?: boolean | null;
    budgetRange?: BudgetRange | null;
    ageRange?: AgeRange | null;
    freezerSize?: FreezerSize | null;
    freezerStockAmount?: FreezerStockAmount | null;
    languageType?: LanguageType;
    visa?: boolean | null;
    mastercard?: boolean | null;
    americanExpress?: boolean | null;
    usesOtherCreditCard?: boolean | null;
    otherCreditCard?: string | null;
    numberOfAdults?: number | null;
    numberOfKids?: number | null;
    numberOfPets?: number | null;
    petTypeDog?: boolean | null;
    petTypeCat?: boolean | null;
    petTypeFish?: boolean | null;
    petTypeBird?: boolean | null;
    petTypeRodent?: boolean | null;
    petTypeReptile?: boolean | null;
    petTypeRabbit?: boolean | null;
    petTypeOtherOrExotic?: boolean | null;
    hasFreezer?: boolean | null;
    hasSpace?: boolean | null;
    email?: string | null;
    hasNoEmail?: boolean | null;
    lastName?: string | null;
    firstName?: string | null;
    conjointFirstName?: string | null;
    conjointLastName?: string | null;
    occupation?: string | null;
    conjointOccupation?: string | null;
    livingArrangement?: LivingArrangement | null;
    crossStreet?: string | null;
    comments?: string | null;
    appointmentType?: AppointmentType;
    homePhoneNumber?: string | null;
    cellPhoneNumber?: string | null;
    workPhoneNumber?: string | null;
    homePhoneNumberDisplay?: string | null;
    workPhoneNumberDisplay?: string | null;
    cellPhoneNumberDisplay?: string | null;
    extension?: string | null;
    address?: AddressDto | null;
    visitsIga?: boolean | null;
    visitsMetro?: boolean | null;
    visitsMaxi?: boolean | null;
    visitsSuperC?: boolean | null;
    visitsLoblaws?: boolean | null;
    visitsCostco?: boolean | null;
    visitsWalmart?: boolean | null;
    visitsOtherSupermarket?: boolean | null;
    otherSupermarket?: string | null;
    onlineIga?: boolean;
    onlineMetro?: boolean;
    onlineMaxi?: boolean;
    onlineWalmart?: boolean;
    onlineGoodfood?: boolean;
    onlineGroceryOther?: boolean;
    onlineOtherSupermarket?: string | null;
    appointmentDateTime?: moment.Moment | null;
    employee?: NestedEmployeeDto | null;
    originalSalesRep?: SalesRepDto | null;
    numberOfReferences?: number | null;
    rating?: number | null;
    ratingPercent?: number | null;
    isQualified?: boolean;
    isUpForReview?: boolean;
    clientLeadId?: number | null;
    callbackClientLeadId?: number | null;
    isVirtual?: boolean | null;
    appelEntrant?: boolean | null;
    originID?: string | null;
    hasNoOriginID?: boolean | null;

    constructor(data?: IAppointmentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.buysMeatAtOther = _data["buysMeatAtOther"] !== undefined ? _data["buysMeatAtOther"] : <any>null;
            this.callDateTime = _data["callDateTime"] ? moment(_data["callDateTime"].toString()) : <any>null;
            this.tmName = _data["tmName"] !== undefined ? _data["tmName"] : <any>null;
            this.appointmentStatus = _data["appointmentStatus"] !== undefined ? _data["appointmentStatus"] : <any>null;
            this.callNo = _data["callNo"] !== undefined ? _data["callNo"] : <any>null;
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.clientNo = _data["clientNo"] !== undefined ? _data["clientNo"] : <any>null;
            this.referredBy = _data["referredBy"] ? SalesRepDto.fromJS(_data["referredBy"]) : <any>null;
            this.noVendeur = _data["noVendeur"] !== undefined ? _data["noVendeur"] : <any>null;
            this.gender = _data["gender"] !== undefined ? _data["gender"] : <any>null;
            this.buysMeatAtButcher = _data["buysMeatAtButcher"] !== undefined ? _data["buysMeatAtButcher"] : <any>null;
            this.buysMeatAtSupermarket = _data["buysMeatAtSupermarket"] !== undefined ? _data["buysMeatAtSupermarket"] : <any>null;
            this.buysMeatAtExotic = _data["buysMeatAtExotic"] !== undefined ? _data["buysMeatAtExotic"] : <any>null;
            this.buysMeatAtHalal = _data["buysMeatAtHalal"] !== undefined ? _data["buysMeatAtHalal"] : <any>null;
            this.other = _data["other"] !== undefined ? _data["other"] : <any>null;
            this.budgetRange = _data["budgetRange"] !== undefined ? _data["budgetRange"] : <any>null;
            this.ageRange = _data["ageRange"] !== undefined ? _data["ageRange"] : <any>null;
            this.freezerSize = _data["freezerSize"] !== undefined ? _data["freezerSize"] : <any>null;
            this.freezerStockAmount = _data["freezerStockAmount"] !== undefined ? _data["freezerStockAmount"] : <any>null;
            this.languageType = _data["languageType"] !== undefined ? _data["languageType"] : <any>null;
            this.visa = _data["visa"] !== undefined ? _data["visa"] : <any>null;
            this.mastercard = _data["mastercard"] !== undefined ? _data["mastercard"] : <any>null;
            this.americanExpress = _data["americanExpress"] !== undefined ? _data["americanExpress"] : <any>null;
            this.usesOtherCreditCard = _data["usesOtherCreditCard"] !== undefined ? _data["usesOtherCreditCard"] : <any>null;
            this.otherCreditCard = _data["otherCreditCard"] !== undefined ? _data["otherCreditCard"] : <any>null;
            this.numberOfAdults = _data["numberOfAdults"] !== undefined ? _data["numberOfAdults"] : <any>null;
            this.numberOfKids = _data["numberOfKids"] !== undefined ? _data["numberOfKids"] : <any>null;
            this.numberOfPets = _data["numberOfPets"] !== undefined ? _data["numberOfPets"] : <any>null;
            this.petTypeDog = _data["petTypeDog"] !== undefined ? _data["petTypeDog"] : <any>null;
            this.petTypeCat = _data["petTypeCat"] !== undefined ? _data["petTypeCat"] : <any>null;
            this.petTypeFish = _data["petTypeFish"] !== undefined ? _data["petTypeFish"] : <any>null;
            this.petTypeBird = _data["petTypeBird"] !== undefined ? _data["petTypeBird"] : <any>null;
            this.petTypeRodent = _data["petTypeRodent"] !== undefined ? _data["petTypeRodent"] : <any>null;
            this.petTypeReptile = _data["petTypeReptile"] !== undefined ? _data["petTypeReptile"] : <any>null;
            this.petTypeRabbit = _data["petTypeRabbit"] !== undefined ? _data["petTypeRabbit"] : <any>null;
            this.petTypeOtherOrExotic = _data["petTypeOtherOrExotic"] !== undefined ? _data["petTypeOtherOrExotic"] : <any>null;
            this.hasFreezer = _data["hasFreezer"] !== undefined ? _data["hasFreezer"] : <any>null;
            this.hasSpace = _data["hasSpace"] !== undefined ? _data["hasSpace"] : <any>null;
            this.email = _data["email"] !== undefined ? _data["email"] : <any>null;
            this.hasNoEmail = _data["hasNoEmail"] !== undefined ? _data["hasNoEmail"] : <any>null;
            this.lastName = _data["lastName"] !== undefined ? _data["lastName"] : <any>null;
            this.firstName = _data["firstName"] !== undefined ? _data["firstName"] : <any>null;
            this.conjointFirstName = _data["conjointFirstName"] !== undefined ? _data["conjointFirstName"] : <any>null;
            this.conjointLastName = _data["conjointLastName"] !== undefined ? _data["conjointLastName"] : <any>null;
            this.occupation = _data["occupation"] !== undefined ? _data["occupation"] : <any>null;
            this.conjointOccupation = _data["conjointOccupation"] !== undefined ? _data["conjointOccupation"] : <any>null;
            this.livingArrangement = _data["livingArrangement"] !== undefined ? _data["livingArrangement"] : <any>null;
            this.crossStreet = _data["crossStreet"] !== undefined ? _data["crossStreet"] : <any>null;
            this.comments = _data["comments"] !== undefined ? _data["comments"] : <any>null;
            this.appointmentType = _data["appointmentType"] !== undefined ? _data["appointmentType"] : <any>null;
            this.homePhoneNumber = _data["homePhoneNumber"] !== undefined ? _data["homePhoneNumber"] : <any>null;
            this.cellPhoneNumber = _data["cellPhoneNumber"] !== undefined ? _data["cellPhoneNumber"] : <any>null;
            this.workPhoneNumber = _data["workPhoneNumber"] !== undefined ? _data["workPhoneNumber"] : <any>null;
            this.homePhoneNumberDisplay = _data["homePhoneNumberDisplay"] !== undefined ? _data["homePhoneNumberDisplay"] : <any>null;
            this.workPhoneNumberDisplay = _data["workPhoneNumberDisplay"] !== undefined ? _data["workPhoneNumberDisplay"] : <any>null;
            this.cellPhoneNumberDisplay = _data["cellPhoneNumberDisplay"] !== undefined ? _data["cellPhoneNumberDisplay"] : <any>null;
            this.extension = _data["extension"] !== undefined ? _data["extension"] : <any>null;
            this.address = _data["address"] ? AddressDto.fromJS(_data["address"]) : <any>null;
            this.visitsIga = _data["visitsIga"] !== undefined ? _data["visitsIga"] : <any>null;
            this.visitsMetro = _data["visitsMetro"] !== undefined ? _data["visitsMetro"] : <any>null;
            this.visitsMaxi = _data["visitsMaxi"] !== undefined ? _data["visitsMaxi"] : <any>null;
            this.visitsSuperC = _data["visitsSuperC"] !== undefined ? _data["visitsSuperC"] : <any>null;
            this.visitsLoblaws = _data["visitsLoblaws"] !== undefined ? _data["visitsLoblaws"] : <any>null;
            this.visitsCostco = _data["visitsCostco"] !== undefined ? _data["visitsCostco"] : <any>null;
            this.visitsWalmart = _data["visitsWalmart"] !== undefined ? _data["visitsWalmart"] : <any>null;
            this.visitsOtherSupermarket = _data["visitsOtherSupermarket"] !== undefined ? _data["visitsOtherSupermarket"] : <any>null;
            this.otherSupermarket = _data["otherSupermarket"] !== undefined ? _data["otherSupermarket"] : <any>null;
            this.onlineIga = _data["onlineIga"] !== undefined ? _data["onlineIga"] : <any>null;
            this.onlineMetro = _data["onlineMetro"] !== undefined ? _data["onlineMetro"] : <any>null;
            this.onlineMaxi = _data["onlineMaxi"] !== undefined ? _data["onlineMaxi"] : <any>null;
            this.onlineWalmart = _data["onlineWalmart"] !== undefined ? _data["onlineWalmart"] : <any>null;
            this.onlineGoodfood = _data["onlineGoodfood"] !== undefined ? _data["onlineGoodfood"] : <any>null;
            this.onlineGroceryOther = _data["onlineGroceryOther"] !== undefined ? _data["onlineGroceryOther"] : <any>null;
            this.onlineOtherSupermarket = _data["onlineOtherSupermarket"] !== undefined ? _data["onlineOtherSupermarket"] : <any>null;
            this.appointmentDateTime = _data["appointmentDateTime"] ? moment(_data["appointmentDateTime"].toString()) : <any>null;
            this.employee = _data["employee"] ? NestedEmployeeDto.fromJS(_data["employee"]) : <any>null;
            this.originalSalesRep = _data["originalSalesRep"] ? SalesRepDto.fromJS(_data["originalSalesRep"]) : <any>null;
            this.numberOfReferences = _data["numberOfReferences"] !== undefined ? _data["numberOfReferences"] : <any>null;
            this.rating = _data["rating"] !== undefined ? _data["rating"] : <any>null;
            this.ratingPercent = _data["ratingPercent"] !== undefined ? _data["ratingPercent"] : <any>null;
            this.isQualified = _data["isQualified"] !== undefined ? _data["isQualified"] : <any>null;
            this.isUpForReview = _data["isUpForReview"] !== undefined ? _data["isUpForReview"] : <any>null;
            this.clientLeadId = _data["clientLeadId"] !== undefined ? _data["clientLeadId"] : <any>null;
            this.callbackClientLeadId = _data["callbackClientLeadId"] !== undefined ? _data["callbackClientLeadId"] : <any>null;
            this.isVirtual = _data["isVirtual"] !== undefined ? _data["isVirtual"] : <any>null;
            this.appelEntrant = _data["appelEntrant"] !== undefined ? _data["appelEntrant"] : <any>null;
            this.originID = _data["originID"] !== undefined ? _data["originID"] : <any>null;
            this.hasNoOriginID = _data["hasNoOriginID"] !== undefined ? _data["hasNoOriginID"] : <any>null;
        }
    }

    static fromJS(data: any): AppointmentDto {
        data = typeof data === 'object' ? data : {};
        let result = new AppointmentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["buysMeatAtOther"] = this.buysMeatAtOther !== undefined ? this.buysMeatAtOther : <any>null;
        data["callDateTime"] = this.callDateTime ? this.callDateTime.toISOString() : <any>null;
        data["tmName"] = this.tmName !== undefined ? this.tmName : <any>null;
        data["appointmentStatus"] = this.appointmentStatus !== undefined ? this.appointmentStatus : <any>null;
        data["callNo"] = this.callNo !== undefined ? this.callNo : <any>null;
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["clientNo"] = this.clientNo !== undefined ? this.clientNo : <any>null;
        data["referredBy"] = this.referredBy ? this.referredBy.toJSON() : <any>null;
        data["noVendeur"] = this.noVendeur !== undefined ? this.noVendeur : <any>null;
        data["gender"] = this.gender !== undefined ? this.gender : <any>null;
        data["buysMeatAtButcher"] = this.buysMeatAtButcher !== undefined ? this.buysMeatAtButcher : <any>null;
        data["buysMeatAtSupermarket"] = this.buysMeatAtSupermarket !== undefined ? this.buysMeatAtSupermarket : <any>null;
        data["buysMeatAtExotic"] = this.buysMeatAtExotic !== undefined ? this.buysMeatAtExotic : <any>null;
        data["buysMeatAtHalal"] = this.buysMeatAtHalal !== undefined ? this.buysMeatAtHalal : <any>null;
        data["other"] = this.other !== undefined ? this.other : <any>null;
        data["budgetRange"] = this.budgetRange !== undefined ? this.budgetRange : <any>null;
        data["ageRange"] = this.ageRange !== undefined ? this.ageRange : <any>null;
        data["freezerSize"] = this.freezerSize !== undefined ? this.freezerSize : <any>null;
        data["freezerStockAmount"] = this.freezerStockAmount !== undefined ? this.freezerStockAmount : <any>null;
        data["languageType"] = this.languageType !== undefined ? this.languageType : <any>null;
        data["visa"] = this.visa !== undefined ? this.visa : <any>null;
        data["mastercard"] = this.mastercard !== undefined ? this.mastercard : <any>null;
        data["americanExpress"] = this.americanExpress !== undefined ? this.americanExpress : <any>null;
        data["usesOtherCreditCard"] = this.usesOtherCreditCard !== undefined ? this.usesOtherCreditCard : <any>null;
        data["otherCreditCard"] = this.otherCreditCard !== undefined ? this.otherCreditCard : <any>null;
        data["numberOfAdults"] = this.numberOfAdults !== undefined ? this.numberOfAdults : <any>null;
        data["numberOfKids"] = this.numberOfKids !== undefined ? this.numberOfKids : <any>null;
        data["numberOfPets"] = this.numberOfPets !== undefined ? this.numberOfPets : <any>null;
        data["petTypeDog"] = this.petTypeDog !== undefined ? this.petTypeDog : <any>null;
        data["petTypeCat"] = this.petTypeCat !== undefined ? this.petTypeCat : <any>null;
        data["petTypeFish"] = this.petTypeFish !== undefined ? this.petTypeFish : <any>null;
        data["petTypeBird"] = this.petTypeBird !== undefined ? this.petTypeBird : <any>null;
        data["petTypeRodent"] = this.petTypeRodent !== undefined ? this.petTypeRodent : <any>null;
        data["petTypeReptile"] = this.petTypeReptile !== undefined ? this.petTypeReptile : <any>null;
        data["petTypeRabbit"] = this.petTypeRabbit !== undefined ? this.petTypeRabbit : <any>null;
        data["petTypeOtherOrExotic"] = this.petTypeOtherOrExotic !== undefined ? this.petTypeOtherOrExotic : <any>null;
        data["hasFreezer"] = this.hasFreezer !== undefined ? this.hasFreezer : <any>null;
        data["hasSpace"] = this.hasSpace !== undefined ? this.hasSpace : <any>null;
        data["email"] = this.email !== undefined ? this.email : <any>null;
        data["hasNoEmail"] = this.hasNoEmail !== undefined ? this.hasNoEmail : <any>null;
        data["lastName"] = this.lastName !== undefined ? this.lastName : <any>null;
        data["firstName"] = this.firstName !== undefined ? this.firstName : <any>null;
        data["conjointFirstName"] = this.conjointFirstName !== undefined ? this.conjointFirstName : <any>null;
        data["conjointLastName"] = this.conjointLastName !== undefined ? this.conjointLastName : <any>null;
        data["occupation"] = this.occupation !== undefined ? this.occupation : <any>null;
        data["conjointOccupation"] = this.conjointOccupation !== undefined ? this.conjointOccupation : <any>null;
        data["livingArrangement"] = this.livingArrangement !== undefined ? this.livingArrangement : <any>null;
        data["crossStreet"] = this.crossStreet !== undefined ? this.crossStreet : <any>null;
        data["comments"] = this.comments !== undefined ? this.comments : <any>null;
        data["appointmentType"] = this.appointmentType !== undefined ? this.appointmentType : <any>null;
        data["homePhoneNumber"] = this.homePhoneNumber !== undefined ? this.homePhoneNumber : <any>null;
        data["cellPhoneNumber"] = this.cellPhoneNumber !== undefined ? this.cellPhoneNumber : <any>null;
        data["workPhoneNumber"] = this.workPhoneNumber !== undefined ? this.workPhoneNumber : <any>null;
        data["homePhoneNumberDisplay"] = this.homePhoneNumberDisplay !== undefined ? this.homePhoneNumberDisplay : <any>null;
        data["workPhoneNumberDisplay"] = this.workPhoneNumberDisplay !== undefined ? this.workPhoneNumberDisplay : <any>null;
        data["cellPhoneNumberDisplay"] = this.cellPhoneNumberDisplay !== undefined ? this.cellPhoneNumberDisplay : <any>null;
        data["extension"] = this.extension !== undefined ? this.extension : <any>null;
        data["address"] = this.address ? this.address.toJSON() : <any>null;
        data["visitsIga"] = this.visitsIga !== undefined ? this.visitsIga : <any>null;
        data["visitsMetro"] = this.visitsMetro !== undefined ? this.visitsMetro : <any>null;
        data["visitsMaxi"] = this.visitsMaxi !== undefined ? this.visitsMaxi : <any>null;
        data["visitsSuperC"] = this.visitsSuperC !== undefined ? this.visitsSuperC : <any>null;
        data["visitsLoblaws"] = this.visitsLoblaws !== undefined ? this.visitsLoblaws : <any>null;
        data["visitsCostco"] = this.visitsCostco !== undefined ? this.visitsCostco : <any>null;
        data["visitsWalmart"] = this.visitsWalmart !== undefined ? this.visitsWalmart : <any>null;
        data["visitsOtherSupermarket"] = this.visitsOtherSupermarket !== undefined ? this.visitsOtherSupermarket : <any>null;
        data["otherSupermarket"] = this.otherSupermarket !== undefined ? this.otherSupermarket : <any>null;
        data["onlineIga"] = this.onlineIga !== undefined ? this.onlineIga : <any>null;
        data["onlineMetro"] = this.onlineMetro !== undefined ? this.onlineMetro : <any>null;
        data["onlineMaxi"] = this.onlineMaxi !== undefined ? this.onlineMaxi : <any>null;
        data["onlineWalmart"] = this.onlineWalmart !== undefined ? this.onlineWalmart : <any>null;
        data["onlineGoodfood"] = this.onlineGoodfood !== undefined ? this.onlineGoodfood : <any>null;
        data["onlineGroceryOther"] = this.onlineGroceryOther !== undefined ? this.onlineGroceryOther : <any>null;
        data["onlineOtherSupermarket"] = this.onlineOtherSupermarket !== undefined ? this.onlineOtherSupermarket : <any>null;
        data["appointmentDateTime"] = this.appointmentDateTime ? this.appointmentDateTime.toISOString() : <any>null;
        data["employee"] = this.employee ? this.employee.toJSON() : <any>null;
        data["originalSalesRep"] = this.originalSalesRep ? this.originalSalesRep.toJSON() : <any>null;
        data["numberOfReferences"] = this.numberOfReferences !== undefined ? this.numberOfReferences : <any>null;
        data["rating"] = this.rating !== undefined ? this.rating : <any>null;
        data["ratingPercent"] = this.ratingPercent !== undefined ? this.ratingPercent : <any>null;
        data["isQualified"] = this.isQualified !== undefined ? this.isQualified : <any>null;
        data["isUpForReview"] = this.isUpForReview !== undefined ? this.isUpForReview : <any>null;
        data["clientLeadId"] = this.clientLeadId !== undefined ? this.clientLeadId : <any>null;
        data["callbackClientLeadId"] = this.callbackClientLeadId !== undefined ? this.callbackClientLeadId : <any>null;
        data["isVirtual"] = this.isVirtual !== undefined ? this.isVirtual : <any>null;
        data["appelEntrant"] = this.appelEntrant !== undefined ? this.appelEntrant : <any>null;
        data["originID"] = this.originID !== undefined ? this.originID : <any>null;
        data["hasNoOriginID"] = this.hasNoOriginID !== undefined ? this.hasNoOriginID : <any>null;
        return data;
    }
}

export interface IAppointmentDto {
    buysMeatAtOther?: boolean | null;
    callDateTime?: moment.Moment | null;
    tmName?: string | null;
    appointmentStatus?: AppointmentStatus;
    callNo?: number | null;
    id?: string | null;
    clientNo?: number | null;
    referredBy?: SalesRepDto | null;
    noVendeur?: number | null;
    gender?: AppointmentClientGender | null;
    buysMeatAtButcher?: boolean | null;
    buysMeatAtSupermarket?: boolean | null;
    buysMeatAtExotic?: boolean | null;
    buysMeatAtHalal?: boolean | null;
    other?: boolean | null;
    budgetRange?: BudgetRange | null;
    ageRange?: AgeRange | null;
    freezerSize?: FreezerSize | null;
    freezerStockAmount?: FreezerStockAmount | null;
    languageType?: LanguageType;
    visa?: boolean | null;
    mastercard?: boolean | null;
    americanExpress?: boolean | null;
    usesOtherCreditCard?: boolean | null;
    otherCreditCard?: string | null;
    numberOfAdults?: number | null;
    numberOfKids?: number | null;
    numberOfPets?: number | null;
    petTypeDog?: boolean | null;
    petTypeCat?: boolean | null;
    petTypeFish?: boolean | null;
    petTypeBird?: boolean | null;
    petTypeRodent?: boolean | null;
    petTypeReptile?: boolean | null;
    petTypeRabbit?: boolean | null;
    petTypeOtherOrExotic?: boolean | null;
    hasFreezer?: boolean | null;
    hasSpace?: boolean | null;
    email?: string | null;
    hasNoEmail?: boolean | null;
    lastName?: string | null;
    firstName?: string | null;
    conjointFirstName?: string | null;
    conjointLastName?: string | null;
    occupation?: string | null;
    conjointOccupation?: string | null;
    livingArrangement?: LivingArrangement | null;
    crossStreet?: string | null;
    comments?: string | null;
    appointmentType?: AppointmentType;
    homePhoneNumber?: string | null;
    cellPhoneNumber?: string | null;
    workPhoneNumber?: string | null;
    homePhoneNumberDisplay?: string | null;
    workPhoneNumberDisplay?: string | null;
    cellPhoneNumberDisplay?: string | null;
    extension?: string | null;
    address?: AddressDto | null;
    visitsIga?: boolean | null;
    visitsMetro?: boolean | null;
    visitsMaxi?: boolean | null;
    visitsSuperC?: boolean | null;
    visitsLoblaws?: boolean | null;
    visitsCostco?: boolean | null;
    visitsWalmart?: boolean | null;
    visitsOtherSupermarket?: boolean | null;
    otherSupermarket?: string | null;
    onlineIga?: boolean;
    onlineMetro?: boolean;
    onlineMaxi?: boolean;
    onlineWalmart?: boolean;
    onlineGoodfood?: boolean;
    onlineGroceryOther?: boolean;
    onlineOtherSupermarket?: string | null;
    appointmentDateTime?: moment.Moment | null;
    employee?: NestedEmployeeDto | null;
    originalSalesRep?: SalesRepDto | null;
    numberOfReferences?: number | null;
    rating?: number | null;
    ratingPercent?: number | null;
    isQualified?: boolean;
    isUpForReview?: boolean;
    clientLeadId?: number | null;
    callbackClientLeadId?: number | null;
    isVirtual?: boolean | null;
    appelEntrant?: boolean | null;
    originID?: string | null;
    hasNoOriginID?: boolean | null;
}

export class AppointmentManagementDto extends AppointmentDto implements IAppointmentManagementDto {
    confirmedSalesRep?: SalesRepDto | null;
    vendorConfirmed?: boolean;
    statusComments?: string | null;
    distributorComments?: string | null;
    postPonedDate?: moment.Moment | null;
    cartValue?: number;
    confirmed?: boolean;
    isAppointmentDispatched?: boolean;
    montantCommande?: number | null;
    appointmentDispatchedRecords?: AppointmentDispatchedRecordDto[] | null;

    constructor(data?: IAppointmentManagementDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.confirmedSalesRep = _data["confirmedSalesRep"] ? SalesRepDto.fromJS(_data["confirmedSalesRep"]) : <any>null;
            this.vendorConfirmed = _data["vendorConfirmed"] !== undefined ? _data["vendorConfirmed"] : <any>null;
            this.statusComments = _data["statusComments"] !== undefined ? _data["statusComments"] : <any>null;
            this.distributorComments = _data["distributorComments"] !== undefined ? _data["distributorComments"] : <any>null;
            this.postPonedDate = _data["postPonedDate"] ? moment(_data["postPonedDate"].toString()) : <any>null;
            this.cartValue = _data["cartValue"] !== undefined ? _data["cartValue"] : <any>null;
            this.confirmed = _data["confirmed"] !== undefined ? _data["confirmed"] : <any>null;
            this.isAppointmentDispatched = _data["isAppointmentDispatched"] !== undefined ? _data["isAppointmentDispatched"] : <any>null;
            this.montantCommande = _data["montantCommande"] !== undefined ? _data["montantCommande"] : <any>null;
            if (Array.isArray(_data["appointmentDispatchedRecords"])) {
                this.appointmentDispatchedRecords = [] as any;
                for (let item of _data["appointmentDispatchedRecords"])
                    this.appointmentDispatchedRecords!.push(AppointmentDispatchedRecordDto.fromJS(item));
            }
            else {
                this.appointmentDispatchedRecords = <any>null;
            }
        }
    }

    static override fromJS(data: any): AppointmentManagementDto {
        data = typeof data === 'object' ? data : {};
        let result = new AppointmentManagementDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["confirmedSalesRep"] = this.confirmedSalesRep ? this.confirmedSalesRep.toJSON() : <any>null;
        data["vendorConfirmed"] = this.vendorConfirmed !== undefined ? this.vendorConfirmed : <any>null;
        data["statusComments"] = this.statusComments !== undefined ? this.statusComments : <any>null;
        data["distributorComments"] = this.distributorComments !== undefined ? this.distributorComments : <any>null;
        data["postPonedDate"] = this.postPonedDate ? this.postPonedDate.toISOString() : <any>null;
        data["cartValue"] = this.cartValue !== undefined ? this.cartValue : <any>null;
        data["confirmed"] = this.confirmed !== undefined ? this.confirmed : <any>null;
        data["isAppointmentDispatched"] = this.isAppointmentDispatched !== undefined ? this.isAppointmentDispatched : <any>null;
        data["montantCommande"] = this.montantCommande !== undefined ? this.montantCommande : <any>null;
        if (Array.isArray(this.appointmentDispatchedRecords)) {
            data["appointmentDispatchedRecords"] = [];
            for (let item of this.appointmentDispatchedRecords)
                data["appointmentDispatchedRecords"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IAppointmentManagementDto extends IAppointmentDto {
    confirmedSalesRep?: SalesRepDto | null;
    vendorConfirmed?: boolean;
    statusComments?: string | null;
    distributorComments?: string | null;
    postPonedDate?: moment.Moment | null;
    cartValue?: number;
    confirmed?: boolean;
    isAppointmentDispatched?: boolean;
    montantCommande?: number | null;
    appointmentDispatchedRecords?: AppointmentDispatchedRecordDto[] | null;
}

export class AppointmentQualificationDto extends AppointmentManagementDto implements IAppointmentQualificationDto {
    qualified?: boolean;
    promo?: boolean;

    constructor(data?: IAppointmentQualificationDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.qualified = _data["qualified"] !== undefined ? _data["qualified"] : <any>null;
            this.promo = _data["promo"] !== undefined ? _data["promo"] : <any>null;
        }
    }

    static override fromJS(data: any): AppointmentQualificationDto {
        data = typeof data === 'object' ? data : {};
        let result = new AppointmentQualificationDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["qualified"] = this.qualified !== undefined ? this.qualified : <any>null;
        data["promo"] = this.promo !== undefined ? this.promo : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IAppointmentQualificationDto extends IAppointmentManagementDto {
    qualified?: boolean;
    promo?: boolean;
}

export class SalesRepDto implements ISalesRepDto {
    id?: number | null;
    name?: string | null;
    tabletAccess?: boolean | null;

    constructor(data?: ISalesRepDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.tabletAccess = _data["tabletAccess"] !== undefined ? _data["tabletAccess"] : <any>null;
        }
    }

    static fromJS(data: any): SalesRepDto {
        data = typeof data === 'object' ? data : {};
        let result = new SalesRepDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["tabletAccess"] = this.tabletAccess !== undefined ? this.tabletAccess : <any>null;
        return data;
    }
}

export interface ISalesRepDto {
    id?: number | null;
    name?: string | null;
    tabletAccess?: boolean | null;
}

export class AppointmentDispatchedRecordDto implements IAppointmentDispatchedRecordDto {
    id?: string | null;
    dispatchType?: AppointmentDispatchType;
    performedByEmployeeName?: string | null;
    performedOnDateTime?: moment.Moment;
    tabletDispatchedAppointmentId?: string;
    confirmedSalesRepName?: string | null;
    isRemoteOrder?: boolean | null;

    constructor(data?: IAppointmentDispatchedRecordDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.dispatchType = _data["dispatchType"] !== undefined ? _data["dispatchType"] : <any>null;
            this.performedByEmployeeName = _data["performedByEmployeeName"] !== undefined ? _data["performedByEmployeeName"] : <any>null;
            this.performedOnDateTime = _data["performedOnDateTime"] ? moment(_data["performedOnDateTime"].toString()) : <any>null;
            this.tabletDispatchedAppointmentId = _data["tabletDispatchedAppointmentId"] !== undefined ? _data["tabletDispatchedAppointmentId"] : <any>null;
            this.confirmedSalesRepName = _data["confirmedSalesRepName"] !== undefined ? _data["confirmedSalesRepName"] : <any>null;
            this.isRemoteOrder = _data["isRemoteOrder"] !== undefined ? _data["isRemoteOrder"] : <any>null;
        }
    }

    static fromJS(data: any): AppointmentDispatchedRecordDto {
        data = typeof data === 'object' ? data : {};
        let result = new AppointmentDispatchedRecordDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["dispatchType"] = this.dispatchType !== undefined ? this.dispatchType : <any>null;
        data["performedByEmployeeName"] = this.performedByEmployeeName !== undefined ? this.performedByEmployeeName : <any>null;
        data["performedOnDateTime"] = this.performedOnDateTime ? this.performedOnDateTime.toISOString() : <any>null;
        data["tabletDispatchedAppointmentId"] = this.tabletDispatchedAppointmentId !== undefined ? this.tabletDispatchedAppointmentId : <any>null;
        data["confirmedSalesRepName"] = this.confirmedSalesRepName !== undefined ? this.confirmedSalesRepName : <any>null;
        data["isRemoteOrder"] = this.isRemoteOrder !== undefined ? this.isRemoteOrder : <any>null;
        return data;
    }
}

export interface IAppointmentDispatchedRecordDto {
    id?: string | null;
    dispatchType?: AppointmentDispatchType;
    performedByEmployeeName?: string | null;
    performedOnDateTime?: moment.Moment;
    tabletDispatchedAppointmentId?: string;
    confirmedSalesRepName?: string | null;
    isRemoteOrder?: boolean | null;
}

export enum AppointmentDispatchType {
    Dispatch = "dispatch",
    UpdateDispatched = "updateDispatched",
    RecallDispatched = "recallDispatched",
}

export enum AppointmentStatus {
    OnStandby = "onStandby",
    Confirmed = "confirmed",
    Postponed = "postponed",
    Sold = "sold",
    Cancelled = "cancelled",
    Delivered = "delivered",
    Callback = "callback",
    ShownNotSold = "shownNotSold",
    ShownToBeFinalized = "shownToBeFinalized",
    NotShown = "notShown",
    Refused = "refused",
}

export enum AppointmentClientGender {
    Male = "male",
    Female = "female",
    Promo = "promo",
}

export enum BudgetRange {
    Low = "low",
    LowMed = "lowMed",
    Med = "med",
    MedHigh = "medHigh",
    High = "high",
}

export enum AgeRange {
    EighteenToTwentyFour = "eighteenToTwentyFour",
    TwentyFiveToThirtyFour = "twentyFiveToThirtyFour",
    ThirtyFiveToFortyFour = "thirtyFiveToFortyFour",
    FortyFiveToFiftyFour = "fortyFiveToFiftyFour",
    FiftyFiveToSixtyFour = "fiftyFiveToSixtyFour",
    SixtyFiveAndOver = "sixtyFiveAndOver",
}

export enum FreezerSize {
    Small = "small",
    Medium = "medium",
    Large = "large",
}

export enum FreezerStockAmount {
    Empty = "empty",
    Quarter = "quarter",
    Half = "half",
    ThreeQuarters = "threeQuarters",
    Full = "full",
}

export enum LanguageType {
    English = "english",
    French = "french",
}

export enum LivingArrangement {
    Renter = "renter",
    PropertyOwner = "propertyOwner",
}

export enum AppointmentType {
    New = "new",
    Renew = "renew",
    Winback = "winback",
}

export class AddressDto implements IAddressDto {
    id?: string | null;
    street?: string | null;
    apartment?: string | null;
    city?: string | null;
    province?: string | null;
    neighborhood?: string | null;
    postalCode?: string | null;
    country?: string | null;
    fullAddress?: string | null;

    constructor(data?: IAddressDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.street = _data["street"] !== undefined ? _data["street"] : <any>null;
            this.apartment = _data["apartment"] !== undefined ? _data["apartment"] : <any>null;
            this.city = _data["city"] !== undefined ? _data["city"] : <any>null;
            this.province = _data["province"] !== undefined ? _data["province"] : <any>null;
            this.neighborhood = _data["neighborhood"] !== undefined ? _data["neighborhood"] : <any>null;
            this.postalCode = _data["postalCode"] !== undefined ? _data["postalCode"] : <any>null;
            this.country = _data["country"] !== undefined ? _data["country"] : <any>null;
            this.fullAddress = _data["fullAddress"] !== undefined ? _data["fullAddress"] : <any>null;
        }
    }

    static fromJS(data: any): AddressDto {
        data = typeof data === 'object' ? data : {};
        let result = new AddressDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["street"] = this.street !== undefined ? this.street : <any>null;
        data["apartment"] = this.apartment !== undefined ? this.apartment : <any>null;
        data["city"] = this.city !== undefined ? this.city : <any>null;
        data["province"] = this.province !== undefined ? this.province : <any>null;
        data["neighborhood"] = this.neighborhood !== undefined ? this.neighborhood : <any>null;
        data["postalCode"] = this.postalCode !== undefined ? this.postalCode : <any>null;
        data["country"] = this.country !== undefined ? this.country : <any>null;
        data["fullAddress"] = this.fullAddress !== undefined ? this.fullAddress : <any>null;
        return data;
    }
}

export interface IAddressDto {
    id?: string | null;
    street?: string | null;
    apartment?: string | null;
    city?: string | null;
    province?: string | null;
    neighborhood?: string | null;
    postalCode?: string | null;
    country?: string | null;
    fullAddress?: string | null;
}

export class NestedEmployeeDto implements INestedEmployeeDto {
    id?: string | null;
    name?: string | null;
    activeDirectoryUsername?: string | null;
    sid?: string | null;

    constructor(data?: INestedEmployeeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.activeDirectoryUsername = _data["activeDirectoryUsername"] !== undefined ? _data["activeDirectoryUsername"] : <any>null;
            this.sid = _data["sid"] !== undefined ? _data["sid"] : <any>null;
        }
    }

    static fromJS(data: any): NestedEmployeeDto {
        data = typeof data === 'object' ? data : {};
        let result = new NestedEmployeeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["activeDirectoryUsername"] = this.activeDirectoryUsername !== undefined ? this.activeDirectoryUsername : <any>null;
        data["sid"] = this.sid !== undefined ? this.sid : <any>null;
        return data;
    }
}

export interface INestedEmployeeDto {
    id?: string | null;
    name?: string | null;
    activeDirectoryUsername?: string | null;
    sid?: string | null;
}

export class UpdateQualificationCommand implements IUpdateQualificationCommand {
    callNo?: number;
    isQualified?: boolean;
    isPromo?: boolean;
    employeeId?: string | null;

    constructor(data?: IUpdateQualificationCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.callNo = _data["callNo"] !== undefined ? _data["callNo"] : <any>null;
            this.isQualified = _data["isQualified"] !== undefined ? _data["isQualified"] : <any>null;
            this.isPromo = _data["isPromo"] !== undefined ? _data["isPromo"] : <any>null;
            this.employeeId = _data["employeeId"] !== undefined ? _data["employeeId"] : <any>null;
        }
    }

    static fromJS(data: any): UpdateQualificationCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateQualificationCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["callNo"] = this.callNo !== undefined ? this.callNo : <any>null;
        data["isQualified"] = this.isQualified !== undefined ? this.isQualified : <any>null;
        data["isPromo"] = this.isPromo !== undefined ? this.isPromo : <any>null;
        data["employeeId"] = this.employeeId !== undefined ? this.employeeId : <any>null;
        return data;
    }
}

export interface IUpdateQualificationCommand {
    callNo?: number;
    isQualified?: boolean;
    isPromo?: boolean;
    employeeId?: string | null;
}

export class PutUpForReviewCommand implements IPutUpForReviewCommand {
    callNo?: number;
    employeeId?: string | null;

    constructor(data?: IPutUpForReviewCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.callNo = _data["callNo"] !== undefined ? _data["callNo"] : <any>null;
            this.employeeId = _data["employeeId"] !== undefined ? _data["employeeId"] : <any>null;
        }
    }

    static fromJS(data: any): PutUpForReviewCommand {
        data = typeof data === 'object' ? data : {};
        let result = new PutUpForReviewCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["callNo"] = this.callNo !== undefined ? this.callNo : <any>null;
        data["employeeId"] = this.employeeId !== undefined ? this.employeeId : <any>null;
        return data;
    }
}

export interface IPutUpForReviewCommand {
    callNo?: number;
    employeeId?: string | null;
}

export class PaginatedResultOfAppointmentLookupDto extends PaginatedResult implements IPaginatedResultOfAppointmentLookupDto {
    entities?: AppointmentLookupDto[] | null;

    constructor(data?: IPaginatedResultOfAppointmentLookupDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["entities"])) {
                this.entities = [] as any;
                for (let item of _data["entities"])
                    this.entities!.push(AppointmentLookupDto.fromJS(item));
            }
            else {
                this.entities = <any>null;
            }
        }
    }

    static override fromJS(data: any): PaginatedResultOfAppointmentLookupDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResultOfAppointmentLookupDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.entities)) {
            data["entities"] = [];
            for (let item of this.entities)
                data["entities"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IPaginatedResultOfAppointmentLookupDto extends IPaginatedResult {
    entities?: AppointmentLookupDto[] | null;
}

export class AppointmentLookupDto implements IAppointmentLookupDto {
    appointmentDateTime?: moment.Moment | null;
    email?: string | null;
    workPhoneNumber?: string | null;
    cellPhoneNumber?: string | null;
    callNo?: number;
    index?: number;
    id?: string | null;
    firstName?: string | null;
    lastName?: string | null;
    name?: string | null;
    homePhoneNumber?: string | null;

    constructor(data?: IAppointmentLookupDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.appointmentDateTime = _data["appointmentDateTime"] ? moment(_data["appointmentDateTime"].toString()) : <any>null;
            this.email = _data["email"] !== undefined ? _data["email"] : <any>null;
            this.workPhoneNumber = _data["workPhoneNumber"] !== undefined ? _data["workPhoneNumber"] : <any>null;
            this.cellPhoneNumber = _data["cellPhoneNumber"] !== undefined ? _data["cellPhoneNumber"] : <any>null;
            this.callNo = _data["callNo"] !== undefined ? _data["callNo"] : <any>null;
            this.index = _data["index"] !== undefined ? _data["index"] : <any>null;
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.firstName = _data["firstName"] !== undefined ? _data["firstName"] : <any>null;
            this.lastName = _data["lastName"] !== undefined ? _data["lastName"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.homePhoneNumber = _data["homePhoneNumber"] !== undefined ? _data["homePhoneNumber"] : <any>null;
        }
    }

    static fromJS(data: any): AppointmentLookupDto {
        data = typeof data === 'object' ? data : {};
        let result = new AppointmentLookupDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["appointmentDateTime"] = this.appointmentDateTime ? this.appointmentDateTime.toISOString() : <any>null;
        data["email"] = this.email !== undefined ? this.email : <any>null;
        data["workPhoneNumber"] = this.workPhoneNumber !== undefined ? this.workPhoneNumber : <any>null;
        data["cellPhoneNumber"] = this.cellPhoneNumber !== undefined ? this.cellPhoneNumber : <any>null;
        data["callNo"] = this.callNo !== undefined ? this.callNo : <any>null;
        data["index"] = this.index !== undefined ? this.index : <any>null;
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["firstName"] = this.firstName !== undefined ? this.firstName : <any>null;
        data["lastName"] = this.lastName !== undefined ? this.lastName : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["homePhoneNumber"] = this.homePhoneNumber !== undefined ? this.homePhoneNumber : <any>null;
        return data;
    }
}

export interface IAppointmentLookupDto {
    appointmentDateTime?: moment.Moment | null;
    email?: string | null;
    workPhoneNumber?: string | null;
    cellPhoneNumber?: string | null;
    callNo?: number;
    index?: number;
    id?: string | null;
    firstName?: string | null;
    lastName?: string | null;
    name?: string | null;
    homePhoneNumber?: string | null;
}

export class GetLegacyAppointmentListQuery extends PaginationModel implements IGetLegacyAppointmentListQuery {
    fromDateTime?: moment.Moment;
    toDateTime?: moment.Moment;
    onlyShowAssignedClientLeadNotes?: boolean;
    userId?: string | null;

    constructor(data?: IGetLegacyAppointmentListQuery) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.fromDateTime = _data["fromDateTime"] ? moment(_data["fromDateTime"].toString()) : <any>null;
            this.toDateTime = _data["toDateTime"] ? moment(_data["toDateTime"].toString()) : <any>null;
            this.onlyShowAssignedClientLeadNotes = _data["onlyShowAssignedClientLeadNotes"] !== undefined ? _data["onlyShowAssignedClientLeadNotes"] : <any>null;
            this.userId = _data["userId"] !== undefined ? _data["userId"] : <any>null;
        }
    }

    static override fromJS(data: any): GetLegacyAppointmentListQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetLegacyAppointmentListQuery();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fromDateTime"] = this.fromDateTime ? this.fromDateTime.toISOString() : <any>null;
        data["toDateTime"] = this.toDateTime ? this.toDateTime.toISOString() : <any>null;
        data["onlyShowAssignedClientLeadNotes"] = this.onlyShowAssignedClientLeadNotes !== undefined ? this.onlyShowAssignedClientLeadNotes : <any>null;
        data["userId"] = this.userId !== undefined ? this.userId : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IGetLegacyAppointmentListQuery extends IPaginationModel {
    fromDateTime?: moment.Moment;
    toDateTime?: moment.Moment;
    onlyShowAssignedClientLeadNotes?: boolean;
    userId?: string | null;
}

export class CreateLegacyAppointmentCommand implements ICreateLegacyAppointmentCommand {
    appointment?: AppointmentDto | null;
    isCreatedFromCallback?: boolean;
    isCreatedFromClientLead?: boolean;
    sid?: string | null;

    constructor(data?: ICreateLegacyAppointmentCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.appointment = _data["appointment"] ? AppointmentDto.fromJS(_data["appointment"]) : <any>null;
            this.isCreatedFromCallback = _data["isCreatedFromCallback"] !== undefined ? _data["isCreatedFromCallback"] : <any>null;
            this.isCreatedFromClientLead = _data["isCreatedFromClientLead"] !== undefined ? _data["isCreatedFromClientLead"] : <any>null;
            this.sid = _data["sid"] !== undefined ? _data["sid"] : <any>null;
        }
    }

    static fromJS(data: any): CreateLegacyAppointmentCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateLegacyAppointmentCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["appointment"] = this.appointment ? this.appointment.toJSON() : <any>null;
        data["isCreatedFromCallback"] = this.isCreatedFromCallback !== undefined ? this.isCreatedFromCallback : <any>null;
        data["isCreatedFromClientLead"] = this.isCreatedFromClientLead !== undefined ? this.isCreatedFromClientLead : <any>null;
        data["sid"] = this.sid !== undefined ? this.sid : <any>null;
        return data;
    }
}

export interface ICreateLegacyAppointmentCommand {
    appointment?: AppointmentDto | null;
    isCreatedFromCallback?: boolean;
    isCreatedFromClientLead?: boolean;
    sid?: string | null;
}

export class CreateOrEditClientLeadProfileCommand implements ICreateOrEditClientLeadProfileCommand {
    appointment?: AppointmentDto | null;
    clientLeadId?: number;
    postalCode?: string | null;

    constructor(data?: ICreateOrEditClientLeadProfileCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.appointment = _data["appointment"] ? AppointmentDto.fromJS(_data["appointment"]) : <any>null;
            this.clientLeadId = _data["clientLeadId"] !== undefined ? _data["clientLeadId"] : <any>null;
            this.postalCode = _data["postalCode"] !== undefined ? _data["postalCode"] : <any>null;
        }
    }

    static fromJS(data: any): CreateOrEditClientLeadProfileCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditClientLeadProfileCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["appointment"] = this.appointment ? this.appointment.toJSON() : <any>null;
        data["clientLeadId"] = this.clientLeadId !== undefined ? this.clientLeadId : <any>null;
        data["postalCode"] = this.postalCode !== undefined ? this.postalCode : <any>null;
        return data;
    }
}

export interface ICreateOrEditClientLeadProfileCommand {
    appointment?: AppointmentDto | null;
    clientLeadId?: number;
    postalCode?: string | null;
}

export class EditLegacyAppointmentCommand implements IEditLegacyAppointmentCommand {
    appointment?: AppointmentManagementDto | null;
    user?: ClaimsPrincipal | null;

    constructor(data?: IEditLegacyAppointmentCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.appointment = _data["appointment"] ? AppointmentManagementDto.fromJS(_data["appointment"]) : <any>null;
            this.user = _data["user"] ? ClaimsPrincipal.fromJS(_data["user"]) : <any>null;
        }
    }

    static fromJS(data: any): EditLegacyAppointmentCommand {
        data = typeof data === 'object' ? data : {};
        let result = new EditLegacyAppointmentCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["appointment"] = this.appointment ? this.appointment.toJSON() : <any>null;
        data["user"] = this.user ? this.user.toJSON() : <any>null;
        return data;
    }
}

export interface IEditLegacyAppointmentCommand {
    appointment?: AppointmentManagementDto | null;
    user?: ClaimsPrincipal | null;
}

export class ClaimsPrincipal implements IClaimsPrincipal {
    claims?: Claim[];
    identities?: ClaimsIdentity[];
    identity?: IIdentity | null;

    constructor(data?: IClaimsPrincipal) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["claims"])) {
                this.claims = [] as any;
                for (let item of _data["claims"])
                    this.claims!.push(Claim.fromJS(item));
            }
            else {
                this.claims = <any>null;
            }
            if (Array.isArray(_data["identities"])) {
                this.identities = [] as any;
                for (let item of _data["identities"])
                    this.identities!.push(ClaimsIdentity.fromJS(item));
            }
            else {
                this.identities = <any>null;
            }
            this.identity = _data["identity"] ? IIdentity.fromJS(_data["identity"]) : <any>null;
        }
    }

    static fromJS(data: any): ClaimsPrincipal {
        data = typeof data === 'object' ? data : {};
        let result = new ClaimsPrincipal();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.claims)) {
            data["claims"] = [];
            for (let item of this.claims)
                data["claims"].push(item.toJSON());
        }
        if (Array.isArray(this.identities)) {
            data["identities"] = [];
            for (let item of this.identities)
                data["identities"].push(item.toJSON());
        }
        data["identity"] = this.identity ? this.identity.toJSON() : <any>null;
        return data;
    }
}

export interface IClaimsPrincipal {
    claims?: Claim[];
    identities?: ClaimsIdentity[];
    identity?: IIdentity | null;
}

export class Claim implements IClaim {
    issuer?: string;
    originalIssuer?: string;
    properties?: { [key: string]: string; };
    subject?: ClaimsIdentity | null;
    type?: string;
    value?: string;
    valueType?: string;

    constructor(data?: IClaim) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.issuer = _data["issuer"] !== undefined ? _data["issuer"] : <any>null;
            this.originalIssuer = _data["originalIssuer"] !== undefined ? _data["originalIssuer"] : <any>null;
            if (_data["properties"]) {
                this.properties = {} as any;
                for (let key in _data["properties"]) {
                    if (_data["properties"].hasOwnProperty(key))
                        (<any>this.properties)![key] = _data["properties"][key] !== undefined ? _data["properties"][key] : <any>null;
                }
            }
            else {
                this.properties = <any>null;
            }
            this.subject = _data["subject"] ? ClaimsIdentity.fromJS(_data["subject"]) : <any>null;
            this.type = _data["type"] !== undefined ? _data["type"] : <any>null;
            this.value = _data["value"] !== undefined ? _data["value"] : <any>null;
            this.valueType = _data["valueType"] !== undefined ? _data["valueType"] : <any>null;
        }
    }

    static fromJS(data: any): Claim {
        data = typeof data === 'object' ? data : {};
        let result = new Claim();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["issuer"] = this.issuer !== undefined ? this.issuer : <any>null;
        data["originalIssuer"] = this.originalIssuer !== undefined ? this.originalIssuer : <any>null;
        if (this.properties) {
            data["properties"] = {};
            for (let key in this.properties) {
                if (this.properties.hasOwnProperty(key))
                    (<any>data["properties"])[key] = this.properties[key] !== undefined ? this.properties[key] : <any>null;
            }
        }
        data["subject"] = this.subject ? this.subject.toJSON() : <any>null;
        data["type"] = this.type !== undefined ? this.type : <any>null;
        data["value"] = this.value !== undefined ? this.value : <any>null;
        data["valueType"] = this.valueType !== undefined ? this.valueType : <any>null;
        return data;
    }
}

export interface IClaim {
    issuer?: string;
    originalIssuer?: string;
    properties?: { [key: string]: string; };
    subject?: ClaimsIdentity | null;
    type?: string;
    value?: string;
    valueType?: string;
}

export class ClaimsIdentity implements IClaimsIdentity {
    authenticationType?: string | null;
    isAuthenticated?: boolean;
    actor?: ClaimsIdentity | null;
    bootstrapContext?: any | null;
    claims?: Claim[];
    label?: string | null;
    name?: string | null;
    nameClaimType?: string;
    roleClaimType?: string;

    constructor(data?: IClaimsIdentity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.authenticationType = _data["authenticationType"] !== undefined ? _data["authenticationType"] : <any>null;
            this.isAuthenticated = _data["isAuthenticated"] !== undefined ? _data["isAuthenticated"] : <any>null;
            this.actor = _data["actor"] ? ClaimsIdentity.fromJS(_data["actor"]) : <any>null;
            this.bootstrapContext = _data["bootstrapContext"] !== undefined ? _data["bootstrapContext"] : <any>null;
            if (Array.isArray(_data["claims"])) {
                this.claims = [] as any;
                for (let item of _data["claims"])
                    this.claims!.push(Claim.fromJS(item));
            }
            else {
                this.claims = <any>null;
            }
            this.label = _data["label"] !== undefined ? _data["label"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.nameClaimType = _data["nameClaimType"] !== undefined ? _data["nameClaimType"] : <any>null;
            this.roleClaimType = _data["roleClaimType"] !== undefined ? _data["roleClaimType"] : <any>null;
        }
    }

    static fromJS(data: any): ClaimsIdentity {
        data = typeof data === 'object' ? data : {};
        let result = new ClaimsIdentity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["authenticationType"] = this.authenticationType !== undefined ? this.authenticationType : <any>null;
        data["isAuthenticated"] = this.isAuthenticated !== undefined ? this.isAuthenticated : <any>null;
        data["actor"] = this.actor ? this.actor.toJSON() : <any>null;
        data["bootstrapContext"] = this.bootstrapContext !== undefined ? this.bootstrapContext : <any>null;
        if (Array.isArray(this.claims)) {
            data["claims"] = [];
            for (let item of this.claims)
                data["claims"].push(item.toJSON());
        }
        data["label"] = this.label !== undefined ? this.label : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["nameClaimType"] = this.nameClaimType !== undefined ? this.nameClaimType : <any>null;
        data["roleClaimType"] = this.roleClaimType !== undefined ? this.roleClaimType : <any>null;
        return data;
    }
}

export interface IClaimsIdentity {
    authenticationType?: string | null;
    isAuthenticated?: boolean;
    actor?: ClaimsIdentity | null;
    bootstrapContext?: any | null;
    claims?: Claim[];
    label?: string | null;
    name?: string | null;
    nameClaimType?: string;
    roleClaimType?: string;
}

export abstract class IIdentity implements IIIdentity {
    name?: string | null;
    authenticationType?: string | null;
    isAuthenticated?: boolean;

    constructor(data?: IIIdentity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.authenticationType = _data["authenticationType"] !== undefined ? _data["authenticationType"] : <any>null;
            this.isAuthenticated = _data["isAuthenticated"] !== undefined ? _data["isAuthenticated"] : <any>null;
        }
    }

    static fromJS(data: any): IIdentity {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'IIdentity' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["authenticationType"] = this.authenticationType !== undefined ? this.authenticationType : <any>null;
        data["isAuthenticated"] = this.isAuthenticated !== undefined ? this.isAuthenticated : <any>null;
        return data;
    }
}

export interface IIIdentity {
    name?: string | null;
    authenticationType?: string | null;
    isAuthenticated?: boolean;
}

export class AddToDoNotCallListCommand implements IAddToDoNotCallListCommand {
    phoneNumber?: string | null;
    userId?: string | null;

    constructor(data?: IAddToDoNotCallListCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.phoneNumber = _data["phoneNumber"] !== undefined ? _data["phoneNumber"] : <any>null;
            this.userId = _data["userId"] !== undefined ? _data["userId"] : <any>null;
        }
    }

    static fromJS(data: any): AddToDoNotCallListCommand {
        data = typeof data === 'object' ? data : {};
        let result = new AddToDoNotCallListCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["phoneNumber"] = this.phoneNumber !== undefined ? this.phoneNumber : <any>null;
        data["userId"] = this.userId !== undefined ? this.userId : <any>null;
        return data;
    }
}

export interface IAddToDoNotCallListCommand {
    phoneNumber?: string | null;
    userId?: string | null;
}

export class CalculateAppointmentRatingCommand implements ICalculateAppointmentRatingCommand {
    buysMeatAtButcher?: boolean | null;
    budgetRange?: BudgetRange | null;
    hasFreezer?: boolean | null;
    hasSpace?: boolean | null;
    freezerSize?: FreezerSize | null;
    freezerStockAmount?: FreezerStockAmount | null;
    visa?: boolean | null;
    mastercard?: boolean | null;
    americanExpress?: boolean | null;
    referredBy?: SalesRepDto | null;
    numberOfAdults?: number | null;
    numberOfKids?: number | null;
    lastName?: string | null;
    firstName?: string | null;
    conjointFirstName?: string | null;
    conjointLastName?: string | null;
    livingArrangement?: LivingArrangement | null;

    constructor(data?: ICalculateAppointmentRatingCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.buysMeatAtButcher = _data["buysMeatAtButcher"] !== undefined ? _data["buysMeatAtButcher"] : <any>null;
            this.budgetRange = _data["budgetRange"] !== undefined ? _data["budgetRange"] : <any>null;
            this.hasFreezer = _data["hasFreezer"] !== undefined ? _data["hasFreezer"] : <any>null;
            this.hasSpace = _data["hasSpace"] !== undefined ? _data["hasSpace"] : <any>null;
            this.freezerSize = _data["freezerSize"] !== undefined ? _data["freezerSize"] : <any>null;
            this.freezerStockAmount = _data["freezerStockAmount"] !== undefined ? _data["freezerStockAmount"] : <any>null;
            this.visa = _data["visa"] !== undefined ? _data["visa"] : <any>null;
            this.mastercard = _data["mastercard"] !== undefined ? _data["mastercard"] : <any>null;
            this.americanExpress = _data["americanExpress"] !== undefined ? _data["americanExpress"] : <any>null;
            this.referredBy = _data["referredBy"] ? SalesRepDto.fromJS(_data["referredBy"]) : <any>null;
            this.numberOfAdults = _data["numberOfAdults"] !== undefined ? _data["numberOfAdults"] : <any>null;
            this.numberOfKids = _data["numberOfKids"] !== undefined ? _data["numberOfKids"] : <any>null;
            this.lastName = _data["lastName"] !== undefined ? _data["lastName"] : <any>null;
            this.firstName = _data["firstName"] !== undefined ? _data["firstName"] : <any>null;
            this.conjointFirstName = _data["conjointFirstName"] !== undefined ? _data["conjointFirstName"] : <any>null;
            this.conjointLastName = _data["conjointLastName"] !== undefined ? _data["conjointLastName"] : <any>null;
            this.livingArrangement = _data["livingArrangement"] !== undefined ? _data["livingArrangement"] : <any>null;
        }
    }

    static fromJS(data: any): CalculateAppointmentRatingCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CalculateAppointmentRatingCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["buysMeatAtButcher"] = this.buysMeatAtButcher !== undefined ? this.buysMeatAtButcher : <any>null;
        data["budgetRange"] = this.budgetRange !== undefined ? this.budgetRange : <any>null;
        data["hasFreezer"] = this.hasFreezer !== undefined ? this.hasFreezer : <any>null;
        data["hasSpace"] = this.hasSpace !== undefined ? this.hasSpace : <any>null;
        data["freezerSize"] = this.freezerSize !== undefined ? this.freezerSize : <any>null;
        data["freezerStockAmount"] = this.freezerStockAmount !== undefined ? this.freezerStockAmount : <any>null;
        data["visa"] = this.visa !== undefined ? this.visa : <any>null;
        data["mastercard"] = this.mastercard !== undefined ? this.mastercard : <any>null;
        data["americanExpress"] = this.americanExpress !== undefined ? this.americanExpress : <any>null;
        data["referredBy"] = this.referredBy ? this.referredBy.toJSON() : <any>null;
        data["numberOfAdults"] = this.numberOfAdults !== undefined ? this.numberOfAdults : <any>null;
        data["numberOfKids"] = this.numberOfKids !== undefined ? this.numberOfKids : <any>null;
        data["lastName"] = this.lastName !== undefined ? this.lastName : <any>null;
        data["firstName"] = this.firstName !== undefined ? this.firstName : <any>null;
        data["conjointFirstName"] = this.conjointFirstName !== undefined ? this.conjointFirstName : <any>null;
        data["conjointLastName"] = this.conjointLastName !== undefined ? this.conjointLastName : <any>null;
        data["livingArrangement"] = this.livingArrangement !== undefined ? this.livingArrangement : <any>null;
        return data;
    }
}

export interface ICalculateAppointmentRatingCommand {
    buysMeatAtButcher?: boolean | null;
    budgetRange?: BudgetRange | null;
    hasFreezer?: boolean | null;
    hasSpace?: boolean | null;
    freezerSize?: FreezerSize | null;
    freezerStockAmount?: FreezerStockAmount | null;
    visa?: boolean | null;
    mastercard?: boolean | null;
    americanExpress?: boolean | null;
    referredBy?: SalesRepDto | null;
    numberOfAdults?: number | null;
    numberOfKids?: number | null;
    lastName?: string | null;
    firstName?: string | null;
    conjointFirstName?: string | null;
    conjointLastName?: string | null;
    livingArrangement?: LivingArrangement | null;
}

export class CredentialsViewModel implements ICredentialsViewModel {
    userName?: string | null;
    password?: string | null;

    constructor(data?: ICredentialsViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userName = _data["userName"] !== undefined ? _data["userName"] : <any>null;
            this.password = _data["password"] !== undefined ? _data["password"] : <any>null;
        }
    }

    static fromJS(data: any): CredentialsViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new CredentialsViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userName"] = this.userName !== undefined ? this.userName : <any>null;
        data["password"] = this.password !== undefined ? this.password : <any>null;
        return data;
    }
}

export interface ICredentialsViewModel {
    userName?: string | null;
    password?: string | null;
}

export class BackgroundJobDto implements IBackgroundJobDto {
    id?: string | null;
    hangFireId?: string | null;
    itemsProcessed?: number;
    isComplete?: boolean;
    totalItemsToProcessed?: number;
    statusMessage?: string | null;

    constructor(data?: IBackgroundJobDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.hangFireId = _data["hangFireId"] !== undefined ? _data["hangFireId"] : <any>null;
            this.itemsProcessed = _data["itemsProcessed"] !== undefined ? _data["itemsProcessed"] : <any>null;
            this.isComplete = _data["isComplete"] !== undefined ? _data["isComplete"] : <any>null;
            this.totalItemsToProcessed = _data["totalItemsToProcessed"] !== undefined ? _data["totalItemsToProcessed"] : <any>null;
            this.statusMessage = _data["statusMessage"] !== undefined ? _data["statusMessage"] : <any>null;
        }
    }

    static fromJS(data: any): BackgroundJobDto {
        data = typeof data === 'object' ? data : {};
        let result = new BackgroundJobDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["hangFireId"] = this.hangFireId !== undefined ? this.hangFireId : <any>null;
        data["itemsProcessed"] = this.itemsProcessed !== undefined ? this.itemsProcessed : <any>null;
        data["isComplete"] = this.isComplete !== undefined ? this.isComplete : <any>null;
        data["totalItemsToProcessed"] = this.totalItemsToProcessed !== undefined ? this.totalItemsToProcessed : <any>null;
        data["statusMessage"] = this.statusMessage !== undefined ? this.statusMessage : <any>null;
        return data;
    }
}

export interface IBackgroundJobDto {
    id?: string | null;
    hangFireId?: string | null;
    itemsProcessed?: number;
    isComplete?: boolean;
    totalItemsToProcessed?: number;
    statusMessage?: string | null;
}

export class BaseResponseDto implements IBaseResponseDto {
    errors?: BaseServiceError[] | null;
    notifications?: BaseServiceNotification[] | null;
    hasError?: boolean;
    hasNotification?: boolean;
    isSuccessfull?: boolean;

    constructor(data?: IBaseResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(BaseServiceError.fromJS(item));
            }
            else {
                this.errors = <any>null;
            }
            if (Array.isArray(_data["notifications"])) {
                this.notifications = [] as any;
                for (let item of _data["notifications"])
                    this.notifications!.push(BaseServiceNotification.fromJS(item));
            }
            else {
                this.notifications = <any>null;
            }
            this.hasError = _data["hasError"] !== undefined ? _data["hasError"] : <any>null;
            this.hasNotification = _data["hasNotification"] !== undefined ? _data["hasNotification"] : <any>null;
            this.isSuccessfull = _data["isSuccessfull"] !== undefined ? _data["isSuccessfull"] : <any>null;
        }
    }

    static fromJS(data: any): BaseResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new BaseResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item.toJSON());
        }
        if (Array.isArray(this.notifications)) {
            data["notifications"] = [];
            for (let item of this.notifications)
                data["notifications"].push(item.toJSON());
        }
        data["hasError"] = this.hasError !== undefined ? this.hasError : <any>null;
        data["hasNotification"] = this.hasNotification !== undefined ? this.hasNotification : <any>null;
        data["isSuccessfull"] = this.isSuccessfull !== undefined ? this.isSuccessfull : <any>null;
        return data;
    }
}

export interface IBaseResponseDto {
    errors?: BaseServiceError[] | null;
    notifications?: BaseServiceNotification[] | null;
    hasError?: boolean;
    hasNotification?: boolean;
    isSuccessfull?: boolean;
}

export class ErpSalesOrderDto extends BaseResponseDto implements IErpSalesOrderDto {
    id?: string | null;
    rowNumber?: number;
    approved?: NullableBooleanValue | null;
    baseCurrencyID?: StringValue | null;
    billToAddressOverride?: NullableBooleanValue | null;
    billToContactOverride?: NullableBooleanValue | null;
    cashAccount?: any | null;
    controlTotal?: NullableDoubleValue | null;
    creditHold?: NullableBooleanValue | null;
    currencyID?: StringValue | null;
    currencyRate?: NullableDoubleValue | null;
    currencyRateTypeID?: any | null;
    customerID?: StringValue | null;
    customerOrder?: any | null;
    date?: NullableDateTimeValue | null;
    description?: any | null;
    destinationWarehouseID?: any | null;
    disableAutomaticDiscountUpdate?: NullableBooleanValue | null;
    effectiveDate?: NullableDateTimeValue | null;
    externalRef?: any | null;
    hold?: NullableBooleanValue | null;
    isTaxValid?: NullableBooleanValue | null;
    lastModified?: NullableDateTimeValue | null;
    locationID?: StringValue | null;
    orderedQty?: NullableDoubleValue | null;
    orderNbr?: StringValue | null;
    orderTotal?: NullableDoubleValue | null;
    orderType?: StringValue | null;
    paymentMethod?: any | null;
    paymentRef?: any | null;
    preferredWarehouseID?: any | null;
    reciprocalRate?: NullableDoubleValue | null;
    requestedOn?: NullableDateTimeValue | null;
    shipToAddressOverride?: NullableBooleanValue | null;
    shipToContactOverride?: NullableBooleanValue | null;
    shipVia?: any | null;
    status?: StringValue | null;
    taxTotal?: NullableDoubleValue | null;
    vatExemptTotal?: NullableDoubleValue | null;
    vatTaxableTotal?: NullableDoubleValue | null;
    custom?: ErpCustomDtoOfErpSalesOrderCustomDocumentDto | null;
    links?: Links | null;
    shipToAddress?: ErpAddressDto | null;
    details?: ErpSalesOrderDetailsDto[] | null;
    shipments?: ErpSalesOrderShipmentDto[] | null;

    constructor(data?: IErpSalesOrderDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.rowNumber = _data["rowNumber"] !== undefined ? _data["rowNumber"] : <any>null;
            this.approved = _data["approved"] ? NullableBooleanValue.fromJS(_data["approved"]) : <any>null;
            this.baseCurrencyID = _data["baseCurrencyID"] ? StringValue.fromJS(_data["baseCurrencyID"]) : <any>null;
            this.billToAddressOverride = _data["billToAddressOverride"] ? NullableBooleanValue.fromJS(_data["billToAddressOverride"]) : <any>null;
            this.billToContactOverride = _data["billToContactOverride"] ? NullableBooleanValue.fromJS(_data["billToContactOverride"]) : <any>null;
            this.cashAccount = _data["cashAccount"] !== undefined ? _data["cashAccount"] : <any>null;
            this.controlTotal = _data["controlTotal"] ? NullableDoubleValue.fromJS(_data["controlTotal"]) : <any>null;
            this.creditHold = _data["creditHold"] ? NullableBooleanValue.fromJS(_data["creditHold"]) : <any>null;
            this.currencyID = _data["currencyID"] ? StringValue.fromJS(_data["currencyID"]) : <any>null;
            this.currencyRate = _data["currencyRate"] ? NullableDoubleValue.fromJS(_data["currencyRate"]) : <any>null;
            this.currencyRateTypeID = _data["currencyRateTypeID"] !== undefined ? _data["currencyRateTypeID"] : <any>null;
            this.customerID = _data["customerID"] ? StringValue.fromJS(_data["customerID"]) : <any>null;
            this.customerOrder = _data["customerOrder"] !== undefined ? _data["customerOrder"] : <any>null;
            this.date = _data["date"] ? NullableDateTimeValue.fromJS(_data["date"]) : <any>null;
            this.description = _data["description"] !== undefined ? _data["description"] : <any>null;
            this.destinationWarehouseID = _data["destinationWarehouseID"] !== undefined ? _data["destinationWarehouseID"] : <any>null;
            this.disableAutomaticDiscountUpdate = _data["disableAutomaticDiscountUpdate"] ? NullableBooleanValue.fromJS(_data["disableAutomaticDiscountUpdate"]) : <any>null;
            this.effectiveDate = _data["effectiveDate"] ? NullableDateTimeValue.fromJS(_data["effectiveDate"]) : <any>null;
            this.externalRef = _data["externalRef"] !== undefined ? _data["externalRef"] : <any>null;
            this.hold = _data["hold"] ? NullableBooleanValue.fromJS(_data["hold"]) : <any>null;
            this.isTaxValid = _data["isTaxValid"] ? NullableBooleanValue.fromJS(_data["isTaxValid"]) : <any>null;
            this.lastModified = _data["lastModified"] ? NullableDateTimeValue.fromJS(_data["lastModified"]) : <any>null;
            this.locationID = _data["locationID"] ? StringValue.fromJS(_data["locationID"]) : <any>null;
            this.orderedQty = _data["orderedQty"] ? NullableDoubleValue.fromJS(_data["orderedQty"]) : <any>null;
            this.orderNbr = _data["orderNbr"] ? StringValue.fromJS(_data["orderNbr"]) : <any>null;
            this.orderTotal = _data["orderTotal"] ? NullableDoubleValue.fromJS(_data["orderTotal"]) : <any>null;
            this.orderType = _data["orderType"] ? StringValue.fromJS(_data["orderType"]) : <any>null;
            this.paymentMethod = _data["paymentMethod"] !== undefined ? _data["paymentMethod"] : <any>null;
            this.paymentRef = _data["paymentRef"] !== undefined ? _data["paymentRef"] : <any>null;
            this.preferredWarehouseID = _data["preferredWarehouseID"] !== undefined ? _data["preferredWarehouseID"] : <any>null;
            this.reciprocalRate = _data["reciprocalRate"] ? NullableDoubleValue.fromJS(_data["reciprocalRate"]) : <any>null;
            this.requestedOn = _data["requestedOn"] ? NullableDateTimeValue.fromJS(_data["requestedOn"]) : <any>null;
            this.shipToAddressOverride = _data["shipToAddressOverride"] ? NullableBooleanValue.fromJS(_data["shipToAddressOverride"]) : <any>null;
            this.shipToContactOverride = _data["shipToContactOverride"] ? NullableBooleanValue.fromJS(_data["shipToContactOverride"]) : <any>null;
            this.shipVia = _data["shipVia"] !== undefined ? _data["shipVia"] : <any>null;
            this.status = _data["status"] ? StringValue.fromJS(_data["status"]) : <any>null;
            this.taxTotal = _data["taxTotal"] ? NullableDoubleValue.fromJS(_data["taxTotal"]) : <any>null;
            this.vatExemptTotal = _data["vatExemptTotal"] ? NullableDoubleValue.fromJS(_data["vatExemptTotal"]) : <any>null;
            this.vatTaxableTotal = _data["vatTaxableTotal"] ? NullableDoubleValue.fromJS(_data["vatTaxableTotal"]) : <any>null;
            this.custom = _data["custom"] ? ErpCustomDtoOfErpSalesOrderCustomDocumentDto.fromJS(_data["custom"]) : <any>null;
            this.links = _data["links"] ? Links.fromJS(_data["links"]) : <any>null;
            this.shipToAddress = _data["shipToAddress"] ? ErpAddressDto.fromJS(_data["shipToAddress"]) : <any>null;
            if (Array.isArray(_data["details"])) {
                this.details = [] as any;
                for (let item of _data["details"])
                    this.details!.push(ErpSalesOrderDetailsDto.fromJS(item));
            }
            else {
                this.details = <any>null;
            }
            if (Array.isArray(_data["shipments"])) {
                this.shipments = [] as any;
                for (let item of _data["shipments"])
                    this.shipments!.push(ErpSalesOrderShipmentDto.fromJS(item));
            }
            else {
                this.shipments = <any>null;
            }
        }
    }

    static override fromJS(data: any): ErpSalesOrderDto {
        data = typeof data === 'object' ? data : {};
        let result = new ErpSalesOrderDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["rowNumber"] = this.rowNumber !== undefined ? this.rowNumber : <any>null;
        data["approved"] = this.approved ? this.approved.toJSON() : <any>null;
        data["baseCurrencyID"] = this.baseCurrencyID ? this.baseCurrencyID.toJSON() : <any>null;
        data["billToAddressOverride"] = this.billToAddressOverride ? this.billToAddressOverride.toJSON() : <any>null;
        data["billToContactOverride"] = this.billToContactOverride ? this.billToContactOverride.toJSON() : <any>null;
        data["cashAccount"] = this.cashAccount !== undefined ? this.cashAccount : <any>null;
        data["controlTotal"] = this.controlTotal ? this.controlTotal.toJSON() : <any>null;
        data["creditHold"] = this.creditHold ? this.creditHold.toJSON() : <any>null;
        data["currencyID"] = this.currencyID ? this.currencyID.toJSON() : <any>null;
        data["currencyRate"] = this.currencyRate ? this.currencyRate.toJSON() : <any>null;
        data["currencyRateTypeID"] = this.currencyRateTypeID !== undefined ? this.currencyRateTypeID : <any>null;
        data["customerID"] = this.customerID ? this.customerID.toJSON() : <any>null;
        data["customerOrder"] = this.customerOrder !== undefined ? this.customerOrder : <any>null;
        data["date"] = this.date ? this.date.toJSON() : <any>null;
        data["description"] = this.description !== undefined ? this.description : <any>null;
        data["destinationWarehouseID"] = this.destinationWarehouseID !== undefined ? this.destinationWarehouseID : <any>null;
        data["disableAutomaticDiscountUpdate"] = this.disableAutomaticDiscountUpdate ? this.disableAutomaticDiscountUpdate.toJSON() : <any>null;
        data["effectiveDate"] = this.effectiveDate ? this.effectiveDate.toJSON() : <any>null;
        data["externalRef"] = this.externalRef !== undefined ? this.externalRef : <any>null;
        data["hold"] = this.hold ? this.hold.toJSON() : <any>null;
        data["isTaxValid"] = this.isTaxValid ? this.isTaxValid.toJSON() : <any>null;
        data["lastModified"] = this.lastModified ? this.lastModified.toJSON() : <any>null;
        data["locationID"] = this.locationID ? this.locationID.toJSON() : <any>null;
        data["orderedQty"] = this.orderedQty ? this.orderedQty.toJSON() : <any>null;
        data["orderNbr"] = this.orderNbr ? this.orderNbr.toJSON() : <any>null;
        data["orderTotal"] = this.orderTotal ? this.orderTotal.toJSON() : <any>null;
        data["orderType"] = this.orderType ? this.orderType.toJSON() : <any>null;
        data["paymentMethod"] = this.paymentMethod !== undefined ? this.paymentMethod : <any>null;
        data["paymentRef"] = this.paymentRef !== undefined ? this.paymentRef : <any>null;
        data["preferredWarehouseID"] = this.preferredWarehouseID !== undefined ? this.preferredWarehouseID : <any>null;
        data["reciprocalRate"] = this.reciprocalRate ? this.reciprocalRate.toJSON() : <any>null;
        data["requestedOn"] = this.requestedOn ? this.requestedOn.toJSON() : <any>null;
        data["shipToAddressOverride"] = this.shipToAddressOverride ? this.shipToAddressOverride.toJSON() : <any>null;
        data["shipToContactOverride"] = this.shipToContactOverride ? this.shipToContactOverride.toJSON() : <any>null;
        data["shipVia"] = this.shipVia !== undefined ? this.shipVia : <any>null;
        data["status"] = this.status ? this.status.toJSON() : <any>null;
        data["taxTotal"] = this.taxTotal ? this.taxTotal.toJSON() : <any>null;
        data["vatExemptTotal"] = this.vatExemptTotal ? this.vatExemptTotal.toJSON() : <any>null;
        data["vatTaxableTotal"] = this.vatTaxableTotal ? this.vatTaxableTotal.toJSON() : <any>null;
        data["custom"] = this.custom ? this.custom.toJSON() : <any>null;
        data["links"] = this.links ? this.links.toJSON() : <any>null;
        data["shipToAddress"] = this.shipToAddress ? this.shipToAddress.toJSON() : <any>null;
        if (Array.isArray(this.details)) {
            data["details"] = [];
            for (let item of this.details)
                data["details"].push(item.toJSON());
        }
        if (Array.isArray(this.shipments)) {
            data["shipments"] = [];
            for (let item of this.shipments)
                data["shipments"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IErpSalesOrderDto extends IBaseResponseDto {
    id?: string | null;
    rowNumber?: number;
    approved?: NullableBooleanValue | null;
    baseCurrencyID?: StringValue | null;
    billToAddressOverride?: NullableBooleanValue | null;
    billToContactOverride?: NullableBooleanValue | null;
    cashAccount?: any | null;
    controlTotal?: NullableDoubleValue | null;
    creditHold?: NullableBooleanValue | null;
    currencyID?: StringValue | null;
    currencyRate?: NullableDoubleValue | null;
    currencyRateTypeID?: any | null;
    customerID?: StringValue | null;
    customerOrder?: any | null;
    date?: NullableDateTimeValue | null;
    description?: any | null;
    destinationWarehouseID?: any | null;
    disableAutomaticDiscountUpdate?: NullableBooleanValue | null;
    effectiveDate?: NullableDateTimeValue | null;
    externalRef?: any | null;
    hold?: NullableBooleanValue | null;
    isTaxValid?: NullableBooleanValue | null;
    lastModified?: NullableDateTimeValue | null;
    locationID?: StringValue | null;
    orderedQty?: NullableDoubleValue | null;
    orderNbr?: StringValue | null;
    orderTotal?: NullableDoubleValue | null;
    orderType?: StringValue | null;
    paymentMethod?: any | null;
    paymentRef?: any | null;
    preferredWarehouseID?: any | null;
    reciprocalRate?: NullableDoubleValue | null;
    requestedOn?: NullableDateTimeValue | null;
    shipToAddressOverride?: NullableBooleanValue | null;
    shipToContactOverride?: NullableBooleanValue | null;
    shipVia?: any | null;
    status?: StringValue | null;
    taxTotal?: NullableDoubleValue | null;
    vatExemptTotal?: NullableDoubleValue | null;
    vatTaxableTotal?: NullableDoubleValue | null;
    custom?: ErpCustomDtoOfErpSalesOrderCustomDocumentDto | null;
    links?: Links | null;
    shipToAddress?: ErpAddressDto | null;
    details?: ErpSalesOrderDetailsDto[] | null;
    shipments?: ErpSalesOrderShipmentDto[] | null;
}

export class NullableBooleanValue implements INullableBooleanValue {
    value?: boolean | null;

    constructor(data?: INullableBooleanValue) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"] !== undefined ? _data["value"] : <any>null;
        }
    }

    static fromJS(data: any): NullableBooleanValue {
        data = typeof data === 'object' ? data : {};
        let result = new NullableBooleanValue();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value !== undefined ? this.value : <any>null;
        return data;
    }
}

export interface INullableBooleanValue {
    value?: boolean | null;
}

export class StringValue implements IStringValue {
    value?: string | null;

    constructor(data?: IStringValue) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"] !== undefined ? _data["value"] : <any>null;
        }
    }

    static fromJS(data: any): StringValue {
        data = typeof data === 'object' ? data : {};
        let result = new StringValue();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value !== undefined ? this.value : <any>null;
        return data;
    }
}

export interface IStringValue {
    value?: string | null;
}

export class NullableDoubleValue implements INullableDoubleValue {
    value?: number | null;

    constructor(data?: INullableDoubleValue) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"] !== undefined ? _data["value"] : <any>null;
        }
    }

    static fromJS(data: any): NullableDoubleValue {
        data = typeof data === 'object' ? data : {};
        let result = new NullableDoubleValue();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value !== undefined ? this.value : <any>null;
        return data;
    }
}

export interface INullableDoubleValue {
    value?: number | null;
}

export class NullableDateTimeValue implements INullableDateTimeValue {
    value?: moment.Moment | null;

    constructor(data?: INullableDateTimeValue) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"] ? moment(_data["value"].toString()) : <any>null;
        }
    }

    static fromJS(data: any): NullableDateTimeValue {
        data = typeof data === 'object' ? data : {};
        let result = new NullableDateTimeValue();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value ? this.value.toISOString() : <any>null;
        return data;
    }
}

export interface INullableDateTimeValue {
    value?: moment.Moment | null;
}

export class ErpCustomDtoOfErpSalesOrderCustomDocumentDto implements IErpCustomDtoOfErpSalesOrderCustomDocumentDto {
    document?: ErpSalesOrderCustomDocumentDto | null;

    constructor(data?: IErpCustomDtoOfErpSalesOrderCustomDocumentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.document = _data["document"] ? ErpSalesOrderCustomDocumentDto.fromJS(_data["document"]) : <any>null;
        }
    }

    static fromJS(data: any): ErpCustomDtoOfErpSalesOrderCustomDocumentDto {
        data = typeof data === 'object' ? data : {};
        let result = new ErpCustomDtoOfErpSalesOrderCustomDocumentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["document"] = this.document ? this.document.toJSON() : <any>null;
        return data;
    }
}

export interface IErpCustomDtoOfErpSalesOrderCustomDocumentDto {
    document?: ErpSalesOrderCustomDocumentDto | null;
}

export class ErpSalesOrderCustomDocumentDto implements IErpSalesOrderCustomDocumentDto {
    usrSFDeliveryCounter?: NullableIntValue | null;
    usrSFPaymentFrequency?: StringValue | null;
    usrSFPaymentMethod?: StringValue | null;
    usrSFNumberOfPayments?: NullableIntValue | null;
    usrSFFirstPaymentDate?: NullableIntValue | null;
    usrSFSecondPaymentDate?: NullableIntValue | null;
    usrSFUseLastDayOfMonthForPayment?: NullableBooleanValue | null;
    usrSFPaymentStartDate?: NullableDateTimeValue | null;
    usrSFBlanketOrderNbr?: StringValue | null;
    usrSFNbreMonths?: NullableIntValue | null;
    usrSFRang?: NullableIntValue | null;
    usrSFTypeCommande?: StringValue | null;
    usrSFAssociatedSalesOrderNbr?: StringValue | null;
    usrSFAssociatedReturnOrderNbr?: StringValue | null;
    usrReasonOfRejectfield?: StringValue | null;
    usrDateofcreditapproval?: NullableDateTimeValue | null;
    usrSFRefTm?: NullableIntValue | null;
    usrSFNoVendeur?: NullableIntValue | null;
    usrSFAppointmentNumber?: NullableIntValue | null;
    usrSFControlTotal?: StringValue | null;
    attributeMENU?: StringValue | null;
    attributeWINBACK?: NullableBooleanValue | null;
    attributeORIGINE?: StringValue | null;
    usrSFLastModifiedBy?: StringValue | null;
    usrRouteId?: NullableIntValue | null;
    usrOptimoOrderStatus?: StringValue | null;
    usrSFStopNumber?: NullableIntValue | null;
    usrSFScheduleDate?: NullableDateTimeValue | null;
    usrSFScheduledTime?: StringValue | null;
    usrScheduledInMorning?: NullableBooleanValue | null;
    usrScheduledInAfternoon?: NullableBooleanValue | null;
    usrScheduledInEvening?: NullableBooleanValue | null;

    constructor(data?: IErpSalesOrderCustomDocumentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.usrSFDeliveryCounter = _data["usrSFDeliveryCounter"] ? NullableIntValue.fromJS(_data["usrSFDeliveryCounter"]) : <any>null;
            this.usrSFPaymentFrequency = _data["usrSFPaymentFrequency"] ? StringValue.fromJS(_data["usrSFPaymentFrequency"]) : <any>null;
            this.usrSFPaymentMethod = _data["usrSFPaymentMethod"] ? StringValue.fromJS(_data["usrSFPaymentMethod"]) : <any>null;
            this.usrSFNumberOfPayments = _data["usrSFNumberOfPayments"] ? NullableIntValue.fromJS(_data["usrSFNumberOfPayments"]) : <any>null;
            this.usrSFFirstPaymentDate = _data["usrSFFirstPaymentDate"] ? NullableIntValue.fromJS(_data["usrSFFirstPaymentDate"]) : <any>null;
            this.usrSFSecondPaymentDate = _data["usrSFSecondPaymentDate"] ? NullableIntValue.fromJS(_data["usrSFSecondPaymentDate"]) : <any>null;
            this.usrSFUseLastDayOfMonthForPayment = _data["usrSFUseLastDayOfMonthForPayment"] ? NullableBooleanValue.fromJS(_data["usrSFUseLastDayOfMonthForPayment"]) : <any>null;
            this.usrSFPaymentStartDate = _data["usrSFPaymentStartDate"] ? NullableDateTimeValue.fromJS(_data["usrSFPaymentStartDate"]) : <any>null;
            this.usrSFBlanketOrderNbr = _data["usrSFBlanketOrderNbr"] ? StringValue.fromJS(_data["usrSFBlanketOrderNbr"]) : <any>null;
            this.usrSFNbreMonths = _data["usrSFNbreMonths"] ? NullableIntValue.fromJS(_data["usrSFNbreMonths"]) : <any>null;
            this.usrSFRang = _data["usrSFRang"] ? NullableIntValue.fromJS(_data["usrSFRang"]) : <any>null;
            this.usrSFTypeCommande = _data["usrSFTypeCommande"] ? StringValue.fromJS(_data["usrSFTypeCommande"]) : <any>null;
            this.usrSFAssociatedSalesOrderNbr = _data["usrSFAssociatedSalesOrderNbr"] ? StringValue.fromJS(_data["usrSFAssociatedSalesOrderNbr"]) : <any>null;
            this.usrSFAssociatedReturnOrderNbr = _data["usrSFAssociatedReturnOrderNbr"] ? StringValue.fromJS(_data["usrSFAssociatedReturnOrderNbr"]) : <any>null;
            this.usrReasonOfRejectfield = _data["usrReasonOfRejectfield"] ? StringValue.fromJS(_data["usrReasonOfRejectfield"]) : <any>null;
            this.usrDateofcreditapproval = _data["usrDateofcreditapproval"] ? NullableDateTimeValue.fromJS(_data["usrDateofcreditapproval"]) : <any>null;
            this.usrSFRefTm = _data["usrSFRefTm"] ? NullableIntValue.fromJS(_data["usrSFRefTm"]) : <any>null;
            this.usrSFNoVendeur = _data["usrSFNoVendeur"] ? NullableIntValue.fromJS(_data["usrSFNoVendeur"]) : <any>null;
            this.usrSFAppointmentNumber = _data["usrSFAppointmentNumber"] ? NullableIntValue.fromJS(_data["usrSFAppointmentNumber"]) : <any>null;
            this.usrSFControlTotal = _data["usrSFControlTotal"] ? StringValue.fromJS(_data["usrSFControlTotal"]) : <any>null;
            this.attributeMENU = _data["attributeMENU"] ? StringValue.fromJS(_data["attributeMENU"]) : <any>null;
            this.attributeWINBACK = _data["attributeWINBACK"] ? NullableBooleanValue.fromJS(_data["attributeWINBACK"]) : <any>null;
            this.attributeORIGINE = _data["attributeORIGINE"] ? StringValue.fromJS(_data["attributeORIGINE"]) : <any>null;
            this.usrSFLastModifiedBy = _data["usrSFLastModifiedBy"] ? StringValue.fromJS(_data["usrSFLastModifiedBy"]) : <any>null;
            this.usrRouteId = _data["usrRouteId"] ? NullableIntValue.fromJS(_data["usrRouteId"]) : <any>null;
            this.usrOptimoOrderStatus = _data["usrOptimoOrderStatus"] ? StringValue.fromJS(_data["usrOptimoOrderStatus"]) : <any>null;
            this.usrSFStopNumber = _data["usrSFStopNumber"] ? NullableIntValue.fromJS(_data["usrSFStopNumber"]) : <any>null;
            this.usrSFScheduleDate = _data["usrSFScheduleDate"] ? NullableDateTimeValue.fromJS(_data["usrSFScheduleDate"]) : <any>null;
            this.usrSFScheduledTime = _data["usrSFScheduledTime"] ? StringValue.fromJS(_data["usrSFScheduledTime"]) : <any>null;
            this.usrScheduledInMorning = _data["usrScheduledInMorning"] ? NullableBooleanValue.fromJS(_data["usrScheduledInMorning"]) : <any>null;
            this.usrScheduledInAfternoon = _data["usrScheduledInAfternoon"] ? NullableBooleanValue.fromJS(_data["usrScheduledInAfternoon"]) : <any>null;
            this.usrScheduledInEvening = _data["usrScheduledInEvening"] ? NullableBooleanValue.fromJS(_data["usrScheduledInEvening"]) : <any>null;
        }
    }

    static fromJS(data: any): ErpSalesOrderCustomDocumentDto {
        data = typeof data === 'object' ? data : {};
        let result = new ErpSalesOrderCustomDocumentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["usrSFDeliveryCounter"] = this.usrSFDeliveryCounter ? this.usrSFDeliveryCounter.toJSON() : <any>null;
        data["usrSFPaymentFrequency"] = this.usrSFPaymentFrequency ? this.usrSFPaymentFrequency.toJSON() : <any>null;
        data["usrSFPaymentMethod"] = this.usrSFPaymentMethod ? this.usrSFPaymentMethod.toJSON() : <any>null;
        data["usrSFNumberOfPayments"] = this.usrSFNumberOfPayments ? this.usrSFNumberOfPayments.toJSON() : <any>null;
        data["usrSFFirstPaymentDate"] = this.usrSFFirstPaymentDate ? this.usrSFFirstPaymentDate.toJSON() : <any>null;
        data["usrSFSecondPaymentDate"] = this.usrSFSecondPaymentDate ? this.usrSFSecondPaymentDate.toJSON() : <any>null;
        data["usrSFUseLastDayOfMonthForPayment"] = this.usrSFUseLastDayOfMonthForPayment ? this.usrSFUseLastDayOfMonthForPayment.toJSON() : <any>null;
        data["usrSFPaymentStartDate"] = this.usrSFPaymentStartDate ? this.usrSFPaymentStartDate.toJSON() : <any>null;
        data["usrSFBlanketOrderNbr"] = this.usrSFBlanketOrderNbr ? this.usrSFBlanketOrderNbr.toJSON() : <any>null;
        data["usrSFNbreMonths"] = this.usrSFNbreMonths ? this.usrSFNbreMonths.toJSON() : <any>null;
        data["usrSFRang"] = this.usrSFRang ? this.usrSFRang.toJSON() : <any>null;
        data["usrSFTypeCommande"] = this.usrSFTypeCommande ? this.usrSFTypeCommande.toJSON() : <any>null;
        data["usrSFAssociatedSalesOrderNbr"] = this.usrSFAssociatedSalesOrderNbr ? this.usrSFAssociatedSalesOrderNbr.toJSON() : <any>null;
        data["usrSFAssociatedReturnOrderNbr"] = this.usrSFAssociatedReturnOrderNbr ? this.usrSFAssociatedReturnOrderNbr.toJSON() : <any>null;
        data["usrReasonOfRejectfield"] = this.usrReasonOfRejectfield ? this.usrReasonOfRejectfield.toJSON() : <any>null;
        data["usrDateofcreditapproval"] = this.usrDateofcreditapproval ? this.usrDateofcreditapproval.toJSON() : <any>null;
        data["usrSFRefTm"] = this.usrSFRefTm ? this.usrSFRefTm.toJSON() : <any>null;
        data["usrSFNoVendeur"] = this.usrSFNoVendeur ? this.usrSFNoVendeur.toJSON() : <any>null;
        data["usrSFAppointmentNumber"] = this.usrSFAppointmentNumber ? this.usrSFAppointmentNumber.toJSON() : <any>null;
        data["usrSFControlTotal"] = this.usrSFControlTotal ? this.usrSFControlTotal.toJSON() : <any>null;
        data["attributeMENU"] = this.attributeMENU ? this.attributeMENU.toJSON() : <any>null;
        data["attributeWINBACK"] = this.attributeWINBACK ? this.attributeWINBACK.toJSON() : <any>null;
        data["attributeORIGINE"] = this.attributeORIGINE ? this.attributeORIGINE.toJSON() : <any>null;
        data["usrSFLastModifiedBy"] = this.usrSFLastModifiedBy ? this.usrSFLastModifiedBy.toJSON() : <any>null;
        data["usrRouteId"] = this.usrRouteId ? this.usrRouteId.toJSON() : <any>null;
        data["usrOptimoOrderStatus"] = this.usrOptimoOrderStatus ? this.usrOptimoOrderStatus.toJSON() : <any>null;
        data["usrSFStopNumber"] = this.usrSFStopNumber ? this.usrSFStopNumber.toJSON() : <any>null;
        data["usrSFScheduleDate"] = this.usrSFScheduleDate ? this.usrSFScheduleDate.toJSON() : <any>null;
        data["usrSFScheduledTime"] = this.usrSFScheduledTime ? this.usrSFScheduledTime.toJSON() : <any>null;
        data["usrScheduledInMorning"] = this.usrScheduledInMorning ? this.usrScheduledInMorning.toJSON() : <any>null;
        data["usrScheduledInAfternoon"] = this.usrScheduledInAfternoon ? this.usrScheduledInAfternoon.toJSON() : <any>null;
        data["usrScheduledInEvening"] = this.usrScheduledInEvening ? this.usrScheduledInEvening.toJSON() : <any>null;
        return data;
    }
}

export interface IErpSalesOrderCustomDocumentDto {
    usrSFDeliveryCounter?: NullableIntValue | null;
    usrSFPaymentFrequency?: StringValue | null;
    usrSFPaymentMethod?: StringValue | null;
    usrSFNumberOfPayments?: NullableIntValue | null;
    usrSFFirstPaymentDate?: NullableIntValue | null;
    usrSFSecondPaymentDate?: NullableIntValue | null;
    usrSFUseLastDayOfMonthForPayment?: NullableBooleanValue | null;
    usrSFPaymentStartDate?: NullableDateTimeValue | null;
    usrSFBlanketOrderNbr?: StringValue | null;
    usrSFNbreMonths?: NullableIntValue | null;
    usrSFRang?: NullableIntValue | null;
    usrSFTypeCommande?: StringValue | null;
    usrSFAssociatedSalesOrderNbr?: StringValue | null;
    usrSFAssociatedReturnOrderNbr?: StringValue | null;
    usrReasonOfRejectfield?: StringValue | null;
    usrDateofcreditapproval?: NullableDateTimeValue | null;
    usrSFRefTm?: NullableIntValue | null;
    usrSFNoVendeur?: NullableIntValue | null;
    usrSFAppointmentNumber?: NullableIntValue | null;
    usrSFControlTotal?: StringValue | null;
    attributeMENU?: StringValue | null;
    attributeWINBACK?: NullableBooleanValue | null;
    attributeORIGINE?: StringValue | null;
    usrSFLastModifiedBy?: StringValue | null;
    usrRouteId?: NullableIntValue | null;
    usrOptimoOrderStatus?: StringValue | null;
    usrSFStopNumber?: NullableIntValue | null;
    usrSFScheduleDate?: NullableDateTimeValue | null;
    usrSFScheduledTime?: StringValue | null;
    usrScheduledInMorning?: NullableBooleanValue | null;
    usrScheduledInAfternoon?: NullableBooleanValue | null;
    usrScheduledInEvening?: NullableBooleanValue | null;
}

export class NullableIntValue implements INullableIntValue {
    value?: number | null;

    constructor(data?: INullableIntValue) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"] !== undefined ? _data["value"] : <any>null;
        }
    }

    static fromJS(data: any): NullableIntValue {
        data = typeof data === 'object' ? data : {};
        let result = new NullableIntValue();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value !== undefined ? this.value : <any>null;
        return data;
    }
}

export interface INullableIntValue {
    value?: number | null;
}

export class Links implements ILinks {
    self?: string | null;
    filesPut?: string | null;

    constructor(data?: ILinks) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.self = _data["self"] !== undefined ? _data["self"] : <any>null;
            this.filesPut = _data["filesPut"] !== undefined ? _data["filesPut"] : <any>null;
        }
    }

    static fromJS(data: any): Links {
        data = typeof data === 'object' ? data : {};
        let result = new Links();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["self"] = this.self !== undefined ? this.self : <any>null;
        data["filesPut"] = this.filesPut !== undefined ? this.filesPut : <any>null;
        return data;
    }
}

export interface ILinks {
    self?: string | null;
    filesPut?: string | null;
}

export class ErpAddressDto implements IErpAddressDto {
    addressLine1?: StringValue | null;
    addressLine2?: StringValue | null;
    city?: StringValue | null;
    country?: StringValue | null;
    postalCode?: StringValue | null;
    state?: StringValue | null;

    constructor(data?: IErpAddressDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.addressLine1 = _data["addressLine1"] ? StringValue.fromJS(_data["addressLine1"]) : <any>null;
            this.addressLine2 = _data["addressLine2"] ? StringValue.fromJS(_data["addressLine2"]) : <any>null;
            this.city = _data["city"] ? StringValue.fromJS(_data["city"]) : <any>null;
            this.country = _data["country"] ? StringValue.fromJS(_data["country"]) : <any>null;
            this.postalCode = _data["postalCode"] ? StringValue.fromJS(_data["postalCode"]) : <any>null;
            this.state = _data["state"] ? StringValue.fromJS(_data["state"]) : <any>null;
        }
    }

    static fromJS(data: any): ErpAddressDto {
        data = typeof data === 'object' ? data : {};
        let result = new ErpAddressDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["addressLine1"] = this.addressLine1 ? this.addressLine1.toJSON() : <any>null;
        data["addressLine2"] = this.addressLine2 ? this.addressLine2.toJSON() : <any>null;
        data["city"] = this.city ? this.city.toJSON() : <any>null;
        data["country"] = this.country ? this.country.toJSON() : <any>null;
        data["postalCode"] = this.postalCode ? this.postalCode.toJSON() : <any>null;
        data["state"] = this.state ? this.state.toJSON() : <any>null;
        return data;
    }
}

export interface IErpAddressDto {
    addressLine1?: StringValue | null;
    addressLine2?: StringValue | null;
    city?: StringValue | null;
    country?: StringValue | null;
    postalCode?: StringValue | null;
    state?: StringValue | null;
}

export class ErpSalesOrderDetailsDto implements IErpSalesOrderDetailsDto {
    id?: string | null;
    rowNumber?: number;
    account?: StringValue | null;
    alternateID?: any | null;
    autoCreateIssue?: BooleanValue | null;
    averageCost?: NullableDoubleValue | null;
    branch?: StringValue | null;
    calculateDiscountsOnImport?: any | null;
    commissionable?: BooleanValue | null;
    completed?: BooleanValue | null;
    discountAmount?: NullableDecimalValue | null;
    discountCode?: any | null;
    discountedUnitPrice?: NullableDecimalValue | null;
    discountPercent?: NullableDecimalValue | null;
    extendedPrice?: NullableDecimalValue | null;
    freeItem?: BooleanValue | null;
    inventoryID?: StringValue | null;
    lastModifiedDate?: StringValue | null;
    lineDescription?: StringValue | null;
    lineNbr?: IntValue | null;
    lineType?: StringValue | null;
    location?: any | null;
    manualDiscount?: BooleanValue | null;
    markForPO?: BooleanValue | null;
    openQty?: NullableDoubleValue | null;
    operation?: StringValue | null;
    orderQty?: NullableDoubleValue | null;
    overshipThreshold?: NullableDecimalValue | null;
    poSource?: any | null;
    qtyOnShipments?: NullableDoubleValue | null;
    reasonCode?: any | null;
    requestedOn?: DateTimeValue | null;
    salespersonID?: any | null;
    shipOn?: DateTimeValue | null;
    shippingRule?: StringValue | null;
    taxCategory?: StringValue | null;
    unbilledAmount?: NullableDecimalValue | null;
    undershipThreshold?: NullableDecimalValue | null;
    unitCost?: NullableDoubleValue | null;
    unitPrice?: NullableDecimalValue | null;
    uom?: StringValue | null;
    warehouseID?: StringValue | null;
    orderNbr?: StringValue | null;
    amount?: NullableDoubleValue | null;
    custom?: ErpCustomTransactionsDtoOfErpStockItemCustomDocumentDto | null;

    constructor(data?: IErpSalesOrderDetailsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.rowNumber = _data["rowNumber"] !== undefined ? _data["rowNumber"] : <any>null;
            this.account = _data["account"] ? StringValue.fromJS(_data["account"]) : <any>null;
            this.alternateID = _data["alternateID"] !== undefined ? _data["alternateID"] : <any>null;
            this.autoCreateIssue = _data["autoCreateIssue"] ? BooleanValue.fromJS(_data["autoCreateIssue"]) : <any>null;
            this.averageCost = _data["averageCost"] ? NullableDoubleValue.fromJS(_data["averageCost"]) : <any>null;
            this.branch = _data["branch"] ? StringValue.fromJS(_data["branch"]) : <any>null;
            this.calculateDiscountsOnImport = _data["calculateDiscountsOnImport"] !== undefined ? _data["calculateDiscountsOnImport"] : <any>null;
            this.commissionable = _data["commissionable"] ? BooleanValue.fromJS(_data["commissionable"]) : <any>null;
            this.completed = _data["completed"] ? BooleanValue.fromJS(_data["completed"]) : <any>null;
            this.discountAmount = _data["discountAmount"] ? NullableDecimalValue.fromJS(_data["discountAmount"]) : <any>null;
            this.discountCode = _data["discountCode"] !== undefined ? _data["discountCode"] : <any>null;
            this.discountedUnitPrice = _data["discountedUnitPrice"] ? NullableDecimalValue.fromJS(_data["discountedUnitPrice"]) : <any>null;
            this.discountPercent = _data["discountPercent"] ? NullableDecimalValue.fromJS(_data["discountPercent"]) : <any>null;
            this.extendedPrice = _data["extendedPrice"] ? NullableDecimalValue.fromJS(_data["extendedPrice"]) : <any>null;
            this.freeItem = _data["freeItem"] ? BooleanValue.fromJS(_data["freeItem"]) : <any>null;
            this.inventoryID = _data["inventoryID"] ? StringValue.fromJS(_data["inventoryID"]) : <any>null;
            this.lastModifiedDate = _data["lastModifiedDate"] ? StringValue.fromJS(_data["lastModifiedDate"]) : <any>null;
            this.lineDescription = _data["lineDescription"] ? StringValue.fromJS(_data["lineDescription"]) : <any>null;
            this.lineNbr = _data["lineNbr"] ? IntValue.fromJS(_data["lineNbr"]) : <any>null;
            this.lineType = _data["lineType"] ? StringValue.fromJS(_data["lineType"]) : <any>null;
            this.location = _data["location"] !== undefined ? _data["location"] : <any>null;
            this.manualDiscount = _data["manualDiscount"] ? BooleanValue.fromJS(_data["manualDiscount"]) : <any>null;
            this.markForPO = _data["markForPO"] ? BooleanValue.fromJS(_data["markForPO"]) : <any>null;
            this.openQty = _data["openQty"] ? NullableDoubleValue.fromJS(_data["openQty"]) : <any>null;
            this.operation = _data["operation"] ? StringValue.fromJS(_data["operation"]) : <any>null;
            this.orderQty = _data["orderQty"] ? NullableDoubleValue.fromJS(_data["orderQty"]) : <any>null;
            this.overshipThreshold = _data["overshipThreshold"] ? NullableDecimalValue.fromJS(_data["overshipThreshold"]) : <any>null;
            this.poSource = _data["poSource"] !== undefined ? _data["poSource"] : <any>null;
            this.qtyOnShipments = _data["qtyOnShipments"] ? NullableDoubleValue.fromJS(_data["qtyOnShipments"]) : <any>null;
            this.reasonCode = _data["reasonCode"] !== undefined ? _data["reasonCode"] : <any>null;
            this.requestedOn = _data["requestedOn"] ? DateTimeValue.fromJS(_data["requestedOn"]) : <any>null;
            this.salespersonID = _data["salespersonID"] !== undefined ? _data["salespersonID"] : <any>null;
            this.shipOn = _data["shipOn"] ? DateTimeValue.fromJS(_data["shipOn"]) : <any>null;
            this.shippingRule = _data["shippingRule"] ? StringValue.fromJS(_data["shippingRule"]) : <any>null;
            this.taxCategory = _data["taxCategory"] ? StringValue.fromJS(_data["taxCategory"]) : <any>null;
            this.unbilledAmount = _data["unbilledAmount"] ? NullableDecimalValue.fromJS(_data["unbilledAmount"]) : <any>null;
            this.undershipThreshold = _data["undershipThreshold"] ? NullableDecimalValue.fromJS(_data["undershipThreshold"]) : <any>null;
            this.unitCost = _data["unitCost"] ? NullableDoubleValue.fromJS(_data["unitCost"]) : <any>null;
            this.unitPrice = _data["unitPrice"] ? NullableDecimalValue.fromJS(_data["unitPrice"]) : <any>null;
            this.uom = _data["uom"] ? StringValue.fromJS(_data["uom"]) : <any>null;
            this.warehouseID = _data["warehouseID"] ? StringValue.fromJS(_data["warehouseID"]) : <any>null;
            this.orderNbr = _data["orderNbr"] ? StringValue.fromJS(_data["orderNbr"]) : <any>null;
            this.amount = _data["amount"] ? NullableDoubleValue.fromJS(_data["amount"]) : <any>null;
            this.custom = _data["custom"] ? ErpCustomTransactionsDtoOfErpStockItemCustomDocumentDto.fromJS(_data["custom"]) : <any>null;
        }
    }

    static fromJS(data: any): ErpSalesOrderDetailsDto {
        data = typeof data === 'object' ? data : {};
        let result = new ErpSalesOrderDetailsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["rowNumber"] = this.rowNumber !== undefined ? this.rowNumber : <any>null;
        data["account"] = this.account ? this.account.toJSON() : <any>null;
        data["alternateID"] = this.alternateID !== undefined ? this.alternateID : <any>null;
        data["autoCreateIssue"] = this.autoCreateIssue ? this.autoCreateIssue.toJSON() : <any>null;
        data["averageCost"] = this.averageCost ? this.averageCost.toJSON() : <any>null;
        data["branch"] = this.branch ? this.branch.toJSON() : <any>null;
        data["calculateDiscountsOnImport"] = this.calculateDiscountsOnImport !== undefined ? this.calculateDiscountsOnImport : <any>null;
        data["commissionable"] = this.commissionable ? this.commissionable.toJSON() : <any>null;
        data["completed"] = this.completed ? this.completed.toJSON() : <any>null;
        data["discountAmount"] = this.discountAmount ? this.discountAmount.toJSON() : <any>null;
        data["discountCode"] = this.discountCode !== undefined ? this.discountCode : <any>null;
        data["discountedUnitPrice"] = this.discountedUnitPrice ? this.discountedUnitPrice.toJSON() : <any>null;
        data["discountPercent"] = this.discountPercent ? this.discountPercent.toJSON() : <any>null;
        data["extendedPrice"] = this.extendedPrice ? this.extendedPrice.toJSON() : <any>null;
        data["freeItem"] = this.freeItem ? this.freeItem.toJSON() : <any>null;
        data["inventoryID"] = this.inventoryID ? this.inventoryID.toJSON() : <any>null;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toJSON() : <any>null;
        data["lineDescription"] = this.lineDescription ? this.lineDescription.toJSON() : <any>null;
        data["lineNbr"] = this.lineNbr ? this.lineNbr.toJSON() : <any>null;
        data["lineType"] = this.lineType ? this.lineType.toJSON() : <any>null;
        data["location"] = this.location !== undefined ? this.location : <any>null;
        data["manualDiscount"] = this.manualDiscount ? this.manualDiscount.toJSON() : <any>null;
        data["markForPO"] = this.markForPO ? this.markForPO.toJSON() : <any>null;
        data["openQty"] = this.openQty ? this.openQty.toJSON() : <any>null;
        data["operation"] = this.operation ? this.operation.toJSON() : <any>null;
        data["orderQty"] = this.orderQty ? this.orderQty.toJSON() : <any>null;
        data["overshipThreshold"] = this.overshipThreshold ? this.overshipThreshold.toJSON() : <any>null;
        data["poSource"] = this.poSource !== undefined ? this.poSource : <any>null;
        data["qtyOnShipments"] = this.qtyOnShipments ? this.qtyOnShipments.toJSON() : <any>null;
        data["reasonCode"] = this.reasonCode !== undefined ? this.reasonCode : <any>null;
        data["requestedOn"] = this.requestedOn ? this.requestedOn.toJSON() : <any>null;
        data["salespersonID"] = this.salespersonID !== undefined ? this.salespersonID : <any>null;
        data["shipOn"] = this.shipOn ? this.shipOn.toJSON() : <any>null;
        data["shippingRule"] = this.shippingRule ? this.shippingRule.toJSON() : <any>null;
        data["taxCategory"] = this.taxCategory ? this.taxCategory.toJSON() : <any>null;
        data["unbilledAmount"] = this.unbilledAmount ? this.unbilledAmount.toJSON() : <any>null;
        data["undershipThreshold"] = this.undershipThreshold ? this.undershipThreshold.toJSON() : <any>null;
        data["unitCost"] = this.unitCost ? this.unitCost.toJSON() : <any>null;
        data["unitPrice"] = this.unitPrice ? this.unitPrice.toJSON() : <any>null;
        data["uom"] = this.uom ? this.uom.toJSON() : <any>null;
        data["warehouseID"] = this.warehouseID ? this.warehouseID.toJSON() : <any>null;
        data["orderNbr"] = this.orderNbr ? this.orderNbr.toJSON() : <any>null;
        data["amount"] = this.amount ? this.amount.toJSON() : <any>null;
        data["custom"] = this.custom ? this.custom.toJSON() : <any>null;
        return data;
    }
}

export interface IErpSalesOrderDetailsDto {
    id?: string | null;
    rowNumber?: number;
    account?: StringValue | null;
    alternateID?: any | null;
    autoCreateIssue?: BooleanValue | null;
    averageCost?: NullableDoubleValue | null;
    branch?: StringValue | null;
    calculateDiscountsOnImport?: any | null;
    commissionable?: BooleanValue | null;
    completed?: BooleanValue | null;
    discountAmount?: NullableDecimalValue | null;
    discountCode?: any | null;
    discountedUnitPrice?: NullableDecimalValue | null;
    discountPercent?: NullableDecimalValue | null;
    extendedPrice?: NullableDecimalValue | null;
    freeItem?: BooleanValue | null;
    inventoryID?: StringValue | null;
    lastModifiedDate?: StringValue | null;
    lineDescription?: StringValue | null;
    lineNbr?: IntValue | null;
    lineType?: StringValue | null;
    location?: any | null;
    manualDiscount?: BooleanValue | null;
    markForPO?: BooleanValue | null;
    openQty?: NullableDoubleValue | null;
    operation?: StringValue | null;
    orderQty?: NullableDoubleValue | null;
    overshipThreshold?: NullableDecimalValue | null;
    poSource?: any | null;
    qtyOnShipments?: NullableDoubleValue | null;
    reasonCode?: any | null;
    requestedOn?: DateTimeValue | null;
    salespersonID?: any | null;
    shipOn?: DateTimeValue | null;
    shippingRule?: StringValue | null;
    taxCategory?: StringValue | null;
    unbilledAmount?: NullableDecimalValue | null;
    undershipThreshold?: NullableDecimalValue | null;
    unitCost?: NullableDoubleValue | null;
    unitPrice?: NullableDecimalValue | null;
    uom?: StringValue | null;
    warehouseID?: StringValue | null;
    orderNbr?: StringValue | null;
    amount?: NullableDoubleValue | null;
    custom?: ErpCustomTransactionsDtoOfErpStockItemCustomDocumentDto | null;
}

export class BooleanValue implements IBooleanValue {
    value?: boolean;

    constructor(data?: IBooleanValue) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"] !== undefined ? _data["value"] : <any>null;
        }
    }

    static fromJS(data: any): BooleanValue {
        data = typeof data === 'object' ? data : {};
        let result = new BooleanValue();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value !== undefined ? this.value : <any>null;
        return data;
    }
}

export interface IBooleanValue {
    value?: boolean;
}

export class NullableDecimalValue implements INullableDecimalValue {
    value?: number | null;

    constructor(data?: INullableDecimalValue) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"] !== undefined ? _data["value"] : <any>null;
        }
    }

    static fromJS(data: any): NullableDecimalValue {
        data = typeof data === 'object' ? data : {};
        let result = new NullableDecimalValue();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value !== undefined ? this.value : <any>null;
        return data;
    }
}

export interface INullableDecimalValue {
    value?: number | null;
}

export class IntValue implements IIntValue {
    value?: number;

    constructor(data?: IIntValue) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"] !== undefined ? _data["value"] : <any>null;
        }
    }

    static fromJS(data: any): IntValue {
        data = typeof data === 'object' ? data : {};
        let result = new IntValue();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value !== undefined ? this.value : <any>null;
        return data;
    }
}

export interface IIntValue {
    value?: number;
}

export class DateTimeValue implements IDateTimeValue {
    value?: moment.Moment;

    constructor(data?: IDateTimeValue) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"] ? moment(_data["value"].toString()) : <any>null;
        }
    }

    static fromJS(data: any): DateTimeValue {
        data = typeof data === 'object' ? data : {};
        let result = new DateTimeValue();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value ? this.value.toISOString() : <any>null;
        return data;
    }
}

export interface IDateTimeValue {
    value?: moment.Moment;
}

export class ErpCustomTransactionsDtoOfErpStockItemCustomDocumentDto implements IErpCustomTransactionsDtoOfErpStockItemCustomDocumentDto {
    transactions?: ErpStockItemCustomDocumentDto | null;

    constructor(data?: IErpCustomTransactionsDtoOfErpStockItemCustomDocumentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.transactions = _data["transactions"] ? ErpStockItemCustomDocumentDto.fromJS(_data["transactions"]) : <any>null;
        }
    }

    static fromJS(data: any): ErpCustomTransactionsDtoOfErpStockItemCustomDocumentDto {
        data = typeof data === 'object' ? data : {};
        let result = new ErpCustomTransactionsDtoOfErpStockItemCustomDocumentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["transactions"] = this.transactions ? this.transactions.toJSON() : <any>null;
        return data;
    }
}

export interface IErpCustomTransactionsDtoOfErpStockItemCustomDocumentDto {
    transactions?: ErpStockItemCustomDocumentDto | null;
}

export class ErpStockItemCustomDocumentDto implements IErpStockItemCustomDocumentDto {
    usrSFReturnOrReplacement?: StringValue | null;
    usrSFReturnReason?: StringValue | null;
    usrSFIsAdjustment?: NullableBooleanValue | null;
    usrSFAdjustmentForInventoryID?: StringValue | null;

    constructor(data?: IErpStockItemCustomDocumentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.usrSFReturnOrReplacement = _data["usrSFReturnOrReplacement"] ? StringValue.fromJS(_data["usrSFReturnOrReplacement"]) : <any>null;
            this.usrSFReturnReason = _data["usrSFReturnReason"] ? StringValue.fromJS(_data["usrSFReturnReason"]) : <any>null;
            this.usrSFIsAdjustment = _data["usrSFIsAdjustment"] ? NullableBooleanValue.fromJS(_data["usrSFIsAdjustment"]) : <any>null;
            this.usrSFAdjustmentForInventoryID = _data["usrSFAdjustmentForInventoryID"] ? StringValue.fromJS(_data["usrSFAdjustmentForInventoryID"]) : <any>null;
        }
    }

    static fromJS(data: any): ErpStockItemCustomDocumentDto {
        data = typeof data === 'object' ? data : {};
        let result = new ErpStockItemCustomDocumentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["usrSFReturnOrReplacement"] = this.usrSFReturnOrReplacement ? this.usrSFReturnOrReplacement.toJSON() : <any>null;
        data["usrSFReturnReason"] = this.usrSFReturnReason ? this.usrSFReturnReason.toJSON() : <any>null;
        data["usrSFIsAdjustment"] = this.usrSFIsAdjustment ? this.usrSFIsAdjustment.toJSON() : <any>null;
        data["usrSFAdjustmentForInventoryID"] = this.usrSFAdjustmentForInventoryID ? this.usrSFAdjustmentForInventoryID.toJSON() : <any>null;
        return data;
    }
}

export interface IErpStockItemCustomDocumentDto {
    usrSFReturnOrReplacement?: StringValue | null;
    usrSFReturnReason?: StringValue | null;
    usrSFIsAdjustment?: NullableBooleanValue | null;
    usrSFAdjustmentForInventoryID?: StringValue | null;
}

export class ErpSalesOrderShipmentDto implements IErpSalesOrderShipmentDto {
    shipmentNbr?: StringValue | null;
    invoiceType?: StringValue | null;
    invoiceNbr?: StringValue | null;
    status?: StringValue | null;

    constructor(data?: IErpSalesOrderShipmentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.shipmentNbr = _data["shipmentNbr"] ? StringValue.fromJS(_data["shipmentNbr"]) : <any>null;
            this.invoiceType = _data["invoiceType"] ? StringValue.fromJS(_data["invoiceType"]) : <any>null;
            this.invoiceNbr = _data["invoiceNbr"] ? StringValue.fromJS(_data["invoiceNbr"]) : <any>null;
            this.status = _data["status"] ? StringValue.fromJS(_data["status"]) : <any>null;
        }
    }

    static fromJS(data: any): ErpSalesOrderShipmentDto {
        data = typeof data === 'object' ? data : {};
        let result = new ErpSalesOrderShipmentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["shipmentNbr"] = this.shipmentNbr ? this.shipmentNbr.toJSON() : <any>null;
        data["invoiceType"] = this.invoiceType ? this.invoiceType.toJSON() : <any>null;
        data["invoiceNbr"] = this.invoiceNbr ? this.invoiceNbr.toJSON() : <any>null;
        data["status"] = this.status ? this.status.toJSON() : <any>null;
        return data;
    }
}

export interface IErpSalesOrderShipmentDto {
    shipmentNbr?: StringValue | null;
    invoiceType?: StringValue | null;
    invoiceNbr?: StringValue | null;
    status?: StringValue | null;
}

export class BaseServiceError implements IBaseServiceError {
    message?: string | null;
    code?: number;
    errorType?: ErrorTypeEnum;
    stackTrace?: string | null;
    additionalInformation?: string | null;

    constructor(data?: IBaseServiceError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.message = _data["message"] !== undefined ? _data["message"] : <any>null;
            this.code = _data["code"] !== undefined ? _data["code"] : <any>null;
            this.errorType = _data["errorType"] !== undefined ? _data["errorType"] : <any>null;
            this.stackTrace = _data["stackTrace"] !== undefined ? _data["stackTrace"] : <any>null;
            this.additionalInformation = _data["additionalInformation"] !== undefined ? _data["additionalInformation"] : <any>null;
        }
    }

    static fromJS(data: any): BaseServiceError {
        data = typeof data === 'object' ? data : {};
        let result = new BaseServiceError();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["message"] = this.message !== undefined ? this.message : <any>null;
        data["code"] = this.code !== undefined ? this.code : <any>null;
        data["errorType"] = this.errorType !== undefined ? this.errorType : <any>null;
        data["stackTrace"] = this.stackTrace !== undefined ? this.stackTrace : <any>null;
        data["additionalInformation"] = this.additionalInformation !== undefined ? this.additionalInformation : <any>null;
        return data;
    }
}

export interface IBaseServiceError {
    message?: string | null;
    code?: number;
    errorType?: ErrorTypeEnum;
    stackTrace?: string | null;
    additionalInformation?: string | null;
}

export enum ErrorTypeEnum {
    NotSet = "notSet",
    Unhandled = "unhandled",
    Security = "security",
    Datasource = "datasource",
    DataIntegrity = "dataIntegrity",
    Service = "service",
    Interface = "interface",
}

export class BaseServiceNotification implements IBaseServiceNotification {
    message?: string | null;
    code?: number;
    notificationType?: NotificationTypeEnum;
    additionalInformation?: string | null;

    constructor(data?: IBaseServiceNotification) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.message = _data["message"] !== undefined ? _data["message"] : <any>null;
            this.code = _data["code"] !== undefined ? _data["code"] : <any>null;
            this.notificationType = _data["notificationType"] !== undefined ? _data["notificationType"] : <any>null;
            this.additionalInformation = _data["additionalInformation"] !== undefined ? _data["additionalInformation"] : <any>null;
        }
    }

    static fromJS(data: any): BaseServiceNotification {
        data = typeof data === 'object' ? data : {};
        let result = new BaseServiceNotification();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["message"] = this.message !== undefined ? this.message : <any>null;
        data["code"] = this.code !== undefined ? this.code : <any>null;
        data["notificationType"] = this.notificationType !== undefined ? this.notificationType : <any>null;
        data["additionalInformation"] = this.additionalInformation !== undefined ? this.additionalInformation : <any>null;
        return data;
    }
}

export interface IBaseServiceNotification {
    message?: string | null;
    code?: number;
    notificationType?: NotificationTypeEnum;
    additionalInformation?: string | null;
}

export enum NotificationTypeEnum {
    NotSet = "notSet",
    System = "system",
    Warning = "warning",
    Error = "error",
    Information = "information",
}

export class GetBlanketOrdersQuery implements IGetBlanketOrdersQuery {
    startDate?: moment.Moment;
    endDate?: moment.Moment;

    constructor(data?: IGetBlanketOrdersQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.startDate = _data["startDate"] ? moment(_data["startDate"].toString()) : <any>null;
            this.endDate = _data["endDate"] ? moment(_data["endDate"].toString()) : <any>null;
        }
    }

    static fromJS(data: any): GetBlanketOrdersQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetBlanketOrdersQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>null;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>null;
        return data;
    }
}

export interface IGetBlanketOrdersQuery {
    startDate?: moment.Moment;
    endDate?: moment.Moment;
}

export class GetBlanketOrderByOrderNbrQuery implements IGetBlanketOrderByOrderNbrQuery {
    orderNbr?: string | null;

    constructor(data?: IGetBlanketOrderByOrderNbrQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.orderNbr = _data["orderNbr"] !== undefined ? _data["orderNbr"] : <any>null;
        }
    }

    static fromJS(data: any): GetBlanketOrderByOrderNbrQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetBlanketOrderByOrderNbrQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["orderNbr"] = this.orderNbr !== undefined ? this.orderNbr : <any>null;
        return data;
    }
}

export interface IGetBlanketOrderByOrderNbrQuery {
    orderNbr?: string | null;
}

export class BlanketOrderWithChildOrdersDto implements IBlanketOrderWithChildOrdersDto {
    blanketOrder?: ErpSalesOrderDto | null;
    salesOrders?: ErpSalesOrderDto[] | null;

    constructor(data?: IBlanketOrderWithChildOrdersDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.blanketOrder = _data["blanketOrder"] ? ErpSalesOrderDto.fromJS(_data["blanketOrder"]) : <any>null;
            if (Array.isArray(_data["salesOrders"])) {
                this.salesOrders = [] as any;
                for (let item of _data["salesOrders"])
                    this.salesOrders!.push(ErpSalesOrderDto.fromJS(item));
            }
            else {
                this.salesOrders = <any>null;
            }
        }
    }

    static fromJS(data: any): BlanketOrderWithChildOrdersDto {
        data = typeof data === 'object' ? data : {};
        let result = new BlanketOrderWithChildOrdersDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["blanketOrder"] = this.blanketOrder ? this.blanketOrder.toJSON() : <any>null;
        if (Array.isArray(this.salesOrders)) {
            data["salesOrders"] = [];
            for (let item of this.salesOrders)
                data["salesOrders"].push(item.toJSON());
        }
        return data;
    }
}

export interface IBlanketOrderWithChildOrdersDto {
    blanketOrder?: ErpSalesOrderDto | null;
    salesOrders?: ErpSalesOrderDto[] | null;
}

export class GetBlanketOrderByOrderNbrWithChildOrders implements IGetBlanketOrderByOrderNbrWithChildOrders {
    orderNbr?: string | null;

    constructor(data?: IGetBlanketOrderByOrderNbrWithChildOrders) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.orderNbr = _data["orderNbr"] !== undefined ? _data["orderNbr"] : <any>null;
        }
    }

    static fromJS(data: any): GetBlanketOrderByOrderNbrWithChildOrders {
        data = typeof data === 'object' ? data : {};
        let result = new GetBlanketOrderByOrderNbrWithChildOrders();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["orderNbr"] = this.orderNbr !== undefined ? this.orderNbr : <any>null;
        return data;
    }
}

export interface IGetBlanketOrderByOrderNbrWithChildOrders {
    orderNbr?: string | null;
}

export class GetSalesOrdersUnderBlanketOrderQuery implements IGetSalesOrdersUnderBlanketOrderQuery {
    blanketOrderNbr?: string | null;

    constructor(data?: IGetSalesOrdersUnderBlanketOrderQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.blanketOrderNbr = _data["blanketOrderNbr"] !== undefined ? _data["blanketOrderNbr"] : <any>null;
        }
    }

    static fromJS(data: any): GetSalesOrdersUnderBlanketOrderQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetSalesOrdersUnderBlanketOrderQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["blanketOrderNbr"] = this.blanketOrderNbr !== undefined ? this.blanketOrderNbr : <any>null;
        return data;
    }
}

export interface IGetSalesOrdersUnderBlanketOrderQuery {
    blanketOrderNbr?: string | null;
}

export class CreateChildSalesOrdersUnderBlanketOrderCommand implements ICreateChildSalesOrdersUnderBlanketOrderCommand {
    blanketOrderNumber?: string | null;
    blanketOrder?: ErpSalesOrderDto | null;
    childSalesOrders?: ErpSalesOrderInput[] | null;

    constructor(data?: ICreateChildSalesOrdersUnderBlanketOrderCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.blanketOrderNumber = _data["blanketOrderNumber"] !== undefined ? _data["blanketOrderNumber"] : <any>null;
            this.blanketOrder = _data["blanketOrder"] ? ErpSalesOrderDto.fromJS(_data["blanketOrder"]) : <any>null;
            if (Array.isArray(_data["childSalesOrders"])) {
                this.childSalesOrders = [] as any;
                for (let item of _data["childSalesOrders"])
                    this.childSalesOrders!.push(ErpSalesOrderInput.fromJS(item));
            }
            else {
                this.childSalesOrders = <any>null;
            }
        }
    }

    static fromJS(data: any): CreateChildSalesOrdersUnderBlanketOrderCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateChildSalesOrdersUnderBlanketOrderCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["blanketOrderNumber"] = this.blanketOrderNumber !== undefined ? this.blanketOrderNumber : <any>null;
        data["blanketOrder"] = this.blanketOrder ? this.blanketOrder.toJSON() : <any>null;
        if (Array.isArray(this.childSalesOrders)) {
            data["childSalesOrders"] = [];
            for (let item of this.childSalesOrders)
                data["childSalesOrders"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICreateChildSalesOrdersUnderBlanketOrderCommand {
    blanketOrderNumber?: string | null;
    blanketOrder?: ErpSalesOrderDto | null;
    childSalesOrders?: ErpSalesOrderInput[] | null;
}

export class ErpSalesOrderInput implements IErpSalesOrderInput {
    id?: string | null;
    orderNbr?: StringValue | null;
    orderType?: StringValue | null;
    customerID?: StringValue | null;
    note?: string | null;
    customerOrderNbr?: StringValue | null;
    status?: StringValue | null;
    hold?: BooleanValue | null;
    orderDate?: NullableDateTimeValue | null;
    date?: NullableDateTimeValue | null;
    requestedOn?: NullableDateTimeValue | null;
    details?: ErpSalesOrderDetailInput[] | null;
    custom?: ErpCustomDtoOfErpSalesOrderCustomDocumentDto | null;
    financialSettings?: ErpFinancialSettingsInput | null;

    constructor(data?: IErpSalesOrderInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.orderNbr = _data["orderNbr"] ? StringValue.fromJS(_data["orderNbr"]) : <any>null;
            this.orderType = _data["orderType"] ? StringValue.fromJS(_data["orderType"]) : <any>null;
            this.customerID = _data["customerID"] ? StringValue.fromJS(_data["customerID"]) : <any>null;
            this.note = _data["note"] !== undefined ? _data["note"] : <any>null;
            this.customerOrderNbr = _data["customerOrderNbr"] ? StringValue.fromJS(_data["customerOrderNbr"]) : <any>null;
            this.status = _data["status"] ? StringValue.fromJS(_data["status"]) : <any>null;
            this.hold = _data["hold"] ? BooleanValue.fromJS(_data["hold"]) : <any>null;
            this.orderDate = _data["orderDate"] ? NullableDateTimeValue.fromJS(_data["orderDate"]) : <any>null;
            this.date = _data["date"] ? NullableDateTimeValue.fromJS(_data["date"]) : <any>null;
            this.requestedOn = _data["requestedOn"] ? NullableDateTimeValue.fromJS(_data["requestedOn"]) : <any>null;
            if (Array.isArray(_data["details"])) {
                this.details = [] as any;
                for (let item of _data["details"])
                    this.details!.push(ErpSalesOrderDetailInput.fromJS(item));
            }
            else {
                this.details = <any>null;
            }
            this.custom = _data["custom"] ? ErpCustomDtoOfErpSalesOrderCustomDocumentDto.fromJS(_data["custom"]) : <any>null;
            this.financialSettings = _data["financialSettings"] ? ErpFinancialSettingsInput.fromJS(_data["financialSettings"]) : <any>null;
        }
    }

    static fromJS(data: any): ErpSalesOrderInput {
        data = typeof data === 'object' ? data : {};
        let result = new ErpSalesOrderInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["orderNbr"] = this.orderNbr ? this.orderNbr.toJSON() : <any>null;
        data["orderType"] = this.orderType ? this.orderType.toJSON() : <any>null;
        data["customerID"] = this.customerID ? this.customerID.toJSON() : <any>null;
        data["note"] = this.note !== undefined ? this.note : <any>null;
        data["customerOrderNbr"] = this.customerOrderNbr ? this.customerOrderNbr.toJSON() : <any>null;
        data["status"] = this.status ? this.status.toJSON() : <any>null;
        data["hold"] = this.hold ? this.hold.toJSON() : <any>null;
        data["orderDate"] = this.orderDate ? this.orderDate.toJSON() : <any>null;
        data["date"] = this.date ? this.date.toJSON() : <any>null;
        data["requestedOn"] = this.requestedOn ? this.requestedOn.toJSON() : <any>null;
        if (Array.isArray(this.details)) {
            data["details"] = [];
            for (let item of this.details)
                data["details"].push(item.toJSON());
        }
        data["custom"] = this.custom ? this.custom.toJSON() : <any>null;
        data["financialSettings"] = this.financialSettings ? this.financialSettings.toJSON() : <any>null;
        return data;
    }
}

export interface IErpSalesOrderInput {
    id?: string | null;
    orderNbr?: StringValue | null;
    orderType?: StringValue | null;
    customerID?: StringValue | null;
    note?: string | null;
    customerOrderNbr?: StringValue | null;
    status?: StringValue | null;
    hold?: BooleanValue | null;
    orderDate?: NullableDateTimeValue | null;
    date?: NullableDateTimeValue | null;
    requestedOn?: NullableDateTimeValue | null;
    details?: ErpSalesOrderDetailInput[] | null;
    custom?: ErpCustomDtoOfErpSalesOrderCustomDocumentDto | null;
    financialSettings?: ErpFinancialSettingsInput | null;
}

export class ErpSalesOrderDetailInput implements IErpSalesOrderDetailInput {
    id?: string | null;
    inventoryID?: StringValue | null;
    orderQty?: StringValue | null;
    manualPrice?: BooleanValue | null;
    unitPrice?: StringValue | null;
    freeItem?: BooleanValue | null;
    lineDescription?: StringValue | null;
    custom?: ErpCustomTransactionsDtoOfErpStockItemCustomDocumentInput | null;

    constructor(data?: IErpSalesOrderDetailInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.inventoryID = _data["inventoryID"] ? StringValue.fromJS(_data["inventoryID"]) : <any>null;
            this.orderQty = _data["orderQty"] ? StringValue.fromJS(_data["orderQty"]) : <any>null;
            this.manualPrice = _data["manualPrice"] ? BooleanValue.fromJS(_data["manualPrice"]) : <any>null;
            this.unitPrice = _data["unitPrice"] ? StringValue.fromJS(_data["unitPrice"]) : <any>null;
            this.freeItem = _data["freeItem"] ? BooleanValue.fromJS(_data["freeItem"]) : <any>null;
            this.lineDescription = _data["lineDescription"] ? StringValue.fromJS(_data["lineDescription"]) : <any>null;
            this.custom = _data["custom"] ? ErpCustomTransactionsDtoOfErpStockItemCustomDocumentInput.fromJS(_data["custom"]) : <any>null;
        }
    }

    static fromJS(data: any): ErpSalesOrderDetailInput {
        data = typeof data === 'object' ? data : {};
        let result = new ErpSalesOrderDetailInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["inventoryID"] = this.inventoryID ? this.inventoryID.toJSON() : <any>null;
        data["orderQty"] = this.orderQty ? this.orderQty.toJSON() : <any>null;
        data["manualPrice"] = this.manualPrice ? this.manualPrice.toJSON() : <any>null;
        data["unitPrice"] = this.unitPrice ? this.unitPrice.toJSON() : <any>null;
        data["freeItem"] = this.freeItem ? this.freeItem.toJSON() : <any>null;
        data["lineDescription"] = this.lineDescription ? this.lineDescription.toJSON() : <any>null;
        data["custom"] = this.custom ? this.custom.toJSON() : <any>null;
        return data;
    }
}

export interface IErpSalesOrderDetailInput {
    id?: string | null;
    inventoryID?: StringValue | null;
    orderQty?: StringValue | null;
    manualPrice?: BooleanValue | null;
    unitPrice?: StringValue | null;
    freeItem?: BooleanValue | null;
    lineDescription?: StringValue | null;
    custom?: ErpCustomTransactionsDtoOfErpStockItemCustomDocumentInput | null;
}

export class ErpCustomTransactionsDtoOfErpStockItemCustomDocumentInput implements IErpCustomTransactionsDtoOfErpStockItemCustomDocumentInput {
    transactions?: ErpStockItemCustomDocumentInput | null;

    constructor(data?: IErpCustomTransactionsDtoOfErpStockItemCustomDocumentInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.transactions = _data["transactions"] ? ErpStockItemCustomDocumentInput.fromJS(_data["transactions"]) : <any>null;
        }
    }

    static fromJS(data: any): ErpCustomTransactionsDtoOfErpStockItemCustomDocumentInput {
        data = typeof data === 'object' ? data : {};
        let result = new ErpCustomTransactionsDtoOfErpStockItemCustomDocumentInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["transactions"] = this.transactions ? this.transactions.toJSON() : <any>null;
        return data;
    }
}

export interface IErpCustomTransactionsDtoOfErpStockItemCustomDocumentInput {
    transactions?: ErpStockItemCustomDocumentInput | null;
}

export class ErpStockItemCustomDocumentInput implements IErpStockItemCustomDocumentInput {
    usrSFReturnOrReplacement?: StringValue | null;
    usrSFReturnReason?: StringValue | null;
    usrSFIsAdjustment?: BooleanValue | null;
    usrSFAdjustmentForInventoryID?: StringValue | null;
    usrSFLastModifiedBy?: StringValue | null;

    constructor(data?: IErpStockItemCustomDocumentInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.usrSFReturnOrReplacement = _data["usrSFReturnOrReplacement"] ? StringValue.fromJS(_data["usrSFReturnOrReplacement"]) : <any>null;
            this.usrSFReturnReason = _data["usrSFReturnReason"] ? StringValue.fromJS(_data["usrSFReturnReason"]) : <any>null;
            this.usrSFIsAdjustment = _data["usrSFIsAdjustment"] ? BooleanValue.fromJS(_data["usrSFIsAdjustment"]) : <any>null;
            this.usrSFAdjustmentForInventoryID = _data["usrSFAdjustmentForInventoryID"] ? StringValue.fromJS(_data["usrSFAdjustmentForInventoryID"]) : <any>null;
            this.usrSFLastModifiedBy = _data["usrSFLastModifiedBy"] ? StringValue.fromJS(_data["usrSFLastModifiedBy"]) : <any>null;
        }
    }

    static fromJS(data: any): ErpStockItemCustomDocumentInput {
        data = typeof data === 'object' ? data : {};
        let result = new ErpStockItemCustomDocumentInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["usrSFReturnOrReplacement"] = this.usrSFReturnOrReplacement ? this.usrSFReturnOrReplacement.toJSON() : <any>null;
        data["usrSFReturnReason"] = this.usrSFReturnReason ? this.usrSFReturnReason.toJSON() : <any>null;
        data["usrSFIsAdjustment"] = this.usrSFIsAdjustment ? this.usrSFIsAdjustment.toJSON() : <any>null;
        data["usrSFAdjustmentForInventoryID"] = this.usrSFAdjustmentForInventoryID ? this.usrSFAdjustmentForInventoryID.toJSON() : <any>null;
        data["usrSFLastModifiedBy"] = this.usrSFLastModifiedBy ? this.usrSFLastModifiedBy.toJSON() : <any>null;
        return data;
    }
}

export interface IErpStockItemCustomDocumentInput {
    usrSFReturnOrReplacement?: StringValue | null;
    usrSFReturnReason?: StringValue | null;
    usrSFIsAdjustment?: BooleanValue | null;
    usrSFAdjustmentForInventoryID?: StringValue | null;
    usrSFLastModifiedBy?: StringValue | null;
}

export class ErpFinancialSettingsInput implements IErpFinancialSettingsInput {
    terms?: StringValue | null;

    constructor(data?: IErpFinancialSettingsInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.terms = _data["terms"] ? StringValue.fromJS(_data["terms"]) : <any>null;
        }
    }

    static fromJS(data: any): ErpFinancialSettingsInput {
        data = typeof data === 'object' ? data : {};
        let result = new ErpFinancialSettingsInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["terms"] = this.terms ? this.terms.toJSON() : <any>null;
        return data;
    }
}

export interface IErpFinancialSettingsInput {
    terms?: StringValue | null;
}

export class UpdateChildOrdersUnderBlanketOrderCommand implements IUpdateChildOrdersUnderBlanketOrderCommand {
    updateOrdersDto?: UpdateOrdersDto | null;

    constructor(data?: IUpdateChildOrdersUnderBlanketOrderCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.updateOrdersDto = _data["updateOrdersDto"] ? UpdateOrdersDto.fromJS(_data["updateOrdersDto"]) : <any>null;
        }
    }

    static fromJS(data: any): UpdateChildOrdersUnderBlanketOrderCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateChildOrdersUnderBlanketOrderCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["updateOrdersDto"] = this.updateOrdersDto ? this.updateOrdersDto.toJSON() : <any>null;
        return data;
    }
}

export interface IUpdateChildOrdersUnderBlanketOrderCommand {
    updateOrdersDto?: UpdateOrdersDto | null;
}

export class UpdateOrdersDto implements IUpdateOrdersDto {
    originalBlanketOrder?: ErpSalesOrderDto | null;
    modifiedBlanketOrder?: ErpSalesOrderInput | null;
    originalChildOrders?: ErpSalesOrderDto[] | null;
    modifiedChildOrders?: ErpSalesOrderInput[] | null;
    newChildOrders?: ErpSalesOrderInput[] | null;
    deletedChildOrders?: ErpSalesOrderInput[] | null;

    constructor(data?: IUpdateOrdersDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.originalBlanketOrder = _data["originalBlanketOrder"] ? ErpSalesOrderDto.fromJS(_data["originalBlanketOrder"]) : <any>null;
            this.modifiedBlanketOrder = _data["modifiedBlanketOrder"] ? ErpSalesOrderInput.fromJS(_data["modifiedBlanketOrder"]) : <any>null;
            if (Array.isArray(_data["originalChildOrders"])) {
                this.originalChildOrders = [] as any;
                for (let item of _data["originalChildOrders"])
                    this.originalChildOrders!.push(ErpSalesOrderDto.fromJS(item));
            }
            else {
                this.originalChildOrders = <any>null;
            }
            if (Array.isArray(_data["modifiedChildOrders"])) {
                this.modifiedChildOrders = [] as any;
                for (let item of _data["modifiedChildOrders"])
                    this.modifiedChildOrders!.push(ErpSalesOrderInput.fromJS(item));
            }
            else {
                this.modifiedChildOrders = <any>null;
            }
            if (Array.isArray(_data["newChildOrders"])) {
                this.newChildOrders = [] as any;
                for (let item of _data["newChildOrders"])
                    this.newChildOrders!.push(ErpSalesOrderInput.fromJS(item));
            }
            else {
                this.newChildOrders = <any>null;
            }
            if (Array.isArray(_data["deletedChildOrders"])) {
                this.deletedChildOrders = [] as any;
                for (let item of _data["deletedChildOrders"])
                    this.deletedChildOrders!.push(ErpSalesOrderInput.fromJS(item));
            }
            else {
                this.deletedChildOrders = <any>null;
            }
        }
    }

    static fromJS(data: any): UpdateOrdersDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateOrdersDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["originalBlanketOrder"] = this.originalBlanketOrder ? this.originalBlanketOrder.toJSON() : <any>null;
        data["modifiedBlanketOrder"] = this.modifiedBlanketOrder ? this.modifiedBlanketOrder.toJSON() : <any>null;
        if (Array.isArray(this.originalChildOrders)) {
            data["originalChildOrders"] = [];
            for (let item of this.originalChildOrders)
                data["originalChildOrders"].push(item.toJSON());
        }
        if (Array.isArray(this.modifiedChildOrders)) {
            data["modifiedChildOrders"] = [];
            for (let item of this.modifiedChildOrders)
                data["modifiedChildOrders"].push(item.toJSON());
        }
        if (Array.isArray(this.newChildOrders)) {
            data["newChildOrders"] = [];
            for (let item of this.newChildOrders)
                data["newChildOrders"].push(item.toJSON());
        }
        if (Array.isArray(this.deletedChildOrders)) {
            data["deletedChildOrders"] = [];
            for (let item of this.deletedChildOrders)
                data["deletedChildOrders"].push(item.toJSON());
        }
        return data;
    }
}

export interface IUpdateOrdersDto {
    originalBlanketOrder?: ErpSalesOrderDto | null;
    modifiedBlanketOrder?: ErpSalesOrderInput | null;
    originalChildOrders?: ErpSalesOrderDto[] | null;
    modifiedChildOrders?: ErpSalesOrderInput[] | null;
    newChildOrders?: ErpSalesOrderInput[] | null;
    deletedChildOrders?: ErpSalesOrderInput[] | null;
}

export class CreateChildOrderCommand implements ICreateChildOrderCommand {
    blanketOrder?: ErpSalesOrderDto | null;
    blanketOrderNbr?: string | null;

    constructor(data?: ICreateChildOrderCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.blanketOrder = _data["blanketOrder"] ? ErpSalesOrderDto.fromJS(_data["blanketOrder"]) : <any>null;
            this.blanketOrderNbr = _data["blanketOrderNbr"] !== undefined ? _data["blanketOrderNbr"] : <any>null;
        }
    }

    static fromJS(data: any): CreateChildOrderCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateChildOrderCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["blanketOrder"] = this.blanketOrder ? this.blanketOrder.toJSON() : <any>null;
        data["blanketOrderNbr"] = this.blanketOrderNbr !== undefined ? this.blanketOrderNbr : <any>null;
        return data;
    }
}

export interface ICreateChildOrderCommand {
    blanketOrder?: ErpSalesOrderDto | null;
    blanketOrderNbr?: string | null;
}

export class DeleteSalesOrderCommand implements IDeleteSalesOrderCommand {
    orderNbr?: string | null;
    type?: string | null;

    constructor(data?: IDeleteSalesOrderCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.orderNbr = _data["orderNbr"] !== undefined ? _data["orderNbr"] : <any>null;
            this.type = _data["type"] !== undefined ? _data["type"] : <any>null;
        }
    }

    static fromJS(data: any): DeleteSalesOrderCommand {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteSalesOrderCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["orderNbr"] = this.orderNbr !== undefined ? this.orderNbr : <any>null;
        data["type"] = this.type !== undefined ? this.type : <any>null;
        return data;
    }
}

export interface IDeleteSalesOrderCommand {
    orderNbr?: string | null;
    type?: string | null;
}

export class GetReturnOrdersQuery implements IGetReturnOrdersQuery {
    orders?: ErpSalesOrderDto[] | null;

    constructor(data?: IGetReturnOrdersQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["orders"])) {
                this.orders = [] as any;
                for (let item of _data["orders"])
                    this.orders!.push(ErpSalesOrderDto.fromJS(item));
            }
            else {
                this.orders = <any>null;
            }
        }
    }

    static fromJS(data: any): GetReturnOrdersQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetReturnOrdersQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.orders)) {
            data["orders"] = [];
            for (let item of this.orders)
                data["orders"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetReturnOrdersQuery {
    orders?: ErpSalesOrderDto[] | null;
}

export class ErpCustomerDto extends BaseResponseDto implements IErpCustomerDto {
    id?: string | null;
    rowNumber?: number;
    note?: StringValue | null;
    applyOverdueCharges?: NullableBooleanValue | null;
    autoApplyPayments?: NullableBooleanValue | null;
    billingAddressSameAsMain?: NullableBooleanValue | null;
    billingContactSameAsMain?: NullableBooleanValue | null;
    createdDateTime?: StringValue | null;
    currencyID?: StringValue | null;
    customerClass?: StringValue | null;
    customerID?: StringValue | null;
    customerName?: StringValue | null;
    enableCurrencyOverride?: NullableBooleanValue | null;
    enableRateOverride?: NullableBooleanValue | null;
    enableWriteOffs?: NullableBooleanValue | null;
    lastModifiedDateTime?: StringValue | null;
    locationName?: StringValue | null;
    multiCurrencyStatements?: NullableBooleanValue | null;
    orderPriority?: DoubleValue | null;
    shippingBranch?: StringValue | null;
    shippingRule?: StringValue | null;
    statementCycleID?: StringValue | null;
    statementType?: StringValue | null;
    status?: StringValue | null;
    taxZone?: StringValue | null;
    terms?: StringValue | null;
    writeOffLimit?: DoubleValue | null;
    printDunningLetters?: NullableBooleanValue | null;
    printInvoices?: NullableBooleanValue | null;
    printStatements?: NullableBooleanValue | null;
    residentialDelivery?: NullableBooleanValue | null;
    saturdayDelivery?: NullableBooleanValue | null;
    sendDunningLettersByEmail?: NullableBooleanValue | null;
    sendInvoicesByEmail?: NullableBooleanValue | null;
    sendStatementsByEmail?: NullableBooleanValue | null;
    contacts?: ErpContactListDto[] | null;
    billingContact?: ErpContactDto | null;
    mainContact?: ErpContactDto | null;
    primaryContact?: ErpContactDto | null;

    constructor(data?: IErpCustomerDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.rowNumber = _data["rowNumber"] !== undefined ? _data["rowNumber"] : <any>null;
            this.note = _data["note"] ? StringValue.fromJS(_data["note"]) : <any>null;
            this.applyOverdueCharges = _data["applyOverdueCharges"] ? NullableBooleanValue.fromJS(_data["applyOverdueCharges"]) : <any>null;
            this.autoApplyPayments = _data["autoApplyPayments"] ? NullableBooleanValue.fromJS(_data["autoApplyPayments"]) : <any>null;
            this.billingAddressSameAsMain = _data["billingAddressSameAsMain"] ? NullableBooleanValue.fromJS(_data["billingAddressSameAsMain"]) : <any>null;
            this.billingContactSameAsMain = _data["billingContactSameAsMain"] ? NullableBooleanValue.fromJS(_data["billingContactSameAsMain"]) : <any>null;
            this.createdDateTime = _data["createdDateTime"] ? StringValue.fromJS(_data["createdDateTime"]) : <any>null;
            this.currencyID = _data["currencyID"] ? StringValue.fromJS(_data["currencyID"]) : <any>null;
            this.customerClass = _data["customerClass"] ? StringValue.fromJS(_data["customerClass"]) : <any>null;
            this.customerID = _data["customerID"] ? StringValue.fromJS(_data["customerID"]) : <any>null;
            this.customerName = _data["customerName"] ? StringValue.fromJS(_data["customerName"]) : <any>null;
            this.enableCurrencyOverride = _data["enableCurrencyOverride"] ? NullableBooleanValue.fromJS(_data["enableCurrencyOverride"]) : <any>null;
            this.enableRateOverride = _data["enableRateOverride"] ? NullableBooleanValue.fromJS(_data["enableRateOverride"]) : <any>null;
            this.enableWriteOffs = _data["enableWriteOffs"] ? NullableBooleanValue.fromJS(_data["enableWriteOffs"]) : <any>null;
            this.lastModifiedDateTime = _data["lastModifiedDateTime"] ? StringValue.fromJS(_data["lastModifiedDateTime"]) : <any>null;
            this.locationName = _data["locationName"] ? StringValue.fromJS(_data["locationName"]) : <any>null;
            this.multiCurrencyStatements = _data["multiCurrencyStatements"] ? NullableBooleanValue.fromJS(_data["multiCurrencyStatements"]) : <any>null;
            this.orderPriority = _data["orderPriority"] ? DoubleValue.fromJS(_data["orderPriority"]) : <any>null;
            this.shippingBranch = _data["shippingBranch"] ? StringValue.fromJS(_data["shippingBranch"]) : <any>null;
            this.shippingRule = _data["shippingRule"] ? StringValue.fromJS(_data["shippingRule"]) : <any>null;
            this.statementCycleID = _data["statementCycleID"] ? StringValue.fromJS(_data["statementCycleID"]) : <any>null;
            this.statementType = _data["statementType"] ? StringValue.fromJS(_data["statementType"]) : <any>null;
            this.status = _data["status"] ? StringValue.fromJS(_data["status"]) : <any>null;
            this.taxZone = _data["taxZone"] ? StringValue.fromJS(_data["taxZone"]) : <any>null;
            this.terms = _data["terms"] ? StringValue.fromJS(_data["terms"]) : <any>null;
            this.writeOffLimit = _data["writeOffLimit"] ? DoubleValue.fromJS(_data["writeOffLimit"]) : <any>null;
            this.printDunningLetters = _data["printDunningLetters"] ? NullableBooleanValue.fromJS(_data["printDunningLetters"]) : <any>null;
            this.printInvoices = _data["printInvoices"] ? NullableBooleanValue.fromJS(_data["printInvoices"]) : <any>null;
            this.printStatements = _data["printStatements"] ? NullableBooleanValue.fromJS(_data["printStatements"]) : <any>null;
            this.residentialDelivery = _data["residentialDelivery"] ? NullableBooleanValue.fromJS(_data["residentialDelivery"]) : <any>null;
            this.saturdayDelivery = _data["saturdayDelivery"] ? NullableBooleanValue.fromJS(_data["saturdayDelivery"]) : <any>null;
            this.sendDunningLettersByEmail = _data["sendDunningLettersByEmail"] ? NullableBooleanValue.fromJS(_data["sendDunningLettersByEmail"]) : <any>null;
            this.sendInvoicesByEmail = _data["sendInvoicesByEmail"] ? NullableBooleanValue.fromJS(_data["sendInvoicesByEmail"]) : <any>null;
            this.sendStatementsByEmail = _data["sendStatementsByEmail"] ? NullableBooleanValue.fromJS(_data["sendStatementsByEmail"]) : <any>null;
            if (Array.isArray(_data["contacts"])) {
                this.contacts = [] as any;
                for (let item of _data["contacts"])
                    this.contacts!.push(ErpContactListDto.fromJS(item));
            }
            else {
                this.contacts = <any>null;
            }
            this.billingContact = _data["billingContact"] ? ErpContactDto.fromJS(_data["billingContact"]) : <any>null;
            this.mainContact = _data["mainContact"] ? ErpContactDto.fromJS(_data["mainContact"]) : <any>null;
            this.primaryContact = _data["primaryContact"] ? ErpContactDto.fromJS(_data["primaryContact"]) : <any>null;
        }
    }

    static override fromJS(data: any): ErpCustomerDto {
        data = typeof data === 'object' ? data : {};
        let result = new ErpCustomerDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["rowNumber"] = this.rowNumber !== undefined ? this.rowNumber : <any>null;
        data["note"] = this.note ? this.note.toJSON() : <any>null;
        data["applyOverdueCharges"] = this.applyOverdueCharges ? this.applyOverdueCharges.toJSON() : <any>null;
        data["autoApplyPayments"] = this.autoApplyPayments ? this.autoApplyPayments.toJSON() : <any>null;
        data["billingAddressSameAsMain"] = this.billingAddressSameAsMain ? this.billingAddressSameAsMain.toJSON() : <any>null;
        data["billingContactSameAsMain"] = this.billingContactSameAsMain ? this.billingContactSameAsMain.toJSON() : <any>null;
        data["createdDateTime"] = this.createdDateTime ? this.createdDateTime.toJSON() : <any>null;
        data["currencyID"] = this.currencyID ? this.currencyID.toJSON() : <any>null;
        data["customerClass"] = this.customerClass ? this.customerClass.toJSON() : <any>null;
        data["customerID"] = this.customerID ? this.customerID.toJSON() : <any>null;
        data["customerName"] = this.customerName ? this.customerName.toJSON() : <any>null;
        data["enableCurrencyOverride"] = this.enableCurrencyOverride ? this.enableCurrencyOverride.toJSON() : <any>null;
        data["enableRateOverride"] = this.enableRateOverride ? this.enableRateOverride.toJSON() : <any>null;
        data["enableWriteOffs"] = this.enableWriteOffs ? this.enableWriteOffs.toJSON() : <any>null;
        data["lastModifiedDateTime"] = this.lastModifiedDateTime ? this.lastModifiedDateTime.toJSON() : <any>null;
        data["locationName"] = this.locationName ? this.locationName.toJSON() : <any>null;
        data["multiCurrencyStatements"] = this.multiCurrencyStatements ? this.multiCurrencyStatements.toJSON() : <any>null;
        data["orderPriority"] = this.orderPriority ? this.orderPriority.toJSON() : <any>null;
        data["shippingBranch"] = this.shippingBranch ? this.shippingBranch.toJSON() : <any>null;
        data["shippingRule"] = this.shippingRule ? this.shippingRule.toJSON() : <any>null;
        data["statementCycleID"] = this.statementCycleID ? this.statementCycleID.toJSON() : <any>null;
        data["statementType"] = this.statementType ? this.statementType.toJSON() : <any>null;
        data["status"] = this.status ? this.status.toJSON() : <any>null;
        data["taxZone"] = this.taxZone ? this.taxZone.toJSON() : <any>null;
        data["terms"] = this.terms ? this.terms.toJSON() : <any>null;
        data["writeOffLimit"] = this.writeOffLimit ? this.writeOffLimit.toJSON() : <any>null;
        data["printDunningLetters"] = this.printDunningLetters ? this.printDunningLetters.toJSON() : <any>null;
        data["printInvoices"] = this.printInvoices ? this.printInvoices.toJSON() : <any>null;
        data["printStatements"] = this.printStatements ? this.printStatements.toJSON() : <any>null;
        data["residentialDelivery"] = this.residentialDelivery ? this.residentialDelivery.toJSON() : <any>null;
        data["saturdayDelivery"] = this.saturdayDelivery ? this.saturdayDelivery.toJSON() : <any>null;
        data["sendDunningLettersByEmail"] = this.sendDunningLettersByEmail ? this.sendDunningLettersByEmail.toJSON() : <any>null;
        data["sendInvoicesByEmail"] = this.sendInvoicesByEmail ? this.sendInvoicesByEmail.toJSON() : <any>null;
        data["sendStatementsByEmail"] = this.sendStatementsByEmail ? this.sendStatementsByEmail.toJSON() : <any>null;
        if (Array.isArray(this.contacts)) {
            data["contacts"] = [];
            for (let item of this.contacts)
                data["contacts"].push(item.toJSON());
        }
        data["billingContact"] = this.billingContact ? this.billingContact.toJSON() : <any>null;
        data["mainContact"] = this.mainContact ? this.mainContact.toJSON() : <any>null;
        data["primaryContact"] = this.primaryContact ? this.primaryContact.toJSON() : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IErpCustomerDto extends IBaseResponseDto {
    id?: string | null;
    rowNumber?: number;
    note?: StringValue | null;
    applyOverdueCharges?: NullableBooleanValue | null;
    autoApplyPayments?: NullableBooleanValue | null;
    billingAddressSameAsMain?: NullableBooleanValue | null;
    billingContactSameAsMain?: NullableBooleanValue | null;
    createdDateTime?: StringValue | null;
    currencyID?: StringValue | null;
    customerClass?: StringValue | null;
    customerID?: StringValue | null;
    customerName?: StringValue | null;
    enableCurrencyOverride?: NullableBooleanValue | null;
    enableRateOverride?: NullableBooleanValue | null;
    enableWriteOffs?: NullableBooleanValue | null;
    lastModifiedDateTime?: StringValue | null;
    locationName?: StringValue | null;
    multiCurrencyStatements?: NullableBooleanValue | null;
    orderPriority?: DoubleValue | null;
    shippingBranch?: StringValue | null;
    shippingRule?: StringValue | null;
    statementCycleID?: StringValue | null;
    statementType?: StringValue | null;
    status?: StringValue | null;
    taxZone?: StringValue | null;
    terms?: StringValue | null;
    writeOffLimit?: DoubleValue | null;
    printDunningLetters?: NullableBooleanValue | null;
    printInvoices?: NullableBooleanValue | null;
    printStatements?: NullableBooleanValue | null;
    residentialDelivery?: NullableBooleanValue | null;
    saturdayDelivery?: NullableBooleanValue | null;
    sendDunningLettersByEmail?: NullableBooleanValue | null;
    sendInvoicesByEmail?: NullableBooleanValue | null;
    sendStatementsByEmail?: NullableBooleanValue | null;
    contacts?: ErpContactListDto[] | null;
    billingContact?: ErpContactDto | null;
    mainContact?: ErpContactDto | null;
    primaryContact?: ErpContactDto | null;
}

export class DoubleValue implements IDoubleValue {
    value?: number | null;

    constructor(data?: IDoubleValue) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"] !== undefined ? _data["value"] : <any>null;
        }
    }

    static fromJS(data: any): DoubleValue {
        data = typeof data === 'object' ? data : {};
        let result = new DoubleValue();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value !== undefined ? this.value : <any>null;
        return data;
    }
}

export interface IDoubleValue {
    value?: number | null;
}

export class ErpContactListDto implements IErpContactListDto {
    contactID?: IntValue | null;
    contact?: ErpContactDto | null;

    constructor(data?: IErpContactListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.contactID = _data["contactID"] ? IntValue.fromJS(_data["contactID"]) : <any>null;
            this.contact = _data["contact"] ? ErpContactDto.fromJS(_data["contact"]) : <any>null;
        }
    }

    static fromJS(data: any): ErpContactListDto {
        data = typeof data === 'object' ? data : {};
        let result = new ErpContactListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contactID"] = this.contactID ? this.contactID.toJSON() : <any>null;
        data["contact"] = this.contact ? this.contact.toJSON() : <any>null;
        return data;
    }
}

export interface IErpContactListDto {
    contactID?: IntValue | null;
    contact?: ErpContactDto | null;
}

export class ErpContactDto implements IErpContactDto {
    id?: string | null;
    rowNumber?: number;
    note?: StringValue | null;
    businessAccount?: StringValue | null;
    contactID?: IntValue | null;
    email?: StringValue | null;
    firstName?: StringValue | null;
    lastName?: StringValue | null;
    displayName?: StringValue | null;
    phone1?: StringValue | null;
    phone2?: StringValue | null;
    phone3?: StringValue | null;
    dateOfBirth?: StringValue | null;
    getDateOfBirth?: moment.Moment | null;
    languageOrLocale?: StringValue | null;
    getLanguageType?: LanguageType;
    address?: ErpAddressDto | null;

    constructor(data?: IErpContactDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.rowNumber = _data["rowNumber"] !== undefined ? _data["rowNumber"] : <any>null;
            this.note = _data["note"] ? StringValue.fromJS(_data["note"]) : <any>null;
            this.businessAccount = _data["businessAccount"] ? StringValue.fromJS(_data["businessAccount"]) : <any>null;
            this.contactID = _data["contactID"] ? IntValue.fromJS(_data["contactID"]) : <any>null;
            this.email = _data["email"] ? StringValue.fromJS(_data["email"]) : <any>null;
            this.firstName = _data["firstName"] ? StringValue.fromJS(_data["firstName"]) : <any>null;
            this.lastName = _data["lastName"] ? StringValue.fromJS(_data["lastName"]) : <any>null;
            this.displayName = _data["displayName"] ? StringValue.fromJS(_data["displayName"]) : <any>null;
            this.phone1 = _data["phone1"] ? StringValue.fromJS(_data["phone1"]) : <any>null;
            this.phone2 = _data["phone2"] ? StringValue.fromJS(_data["phone2"]) : <any>null;
            this.phone3 = _data["phone3"] ? StringValue.fromJS(_data["phone3"]) : <any>null;
            this.dateOfBirth = _data["dateOfBirth"] ? StringValue.fromJS(_data["dateOfBirth"]) : <any>null;
            this.getDateOfBirth = _data["getDateOfBirth"] ? moment(_data["getDateOfBirth"].toString()) : <any>null;
            this.languageOrLocale = _data["languageOrLocale"] ? StringValue.fromJS(_data["languageOrLocale"]) : <any>null;
            this.getLanguageType = _data["getLanguageType"] !== undefined ? _data["getLanguageType"] : <any>null;
            this.address = _data["address"] ? ErpAddressDto.fromJS(_data["address"]) : <any>null;
        }
    }

    static fromJS(data: any): ErpContactDto {
        data = typeof data === 'object' ? data : {};
        let result = new ErpContactDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["rowNumber"] = this.rowNumber !== undefined ? this.rowNumber : <any>null;
        data["note"] = this.note ? this.note.toJSON() : <any>null;
        data["businessAccount"] = this.businessAccount ? this.businessAccount.toJSON() : <any>null;
        data["contactID"] = this.contactID ? this.contactID.toJSON() : <any>null;
        data["email"] = this.email ? this.email.toJSON() : <any>null;
        data["firstName"] = this.firstName ? this.firstName.toJSON() : <any>null;
        data["lastName"] = this.lastName ? this.lastName.toJSON() : <any>null;
        data["displayName"] = this.displayName ? this.displayName.toJSON() : <any>null;
        data["phone1"] = this.phone1 ? this.phone1.toJSON() : <any>null;
        data["phone2"] = this.phone2 ? this.phone2.toJSON() : <any>null;
        data["phone3"] = this.phone3 ? this.phone3.toJSON() : <any>null;
        data["dateOfBirth"] = this.dateOfBirth ? this.dateOfBirth.toJSON() : <any>null;
        data["getDateOfBirth"] = this.getDateOfBirth ? this.getDateOfBirth.toISOString() : <any>null;
        data["languageOrLocale"] = this.languageOrLocale ? this.languageOrLocale.toJSON() : <any>null;
        data["getLanguageType"] = this.getLanguageType !== undefined ? this.getLanguageType : <any>null;
        data["address"] = this.address ? this.address.toJSON() : <any>null;
        return data;
    }
}

export interface IErpContactDto {
    id?: string | null;
    rowNumber?: number;
    note?: StringValue | null;
    businessAccount?: StringValue | null;
    contactID?: IntValue | null;
    email?: StringValue | null;
    firstName?: StringValue | null;
    lastName?: StringValue | null;
    displayName?: StringValue | null;
    phone1?: StringValue | null;
    phone2?: StringValue | null;
    phone3?: StringValue | null;
    dateOfBirth?: StringValue | null;
    getDateOfBirth?: moment.Moment | null;
    languageOrLocale?: StringValue | null;
    getLanguageType?: LanguageType;
    address?: ErpAddressDto | null;
}

export class GetCustomerQuery implements IGetCustomerQuery {
    customerId?: string | null;

    constructor(data?: IGetCustomerQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.customerId = _data["customerId"] !== undefined ? _data["customerId"] : <any>null;
        }
    }

    static fromJS(data: any): GetCustomerQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetCustomerQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customerId"] = this.customerId !== undefined ? this.customerId : <any>null;
        return data;
    }
}

export interface IGetCustomerQuery {
    customerId?: string | null;
}

export class PaginatedResultOfCallbackClientLeadLookupDto extends PaginatedResult implements IPaginatedResultOfCallbackClientLeadLookupDto {
    entities?: CallbackClientLeadLookupDto[] | null;

    constructor(data?: IPaginatedResultOfCallbackClientLeadLookupDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["entities"])) {
                this.entities = [] as any;
                for (let item of _data["entities"])
                    this.entities!.push(CallbackClientLeadLookupDto.fromJS(item));
            }
            else {
                this.entities = <any>null;
            }
        }
    }

    static override fromJS(data: any): PaginatedResultOfCallbackClientLeadLookupDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResultOfCallbackClientLeadLookupDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.entities)) {
            data["entities"] = [];
            for (let item of this.entities)
                data["entities"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IPaginatedResultOfCallbackClientLeadLookupDto extends IPaginatedResult {
    entities?: CallbackClientLeadLookupDto[] | null;
}

export class CallbackClientLeadLookupDto implements ICallbackClientLeadLookupDto {
    rating?: number | null;
    id?: number;
    index?: number;
    clientNumber?: number;
    assignedEmployeeId?: string | null;
    assignedEmployeeName?: string | null;
    assignedByEmployeeId?: string | null;
    assignedByEmployeeName?: string | null;
    assignedEmployeeDateTime?: moment.Moment | null;
    createdDateTime?: moment.Moment;
    city?: string | null;
    orderTotalValueIncludingFees?: number;
    renewalDate?: moment.Moment;
    callBackType?: CallBackType;
    callBackTypeDisplay?: string | null;
    contactAfterDateTime?: moment.Moment | null;
    callBackDateTime?: moment.Moment | null;
    lastOrderDeliveredPercentage?: number;
    clientMadeEmailRequest?: boolean;
    status?: CallbackClientLeadStatus;
    clientMadeEmailRequestOnDate?: moment.Moment | null;
    lastOrderDeliveryDate?: moment.Moment | null;

    constructor(data?: ICallbackClientLeadLookupDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.rating = _data["rating"] !== undefined ? _data["rating"] : <any>null;
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.index = _data["index"] !== undefined ? _data["index"] : <any>null;
            this.clientNumber = _data["clientNumber"] !== undefined ? _data["clientNumber"] : <any>null;
            this.assignedEmployeeId = _data["assignedEmployeeId"] !== undefined ? _data["assignedEmployeeId"] : <any>null;
            this.assignedEmployeeName = _data["assignedEmployeeName"] !== undefined ? _data["assignedEmployeeName"] : <any>null;
            this.assignedByEmployeeId = _data["assignedByEmployeeId"] !== undefined ? _data["assignedByEmployeeId"] : <any>null;
            this.assignedByEmployeeName = _data["assignedByEmployeeName"] !== undefined ? _data["assignedByEmployeeName"] : <any>null;
            this.assignedEmployeeDateTime = _data["assignedEmployeeDateTime"] ? moment(_data["assignedEmployeeDateTime"].toString()) : <any>null;
            this.createdDateTime = _data["createdDateTime"] ? moment(_data["createdDateTime"].toString()) : <any>null;
            this.city = _data["city"] !== undefined ? _data["city"] : <any>null;
            this.orderTotalValueIncludingFees = _data["orderTotalValueIncludingFees"] !== undefined ? _data["orderTotalValueIncludingFees"] : <any>null;
            this.renewalDate = _data["renewalDate"] ? moment(_data["renewalDate"].toString()) : <any>null;
            this.callBackType = _data["callBackType"] !== undefined ? _data["callBackType"] : <any>null;
            this.callBackTypeDisplay = _data["callBackTypeDisplay"] !== undefined ? _data["callBackTypeDisplay"] : <any>null;
            this.contactAfterDateTime = _data["contactAfterDateTime"] ? moment(_data["contactAfterDateTime"].toString()) : <any>null;
            this.callBackDateTime = _data["callBackDateTime"] ? moment(_data["callBackDateTime"].toString()) : <any>null;
            this.lastOrderDeliveredPercentage = _data["lastOrderDeliveredPercentage"] !== undefined ? _data["lastOrderDeliveredPercentage"] : <any>null;
            this.clientMadeEmailRequest = _data["clientMadeEmailRequest"] !== undefined ? _data["clientMadeEmailRequest"] : <any>null;
            this.status = _data["status"] !== undefined ? _data["status"] : <any>null;
            this.clientMadeEmailRequestOnDate = _data["clientMadeEmailRequestOnDate"] ? moment(_data["clientMadeEmailRequestOnDate"].toString()) : <any>null;
            this.lastOrderDeliveryDate = _data["lastOrderDeliveryDate"] ? moment(_data["lastOrderDeliveryDate"].toString()) : <any>null;
        }
    }

    static fromJS(data: any): CallbackClientLeadLookupDto {
        data = typeof data === 'object' ? data : {};
        let result = new CallbackClientLeadLookupDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["rating"] = this.rating !== undefined ? this.rating : <any>null;
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["index"] = this.index !== undefined ? this.index : <any>null;
        data["clientNumber"] = this.clientNumber !== undefined ? this.clientNumber : <any>null;
        data["assignedEmployeeId"] = this.assignedEmployeeId !== undefined ? this.assignedEmployeeId : <any>null;
        data["assignedEmployeeName"] = this.assignedEmployeeName !== undefined ? this.assignedEmployeeName : <any>null;
        data["assignedByEmployeeId"] = this.assignedByEmployeeId !== undefined ? this.assignedByEmployeeId : <any>null;
        data["assignedByEmployeeName"] = this.assignedByEmployeeName !== undefined ? this.assignedByEmployeeName : <any>null;
        data["assignedEmployeeDateTime"] = this.assignedEmployeeDateTime ? this.assignedEmployeeDateTime.toISOString() : <any>null;
        data["createdDateTime"] = this.createdDateTime ? this.createdDateTime.toISOString() : <any>null;
        data["city"] = this.city !== undefined ? this.city : <any>null;
        data["orderTotalValueIncludingFees"] = this.orderTotalValueIncludingFees !== undefined ? this.orderTotalValueIncludingFees : <any>null;
        data["renewalDate"] = this.renewalDate ? this.renewalDate.toISOString() : <any>null;
        data["callBackType"] = this.callBackType !== undefined ? this.callBackType : <any>null;
        data["callBackTypeDisplay"] = this.callBackTypeDisplay !== undefined ? this.callBackTypeDisplay : <any>null;
        data["contactAfterDateTime"] = this.contactAfterDateTime ? this.contactAfterDateTime.toISOString() : <any>null;
        data["callBackDateTime"] = this.callBackDateTime ? this.callBackDateTime.toISOString() : <any>null;
        data["lastOrderDeliveredPercentage"] = this.lastOrderDeliveredPercentage !== undefined ? this.lastOrderDeliveredPercentage : <any>null;
        data["clientMadeEmailRequest"] = this.clientMadeEmailRequest !== undefined ? this.clientMadeEmailRequest : <any>null;
        data["status"] = this.status !== undefined ? this.status : <any>null;
        data["clientMadeEmailRequestOnDate"] = this.clientMadeEmailRequestOnDate ? this.clientMadeEmailRequestOnDate.toISOString() : <any>null;
        data["lastOrderDeliveryDate"] = this.lastOrderDeliveryDate ? this.lastOrderDeliveryDate.toISOString() : <any>null;
        return data;
    }
}

export interface ICallbackClientLeadLookupDto {
    rating?: number | null;
    id?: number;
    index?: number;
    clientNumber?: number;
    assignedEmployeeId?: string | null;
    assignedEmployeeName?: string | null;
    assignedByEmployeeId?: string | null;
    assignedByEmployeeName?: string | null;
    assignedEmployeeDateTime?: moment.Moment | null;
    createdDateTime?: moment.Moment;
    city?: string | null;
    orderTotalValueIncludingFees?: number;
    renewalDate?: moment.Moment;
    callBackType?: CallBackType;
    callBackTypeDisplay?: string | null;
    contactAfterDateTime?: moment.Moment | null;
    callBackDateTime?: moment.Moment | null;
    lastOrderDeliveredPercentage?: number;
    clientMadeEmailRequest?: boolean;
    status?: CallbackClientLeadStatus;
    clientMadeEmailRequestOnDate?: moment.Moment | null;
    lastOrderDeliveryDate?: moment.Moment | null;
}

export enum CallBackType {
    Invalid = "invalid",
    Renewal = "renewal",
    Winback = "winback",
}

export enum CallbackClientLeadStatus {
    Invalid = "invalid",
    Open = "open",
    Closed = "closed",
    NotInterested = "notInterested",
    Unbookable = "unbookable",
    AutomatedClosed = "automatedClosed",
}

export class GetCallBackClientLeadsQuery extends PaginationModel implements IGetCallBackClientLeadsQuery {
    searchDateUtcRange?: (moment.Moment | null)[] | null;
    hasAssignedEmployee?: boolean;
    hasNoAssignedEmployee?: boolean;
    isRenewal?: boolean;
    isWinback?: boolean;
    onlyClientsWithEmailRequest?: boolean;
    includeContactAfter?: boolean;
    isInvalid?: boolean;
    isOpen?: boolean;
    isClosed?: boolean;
    isNotInterested?: boolean;
    isUnbookable?: boolean;
    isAutomatedClosed?: boolean;
    ignoreDateRange?: boolean;
    getFiveStarRatings?: boolean;
    getFourStarRatings?: boolean;
    getThreeStarRatings?: boolean;
    getTwoStarRatings?: boolean;
    getOneStarRatings?: boolean;
    getNoStarRatings?: boolean;

    constructor(data?: IGetCallBackClientLeadsQuery) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["searchDateUtcRange"])) {
                this.searchDateUtcRange = [] as any;
                for (let item of _data["searchDateUtcRange"])
                    this.searchDateUtcRange!.push(moment(item));
            }
            else {
                this.searchDateUtcRange = <any>null;
            }
            this.hasAssignedEmployee = _data["hasAssignedEmployee"] !== undefined ? _data["hasAssignedEmployee"] : <any>null;
            this.hasNoAssignedEmployee = _data["hasNoAssignedEmployee"] !== undefined ? _data["hasNoAssignedEmployee"] : <any>null;
            this.isRenewal = _data["isRenewal"] !== undefined ? _data["isRenewal"] : <any>null;
            this.isWinback = _data["isWinback"] !== undefined ? _data["isWinback"] : <any>null;
            this.onlyClientsWithEmailRequest = _data["onlyClientsWithEmailRequest"] !== undefined ? _data["onlyClientsWithEmailRequest"] : <any>null;
            this.includeContactAfter = _data["includeContactAfter"] !== undefined ? _data["includeContactAfter"] : <any>null;
            this.isInvalid = _data["isInvalid"] !== undefined ? _data["isInvalid"] : <any>null;
            this.isOpen = _data["isOpen"] !== undefined ? _data["isOpen"] : <any>null;
            this.isClosed = _data["isClosed"] !== undefined ? _data["isClosed"] : <any>null;
            this.isNotInterested = _data["isNotInterested"] !== undefined ? _data["isNotInterested"] : <any>null;
            this.isUnbookable = _data["isUnbookable"] !== undefined ? _data["isUnbookable"] : <any>null;
            this.isAutomatedClosed = _data["isAutomatedClosed"] !== undefined ? _data["isAutomatedClosed"] : <any>null;
            this.ignoreDateRange = _data["ignoreDateRange"] !== undefined ? _data["ignoreDateRange"] : <any>null;
            this.getFiveStarRatings = _data["getFiveStarRatings"] !== undefined ? _data["getFiveStarRatings"] : <any>null;
            this.getFourStarRatings = _data["getFourStarRatings"] !== undefined ? _data["getFourStarRatings"] : <any>null;
            this.getThreeStarRatings = _data["getThreeStarRatings"] !== undefined ? _data["getThreeStarRatings"] : <any>null;
            this.getTwoStarRatings = _data["getTwoStarRatings"] !== undefined ? _data["getTwoStarRatings"] : <any>null;
            this.getOneStarRatings = _data["getOneStarRatings"] !== undefined ? _data["getOneStarRatings"] : <any>null;
            this.getNoStarRatings = _data["getNoStarRatings"] !== undefined ? _data["getNoStarRatings"] : <any>null;
        }
    }

    static override fromJS(data: any): GetCallBackClientLeadsQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetCallBackClientLeadsQuery();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.searchDateUtcRange)) {
            data["searchDateUtcRange"] = [];
            for (let item of this.searchDateUtcRange)
                data["searchDateUtcRange"].push(item.toISOString());
        }
        data["hasAssignedEmployee"] = this.hasAssignedEmployee !== undefined ? this.hasAssignedEmployee : <any>null;
        data["hasNoAssignedEmployee"] = this.hasNoAssignedEmployee !== undefined ? this.hasNoAssignedEmployee : <any>null;
        data["isRenewal"] = this.isRenewal !== undefined ? this.isRenewal : <any>null;
        data["isWinback"] = this.isWinback !== undefined ? this.isWinback : <any>null;
        data["onlyClientsWithEmailRequest"] = this.onlyClientsWithEmailRequest !== undefined ? this.onlyClientsWithEmailRequest : <any>null;
        data["includeContactAfter"] = this.includeContactAfter !== undefined ? this.includeContactAfter : <any>null;
        data["isInvalid"] = this.isInvalid !== undefined ? this.isInvalid : <any>null;
        data["isOpen"] = this.isOpen !== undefined ? this.isOpen : <any>null;
        data["isClosed"] = this.isClosed !== undefined ? this.isClosed : <any>null;
        data["isNotInterested"] = this.isNotInterested !== undefined ? this.isNotInterested : <any>null;
        data["isUnbookable"] = this.isUnbookable !== undefined ? this.isUnbookable : <any>null;
        data["isAutomatedClosed"] = this.isAutomatedClosed !== undefined ? this.isAutomatedClosed : <any>null;
        data["ignoreDateRange"] = this.ignoreDateRange !== undefined ? this.ignoreDateRange : <any>null;
        data["getFiveStarRatings"] = this.getFiveStarRatings !== undefined ? this.getFiveStarRatings : <any>null;
        data["getFourStarRatings"] = this.getFourStarRatings !== undefined ? this.getFourStarRatings : <any>null;
        data["getThreeStarRatings"] = this.getThreeStarRatings !== undefined ? this.getThreeStarRatings : <any>null;
        data["getTwoStarRatings"] = this.getTwoStarRatings !== undefined ? this.getTwoStarRatings : <any>null;
        data["getOneStarRatings"] = this.getOneStarRatings !== undefined ? this.getOneStarRatings : <any>null;
        data["getNoStarRatings"] = this.getNoStarRatings !== undefined ? this.getNoStarRatings : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IGetCallBackClientLeadsQuery extends IPaginationModel {
    searchDateUtcRange?: (moment.Moment | null)[] | null;
    hasAssignedEmployee?: boolean;
    hasNoAssignedEmployee?: boolean;
    isRenewal?: boolean;
    isWinback?: boolean;
    onlyClientsWithEmailRequest?: boolean;
    includeContactAfter?: boolean;
    isInvalid?: boolean;
    isOpen?: boolean;
    isClosed?: boolean;
    isNotInterested?: boolean;
    isUnbookable?: boolean;
    isAutomatedClosed?: boolean;
    ignoreDateRange?: boolean;
    getFiveStarRatings?: boolean;
    getFourStarRatings?: boolean;
    getThreeStarRatings?: boolean;
    getTwoStarRatings?: boolean;
    getOneStarRatings?: boolean;
    getNoStarRatings?: boolean;
}

export class GetMyAssignedCallbackClientLeadsQuery extends PaginationModel implements IGetMyAssignedCallbackClientLeadsQuery {
    userId?: string | null;
    hasFollowUp?: boolean;
    hasNoFollowUp?: boolean;
    onlyClientsWithEmailRequest?: boolean;
    showOpen?: boolean;
    showClosed?: boolean;
    getFiveStarRatings?: boolean;
    getFourStarRatings?: boolean;
    getThreeStarRatings?: boolean;
    getTwoStarRatings?: boolean;
    getOneStarRatings?: boolean;
    getNoStarRatings?: boolean;

    constructor(data?: IGetMyAssignedCallbackClientLeadsQuery) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.userId = _data["userId"] !== undefined ? _data["userId"] : <any>null;
            this.hasFollowUp = _data["hasFollowUp"] !== undefined ? _data["hasFollowUp"] : <any>null;
            this.hasNoFollowUp = _data["hasNoFollowUp"] !== undefined ? _data["hasNoFollowUp"] : <any>null;
            this.onlyClientsWithEmailRequest = _data["onlyClientsWithEmailRequest"] !== undefined ? _data["onlyClientsWithEmailRequest"] : <any>null;
            this.showOpen = _data["showOpen"] !== undefined ? _data["showOpen"] : <any>null;
            this.showClosed = _data["showClosed"] !== undefined ? _data["showClosed"] : <any>null;
            this.getFiveStarRatings = _data["getFiveStarRatings"] !== undefined ? _data["getFiveStarRatings"] : <any>null;
            this.getFourStarRatings = _data["getFourStarRatings"] !== undefined ? _data["getFourStarRatings"] : <any>null;
            this.getThreeStarRatings = _data["getThreeStarRatings"] !== undefined ? _data["getThreeStarRatings"] : <any>null;
            this.getTwoStarRatings = _data["getTwoStarRatings"] !== undefined ? _data["getTwoStarRatings"] : <any>null;
            this.getOneStarRatings = _data["getOneStarRatings"] !== undefined ? _data["getOneStarRatings"] : <any>null;
            this.getNoStarRatings = _data["getNoStarRatings"] !== undefined ? _data["getNoStarRatings"] : <any>null;
        }
    }

    static override fromJS(data: any): GetMyAssignedCallbackClientLeadsQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetMyAssignedCallbackClientLeadsQuery();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId !== undefined ? this.userId : <any>null;
        data["hasFollowUp"] = this.hasFollowUp !== undefined ? this.hasFollowUp : <any>null;
        data["hasNoFollowUp"] = this.hasNoFollowUp !== undefined ? this.hasNoFollowUp : <any>null;
        data["onlyClientsWithEmailRequest"] = this.onlyClientsWithEmailRequest !== undefined ? this.onlyClientsWithEmailRequest : <any>null;
        data["showOpen"] = this.showOpen !== undefined ? this.showOpen : <any>null;
        data["showClosed"] = this.showClosed !== undefined ? this.showClosed : <any>null;
        data["getFiveStarRatings"] = this.getFiveStarRatings !== undefined ? this.getFiveStarRatings : <any>null;
        data["getFourStarRatings"] = this.getFourStarRatings !== undefined ? this.getFourStarRatings : <any>null;
        data["getThreeStarRatings"] = this.getThreeStarRatings !== undefined ? this.getThreeStarRatings : <any>null;
        data["getTwoStarRatings"] = this.getTwoStarRatings !== undefined ? this.getTwoStarRatings : <any>null;
        data["getOneStarRatings"] = this.getOneStarRatings !== undefined ? this.getOneStarRatings : <any>null;
        data["getNoStarRatings"] = this.getNoStarRatings !== undefined ? this.getNoStarRatings : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IGetMyAssignedCallbackClientLeadsQuery extends IPaginationModel {
    userId?: string | null;
    hasFollowUp?: boolean;
    hasNoFollowUp?: boolean;
    onlyClientsWithEmailRequest?: boolean;
    showOpen?: boolean;
    showClosed?: boolean;
    getFiveStarRatings?: boolean;
    getFourStarRatings?: boolean;
    getThreeStarRatings?: boolean;
    getTwoStarRatings?: boolean;
    getOneStarRatings?: boolean;
    getNoStarRatings?: boolean;
}

export class BaseClientLeadDto implements IBaseClientLeadDto {
    assignedEmployee?: NestedEmployeeDto | null;
    assignedEmployeeId?: string | null;
    assignedByEmployee?: NestedEmployeeDto | null;
    assignedByEmployeeId?: string | null;
    assignedEmployeeDateTime?: moment.Moment | null;
    createdDateTime?: moment.Moment;

    constructor(data?: IBaseClientLeadDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.assignedEmployee = _data["assignedEmployee"] ? NestedEmployeeDto.fromJS(_data["assignedEmployee"]) : <any>null;
            this.assignedEmployeeId = _data["assignedEmployeeId"] !== undefined ? _data["assignedEmployeeId"] : <any>null;
            this.assignedByEmployee = _data["assignedByEmployee"] ? NestedEmployeeDto.fromJS(_data["assignedByEmployee"]) : <any>null;
            this.assignedByEmployeeId = _data["assignedByEmployeeId"] !== undefined ? _data["assignedByEmployeeId"] : <any>null;
            this.assignedEmployeeDateTime = _data["assignedEmployeeDateTime"] ? moment(_data["assignedEmployeeDateTime"].toString()) : <any>null;
            this.createdDateTime = _data["createdDateTime"] ? moment(_data["createdDateTime"].toString()) : <any>null;
        }
    }

    static fromJS(data: any): BaseClientLeadDto {
        data = typeof data === 'object' ? data : {};
        let result = new BaseClientLeadDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["assignedEmployee"] = this.assignedEmployee ? this.assignedEmployee.toJSON() : <any>null;
        data["assignedEmployeeId"] = this.assignedEmployeeId !== undefined ? this.assignedEmployeeId : <any>null;
        data["assignedByEmployee"] = this.assignedByEmployee ? this.assignedByEmployee.toJSON() : <any>null;
        data["assignedByEmployeeId"] = this.assignedByEmployeeId !== undefined ? this.assignedByEmployeeId : <any>null;
        data["assignedEmployeeDateTime"] = this.assignedEmployeeDateTime ? this.assignedEmployeeDateTime.toISOString() : <any>null;
        data["createdDateTime"] = this.createdDateTime ? this.createdDateTime.toISOString() : <any>null;
        return data;
    }
}

export interface IBaseClientLeadDto {
    assignedEmployee?: NestedEmployeeDto | null;
    assignedEmployeeId?: string | null;
    assignedByEmployee?: NestedEmployeeDto | null;
    assignedByEmployeeId?: string | null;
    assignedEmployeeDateTime?: moment.Moment | null;
    createdDateTime?: moment.Moment;
}

export class CallBackClientLeadDto extends BaseClientLeadDto implements ICallBackClientLeadDto {
    id?: number;
    clientNumber?: number;
    city?: string | null;
    orderTotalValueIncludingFees?: number;
    renewalDate?: moment.Moment;
    firstDeliveryDate?: moment.Moment | null;
    callbackType?: CallBackType;
    callbackDateTime?: moment.Moment | null;
    lastOrderMonthDuration?: number | null;
    orderNo?: number;
    lastOrderDeliveredPercentage?: number;
    lastOrderDeliveryDate?: moment.Moment | null;

    constructor(data?: ICallBackClientLeadDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.clientNumber = _data["clientNumber"] !== undefined ? _data["clientNumber"] : <any>null;
            this.city = _data["city"] !== undefined ? _data["city"] : <any>null;
            this.orderTotalValueIncludingFees = _data["orderTotalValueIncludingFees"] !== undefined ? _data["orderTotalValueIncludingFees"] : <any>null;
            this.renewalDate = _data["renewalDate"] ? moment(_data["renewalDate"].toString()) : <any>null;
            this.firstDeliveryDate = _data["firstDeliveryDate"] ? moment(_data["firstDeliveryDate"].toString()) : <any>null;
            this.callbackType = _data["callbackType"] !== undefined ? _data["callbackType"] : <any>null;
            this.callbackDateTime = _data["callbackDateTime"] ? moment(_data["callbackDateTime"].toString()) : <any>null;
            this.lastOrderMonthDuration = _data["lastOrderMonthDuration"] !== undefined ? _data["lastOrderMonthDuration"] : <any>null;
            this.orderNo = _data["orderNo"] !== undefined ? _data["orderNo"] : <any>null;
            this.lastOrderDeliveredPercentage = _data["lastOrderDeliveredPercentage"] !== undefined ? _data["lastOrderDeliveredPercentage"] : <any>null;
            this.lastOrderDeliveryDate = _data["lastOrderDeliveryDate"] ? moment(_data["lastOrderDeliveryDate"].toString()) : <any>null;
        }
    }

    static override fromJS(data: any): CallBackClientLeadDto {
        data = typeof data === 'object' ? data : {};
        let result = new CallBackClientLeadDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["clientNumber"] = this.clientNumber !== undefined ? this.clientNumber : <any>null;
        data["city"] = this.city !== undefined ? this.city : <any>null;
        data["orderTotalValueIncludingFees"] = this.orderTotalValueIncludingFees !== undefined ? this.orderTotalValueIncludingFees : <any>null;
        data["renewalDate"] = this.renewalDate ? this.renewalDate.toISOString() : <any>null;
        data["firstDeliveryDate"] = this.firstDeliveryDate ? this.firstDeliveryDate.toISOString() : <any>null;
        data["callbackType"] = this.callbackType !== undefined ? this.callbackType : <any>null;
        data["callbackDateTime"] = this.callbackDateTime ? this.callbackDateTime.toISOString() : <any>null;
        data["lastOrderMonthDuration"] = this.lastOrderMonthDuration !== undefined ? this.lastOrderMonthDuration : <any>null;
        data["orderNo"] = this.orderNo !== undefined ? this.orderNo : <any>null;
        data["lastOrderDeliveredPercentage"] = this.lastOrderDeliveredPercentage !== undefined ? this.lastOrderDeliveredPercentage : <any>null;
        data["lastOrderDeliveryDate"] = this.lastOrderDeliveryDate ? this.lastOrderDeliveryDate.toISOString() : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface ICallBackClientLeadDto extends IBaseClientLeadDto {
    id?: number;
    clientNumber?: number;
    city?: string | null;
    orderTotalValueIncludingFees?: number;
    renewalDate?: moment.Moment;
    firstDeliveryDate?: moment.Moment | null;
    callbackType?: CallBackType;
    callbackDateTime?: moment.Moment | null;
    lastOrderMonthDuration?: number | null;
    orderNo?: number;
    lastOrderDeliveredPercentage?: number;
    lastOrderDeliveryDate?: moment.Moment | null;
}

export class GetCallBackClientLeadsAggregatedRatingsQueryResponse implements IGetCallBackClientLeadsAggregatedRatingsQueryResponse {
    fiveStarRatingCount?: number;
    fourStarRatingCount?: number;
    threeStarRatingCount?: number;
    twoStarRatingCount?: number;
    oneStarRatingCount?: number;
    noStarRatingCount?: number;

    constructor(data?: IGetCallBackClientLeadsAggregatedRatingsQueryResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fiveStarRatingCount = _data["fiveStarRatingCount"] !== undefined ? _data["fiveStarRatingCount"] : <any>null;
            this.fourStarRatingCount = _data["fourStarRatingCount"] !== undefined ? _data["fourStarRatingCount"] : <any>null;
            this.threeStarRatingCount = _data["threeStarRatingCount"] !== undefined ? _data["threeStarRatingCount"] : <any>null;
            this.twoStarRatingCount = _data["twoStarRatingCount"] !== undefined ? _data["twoStarRatingCount"] : <any>null;
            this.oneStarRatingCount = _data["oneStarRatingCount"] !== undefined ? _data["oneStarRatingCount"] : <any>null;
            this.noStarRatingCount = _data["noStarRatingCount"] !== undefined ? _data["noStarRatingCount"] : <any>null;
        }
    }

    static fromJS(data: any): GetCallBackClientLeadsAggregatedRatingsQueryResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetCallBackClientLeadsAggregatedRatingsQueryResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fiveStarRatingCount"] = this.fiveStarRatingCount !== undefined ? this.fiveStarRatingCount : <any>null;
        data["fourStarRatingCount"] = this.fourStarRatingCount !== undefined ? this.fourStarRatingCount : <any>null;
        data["threeStarRatingCount"] = this.threeStarRatingCount !== undefined ? this.threeStarRatingCount : <any>null;
        data["twoStarRatingCount"] = this.twoStarRatingCount !== undefined ? this.twoStarRatingCount : <any>null;
        data["oneStarRatingCount"] = this.oneStarRatingCount !== undefined ? this.oneStarRatingCount : <any>null;
        data["noStarRatingCount"] = this.noStarRatingCount !== undefined ? this.noStarRatingCount : <any>null;
        return data;
    }
}

export interface IGetCallBackClientLeadsAggregatedRatingsQueryResponse {
    fiveStarRatingCount?: number;
    fourStarRatingCount?: number;
    threeStarRatingCount?: number;
    twoStarRatingCount?: number;
    oneStarRatingCount?: number;
    noStarRatingCount?: number;
}

export class GetCallBackClientLeadsAggregatedRatingsQuery implements IGetCallBackClientLeadsAggregatedRatingsQuery {
    searchDateUtcRange?: (moment.Moment | null)[] | null;
    hasAssignedEmployee?: boolean;
    hasNoAssignedEmployee?: boolean;
    isRenewal?: boolean;
    isWinback?: boolean;
    onlyClientsWithEmailRequest?: boolean;
    includeContactAfter?: boolean;
    isInvalid?: boolean;
    isOpen?: boolean;
    isClosed?: boolean;
    isNotInterested?: boolean;
    isUnbookable?: boolean;
    isAutomatedClosed?: boolean;
    ignoreDateRange?: boolean;
    searchString?: string | null;

    constructor(data?: IGetCallBackClientLeadsAggregatedRatingsQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["searchDateUtcRange"])) {
                this.searchDateUtcRange = [] as any;
                for (let item of _data["searchDateUtcRange"])
                    this.searchDateUtcRange!.push(moment(item));
            }
            else {
                this.searchDateUtcRange = <any>null;
            }
            this.hasAssignedEmployee = _data["hasAssignedEmployee"] !== undefined ? _data["hasAssignedEmployee"] : <any>null;
            this.hasNoAssignedEmployee = _data["hasNoAssignedEmployee"] !== undefined ? _data["hasNoAssignedEmployee"] : <any>null;
            this.isRenewal = _data["isRenewal"] !== undefined ? _data["isRenewal"] : <any>null;
            this.isWinback = _data["isWinback"] !== undefined ? _data["isWinback"] : <any>null;
            this.onlyClientsWithEmailRequest = _data["onlyClientsWithEmailRequest"] !== undefined ? _data["onlyClientsWithEmailRequest"] : <any>null;
            this.includeContactAfter = _data["includeContactAfter"] !== undefined ? _data["includeContactAfter"] : <any>null;
            this.isInvalid = _data["isInvalid"] !== undefined ? _data["isInvalid"] : <any>null;
            this.isOpen = _data["isOpen"] !== undefined ? _data["isOpen"] : <any>null;
            this.isClosed = _data["isClosed"] !== undefined ? _data["isClosed"] : <any>null;
            this.isNotInterested = _data["isNotInterested"] !== undefined ? _data["isNotInterested"] : <any>null;
            this.isUnbookable = _data["isUnbookable"] !== undefined ? _data["isUnbookable"] : <any>null;
            this.isAutomatedClosed = _data["isAutomatedClosed"] !== undefined ? _data["isAutomatedClosed"] : <any>null;
            this.ignoreDateRange = _data["ignoreDateRange"] !== undefined ? _data["ignoreDateRange"] : <any>null;
            this.searchString = _data["searchString"] !== undefined ? _data["searchString"] : <any>null;
        }
    }

    static fromJS(data: any): GetCallBackClientLeadsAggregatedRatingsQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetCallBackClientLeadsAggregatedRatingsQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.searchDateUtcRange)) {
            data["searchDateUtcRange"] = [];
            for (let item of this.searchDateUtcRange)
                data["searchDateUtcRange"].push(item.toISOString());
        }
        data["hasAssignedEmployee"] = this.hasAssignedEmployee !== undefined ? this.hasAssignedEmployee : <any>null;
        data["hasNoAssignedEmployee"] = this.hasNoAssignedEmployee !== undefined ? this.hasNoAssignedEmployee : <any>null;
        data["isRenewal"] = this.isRenewal !== undefined ? this.isRenewal : <any>null;
        data["isWinback"] = this.isWinback !== undefined ? this.isWinback : <any>null;
        data["onlyClientsWithEmailRequest"] = this.onlyClientsWithEmailRequest !== undefined ? this.onlyClientsWithEmailRequest : <any>null;
        data["includeContactAfter"] = this.includeContactAfter !== undefined ? this.includeContactAfter : <any>null;
        data["isInvalid"] = this.isInvalid !== undefined ? this.isInvalid : <any>null;
        data["isOpen"] = this.isOpen !== undefined ? this.isOpen : <any>null;
        data["isClosed"] = this.isClosed !== undefined ? this.isClosed : <any>null;
        data["isNotInterested"] = this.isNotInterested !== undefined ? this.isNotInterested : <any>null;
        data["isUnbookable"] = this.isUnbookable !== undefined ? this.isUnbookable : <any>null;
        data["isAutomatedClosed"] = this.isAutomatedClosed !== undefined ? this.isAutomatedClosed : <any>null;
        data["ignoreDateRange"] = this.ignoreDateRange !== undefined ? this.ignoreDateRange : <any>null;
        data["searchString"] = this.searchString !== undefined ? this.searchString : <any>null;
        return data;
    }
}

export interface IGetCallBackClientLeadsAggregatedRatingsQuery {
    searchDateUtcRange?: (moment.Moment | null)[] | null;
    hasAssignedEmployee?: boolean;
    hasNoAssignedEmployee?: boolean;
    isRenewal?: boolean;
    isWinback?: boolean;
    onlyClientsWithEmailRequest?: boolean;
    includeContactAfter?: boolean;
    isInvalid?: boolean;
    isOpen?: boolean;
    isClosed?: boolean;
    isNotInterested?: boolean;
    isUnbookable?: boolean;
    isAutomatedClosed?: boolean;
    ignoreDateRange?: boolean;
    searchString?: string | null;
}

export class GetMyCallBackClientLeadsAggregatedRatingsQueryResponse implements IGetMyCallBackClientLeadsAggregatedRatingsQueryResponse {
    fiveStarRatingCount?: number;
    fourStarRatingCount?: number;
    threeStarRatingCount?: number;
    twoStarRatingCount?: number;
    oneStarRatingCount?: number;
    noStarRatingCount?: number;

    constructor(data?: IGetMyCallBackClientLeadsAggregatedRatingsQueryResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fiveStarRatingCount = _data["fiveStarRatingCount"] !== undefined ? _data["fiveStarRatingCount"] : <any>null;
            this.fourStarRatingCount = _data["fourStarRatingCount"] !== undefined ? _data["fourStarRatingCount"] : <any>null;
            this.threeStarRatingCount = _data["threeStarRatingCount"] !== undefined ? _data["threeStarRatingCount"] : <any>null;
            this.twoStarRatingCount = _data["twoStarRatingCount"] !== undefined ? _data["twoStarRatingCount"] : <any>null;
            this.oneStarRatingCount = _data["oneStarRatingCount"] !== undefined ? _data["oneStarRatingCount"] : <any>null;
            this.noStarRatingCount = _data["noStarRatingCount"] !== undefined ? _data["noStarRatingCount"] : <any>null;
        }
    }

    static fromJS(data: any): GetMyCallBackClientLeadsAggregatedRatingsQueryResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetMyCallBackClientLeadsAggregatedRatingsQueryResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fiveStarRatingCount"] = this.fiveStarRatingCount !== undefined ? this.fiveStarRatingCount : <any>null;
        data["fourStarRatingCount"] = this.fourStarRatingCount !== undefined ? this.fourStarRatingCount : <any>null;
        data["threeStarRatingCount"] = this.threeStarRatingCount !== undefined ? this.threeStarRatingCount : <any>null;
        data["twoStarRatingCount"] = this.twoStarRatingCount !== undefined ? this.twoStarRatingCount : <any>null;
        data["oneStarRatingCount"] = this.oneStarRatingCount !== undefined ? this.oneStarRatingCount : <any>null;
        data["noStarRatingCount"] = this.noStarRatingCount !== undefined ? this.noStarRatingCount : <any>null;
        return data;
    }
}

export interface IGetMyCallBackClientLeadsAggregatedRatingsQueryResponse {
    fiveStarRatingCount?: number;
    fourStarRatingCount?: number;
    threeStarRatingCount?: number;
    twoStarRatingCount?: number;
    oneStarRatingCount?: number;
    noStarRatingCount?: number;
}

export class GetMyCallBackClientLeadsAggregatedRatingsQuery implements IGetMyCallBackClientLeadsAggregatedRatingsQuery {
    userId?: string | null;
    hasFollowUp?: boolean;
    hasNoFollowUp?: boolean;
    onlyClientsWithEmailRequest?: boolean;
    showOpen?: boolean;
    showClosed?: boolean;
    searchString?: string | null;

    constructor(data?: IGetMyCallBackClientLeadsAggregatedRatingsQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"] !== undefined ? _data["userId"] : <any>null;
            this.hasFollowUp = _data["hasFollowUp"] !== undefined ? _data["hasFollowUp"] : <any>null;
            this.hasNoFollowUp = _data["hasNoFollowUp"] !== undefined ? _data["hasNoFollowUp"] : <any>null;
            this.onlyClientsWithEmailRequest = _data["onlyClientsWithEmailRequest"] !== undefined ? _data["onlyClientsWithEmailRequest"] : <any>null;
            this.showOpen = _data["showOpen"] !== undefined ? _data["showOpen"] : <any>null;
            this.showClosed = _data["showClosed"] !== undefined ? _data["showClosed"] : <any>null;
            this.searchString = _data["searchString"] !== undefined ? _data["searchString"] : <any>null;
        }
    }

    static fromJS(data: any): GetMyCallBackClientLeadsAggregatedRatingsQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetMyCallBackClientLeadsAggregatedRatingsQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId !== undefined ? this.userId : <any>null;
        data["hasFollowUp"] = this.hasFollowUp !== undefined ? this.hasFollowUp : <any>null;
        data["hasNoFollowUp"] = this.hasNoFollowUp !== undefined ? this.hasNoFollowUp : <any>null;
        data["onlyClientsWithEmailRequest"] = this.onlyClientsWithEmailRequest !== undefined ? this.onlyClientsWithEmailRequest : <any>null;
        data["showOpen"] = this.showOpen !== undefined ? this.showOpen : <any>null;
        data["showClosed"] = this.showClosed !== undefined ? this.showClosed : <any>null;
        data["searchString"] = this.searchString !== undefined ? this.searchString : <any>null;
        return data;
    }
}

export interface IGetMyCallBackClientLeadsAggregatedRatingsQuery {
    userId?: string | null;
    hasFollowUp?: boolean;
    hasNoFollowUp?: boolean;
    onlyClientsWithEmailRequest?: boolean;
    showOpen?: boolean;
    showClosed?: boolean;
    searchString?: string | null;
}

export class AssignEmployeeToCallbackClientLeadsCommand implements IAssignEmployeeToCallbackClientLeadsCommand {
    employeeId?: string | null;
    callbackClientLeadsId?: number[] | null;

    constructor(data?: IAssignEmployeeToCallbackClientLeadsCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.employeeId = _data["employeeId"] !== undefined ? _data["employeeId"] : <any>null;
            if (Array.isArray(_data["callbackClientLeadsId"])) {
                this.callbackClientLeadsId = [] as any;
                for (let item of _data["callbackClientLeadsId"])
                    this.callbackClientLeadsId!.push(item);
            }
            else {
                this.callbackClientLeadsId = <any>null;
            }
        }
    }

    static fromJS(data: any): AssignEmployeeToCallbackClientLeadsCommand {
        data = typeof data === 'object' ? data : {};
        let result = new AssignEmployeeToCallbackClientLeadsCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["employeeId"] = this.employeeId !== undefined ? this.employeeId : <any>null;
        if (Array.isArray(this.callbackClientLeadsId)) {
            data["callbackClientLeadsId"] = [];
            for (let item of this.callbackClientLeadsId)
                data["callbackClientLeadsId"].push(item);
        }
        return data;
    }
}

export interface IAssignEmployeeToCallbackClientLeadsCommand {
    employeeId?: string | null;
    callbackClientLeadsId?: number[] | null;
}

export class UnassignEmployeeToCallbackClientLeadCommand implements IUnassignEmployeeToCallbackClientLeadCommand {
    callbackClientLeadsId?: number[] | null;

    constructor(data?: IUnassignEmployeeToCallbackClientLeadCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["callbackClientLeadsId"])) {
                this.callbackClientLeadsId = [] as any;
                for (let item of _data["callbackClientLeadsId"])
                    this.callbackClientLeadsId!.push(item);
            }
            else {
                this.callbackClientLeadsId = <any>null;
            }
        }
    }

    static fromJS(data: any): UnassignEmployeeToCallbackClientLeadCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UnassignEmployeeToCallbackClientLeadCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.callbackClientLeadsId)) {
            data["callbackClientLeadsId"] = [];
            for (let item of this.callbackClientLeadsId)
                data["callbackClientLeadsId"].push(item);
        }
        return data;
    }
}

export interface IUnassignEmployeeToCallbackClientLeadCommand {
    callbackClientLeadsId?: number[] | null;
}

export class PostponeCallbackClientLeadCommand implements IPostponeCallbackClientLeadCommand {
    clientNo?: number[] | null;

    constructor(data?: IPostponeCallbackClientLeadCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["clientNo"])) {
                this.clientNo = [] as any;
                for (let item of _data["clientNo"])
                    this.clientNo!.push(item);
            }
            else {
                this.clientNo = <any>null;
            }
        }
    }

    static fromJS(data: any): PostponeCallbackClientLeadCommand {
        data = typeof data === 'object' ? data : {};
        let result = new PostponeCallbackClientLeadCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.clientNo)) {
            data["clientNo"] = [];
            for (let item of this.clientNo)
                data["clientNo"].push(item);
        }
        return data;
    }
}

export interface IPostponeCallbackClientLeadCommand {
    clientNo?: number[] | null;
}

export class BaseLeadNoteDto implements IBaseLeadNoteDto {
    id?: string | null;
    noteType?: LeadNoteType;
    unbookableReason?: UnbookableReason | null;
    subject?: string | null;
    description?: string | null;
    createdByEmployee?: LookUpEmployeeViewModel | null;
    createdById?: string | null;
    callRating?: number | null;
    followUpDateTime?: moment.Moment | null;
    appointmentDateTime?: moment.Moment | null;
    callOccuredDateTime?: moment.Moment | null;
    sendNotification?: boolean;
    callee?: Callee | null;
    propertyId?: number;
    createdDateTime?: moment.Moment;
    lastUpdatedById?: string | null;

    constructor(data?: IBaseLeadNoteDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.noteType = _data["noteType"] !== undefined ? _data["noteType"] : <any>null;
            this.unbookableReason = _data["unbookableReason"] !== undefined ? _data["unbookableReason"] : <any>null;
            this.subject = _data["subject"] !== undefined ? _data["subject"] : <any>null;
            this.description = _data["description"] !== undefined ? _data["description"] : <any>null;
            this.createdByEmployee = _data["createdByEmployee"] ? LookUpEmployeeViewModel.fromJS(_data["createdByEmployee"]) : <any>null;
            this.createdById = _data["createdById"] !== undefined ? _data["createdById"] : <any>null;
            this.callRating = _data["callRating"] !== undefined ? _data["callRating"] : <any>null;
            this.followUpDateTime = _data["followUpDateTime"] ? moment(_data["followUpDateTime"].toString()) : <any>null;
            this.appointmentDateTime = _data["appointmentDateTime"] ? moment(_data["appointmentDateTime"].toString()) : <any>null;
            this.callOccuredDateTime = _data["callOccuredDateTime"] ? moment(_data["callOccuredDateTime"].toString()) : <any>null;
            this.sendNotification = _data["sendNotification"] !== undefined ? _data["sendNotification"] : <any>null;
            this.callee = _data["callee"] !== undefined ? _data["callee"] : <any>null;
            this.propertyId = _data["propertyId"] !== undefined ? _data["propertyId"] : <any>null;
            this.createdDateTime = _data["createdDateTime"] ? moment(_data["createdDateTime"].toString()) : <any>null;
            this.lastUpdatedById = _data["lastUpdatedById"] !== undefined ? _data["lastUpdatedById"] : <any>null;
        }
    }

    static fromJS(data: any): BaseLeadNoteDto {
        data = typeof data === 'object' ? data : {};
        let result = new BaseLeadNoteDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["noteType"] = this.noteType !== undefined ? this.noteType : <any>null;
        data["unbookableReason"] = this.unbookableReason !== undefined ? this.unbookableReason : <any>null;
        data["subject"] = this.subject !== undefined ? this.subject : <any>null;
        data["description"] = this.description !== undefined ? this.description : <any>null;
        data["createdByEmployee"] = this.createdByEmployee ? this.createdByEmployee.toJSON() : <any>null;
        data["createdById"] = this.createdById !== undefined ? this.createdById : <any>null;
        data["callRating"] = this.callRating !== undefined ? this.callRating : <any>null;
        data["followUpDateTime"] = this.followUpDateTime ? this.followUpDateTime.toISOString() : <any>null;
        data["appointmentDateTime"] = this.appointmentDateTime ? this.appointmentDateTime.toISOString() : <any>null;
        data["callOccuredDateTime"] = this.callOccuredDateTime ? this.callOccuredDateTime.toISOString() : <any>null;
        data["sendNotification"] = this.sendNotification !== undefined ? this.sendNotification : <any>null;
        data["callee"] = this.callee !== undefined ? this.callee : <any>null;
        data["propertyId"] = this.propertyId !== undefined ? this.propertyId : <any>null;
        data["createdDateTime"] = this.createdDateTime ? this.createdDateTime.toISOString() : <any>null;
        data["lastUpdatedById"] = this.lastUpdatedById !== undefined ? this.lastUpdatedById : <any>null;
        return data;
    }
}

export interface IBaseLeadNoteDto {
    id?: string | null;
    noteType?: LeadNoteType;
    unbookableReason?: UnbookableReason | null;
    subject?: string | null;
    description?: string | null;
    createdByEmployee?: LookUpEmployeeViewModel | null;
    createdById?: string | null;
    callRating?: number | null;
    followUpDateTime?: moment.Moment | null;
    appointmentDateTime?: moment.Moment | null;
    callOccuredDateTime?: moment.Moment | null;
    sendNotification?: boolean;
    callee?: Callee | null;
    propertyId?: number;
    createdDateTime?: moment.Moment;
    lastUpdatedById?: string | null;
}

export class CallbackClientLeadNoteDto extends BaseLeadNoteDto implements ICallbackClientLeadNoteDto {
    callbackClientLeadId?: number;
    clientLeadName?: string | null;
    callbackUnbookableReason?: CallbackUnbookableReason | null;
    notInterestedReason?: CallbackNotInterestedReason | null;

    constructor(data?: ICallbackClientLeadNoteDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.callbackClientLeadId = _data["callbackClientLeadId"] !== undefined ? _data["callbackClientLeadId"] : <any>null;
            this.clientLeadName = _data["clientLeadName"] !== undefined ? _data["clientLeadName"] : <any>null;
            this.callbackUnbookableReason = _data["callbackUnbookableReason"] !== undefined ? _data["callbackUnbookableReason"] : <any>null;
            this.notInterestedReason = _data["notInterestedReason"] !== undefined ? _data["notInterestedReason"] : <any>null;
        }
    }

    static override fromJS(data: any): CallbackClientLeadNoteDto {
        data = typeof data === 'object' ? data : {};
        let result = new CallbackClientLeadNoteDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["callbackClientLeadId"] = this.callbackClientLeadId !== undefined ? this.callbackClientLeadId : <any>null;
        data["clientLeadName"] = this.clientLeadName !== undefined ? this.clientLeadName : <any>null;
        data["callbackUnbookableReason"] = this.callbackUnbookableReason !== undefined ? this.callbackUnbookableReason : <any>null;
        data["notInterestedReason"] = this.notInterestedReason !== undefined ? this.notInterestedReason : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface ICallbackClientLeadNoteDto extends IBaseLeadNoteDto {
    callbackClientLeadId?: number;
    clientLeadName?: string | null;
    callbackUnbookableReason?: CallbackUnbookableReason | null;
    notInterestedReason?: CallbackNotInterestedReason | null;
}

export enum CallbackUnbookableReason {
    Invalid = "invalid",
    Divorced = "divorced",
    Moved = "moved",
    LostToCompetition = "lostToCompetition",
    Vegetarians = "vegetarians",
    MoreService = "moreService",
    FarmersOrHunters = "farmersOrHunters",
    RenewalAlreadyDone = "renewalAlreadyDone",
    BlockedOnCredit = "blockedOnCredit",
    Death = "death",
}

export enum CallbackNotInterestedReason {
    Invalid = "invalid",
    NotSatisfiedWithQuality = "notSatisfiedWithQuality",
    NotSatisfiedWithService = "notSatisfiedWithService",
    TightFinances = "tightFinances",
    TooExpensive = "tooExpensive",
    TooMuchOnStock = "tooMuchOnStock",
    EncouragesTheLocal = "encouragesTheLocal",
    NotEnoughEcological = "notEnoughEcological",
    WantNoFollowUp = "wantNoFollowUp",
}

export enum LeadNoteType {
    FollowUp = "followUp",
    Comment = "comment",
    Appointment = "appointment",
    Call = "call",
    Other = "other",
    NotInterested = "notInterested",
    Unbookable = "unbookable",
}

export enum UnbookableReason {
    Corporate = "corporate",
    Medical = "medical",
    Professional = "professional",
    Commercial = "commercial",
    BadNumber = "badNumber",
}

export class LookUpEmployeeViewModel implements ILookUpEmployeeViewModel {
    name?: string | null;
    id?: string | null;

    constructor(data?: ILookUpEmployeeViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
        }
    }

    static fromJS(data: any): LookUpEmployeeViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new LookUpEmployeeViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["id"] = this.id !== undefined ? this.id : <any>null;
        return data;
    }
}

export interface ILookUpEmployeeViewModel {
    name?: string | null;
    id?: string | null;
}

export enum Callee {
    Husband = "husband",
    Wife = "wife",
    Other = "other",
}

export class BaseCallbackClientLeadNoteCommand implements IBaseCallbackClientLeadNoteCommand {
    callbackClientLeadNote?: CallbackClientLeadNoteDto | null;

    constructor(data?: IBaseCallbackClientLeadNoteCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.callbackClientLeadNote = _data["callbackClientLeadNote"] ? CallbackClientLeadNoteDto.fromJS(_data["callbackClientLeadNote"]) : <any>null;
        }
    }

    static fromJS(data: any): BaseCallbackClientLeadNoteCommand {
        data = typeof data === 'object' ? data : {};
        let result = new BaseCallbackClientLeadNoteCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["callbackClientLeadNote"] = this.callbackClientLeadNote ? this.callbackClientLeadNote.toJSON() : <any>null;
        return data;
    }
}

export interface IBaseCallbackClientLeadNoteCommand {
    callbackClientLeadNote?: CallbackClientLeadNoteDto | null;
}

export class AddCallbackClientLeadNoteCommand extends BaseCallbackClientLeadNoteCommand implements IAddCallbackClientLeadNoteCommand {
    insertLegacyNote?: boolean;

    constructor(data?: IAddCallbackClientLeadNoteCommand) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.insertLegacyNote = _data["insertLegacyNote"] !== undefined ? _data["insertLegacyNote"] : <any>null;
        }
    }

    static override fromJS(data: any): AddCallbackClientLeadNoteCommand {
        data = typeof data === 'object' ? data : {};
        let result = new AddCallbackClientLeadNoteCommand();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["insertLegacyNote"] = this.insertLegacyNote !== undefined ? this.insertLegacyNote : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IAddCallbackClientLeadNoteCommand extends IBaseCallbackClientLeadNoteCommand {
    insertLegacyNote?: boolean;
}

export class EditCallbackClientLeadNoteCommand extends BaseCallbackClientLeadNoteCommand implements IEditCallbackClientLeadNoteCommand {

    constructor(data?: IEditCallbackClientLeadNoteCommand) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): EditCallbackClientLeadNoteCommand {
        data = typeof data === 'object' ? data : {};
        let result = new EditCallbackClientLeadNoteCommand();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IEditCallbackClientLeadNoteCommand extends IBaseCallbackClientLeadNoteCommand {
}

export class NonRenouveleVocalComDto implements INonRenouveleVocalComDto {
    noCommande?: number;
    noClient?: number;
    nom?: string | null;
    conjoint?: string | null;
    nomVendeur?: string | null;
    address?: string | null;
    ville?: string | null;
    nbreLivraison?: string | null;
    dateLivraison?: moment.Moment;
    renouvellement?: number;
    renouDate?: moment.Moment;
    nonToutLivree?: boolean;
    enrecouvrement?: boolean;
    distributeur?: string | null;

    constructor(data?: INonRenouveleVocalComDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.noCommande = _data["noCommande"] !== undefined ? _data["noCommande"] : <any>null;
            this.noClient = _data["noClient"] !== undefined ? _data["noClient"] : <any>null;
            this.nom = _data["nom"] !== undefined ? _data["nom"] : <any>null;
            this.conjoint = _data["conjoint"] !== undefined ? _data["conjoint"] : <any>null;
            this.nomVendeur = _data["nomVendeur"] !== undefined ? _data["nomVendeur"] : <any>null;
            this.address = _data["address"] !== undefined ? _data["address"] : <any>null;
            this.ville = _data["ville"] !== undefined ? _data["ville"] : <any>null;
            this.nbreLivraison = _data["nbreLivraison"] !== undefined ? _data["nbreLivraison"] : <any>null;
            this.dateLivraison = _data["dateLivraison"] ? moment(_data["dateLivraison"].toString()) : <any>null;
            this.renouvellement = _data["renouvellement"] !== undefined ? _data["renouvellement"] : <any>null;
            this.renouDate = _data["renouDate"] ? moment(_data["renouDate"].toString()) : <any>null;
            this.nonToutLivree = _data["nonToutLivree"] !== undefined ? _data["nonToutLivree"] : <any>null;
            this.enrecouvrement = _data["enrecouvrement"] !== undefined ? _data["enrecouvrement"] : <any>null;
            this.distributeur = _data["distributeur"] !== undefined ? _data["distributeur"] : <any>null;
        }
    }

    static fromJS(data: any): NonRenouveleVocalComDto {
        data = typeof data === 'object' ? data : {};
        let result = new NonRenouveleVocalComDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["noCommande"] = this.noCommande !== undefined ? this.noCommande : <any>null;
        data["noClient"] = this.noClient !== undefined ? this.noClient : <any>null;
        data["nom"] = this.nom !== undefined ? this.nom : <any>null;
        data["conjoint"] = this.conjoint !== undefined ? this.conjoint : <any>null;
        data["nomVendeur"] = this.nomVendeur !== undefined ? this.nomVendeur : <any>null;
        data["address"] = this.address !== undefined ? this.address : <any>null;
        data["ville"] = this.ville !== undefined ? this.ville : <any>null;
        data["nbreLivraison"] = this.nbreLivraison !== undefined ? this.nbreLivraison : <any>null;
        data["dateLivraison"] = this.dateLivraison ? this.dateLivraison.toISOString() : <any>null;
        data["renouvellement"] = this.renouvellement !== undefined ? this.renouvellement : <any>null;
        data["renouDate"] = this.renouDate ? this.renouDate.toISOString() : <any>null;
        data["nonToutLivree"] = this.nonToutLivree !== undefined ? this.nonToutLivree : <any>null;
        data["enrecouvrement"] = this.enrecouvrement !== undefined ? this.enrecouvrement : <any>null;
        data["distributeur"] = this.distributeur !== undefined ? this.distributeur : <any>null;
        return data;
    }
}

export interface INonRenouveleVocalComDto {
    noCommande?: number;
    noClient?: number;
    nom?: string | null;
    conjoint?: string | null;
    nomVendeur?: string | null;
    address?: string | null;
    ville?: string | null;
    nbreLivraison?: string | null;
    dateLivraison?: moment.Moment;
    renouvellement?: number;
    renouDate?: moment.Moment;
    nonToutLivree?: boolean;
    enrecouvrement?: boolean;
    distributeur?: string | null;
}

export class GetCallbackRenewalClientLeadsQuery implements IGetCallbackRenewalClientLeadsQuery {
    startDate?: moment.Moment;
    endDate?: moment.Moment;

    constructor(data?: IGetCallbackRenewalClientLeadsQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.startDate = _data["startDate"] ? moment(_data["startDate"].toString()) : <any>null;
            this.endDate = _data["endDate"] ? moment(_data["endDate"].toString()) : <any>null;
        }
    }

    static fromJS(data: any): GetCallbackRenewalClientLeadsQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetCallbackRenewalClientLeadsQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>null;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>null;
        return data;
    }
}

export interface IGetCallbackRenewalClientLeadsQuery {
    startDate?: moment.Moment;
    endDate?: moment.Moment;
}

export class ImportRenewalCallbacksFromClientNosCommand implements IImportRenewalCallbacksFromClientNosCommand {
    clientNos?: number[] | null;

    constructor(data?: IImportRenewalCallbacksFromClientNosCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["clientNos"])) {
                this.clientNos = [] as any;
                for (let item of _data["clientNos"])
                    this.clientNos!.push(item);
            }
            else {
                this.clientNos = <any>null;
            }
        }
    }

    static fromJS(data: any): ImportRenewalCallbacksFromClientNosCommand {
        data = typeof data === 'object' ? data : {};
        let result = new ImportRenewalCallbacksFromClientNosCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.clientNos)) {
            data["clientNos"] = [];
            for (let item of this.clientNos)
                data["clientNos"].push(item);
        }
        return data;
    }
}

export interface IImportRenewalCallbacksFromClientNosCommand {
    clientNos?: number[] | null;
}

export class CallCenterConfigurationsDto implements ICallCenterConfigurationsDto {
    id?: string | null;
    departmentName?: string | null;
    isMondayOpen?: boolean;
    isTuesdayOpen?: boolean;
    isWednesdayOpen?: boolean;
    isThursdayOpen?: boolean;
    isFridayOpen?: boolean;
    isSaturdayOpen?: boolean;
    isSundayOpen?: boolean;
    mondayOpenHour?: moment.Duration;
    mondayCloseHour?: moment.Duration;
    tuesdayOpenHour?: moment.Duration;
    tuesdayCloseHour?: moment.Duration;
    wednesdayOpenHour?: moment.Duration;
    wednesdayCloseHour?: moment.Duration;
    thursdayOpenHour?: moment.Duration;
    thursdayCloseHour?: moment.Duration;
    fridayOpenHour?: moment.Duration;
    fridayCloseHour?: moment.Duration;
    saturdayOpenHour?: moment.Duration;
    saturdayCloseHour?: moment.Duration;
    sundayOpenHour?: moment.Duration;
    sundayCloseHour?: moment.Duration;
    enableHighVolumeWarning?: boolean;
    maxHoldTime?: number;
    hoursOfOperationRecordingUrl?: string | null;
    workingHours?: string | null;
    isClosed?: boolean;

    constructor(data?: ICallCenterConfigurationsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.departmentName = _data["departmentName"] !== undefined ? _data["departmentName"] : <any>null;
            this.isMondayOpen = _data["isMondayOpen"] !== undefined ? _data["isMondayOpen"] : <any>null;
            this.isTuesdayOpen = _data["isTuesdayOpen"] !== undefined ? _data["isTuesdayOpen"] : <any>null;
            this.isWednesdayOpen = _data["isWednesdayOpen"] !== undefined ? _data["isWednesdayOpen"] : <any>null;
            this.isThursdayOpen = _data["isThursdayOpen"] !== undefined ? _data["isThursdayOpen"] : <any>null;
            this.isFridayOpen = _data["isFridayOpen"] !== undefined ? _data["isFridayOpen"] : <any>null;
            this.isSaturdayOpen = _data["isSaturdayOpen"] !== undefined ? _data["isSaturdayOpen"] : <any>null;
            this.isSundayOpen = _data["isSundayOpen"] !== undefined ? _data["isSundayOpen"] : <any>null;
            this.mondayOpenHour = _data["mondayOpenHour"] ? moment.duration(_data["mondayOpenHour"].toString()) : <any>null;
            this.mondayCloseHour = _data["mondayCloseHour"] ? moment.duration(_data["mondayCloseHour"].toString()) : <any>null;
            this.tuesdayOpenHour = _data["tuesdayOpenHour"] ? moment.duration(_data["tuesdayOpenHour"].toString()) : <any>null;
            this.tuesdayCloseHour = _data["tuesdayCloseHour"] ? moment.duration(_data["tuesdayCloseHour"].toString()) : <any>null;
            this.wednesdayOpenHour = _data["wednesdayOpenHour"] ? moment.duration(_data["wednesdayOpenHour"].toString()) : <any>null;
            this.wednesdayCloseHour = _data["wednesdayCloseHour"] ? moment.duration(_data["wednesdayCloseHour"].toString()) : <any>null;
            this.thursdayOpenHour = _data["thursdayOpenHour"] ? moment.duration(_data["thursdayOpenHour"].toString()) : <any>null;
            this.thursdayCloseHour = _data["thursdayCloseHour"] ? moment.duration(_data["thursdayCloseHour"].toString()) : <any>null;
            this.fridayOpenHour = _data["fridayOpenHour"] ? moment.duration(_data["fridayOpenHour"].toString()) : <any>null;
            this.fridayCloseHour = _data["fridayCloseHour"] ? moment.duration(_data["fridayCloseHour"].toString()) : <any>null;
            this.saturdayOpenHour = _data["saturdayOpenHour"] ? moment.duration(_data["saturdayOpenHour"].toString()) : <any>null;
            this.saturdayCloseHour = _data["saturdayCloseHour"] ? moment.duration(_data["saturdayCloseHour"].toString()) : <any>null;
            this.sundayOpenHour = _data["sundayOpenHour"] ? moment.duration(_data["sundayOpenHour"].toString()) : <any>null;
            this.sundayCloseHour = _data["sundayCloseHour"] ? moment.duration(_data["sundayCloseHour"].toString()) : <any>null;
            this.enableHighVolumeWarning = _data["enableHighVolumeWarning"] !== undefined ? _data["enableHighVolumeWarning"] : <any>null;
            this.maxHoldTime = _data["maxHoldTime"] !== undefined ? _data["maxHoldTime"] : <any>null;
            this.hoursOfOperationRecordingUrl = _data["hoursOfOperationRecordingUrl"] !== undefined ? _data["hoursOfOperationRecordingUrl"] : <any>null;
            this.workingHours = _data["workingHours"] !== undefined ? _data["workingHours"] : <any>null;
            this.isClosed = _data["isClosed"] !== undefined ? _data["isClosed"] : <any>null;
        }
    }

    static fromJS(data: any): CallCenterConfigurationsDto {
        data = typeof data === 'object' ? data : {};
        let result = new CallCenterConfigurationsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["departmentName"] = this.departmentName !== undefined ? this.departmentName : <any>null;
        data["isMondayOpen"] = this.isMondayOpen !== undefined ? this.isMondayOpen : <any>null;
        data["isTuesdayOpen"] = this.isTuesdayOpen !== undefined ? this.isTuesdayOpen : <any>null;
        data["isWednesdayOpen"] = this.isWednesdayOpen !== undefined ? this.isWednesdayOpen : <any>null;
        data["isThursdayOpen"] = this.isThursdayOpen !== undefined ? this.isThursdayOpen : <any>null;
        data["isFridayOpen"] = this.isFridayOpen !== undefined ? this.isFridayOpen : <any>null;
        data["isSaturdayOpen"] = this.isSaturdayOpen !== undefined ? this.isSaturdayOpen : <any>null;
        data["isSundayOpen"] = this.isSundayOpen !== undefined ? this.isSundayOpen : <any>null;
        data["mondayOpenHour"] = this.mondayOpenHour ? this.mondayOpenHour.format('d.hh:mm:ss.SS', { trim: false }) : <any>null;
        data["mondayCloseHour"] = this.mondayCloseHour ? this.mondayCloseHour.format('d.hh:mm:ss.SS', { trim: false }) : <any>null;
        data["tuesdayOpenHour"] = this.tuesdayOpenHour ? this.tuesdayOpenHour.format('d.hh:mm:ss.SS', { trim: false }) : <any>null;
        data["tuesdayCloseHour"] = this.tuesdayCloseHour ? this.tuesdayCloseHour.format('d.hh:mm:ss.SS', { trim: false }) : <any>null;
        data["wednesdayOpenHour"] = this.wednesdayOpenHour ? this.wednesdayOpenHour.format('d.hh:mm:ss.SS', { trim: false }) : <any>null;
        data["wednesdayCloseHour"] = this.wednesdayCloseHour ? this.wednesdayCloseHour.format('d.hh:mm:ss.SS', { trim: false }) : <any>null;
        data["thursdayOpenHour"] = this.thursdayOpenHour ? this.thursdayOpenHour.format('d.hh:mm:ss.SS', { trim: false }) : <any>null;
        data["thursdayCloseHour"] = this.thursdayCloseHour ? this.thursdayCloseHour.format('d.hh:mm:ss.SS', { trim: false }) : <any>null;
        data["fridayOpenHour"] = this.fridayOpenHour ? this.fridayOpenHour.format('d.hh:mm:ss.SS', { trim: false }) : <any>null;
        data["fridayCloseHour"] = this.fridayCloseHour ? this.fridayCloseHour.format('d.hh:mm:ss.SS', { trim: false }) : <any>null;
        data["saturdayOpenHour"] = this.saturdayOpenHour ? this.saturdayOpenHour.format('d.hh:mm:ss.SS', { trim: false }) : <any>null;
        data["saturdayCloseHour"] = this.saturdayCloseHour ? this.saturdayCloseHour.format('d.hh:mm:ss.SS', { trim: false }) : <any>null;
        data["sundayOpenHour"] = this.sundayOpenHour ? this.sundayOpenHour.format('d.hh:mm:ss.SS', { trim: false }) : <any>null;
        data["sundayCloseHour"] = this.sundayCloseHour ? this.sundayCloseHour.format('d.hh:mm:ss.SS', { trim: false }) : <any>null;
        data["enableHighVolumeWarning"] = this.enableHighVolumeWarning !== undefined ? this.enableHighVolumeWarning : <any>null;
        data["maxHoldTime"] = this.maxHoldTime !== undefined ? this.maxHoldTime : <any>null;
        data["hoursOfOperationRecordingUrl"] = this.hoursOfOperationRecordingUrl !== undefined ? this.hoursOfOperationRecordingUrl : <any>null;
        data["workingHours"] = this.workingHours !== undefined ? this.workingHours : <any>null;
        data["isClosed"] = this.isClosed !== undefined ? this.isClosed : <any>null;
        return data;
    }
}

export interface ICallCenterConfigurationsDto {
    id?: string | null;
    departmentName?: string | null;
    isMondayOpen?: boolean;
    isTuesdayOpen?: boolean;
    isWednesdayOpen?: boolean;
    isThursdayOpen?: boolean;
    isFridayOpen?: boolean;
    isSaturdayOpen?: boolean;
    isSundayOpen?: boolean;
    mondayOpenHour?: moment.Duration;
    mondayCloseHour?: moment.Duration;
    tuesdayOpenHour?: moment.Duration;
    tuesdayCloseHour?: moment.Duration;
    wednesdayOpenHour?: moment.Duration;
    wednesdayCloseHour?: moment.Duration;
    thursdayOpenHour?: moment.Duration;
    thursdayCloseHour?: moment.Duration;
    fridayOpenHour?: moment.Duration;
    fridayCloseHour?: moment.Duration;
    saturdayOpenHour?: moment.Duration;
    saturdayCloseHour?: moment.Duration;
    sundayOpenHour?: moment.Duration;
    sundayCloseHour?: moment.Duration;
    enableHighVolumeWarning?: boolean;
    maxHoldTime?: number;
    hoursOfOperationRecordingUrl?: string | null;
    workingHours?: string | null;
    isClosed?: boolean;
}

export class GetCallCenterConfigurationQuery implements IGetCallCenterConfigurationQuery {
    id?: string | null;

    constructor(data?: IGetCallCenterConfigurationQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
        }
    }

    static fromJS(data: any): GetCallCenterConfigurationQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetCallCenterConfigurationQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        return data;
    }
}

export interface IGetCallCenterConfigurationQuery {
    id?: string | null;
}

export class CallCenterDepartmentDto implements ICallCenterDepartmentDto {
    id?: string | null;
    departmentName?: string | null;
    enableHighVolumeWarning?: boolean;
    isClosed?: boolean;
    workingHours?: string | null;

    constructor(data?: ICallCenterDepartmentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.departmentName = _data["departmentName"] !== undefined ? _data["departmentName"] : <any>null;
            this.enableHighVolumeWarning = _data["enableHighVolumeWarning"] !== undefined ? _data["enableHighVolumeWarning"] : <any>null;
            this.isClosed = _data["isClosed"] !== undefined ? _data["isClosed"] : <any>null;
            this.workingHours = _data["workingHours"] !== undefined ? _data["workingHours"] : <any>null;
        }
    }

    static fromJS(data: any): CallCenterDepartmentDto {
        data = typeof data === 'object' ? data : {};
        let result = new CallCenterDepartmentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["departmentName"] = this.departmentName !== undefined ? this.departmentName : <any>null;
        data["enableHighVolumeWarning"] = this.enableHighVolumeWarning !== undefined ? this.enableHighVolumeWarning : <any>null;
        data["isClosed"] = this.isClosed !== undefined ? this.isClosed : <any>null;
        data["workingHours"] = this.workingHours !== undefined ? this.workingHours : <any>null;
        return data;
    }
}

export interface ICallCenterDepartmentDto {
    id?: string | null;
    departmentName?: string | null;
    enableHighVolumeWarning?: boolean;
    isClosed?: boolean;
    workingHours?: string | null;
}

/** Represents a void type, since Void is not a valid return type in C#. */
export class Unit implements IUnit {

    constructor(data?: IUnit) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): Unit {
        data = typeof data === 'object' ? data : {};
        let result = new Unit();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

/** Represents a void type, since Void is not a valid return type in C#. */
export interface IUnit {
}

export class AddHoursOfOperationsRecordingCommand implements IAddHoursOfOperationsRecordingCommand {
    departmentName?: string | null;
    uploadedFile?: string | null;
    fileName?: string | null;

    constructor(data?: IAddHoursOfOperationsRecordingCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.departmentName = _data["departmentName"] !== undefined ? _data["departmentName"] : <any>null;
            this.uploadedFile = _data["uploadedFile"] !== undefined ? _data["uploadedFile"] : <any>null;
            this.fileName = _data["fileName"] !== undefined ? _data["fileName"] : <any>null;
        }
    }

    static fromJS(data: any): AddHoursOfOperationsRecordingCommand {
        data = typeof data === 'object' ? data : {};
        let result = new AddHoursOfOperationsRecordingCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["departmentName"] = this.departmentName !== undefined ? this.departmentName : <any>null;
        data["uploadedFile"] = this.uploadedFile !== undefined ? this.uploadedFile : <any>null;
        data["fileName"] = this.fileName !== undefined ? this.fileName : <any>null;
        return data;
    }
}

export interface IAddHoursOfOperationsRecordingCommand {
    departmentName?: string | null;
    uploadedFile?: string | null;
    fileName?: string | null;
}

export class PaginatedResultOfStatutoryHolidayDto extends PaginatedResult implements IPaginatedResultOfStatutoryHolidayDto {
    entities?: StatutoryHolidayDto[] | null;

    constructor(data?: IPaginatedResultOfStatutoryHolidayDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["entities"])) {
                this.entities = [] as any;
                for (let item of _data["entities"])
                    this.entities!.push(StatutoryHolidayDto.fromJS(item));
            }
            else {
                this.entities = <any>null;
            }
        }
    }

    static override fromJS(data: any): PaginatedResultOfStatutoryHolidayDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResultOfStatutoryHolidayDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.entities)) {
            data["entities"] = [];
            for (let item of this.entities)
                data["entities"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IPaginatedResultOfStatutoryHolidayDto extends IPaginatedResult {
    entities?: StatutoryHolidayDto[] | null;
}

export class StatutoryHolidayDto implements IStatutoryHolidayDto {
    id?: string | null;
    name?: string | null;
    fromDate?: moment.Moment;
    toDate?: moment.Moment;
    isSingleDay?: boolean;
    assetName?: string | null;
    assetUrl?: string | null;

    constructor(data?: IStatutoryHolidayDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.fromDate = _data["fromDate"] ? moment(_data["fromDate"].toString()) : <any>null;
            this.toDate = _data["toDate"] ? moment(_data["toDate"].toString()) : <any>null;
            this.isSingleDay = _data["isSingleDay"] !== undefined ? _data["isSingleDay"] : <any>null;
            this.assetName = _data["assetName"] !== undefined ? _data["assetName"] : <any>null;
            this.assetUrl = _data["assetUrl"] !== undefined ? _data["assetUrl"] : <any>null;
        }
    }

    static fromJS(data: any): StatutoryHolidayDto {
        data = typeof data === 'object' ? data : {};
        let result = new StatutoryHolidayDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["fromDate"] = this.fromDate ? this.fromDate.toISOString() : <any>null;
        data["toDate"] = this.toDate ? this.toDate.toISOString() : <any>null;
        data["isSingleDay"] = this.isSingleDay !== undefined ? this.isSingleDay : <any>null;
        data["assetName"] = this.assetName !== undefined ? this.assetName : <any>null;
        data["assetUrl"] = this.assetUrl !== undefined ? this.assetUrl : <any>null;
        return data;
    }
}

export interface IStatutoryHolidayDto {
    id?: string | null;
    name?: string | null;
    fromDate?: moment.Moment;
    toDate?: moment.Moment;
    isSingleDay?: boolean;
    assetName?: string | null;
    assetUrl?: string | null;
}

export class GetStatutoryHolidaysQuery extends PaginationModel implements IGetStatutoryHolidaysQuery {
    showPastHolidays?: boolean;

    constructor(data?: IGetStatutoryHolidaysQuery) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.showPastHolidays = _data["showPastHolidays"] !== undefined ? _data["showPastHolidays"] : <any>null;
        }
    }

    static override fromJS(data: any): GetStatutoryHolidaysQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetStatutoryHolidaysQuery();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["showPastHolidays"] = this.showPastHolidays !== undefined ? this.showPastHolidays : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IGetStatutoryHolidaysQuery extends IPaginationModel {
    showPastHolidays?: boolean;
}

export class GetStatutoryHolidayQuery implements IGetStatutoryHolidayQuery {
    id?: string | null;

    constructor(data?: IGetStatutoryHolidayQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
        }
    }

    static fromJS(data: any): GetStatutoryHolidayQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetStatutoryHolidayQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        return data;
    }
}

export interface IGetStatutoryHolidayQuery {
    id?: string | null;
}

export class DeleteStatutoryHolidayCommand implements IDeleteStatutoryHolidayCommand {
    id?: string | null;

    constructor(data?: IDeleteStatutoryHolidayCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
        }
    }

    static fromJS(data: any): DeleteStatutoryHolidayCommand {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteStatutoryHolidayCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        return data;
    }
}

export interface IDeleteStatutoryHolidayCommand {
    id?: string | null;
}

export class UpdateStatutoryHolidayCommand implements IUpdateStatutoryHolidayCommand {
    statutoryHolidayDto?: StatutoryHolidayDto | null;
    uploadedFile?: string | null;
    fileName?: string | null;

    constructor(data?: IUpdateStatutoryHolidayCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statutoryHolidayDto = _data["statutoryHolidayDto"] ? StatutoryHolidayDto.fromJS(_data["statutoryHolidayDto"]) : <any>null;
            this.uploadedFile = _data["uploadedFile"] !== undefined ? _data["uploadedFile"] : <any>null;
            this.fileName = _data["fileName"] !== undefined ? _data["fileName"] : <any>null;
        }
    }

    static fromJS(data: any): UpdateStatutoryHolidayCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateStatutoryHolidayCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statutoryHolidayDto"] = this.statutoryHolidayDto ? this.statutoryHolidayDto.toJSON() : <any>null;
        data["uploadedFile"] = this.uploadedFile !== undefined ? this.uploadedFile : <any>null;
        data["fileName"] = this.fileName !== undefined ? this.fileName : <any>null;
        return data;
    }
}

export interface IUpdateStatutoryHolidayCommand {
    statutoryHolidayDto?: StatutoryHolidayDto | null;
    uploadedFile?: string | null;
    fileName?: string | null;
}

export class CreateStatutoryHolidayCommand implements ICreateStatutoryHolidayCommand {
    statutoryHoliday?: StatutoryHolidayDto | null;
    uploadedFile?: string | null;
    fileName?: string | null;

    constructor(data?: ICreateStatutoryHolidayCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statutoryHoliday = _data["statutoryHoliday"] ? StatutoryHolidayDto.fromJS(_data["statutoryHoliday"]) : <any>null;
            this.uploadedFile = _data["uploadedFile"] !== undefined ? _data["uploadedFile"] : <any>null;
            this.fileName = _data["fileName"] !== undefined ? _data["fileName"] : <any>null;
        }
    }

    static fromJS(data: any): CreateStatutoryHolidayCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateStatutoryHolidayCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statutoryHoliday"] = this.statutoryHoliday ? this.statutoryHoliday.toJSON() : <any>null;
        data["uploadedFile"] = this.uploadedFile !== undefined ? this.uploadedFile : <any>null;
        data["fileName"] = this.fileName !== undefined ? this.fileName : <any>null;
        return data;
    }
}

export interface ICreateStatutoryHolidayCommand {
    statutoryHoliday?: StatutoryHolidayDto | null;
    uploadedFile?: string | null;
    fileName?: string | null;
}

export class TwilioCommonRecordingsDto implements ITwilioCommonRecordingsDto {
    id?: string | null;
    recordingName?: string | null;
    assetName?: string | null;
    assetUrl?: string | null;

    constructor(data?: ITwilioCommonRecordingsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.recordingName = _data["recordingName"] !== undefined ? _data["recordingName"] : <any>null;
            this.assetName = _data["assetName"] !== undefined ? _data["assetName"] : <any>null;
            this.assetUrl = _data["assetUrl"] !== undefined ? _data["assetUrl"] : <any>null;
        }
    }

    static fromJS(data: any): TwilioCommonRecordingsDto {
        data = typeof data === 'object' ? data : {};
        let result = new TwilioCommonRecordingsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["recordingName"] = this.recordingName !== undefined ? this.recordingName : <any>null;
        data["assetName"] = this.assetName !== undefined ? this.assetName : <any>null;
        data["assetUrl"] = this.assetUrl !== undefined ? this.assetUrl : <any>null;
        return data;
    }
}

export interface ITwilioCommonRecordingsDto {
    id?: string | null;
    recordingName?: string | null;
    assetName?: string | null;
    assetUrl?: string | null;
}

export class UpdateTwilioCommondRecordingsCommand implements IUpdateTwilioCommondRecordingsCommand {
    unexpectedClosedRecordingFile?: string | null;
    highVolumeRecordingFile?: string | null;
    noAgentsAvailableRecordingFile?: string | null;
    offRampRecordingFile?: string | null;
    queuePositionRecordingFile?: string | null;

    constructor(data?: IUpdateTwilioCommondRecordingsCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.unexpectedClosedRecordingFile = _data["unexpectedClosedRecordingFile"] !== undefined ? _data["unexpectedClosedRecordingFile"] : <any>null;
            this.highVolumeRecordingFile = _data["highVolumeRecordingFile"] !== undefined ? _data["highVolumeRecordingFile"] : <any>null;
            this.noAgentsAvailableRecordingFile = _data["noAgentsAvailableRecordingFile"] !== undefined ? _data["noAgentsAvailableRecordingFile"] : <any>null;
            this.offRampRecordingFile = _data["offRampRecordingFile"] !== undefined ? _data["offRampRecordingFile"] : <any>null;
            this.queuePositionRecordingFile = _data["queuePositionRecordingFile"] !== undefined ? _data["queuePositionRecordingFile"] : <any>null;
        }
    }

    static fromJS(data: any): UpdateTwilioCommondRecordingsCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateTwilioCommondRecordingsCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["unexpectedClosedRecordingFile"] = this.unexpectedClosedRecordingFile !== undefined ? this.unexpectedClosedRecordingFile : <any>null;
        data["highVolumeRecordingFile"] = this.highVolumeRecordingFile !== undefined ? this.highVolumeRecordingFile : <any>null;
        data["noAgentsAvailableRecordingFile"] = this.noAgentsAvailableRecordingFile !== undefined ? this.noAgentsAvailableRecordingFile : <any>null;
        data["offRampRecordingFile"] = this.offRampRecordingFile !== undefined ? this.offRampRecordingFile : <any>null;
        data["queuePositionRecordingFile"] = this.queuePositionRecordingFile !== undefined ? this.queuePositionRecordingFile : <any>null;
        return data;
    }
}

export interface IUpdateTwilioCommondRecordingsCommand {
    unexpectedClosedRecordingFile?: string | null;
    highVolumeRecordingFile?: string | null;
    noAgentsAvailableRecordingFile?: string | null;
    offRampRecordingFile?: string | null;
    queuePositionRecordingFile?: string | null;
}

export class CampaignDto implements ICampaignDto {
    id?: number;
    name?: string | null;
    priority?: number;
    includeAllAgents?: boolean;
    createdDate?: moment.Moment;
    status?: CampaignStatus;
    associatedAgents?: EmployeeDto[] | null;

    constructor(data?: ICampaignDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.priority = _data["priority"] !== undefined ? _data["priority"] : <any>null;
            this.includeAllAgents = _data["includeAllAgents"] !== undefined ? _data["includeAllAgents"] : <any>null;
            this.createdDate = _data["createdDate"] ? moment(_data["createdDate"].toString()) : <any>null;
            this.status = _data["status"] !== undefined ? _data["status"] : <any>null;
            if (Array.isArray(_data["associatedAgents"])) {
                this.associatedAgents = [] as any;
                for (let item of _data["associatedAgents"])
                    this.associatedAgents!.push(EmployeeDto.fromJS(item));
            }
            else {
                this.associatedAgents = <any>null;
            }
        }
    }

    static fromJS(data: any): CampaignDto {
        data = typeof data === 'object' ? data : {};
        let result = new CampaignDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["priority"] = this.priority !== undefined ? this.priority : <any>null;
        data["includeAllAgents"] = this.includeAllAgents !== undefined ? this.includeAllAgents : <any>null;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>null;
        data["status"] = this.status !== undefined ? this.status : <any>null;
        if (Array.isArray(this.associatedAgents)) {
            data["associatedAgents"] = [];
            for (let item of this.associatedAgents)
                data["associatedAgents"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICampaignDto {
    id?: number;
    name?: string | null;
    priority?: number;
    includeAllAgents?: boolean;
    createdDate?: moment.Moment;
    status?: CampaignStatus;
    associatedAgents?: EmployeeDto[] | null;
}

export enum CampaignStatus {
    Open = "open",
    Closed = "closed",
}

export class EmployeeDto implements IEmployeeDto {
    id?: string | null;
    email?: string | null;
    workEmail?: string | null;
    name?: string | null;
    title?: Title | null;
    phoneNumber?: string | null;
    workNumber?: string | null;
    otherNumber?: string | null;
    position?: string | null;
    emergencyContactName?: string | null;
    emergencyPhoneNumber?: string | null;
    activeDirectoryUsername?: string | null;
    employeeNumber?: number;
    salesRepNumber?: number | null;
    accountLocked?: boolean;
    assignedRoles?: string[] | null;
    assignedPolicies?: string[] | null;
    salesRepProfile?: SalesRepProfile | null;
    isHidden?: boolean | null;
    lastPasswordChangedDate?: moment.Moment | null;
    deactivated?: boolean;
    image?: ImageMediaDto | null;
    sid?: string | null;

    constructor(data?: IEmployeeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.email = _data["email"] !== undefined ? _data["email"] : <any>null;
            this.workEmail = _data["workEmail"] !== undefined ? _data["workEmail"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.title = _data["title"] !== undefined ? _data["title"] : <any>null;
            this.phoneNumber = _data["phoneNumber"] !== undefined ? _data["phoneNumber"] : <any>null;
            this.workNumber = _data["workNumber"] !== undefined ? _data["workNumber"] : <any>null;
            this.otherNumber = _data["otherNumber"] !== undefined ? _data["otherNumber"] : <any>null;
            this.position = _data["position"] !== undefined ? _data["position"] : <any>null;
            this.emergencyContactName = _data["emergencyContactName"] !== undefined ? _data["emergencyContactName"] : <any>null;
            this.emergencyPhoneNumber = _data["emergencyPhoneNumber"] !== undefined ? _data["emergencyPhoneNumber"] : <any>null;
            this.activeDirectoryUsername = _data["activeDirectoryUsername"] !== undefined ? _data["activeDirectoryUsername"] : <any>null;
            this.employeeNumber = _data["employeeNumber"] !== undefined ? _data["employeeNumber"] : <any>null;
            this.salesRepNumber = _data["salesRepNumber"] !== undefined ? _data["salesRepNumber"] : <any>null;
            this.accountLocked = _data["accountLocked"] !== undefined ? _data["accountLocked"] : <any>null;
            if (Array.isArray(_data["assignedRoles"])) {
                this.assignedRoles = [] as any;
                for (let item of _data["assignedRoles"])
                    this.assignedRoles!.push(item);
            }
            else {
                this.assignedRoles = <any>null;
            }
            if (Array.isArray(_data["assignedPolicies"])) {
                this.assignedPolicies = [] as any;
                for (let item of _data["assignedPolicies"])
                    this.assignedPolicies!.push(item);
            }
            else {
                this.assignedPolicies = <any>null;
            }
            this.salesRepProfile = _data["salesRepProfile"] ? SalesRepProfile.fromJS(_data["salesRepProfile"]) : <any>null;
            this.isHidden = _data["isHidden"] !== undefined ? _data["isHidden"] : <any>null;
            this.lastPasswordChangedDate = _data["lastPasswordChangedDate"] ? moment(_data["lastPasswordChangedDate"].toString()) : <any>null;
            this.deactivated = _data["deactivated"] !== undefined ? _data["deactivated"] : <any>null;
            this.image = _data["image"] ? ImageMediaDto.fromJS(_data["image"]) : <any>null;
            this.sid = _data["sid"] !== undefined ? _data["sid"] : <any>null;
        }
    }

    static fromJS(data: any): EmployeeDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["email"] = this.email !== undefined ? this.email : <any>null;
        data["workEmail"] = this.workEmail !== undefined ? this.workEmail : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["title"] = this.title !== undefined ? this.title : <any>null;
        data["phoneNumber"] = this.phoneNumber !== undefined ? this.phoneNumber : <any>null;
        data["workNumber"] = this.workNumber !== undefined ? this.workNumber : <any>null;
        data["otherNumber"] = this.otherNumber !== undefined ? this.otherNumber : <any>null;
        data["position"] = this.position !== undefined ? this.position : <any>null;
        data["emergencyContactName"] = this.emergencyContactName !== undefined ? this.emergencyContactName : <any>null;
        data["emergencyPhoneNumber"] = this.emergencyPhoneNumber !== undefined ? this.emergencyPhoneNumber : <any>null;
        data["activeDirectoryUsername"] = this.activeDirectoryUsername !== undefined ? this.activeDirectoryUsername : <any>null;
        data["employeeNumber"] = this.employeeNumber !== undefined ? this.employeeNumber : <any>null;
        data["salesRepNumber"] = this.salesRepNumber !== undefined ? this.salesRepNumber : <any>null;
        data["accountLocked"] = this.accountLocked !== undefined ? this.accountLocked : <any>null;
        if (Array.isArray(this.assignedRoles)) {
            data["assignedRoles"] = [];
            for (let item of this.assignedRoles)
                data["assignedRoles"].push(item);
        }
        if (Array.isArray(this.assignedPolicies)) {
            data["assignedPolicies"] = [];
            for (let item of this.assignedPolicies)
                data["assignedPolicies"].push(item);
        }
        data["salesRepProfile"] = this.salesRepProfile ? this.salesRepProfile.toJSON() : <any>null;
        data["isHidden"] = this.isHidden !== undefined ? this.isHidden : <any>null;
        data["lastPasswordChangedDate"] = this.lastPasswordChangedDate ? this.lastPasswordChangedDate.toISOString() : <any>null;
        data["deactivated"] = this.deactivated !== undefined ? this.deactivated : <any>null;
        data["image"] = this.image ? this.image.toJSON() : <any>null;
        data["sid"] = this.sid !== undefined ? this.sid : <any>null;
        return data;
    }
}

export interface IEmployeeDto {
    id?: string | null;
    email?: string | null;
    workEmail?: string | null;
    name?: string | null;
    title?: Title | null;
    phoneNumber?: string | null;
    workNumber?: string | null;
    otherNumber?: string | null;
    position?: string | null;
    emergencyContactName?: string | null;
    emergencyPhoneNumber?: string | null;
    activeDirectoryUsername?: string | null;
    employeeNumber?: number;
    salesRepNumber?: number | null;
    accountLocked?: boolean;
    assignedRoles?: string[] | null;
    assignedPolicies?: string[] | null;
    salesRepProfile?: SalesRepProfile | null;
    isHidden?: boolean | null;
    lastPasswordChangedDate?: moment.Moment | null;
    deactivated?: boolean;
    image?: ImageMediaDto | null;
    sid?: string | null;
}

export class SalesRepProfile implements ISalesRepProfile {
    employeeId?: string | null;
    employee?: Employee | null;
    salesRepNumber?: number;

    constructor(data?: ISalesRepProfile) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.employeeId = _data["employeeId"] !== undefined ? _data["employeeId"] : <any>null;
            this.employee = _data["employee"] ? Employee.fromJS(_data["employee"]) : <any>null;
            this.salesRepNumber = _data["salesRepNumber"] !== undefined ? _data["salesRepNumber"] : <any>null;
        }
    }

    static fromJS(data: any): SalesRepProfile {
        data = typeof data === 'object' ? data : {};
        let result = new SalesRepProfile();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["employeeId"] = this.employeeId !== undefined ? this.employeeId : <any>null;
        data["employee"] = this.employee ? this.employee.toJSON() : <any>null;
        data["salesRepNumber"] = this.salesRepNumber !== undefined ? this.salesRepNumber : <any>null;
        return data;
    }
}

export interface ISalesRepProfile {
    employeeId?: string | null;
    employee?: Employee | null;
    salesRepNumber?: number;
}

export class IdentityUserOfString implements IIdentityUserOfString {
    id?: string | null;
    userName?: string | null;
    normalizedUserName?: string | null;
    email?: string | null;
    normalizedEmail?: string | null;
    emailConfirmed?: boolean;
    passwordHash?: string | null;
    securityStamp?: string | null;
    concurrencyStamp?: string | null;
    phoneNumber?: string | null;
    phoneNumberConfirmed?: boolean;
    twoFactorEnabled?: boolean;
    lockoutEnd?: moment.Moment | null;
    lockoutEnabled?: boolean;
    accessFailedCount?: number;

    constructor(data?: IIdentityUserOfString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.userName = _data["userName"] !== undefined ? _data["userName"] : <any>null;
            this.normalizedUserName = _data["normalizedUserName"] !== undefined ? _data["normalizedUserName"] : <any>null;
            this.email = _data["email"] !== undefined ? _data["email"] : <any>null;
            this.normalizedEmail = _data["normalizedEmail"] !== undefined ? _data["normalizedEmail"] : <any>null;
            this.emailConfirmed = _data["emailConfirmed"] !== undefined ? _data["emailConfirmed"] : <any>null;
            this.passwordHash = _data["passwordHash"] !== undefined ? _data["passwordHash"] : <any>null;
            this.securityStamp = _data["securityStamp"] !== undefined ? _data["securityStamp"] : <any>null;
            this.concurrencyStamp = _data["concurrencyStamp"] !== undefined ? _data["concurrencyStamp"] : <any>null;
            this.phoneNumber = _data["phoneNumber"] !== undefined ? _data["phoneNumber"] : <any>null;
            this.phoneNumberConfirmed = _data["phoneNumberConfirmed"] !== undefined ? _data["phoneNumberConfirmed"] : <any>null;
            this.twoFactorEnabled = _data["twoFactorEnabled"] !== undefined ? _data["twoFactorEnabled"] : <any>null;
            this.lockoutEnd = _data["lockoutEnd"] ? moment(_data["lockoutEnd"].toString()) : <any>null;
            this.lockoutEnabled = _data["lockoutEnabled"] !== undefined ? _data["lockoutEnabled"] : <any>null;
            this.accessFailedCount = _data["accessFailedCount"] !== undefined ? _data["accessFailedCount"] : <any>null;
        }
    }

    static fromJS(data: any): IdentityUserOfString {
        data = typeof data === 'object' ? data : {};
        let result = new IdentityUserOfString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["userName"] = this.userName !== undefined ? this.userName : <any>null;
        data["normalizedUserName"] = this.normalizedUserName !== undefined ? this.normalizedUserName : <any>null;
        data["email"] = this.email !== undefined ? this.email : <any>null;
        data["normalizedEmail"] = this.normalizedEmail !== undefined ? this.normalizedEmail : <any>null;
        data["emailConfirmed"] = this.emailConfirmed !== undefined ? this.emailConfirmed : <any>null;
        data["passwordHash"] = this.passwordHash !== undefined ? this.passwordHash : <any>null;
        data["securityStamp"] = this.securityStamp !== undefined ? this.securityStamp : <any>null;
        data["concurrencyStamp"] = this.concurrencyStamp !== undefined ? this.concurrencyStamp : <any>null;
        data["phoneNumber"] = this.phoneNumber !== undefined ? this.phoneNumber : <any>null;
        data["phoneNumberConfirmed"] = this.phoneNumberConfirmed !== undefined ? this.phoneNumberConfirmed : <any>null;
        data["twoFactorEnabled"] = this.twoFactorEnabled !== undefined ? this.twoFactorEnabled : <any>null;
        data["lockoutEnd"] = this.lockoutEnd ? this.lockoutEnd.toISOString() : <any>null;
        data["lockoutEnabled"] = this.lockoutEnabled !== undefined ? this.lockoutEnabled : <any>null;
        data["accessFailedCount"] = this.accessFailedCount !== undefined ? this.accessFailedCount : <any>null;
        return data;
    }
}

export interface IIdentityUserOfString {
    id?: string | null;
    userName?: string | null;
    normalizedUserName?: string | null;
    email?: string | null;
    normalizedEmail?: string | null;
    emailConfirmed?: boolean;
    passwordHash?: string | null;
    securityStamp?: string | null;
    concurrencyStamp?: string | null;
    phoneNumber?: string | null;
    phoneNumberConfirmed?: boolean;
    twoFactorEnabled?: boolean;
    lockoutEnd?: moment.Moment | null;
    lockoutEnabled?: boolean;
    accessFailedCount?: number;
}

export class IdentityUser extends IdentityUserOfString implements IIdentityUser {

    constructor(data?: IIdentityUser) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): IdentityUser {
        data = typeof data === 'object' ? data : {};
        let result = new IdentityUser();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IIdentityUser extends IIdentityUserOfString {
}

export class ApplicationUser extends IdentityUser implements IApplicationUser {
    name!: string;
    title?: Title;
    phoneNumber?: string | null;
    extensionPhoneNumber?: string | null;
    workNumber?: string | null;
    workExtensionPhoneNumber?: string | null;
    otherNumber?: string | null;
    address?: Address | null;

    constructor(data?: IApplicationUser) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.title = _data["title"] !== undefined ? _data["title"] : <any>null;
            this.phoneNumber = _data["phoneNumber"] !== undefined ? _data["phoneNumber"] : <any>null;
            this.extensionPhoneNumber = _data["extensionPhoneNumber"] !== undefined ? _data["extensionPhoneNumber"] : <any>null;
            this.workNumber = _data["workNumber"] !== undefined ? _data["workNumber"] : <any>null;
            this.workExtensionPhoneNumber = _data["workExtensionPhoneNumber"] !== undefined ? _data["workExtensionPhoneNumber"] : <any>null;
            this.otherNumber = _data["otherNumber"] !== undefined ? _data["otherNumber"] : <any>null;
            this.address = _data["address"] ? Address.fromJS(_data["address"]) : <any>null;
        }
    }

    static override fromJS(data: any): ApplicationUser {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicationUser();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["title"] = this.title !== undefined ? this.title : <any>null;
        data["phoneNumber"] = this.phoneNumber !== undefined ? this.phoneNumber : <any>null;
        data["extensionPhoneNumber"] = this.extensionPhoneNumber !== undefined ? this.extensionPhoneNumber : <any>null;
        data["workNumber"] = this.workNumber !== undefined ? this.workNumber : <any>null;
        data["workExtensionPhoneNumber"] = this.workExtensionPhoneNumber !== undefined ? this.workExtensionPhoneNumber : <any>null;
        data["otherNumber"] = this.otherNumber !== undefined ? this.otherNumber : <any>null;
        data["address"] = this.address ? this.address.toJSON() : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IApplicationUser extends IIdentityUser {
    name: string;
    title?: Title;
    phoneNumber?: string | null;
    extensionPhoneNumber?: string | null;
    workNumber?: string | null;
    workExtensionPhoneNumber?: string | null;
    otherNumber?: string | null;
    address?: Address | null;
}

export class Employee extends ApplicationUser implements IEmployee {
    position?: string | null;
    emergencyContactName?: string | null;
    emergencyPhoneNumber?: string | null;
    employeeNumber?: number;
    emergencyContactInformation?: EmergencyContactInformation | null;
    firstName?: string | null;
    lastName?: string | null;
    jobInformation?: JobInformation | null;
    activeDirectoryUsername?: string | null;
    assignedRoles?: string[] | null;
    salesRepProfile?: SalesRepProfile | null;
    isHidden?: boolean | null;
    lastPasswordChangedDate?: moment.Moment | null;
    deactivated?: boolean;
    image?: ImageMedia | null;
    imageId?: string | null;
    sid?: string | null;

    constructor(data?: IEmployee) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.position = _data["position"] !== undefined ? _data["position"] : <any>null;
            this.emergencyContactName = _data["emergencyContactName"] !== undefined ? _data["emergencyContactName"] : <any>null;
            this.emergencyPhoneNumber = _data["emergencyPhoneNumber"] !== undefined ? _data["emergencyPhoneNumber"] : <any>null;
            this.employeeNumber = _data["employeeNumber"] !== undefined ? _data["employeeNumber"] : <any>null;
            this.emergencyContactInformation = _data["emergencyContactInformation"] ? EmergencyContactInformation.fromJS(_data["emergencyContactInformation"]) : <any>null;
            this.firstName = _data["firstName"] !== undefined ? _data["firstName"] : <any>null;
            this.lastName = _data["lastName"] !== undefined ? _data["lastName"] : <any>null;
            this.jobInformation = _data["jobInformation"] ? JobInformation.fromJS(_data["jobInformation"]) : <any>null;
            this.activeDirectoryUsername = _data["activeDirectoryUsername"] !== undefined ? _data["activeDirectoryUsername"] : <any>null;
            if (Array.isArray(_data["assignedRoles"])) {
                this.assignedRoles = [] as any;
                for (let item of _data["assignedRoles"])
                    this.assignedRoles!.push(item);
            }
            else {
                this.assignedRoles = <any>null;
            }
            this.salesRepProfile = _data["salesRepProfile"] ? SalesRepProfile.fromJS(_data["salesRepProfile"]) : <any>null;
            this.isHidden = _data["isHidden"] !== undefined ? _data["isHidden"] : <any>null;
            this.lastPasswordChangedDate = _data["lastPasswordChangedDate"] ? moment(_data["lastPasswordChangedDate"].toString()) : <any>null;
            this.deactivated = _data["deactivated"] !== undefined ? _data["deactivated"] : <any>null;
            this.image = _data["image"] ? ImageMedia.fromJS(_data["image"]) : <any>null;
            this.imageId = _data["imageId"] !== undefined ? _data["imageId"] : <any>null;
            this.sid = _data["sid"] !== undefined ? _data["sid"] : <any>null;
        }
    }

    static override fromJS(data: any): Employee {
        data = typeof data === 'object' ? data : {};
        let result = new Employee();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["position"] = this.position !== undefined ? this.position : <any>null;
        data["emergencyContactName"] = this.emergencyContactName !== undefined ? this.emergencyContactName : <any>null;
        data["emergencyPhoneNumber"] = this.emergencyPhoneNumber !== undefined ? this.emergencyPhoneNumber : <any>null;
        data["employeeNumber"] = this.employeeNumber !== undefined ? this.employeeNumber : <any>null;
        data["emergencyContactInformation"] = this.emergencyContactInformation ? this.emergencyContactInformation.toJSON() : <any>null;
        data["firstName"] = this.firstName !== undefined ? this.firstName : <any>null;
        data["lastName"] = this.lastName !== undefined ? this.lastName : <any>null;
        data["jobInformation"] = this.jobInformation ? this.jobInformation.toJSON() : <any>null;
        data["activeDirectoryUsername"] = this.activeDirectoryUsername !== undefined ? this.activeDirectoryUsername : <any>null;
        if (Array.isArray(this.assignedRoles)) {
            data["assignedRoles"] = [];
            for (let item of this.assignedRoles)
                data["assignedRoles"].push(item);
        }
        data["salesRepProfile"] = this.salesRepProfile ? this.salesRepProfile.toJSON() : <any>null;
        data["isHidden"] = this.isHidden !== undefined ? this.isHidden : <any>null;
        data["lastPasswordChangedDate"] = this.lastPasswordChangedDate ? this.lastPasswordChangedDate.toISOString() : <any>null;
        data["deactivated"] = this.deactivated !== undefined ? this.deactivated : <any>null;
        data["image"] = this.image ? this.image.toJSON() : <any>null;
        data["imageId"] = this.imageId !== undefined ? this.imageId : <any>null;
        data["sid"] = this.sid !== undefined ? this.sid : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IEmployee extends IApplicationUser {
    position?: string | null;
    emergencyContactName?: string | null;
    emergencyPhoneNumber?: string | null;
    employeeNumber?: number;
    emergencyContactInformation?: EmergencyContactInformation | null;
    firstName?: string | null;
    lastName?: string | null;
    jobInformation?: JobInformation | null;
    activeDirectoryUsername?: string | null;
    assignedRoles?: string[] | null;
    salesRepProfile?: SalesRepProfile | null;
    isHidden?: boolean | null;
    lastPasswordChangedDate?: moment.Moment | null;
    deactivated?: boolean;
    image?: ImageMedia | null;
    imageId?: string | null;
    sid?: string | null;
}

export abstract class EntityOfString implements IEntityOfString {
    id?: string | null;

    constructor(data?: IEntityOfString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
        }
    }

    static fromJS(data: any): EntityOfString {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'EntityOfString' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        return data;
    }
}

export interface IEntityOfString {
    id?: string | null;
}

export class CommonMedia extends EntityOfString implements ICommonMedia {
    uploadedFileName?: string | null;
    internalDescription?: string | null;
    hasCaptions?: boolean;
    filePath?: string | null;
    fileName?: string | null;
    fileExtension?: string | null;
    uploadedOn?: moment.Moment;
    uploadedByUser?: ApplicationUser | null;
    uploadedByUserId?: string | null;
    fileSize?: number;

    constructor(data?: ICommonMedia) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.uploadedFileName = _data["uploadedFileName"] !== undefined ? _data["uploadedFileName"] : <any>null;
            this.internalDescription = _data["internalDescription"] !== undefined ? _data["internalDescription"] : <any>null;
            this.hasCaptions = _data["hasCaptions"] !== undefined ? _data["hasCaptions"] : <any>null;
            this.filePath = _data["filePath"] !== undefined ? _data["filePath"] : <any>null;
            this.fileName = _data["fileName"] !== undefined ? _data["fileName"] : <any>null;
            this.fileExtension = _data["fileExtension"] !== undefined ? _data["fileExtension"] : <any>null;
            this.uploadedOn = _data["uploadedOn"] ? moment(_data["uploadedOn"].toString()) : <any>null;
            this.uploadedByUser = _data["uploadedByUser"] ? ApplicationUser.fromJS(_data["uploadedByUser"]) : <any>null;
            this.uploadedByUserId = _data["uploadedByUserId"] !== undefined ? _data["uploadedByUserId"] : <any>null;
            this.fileSize = _data["fileSize"] !== undefined ? _data["fileSize"] : <any>null;
        }
    }

    static override fromJS(data: any): CommonMedia {
        data = typeof data === 'object' ? data : {};
        let result = new CommonMedia();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["uploadedFileName"] = this.uploadedFileName !== undefined ? this.uploadedFileName : <any>null;
        data["internalDescription"] = this.internalDescription !== undefined ? this.internalDescription : <any>null;
        data["hasCaptions"] = this.hasCaptions !== undefined ? this.hasCaptions : <any>null;
        data["filePath"] = this.filePath !== undefined ? this.filePath : <any>null;
        data["fileName"] = this.fileName !== undefined ? this.fileName : <any>null;
        data["fileExtension"] = this.fileExtension !== undefined ? this.fileExtension : <any>null;
        data["uploadedOn"] = this.uploadedOn ? this.uploadedOn.toISOString() : <any>null;
        data["uploadedByUser"] = this.uploadedByUser ? this.uploadedByUser.toJSON() : <any>null;
        data["uploadedByUserId"] = this.uploadedByUserId !== undefined ? this.uploadedByUserId : <any>null;
        data["fileSize"] = this.fileSize !== undefined ? this.fileSize : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface ICommonMedia extends IEntityOfString {
    uploadedFileName?: string | null;
    internalDescription?: string | null;
    hasCaptions?: boolean;
    filePath?: string | null;
    fileName?: string | null;
    fileExtension?: string | null;
    uploadedOn?: moment.Moment;
    uploadedByUser?: ApplicationUser | null;
    uploadedByUserId?: string | null;
    fileSize?: number;
}

export class ImageMedia extends CommonMedia implements IImageMedia {
    height?: number;
    width?: number;
    mediaId?: string | null;
    thumbnailPath?: string | null;

    constructor(data?: IImageMedia) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.height = _data["height"] !== undefined ? _data["height"] : <any>null;
            this.width = _data["width"] !== undefined ? _data["width"] : <any>null;
            this.mediaId = _data["mediaId"] !== undefined ? _data["mediaId"] : <any>null;
            this.thumbnailPath = _data["thumbnailPath"] !== undefined ? _data["thumbnailPath"] : <any>null;
        }
    }

    static override fromJS(data: any): ImageMedia {
        data = typeof data === 'object' ? data : {};
        let result = new ImageMedia();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["height"] = this.height !== undefined ? this.height : <any>null;
        data["width"] = this.width !== undefined ? this.width : <any>null;
        data["mediaId"] = this.mediaId !== undefined ? this.mediaId : <any>null;
        data["thumbnailPath"] = this.thumbnailPath !== undefined ? this.thumbnailPath : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IImageMedia extends ICommonMedia {
    height?: number;
    width?: number;
    mediaId?: string | null;
    thumbnailPath?: string | null;
}

export class PaginatedResultOfCampaignLookUpDto extends PaginatedResult implements IPaginatedResultOfCampaignLookUpDto {
    entities?: CampaignLookUpDto[] | null;

    constructor(data?: IPaginatedResultOfCampaignLookUpDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["entities"])) {
                this.entities = [] as any;
                for (let item of _data["entities"])
                    this.entities!.push(CampaignLookUpDto.fromJS(item));
            }
            else {
                this.entities = <any>null;
            }
        }
    }

    static override fromJS(data: any): PaginatedResultOfCampaignLookUpDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResultOfCampaignLookUpDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.entities)) {
            data["entities"] = [];
            for (let item of this.entities)
                data["entities"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IPaginatedResultOfCampaignLookUpDto extends IPaginatedResult {
    entities?: CampaignLookUpDto[] | null;
}

export class CampaignLookUpDto implements ICampaignLookUpDto {
    id?: number;
    name?: string | null;
    priority?: number;
    createdDate?: moment.Moment;
    status?: CampaignStatus;
    index?: number;
    totalClientLeads?: number;
    totalConsumedClientLeads?: number;
    percentageOfConsumedClientLeads?: number;
    totalClosedClientLeads?: number;
    percentageOfClosedClientLeads?: number;
    totalParkedClientLeads?: number;
    percentageOfParkedClientLeads?: number;
    totalRDVs?: number;
    totalAgents?: number;

    constructor(data?: ICampaignLookUpDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.priority = _data["priority"] !== undefined ? _data["priority"] : <any>null;
            this.createdDate = _data["createdDate"] ? moment(_data["createdDate"].toString()) : <any>null;
            this.status = _data["status"] !== undefined ? _data["status"] : <any>null;
            this.index = _data["index"] !== undefined ? _data["index"] : <any>null;
            this.totalClientLeads = _data["totalClientLeads"] !== undefined ? _data["totalClientLeads"] : <any>null;
            this.totalConsumedClientLeads = _data["totalConsumedClientLeads"] !== undefined ? _data["totalConsumedClientLeads"] : <any>null;
            this.percentageOfConsumedClientLeads = _data["percentageOfConsumedClientLeads"] !== undefined ? _data["percentageOfConsumedClientLeads"] : <any>null;
            this.totalClosedClientLeads = _data["totalClosedClientLeads"] !== undefined ? _data["totalClosedClientLeads"] : <any>null;
            this.percentageOfClosedClientLeads = _data["percentageOfClosedClientLeads"] !== undefined ? _data["percentageOfClosedClientLeads"] : <any>null;
            this.totalParkedClientLeads = _data["totalParkedClientLeads"] !== undefined ? _data["totalParkedClientLeads"] : <any>null;
            this.percentageOfParkedClientLeads = _data["percentageOfParkedClientLeads"] !== undefined ? _data["percentageOfParkedClientLeads"] : <any>null;
            this.totalRDVs = _data["totalRDVs"] !== undefined ? _data["totalRDVs"] : <any>null;
            this.totalAgents = _data["totalAgents"] !== undefined ? _data["totalAgents"] : <any>null;
        }
    }

    static fromJS(data: any): CampaignLookUpDto {
        data = typeof data === 'object' ? data : {};
        let result = new CampaignLookUpDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["priority"] = this.priority !== undefined ? this.priority : <any>null;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>null;
        data["status"] = this.status !== undefined ? this.status : <any>null;
        data["index"] = this.index !== undefined ? this.index : <any>null;
        data["totalClientLeads"] = this.totalClientLeads !== undefined ? this.totalClientLeads : <any>null;
        data["totalConsumedClientLeads"] = this.totalConsumedClientLeads !== undefined ? this.totalConsumedClientLeads : <any>null;
        data["percentageOfConsumedClientLeads"] = this.percentageOfConsumedClientLeads !== undefined ? this.percentageOfConsumedClientLeads : <any>null;
        data["totalClosedClientLeads"] = this.totalClosedClientLeads !== undefined ? this.totalClosedClientLeads : <any>null;
        data["percentageOfClosedClientLeads"] = this.percentageOfClosedClientLeads !== undefined ? this.percentageOfClosedClientLeads : <any>null;
        data["totalParkedClientLeads"] = this.totalParkedClientLeads !== undefined ? this.totalParkedClientLeads : <any>null;
        data["percentageOfParkedClientLeads"] = this.percentageOfParkedClientLeads !== undefined ? this.percentageOfParkedClientLeads : <any>null;
        data["totalRDVs"] = this.totalRDVs !== undefined ? this.totalRDVs : <any>null;
        data["totalAgents"] = this.totalAgents !== undefined ? this.totalAgents : <any>null;
        return data;
    }
}

export interface ICampaignLookUpDto {
    id?: number;
    name?: string | null;
    priority?: number;
    createdDate?: moment.Moment;
    status?: CampaignStatus;
    index?: number;
    totalClientLeads?: number;
    totalConsumedClientLeads?: number;
    percentageOfConsumedClientLeads?: number;
    totalClosedClientLeads?: number;
    percentageOfClosedClientLeads?: number;
    totalParkedClientLeads?: number;
    percentageOfParkedClientLeads?: number;
    totalRDVs?: number;
    totalAgents?: number;
}

export class GetCampaignListQuery extends PaginationModel implements IGetCampaignListQuery {
    isOpen?: boolean;
    isClosed?: boolean;
    hasAssociatedAgents?: boolean;
    hasNoAssociatedAgents?: boolean;
    hasUnconsumedLeads?: boolean;
    hasNoLeads?: boolean;

    constructor(data?: IGetCampaignListQuery) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.isOpen = _data["isOpen"] !== undefined ? _data["isOpen"] : <any>null;
            this.isClosed = _data["isClosed"] !== undefined ? _data["isClosed"] : <any>null;
            this.hasAssociatedAgents = _data["hasAssociatedAgents"] !== undefined ? _data["hasAssociatedAgents"] : <any>null;
            this.hasNoAssociatedAgents = _data["hasNoAssociatedAgents"] !== undefined ? _data["hasNoAssociatedAgents"] : <any>null;
            this.hasUnconsumedLeads = _data["hasUnconsumedLeads"] !== undefined ? _data["hasUnconsumedLeads"] : <any>null;
            this.hasNoLeads = _data["hasNoLeads"] !== undefined ? _data["hasNoLeads"] : <any>null;
        }
    }

    static override fromJS(data: any): GetCampaignListQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetCampaignListQuery();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isOpen"] = this.isOpen !== undefined ? this.isOpen : <any>null;
        data["isClosed"] = this.isClosed !== undefined ? this.isClosed : <any>null;
        data["hasAssociatedAgents"] = this.hasAssociatedAgents !== undefined ? this.hasAssociatedAgents : <any>null;
        data["hasNoAssociatedAgents"] = this.hasNoAssociatedAgents !== undefined ? this.hasNoAssociatedAgents : <any>null;
        data["hasUnconsumedLeads"] = this.hasUnconsumedLeads !== undefined ? this.hasUnconsumedLeads : <any>null;
        data["hasNoLeads"] = this.hasNoLeads !== undefined ? this.hasNoLeads : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IGetCampaignListQuery extends IPaginationModel {
    isOpen?: boolean;
    isClosed?: boolean;
    hasAssociatedAgents?: boolean;
    hasNoAssociatedAgents?: boolean;
    hasUnconsumedLeads?: boolean;
    hasNoLeads?: boolean;
}

export class PaginatedResultOfAgentCampaignsLookUpDto extends PaginatedResult implements IPaginatedResultOfAgentCampaignsLookUpDto {
    entities?: AgentCampaignsLookUpDto[] | null;

    constructor(data?: IPaginatedResultOfAgentCampaignsLookUpDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["entities"])) {
                this.entities = [] as any;
                for (let item of _data["entities"])
                    this.entities!.push(AgentCampaignsLookUpDto.fromJS(item));
            }
            else {
                this.entities = <any>null;
            }
        }
    }

    static override fromJS(data: any): PaginatedResultOfAgentCampaignsLookUpDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResultOfAgentCampaignsLookUpDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.entities)) {
            data["entities"] = [];
            for (let item of this.entities)
                data["entities"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IPaginatedResultOfAgentCampaignsLookUpDto extends IPaginatedResult {
    entities?: AgentCampaignsLookUpDto[] | null;
}

export class AgentCampaignsLookUpDto implements IAgentCampaignsLookUpDto {
    index?: number;
    id?: string | null;
    email?: string | null;
    name?: string | null;
    campaigns?: AgentCampaignDto[] | null;

    constructor(data?: IAgentCampaignsLookUpDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.index = _data["index"] !== undefined ? _data["index"] : <any>null;
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.email = _data["email"] !== undefined ? _data["email"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            if (Array.isArray(_data["campaigns"])) {
                this.campaigns = [] as any;
                for (let item of _data["campaigns"])
                    this.campaigns!.push(AgentCampaignDto.fromJS(item));
            }
            else {
                this.campaigns = <any>null;
            }
        }
    }

    static fromJS(data: any): AgentCampaignsLookUpDto {
        data = typeof data === 'object' ? data : {};
        let result = new AgentCampaignsLookUpDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["index"] = this.index !== undefined ? this.index : <any>null;
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["email"] = this.email !== undefined ? this.email : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        if (Array.isArray(this.campaigns)) {
            data["campaigns"] = [];
            for (let item of this.campaigns)
                data["campaigns"].push(item.toJSON());
        }
        return data;
    }
}

export interface IAgentCampaignsLookUpDto {
    index?: number;
    id?: string | null;
    email?: string | null;
    name?: string | null;
    campaigns?: AgentCampaignDto[] | null;
}

export class AgentCampaignDto implements IAgentCampaignDto {
    id?: number;
    name?: string | null;
    includeAllAgents?: boolean;
    status?: CampaignStatus;
    associatedAgents?: EmployeeDto[] | null;

    constructor(data?: IAgentCampaignDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.includeAllAgents = _data["includeAllAgents"] !== undefined ? _data["includeAllAgents"] : <any>null;
            this.status = _data["status"] !== undefined ? _data["status"] : <any>null;
            if (Array.isArray(_data["associatedAgents"])) {
                this.associatedAgents = [] as any;
                for (let item of _data["associatedAgents"])
                    this.associatedAgents!.push(EmployeeDto.fromJS(item));
            }
            else {
                this.associatedAgents = <any>null;
            }
        }
    }

    static fromJS(data: any): AgentCampaignDto {
        data = typeof data === 'object' ? data : {};
        let result = new AgentCampaignDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["includeAllAgents"] = this.includeAllAgents !== undefined ? this.includeAllAgents : <any>null;
        data["status"] = this.status !== undefined ? this.status : <any>null;
        if (Array.isArray(this.associatedAgents)) {
            data["associatedAgents"] = [];
            for (let item of this.associatedAgents)
                data["associatedAgents"].push(item.toJSON());
        }
        return data;
    }
}

export interface IAgentCampaignDto {
    id?: number;
    name?: string | null;
    includeAllAgents?: boolean;
    status?: CampaignStatus;
    associatedAgents?: EmployeeDto[] | null;
}

export class GetAgentCampaignsListQuery extends PaginationModel implements IGetAgentCampaignsListQuery {
    campaignId?: number;
    hasCampaigns?: boolean;
    hasNoCampaigns?: boolean;
    hasNoOpenCampaigns?: boolean;

    constructor(data?: IGetAgentCampaignsListQuery) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.campaignId = _data["campaignId"] !== undefined ? _data["campaignId"] : <any>null;
            this.hasCampaigns = _data["hasCampaigns"] !== undefined ? _data["hasCampaigns"] : <any>null;
            this.hasNoCampaigns = _data["hasNoCampaigns"] !== undefined ? _data["hasNoCampaigns"] : <any>null;
            this.hasNoOpenCampaigns = _data["hasNoOpenCampaigns"] !== undefined ? _data["hasNoOpenCampaigns"] : <any>null;
        }
    }

    static override fromJS(data: any): GetAgentCampaignsListQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetAgentCampaignsListQuery();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["campaignId"] = this.campaignId !== undefined ? this.campaignId : <any>null;
        data["hasCampaigns"] = this.hasCampaigns !== undefined ? this.hasCampaigns : <any>null;
        data["hasNoCampaigns"] = this.hasNoCampaigns !== undefined ? this.hasNoCampaigns : <any>null;
        data["hasNoOpenCampaigns"] = this.hasNoOpenCampaigns !== undefined ? this.hasNoOpenCampaigns : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IGetAgentCampaignsListQuery extends IPaginationModel {
    campaignId?: number;
    hasCampaigns?: boolean;
    hasNoCampaigns?: boolean;
    hasNoOpenCampaigns?: boolean;
}

export class UpsertCampaignCommand implements IUpsertCampaignCommand {
    id?: number;
    name?: string | null;
    priority?: number;
    status?: CampaignStatus;
    includeAllAgents?: boolean;
    associatedAgents?: EmployeeDto[] | null;

    constructor(data?: IUpsertCampaignCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.priority = _data["priority"] !== undefined ? _data["priority"] : <any>null;
            this.status = _data["status"] !== undefined ? _data["status"] : <any>null;
            this.includeAllAgents = _data["includeAllAgents"] !== undefined ? _data["includeAllAgents"] : <any>null;
            if (Array.isArray(_data["associatedAgents"])) {
                this.associatedAgents = [] as any;
                for (let item of _data["associatedAgents"])
                    this.associatedAgents!.push(EmployeeDto.fromJS(item));
            }
            else {
                this.associatedAgents = <any>null;
            }
        }
    }

    static fromJS(data: any): UpsertCampaignCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpsertCampaignCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["priority"] = this.priority !== undefined ? this.priority : <any>null;
        data["status"] = this.status !== undefined ? this.status : <any>null;
        data["includeAllAgents"] = this.includeAllAgents !== undefined ? this.includeAllAgents : <any>null;
        if (Array.isArray(this.associatedAgents)) {
            data["associatedAgents"] = [];
            for (let item of this.associatedAgents)
                data["associatedAgents"].push(item.toJSON());
        }
        return data;
    }
}

export interface IUpsertCampaignCommand {
    id?: number;
    name?: string | null;
    priority?: number;
    status?: CampaignStatus;
    includeAllAgents?: boolean;
    associatedAgents?: EmployeeDto[] | null;
}

export class RemoveCampaignAgentsCommand implements IRemoveCampaignAgentsCommand {
    campaignId?: number;
    employeeId?: string | null;

    constructor(data?: IRemoveCampaignAgentsCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.campaignId = _data["campaignId"] !== undefined ? _data["campaignId"] : <any>null;
            this.employeeId = _data["employeeId"] !== undefined ? _data["employeeId"] : <any>null;
        }
    }

    static fromJS(data: any): RemoveCampaignAgentsCommand {
        data = typeof data === 'object' ? data : {};
        let result = new RemoveCampaignAgentsCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["campaignId"] = this.campaignId !== undefined ? this.campaignId : <any>null;
        data["employeeId"] = this.employeeId !== undefined ? this.employeeId : <any>null;
        return data;
    }
}

export interface IRemoveCampaignAgentsCommand {
    campaignId?: number;
    employeeId?: string | null;
}

export class AssignAgentsToCampaignCommand implements IAssignAgentsToCampaignCommand {
    campaignId?: number;
    employeeIds?: string[] | null;

    constructor(data?: IAssignAgentsToCampaignCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.campaignId = _data["campaignId"] !== undefined ? _data["campaignId"] : <any>null;
            if (Array.isArray(_data["employeeIds"])) {
                this.employeeIds = [] as any;
                for (let item of _data["employeeIds"])
                    this.employeeIds!.push(item);
            }
            else {
                this.employeeIds = <any>null;
            }
        }
    }

    static fromJS(data: any): AssignAgentsToCampaignCommand {
        data = typeof data === 'object' ? data : {};
        let result = new AssignAgentsToCampaignCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["campaignId"] = this.campaignId !== undefined ? this.campaignId : <any>null;
        if (Array.isArray(this.employeeIds)) {
            data["employeeIds"] = [];
            for (let item of this.employeeIds)
                data["employeeIds"].push(item);
        }
        return data;
    }
}

export interface IAssignAgentsToCampaignCommand {
    campaignId?: number;
    employeeIds?: string[] | null;
}

export class CategoryDto implements ICategoryDto {
    id?: string | null;
    name?: string | null;
    nameEn?: string | null;
    descriptionEn?: string | null;
    descriptionFr?: string | null;
    taglineEn?: string | null;
    taglineFr?: string | null;
    categoryOrder?: number;
    menuCategoryOrder?: number;
    menuId?: string | null;
    mb?: boolean | null;
    isDisabled?: boolean;
    creationDateTime?: moment.Moment | null;
    modificationDateTime?: moment.Moment | null;
    deletionDateTime?: moment.Moment | null;
    products?: ProductDto[] | null;
    isCollapsed?: boolean;
    backgroundImage?: ImageMediaDto | null;
    icon?: ImageMediaDto | null;
    showInDigitalMenu?: boolean;

    constructor(data?: ICategoryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.nameEn = _data["nameEn"] !== undefined ? _data["nameEn"] : <any>null;
            this.descriptionEn = _data["descriptionEn"] !== undefined ? _data["descriptionEn"] : <any>null;
            this.descriptionFr = _data["descriptionFr"] !== undefined ? _data["descriptionFr"] : <any>null;
            this.taglineEn = _data["taglineEn"] !== undefined ? _data["taglineEn"] : <any>null;
            this.taglineFr = _data["taglineFr"] !== undefined ? _data["taglineFr"] : <any>null;
            this.categoryOrder = _data["categoryOrder"] !== undefined ? _data["categoryOrder"] : <any>null;
            this.menuCategoryOrder = _data["menuCategoryOrder"] !== undefined ? _data["menuCategoryOrder"] : <any>null;
            this.menuId = _data["menuId"] !== undefined ? _data["menuId"] : <any>null;
            this.mb = _data["mb"] !== undefined ? _data["mb"] : <any>null;
            this.isDisabled = _data["isDisabled"] !== undefined ? _data["isDisabled"] : <any>null;
            this.creationDateTime = _data["creationDateTime"] ? moment(_data["creationDateTime"].toString()) : <any>null;
            this.modificationDateTime = _data["modificationDateTime"] ? moment(_data["modificationDateTime"].toString()) : <any>null;
            this.deletionDateTime = _data["deletionDateTime"] ? moment(_data["deletionDateTime"].toString()) : <any>null;
            if (Array.isArray(_data["products"])) {
                this.products = [] as any;
                for (let item of _data["products"])
                    this.products!.push(ProductDto.fromJS(item));
            }
            else {
                this.products = <any>null;
            }
            this.isCollapsed = _data["isCollapsed"] !== undefined ? _data["isCollapsed"] : <any>null;
            this.backgroundImage = _data["backgroundImage"] ? ImageMediaDto.fromJS(_data["backgroundImage"]) : <any>null;
            this.icon = _data["icon"] ? ImageMediaDto.fromJS(_data["icon"]) : <any>null;
            this.showInDigitalMenu = _data["showInDigitalMenu"] !== undefined ? _data["showInDigitalMenu"] : <any>null;
        }
    }

    static fromJS(data: any): CategoryDto {
        data = typeof data === 'object' ? data : {};
        let result = new CategoryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["nameEn"] = this.nameEn !== undefined ? this.nameEn : <any>null;
        data["descriptionEn"] = this.descriptionEn !== undefined ? this.descriptionEn : <any>null;
        data["descriptionFr"] = this.descriptionFr !== undefined ? this.descriptionFr : <any>null;
        data["taglineEn"] = this.taglineEn !== undefined ? this.taglineEn : <any>null;
        data["taglineFr"] = this.taglineFr !== undefined ? this.taglineFr : <any>null;
        data["categoryOrder"] = this.categoryOrder !== undefined ? this.categoryOrder : <any>null;
        data["menuCategoryOrder"] = this.menuCategoryOrder !== undefined ? this.menuCategoryOrder : <any>null;
        data["menuId"] = this.menuId !== undefined ? this.menuId : <any>null;
        data["mb"] = this.mb !== undefined ? this.mb : <any>null;
        data["isDisabled"] = this.isDisabled !== undefined ? this.isDisabled : <any>null;
        data["creationDateTime"] = this.creationDateTime ? this.creationDateTime.toISOString() : <any>null;
        data["modificationDateTime"] = this.modificationDateTime ? this.modificationDateTime.toISOString() : <any>null;
        data["deletionDateTime"] = this.deletionDateTime ? this.deletionDateTime.toISOString() : <any>null;
        if (Array.isArray(this.products)) {
            data["products"] = [];
            for (let item of this.products)
                data["products"].push(item.toJSON());
        }
        data["isCollapsed"] = this.isCollapsed !== undefined ? this.isCollapsed : <any>null;
        data["backgroundImage"] = this.backgroundImage ? this.backgroundImage.toJSON() : <any>null;
        data["icon"] = this.icon ? this.icon.toJSON() : <any>null;
        data["showInDigitalMenu"] = this.showInDigitalMenu !== undefined ? this.showInDigitalMenu : <any>null;
        return data;
    }
}

export interface ICategoryDto {
    id?: string | null;
    name?: string | null;
    nameEn?: string | null;
    descriptionEn?: string | null;
    descriptionFr?: string | null;
    taglineEn?: string | null;
    taglineFr?: string | null;
    categoryOrder?: number;
    menuCategoryOrder?: number;
    menuId?: string | null;
    mb?: boolean | null;
    isDisabled?: boolean;
    creationDateTime?: moment.Moment | null;
    modificationDateTime?: moment.Moment | null;
    deletionDateTime?: moment.Moment | null;
    products?: ProductDto[] | null;
    isCollapsed?: boolean;
    backgroundImage?: ImageMediaDto | null;
    icon?: ImageMediaDto | null;
    showInDigitalMenu?: boolean;
}

export class ProductDto implements IProductDto {
    displayImage?: ProductImageDto | null;
    id?: string | null;
    productNo!: string;
    productNoConverted?: number | null;
    category?: CategoryDto | null;
    categoryId?: string | null;
    department?: Department | null;
    format?: string | null;
    productNameEn?: string | null;
    productNameFr?: string | null;
    suggestedQuantity?: number | null;
    orderNo?: number | null;
    cost?: number;
    salesPrice?: number;
    descriptionEn?: string | null;
    descriptionFr?: string | null;
    ingredientsFr?: string | null;
    ingredientsEn?: string | null;
    totalSalesPrice?: number | null;
    totalSalesPriceWithTax?: number | null;
    formattedNameEn?: string | null;
    formattedNameFr?: string | null;
    active?: boolean;
    doNotAddToMenu?: boolean;
    tps?: boolean;
    tvq?: boolean;
    new?: boolean;
    salesPriceWithTaxes?: number;
    hideFromDigitalMenu?: boolean;
    updatedById?: string | null;
    updatedBy?: EmployeeDto | null;
    updatedOnDateTime?: moment.Moment | null;
    productImages?: ProductImageDto[] | null;

    constructor(data?: IProductDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.displayImage = _data["displayImage"] ? ProductImageDto.fromJS(_data["displayImage"]) : <any>null;
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.productNo = _data["productNo"] !== undefined ? _data["productNo"] : <any>null;
            this.productNoConverted = _data["productNoConverted"] !== undefined ? _data["productNoConverted"] : <any>null;
            this.category = _data["category"] ? CategoryDto.fromJS(_data["category"]) : <any>null;
            this.categoryId = _data["categoryId"] !== undefined ? _data["categoryId"] : <any>null;
            this.department = _data["department"] !== undefined ? _data["department"] : <any>null;
            this.format = _data["format"] !== undefined ? _data["format"] : <any>null;
            this.productNameEn = _data["productNameEn"] !== undefined ? _data["productNameEn"] : <any>null;
            this.productNameFr = _data["productNameFr"] !== undefined ? _data["productNameFr"] : <any>null;
            this.suggestedQuantity = _data["suggestedQuantity"] !== undefined ? _data["suggestedQuantity"] : <any>null;
            this.orderNo = _data["orderNo"] !== undefined ? _data["orderNo"] : <any>null;
            this.cost = _data["cost"] !== undefined ? _data["cost"] : <any>null;
            this.salesPrice = _data["salesPrice"] !== undefined ? _data["salesPrice"] : <any>null;
            this.descriptionEn = _data["descriptionEn"] !== undefined ? _data["descriptionEn"] : <any>null;
            this.descriptionFr = _data["descriptionFr"] !== undefined ? _data["descriptionFr"] : <any>null;
            this.ingredientsFr = _data["ingredientsFr"] !== undefined ? _data["ingredientsFr"] : <any>null;
            this.ingredientsEn = _data["ingredientsEn"] !== undefined ? _data["ingredientsEn"] : <any>null;
            this.totalSalesPrice = _data["totalSalesPrice"] !== undefined ? _data["totalSalesPrice"] : <any>null;
            this.totalSalesPriceWithTax = _data["totalSalesPriceWithTax"] !== undefined ? _data["totalSalesPriceWithTax"] : <any>null;
            this.formattedNameEn = _data["formattedNameEn"] !== undefined ? _data["formattedNameEn"] : <any>null;
            this.formattedNameFr = _data["formattedNameFr"] !== undefined ? _data["formattedNameFr"] : <any>null;
            this.active = _data["active"] !== undefined ? _data["active"] : <any>null;
            this.doNotAddToMenu = _data["doNotAddToMenu"] !== undefined ? _data["doNotAddToMenu"] : <any>null;
            this.tps = _data["tps"] !== undefined ? _data["tps"] : <any>null;
            this.tvq = _data["tvq"] !== undefined ? _data["tvq"] : <any>null;
            this.new = _data["new"] !== undefined ? _data["new"] : <any>null;
            this.salesPriceWithTaxes = _data["salesPriceWithTaxes"] !== undefined ? _data["salesPriceWithTaxes"] : <any>null;
            this.hideFromDigitalMenu = _data["hideFromDigitalMenu"] !== undefined ? _data["hideFromDigitalMenu"] : <any>null;
            this.updatedById = _data["updatedById"] !== undefined ? _data["updatedById"] : <any>null;
            this.updatedBy = _data["updatedBy"] ? EmployeeDto.fromJS(_data["updatedBy"]) : <any>null;
            this.updatedOnDateTime = _data["updatedOnDateTime"] ? moment(_data["updatedOnDateTime"].toString()) : <any>null;
            if (Array.isArray(_data["productImages"])) {
                this.productImages = [] as any;
                for (let item of _data["productImages"])
                    this.productImages!.push(ProductImageDto.fromJS(item));
            }
            else {
                this.productImages = <any>null;
            }
        }
    }

    static fromJS(data: any): ProductDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProductDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["displayImage"] = this.displayImage ? this.displayImage.toJSON() : <any>null;
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["productNo"] = this.productNo !== undefined ? this.productNo : <any>null;
        data["productNoConverted"] = this.productNoConverted !== undefined ? this.productNoConverted : <any>null;
        data["category"] = this.category ? this.category.toJSON() : <any>null;
        data["categoryId"] = this.categoryId !== undefined ? this.categoryId : <any>null;
        data["department"] = this.department !== undefined ? this.department : <any>null;
        data["format"] = this.format !== undefined ? this.format : <any>null;
        data["productNameEn"] = this.productNameEn !== undefined ? this.productNameEn : <any>null;
        data["productNameFr"] = this.productNameFr !== undefined ? this.productNameFr : <any>null;
        data["suggestedQuantity"] = this.suggestedQuantity !== undefined ? this.suggestedQuantity : <any>null;
        data["orderNo"] = this.orderNo !== undefined ? this.orderNo : <any>null;
        data["cost"] = this.cost !== undefined ? this.cost : <any>null;
        data["salesPrice"] = this.salesPrice !== undefined ? this.salesPrice : <any>null;
        data["descriptionEn"] = this.descriptionEn !== undefined ? this.descriptionEn : <any>null;
        data["descriptionFr"] = this.descriptionFr !== undefined ? this.descriptionFr : <any>null;
        data["ingredientsFr"] = this.ingredientsFr !== undefined ? this.ingredientsFr : <any>null;
        data["ingredientsEn"] = this.ingredientsEn !== undefined ? this.ingredientsEn : <any>null;
        data["totalSalesPrice"] = this.totalSalesPrice !== undefined ? this.totalSalesPrice : <any>null;
        data["totalSalesPriceWithTax"] = this.totalSalesPriceWithTax !== undefined ? this.totalSalesPriceWithTax : <any>null;
        data["formattedNameEn"] = this.formattedNameEn !== undefined ? this.formattedNameEn : <any>null;
        data["formattedNameFr"] = this.formattedNameFr !== undefined ? this.formattedNameFr : <any>null;
        data["active"] = this.active !== undefined ? this.active : <any>null;
        data["doNotAddToMenu"] = this.doNotAddToMenu !== undefined ? this.doNotAddToMenu : <any>null;
        data["tps"] = this.tps !== undefined ? this.tps : <any>null;
        data["tvq"] = this.tvq !== undefined ? this.tvq : <any>null;
        data["new"] = this.new !== undefined ? this.new : <any>null;
        data["salesPriceWithTaxes"] = this.salesPriceWithTaxes !== undefined ? this.salesPriceWithTaxes : <any>null;
        data["hideFromDigitalMenu"] = this.hideFromDigitalMenu !== undefined ? this.hideFromDigitalMenu : <any>null;
        data["updatedById"] = this.updatedById !== undefined ? this.updatedById : <any>null;
        data["updatedBy"] = this.updatedBy ? this.updatedBy.toJSON() : <any>null;
        data["updatedOnDateTime"] = this.updatedOnDateTime ? this.updatedOnDateTime.toISOString() : <any>null;
        if (Array.isArray(this.productImages)) {
            data["productImages"] = [];
            for (let item of this.productImages)
                data["productImages"].push(item.toJSON());
        }
        return data;
    }
}

export interface IProductDto {
    displayImage?: ProductImageDto | null;
    id?: string | null;
    productNo: string;
    productNoConverted?: number | null;
    category?: CategoryDto | null;
    categoryId?: string | null;
    department?: Department | null;
    format?: string | null;
    productNameEn?: string | null;
    productNameFr?: string | null;
    suggestedQuantity?: number | null;
    orderNo?: number | null;
    cost?: number;
    salesPrice?: number;
    descriptionEn?: string | null;
    descriptionFr?: string | null;
    ingredientsFr?: string | null;
    ingredientsEn?: string | null;
    totalSalesPrice?: number | null;
    totalSalesPriceWithTax?: number | null;
    formattedNameEn?: string | null;
    formattedNameFr?: string | null;
    active?: boolean;
    doNotAddToMenu?: boolean;
    tps?: boolean;
    tvq?: boolean;
    new?: boolean;
    salesPriceWithTaxes?: number;
    hideFromDigitalMenu?: boolean;
    updatedById?: string | null;
    updatedBy?: EmployeeDto | null;
    updatedOnDateTime?: moment.Moment | null;
    productImages?: ProductImageDto[] | null;
}

export class ProductImageDto implements IProductImageDto {
    imageId?: string | null;
    imageUrl?: string | null;
    sortOrder?: number;
    thumbnailPathUrl?: string | null;

    constructor(data?: IProductImageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.imageId = _data["imageId"] !== undefined ? _data["imageId"] : <any>null;
            this.imageUrl = _data["imageUrl"] !== undefined ? _data["imageUrl"] : <any>null;
            this.sortOrder = _data["sortOrder"] !== undefined ? _data["sortOrder"] : <any>null;
            this.thumbnailPathUrl = _data["thumbnailPathUrl"] !== undefined ? _data["thumbnailPathUrl"] : <any>null;
        }
    }

    static fromJS(data: any): ProductImageDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProductImageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["imageId"] = this.imageId !== undefined ? this.imageId : <any>null;
        data["imageUrl"] = this.imageUrl !== undefined ? this.imageUrl : <any>null;
        data["sortOrder"] = this.sortOrder !== undefined ? this.sortOrder : <any>null;
        data["thumbnailPathUrl"] = this.thumbnailPathUrl !== undefined ? this.thumbnailPathUrl : <any>null;
        return data;
    }
}

export interface IProductImageDto {
    imageId?: string | null;
    imageUrl?: string | null;
    sortOrder?: number;
    thumbnailPathUrl?: string | null;
}

export enum Department {
    Epicerie = "epicerie",
    EpicerieP = "epicerieP",
    Surgele = "surgele",
    VDivers = "vDivers",
    Viande = "viande",
    VRiendeau = "vRiendeau",
}

export class PaginatedResultOfCategoryLookupDto extends PaginatedResult implements IPaginatedResultOfCategoryLookupDto {
    entities?: CategoryLookupDto[] | null;

    constructor(data?: IPaginatedResultOfCategoryLookupDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["entities"])) {
                this.entities = [] as any;
                for (let item of _data["entities"])
                    this.entities!.push(CategoryLookupDto.fromJS(item));
            }
            else {
                this.entities = <any>null;
            }
        }
    }

    static override fromJS(data: any): PaginatedResultOfCategoryLookupDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResultOfCategoryLookupDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.entities)) {
            data["entities"] = [];
            for (let item of this.entities)
                data["entities"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IPaginatedResultOfCategoryLookupDto extends IPaginatedResult {
    entities?: CategoryLookupDto[] | null;
}

export class CategoryLookupDto implements ICategoryLookupDto {
    index?: number;
    id?: string | null;
    name?: string | null;
    categoryOrder?: number;
    isDisabled?: boolean;

    constructor(data?: ICategoryLookupDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.index = _data["index"] !== undefined ? _data["index"] : <any>null;
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.categoryOrder = _data["categoryOrder"] !== undefined ? _data["categoryOrder"] : <any>null;
            this.isDisabled = _data["isDisabled"] !== undefined ? _data["isDisabled"] : <any>null;
        }
    }

    static fromJS(data: any): CategoryLookupDto {
        data = typeof data === 'object' ? data : {};
        let result = new CategoryLookupDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["index"] = this.index !== undefined ? this.index : <any>null;
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["categoryOrder"] = this.categoryOrder !== undefined ? this.categoryOrder : <any>null;
        data["isDisabled"] = this.isDisabled !== undefined ? this.isDisabled : <any>null;
        return data;
    }
}

export interface ICategoryLookupDto {
    index?: number;
    id?: string | null;
    name?: string | null;
    categoryOrder?: number;
    isDisabled?: boolean;
}

export class GetCategoriesListQuery extends PaginationModel implements IGetCategoriesListQuery {
    user?: ClaimsPrincipal | null;
    includeActive?: boolean;
    includeInactive?: boolean;

    constructor(data?: IGetCategoriesListQuery) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.user = _data["user"] ? ClaimsPrincipal.fromJS(_data["user"]) : <any>null;
            this.includeActive = _data["includeActive"] !== undefined ? _data["includeActive"] : <any>null;
            this.includeInactive = _data["includeInactive"] !== undefined ? _data["includeInactive"] : <any>null;
        }
    }

    static override fromJS(data: any): GetCategoriesListQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetCategoriesListQuery();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["user"] = this.user ? this.user.toJSON() : <any>null;
        data["includeActive"] = this.includeActive !== undefined ? this.includeActive : <any>null;
        data["includeInactive"] = this.includeInactive !== undefined ? this.includeInactive : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IGetCategoriesListQuery extends IPaginationModel {
    user?: ClaimsPrincipal | null;
    includeActive?: boolean;
    includeInactive?: boolean;
}

export class CreateCategoryCommand implements ICreateCategoryCommand {
    categoryDto?: CategoryDto | null;

    constructor(data?: ICreateCategoryCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.categoryDto = _data["categoryDto"] ? CategoryDto.fromJS(_data["categoryDto"]) : <any>null;
        }
    }

    static fromJS(data: any): CreateCategoryCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateCategoryCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["categoryDto"] = this.categoryDto ? this.categoryDto.toJSON() : <any>null;
        return data;
    }
}

export interface ICreateCategoryCommand {
    categoryDto?: CategoryDto | null;
}

export class CategoryReorderDto implements ICategoryReorderDto {
    menuCategoryId?: string | null;
    menuName?: string | null;
    categoryId?: string | null;
    categoryOrderIndex?: number;
    productsInCategory?: number;
    maxOrderIndex?: number;

    constructor(data?: ICategoryReorderDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.menuCategoryId = _data["menuCategoryId"] !== undefined ? _data["menuCategoryId"] : <any>null;
            this.menuName = _data["menuName"] !== undefined ? _data["menuName"] : <any>null;
            this.categoryId = _data["categoryId"] !== undefined ? _data["categoryId"] : <any>null;
            this.categoryOrderIndex = _data["categoryOrderIndex"] !== undefined ? _data["categoryOrderIndex"] : <any>null;
            this.productsInCategory = _data["productsInCategory"] !== undefined ? _data["productsInCategory"] : <any>null;
            this.maxOrderIndex = _data["maxOrderIndex"] !== undefined ? _data["maxOrderIndex"] : <any>null;
        }
    }

    static fromJS(data: any): CategoryReorderDto {
        data = typeof data === 'object' ? data : {};
        let result = new CategoryReorderDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["menuCategoryId"] = this.menuCategoryId !== undefined ? this.menuCategoryId : <any>null;
        data["menuName"] = this.menuName !== undefined ? this.menuName : <any>null;
        data["categoryId"] = this.categoryId !== undefined ? this.categoryId : <any>null;
        data["categoryOrderIndex"] = this.categoryOrderIndex !== undefined ? this.categoryOrderIndex : <any>null;
        data["productsInCategory"] = this.productsInCategory !== undefined ? this.productsInCategory : <any>null;
        data["maxOrderIndex"] = this.maxOrderIndex !== undefined ? this.maxOrderIndex : <any>null;
        return data;
    }
}

export interface ICategoryReorderDto {
    menuCategoryId?: string | null;
    menuName?: string | null;
    categoryId?: string | null;
    categoryOrderIndex?: number;
    productsInCategory?: number;
    maxOrderIndex?: number;
}

export class ReorderCategoriesCommand implements IReorderCategoriesCommand {
    categoriesWithNewOrderIndex?: CategoryToReorderDto[] | null;

    constructor(data?: IReorderCategoriesCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["categoriesWithNewOrderIndex"])) {
                this.categoriesWithNewOrderIndex = [] as any;
                for (let item of _data["categoriesWithNewOrderIndex"])
                    this.categoriesWithNewOrderIndex!.push(CategoryToReorderDto.fromJS(item));
            }
            else {
                this.categoriesWithNewOrderIndex = <any>null;
            }
        }
    }

    static fromJS(data: any): ReorderCategoriesCommand {
        data = typeof data === 'object' ? data : {};
        let result = new ReorderCategoriesCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.categoriesWithNewOrderIndex)) {
            data["categoriesWithNewOrderIndex"] = [];
            for (let item of this.categoriesWithNewOrderIndex)
                data["categoriesWithNewOrderIndex"].push(item.toJSON());
        }
        return data;
    }
}

export interface IReorderCategoriesCommand {
    categoriesWithNewOrderIndex?: CategoryToReorderDto[] | null;
}

export class CategoryToReorderDto implements ICategoryToReorderDto {
    menuCategoryId?: string | null;
    categoryOrderIndex?: number;

    constructor(data?: ICategoryToReorderDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.menuCategoryId = _data["menuCategoryId"] !== undefined ? _data["menuCategoryId"] : <any>null;
            this.categoryOrderIndex = _data["categoryOrderIndex"] !== undefined ? _data["categoryOrderIndex"] : <any>null;
        }
    }

    static fromJS(data: any): CategoryToReorderDto {
        data = typeof data === 'object' ? data : {};
        let result = new CategoryToReorderDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["menuCategoryId"] = this.menuCategoryId !== undefined ? this.menuCategoryId : <any>null;
        data["categoryOrderIndex"] = this.categoryOrderIndex !== undefined ? this.categoryOrderIndex : <any>null;
        return data;
    }
}

export interface ICategoryToReorderDto {
    menuCategoryId?: string | null;
    categoryOrderIndex?: number;
}

export class SetCategoryStatusCommand implements ISetCategoryStatusCommand {
    id?: string | null;
    disabled?: boolean;
    toCategoryId?: string | null;

    constructor(data?: ISetCategoryStatusCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.disabled = _data["disabled"] !== undefined ? _data["disabled"] : <any>null;
            this.toCategoryId = _data["toCategoryId"] !== undefined ? _data["toCategoryId"] : <any>null;
        }
    }

    static fromJS(data: any): SetCategoryStatusCommand {
        data = typeof data === 'object' ? data : {};
        let result = new SetCategoryStatusCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["disabled"] = this.disabled !== undefined ? this.disabled : <any>null;
        data["toCategoryId"] = this.toCategoryId !== undefined ? this.toCategoryId : <any>null;
        return data;
    }
}

export interface ISetCategoryStatusCommand {
    id?: string | null;
    disabled?: boolean;
    toCategoryId?: string | null;
}

export class EditCategoryCommand implements IEditCategoryCommand {
    categoryDto?: CategoryDto | null;

    constructor(data?: IEditCategoryCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.categoryDto = _data["categoryDto"] ? CategoryDto.fromJS(_data["categoryDto"]) : <any>null;
        }
    }

    static fromJS(data: any): EditCategoryCommand {
        data = typeof data === 'object' ? data : {};
        let result = new EditCategoryCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["categoryDto"] = this.categoryDto ? this.categoryDto.toJSON() : <any>null;
        return data;
    }
}

export interface IEditCategoryCommand {
    categoryDto?: CategoryDto | null;
}

export class PaginatedResultOfProductLookupDto extends PaginatedResult implements IPaginatedResultOfProductLookupDto {
    entities?: ProductLookupDto[] | null;

    constructor(data?: IPaginatedResultOfProductLookupDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["entities"])) {
                this.entities = [] as any;
                for (let item of _data["entities"])
                    this.entities!.push(ProductLookupDto.fromJS(item));
            }
            else {
                this.entities = <any>null;
            }
        }
    }

    static override fromJS(data: any): PaginatedResultOfProductLookupDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResultOfProductLookupDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.entities)) {
            data["entities"] = [];
            for (let item of this.entities)
                data["entities"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IPaginatedResultOfProductLookupDto extends IPaginatedResult {
    entities?: ProductLookupDto[] | null;
}

export class ProductLookupDto implements IProductLookupDto {
    index?: number;
    id?: string | null;
    productNo?: string | null;
    productNameFr?: string | null;
    defaultCategoryName?: string | null;
    isActive?: boolean;
    cost?: number;
    salePrice?: number;
    quantity?: number;
    department?: Department | null;
    circuitOrder?: number | null;

    constructor(data?: IProductLookupDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.index = _data["index"] !== undefined ? _data["index"] : <any>null;
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.productNo = _data["productNo"] !== undefined ? _data["productNo"] : <any>null;
            this.productNameFr = _data["productNameFr"] !== undefined ? _data["productNameFr"] : <any>null;
            this.defaultCategoryName = _data["defaultCategoryName"] !== undefined ? _data["defaultCategoryName"] : <any>null;
            this.isActive = _data["isActive"] !== undefined ? _data["isActive"] : <any>null;
            this.cost = _data["cost"] !== undefined ? _data["cost"] : <any>null;
            this.salePrice = _data["salePrice"] !== undefined ? _data["salePrice"] : <any>null;
            this.quantity = _data["quantity"] !== undefined ? _data["quantity"] : <any>null;
            this.department = _data["department"] !== undefined ? _data["department"] : <any>null;
            this.circuitOrder = _data["circuitOrder"] !== undefined ? _data["circuitOrder"] : <any>null;
        }
    }

    static fromJS(data: any): ProductLookupDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProductLookupDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["index"] = this.index !== undefined ? this.index : <any>null;
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["productNo"] = this.productNo !== undefined ? this.productNo : <any>null;
        data["productNameFr"] = this.productNameFr !== undefined ? this.productNameFr : <any>null;
        data["defaultCategoryName"] = this.defaultCategoryName !== undefined ? this.defaultCategoryName : <any>null;
        data["isActive"] = this.isActive !== undefined ? this.isActive : <any>null;
        data["cost"] = this.cost !== undefined ? this.cost : <any>null;
        data["salePrice"] = this.salePrice !== undefined ? this.salePrice : <any>null;
        data["quantity"] = this.quantity !== undefined ? this.quantity : <any>null;
        data["department"] = this.department !== undefined ? this.department : <any>null;
        data["circuitOrder"] = this.circuitOrder !== undefined ? this.circuitOrder : <any>null;
        return data;
    }
}

export interface IProductLookupDto {
    index?: number;
    id?: string | null;
    productNo?: string | null;
    productNameFr?: string | null;
    defaultCategoryName?: string | null;
    isActive?: boolean;
    cost?: number;
    salePrice?: number;
    quantity?: number;
    department?: Department | null;
    circuitOrder?: number | null;
}

export class GetProductsByDepartmentsQuery extends PaginationModel implements IGetProductsByDepartmentsQuery {
    departments?: Department[] | null;

    constructor(data?: IGetProductsByDepartmentsQuery) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["departments"])) {
                this.departments = [] as any;
                for (let item of _data["departments"])
                    this.departments!.push(item);
            }
            else {
                this.departments = <any>null;
            }
        }
    }

    static override fromJS(data: any): GetProductsByDepartmentsQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetProductsByDepartmentsQuery();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.departments)) {
            data["departments"] = [];
            for (let item of this.departments)
                data["departments"].push(item);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IGetProductsByDepartmentsQuery extends IPaginationModel {
    departments?: Department[] | null;
}

export class UpdateCrmProductCircuitOrderCommand implements IUpdateCrmProductCircuitOrderCommand {
    products?: ProductLookupDto[] | null;

    constructor(data?: IUpdateCrmProductCircuitOrderCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["products"])) {
                this.products = [] as any;
                for (let item of _data["products"])
                    this.products!.push(ProductLookupDto.fromJS(item));
            }
            else {
                this.products = <any>null;
            }
        }
    }

    static fromJS(data: any): UpdateCrmProductCircuitOrderCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateCrmProductCircuitOrderCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.products)) {
            data["products"] = [];
            for (let item of this.products)
                data["products"].push(item.toJSON());
        }
        return data;
    }
}

export interface IUpdateCrmProductCircuitOrderCommand {
    products?: ProductLookupDto[] | null;
}

export class ProductData implements IProductData {
    circuit?: number;
    nO_ITEM?: string | null;
    detail?: string | null;

    constructor(data?: IProductData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.circuit = _data["circuit"] !== undefined ? _data["circuit"] : <any>null;
            this.nO_ITEM = _data["nO_ITEM"] !== undefined ? _data["nO_ITEM"] : <any>null;
            this.detail = _data["detail"] !== undefined ? _data["detail"] : <any>null;
        }
    }

    static fromJS(data: any): ProductData {
        data = typeof data === 'object' ? data : {};
        let result = new ProductData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["circuit"] = this.circuit !== undefined ? this.circuit : <any>null;
        data["nO_ITEM"] = this.nO_ITEM !== undefined ? this.nO_ITEM : <any>null;
        data["detail"] = this.detail !== undefined ? this.detail : <any>null;
        return data;
    }
}

export interface IProductData {
    circuit?: number;
    nO_ITEM?: string | null;
    detail?: string | null;
}

export class ClientDeliveryScheduleDto implements IClientDeliveryScheduleDto {
    id?: number;
    clientNo?: number;
    optimoRouteSyncMinDate?: moment.Moment | null;
    optimoRouteSyncMaxDate?: moment.Moment | null;
    deliveryAllowedDateTimes?: ClientDeliveryScheduleAllowedDateTimesDto[] | null;

    constructor(data?: IClientDeliveryScheduleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.clientNo = _data["clientNo"] !== undefined ? _data["clientNo"] : <any>null;
            this.optimoRouteSyncMinDate = _data["optimoRouteSyncMinDate"] ? moment(_data["optimoRouteSyncMinDate"].toString()) : <any>null;
            this.optimoRouteSyncMaxDate = _data["optimoRouteSyncMaxDate"] ? moment(_data["optimoRouteSyncMaxDate"].toString()) : <any>null;
            if (Array.isArray(_data["deliveryAllowedDateTimes"])) {
                this.deliveryAllowedDateTimes = [] as any;
                for (let item of _data["deliveryAllowedDateTimes"])
                    this.deliveryAllowedDateTimes!.push(ClientDeliveryScheduleAllowedDateTimesDto.fromJS(item));
            }
            else {
                this.deliveryAllowedDateTimes = <any>null;
            }
        }
    }

    static fromJS(data: any): ClientDeliveryScheduleDto {
        data = typeof data === 'object' ? data : {};
        let result = new ClientDeliveryScheduleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["clientNo"] = this.clientNo !== undefined ? this.clientNo : <any>null;
        data["optimoRouteSyncMinDate"] = this.optimoRouteSyncMinDate ? this.optimoRouteSyncMinDate.toISOString() : <any>null;
        data["optimoRouteSyncMaxDate"] = this.optimoRouteSyncMaxDate ? this.optimoRouteSyncMaxDate.toISOString() : <any>null;
        if (Array.isArray(this.deliveryAllowedDateTimes)) {
            data["deliveryAllowedDateTimes"] = [];
            for (let item of this.deliveryAllowedDateTimes)
                data["deliveryAllowedDateTimes"].push(item.toJSON());
        }
        return data;
    }
}

export interface IClientDeliveryScheduleDto {
    id?: number;
    clientNo?: number;
    optimoRouteSyncMinDate?: moment.Moment | null;
    optimoRouteSyncMaxDate?: moment.Moment | null;
    deliveryAllowedDateTimes?: ClientDeliveryScheduleAllowedDateTimesDto[] | null;
}

export class ClientDeliveryScheduleAllowedDateTimesDto implements IClientDeliveryScheduleAllowedDateTimesDto {
    id?: number;
    clientDeliveryScheduleId?: number;
    day?: DayOfWeek;
    isMorningDeliveryAllowed?: boolean;
    isAfternoonDeliveryAllowed?: boolean;
    isEveningDeliveryAllowed?: boolean;
    isDayChecked?: boolean;
    from?: moment.Moment;
    fromDate?: string | null;
    fromTime?: string | null;
    to?: moment.Moment;
    toDate?: string | null;
    toTime?: string | null;
    isAdvanceDelivery?: boolean;

    constructor(data?: IClientDeliveryScheduleAllowedDateTimesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.clientDeliveryScheduleId = _data["clientDeliveryScheduleId"] !== undefined ? _data["clientDeliveryScheduleId"] : <any>null;
            this.day = _data["day"] !== undefined ? _data["day"] : <any>null;
            this.isMorningDeliveryAllowed = _data["isMorningDeliveryAllowed"] !== undefined ? _data["isMorningDeliveryAllowed"] : <any>null;
            this.isAfternoonDeliveryAllowed = _data["isAfternoonDeliveryAllowed"] !== undefined ? _data["isAfternoonDeliveryAllowed"] : <any>null;
            this.isEveningDeliveryAllowed = _data["isEveningDeliveryAllowed"] !== undefined ? _data["isEveningDeliveryAllowed"] : <any>null;
            this.isDayChecked = _data["isDayChecked"] !== undefined ? _data["isDayChecked"] : <any>null;
            this.from = _data["from"] ? moment(_data["from"].toString()) : <any>null;
            this.fromDate = _data["fromDate"] !== undefined ? _data["fromDate"] : <any>null;
            this.fromTime = _data["fromTime"] !== undefined ? _data["fromTime"] : <any>null;
            this.to = _data["to"] ? moment(_data["to"].toString()) : <any>null;
            this.toDate = _data["toDate"] !== undefined ? _data["toDate"] : <any>null;
            this.toTime = _data["toTime"] !== undefined ? _data["toTime"] : <any>null;
            this.isAdvanceDelivery = _data["isAdvanceDelivery"] !== undefined ? _data["isAdvanceDelivery"] : <any>null;
        }
    }

    static fromJS(data: any): ClientDeliveryScheduleAllowedDateTimesDto {
        data = typeof data === 'object' ? data : {};
        let result = new ClientDeliveryScheduleAllowedDateTimesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["clientDeliveryScheduleId"] = this.clientDeliveryScheduleId !== undefined ? this.clientDeliveryScheduleId : <any>null;
        data["day"] = this.day !== undefined ? this.day : <any>null;
        data["isMorningDeliveryAllowed"] = this.isMorningDeliveryAllowed !== undefined ? this.isMorningDeliveryAllowed : <any>null;
        data["isAfternoonDeliveryAllowed"] = this.isAfternoonDeliveryAllowed !== undefined ? this.isAfternoonDeliveryAllowed : <any>null;
        data["isEveningDeliveryAllowed"] = this.isEveningDeliveryAllowed !== undefined ? this.isEveningDeliveryAllowed : <any>null;
        data["isDayChecked"] = this.isDayChecked !== undefined ? this.isDayChecked : <any>null;
        data["from"] = this.from ? this.from.toISOString() : <any>null;
        data["fromDate"] = this.fromDate !== undefined ? this.fromDate : <any>null;
        data["fromTime"] = this.fromTime !== undefined ? this.fromTime : <any>null;
        data["to"] = this.to ? this.to.toISOString() : <any>null;
        data["toDate"] = this.toDate !== undefined ? this.toDate : <any>null;
        data["toTime"] = this.toTime !== undefined ? this.toTime : <any>null;
        data["isAdvanceDelivery"] = this.isAdvanceDelivery !== undefined ? this.isAdvanceDelivery : <any>null;
        return data;
    }
}

export interface IClientDeliveryScheduleAllowedDateTimesDto {
    id?: number;
    clientDeliveryScheduleId?: number;
    day?: DayOfWeek;
    isMorningDeliveryAllowed?: boolean;
    isAfternoonDeliveryAllowed?: boolean;
    isEveningDeliveryAllowed?: boolean;
    isDayChecked?: boolean;
    from?: moment.Moment;
    fromDate?: string | null;
    fromTime?: string | null;
    to?: moment.Moment;
    toDate?: string | null;
    toTime?: string | null;
    isAdvanceDelivery?: boolean;
}

export enum DayOfWeek {
    Sunday = "sunday",
    Monday = "monday",
    Tuesday = "tuesday",
    Wednesday = "wednesday",
    Thursday = "thursday",
    Friday = "friday",
    Saturday = "saturday",
}

export class CreateOrUpdateClientDeliveryScheduleCommand implements ICreateOrUpdateClientDeliveryScheduleCommand {
    deliverySchedule?: ClientDeliveryScheduleDto | null;

    constructor(data?: ICreateOrUpdateClientDeliveryScheduleCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.deliverySchedule = _data["deliverySchedule"] ? ClientDeliveryScheduleDto.fromJS(_data["deliverySchedule"]) : <any>null;
        }
    }

    static fromJS(data: any): CreateOrUpdateClientDeliveryScheduleCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateClientDeliveryScheduleCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["deliverySchedule"] = this.deliverySchedule ? this.deliverySchedule.toJSON() : <any>null;
        return data;
    }
}

export interface ICreateOrUpdateClientDeliveryScheduleCommand {
    deliverySchedule?: ClientDeliveryScheduleDto | null;
}

export class PaginatedResultOfClientLeadLookUpDto extends PaginatedResult implements IPaginatedResultOfClientLeadLookUpDto {
    entities?: ClientLeadLookUpDto[] | null;

    constructor(data?: IPaginatedResultOfClientLeadLookUpDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["entities"])) {
                this.entities = [] as any;
                for (let item of _data["entities"])
                    this.entities!.push(ClientLeadLookUpDto.fromJS(item));
            }
            else {
                this.entities = <any>null;
            }
        }
    }

    static override fromJS(data: any): PaginatedResultOfClientLeadLookUpDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResultOfClientLeadLookUpDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.entities)) {
            data["entities"] = [];
            for (let item of this.entities)
                data["entities"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IPaginatedResultOfClientLeadLookUpDto extends IPaginatedResult {
    entities?: ClientLeadLookUpDto[] | null;
}

export class ClientLeadLookUpDto extends BaseClientLeadDto implements IClientLeadLookUpDto {
    referredFrom?: string | null;
    index?: number;
    id?: number;
    name?: string | null;
    email?: string | null;
    callTimes?: ClientLeadCallTimeDto | null;
    phoneNumber?: string | null;
    assignedEmployeeName?: string | null;
    callBackDateTime?: moment.Moment | null;
    referralInfo?: ReferralInfoDto | null;
    status?: ClientLeadStatus;
    unbookableReason?: UnbookableReason | null;
    marketingSiteUrl?: string | null;
    canChangeAssignedEmployee?: boolean;
    isCurrentTmWhoLeadToReference?: boolean;
    clientLeadSourceTypeInfo?: ClientLeadSourceTypeDto | null;
    clientLeadSourceTypeId?: number;
    callNo?: number | null;
    isOpen?: boolean;
    zone?: string | null;
    campaign?: string | null;

    constructor(data?: IClientLeadLookUpDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.referredFrom = _data["referredFrom"] !== undefined ? _data["referredFrom"] : <any>null;
            this.index = _data["index"] !== undefined ? _data["index"] : <any>null;
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.email = _data["email"] !== undefined ? _data["email"] : <any>null;
            this.callTimes = _data["callTimes"] ? ClientLeadCallTimeDto.fromJS(_data["callTimes"]) : <any>null;
            this.phoneNumber = _data["phoneNumber"] !== undefined ? _data["phoneNumber"] : <any>null;
            this.assignedEmployeeName = _data["assignedEmployeeName"] !== undefined ? _data["assignedEmployeeName"] : <any>null;
            this.callBackDateTime = _data["callBackDateTime"] ? moment(_data["callBackDateTime"].toString()) : <any>null;
            this.referralInfo = _data["referralInfo"] ? ReferralInfoDto.fromJS(_data["referralInfo"]) : <any>null;
            this.status = _data["status"] !== undefined ? _data["status"] : <any>null;
            this.unbookableReason = _data["unbookableReason"] !== undefined ? _data["unbookableReason"] : <any>null;
            this.marketingSiteUrl = _data["marketingSiteUrl"] !== undefined ? _data["marketingSiteUrl"] : <any>null;
            this.canChangeAssignedEmployee = _data["canChangeAssignedEmployee"] !== undefined ? _data["canChangeAssignedEmployee"] : <any>null;
            this.isCurrentTmWhoLeadToReference = _data["isCurrentTmWhoLeadToReference"] !== undefined ? _data["isCurrentTmWhoLeadToReference"] : <any>null;
            this.clientLeadSourceTypeInfo = _data["clientLeadSourceTypeInfo"] ? ClientLeadSourceTypeDto.fromJS(_data["clientLeadSourceTypeInfo"]) : <any>null;
            this.clientLeadSourceTypeId = _data["clientLeadSourceTypeId"] !== undefined ? _data["clientLeadSourceTypeId"] : <any>null;
            this.callNo = _data["callNo"] !== undefined ? _data["callNo"] : <any>null;
            this.isOpen = _data["isOpen"] !== undefined ? _data["isOpen"] : <any>null;
            this.zone = _data["zone"] !== undefined ? _data["zone"] : <any>null;
            this.campaign = _data["campaign"] !== undefined ? _data["campaign"] : <any>null;
        }
    }

    static override fromJS(data: any): ClientLeadLookUpDto {
        data = typeof data === 'object' ? data : {};
        let result = new ClientLeadLookUpDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["referredFrom"] = this.referredFrom !== undefined ? this.referredFrom : <any>null;
        data["index"] = this.index !== undefined ? this.index : <any>null;
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["email"] = this.email !== undefined ? this.email : <any>null;
        data["callTimes"] = this.callTimes ? this.callTimes.toJSON() : <any>null;
        data["phoneNumber"] = this.phoneNumber !== undefined ? this.phoneNumber : <any>null;
        data["assignedEmployeeName"] = this.assignedEmployeeName !== undefined ? this.assignedEmployeeName : <any>null;
        data["callBackDateTime"] = this.callBackDateTime ? this.callBackDateTime.toISOString() : <any>null;
        data["referralInfo"] = this.referralInfo ? this.referralInfo.toJSON() : <any>null;
        data["status"] = this.status !== undefined ? this.status : <any>null;
        data["unbookableReason"] = this.unbookableReason !== undefined ? this.unbookableReason : <any>null;
        data["marketingSiteUrl"] = this.marketingSiteUrl !== undefined ? this.marketingSiteUrl : <any>null;
        data["canChangeAssignedEmployee"] = this.canChangeAssignedEmployee !== undefined ? this.canChangeAssignedEmployee : <any>null;
        data["isCurrentTmWhoLeadToReference"] = this.isCurrentTmWhoLeadToReference !== undefined ? this.isCurrentTmWhoLeadToReference : <any>null;
        data["clientLeadSourceTypeInfo"] = this.clientLeadSourceTypeInfo ? this.clientLeadSourceTypeInfo.toJSON() : <any>null;
        data["clientLeadSourceTypeId"] = this.clientLeadSourceTypeId !== undefined ? this.clientLeadSourceTypeId : <any>null;
        data["callNo"] = this.callNo !== undefined ? this.callNo : <any>null;
        data["isOpen"] = this.isOpen !== undefined ? this.isOpen : <any>null;
        data["zone"] = this.zone !== undefined ? this.zone : <any>null;
        data["campaign"] = this.campaign !== undefined ? this.campaign : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IClientLeadLookUpDto extends IBaseClientLeadDto {
    referredFrom?: string | null;
    index?: number;
    id?: number;
    name?: string | null;
    email?: string | null;
    callTimes?: ClientLeadCallTimeDto | null;
    phoneNumber?: string | null;
    assignedEmployeeName?: string | null;
    callBackDateTime?: moment.Moment | null;
    referralInfo?: ReferralInfoDto | null;
    status?: ClientLeadStatus;
    unbookableReason?: UnbookableReason | null;
    marketingSiteUrl?: string | null;
    canChangeAssignedEmployee?: boolean;
    isCurrentTmWhoLeadToReference?: boolean;
    clientLeadSourceTypeInfo?: ClientLeadSourceTypeDto | null;
    clientLeadSourceTypeId?: number;
    callNo?: number | null;
    isOpen?: boolean;
    zone?: string | null;
    campaign?: string | null;
}

export class ClientLeadCallTimeDto implements IClientLeadCallTimeDto {
    callInMorning?: boolean;
    callInAfternoon?: boolean;
    callInEvening?: boolean;
    preferedTimes?: string[] | null;

    constructor(data?: IClientLeadCallTimeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.callInMorning = _data["callInMorning"] !== undefined ? _data["callInMorning"] : <any>null;
            this.callInAfternoon = _data["callInAfternoon"] !== undefined ? _data["callInAfternoon"] : <any>null;
            this.callInEvening = _data["callInEvening"] !== undefined ? _data["callInEvening"] : <any>null;
            if (Array.isArray(_data["preferedTimes"])) {
                this.preferedTimes = [] as any;
                for (let item of _data["preferedTimes"])
                    this.preferedTimes!.push(item);
            }
            else {
                this.preferedTimes = <any>null;
            }
        }
    }

    static fromJS(data: any): ClientLeadCallTimeDto {
        data = typeof data === 'object' ? data : {};
        let result = new ClientLeadCallTimeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["callInMorning"] = this.callInMorning !== undefined ? this.callInMorning : <any>null;
        data["callInAfternoon"] = this.callInAfternoon !== undefined ? this.callInAfternoon : <any>null;
        data["callInEvening"] = this.callInEvening !== undefined ? this.callInEvening : <any>null;
        if (Array.isArray(this.preferedTimes)) {
            data["preferedTimes"] = [];
            for (let item of this.preferedTimes)
                data["preferedTimes"].push(item);
        }
        return data;
    }
}

export interface IClientLeadCallTimeDto {
    callInMorning?: boolean;
    callInAfternoon?: boolean;
    callInEvening?: boolean;
    preferedTimes?: string[] | null;
}

export class ReferralInfoDto implements IReferralInfoDto {
    fromClientRelation?: string | null;
    fromOrderType?: ImportOrderType | null;
    fromClientName?: string | null;
    fromClientConjointName?: string | null;
    fromSalesRepName?: string | null;
    fromTmName?: string | null;
    fromClientCity?: string | null;
    fromOrderNo?: number | null;
    fromEmail?: string | null;

    constructor(data?: IReferralInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fromClientRelation = _data["fromClientRelation"] !== undefined ? _data["fromClientRelation"] : <any>null;
            this.fromOrderType = _data["fromOrderType"] !== undefined ? _data["fromOrderType"] : <any>null;
            this.fromClientName = _data["fromClientName"] !== undefined ? _data["fromClientName"] : <any>null;
            this.fromClientConjointName = _data["fromClientConjointName"] !== undefined ? _data["fromClientConjointName"] : <any>null;
            this.fromSalesRepName = _data["fromSalesRepName"] !== undefined ? _data["fromSalesRepName"] : <any>null;
            this.fromTmName = _data["fromTmName"] !== undefined ? _data["fromTmName"] : <any>null;
            this.fromClientCity = _data["fromClientCity"] !== undefined ? _data["fromClientCity"] : <any>null;
            this.fromOrderNo = _data["fromOrderNo"] !== undefined ? _data["fromOrderNo"] : <any>null;
            this.fromEmail = _data["fromEmail"] !== undefined ? _data["fromEmail"] : <any>null;
        }
    }

    static fromJS(data: any): ReferralInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new ReferralInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fromClientRelation"] = this.fromClientRelation !== undefined ? this.fromClientRelation : <any>null;
        data["fromOrderType"] = this.fromOrderType !== undefined ? this.fromOrderType : <any>null;
        data["fromClientName"] = this.fromClientName !== undefined ? this.fromClientName : <any>null;
        data["fromClientConjointName"] = this.fromClientConjointName !== undefined ? this.fromClientConjointName : <any>null;
        data["fromSalesRepName"] = this.fromSalesRepName !== undefined ? this.fromSalesRepName : <any>null;
        data["fromTmName"] = this.fromTmName !== undefined ? this.fromTmName : <any>null;
        data["fromClientCity"] = this.fromClientCity !== undefined ? this.fromClientCity : <any>null;
        data["fromOrderNo"] = this.fromOrderNo !== undefined ? this.fromOrderNo : <any>null;
        data["fromEmail"] = this.fromEmail !== undefined ? this.fromEmail : <any>null;
        return data;
    }
}

export interface IReferralInfoDto {
    fromClientRelation?: string | null;
    fromOrderType?: ImportOrderType | null;
    fromClientName?: string | null;
    fromClientConjointName?: string | null;
    fromSalesRepName?: string | null;
    fromTmName?: string | null;
    fromClientCity?: string | null;
    fromOrderNo?: number | null;
    fromEmail?: string | null;
}

export enum ImportOrderType {
    New = "new",
    Renew = "renew",
    Custom = "custom",
}

export enum ClientLeadStatus {
    Open = "open",
    Closed = "closed",
    NotInterested = "notInterested",
    Pulled = "pulled",
    Unbookable = "unbookable",
    Retired = "retired",
}

export class ClientLeadSourceTypeDto implements IClientLeadSourceTypeDto {
    id?: number;
    nameEn?: string | null;
    nameFr?: string | null;
    sendSmsNotificationOnNewLead?: boolean;

    constructor(data?: IClientLeadSourceTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.nameEn = _data["nameEn"] !== undefined ? _data["nameEn"] : <any>null;
            this.nameFr = _data["nameFr"] !== undefined ? _data["nameFr"] : <any>null;
            this.sendSmsNotificationOnNewLead = _data["sendSmsNotificationOnNewLead"] !== undefined ? _data["sendSmsNotificationOnNewLead"] : <any>null;
        }
    }

    static fromJS(data: any): ClientLeadSourceTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new ClientLeadSourceTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["nameEn"] = this.nameEn !== undefined ? this.nameEn : <any>null;
        data["nameFr"] = this.nameFr !== undefined ? this.nameFr : <any>null;
        data["sendSmsNotificationOnNewLead"] = this.sendSmsNotificationOnNewLead !== undefined ? this.sendSmsNotificationOnNewLead : <any>null;
        return data;
    }
}

export interface IClientLeadSourceTypeDto {
    id?: number;
    nameEn?: string | null;
    nameFr?: string | null;
    sendSmsNotificationOnNewLead?: boolean;
}

export class GetClientLeadsListQuery extends PaginationModel implements IGetClientLeadsListQuery {
    hasAssignedEmployee?: boolean;
    hasNoAssignedEmployee?: boolean;
    hasAppointment?: boolean;
    hasNoAppointment?: boolean;
    hasFollowUp?: boolean;
    hasNoFollowUp?: boolean;
    hasCampaign?: boolean;
    hasNoCampaign?: boolean;
    isOpen?: boolean;
    isClosed?: boolean;
    isNotInterested?: boolean;
    isUnbookable?: boolean;
    isRetired?: boolean;
    searchDateUtcRange?: (moment.Moment | null)[] | null;
    ignoreDateRange?: boolean;
    filterOnClientLeadSourceIds?: number[] | null;
    isPulled?: boolean;
    fromTmId?: string | null;
    assignedToTmId?: string | null;
    zoneId?: number | null;
    campaignId?: number | null;
    salesRepNo?: number | null;
    user?: ClaimsPrincipal | null;
    importedClientLeadsFromOrdersRecordId?: number | null;

    constructor(data?: IGetClientLeadsListQuery) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.hasAssignedEmployee = _data["hasAssignedEmployee"] !== undefined ? _data["hasAssignedEmployee"] : <any>null;
            this.hasNoAssignedEmployee = _data["hasNoAssignedEmployee"] !== undefined ? _data["hasNoAssignedEmployee"] : <any>null;
            this.hasAppointment = _data["hasAppointment"] !== undefined ? _data["hasAppointment"] : <any>null;
            this.hasNoAppointment = _data["hasNoAppointment"] !== undefined ? _data["hasNoAppointment"] : <any>null;
            this.hasFollowUp = _data["hasFollowUp"] !== undefined ? _data["hasFollowUp"] : <any>null;
            this.hasNoFollowUp = _data["hasNoFollowUp"] !== undefined ? _data["hasNoFollowUp"] : <any>null;
            this.hasCampaign = _data["hasCampaign"] !== undefined ? _data["hasCampaign"] : <any>null;
            this.hasNoCampaign = _data["hasNoCampaign"] !== undefined ? _data["hasNoCampaign"] : <any>null;
            this.isOpen = _data["isOpen"] !== undefined ? _data["isOpen"] : <any>null;
            this.isClosed = _data["isClosed"] !== undefined ? _data["isClosed"] : <any>null;
            this.isNotInterested = _data["isNotInterested"] !== undefined ? _data["isNotInterested"] : <any>null;
            this.isUnbookable = _data["isUnbookable"] !== undefined ? _data["isUnbookable"] : <any>null;
            this.isRetired = _data["isRetired"] !== undefined ? _data["isRetired"] : <any>null;
            if (Array.isArray(_data["searchDateUtcRange"])) {
                this.searchDateUtcRange = [] as any;
                for (let item of _data["searchDateUtcRange"])
                    this.searchDateUtcRange!.push(moment(item));
            }
            else {
                this.searchDateUtcRange = <any>null;
            }
            this.ignoreDateRange = _data["ignoreDateRange"] !== undefined ? _data["ignoreDateRange"] : <any>null;
            if (Array.isArray(_data["filterOnClientLeadSourceIds"])) {
                this.filterOnClientLeadSourceIds = [] as any;
                for (let item of _data["filterOnClientLeadSourceIds"])
                    this.filterOnClientLeadSourceIds!.push(item);
            }
            else {
                this.filterOnClientLeadSourceIds = <any>null;
            }
            this.isPulled = _data["isPulled"] !== undefined ? _data["isPulled"] : <any>null;
            this.fromTmId = _data["fromTmId"] !== undefined ? _data["fromTmId"] : <any>null;
            this.assignedToTmId = _data["assignedToTmId"] !== undefined ? _data["assignedToTmId"] : <any>null;
            this.zoneId = _data["zoneId"] !== undefined ? _data["zoneId"] : <any>null;
            this.campaignId = _data["campaignId"] !== undefined ? _data["campaignId"] : <any>null;
            this.salesRepNo = _data["salesRepNo"] !== undefined ? _data["salesRepNo"] : <any>null;
            this.user = _data["user"] ? ClaimsPrincipal.fromJS(_data["user"]) : <any>null;
            this.importedClientLeadsFromOrdersRecordId = _data["importedClientLeadsFromOrdersRecordId"] !== undefined ? _data["importedClientLeadsFromOrdersRecordId"] : <any>null;
        }
    }

    static override fromJS(data: any): GetClientLeadsListQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetClientLeadsListQuery();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["hasAssignedEmployee"] = this.hasAssignedEmployee !== undefined ? this.hasAssignedEmployee : <any>null;
        data["hasNoAssignedEmployee"] = this.hasNoAssignedEmployee !== undefined ? this.hasNoAssignedEmployee : <any>null;
        data["hasAppointment"] = this.hasAppointment !== undefined ? this.hasAppointment : <any>null;
        data["hasNoAppointment"] = this.hasNoAppointment !== undefined ? this.hasNoAppointment : <any>null;
        data["hasFollowUp"] = this.hasFollowUp !== undefined ? this.hasFollowUp : <any>null;
        data["hasNoFollowUp"] = this.hasNoFollowUp !== undefined ? this.hasNoFollowUp : <any>null;
        data["hasCampaign"] = this.hasCampaign !== undefined ? this.hasCampaign : <any>null;
        data["hasNoCampaign"] = this.hasNoCampaign !== undefined ? this.hasNoCampaign : <any>null;
        data["isOpen"] = this.isOpen !== undefined ? this.isOpen : <any>null;
        data["isClosed"] = this.isClosed !== undefined ? this.isClosed : <any>null;
        data["isNotInterested"] = this.isNotInterested !== undefined ? this.isNotInterested : <any>null;
        data["isUnbookable"] = this.isUnbookable !== undefined ? this.isUnbookable : <any>null;
        data["isRetired"] = this.isRetired !== undefined ? this.isRetired : <any>null;
        if (Array.isArray(this.searchDateUtcRange)) {
            data["searchDateUtcRange"] = [];
            for (let item of this.searchDateUtcRange)
                data["searchDateUtcRange"].push(item.toISOString());
        }
        data["ignoreDateRange"] = this.ignoreDateRange !== undefined ? this.ignoreDateRange : <any>null;
        if (Array.isArray(this.filterOnClientLeadSourceIds)) {
            data["filterOnClientLeadSourceIds"] = [];
            for (let item of this.filterOnClientLeadSourceIds)
                data["filterOnClientLeadSourceIds"].push(item);
        }
        data["isPulled"] = this.isPulled !== undefined ? this.isPulled : <any>null;
        data["fromTmId"] = this.fromTmId !== undefined ? this.fromTmId : <any>null;
        data["assignedToTmId"] = this.assignedToTmId !== undefined ? this.assignedToTmId : <any>null;
        data["zoneId"] = this.zoneId !== undefined ? this.zoneId : <any>null;
        data["campaignId"] = this.campaignId !== undefined ? this.campaignId : <any>null;
        data["salesRepNo"] = this.salesRepNo !== undefined ? this.salesRepNo : <any>null;
        data["user"] = this.user ? this.user.toJSON() : <any>null;
        data["importedClientLeadsFromOrdersRecordId"] = this.importedClientLeadsFromOrdersRecordId !== undefined ? this.importedClientLeadsFromOrdersRecordId : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IGetClientLeadsListQuery extends IPaginationModel {
    hasAssignedEmployee?: boolean;
    hasNoAssignedEmployee?: boolean;
    hasAppointment?: boolean;
    hasNoAppointment?: boolean;
    hasFollowUp?: boolean;
    hasNoFollowUp?: boolean;
    hasCampaign?: boolean;
    hasNoCampaign?: boolean;
    isOpen?: boolean;
    isClosed?: boolean;
    isNotInterested?: boolean;
    isUnbookable?: boolean;
    isRetired?: boolean;
    searchDateUtcRange?: (moment.Moment | null)[] | null;
    ignoreDateRange?: boolean;
    filterOnClientLeadSourceIds?: number[] | null;
    isPulled?: boolean;
    fromTmId?: string | null;
    assignedToTmId?: string | null;
    zoneId?: number | null;
    campaignId?: number | null;
    salesRepNo?: number | null;
    user?: ClaimsPrincipal | null;
    importedClientLeadsFromOrdersRecordId?: number | null;
}

export class GetMyAssignedClientLeadsListQuery extends PaginationModel implements IGetMyAssignedClientLeadsListQuery {
    userId?: string | null;
    hasFollowUp?: boolean;
    hasNoFollowUp?: boolean;
    isFromNewOrder?: boolean;
    isFromRenewalOrder?: boolean;
    isFromOtherSource?: boolean;
    isPulled?: boolean;

    constructor(data?: IGetMyAssignedClientLeadsListQuery) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.userId = _data["userId"] !== undefined ? _data["userId"] : <any>null;
            this.hasFollowUp = _data["hasFollowUp"] !== undefined ? _data["hasFollowUp"] : <any>null;
            this.hasNoFollowUp = _data["hasNoFollowUp"] !== undefined ? _data["hasNoFollowUp"] : <any>null;
            this.isFromNewOrder = _data["isFromNewOrder"] !== undefined ? _data["isFromNewOrder"] : <any>null;
            this.isFromRenewalOrder = _data["isFromRenewalOrder"] !== undefined ? _data["isFromRenewalOrder"] : <any>null;
            this.isFromOtherSource = _data["isFromOtherSource"] !== undefined ? _data["isFromOtherSource"] : <any>null;
            this.isPulled = _data["isPulled"] !== undefined ? _data["isPulled"] : <any>null;
        }
    }

    static override fromJS(data: any): GetMyAssignedClientLeadsListQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetMyAssignedClientLeadsListQuery();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId !== undefined ? this.userId : <any>null;
        data["hasFollowUp"] = this.hasFollowUp !== undefined ? this.hasFollowUp : <any>null;
        data["hasNoFollowUp"] = this.hasNoFollowUp !== undefined ? this.hasNoFollowUp : <any>null;
        data["isFromNewOrder"] = this.isFromNewOrder !== undefined ? this.isFromNewOrder : <any>null;
        data["isFromRenewalOrder"] = this.isFromRenewalOrder !== undefined ? this.isFromRenewalOrder : <any>null;
        data["isFromOtherSource"] = this.isFromOtherSource !== undefined ? this.isFromOtherSource : <any>null;
        data["isPulled"] = this.isPulled !== undefined ? this.isPulled : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IGetMyAssignedClientLeadsListQuery extends IPaginationModel {
    userId?: string | null;
    hasFollowUp?: boolean;
    hasNoFollowUp?: boolean;
    isFromNewOrder?: boolean;
    isFromRenewalOrder?: boolean;
    isFromOtherSource?: boolean;
    isPulled?: boolean;
}

export class ClientLeadDto implements IClientLeadDto {
    marketingSiteUrl?: string | null;
    id?: number;
    name?: string | null;
    email?: string | null;
    phoneNumber?: string | null;
    phoneNumberClean?: string | null;
    phoneNumberExtension?: string | null;
    createdDateTime?: moment.Moment;
    callTimes?: ClientLeadCallTimeDto | null;
    referenceSalesRepNo?: number | null;
    callBackDateTime?: moment.Moment | null;
    address?: AddressDto | null;
    assignedEmployee?: NestedEmployeeDto | null;
    status?: ClientLeadStatus;
    unbookableReason?: UnbookableReason | null;
    notInterestedReason?: NotInterestedReason | null;
    clientLeadSourceTypeInfo?: ClientLeadSourceTypeDto | null;
    clientLeadSourceTypeId?: number;
    referredFrom?: string | null;
    referenceTm?: NestedEmployeeDto | null;
    referenceSalesRep?: NestedEmployeeDto | null;
    clientLeadNotes?: ClientLeadNoteDto[] | null;
    zone?: string | null;
    campaign?: string | null;
    assignedEmployeeId?: string | null;
    assignedEmployeeName?: string | null;
    callNo?: number | null;
    referralInfo?: ReferralInfoDto | null;
    canChangeAssignedEmployee?: boolean;
    isInDnclList?: boolean;
    isInLocalDnclList?: boolean;
    isOptInLeadCreatedAfterLocalDncl?: boolean;

    constructor(data?: IClientLeadDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.marketingSiteUrl = _data["marketingSiteUrl"] !== undefined ? _data["marketingSiteUrl"] : <any>null;
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.email = _data["email"] !== undefined ? _data["email"] : <any>null;
            this.phoneNumber = _data["phoneNumber"] !== undefined ? _data["phoneNumber"] : <any>null;
            this.phoneNumberClean = _data["phoneNumberClean"] !== undefined ? _data["phoneNumberClean"] : <any>null;
            this.phoneNumberExtension = _data["phoneNumberExtension"] !== undefined ? _data["phoneNumberExtension"] : <any>null;
            this.createdDateTime = _data["createdDateTime"] ? moment(_data["createdDateTime"].toString()) : <any>null;
            this.callTimes = _data["callTimes"] ? ClientLeadCallTimeDto.fromJS(_data["callTimes"]) : <any>null;
            this.referenceSalesRepNo = _data["referenceSalesRepNo"] !== undefined ? _data["referenceSalesRepNo"] : <any>null;
            this.callBackDateTime = _data["callBackDateTime"] ? moment(_data["callBackDateTime"].toString()) : <any>null;
            this.address = _data["address"] ? AddressDto.fromJS(_data["address"]) : <any>null;
            this.assignedEmployee = _data["assignedEmployee"] ? NestedEmployeeDto.fromJS(_data["assignedEmployee"]) : <any>null;
            this.status = _data["status"] !== undefined ? _data["status"] : <any>null;
            this.unbookableReason = _data["unbookableReason"] !== undefined ? _data["unbookableReason"] : <any>null;
            this.notInterestedReason = _data["notInterestedReason"] !== undefined ? _data["notInterestedReason"] : <any>null;
            this.clientLeadSourceTypeInfo = _data["clientLeadSourceTypeInfo"] ? ClientLeadSourceTypeDto.fromJS(_data["clientLeadSourceTypeInfo"]) : <any>null;
            this.clientLeadSourceTypeId = _data["clientLeadSourceTypeId"] !== undefined ? _data["clientLeadSourceTypeId"] : <any>null;
            this.referredFrom = _data["referredFrom"] !== undefined ? _data["referredFrom"] : <any>null;
            this.referenceTm = _data["referenceTm"] ? NestedEmployeeDto.fromJS(_data["referenceTm"]) : <any>null;
            this.referenceSalesRep = _data["referenceSalesRep"] ? NestedEmployeeDto.fromJS(_data["referenceSalesRep"]) : <any>null;
            if (Array.isArray(_data["clientLeadNotes"])) {
                this.clientLeadNotes = [] as any;
                for (let item of _data["clientLeadNotes"])
                    this.clientLeadNotes!.push(ClientLeadNoteDto.fromJS(item));
            }
            else {
                this.clientLeadNotes = <any>null;
            }
            this.zone = _data["zone"] !== undefined ? _data["zone"] : <any>null;
            this.campaign = _data["campaign"] !== undefined ? _data["campaign"] : <any>null;
            this.assignedEmployeeId = _data["assignedEmployeeId"] !== undefined ? _data["assignedEmployeeId"] : <any>null;
            this.assignedEmployeeName = _data["assignedEmployeeName"] !== undefined ? _data["assignedEmployeeName"] : <any>null;
            this.callNo = _data["callNo"] !== undefined ? _data["callNo"] : <any>null;
            this.referralInfo = _data["referralInfo"] ? ReferralInfoDto.fromJS(_data["referralInfo"]) : <any>null;
            this.canChangeAssignedEmployee = _data["canChangeAssignedEmployee"] !== undefined ? _data["canChangeAssignedEmployee"] : <any>null;
            this.isInDnclList = _data["isInDnclList"] !== undefined ? _data["isInDnclList"] : <any>null;
            this.isInLocalDnclList = _data["isInLocalDnclList"] !== undefined ? _data["isInLocalDnclList"] : <any>null;
            this.isOptInLeadCreatedAfterLocalDncl = _data["isOptInLeadCreatedAfterLocalDncl"] !== undefined ? _data["isOptInLeadCreatedAfterLocalDncl"] : <any>null;
        }
    }

    static fromJS(data: any): ClientLeadDto {
        data = typeof data === 'object' ? data : {};
        let result = new ClientLeadDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["marketingSiteUrl"] = this.marketingSiteUrl !== undefined ? this.marketingSiteUrl : <any>null;
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["email"] = this.email !== undefined ? this.email : <any>null;
        data["phoneNumber"] = this.phoneNumber !== undefined ? this.phoneNumber : <any>null;
        data["phoneNumberClean"] = this.phoneNumberClean !== undefined ? this.phoneNumberClean : <any>null;
        data["phoneNumberExtension"] = this.phoneNumberExtension !== undefined ? this.phoneNumberExtension : <any>null;
        data["createdDateTime"] = this.createdDateTime ? this.createdDateTime.toISOString() : <any>null;
        data["callTimes"] = this.callTimes ? this.callTimes.toJSON() : <any>null;
        data["referenceSalesRepNo"] = this.referenceSalesRepNo !== undefined ? this.referenceSalesRepNo : <any>null;
        data["callBackDateTime"] = this.callBackDateTime ? this.callBackDateTime.toISOString() : <any>null;
        data["address"] = this.address ? this.address.toJSON() : <any>null;
        data["assignedEmployee"] = this.assignedEmployee ? this.assignedEmployee.toJSON() : <any>null;
        data["status"] = this.status !== undefined ? this.status : <any>null;
        data["unbookableReason"] = this.unbookableReason !== undefined ? this.unbookableReason : <any>null;
        data["notInterestedReason"] = this.notInterestedReason !== undefined ? this.notInterestedReason : <any>null;
        data["clientLeadSourceTypeInfo"] = this.clientLeadSourceTypeInfo ? this.clientLeadSourceTypeInfo.toJSON() : <any>null;
        data["clientLeadSourceTypeId"] = this.clientLeadSourceTypeId !== undefined ? this.clientLeadSourceTypeId : <any>null;
        data["referredFrom"] = this.referredFrom !== undefined ? this.referredFrom : <any>null;
        data["referenceTm"] = this.referenceTm ? this.referenceTm.toJSON() : <any>null;
        data["referenceSalesRep"] = this.referenceSalesRep ? this.referenceSalesRep.toJSON() : <any>null;
        if (Array.isArray(this.clientLeadNotes)) {
            data["clientLeadNotes"] = [];
            for (let item of this.clientLeadNotes)
                data["clientLeadNotes"].push(item.toJSON());
        }
        data["zone"] = this.zone !== undefined ? this.zone : <any>null;
        data["campaign"] = this.campaign !== undefined ? this.campaign : <any>null;
        data["assignedEmployeeId"] = this.assignedEmployeeId !== undefined ? this.assignedEmployeeId : <any>null;
        data["assignedEmployeeName"] = this.assignedEmployeeName !== undefined ? this.assignedEmployeeName : <any>null;
        data["callNo"] = this.callNo !== undefined ? this.callNo : <any>null;
        data["referralInfo"] = this.referralInfo ? this.referralInfo.toJSON() : <any>null;
        data["canChangeAssignedEmployee"] = this.canChangeAssignedEmployee !== undefined ? this.canChangeAssignedEmployee : <any>null;
        data["isInDnclList"] = this.isInDnclList !== undefined ? this.isInDnclList : <any>null;
        data["isInLocalDnclList"] = this.isInLocalDnclList !== undefined ? this.isInLocalDnclList : <any>null;
        data["isOptInLeadCreatedAfterLocalDncl"] = this.isOptInLeadCreatedAfterLocalDncl !== undefined ? this.isOptInLeadCreatedAfterLocalDncl : <any>null;
        return data;
    }
}

export interface IClientLeadDto {
    marketingSiteUrl?: string | null;
    id?: number;
    name?: string | null;
    email?: string | null;
    phoneNumber?: string | null;
    phoneNumberClean?: string | null;
    phoneNumberExtension?: string | null;
    createdDateTime?: moment.Moment;
    callTimes?: ClientLeadCallTimeDto | null;
    referenceSalesRepNo?: number | null;
    callBackDateTime?: moment.Moment | null;
    address?: AddressDto | null;
    assignedEmployee?: NestedEmployeeDto | null;
    status?: ClientLeadStatus;
    unbookableReason?: UnbookableReason | null;
    notInterestedReason?: NotInterestedReason | null;
    clientLeadSourceTypeInfo?: ClientLeadSourceTypeDto | null;
    clientLeadSourceTypeId?: number;
    referredFrom?: string | null;
    referenceTm?: NestedEmployeeDto | null;
    referenceSalesRep?: NestedEmployeeDto | null;
    clientLeadNotes?: ClientLeadNoteDto[] | null;
    zone?: string | null;
    campaign?: string | null;
    assignedEmployeeId?: string | null;
    assignedEmployeeName?: string | null;
    callNo?: number | null;
    referralInfo?: ReferralInfoDto | null;
    canChangeAssignedEmployee?: boolean;
    isInDnclList?: boolean;
    isInLocalDnclList?: boolean;
    isOptInLeadCreatedAfterLocalDncl?: boolean;
}

export enum NotInterestedReason {
    PrefGroceryAccess = "prefGroceryAccess",
    SelfProvisioning = "selfProvisioning",
    Telemarketing = "telemarketing",
    Elderly = "elderly",
    Lifestyle = "lifestyle",
    Competition = "competition",
    DoesNotWantToMeet = "doesNotWantToMeet",
    UnknownReference = "unknownReference",
    Commitment = "commitment",
    Freezer = "freezer",
    Diet = "diet",
    NotObtained = "notObtained",
    WrongNumberOrNoService = "wrongNumberOrNoService",
    ExistingCustomer = "existingCustomer",
}

export class ClientLeadNoteDto extends BaseLeadNoteDto implements IClientLeadNoteDto {
    clientLeadId?: number;
    clientLeadName?: string | null;

    constructor(data?: IClientLeadNoteDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.clientLeadId = _data["clientLeadId"] !== undefined ? _data["clientLeadId"] : <any>null;
            this.clientLeadName = _data["clientLeadName"] !== undefined ? _data["clientLeadName"] : <any>null;
        }
    }

    static override fromJS(data: any): ClientLeadNoteDto {
        data = typeof data === 'object' ? data : {};
        let result = new ClientLeadNoteDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clientLeadId"] = this.clientLeadId !== undefined ? this.clientLeadId : <any>null;
        data["clientLeadName"] = this.clientLeadName !== undefined ? this.clientLeadName : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IClientLeadNoteDto extends IBaseLeadNoteDto {
    clientLeadId?: number;
    clientLeadName?: string | null;
}

export class GetAllClientLeadsNotesListQuery implements IGetAllClientLeadsNotesListQuery {
    clientLeadNoteType?: LeadNoteType[] | null;
    fromDateTime?: moment.Moment;
    toDateTime?: moment.Moment;
    onlyShowAssignedClientLeadNotes?: boolean;
    userId?: string | null;

    constructor(data?: IGetAllClientLeadsNotesListQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["clientLeadNoteType"])) {
                this.clientLeadNoteType = [] as any;
                for (let item of _data["clientLeadNoteType"])
                    this.clientLeadNoteType!.push(item);
            }
            else {
                this.clientLeadNoteType = <any>null;
            }
            this.fromDateTime = _data["fromDateTime"] ? moment(_data["fromDateTime"].toString()) : <any>null;
            this.toDateTime = _data["toDateTime"] ? moment(_data["toDateTime"].toString()) : <any>null;
            this.onlyShowAssignedClientLeadNotes = _data["onlyShowAssignedClientLeadNotes"] !== undefined ? _data["onlyShowAssignedClientLeadNotes"] : <any>null;
            this.userId = _data["userId"] !== undefined ? _data["userId"] : <any>null;
        }
    }

    static fromJS(data: any): GetAllClientLeadsNotesListQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllClientLeadsNotesListQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.clientLeadNoteType)) {
            data["clientLeadNoteType"] = [];
            for (let item of this.clientLeadNoteType)
                data["clientLeadNoteType"].push(item);
        }
        data["fromDateTime"] = this.fromDateTime ? this.fromDateTime.toISOString() : <any>null;
        data["toDateTime"] = this.toDateTime ? this.toDateTime.toISOString() : <any>null;
        data["onlyShowAssignedClientLeadNotes"] = this.onlyShowAssignedClientLeadNotes !== undefined ? this.onlyShowAssignedClientLeadNotes : <any>null;
        data["userId"] = this.userId !== undefined ? this.userId : <any>null;
        return data;
    }
}

export interface IGetAllClientLeadsNotesListQuery {
    clientLeadNoteType?: LeadNoteType[] | null;
    fromDateTime?: moment.Moment;
    toDateTime?: moment.Moment;
    onlyShowAssignedClientLeadNotes?: boolean;
    userId?: string | null;
}

export abstract class AssingableEntity extends EntityOfInteger implements IAssingableEntity {
    assignedEmployee?: Employee | null;
    assignedEmployeeId?: string | null;
    assignedByEmployee?: Employee | null;
    assignedByEmployeeId?: string | null;
    assignedEmployeeDateTime?: moment.Moment | null;
    createdDateTime?: moment.Moment;

    constructor(data?: IAssingableEntity) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.assignedEmployee = _data["assignedEmployee"] ? Employee.fromJS(_data["assignedEmployee"]) : <any>null;
            this.assignedEmployeeId = _data["assignedEmployeeId"] !== undefined ? _data["assignedEmployeeId"] : <any>null;
            this.assignedByEmployee = _data["assignedByEmployee"] ? Employee.fromJS(_data["assignedByEmployee"]) : <any>null;
            this.assignedByEmployeeId = _data["assignedByEmployeeId"] !== undefined ? _data["assignedByEmployeeId"] : <any>null;
            this.assignedEmployeeDateTime = _data["assignedEmployeeDateTime"] ? moment(_data["assignedEmployeeDateTime"].toString()) : <any>null;
            this.createdDateTime = _data["createdDateTime"] ? moment(_data["createdDateTime"].toString()) : <any>null;
        }
    }

    static override fromJS(data: any): AssingableEntity {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'AssingableEntity' cannot be instantiated.");
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["assignedEmployee"] = this.assignedEmployee ? this.assignedEmployee.toJSON() : <any>null;
        data["assignedEmployeeId"] = this.assignedEmployeeId !== undefined ? this.assignedEmployeeId : <any>null;
        data["assignedByEmployee"] = this.assignedByEmployee ? this.assignedByEmployee.toJSON() : <any>null;
        data["assignedByEmployeeId"] = this.assignedByEmployeeId !== undefined ? this.assignedByEmployeeId : <any>null;
        data["assignedEmployeeDateTime"] = this.assignedEmployeeDateTime ? this.assignedEmployeeDateTime.toISOString() : <any>null;
        data["createdDateTime"] = this.createdDateTime ? this.createdDateTime.toISOString() : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IAssingableEntity extends IEntityOfInteger {
    assignedEmployee?: Employee | null;
    assignedEmployeeId?: string | null;
    assignedByEmployee?: Employee | null;
    assignedByEmployeeId?: string | null;
    assignedEmployeeDateTime?: moment.Moment | null;
    createdDateTime?: moment.Moment;
}

export class ClientLead extends AssingableEntity implements IClientLead {
    name!: string;
    email?: string | null;
    phoneNumber?: string | null;
    phoneNumberExtension?: string | null;
    clientLeadCallTime?: ClientLeadCallTime | null;
    callBackDateTime?: moment.Moment | null;
    address?: Address | null;
    languageType?: LanguageType;
    importedClientLeadsOrdersRecord?: ImportedClientLeadsOrdersRecord | null;
    importedClientLeadsOrdersRecordId?: number | null;
    status?: ClientLeadStatus;
    unbookableReason?: UnbookableReason | null;
    clientLeadSourceTypeRecord?: ClientLeadSourceType | null;
    clientLeadSourceTypeId?: number;
    referredFrom?: string | null;
    crmAppointment?: CrmAppointment | null;
    referenceNumber?: number | null;
    isInDnclList?: boolean;
    isInLocalDnclList?: boolean;
    zoneId?: number | null;
    zone?: Zone | null;
    campaignId?: number | null;
    campaign?: Campaign | null;
    clientLeadRecycles?: ClientLeadRecycles[] | null;
    jotformReferenceId?: string | null;
    marketingSiteUrl?: string | null;
    finalStatusChangeDateTime?: moment.Moment | null;
    latestRecycleDateTime?: moment.Moment | null;

    constructor(data?: IClientLead) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.email = _data["email"] !== undefined ? _data["email"] : <any>null;
            this.phoneNumber = _data["phoneNumber"] !== undefined ? _data["phoneNumber"] : <any>null;
            this.phoneNumberExtension = _data["phoneNumberExtension"] !== undefined ? _data["phoneNumberExtension"] : <any>null;
            this.clientLeadCallTime = _data["clientLeadCallTime"] ? ClientLeadCallTime.fromJS(_data["clientLeadCallTime"]) : <any>null;
            this.callBackDateTime = _data["callBackDateTime"] ? moment(_data["callBackDateTime"].toString()) : <any>null;
            this.address = _data["address"] ? Address.fromJS(_data["address"]) : <any>null;
            this.languageType = _data["languageType"] !== undefined ? _data["languageType"] : <any>null;
            this.importedClientLeadsOrdersRecord = _data["importedClientLeadsOrdersRecord"] ? ImportedClientLeadsOrdersRecord.fromJS(_data["importedClientLeadsOrdersRecord"]) : <any>null;
            this.importedClientLeadsOrdersRecordId = _data["importedClientLeadsOrdersRecordId"] !== undefined ? _data["importedClientLeadsOrdersRecordId"] : <any>null;
            this.status = _data["status"] !== undefined ? _data["status"] : <any>null;
            this.unbookableReason = _data["unbookableReason"] !== undefined ? _data["unbookableReason"] : <any>null;
            this.clientLeadSourceTypeRecord = _data["clientLeadSourceTypeRecord"] ? ClientLeadSourceType.fromJS(_data["clientLeadSourceTypeRecord"]) : <any>null;
            this.clientLeadSourceTypeId = _data["clientLeadSourceTypeId"] !== undefined ? _data["clientLeadSourceTypeId"] : <any>null;
            this.referredFrom = _data["referredFrom"] !== undefined ? _data["referredFrom"] : <any>null;
            this.crmAppointment = _data["crmAppointment"] ? CrmAppointment.fromJS(_data["crmAppointment"]) : <any>null;
            this.referenceNumber = _data["referenceNumber"] !== undefined ? _data["referenceNumber"] : <any>null;
            this.isInDnclList = _data["isInDnclList"] !== undefined ? _data["isInDnclList"] : <any>null;
            this.isInLocalDnclList = _data["isInLocalDnclList"] !== undefined ? _data["isInLocalDnclList"] : <any>null;
            this.zoneId = _data["zoneId"] !== undefined ? _data["zoneId"] : <any>null;
            this.zone = _data["zone"] ? Zone.fromJS(_data["zone"]) : <any>null;
            this.campaignId = _data["campaignId"] !== undefined ? _data["campaignId"] : <any>null;
            this.campaign = _data["campaign"] ? Campaign.fromJS(_data["campaign"]) : <any>null;
            if (Array.isArray(_data["clientLeadRecycles"])) {
                this.clientLeadRecycles = [] as any;
                for (let item of _data["clientLeadRecycles"])
                    this.clientLeadRecycles!.push(ClientLeadRecycles.fromJS(item));
            }
            else {
                this.clientLeadRecycles = <any>null;
            }
            this.jotformReferenceId = _data["jotformReferenceId"] !== undefined ? _data["jotformReferenceId"] : <any>null;
            this.marketingSiteUrl = _data["marketingSiteUrl"] !== undefined ? _data["marketingSiteUrl"] : <any>null;
            this.finalStatusChangeDateTime = _data["finalStatusChangeDateTime"] ? moment(_data["finalStatusChangeDateTime"].toString()) : <any>null;
            this.latestRecycleDateTime = _data["latestRecycleDateTime"] ? moment(_data["latestRecycleDateTime"].toString()) : <any>null;
        }
    }

    static override fromJS(data: any): ClientLead {
        data = typeof data === 'object' ? data : {};
        let result = new ClientLead();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["email"] = this.email !== undefined ? this.email : <any>null;
        data["phoneNumber"] = this.phoneNumber !== undefined ? this.phoneNumber : <any>null;
        data["phoneNumberExtension"] = this.phoneNumberExtension !== undefined ? this.phoneNumberExtension : <any>null;
        data["clientLeadCallTime"] = this.clientLeadCallTime ? this.clientLeadCallTime.toJSON() : <any>null;
        data["callBackDateTime"] = this.callBackDateTime ? this.callBackDateTime.toISOString() : <any>null;
        data["address"] = this.address ? this.address.toJSON() : <any>null;
        data["languageType"] = this.languageType !== undefined ? this.languageType : <any>null;
        data["importedClientLeadsOrdersRecord"] = this.importedClientLeadsOrdersRecord ? this.importedClientLeadsOrdersRecord.toJSON() : <any>null;
        data["importedClientLeadsOrdersRecordId"] = this.importedClientLeadsOrdersRecordId !== undefined ? this.importedClientLeadsOrdersRecordId : <any>null;
        data["status"] = this.status !== undefined ? this.status : <any>null;
        data["unbookableReason"] = this.unbookableReason !== undefined ? this.unbookableReason : <any>null;
        data["clientLeadSourceTypeRecord"] = this.clientLeadSourceTypeRecord ? this.clientLeadSourceTypeRecord.toJSON() : <any>null;
        data["clientLeadSourceTypeId"] = this.clientLeadSourceTypeId !== undefined ? this.clientLeadSourceTypeId : <any>null;
        data["referredFrom"] = this.referredFrom !== undefined ? this.referredFrom : <any>null;
        data["crmAppointment"] = this.crmAppointment ? this.crmAppointment.toJSON() : <any>null;
        data["referenceNumber"] = this.referenceNumber !== undefined ? this.referenceNumber : <any>null;
        data["isInDnclList"] = this.isInDnclList !== undefined ? this.isInDnclList : <any>null;
        data["isInLocalDnclList"] = this.isInLocalDnclList !== undefined ? this.isInLocalDnclList : <any>null;
        data["zoneId"] = this.zoneId !== undefined ? this.zoneId : <any>null;
        data["zone"] = this.zone ? this.zone.toJSON() : <any>null;
        data["campaignId"] = this.campaignId !== undefined ? this.campaignId : <any>null;
        data["campaign"] = this.campaign ? this.campaign.toJSON() : <any>null;
        if (Array.isArray(this.clientLeadRecycles)) {
            data["clientLeadRecycles"] = [];
            for (let item of this.clientLeadRecycles)
                data["clientLeadRecycles"].push(item.toJSON());
        }
        data["jotformReferenceId"] = this.jotformReferenceId !== undefined ? this.jotformReferenceId : <any>null;
        data["marketingSiteUrl"] = this.marketingSiteUrl !== undefined ? this.marketingSiteUrl : <any>null;
        data["finalStatusChangeDateTime"] = this.finalStatusChangeDateTime ? this.finalStatusChangeDateTime.toISOString() : <any>null;
        data["latestRecycleDateTime"] = this.latestRecycleDateTime ? this.latestRecycleDateTime.toISOString() : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IClientLead extends IAssingableEntity {
    name: string;
    email?: string | null;
    phoneNumber?: string | null;
    phoneNumberExtension?: string | null;
    clientLeadCallTime?: ClientLeadCallTime | null;
    callBackDateTime?: moment.Moment | null;
    address?: Address | null;
    languageType?: LanguageType;
    importedClientLeadsOrdersRecord?: ImportedClientLeadsOrdersRecord | null;
    importedClientLeadsOrdersRecordId?: number | null;
    status?: ClientLeadStatus;
    unbookableReason?: UnbookableReason | null;
    clientLeadSourceTypeRecord?: ClientLeadSourceType | null;
    clientLeadSourceTypeId?: number;
    referredFrom?: string | null;
    crmAppointment?: CrmAppointment | null;
    referenceNumber?: number | null;
    isInDnclList?: boolean;
    isInLocalDnclList?: boolean;
    zoneId?: number | null;
    zone?: Zone | null;
    campaignId?: number | null;
    campaign?: Campaign | null;
    clientLeadRecycles?: ClientLeadRecycles[] | null;
    jotformReferenceId?: string | null;
    marketingSiteUrl?: string | null;
    finalStatusChangeDateTime?: moment.Moment | null;
    latestRecycleDateTime?: moment.Moment | null;
}

export class ClientLeadCallTime implements IClientLeadCallTime {
    clientLeadId?: number;
    clientLead?: ClientLead | null;
    callInMorning?: boolean;
    callInAfternoon?: boolean;
    callInEvening?: boolean;

    constructor(data?: IClientLeadCallTime) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.clientLeadId = _data["clientLeadId"] !== undefined ? _data["clientLeadId"] : <any>null;
            this.clientLead = _data["clientLead"] ? ClientLead.fromJS(_data["clientLead"]) : <any>null;
            this.callInMorning = _data["callInMorning"] !== undefined ? _data["callInMorning"] : <any>null;
            this.callInAfternoon = _data["callInAfternoon"] !== undefined ? _data["callInAfternoon"] : <any>null;
            this.callInEvening = _data["callInEvening"] !== undefined ? _data["callInEvening"] : <any>null;
        }
    }

    static fromJS(data: any): ClientLeadCallTime {
        data = typeof data === 'object' ? data : {};
        let result = new ClientLeadCallTime();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clientLeadId"] = this.clientLeadId !== undefined ? this.clientLeadId : <any>null;
        data["clientLead"] = this.clientLead ? this.clientLead.toJSON() : <any>null;
        data["callInMorning"] = this.callInMorning !== undefined ? this.callInMorning : <any>null;
        data["callInAfternoon"] = this.callInAfternoon !== undefined ? this.callInAfternoon : <any>null;
        data["callInEvening"] = this.callInEvening !== undefined ? this.callInEvening : <any>null;
        return data;
    }
}

export interface IClientLeadCallTime {
    clientLeadId?: number;
    clientLead?: ClientLead | null;
    callInMorning?: boolean;
    callInAfternoon?: boolean;
    callInEvening?: boolean;
}

export abstract class PrivateEntityOfInteger implements IPrivateEntityOfInteger {
    id?: number;

    constructor(data?: IPrivateEntityOfInteger) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
        }
    }

    static fromJS(data: any): PrivateEntityOfInteger {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'PrivateEntityOfInteger' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        return data;
    }
}

export interface IPrivateEntityOfInteger {
    id?: number;
}

export class ImportedClientLeadsOrdersRecord extends PrivateEntityOfInteger implements IImportedClientLeadsOrdersRecord {
    orderNo?: number;
    importedOrderType?: ImportOrderType;
    clientName?: string | null;
    clientConjointName?: string | null;
    clientNo?: number;
    clientCity?: string | null;
    fromClientId?: string | null;
    fromClient?: Client | null;
    tm?: Employee | null;
    tmId?: string | null;
    tmName?: string | null;
    tmNo?: number | null;
    salesRep?: Employee | null;
    salesRepId?: string | null;
    salesRepName?: string | null;
    salesRepNo?: number | null;
    createdClientLeads?: ClientLead[] | null;
    importedClientLeadsFromOrdersRecordId?: number;
    importedClientLeadsFromOrdersRecord?: ImportedClientLeadsFromOrdersRecord | null;

    constructor(data?: IImportedClientLeadsOrdersRecord) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.orderNo = _data["orderNo"] !== undefined ? _data["orderNo"] : <any>null;
            this.importedOrderType = _data["importedOrderType"] !== undefined ? _data["importedOrderType"] : <any>null;
            this.clientName = _data["clientName"] !== undefined ? _data["clientName"] : <any>null;
            this.clientConjointName = _data["clientConjointName"] !== undefined ? _data["clientConjointName"] : <any>null;
            this.clientNo = _data["clientNo"] !== undefined ? _data["clientNo"] : <any>null;
            this.clientCity = _data["clientCity"] !== undefined ? _data["clientCity"] : <any>null;
            this.fromClientId = _data["fromClientId"] !== undefined ? _data["fromClientId"] : <any>null;
            this.fromClient = _data["fromClient"] ? Client.fromJS(_data["fromClient"]) : <any>null;
            this.tm = _data["tm"] ? Employee.fromJS(_data["tm"]) : <any>null;
            this.tmId = _data["tmId"] !== undefined ? _data["tmId"] : <any>null;
            this.tmName = _data["tmName"] !== undefined ? _data["tmName"] : <any>null;
            this.tmNo = _data["tmNo"] !== undefined ? _data["tmNo"] : <any>null;
            this.salesRep = _data["salesRep"] ? Employee.fromJS(_data["salesRep"]) : <any>null;
            this.salesRepId = _data["salesRepId"] !== undefined ? _data["salesRepId"] : <any>null;
            this.salesRepName = _data["salesRepName"] !== undefined ? _data["salesRepName"] : <any>null;
            this.salesRepNo = _data["salesRepNo"] !== undefined ? _data["salesRepNo"] : <any>null;
            if (Array.isArray(_data["createdClientLeads"])) {
                this.createdClientLeads = [] as any;
                for (let item of _data["createdClientLeads"])
                    this.createdClientLeads!.push(ClientLead.fromJS(item));
            }
            else {
                this.createdClientLeads = <any>null;
            }
            this.importedClientLeadsFromOrdersRecordId = _data["importedClientLeadsFromOrdersRecordId"] !== undefined ? _data["importedClientLeadsFromOrdersRecordId"] : <any>null;
            this.importedClientLeadsFromOrdersRecord = _data["importedClientLeadsFromOrdersRecord"] ? ImportedClientLeadsFromOrdersRecord.fromJS(_data["importedClientLeadsFromOrdersRecord"]) : <any>null;
        }
    }

    static override fromJS(data: any): ImportedClientLeadsOrdersRecord {
        data = typeof data === 'object' ? data : {};
        let result = new ImportedClientLeadsOrdersRecord();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["orderNo"] = this.orderNo !== undefined ? this.orderNo : <any>null;
        data["importedOrderType"] = this.importedOrderType !== undefined ? this.importedOrderType : <any>null;
        data["clientName"] = this.clientName !== undefined ? this.clientName : <any>null;
        data["clientConjointName"] = this.clientConjointName !== undefined ? this.clientConjointName : <any>null;
        data["clientNo"] = this.clientNo !== undefined ? this.clientNo : <any>null;
        data["clientCity"] = this.clientCity !== undefined ? this.clientCity : <any>null;
        data["fromClientId"] = this.fromClientId !== undefined ? this.fromClientId : <any>null;
        data["fromClient"] = this.fromClient ? this.fromClient.toJSON() : <any>null;
        data["tm"] = this.tm ? this.tm.toJSON() : <any>null;
        data["tmId"] = this.tmId !== undefined ? this.tmId : <any>null;
        data["tmName"] = this.tmName !== undefined ? this.tmName : <any>null;
        data["tmNo"] = this.tmNo !== undefined ? this.tmNo : <any>null;
        data["salesRep"] = this.salesRep ? this.salesRep.toJSON() : <any>null;
        data["salesRepId"] = this.salesRepId !== undefined ? this.salesRepId : <any>null;
        data["salesRepName"] = this.salesRepName !== undefined ? this.salesRepName : <any>null;
        data["salesRepNo"] = this.salesRepNo !== undefined ? this.salesRepNo : <any>null;
        if (Array.isArray(this.createdClientLeads)) {
            data["createdClientLeads"] = [];
            for (let item of this.createdClientLeads)
                data["createdClientLeads"].push(item.toJSON());
        }
        data["importedClientLeadsFromOrdersRecordId"] = this.importedClientLeadsFromOrdersRecordId !== undefined ? this.importedClientLeadsFromOrdersRecordId : <any>null;
        data["importedClientLeadsFromOrdersRecord"] = this.importedClientLeadsFromOrdersRecord ? this.importedClientLeadsFromOrdersRecord.toJSON() : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IImportedClientLeadsOrdersRecord extends IPrivateEntityOfInteger {
    orderNo?: number;
    importedOrderType?: ImportOrderType;
    clientName?: string | null;
    clientConjointName?: string | null;
    clientNo?: number;
    clientCity?: string | null;
    fromClientId?: string | null;
    fromClient?: Client | null;
    tm?: Employee | null;
    tmId?: string | null;
    tmName?: string | null;
    tmNo?: number | null;
    salesRep?: Employee | null;
    salesRepId?: string | null;
    salesRepName?: string | null;
    salesRepNo?: number | null;
    createdClientLeads?: ClientLead[] | null;
    importedClientLeadsFromOrdersRecordId?: number;
    importedClientLeadsFromOrdersRecord?: ImportedClientLeadsFromOrdersRecord | null;
}

export class Client extends ApplicationUser implements IClient {
    conjoint?: Client | null;
    conjointId?: string | null;
    clientNo?: number | null;
    dateOfBirth?: moment.Moment;
    bankInfo?: BankInfo | null;
    clientRegisterCode?: ClientRegisterCode | null;
    notificationType?: NotificationType;
    notes?: string | null;
    contracts?: ClientContract[] | null;
    ownerContracts?: Contract[] | null;
    clientChangeRequests?: ClientChangeRequest[] | null;
    clientSatisfactionResponses?: ClientSatisfactionResponse[] | null;
    language?: LanguageType;
    hasNoEmail?: boolean | null;
    gs?: boolean | null;
    otherTaxes?: boolean | null;
    isConjointClient?: boolean;
    isInvalidEmail?: boolean;
    specialInstructions?: string | null;
    deliveryComments?: string | null;
    confirmationNotes?: string | null;
    unsubscribeMarketingEmails?: boolean;
    unsubscribeTransactionalEmails?: boolean;
    pendingClientChangeRequest?: ClientChangeRequest | null;
    nsfNotification?: NsfNotification | null;
    archivedAccount?: boolean;
    archivedReason?: string | null;

    constructor(data?: IClient) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.conjoint = _data["conjoint"] ? Client.fromJS(_data["conjoint"]) : <any>null;
            this.conjointId = _data["conjointId"] !== undefined ? _data["conjointId"] : <any>null;
            this.clientNo = _data["clientNo"] !== undefined ? _data["clientNo"] : <any>null;
            this.dateOfBirth = _data["dateOfBirth"] ? moment(_data["dateOfBirth"].toString()) : <any>null;
            this.bankInfo = _data["bankInfo"] ? BankInfo.fromJS(_data["bankInfo"]) : <any>null;
            this.clientRegisterCode = _data["clientRegisterCode"] ? ClientRegisterCode.fromJS(_data["clientRegisterCode"]) : <any>null;
            this.notificationType = _data["notificationType"] !== undefined ? _data["notificationType"] : <any>null;
            this.notes = _data["notes"] !== undefined ? _data["notes"] : <any>null;
            if (Array.isArray(_data["contracts"])) {
                this.contracts = [] as any;
                for (let item of _data["contracts"])
                    this.contracts!.push(ClientContract.fromJS(item));
            }
            else {
                this.contracts = <any>null;
            }
            if (Array.isArray(_data["ownerContracts"])) {
                this.ownerContracts = [] as any;
                for (let item of _data["ownerContracts"])
                    this.ownerContracts!.push(Contract.fromJS(item));
            }
            else {
                this.ownerContracts = <any>null;
            }
            if (Array.isArray(_data["clientChangeRequests"])) {
                this.clientChangeRequests = [] as any;
                for (let item of _data["clientChangeRequests"])
                    this.clientChangeRequests!.push(ClientChangeRequest.fromJS(item));
            }
            else {
                this.clientChangeRequests = <any>null;
            }
            if (Array.isArray(_data["clientSatisfactionResponses"])) {
                this.clientSatisfactionResponses = [] as any;
                for (let item of _data["clientSatisfactionResponses"])
                    this.clientSatisfactionResponses!.push(ClientSatisfactionResponse.fromJS(item));
            }
            else {
                this.clientSatisfactionResponses = <any>null;
            }
            this.language = _data["language"] !== undefined ? _data["language"] : <any>null;
            this.hasNoEmail = _data["hasNoEmail"] !== undefined ? _data["hasNoEmail"] : <any>null;
            this.gs = _data["gs"] !== undefined ? _data["gs"] : <any>null;
            this.otherTaxes = _data["otherTaxes"] !== undefined ? _data["otherTaxes"] : <any>null;
            this.isConjointClient = _data["isConjointClient"] !== undefined ? _data["isConjointClient"] : <any>null;
            this.isInvalidEmail = _data["isInvalidEmail"] !== undefined ? _data["isInvalidEmail"] : <any>null;
            this.specialInstructions = _data["specialInstructions"] !== undefined ? _data["specialInstructions"] : <any>null;
            this.deliveryComments = _data["deliveryComments"] !== undefined ? _data["deliveryComments"] : <any>null;
            this.confirmationNotes = _data["confirmationNotes"] !== undefined ? _data["confirmationNotes"] : <any>null;
            this.unsubscribeMarketingEmails = _data["unsubscribeMarketingEmails"] !== undefined ? _data["unsubscribeMarketingEmails"] : <any>null;
            this.unsubscribeTransactionalEmails = _data["unsubscribeTransactionalEmails"] !== undefined ? _data["unsubscribeTransactionalEmails"] : <any>null;
            this.pendingClientChangeRequest = _data["pendingClientChangeRequest"] ? ClientChangeRequest.fromJS(_data["pendingClientChangeRequest"]) : <any>null;
            this.nsfNotification = _data["nsfNotification"] ? NsfNotification.fromJS(_data["nsfNotification"]) : <any>null;
            this.archivedAccount = _data["archivedAccount"] !== undefined ? _data["archivedAccount"] : <any>null;
            this.archivedReason = _data["archivedReason"] !== undefined ? _data["archivedReason"] : <any>null;
        }
    }

    static override fromJS(data: any): Client {
        data = typeof data === 'object' ? data : {};
        let result = new Client();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["conjoint"] = this.conjoint ? this.conjoint.toJSON() : <any>null;
        data["conjointId"] = this.conjointId !== undefined ? this.conjointId : <any>null;
        data["clientNo"] = this.clientNo !== undefined ? this.clientNo : <any>null;
        data["dateOfBirth"] = this.dateOfBirth ? this.dateOfBirth.format('YYYY-MM-DD') : <any>null;
        data["bankInfo"] = this.bankInfo ? this.bankInfo.toJSON() : <any>null;
        data["clientRegisterCode"] = this.clientRegisterCode ? this.clientRegisterCode.toJSON() : <any>null;
        data["notificationType"] = this.notificationType !== undefined ? this.notificationType : <any>null;
        data["notes"] = this.notes !== undefined ? this.notes : <any>null;
        if (Array.isArray(this.contracts)) {
            data["contracts"] = [];
            for (let item of this.contracts)
                data["contracts"].push(item.toJSON());
        }
        if (Array.isArray(this.ownerContracts)) {
            data["ownerContracts"] = [];
            for (let item of this.ownerContracts)
                data["ownerContracts"].push(item.toJSON());
        }
        if (Array.isArray(this.clientChangeRequests)) {
            data["clientChangeRequests"] = [];
            for (let item of this.clientChangeRequests)
                data["clientChangeRequests"].push(item.toJSON());
        }
        if (Array.isArray(this.clientSatisfactionResponses)) {
            data["clientSatisfactionResponses"] = [];
            for (let item of this.clientSatisfactionResponses)
                data["clientSatisfactionResponses"].push(item.toJSON());
        }
        data["language"] = this.language !== undefined ? this.language : <any>null;
        data["hasNoEmail"] = this.hasNoEmail !== undefined ? this.hasNoEmail : <any>null;
        data["gs"] = this.gs !== undefined ? this.gs : <any>null;
        data["otherTaxes"] = this.otherTaxes !== undefined ? this.otherTaxes : <any>null;
        data["isConjointClient"] = this.isConjointClient !== undefined ? this.isConjointClient : <any>null;
        data["isInvalidEmail"] = this.isInvalidEmail !== undefined ? this.isInvalidEmail : <any>null;
        data["specialInstructions"] = this.specialInstructions !== undefined ? this.specialInstructions : <any>null;
        data["deliveryComments"] = this.deliveryComments !== undefined ? this.deliveryComments : <any>null;
        data["confirmationNotes"] = this.confirmationNotes !== undefined ? this.confirmationNotes : <any>null;
        data["unsubscribeMarketingEmails"] = this.unsubscribeMarketingEmails !== undefined ? this.unsubscribeMarketingEmails : <any>null;
        data["unsubscribeTransactionalEmails"] = this.unsubscribeTransactionalEmails !== undefined ? this.unsubscribeTransactionalEmails : <any>null;
        data["pendingClientChangeRequest"] = this.pendingClientChangeRequest ? this.pendingClientChangeRequest.toJSON() : <any>null;
        data["nsfNotification"] = this.nsfNotification ? this.nsfNotification.toJSON() : <any>null;
        data["archivedAccount"] = this.archivedAccount !== undefined ? this.archivedAccount : <any>null;
        data["archivedReason"] = this.archivedReason !== undefined ? this.archivedReason : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IClient extends IApplicationUser {
    conjoint?: Client | null;
    conjointId?: string | null;
    clientNo?: number | null;
    dateOfBirth?: moment.Moment;
    bankInfo?: BankInfo | null;
    clientRegisterCode?: ClientRegisterCode | null;
    notificationType?: NotificationType;
    notes?: string | null;
    contracts?: ClientContract[] | null;
    ownerContracts?: Contract[] | null;
    clientChangeRequests?: ClientChangeRequest[] | null;
    clientSatisfactionResponses?: ClientSatisfactionResponse[] | null;
    language?: LanguageType;
    hasNoEmail?: boolean | null;
    gs?: boolean | null;
    otherTaxes?: boolean | null;
    isConjointClient?: boolean;
    isInvalidEmail?: boolean;
    specialInstructions?: string | null;
    deliveryComments?: string | null;
    confirmationNotes?: string | null;
    unsubscribeMarketingEmails?: boolean;
    unsubscribeTransactionalEmails?: boolean;
    pendingClientChangeRequest?: ClientChangeRequest | null;
    nsfNotification?: NsfNotification | null;
    archivedAccount?: boolean;
    archivedReason?: string | null;
}

export class BankInfo extends EntityOfInteger implements IBankInfo {
    useConjointName?: boolean;
    accountNo?: string | null;
    financialInstitutionNo?: string | null;
    branchTransitNo?: string | null;
    bankName?: string | null;
    address?: Address | null;
    contract?: Contract | null;
    clientId?: string | null;
    contractId?: number | null;
    isActive?: boolean;

    constructor(data?: IBankInfo) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.useConjointName = _data["useConjointName"] !== undefined ? _data["useConjointName"] : <any>null;
            this.accountNo = _data["accountNo"] !== undefined ? _data["accountNo"] : <any>null;
            this.financialInstitutionNo = _data["financialInstitutionNo"] !== undefined ? _data["financialInstitutionNo"] : <any>null;
            this.branchTransitNo = _data["branchTransitNo"] !== undefined ? _data["branchTransitNo"] : <any>null;
            this.bankName = _data["bankName"] !== undefined ? _data["bankName"] : <any>null;
            this.address = _data["address"] ? Address.fromJS(_data["address"]) : <any>null;
            this.contract = _data["contract"] ? Contract.fromJS(_data["contract"]) : <any>null;
            this.clientId = _data["clientId"] !== undefined ? _data["clientId"] : <any>null;
            this.contractId = _data["contractId"] !== undefined ? _data["contractId"] : <any>null;
            this.isActive = _data["isActive"] !== undefined ? _data["isActive"] : <any>null;
        }
    }

    static override fromJS(data: any): BankInfo {
        data = typeof data === 'object' ? data : {};
        let result = new BankInfo();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["useConjointName"] = this.useConjointName !== undefined ? this.useConjointName : <any>null;
        data["accountNo"] = this.accountNo !== undefined ? this.accountNo : <any>null;
        data["financialInstitutionNo"] = this.financialInstitutionNo !== undefined ? this.financialInstitutionNo : <any>null;
        data["branchTransitNo"] = this.branchTransitNo !== undefined ? this.branchTransitNo : <any>null;
        data["bankName"] = this.bankName !== undefined ? this.bankName : <any>null;
        data["address"] = this.address ? this.address.toJSON() : <any>null;
        data["contract"] = this.contract ? this.contract.toJSON() : <any>null;
        data["clientId"] = this.clientId !== undefined ? this.clientId : <any>null;
        data["contractId"] = this.contractId !== undefined ? this.contractId : <any>null;
        data["isActive"] = this.isActive !== undefined ? this.isActive : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IBankInfo extends IEntityOfInteger {
    useConjointName?: boolean;
    accountNo?: string | null;
    financialInstitutionNo?: string | null;
    branchTransitNo?: string | null;
    bankName?: string | null;
    address?: Address | null;
    contract?: Contract | null;
    clientId?: string | null;
    contractId?: number | null;
    isActive?: boolean;
}

export class Contract extends EntityOfInteger implements IContract {
    owner?: Client | null;
    ownerId?: string | null;
    clients?: ClientContract[] | null;
    clientIds?: string[] | null;
    clientsNames?: string | null;
    coConsumerName?: string | null;
    notes?: string | null;
    contractNumber!: number;
    numberOfDeliveries?: number;
    contractStatus?: ContractStatus;
    clientQualifier?: ClientQualifier;
    numberOfPayments!: number;
    paymentsLeft?: number;
    contractStateChangeRecords?: ContractStateChangeRecord[] | null;
    paymentFrequency!: PaymentFrequency;
    paymentMethod!: PaymentMethod;
    historicalPaymentInfos?: PaymentInfo[] | null;
    paymentDateChanges?: ClientPaymentDateChange[] | null;
    isClientDateChangeDisabled?: boolean;
    creditTaskAgentAssignmentRecords?: CreditTaskAgentAssignmentRecord[] | null;
    creditTasks?: CreditTask[] | null;
    assignedCreditAgentId?: string | null;
    assignedCreditAgent?: Employee | null;
    assignedCreditAgentDatetime?: moment.Moment | null;
    callBackDateTime?: moment.Moment | null;
    contractRecycles?: ContractRecycles[] | null;
    excludeFromProd?: boolean;
    contractType?: ContractType;
    erpBlanketOrderNbr?: string | null;
    erpOrderNbr?: string | null;
    erpInvoiceNbr?: string | null;
    overrideRemainingManuallyZeroed?: boolean;
    latestRecycleDateTime?: moment.Moment | null;
    remainingAmountToBePaid!: number;
    percentagePaid?: number;
    remainingFeesToBePaid?: number;
    calculatedContractValue?: number;
    expectedContractValue?: number;
    remainingAmountToBePaidWithNsfPayments?: number;
    contractValueWithNsf?: number;
    totalAmendmentsAmount?: number;
    remainingAmendablePaymentsAmount?: number;
    nsfFeesPaid?: number;
    amountPaidWithoutFees?: number;
    amountPaidWithNsfFee?: number;
    nsfFees?: number;
    manualPayments?: Payment[] | null;
    totalManualPaymentsAmount?: number;
    drAmendmentsTotalValue?: number;
    crAmendmentsTotalValue?: number;
    nsfTotalValue?: number;
    nsfCreditedTotalValue?: number;
    nsfNotPaidTotalValue?: number;
    contractValueWithAmendments!: number;
    contractValue!: number;
    originalContractValue!: number;
    setOriginalContractValue?: boolean;
    originalContractValueWithFreezer?: number;
    paymentStartDate!: moment.Moment;
    signedDate!: moment.Moment;
    costOfGoodsSold!: number;
    payments?: Payment[] | null;
    activePayments?: Payment[] | null;
    canceledPayments?: Payment[] | null;
    amendments?: Amendment[] | null;
    papApprovalPath?: string | null;
    amendment?: Amendment | null;
    sellerName?: string | null;
    remainingPayments?: Payment[] | null;
    numberOfMonths?: number;
    firstDayOfBimonthlyPayment?: number;
    lastDayOfBimonthlyPayment?: number;
    useLastDayOfMonthForPayment?: boolean;
    orderNumber?: number;
    numberOfAllowedFreePaymentDateChanges?: number;
    changePaymentFrequencyViewModel?: ChangePaymentFrequencyViewModel | null;
    createdDate!: moment.Moment;
    earliestUnpaidFailedPaymentId?: number | null;
    paidPayments?: Payment[] | null;
    clientHasMadeEnoughPaidPaymentsToChangePaymentDates?: boolean;
    crmContractNumber?: number;
    bankInfos?: BankInfo[] | null;
    isSplitContract?: boolean;
    isPaymentLastFewPaymentForContract?: boolean;
    hasClientPaidAllPaidForPaymentDateChanges?: boolean;
    hasUnPaidNsfPayments?: boolean;
    presidentReport?: ContractContainerBalance | null;
    presidentReportRemainingBalance?: number | null;
    remainingAmountToBePaidWithFees?: number | null;
    letterPrefix?: string | null;

    constructor(data?: IContract) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.owner = _data["owner"] ? Client.fromJS(_data["owner"]) : <any>null;
            this.ownerId = _data["ownerId"] !== undefined ? _data["ownerId"] : <any>null;
            if (Array.isArray(_data["clients"])) {
                this.clients = [] as any;
                for (let item of _data["clients"])
                    this.clients!.push(ClientContract.fromJS(item));
            }
            else {
                this.clients = <any>null;
            }
            if (Array.isArray(_data["clientIds"])) {
                this.clientIds = [] as any;
                for (let item of _data["clientIds"])
                    this.clientIds!.push(item);
            }
            else {
                this.clientIds = <any>null;
            }
            this.clientsNames = _data["clientsNames"] !== undefined ? _data["clientsNames"] : <any>null;
            this.coConsumerName = _data["coConsumerName"] !== undefined ? _data["coConsumerName"] : <any>null;
            this.notes = _data["notes"] !== undefined ? _data["notes"] : <any>null;
            this.contractNumber = _data["contractNumber"] !== undefined ? _data["contractNumber"] : <any>null;
            this.numberOfDeliveries = _data["numberOfDeliveries"] !== undefined ? _data["numberOfDeliveries"] : <any>null;
            this.contractStatus = _data["contractStatus"] !== undefined ? _data["contractStatus"] : <any>null;
            this.clientQualifier = _data["clientQualifier"] !== undefined ? _data["clientQualifier"] : <any>null;
            this.numberOfPayments = _data["numberOfPayments"] !== undefined ? _data["numberOfPayments"] : <any>null;
            this.paymentsLeft = _data["paymentsLeft"] !== undefined ? _data["paymentsLeft"] : <any>null;
            if (Array.isArray(_data["contractStateChangeRecords"])) {
                this.contractStateChangeRecords = [] as any;
                for (let item of _data["contractStateChangeRecords"])
                    this.contractStateChangeRecords!.push(ContractStateChangeRecord.fromJS(item));
            }
            else {
                this.contractStateChangeRecords = <any>null;
            }
            this.paymentFrequency = _data["paymentFrequency"] !== undefined ? _data["paymentFrequency"] : <any>null;
            this.paymentMethod = _data["paymentMethod"] !== undefined ? _data["paymentMethod"] : <any>null;
            if (Array.isArray(_data["historicalPaymentInfos"])) {
                this.historicalPaymentInfos = [] as any;
                for (let item of _data["historicalPaymentInfos"])
                    this.historicalPaymentInfos!.push(PaymentInfo.fromJS(item));
            }
            else {
                this.historicalPaymentInfos = <any>null;
            }
            if (Array.isArray(_data["paymentDateChanges"])) {
                this.paymentDateChanges = [] as any;
                for (let item of _data["paymentDateChanges"])
                    this.paymentDateChanges!.push(ClientPaymentDateChange.fromJS(item));
            }
            else {
                this.paymentDateChanges = <any>null;
            }
            this.isClientDateChangeDisabled = _data["isClientDateChangeDisabled"] !== undefined ? _data["isClientDateChangeDisabled"] : <any>null;
            if (Array.isArray(_data["creditTaskAgentAssignmentRecords"])) {
                this.creditTaskAgentAssignmentRecords = [] as any;
                for (let item of _data["creditTaskAgentAssignmentRecords"])
                    this.creditTaskAgentAssignmentRecords!.push(CreditTaskAgentAssignmentRecord.fromJS(item));
            }
            else {
                this.creditTaskAgentAssignmentRecords = <any>null;
            }
            if (Array.isArray(_data["creditTasks"])) {
                this.creditTasks = [] as any;
                for (let item of _data["creditTasks"])
                    this.creditTasks!.push(CreditTask.fromJS(item));
            }
            else {
                this.creditTasks = <any>null;
            }
            this.assignedCreditAgentId = _data["assignedCreditAgentId"] !== undefined ? _data["assignedCreditAgentId"] : <any>null;
            this.assignedCreditAgent = _data["assignedCreditAgent"] ? Employee.fromJS(_data["assignedCreditAgent"]) : <any>null;
            this.assignedCreditAgentDatetime = _data["assignedCreditAgentDatetime"] ? moment(_data["assignedCreditAgentDatetime"].toString()) : <any>null;
            this.callBackDateTime = _data["callBackDateTime"] ? moment(_data["callBackDateTime"].toString()) : <any>null;
            if (Array.isArray(_data["contractRecycles"])) {
                this.contractRecycles = [] as any;
                for (let item of _data["contractRecycles"])
                    this.contractRecycles!.push(ContractRecycles.fromJS(item));
            }
            else {
                this.contractRecycles = <any>null;
            }
            this.excludeFromProd = _data["excludeFromProd"] !== undefined ? _data["excludeFromProd"] : <any>null;
            this.contractType = _data["contractType"] !== undefined ? _data["contractType"] : <any>null;
            this.erpBlanketOrderNbr = _data["erpBlanketOrderNbr"] !== undefined ? _data["erpBlanketOrderNbr"] : <any>null;
            this.erpOrderNbr = _data["erpOrderNbr"] !== undefined ? _data["erpOrderNbr"] : <any>null;
            this.erpInvoiceNbr = _data["erpInvoiceNbr"] !== undefined ? _data["erpInvoiceNbr"] : <any>null;
            this.overrideRemainingManuallyZeroed = _data["overrideRemainingManuallyZeroed"] !== undefined ? _data["overrideRemainingManuallyZeroed"] : <any>null;
            this.latestRecycleDateTime = _data["latestRecycleDateTime"] ? moment(_data["latestRecycleDateTime"].toString()) : <any>null;
            this.remainingAmountToBePaid = _data["remainingAmountToBePaid"] !== undefined ? _data["remainingAmountToBePaid"] : <any>null;
            this.percentagePaid = _data["percentagePaid"] !== undefined ? _data["percentagePaid"] : <any>null;
            this.remainingFeesToBePaid = _data["remainingFeesToBePaid"] !== undefined ? _data["remainingFeesToBePaid"] : <any>null;
            this.calculatedContractValue = _data["calculatedContractValue"] !== undefined ? _data["calculatedContractValue"] : <any>null;
            this.expectedContractValue = _data["expectedContractValue"] !== undefined ? _data["expectedContractValue"] : <any>null;
            this.remainingAmountToBePaidWithNsfPayments = _data["remainingAmountToBePaidWithNsfPayments"] !== undefined ? _data["remainingAmountToBePaidWithNsfPayments"] : <any>null;
            this.contractValueWithNsf = _data["contractValueWithNsf"] !== undefined ? _data["contractValueWithNsf"] : <any>null;
            this.totalAmendmentsAmount = _data["totalAmendmentsAmount"] !== undefined ? _data["totalAmendmentsAmount"] : <any>null;
            this.remainingAmendablePaymentsAmount = _data["remainingAmendablePaymentsAmount"] !== undefined ? _data["remainingAmendablePaymentsAmount"] : <any>null;
            this.nsfFeesPaid = _data["nsfFeesPaid"] !== undefined ? _data["nsfFeesPaid"] : <any>null;
            this.amountPaidWithoutFees = _data["amountPaidWithoutFees"] !== undefined ? _data["amountPaidWithoutFees"] : <any>null;
            this.amountPaidWithNsfFee = _data["amountPaidWithNsfFee"] !== undefined ? _data["amountPaidWithNsfFee"] : <any>null;
            this.nsfFees = _data["nsfFees"] !== undefined ? _data["nsfFees"] : <any>null;
            if (Array.isArray(_data["manualPayments"])) {
                this.manualPayments = [] as any;
                for (let item of _data["manualPayments"])
                    this.manualPayments!.push(Payment.fromJS(item));
            }
            else {
                this.manualPayments = <any>null;
            }
            this.totalManualPaymentsAmount = _data["totalManualPaymentsAmount"] !== undefined ? _data["totalManualPaymentsAmount"] : <any>null;
            this.drAmendmentsTotalValue = _data["drAmendmentsTotalValue"] !== undefined ? _data["drAmendmentsTotalValue"] : <any>null;
            this.crAmendmentsTotalValue = _data["crAmendmentsTotalValue"] !== undefined ? _data["crAmendmentsTotalValue"] : <any>null;
            this.nsfTotalValue = _data["nsfTotalValue"] !== undefined ? _data["nsfTotalValue"] : <any>null;
            this.nsfCreditedTotalValue = _data["nsfCreditedTotalValue"] !== undefined ? _data["nsfCreditedTotalValue"] : <any>null;
            this.nsfNotPaidTotalValue = _data["nsfNotPaidTotalValue"] !== undefined ? _data["nsfNotPaidTotalValue"] : <any>null;
            this.contractValueWithAmendments = _data["contractValueWithAmendments"] !== undefined ? _data["contractValueWithAmendments"] : <any>null;
            this.contractValue = _data["contractValue"] !== undefined ? _data["contractValue"] : <any>null;
            this.originalContractValue = _data["originalContractValue"] !== undefined ? _data["originalContractValue"] : <any>null;
            this.setOriginalContractValue = _data["setOriginalContractValue"] !== undefined ? _data["setOriginalContractValue"] : <any>null;
            this.originalContractValueWithFreezer = _data["originalContractValueWithFreezer"] !== undefined ? _data["originalContractValueWithFreezer"] : <any>null;
            this.paymentStartDate = _data["paymentStartDate"] ? moment(_data["paymentStartDate"].toString()) : <any>null;
            this.signedDate = _data["signedDate"] ? moment(_data["signedDate"].toString()) : <any>null;
            this.costOfGoodsSold = _data["costOfGoodsSold"] !== undefined ? _data["costOfGoodsSold"] : <any>null;
            if (Array.isArray(_data["payments"])) {
                this.payments = [] as any;
                for (let item of _data["payments"])
                    this.payments!.push(Payment.fromJS(item));
            }
            else {
                this.payments = <any>null;
            }
            if (Array.isArray(_data["activePayments"])) {
                this.activePayments = [] as any;
                for (let item of _data["activePayments"])
                    this.activePayments!.push(Payment.fromJS(item));
            }
            else {
                this.activePayments = <any>null;
            }
            if (Array.isArray(_data["canceledPayments"])) {
                this.canceledPayments = [] as any;
                for (let item of _data["canceledPayments"])
                    this.canceledPayments!.push(Payment.fromJS(item));
            }
            else {
                this.canceledPayments = <any>null;
            }
            if (Array.isArray(_data["amendments"])) {
                this.amendments = [] as any;
                for (let item of _data["amendments"])
                    this.amendments!.push(Amendment.fromJS(item));
            }
            else {
                this.amendments = <any>null;
            }
            this.papApprovalPath = _data["papApprovalPath"] !== undefined ? _data["papApprovalPath"] : <any>null;
            this.amendment = _data["amendment"] ? Amendment.fromJS(_data["amendment"]) : <any>null;
            this.sellerName = _data["sellerName"] !== undefined ? _data["sellerName"] : <any>null;
            if (Array.isArray(_data["remainingPayments"])) {
                this.remainingPayments = [] as any;
                for (let item of _data["remainingPayments"])
                    this.remainingPayments!.push(Payment.fromJS(item));
            }
            else {
                this.remainingPayments = <any>null;
            }
            this.numberOfMonths = _data["numberOfMonths"] !== undefined ? _data["numberOfMonths"] : <any>null;
            this.firstDayOfBimonthlyPayment = _data["firstDayOfBimonthlyPayment"] !== undefined ? _data["firstDayOfBimonthlyPayment"] : <any>null;
            this.lastDayOfBimonthlyPayment = _data["lastDayOfBimonthlyPayment"] !== undefined ? _data["lastDayOfBimonthlyPayment"] : <any>null;
            this.useLastDayOfMonthForPayment = _data["useLastDayOfMonthForPayment"] !== undefined ? _data["useLastDayOfMonthForPayment"] : <any>null;
            this.orderNumber = _data["orderNumber"] !== undefined ? _data["orderNumber"] : <any>null;
            this.numberOfAllowedFreePaymentDateChanges = _data["numberOfAllowedFreePaymentDateChanges"] !== undefined ? _data["numberOfAllowedFreePaymentDateChanges"] : <any>null;
            this.changePaymentFrequencyViewModel = _data["changePaymentFrequencyViewModel"] ? ChangePaymentFrequencyViewModel.fromJS(_data["changePaymentFrequencyViewModel"]) : <any>null;
            this.createdDate = _data["createdDate"] ? moment(_data["createdDate"].toString()) : <any>null;
            this.earliestUnpaidFailedPaymentId = _data["earliestUnpaidFailedPaymentId"] !== undefined ? _data["earliestUnpaidFailedPaymentId"] : <any>null;
            if (Array.isArray(_data["paidPayments"])) {
                this.paidPayments = [] as any;
                for (let item of _data["paidPayments"])
                    this.paidPayments!.push(Payment.fromJS(item));
            }
            else {
                this.paidPayments = <any>null;
            }
            this.clientHasMadeEnoughPaidPaymentsToChangePaymentDates = _data["clientHasMadeEnoughPaidPaymentsToChangePaymentDates"] !== undefined ? _data["clientHasMadeEnoughPaidPaymentsToChangePaymentDates"] : <any>null;
            this.crmContractNumber = _data["crmContractNumber"] !== undefined ? _data["crmContractNumber"] : <any>null;
            if (Array.isArray(_data["bankInfos"])) {
                this.bankInfos = [] as any;
                for (let item of _data["bankInfos"])
                    this.bankInfos!.push(BankInfo.fromJS(item));
            }
            else {
                this.bankInfos = <any>null;
            }
            this.isSplitContract = _data["isSplitContract"] !== undefined ? _data["isSplitContract"] : <any>null;
            this.isPaymentLastFewPaymentForContract = _data["isPaymentLastFewPaymentForContract"] !== undefined ? _data["isPaymentLastFewPaymentForContract"] : <any>null;
            this.hasClientPaidAllPaidForPaymentDateChanges = _data["hasClientPaidAllPaidForPaymentDateChanges"] !== undefined ? _data["hasClientPaidAllPaidForPaymentDateChanges"] : <any>null;
            this.hasUnPaidNsfPayments = _data["hasUnPaidNsfPayments"] !== undefined ? _data["hasUnPaidNsfPayments"] : <any>null;
            this.presidentReport = _data["presidentReport"] ? ContractContainerBalance.fromJS(_data["presidentReport"]) : <any>null;
            this.presidentReportRemainingBalance = _data["presidentReportRemainingBalance"] !== undefined ? _data["presidentReportRemainingBalance"] : <any>null;
            this.remainingAmountToBePaidWithFees = _data["remainingAmountToBePaidWithFees"] !== undefined ? _data["remainingAmountToBePaidWithFees"] : <any>null;
            this.letterPrefix = _data["letterPrefix"] !== undefined ? _data["letterPrefix"] : <any>null;
        }
    }

    static override fromJS(data: any): Contract {
        data = typeof data === 'object' ? data : {};
        let result = new Contract();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["owner"] = this.owner ? this.owner.toJSON() : <any>null;
        data["ownerId"] = this.ownerId !== undefined ? this.ownerId : <any>null;
        if (Array.isArray(this.clients)) {
            data["clients"] = [];
            for (let item of this.clients)
                data["clients"].push(item.toJSON());
        }
        if (Array.isArray(this.clientIds)) {
            data["clientIds"] = [];
            for (let item of this.clientIds)
                data["clientIds"].push(item);
        }
        data["clientsNames"] = this.clientsNames !== undefined ? this.clientsNames : <any>null;
        data["coConsumerName"] = this.coConsumerName !== undefined ? this.coConsumerName : <any>null;
        data["notes"] = this.notes !== undefined ? this.notes : <any>null;
        data["contractNumber"] = this.contractNumber !== undefined ? this.contractNumber : <any>null;
        data["numberOfDeliveries"] = this.numberOfDeliveries !== undefined ? this.numberOfDeliveries : <any>null;
        data["contractStatus"] = this.contractStatus !== undefined ? this.contractStatus : <any>null;
        data["clientQualifier"] = this.clientQualifier !== undefined ? this.clientQualifier : <any>null;
        data["numberOfPayments"] = this.numberOfPayments !== undefined ? this.numberOfPayments : <any>null;
        data["paymentsLeft"] = this.paymentsLeft !== undefined ? this.paymentsLeft : <any>null;
        if (Array.isArray(this.contractStateChangeRecords)) {
            data["contractStateChangeRecords"] = [];
            for (let item of this.contractStateChangeRecords)
                data["contractStateChangeRecords"].push(item.toJSON());
        }
        data["paymentFrequency"] = this.paymentFrequency !== undefined ? this.paymentFrequency : <any>null;
        data["paymentMethod"] = this.paymentMethod !== undefined ? this.paymentMethod : <any>null;
        if (Array.isArray(this.historicalPaymentInfos)) {
            data["historicalPaymentInfos"] = [];
            for (let item of this.historicalPaymentInfos)
                data["historicalPaymentInfos"].push(item.toJSON());
        }
        if (Array.isArray(this.paymentDateChanges)) {
            data["paymentDateChanges"] = [];
            for (let item of this.paymentDateChanges)
                data["paymentDateChanges"].push(item.toJSON());
        }
        data["isClientDateChangeDisabled"] = this.isClientDateChangeDisabled !== undefined ? this.isClientDateChangeDisabled : <any>null;
        if (Array.isArray(this.creditTaskAgentAssignmentRecords)) {
            data["creditTaskAgentAssignmentRecords"] = [];
            for (let item of this.creditTaskAgentAssignmentRecords)
                data["creditTaskAgentAssignmentRecords"].push(item.toJSON());
        }
        if (Array.isArray(this.creditTasks)) {
            data["creditTasks"] = [];
            for (let item of this.creditTasks)
                data["creditTasks"].push(item.toJSON());
        }
        data["assignedCreditAgentId"] = this.assignedCreditAgentId !== undefined ? this.assignedCreditAgentId : <any>null;
        data["assignedCreditAgent"] = this.assignedCreditAgent ? this.assignedCreditAgent.toJSON() : <any>null;
        data["assignedCreditAgentDatetime"] = this.assignedCreditAgentDatetime ? this.assignedCreditAgentDatetime.toISOString() : <any>null;
        data["callBackDateTime"] = this.callBackDateTime ? this.callBackDateTime.toISOString() : <any>null;
        if (Array.isArray(this.contractRecycles)) {
            data["contractRecycles"] = [];
            for (let item of this.contractRecycles)
                data["contractRecycles"].push(item.toJSON());
        }
        data["excludeFromProd"] = this.excludeFromProd !== undefined ? this.excludeFromProd : <any>null;
        data["contractType"] = this.contractType !== undefined ? this.contractType : <any>null;
        data["erpBlanketOrderNbr"] = this.erpBlanketOrderNbr !== undefined ? this.erpBlanketOrderNbr : <any>null;
        data["erpOrderNbr"] = this.erpOrderNbr !== undefined ? this.erpOrderNbr : <any>null;
        data["erpInvoiceNbr"] = this.erpInvoiceNbr !== undefined ? this.erpInvoiceNbr : <any>null;
        data["overrideRemainingManuallyZeroed"] = this.overrideRemainingManuallyZeroed !== undefined ? this.overrideRemainingManuallyZeroed : <any>null;
        data["latestRecycleDateTime"] = this.latestRecycleDateTime ? this.latestRecycleDateTime.toISOString() : <any>null;
        data["remainingAmountToBePaid"] = this.remainingAmountToBePaid !== undefined ? this.remainingAmountToBePaid : <any>null;
        data["percentagePaid"] = this.percentagePaid !== undefined ? this.percentagePaid : <any>null;
        data["remainingFeesToBePaid"] = this.remainingFeesToBePaid !== undefined ? this.remainingFeesToBePaid : <any>null;
        data["calculatedContractValue"] = this.calculatedContractValue !== undefined ? this.calculatedContractValue : <any>null;
        data["expectedContractValue"] = this.expectedContractValue !== undefined ? this.expectedContractValue : <any>null;
        data["remainingAmountToBePaidWithNsfPayments"] = this.remainingAmountToBePaidWithNsfPayments !== undefined ? this.remainingAmountToBePaidWithNsfPayments : <any>null;
        data["contractValueWithNsf"] = this.contractValueWithNsf !== undefined ? this.contractValueWithNsf : <any>null;
        data["totalAmendmentsAmount"] = this.totalAmendmentsAmount !== undefined ? this.totalAmendmentsAmount : <any>null;
        data["remainingAmendablePaymentsAmount"] = this.remainingAmendablePaymentsAmount !== undefined ? this.remainingAmendablePaymentsAmount : <any>null;
        data["nsfFeesPaid"] = this.nsfFeesPaid !== undefined ? this.nsfFeesPaid : <any>null;
        data["amountPaidWithoutFees"] = this.amountPaidWithoutFees !== undefined ? this.amountPaidWithoutFees : <any>null;
        data["amountPaidWithNsfFee"] = this.amountPaidWithNsfFee !== undefined ? this.amountPaidWithNsfFee : <any>null;
        data["nsfFees"] = this.nsfFees !== undefined ? this.nsfFees : <any>null;
        if (Array.isArray(this.manualPayments)) {
            data["manualPayments"] = [];
            for (let item of this.manualPayments)
                data["manualPayments"].push(item.toJSON());
        }
        data["totalManualPaymentsAmount"] = this.totalManualPaymentsAmount !== undefined ? this.totalManualPaymentsAmount : <any>null;
        data["drAmendmentsTotalValue"] = this.drAmendmentsTotalValue !== undefined ? this.drAmendmentsTotalValue : <any>null;
        data["crAmendmentsTotalValue"] = this.crAmendmentsTotalValue !== undefined ? this.crAmendmentsTotalValue : <any>null;
        data["nsfTotalValue"] = this.nsfTotalValue !== undefined ? this.nsfTotalValue : <any>null;
        data["nsfCreditedTotalValue"] = this.nsfCreditedTotalValue !== undefined ? this.nsfCreditedTotalValue : <any>null;
        data["nsfNotPaidTotalValue"] = this.nsfNotPaidTotalValue !== undefined ? this.nsfNotPaidTotalValue : <any>null;
        data["contractValueWithAmendments"] = this.contractValueWithAmendments !== undefined ? this.contractValueWithAmendments : <any>null;
        data["contractValue"] = this.contractValue !== undefined ? this.contractValue : <any>null;
        data["originalContractValue"] = this.originalContractValue !== undefined ? this.originalContractValue : <any>null;
        data["setOriginalContractValue"] = this.setOriginalContractValue !== undefined ? this.setOriginalContractValue : <any>null;
        data["originalContractValueWithFreezer"] = this.originalContractValueWithFreezer !== undefined ? this.originalContractValueWithFreezer : <any>null;
        data["paymentStartDate"] = this.paymentStartDate ? this.paymentStartDate.format('YYYY-MM-DD') : <any>null;
        data["signedDate"] = this.signedDate ? this.signedDate.format('YYYY-MM-DD') : <any>null;
        data["costOfGoodsSold"] = this.costOfGoodsSold !== undefined ? this.costOfGoodsSold : <any>null;
        if (Array.isArray(this.payments)) {
            data["payments"] = [];
            for (let item of this.payments)
                data["payments"].push(item.toJSON());
        }
        if (Array.isArray(this.activePayments)) {
            data["activePayments"] = [];
            for (let item of this.activePayments)
                data["activePayments"].push(item.toJSON());
        }
        if (Array.isArray(this.canceledPayments)) {
            data["canceledPayments"] = [];
            for (let item of this.canceledPayments)
                data["canceledPayments"].push(item.toJSON());
        }
        if (Array.isArray(this.amendments)) {
            data["amendments"] = [];
            for (let item of this.amendments)
                data["amendments"].push(item.toJSON());
        }
        data["papApprovalPath"] = this.papApprovalPath !== undefined ? this.papApprovalPath : <any>null;
        data["amendment"] = this.amendment ? this.amendment.toJSON() : <any>null;
        data["sellerName"] = this.sellerName !== undefined ? this.sellerName : <any>null;
        if (Array.isArray(this.remainingPayments)) {
            data["remainingPayments"] = [];
            for (let item of this.remainingPayments)
                data["remainingPayments"].push(item.toJSON());
        }
        data["numberOfMonths"] = this.numberOfMonths !== undefined ? this.numberOfMonths : <any>null;
        data["firstDayOfBimonthlyPayment"] = this.firstDayOfBimonthlyPayment !== undefined ? this.firstDayOfBimonthlyPayment : <any>null;
        data["lastDayOfBimonthlyPayment"] = this.lastDayOfBimonthlyPayment !== undefined ? this.lastDayOfBimonthlyPayment : <any>null;
        data["useLastDayOfMonthForPayment"] = this.useLastDayOfMonthForPayment !== undefined ? this.useLastDayOfMonthForPayment : <any>null;
        data["orderNumber"] = this.orderNumber !== undefined ? this.orderNumber : <any>null;
        data["numberOfAllowedFreePaymentDateChanges"] = this.numberOfAllowedFreePaymentDateChanges !== undefined ? this.numberOfAllowedFreePaymentDateChanges : <any>null;
        data["changePaymentFrequencyViewModel"] = this.changePaymentFrequencyViewModel ? this.changePaymentFrequencyViewModel.toJSON() : <any>null;
        data["createdDate"] = this.createdDate ? this.createdDate.format('YYYY-MM-DD') : <any>null;
        data["earliestUnpaidFailedPaymentId"] = this.earliestUnpaidFailedPaymentId !== undefined ? this.earliestUnpaidFailedPaymentId : <any>null;
        if (Array.isArray(this.paidPayments)) {
            data["paidPayments"] = [];
            for (let item of this.paidPayments)
                data["paidPayments"].push(item.toJSON());
        }
        data["clientHasMadeEnoughPaidPaymentsToChangePaymentDates"] = this.clientHasMadeEnoughPaidPaymentsToChangePaymentDates !== undefined ? this.clientHasMadeEnoughPaidPaymentsToChangePaymentDates : <any>null;
        data["crmContractNumber"] = this.crmContractNumber !== undefined ? this.crmContractNumber : <any>null;
        if (Array.isArray(this.bankInfos)) {
            data["bankInfos"] = [];
            for (let item of this.bankInfos)
                data["bankInfos"].push(item.toJSON());
        }
        data["isSplitContract"] = this.isSplitContract !== undefined ? this.isSplitContract : <any>null;
        data["isPaymentLastFewPaymentForContract"] = this.isPaymentLastFewPaymentForContract !== undefined ? this.isPaymentLastFewPaymentForContract : <any>null;
        data["hasClientPaidAllPaidForPaymentDateChanges"] = this.hasClientPaidAllPaidForPaymentDateChanges !== undefined ? this.hasClientPaidAllPaidForPaymentDateChanges : <any>null;
        data["hasUnPaidNsfPayments"] = this.hasUnPaidNsfPayments !== undefined ? this.hasUnPaidNsfPayments : <any>null;
        data["presidentReport"] = this.presidentReport ? this.presidentReport.toJSON() : <any>null;
        data["presidentReportRemainingBalance"] = this.presidentReportRemainingBalance !== undefined ? this.presidentReportRemainingBalance : <any>null;
        data["remainingAmountToBePaidWithFees"] = this.remainingAmountToBePaidWithFees !== undefined ? this.remainingAmountToBePaidWithFees : <any>null;
        data["letterPrefix"] = this.letterPrefix !== undefined ? this.letterPrefix : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IContract extends IEntityOfInteger {
    owner?: Client | null;
    ownerId?: string | null;
    clients?: ClientContract[] | null;
    clientIds?: string[] | null;
    clientsNames?: string | null;
    coConsumerName?: string | null;
    notes?: string | null;
    contractNumber: number;
    numberOfDeliveries?: number;
    contractStatus?: ContractStatus;
    clientQualifier?: ClientQualifier;
    numberOfPayments: number;
    paymentsLeft?: number;
    contractStateChangeRecords?: ContractStateChangeRecord[] | null;
    paymentFrequency: PaymentFrequency;
    paymentMethod: PaymentMethod;
    historicalPaymentInfos?: PaymentInfo[] | null;
    paymentDateChanges?: ClientPaymentDateChange[] | null;
    isClientDateChangeDisabled?: boolean;
    creditTaskAgentAssignmentRecords?: CreditTaskAgentAssignmentRecord[] | null;
    creditTasks?: CreditTask[] | null;
    assignedCreditAgentId?: string | null;
    assignedCreditAgent?: Employee | null;
    assignedCreditAgentDatetime?: moment.Moment | null;
    callBackDateTime?: moment.Moment | null;
    contractRecycles?: ContractRecycles[] | null;
    excludeFromProd?: boolean;
    contractType?: ContractType;
    erpBlanketOrderNbr?: string | null;
    erpOrderNbr?: string | null;
    erpInvoiceNbr?: string | null;
    overrideRemainingManuallyZeroed?: boolean;
    latestRecycleDateTime?: moment.Moment | null;
    remainingAmountToBePaid: number;
    percentagePaid?: number;
    remainingFeesToBePaid?: number;
    calculatedContractValue?: number;
    expectedContractValue?: number;
    remainingAmountToBePaidWithNsfPayments?: number;
    contractValueWithNsf?: number;
    totalAmendmentsAmount?: number;
    remainingAmendablePaymentsAmount?: number;
    nsfFeesPaid?: number;
    amountPaidWithoutFees?: number;
    amountPaidWithNsfFee?: number;
    nsfFees?: number;
    manualPayments?: Payment[] | null;
    totalManualPaymentsAmount?: number;
    drAmendmentsTotalValue?: number;
    crAmendmentsTotalValue?: number;
    nsfTotalValue?: number;
    nsfCreditedTotalValue?: number;
    nsfNotPaidTotalValue?: number;
    contractValueWithAmendments: number;
    contractValue: number;
    originalContractValue: number;
    setOriginalContractValue?: boolean;
    originalContractValueWithFreezer?: number;
    paymentStartDate: moment.Moment;
    signedDate: moment.Moment;
    costOfGoodsSold: number;
    payments?: Payment[] | null;
    activePayments?: Payment[] | null;
    canceledPayments?: Payment[] | null;
    amendments?: Amendment[] | null;
    papApprovalPath?: string | null;
    amendment?: Amendment | null;
    sellerName?: string | null;
    remainingPayments?: Payment[] | null;
    numberOfMonths?: number;
    firstDayOfBimonthlyPayment?: number;
    lastDayOfBimonthlyPayment?: number;
    useLastDayOfMonthForPayment?: boolean;
    orderNumber?: number;
    numberOfAllowedFreePaymentDateChanges?: number;
    changePaymentFrequencyViewModel?: ChangePaymentFrequencyViewModel | null;
    createdDate: moment.Moment;
    earliestUnpaidFailedPaymentId?: number | null;
    paidPayments?: Payment[] | null;
    clientHasMadeEnoughPaidPaymentsToChangePaymentDates?: boolean;
    crmContractNumber?: number;
    bankInfos?: BankInfo[] | null;
    isSplitContract?: boolean;
    isPaymentLastFewPaymentForContract?: boolean;
    hasClientPaidAllPaidForPaymentDateChanges?: boolean;
    hasUnPaidNsfPayments?: boolean;
    presidentReport?: ContractContainerBalance | null;
    presidentReportRemainingBalance?: number | null;
    remainingAmountToBePaidWithFees?: number | null;
    letterPrefix?: string | null;
}

export class ClientContract implements IClientContract {
    clientId?: string | null;
    client?: Client | null;
    contractId?: number;
    contract?: Contract | null;
    isOwner?: boolean;

    constructor(data?: IClientContract) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.clientId = _data["clientId"] !== undefined ? _data["clientId"] : <any>null;
            this.client = _data["client"] ? Client.fromJS(_data["client"]) : <any>null;
            this.contractId = _data["contractId"] !== undefined ? _data["contractId"] : <any>null;
            this.contract = _data["contract"] ? Contract.fromJS(_data["contract"]) : <any>null;
            this.isOwner = _data["isOwner"] !== undefined ? _data["isOwner"] : <any>null;
        }
    }

    static fromJS(data: any): ClientContract {
        data = typeof data === 'object' ? data : {};
        let result = new ClientContract();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clientId"] = this.clientId !== undefined ? this.clientId : <any>null;
        data["client"] = this.client ? this.client.toJSON() : <any>null;
        data["contractId"] = this.contractId !== undefined ? this.contractId : <any>null;
        data["contract"] = this.contract ? this.contract.toJSON() : <any>null;
        data["isOwner"] = this.isOwner !== undefined ? this.isOwner : <any>null;
        return data;
    }
}

export interface IClientContract {
    clientId?: string | null;
    client?: Client | null;
    contractId?: number;
    contract?: Contract | null;
    isOwner?: boolean;
}

export enum ContractStatus {
    Active = "active",
    NsfLocked = "nsfLocked",
    PendingCancellation = "pendingCancellation",
    Cancelled = "cancelled",
    Completed = "completed",
}

export enum ClientQualifier {
    CurrentAccount = "currentAccount",
    AgreementRespected = "agreementRespected",
    SecondCreditToDo = "secondCreditToDo",
    ClientAgency = "clientAgency",
    CollectionAccount = "collectionAccount",
    BadDebtAccount = "badDebtAccount",
}

export abstract class WriteAuditRecord extends EntityOfInteger implements IWriteAuditRecord {
    changedDateTime?: moment.Moment;
    employee?: Employee | null;
    employeeId?: string | null;

    constructor(data?: IWriteAuditRecord) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.changedDateTime = _data["changedDateTime"] ? moment(_data["changedDateTime"].toString()) : <any>null;
            this.employee = _data["employee"] ? Employee.fromJS(_data["employee"]) : <any>null;
            this.employeeId = _data["employeeId"] !== undefined ? _data["employeeId"] : <any>null;
        }
    }

    static override fromJS(data: any): WriteAuditRecord {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'WriteAuditRecord' cannot be instantiated.");
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["changedDateTime"] = this.changedDateTime ? this.changedDateTime.toISOString() : <any>null;
        data["employee"] = this.employee ? this.employee.toJSON() : <any>null;
        data["employeeId"] = this.employeeId !== undefined ? this.employeeId : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IWriteAuditRecord extends IEntityOfInteger {
    changedDateTime?: moment.Moment;
    employee?: Employee | null;
    employeeId?: string | null;
}

export class ContractStateChangeRecord extends WriteAuditRecord implements IContractStateChangeRecord {
    contract?: Contract | null;
    fromState?: ContractStatus;
    toState?: ContractStatus;

    constructor(data?: IContractStateChangeRecord) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.contract = _data["contract"] ? Contract.fromJS(_data["contract"]) : <any>null;
            this.fromState = _data["fromState"] !== undefined ? _data["fromState"] : <any>null;
            this.toState = _data["toState"] !== undefined ? _data["toState"] : <any>null;
        }
    }

    static override fromJS(data: any): ContractStateChangeRecord {
        data = typeof data === 'object' ? data : {};
        let result = new ContractStateChangeRecord();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contract"] = this.contract ? this.contract.toJSON() : <any>null;
        data["fromState"] = this.fromState !== undefined ? this.fromState : <any>null;
        data["toState"] = this.toState !== undefined ? this.toState : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IContractStateChangeRecord extends IWriteAuditRecord {
    contract?: Contract | null;
    fromState?: ContractStatus;
    toState?: ContractStatus;
}

export enum PaymentFrequency {
    Weekly = "weekly",
    Biweekly = "biweekly",
    Bimonthly = "bimonthly",
    Monthly = "monthly",
    NotAvailable = "notAvailable",
}

export enum PaymentMethod {
    PPA = "ppa",
    CreditCard = "creditCard",
    Check = "check",
    Cash = "cash",
}

export class PaymentInfo extends EntityOfInteger implements IPaymentInfo {
    numberOfPayments?: number;
    firstDayOfBimonthlyPayment?: number;
    lastDayOfBimonthlyPayment?: number;
    useLastDayOfMonth?: boolean;
    totalValue?: number;
    paymentStartDate?: moment.Moment;
    contract?: Contract | null;
    paymentFrequency?: PaymentFrequency;
    paymentsLeft?: number;
    paymentFrequencyPretty?: string | null;
    paymentAmount?: number;
    lastDayToggle?: boolean;
    madeBy?: Employee | null;
    dateTimePerformed?: moment.Moment | null;
    changeMade?: ChangeMade | null;

    constructor(data?: IPaymentInfo) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.numberOfPayments = _data["numberOfPayments"] !== undefined ? _data["numberOfPayments"] : <any>null;
            this.firstDayOfBimonthlyPayment = _data["firstDayOfBimonthlyPayment"] !== undefined ? _data["firstDayOfBimonthlyPayment"] : <any>null;
            this.lastDayOfBimonthlyPayment = _data["lastDayOfBimonthlyPayment"] !== undefined ? _data["lastDayOfBimonthlyPayment"] : <any>null;
            this.useLastDayOfMonth = _data["useLastDayOfMonth"] !== undefined ? _data["useLastDayOfMonth"] : <any>null;
            this.totalValue = _data["totalValue"] !== undefined ? _data["totalValue"] : <any>null;
            this.paymentStartDate = _data["paymentStartDate"] ? moment(_data["paymentStartDate"].toString()) : <any>null;
            this.contract = _data["contract"] ? Contract.fromJS(_data["contract"]) : <any>null;
            this.paymentFrequency = _data["paymentFrequency"] !== undefined ? _data["paymentFrequency"] : <any>null;
            this.paymentsLeft = _data["paymentsLeft"] !== undefined ? _data["paymentsLeft"] : <any>null;
            this.paymentFrequencyPretty = _data["paymentFrequencyPretty"] !== undefined ? _data["paymentFrequencyPretty"] : <any>null;
            this.paymentAmount = _data["paymentAmount"] !== undefined ? _data["paymentAmount"] : <any>null;
            this.lastDayToggle = _data["lastDayToggle"] !== undefined ? _data["lastDayToggle"] : <any>null;
            this.madeBy = _data["madeBy"] ? Employee.fromJS(_data["madeBy"]) : <any>null;
            this.dateTimePerformed = _data["dateTimePerformed"] ? moment(_data["dateTimePerformed"].toString()) : <any>null;
            this.changeMade = _data["changeMade"] !== undefined ? _data["changeMade"] : <any>null;
        }
    }

    static override fromJS(data: any): PaymentInfo {
        data = typeof data === 'object' ? data : {};
        let result = new PaymentInfo();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["numberOfPayments"] = this.numberOfPayments !== undefined ? this.numberOfPayments : <any>null;
        data["firstDayOfBimonthlyPayment"] = this.firstDayOfBimonthlyPayment !== undefined ? this.firstDayOfBimonthlyPayment : <any>null;
        data["lastDayOfBimonthlyPayment"] = this.lastDayOfBimonthlyPayment !== undefined ? this.lastDayOfBimonthlyPayment : <any>null;
        data["useLastDayOfMonth"] = this.useLastDayOfMonth !== undefined ? this.useLastDayOfMonth : <any>null;
        data["totalValue"] = this.totalValue !== undefined ? this.totalValue : <any>null;
        data["paymentStartDate"] = this.paymentStartDate ? this.paymentStartDate.toISOString() : <any>null;
        data["contract"] = this.contract ? this.contract.toJSON() : <any>null;
        data["paymentFrequency"] = this.paymentFrequency !== undefined ? this.paymentFrequency : <any>null;
        data["paymentsLeft"] = this.paymentsLeft !== undefined ? this.paymentsLeft : <any>null;
        data["paymentFrequencyPretty"] = this.paymentFrequencyPretty !== undefined ? this.paymentFrequencyPretty : <any>null;
        data["paymentAmount"] = this.paymentAmount !== undefined ? this.paymentAmount : <any>null;
        data["lastDayToggle"] = this.lastDayToggle !== undefined ? this.lastDayToggle : <any>null;
        data["madeBy"] = this.madeBy ? this.madeBy.toJSON() : <any>null;
        data["dateTimePerformed"] = this.dateTimePerformed ? this.dateTimePerformed.toISOString() : <any>null;
        data["changeMade"] = this.changeMade !== undefined ? this.changeMade : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IPaymentInfo extends IEntityOfInteger {
    numberOfPayments?: number;
    firstDayOfBimonthlyPayment?: number;
    lastDayOfBimonthlyPayment?: number;
    useLastDayOfMonth?: boolean;
    totalValue?: number;
    paymentStartDate?: moment.Moment;
    contract?: Contract | null;
    paymentFrequency?: PaymentFrequency;
    paymentsLeft?: number;
    paymentFrequencyPretty?: string | null;
    paymentAmount?: number;
    lastDayToggle?: boolean;
    madeBy?: Employee | null;
    dateTimePerformed?: moment.Moment | null;
    changeMade?: ChangeMade | null;
}

export enum ChangeMade {
    ContractPaymentChange = "contractPaymentChange",
    PaymentSplit = "paymentSplit",
}

export class ClientPaymentDateChange extends EntityOfInteger implements IClientPaymentDateChange {
    dateChanged?: moment.Moment;
    paymentId?: number | null;
    payment?: Payment | null;
    createdAmendmentId?: number | null;
    createdAmendment?: Amendment | null;
    previousDate?: moment.Moment | null;
    newDate?: moment.Moment | null;
    acknowledged?: boolean;
    isPaidDateChange?: boolean;
    contract?: Contract | null;
    contractId?: number | null;

    constructor(data?: IClientPaymentDateChange) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.dateChanged = _data["dateChanged"] ? moment(_data["dateChanged"].toString()) : <any>null;
            this.paymentId = _data["paymentId"] !== undefined ? _data["paymentId"] : <any>null;
            this.payment = _data["payment"] ? Payment.fromJS(_data["payment"]) : <any>null;
            this.createdAmendmentId = _data["createdAmendmentId"] !== undefined ? _data["createdAmendmentId"] : <any>null;
            this.createdAmendment = _data["createdAmendment"] ? Amendment.fromJS(_data["createdAmendment"]) : <any>null;
            this.previousDate = _data["previousDate"] ? moment(_data["previousDate"].toString()) : <any>null;
            this.newDate = _data["newDate"] ? moment(_data["newDate"].toString()) : <any>null;
            this.acknowledged = _data["acknowledged"] !== undefined ? _data["acknowledged"] : <any>null;
            this.isPaidDateChange = _data["isPaidDateChange"] !== undefined ? _data["isPaidDateChange"] : <any>null;
            this.contract = _data["contract"] ? Contract.fromJS(_data["contract"]) : <any>null;
            this.contractId = _data["contractId"] !== undefined ? _data["contractId"] : <any>null;
        }
    }

    static override fromJS(data: any): ClientPaymentDateChange {
        data = typeof data === 'object' ? data : {};
        let result = new ClientPaymentDateChange();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dateChanged"] = this.dateChanged ? this.dateChanged.toISOString() : <any>null;
        data["paymentId"] = this.paymentId !== undefined ? this.paymentId : <any>null;
        data["payment"] = this.payment ? this.payment.toJSON() : <any>null;
        data["createdAmendmentId"] = this.createdAmendmentId !== undefined ? this.createdAmendmentId : <any>null;
        data["createdAmendment"] = this.createdAmendment ? this.createdAmendment.toJSON() : <any>null;
        data["previousDate"] = this.previousDate ? this.previousDate.toISOString() : <any>null;
        data["newDate"] = this.newDate ? this.newDate.toISOString() : <any>null;
        data["acknowledged"] = this.acknowledged !== undefined ? this.acknowledged : <any>null;
        data["isPaidDateChange"] = this.isPaidDateChange !== undefined ? this.isPaidDateChange : <any>null;
        data["contract"] = this.contract ? this.contract.toJSON() : <any>null;
        data["contractId"] = this.contractId !== undefined ? this.contractId : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IClientPaymentDateChange extends IEntityOfInteger {
    dateChanged?: moment.Moment;
    paymentId?: number | null;
    payment?: Payment | null;
    createdAmendmentId?: number | null;
    createdAmendment?: Amendment | null;
    previousDate?: moment.Moment | null;
    newDate?: moment.Moment | null;
    acknowledged?: boolean;
    isPaidDateChange?: boolean;
    contract?: Contract | null;
    contractId?: number | null;
}

export class Payment implements IPayment {
    id?: number;
    scheduledDate!: moment.Moment;
    paidDate?: moment.Moment | null;
    failedPayDateTime?: moment.Moment | null;
    dateAdded?: moment.Moment | null;
    paymentBankInfo?: BankInfo | null;
    addedBy?: Employee | null;
    addedById?: string | null;
    isManuallyAdded?: boolean;
    paymentAmount!: number;
    isCreatedDueToNsf?: boolean;
    paymentState?: PaymentState;
    contract!: Contract;
    contractID?: number;
    linkedPayment?: Payment | null;
    linkedPaymentID?: number | null;
    nsfFeeFromNsf?: NsfFee | null;
    nsfFeeFromNsfId?: number | null;
    createdNsfFee?: NsfFee | null;
    clientPaymentDateChanges?: ClientPaymentDateChange[] | null;
    linkedPayments?: Payment[] | null;
    isSyncedToERP?: boolean;
    erpSyncStatus?: ErpSyncStatus;
    erpSyncError?: string | null;
    erpPaymentRef?: string | null;
    eftRecords?: EftRecord[] | null;
    paymentType?: PaymentType;
    isNsfFeeNotCredited?: boolean;
    isNsfFeePartiallyCredited?: boolean;
    isNsfFeeRescheduledWithPartialCredit?: boolean;
    isNsfFeeFullyCredited?: boolean;
    canChangePayment?: boolean;
    eftRecordPayments?: EftRecordPayment[] | null;
    isNsfFee?: boolean;
    isNsf?: boolean;
    customPaymentState?: string | null;
    isReschedulePaymentPaid?: boolean;
    isRescheduleFailedPaymentPaid?: boolean;

    constructor(data?: IPayment) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.contract = new Contract();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.scheduledDate = _data["scheduledDate"] ? moment(_data["scheduledDate"].toString()) : <any>null;
            this.paidDate = _data["paidDate"] ? moment(_data["paidDate"].toString()) : <any>null;
            this.failedPayDateTime = _data["failedPayDateTime"] ? moment(_data["failedPayDateTime"].toString()) : <any>null;
            this.dateAdded = _data["dateAdded"] ? moment(_data["dateAdded"].toString()) : <any>null;
            this.paymentBankInfo = _data["paymentBankInfo"] ? BankInfo.fromJS(_data["paymentBankInfo"]) : <any>null;
            this.addedBy = _data["addedBy"] ? Employee.fromJS(_data["addedBy"]) : <any>null;
            this.addedById = _data["addedById"] !== undefined ? _data["addedById"] : <any>null;
            this.isManuallyAdded = _data["isManuallyAdded"] !== undefined ? _data["isManuallyAdded"] : <any>null;
            this.paymentAmount = _data["paymentAmount"] !== undefined ? _data["paymentAmount"] : <any>null;
            this.isCreatedDueToNsf = _data["isCreatedDueToNsf"] !== undefined ? _data["isCreatedDueToNsf"] : <any>null;
            this.paymentState = _data["paymentState"] !== undefined ? _data["paymentState"] : <any>null;
            this.contract = _data["contract"] ? Contract.fromJS(_data["contract"]) : new Contract();
            this.contractID = _data["contractID"] !== undefined ? _data["contractID"] : <any>null;
            this.linkedPayment = _data["linkedPayment"] ? Payment.fromJS(_data["linkedPayment"]) : <any>null;
            this.linkedPaymentID = _data["linkedPaymentID"] !== undefined ? _data["linkedPaymentID"] : <any>null;
            this.nsfFeeFromNsf = _data["nsfFeeFromNsf"] ? NsfFee.fromJS(_data["nsfFeeFromNsf"]) : <any>null;
            this.nsfFeeFromNsfId = _data["nsfFeeFromNsfId"] !== undefined ? _data["nsfFeeFromNsfId"] : <any>null;
            this.createdNsfFee = _data["createdNsfFee"] ? NsfFee.fromJS(_data["createdNsfFee"]) : <any>null;
            if (Array.isArray(_data["clientPaymentDateChanges"])) {
                this.clientPaymentDateChanges = [] as any;
                for (let item of _data["clientPaymentDateChanges"])
                    this.clientPaymentDateChanges!.push(ClientPaymentDateChange.fromJS(item));
            }
            else {
                this.clientPaymentDateChanges = <any>null;
            }
            if (Array.isArray(_data["linkedPayments"])) {
                this.linkedPayments = [] as any;
                for (let item of _data["linkedPayments"])
                    this.linkedPayments!.push(Payment.fromJS(item));
            }
            else {
                this.linkedPayments = <any>null;
            }
            this.isSyncedToERP = _data["isSyncedToERP"] !== undefined ? _data["isSyncedToERP"] : <any>null;
            this.erpSyncStatus = _data["erpSyncStatus"] !== undefined ? _data["erpSyncStatus"] : <any>null;
            this.erpSyncError = _data["erpSyncError"] !== undefined ? _data["erpSyncError"] : <any>null;
            this.erpPaymentRef = _data["erpPaymentRef"] !== undefined ? _data["erpPaymentRef"] : <any>null;
            if (Array.isArray(_data["eftRecords"])) {
                this.eftRecords = [] as any;
                for (let item of _data["eftRecords"])
                    this.eftRecords!.push(EftRecord.fromJS(item));
            }
            else {
                this.eftRecords = <any>null;
            }
            this.paymentType = _data["paymentType"] !== undefined ? _data["paymentType"] : <any>null;
            this.isNsfFeeNotCredited = _data["isNsfFeeNotCredited"] !== undefined ? _data["isNsfFeeNotCredited"] : <any>null;
            this.isNsfFeePartiallyCredited = _data["isNsfFeePartiallyCredited"] !== undefined ? _data["isNsfFeePartiallyCredited"] : <any>null;
            this.isNsfFeeRescheduledWithPartialCredit = _data["isNsfFeeRescheduledWithPartialCredit"] !== undefined ? _data["isNsfFeeRescheduledWithPartialCredit"] : <any>null;
            this.isNsfFeeFullyCredited = _data["isNsfFeeFullyCredited"] !== undefined ? _data["isNsfFeeFullyCredited"] : <any>null;
            this.canChangePayment = _data["canChangePayment"] !== undefined ? _data["canChangePayment"] : <any>null;
            if (Array.isArray(_data["eftRecordPayments"])) {
                this.eftRecordPayments = [] as any;
                for (let item of _data["eftRecordPayments"])
                    this.eftRecordPayments!.push(EftRecordPayment.fromJS(item));
            }
            else {
                this.eftRecordPayments = <any>null;
            }
            this.isNsfFee = _data["isNsfFee"] !== undefined ? _data["isNsfFee"] : <any>null;
            this.isNsf = _data["isNsf"] !== undefined ? _data["isNsf"] : <any>null;
            this.customPaymentState = _data["customPaymentState"] !== undefined ? _data["customPaymentState"] : <any>null;
            this.isReschedulePaymentPaid = _data["isReschedulePaymentPaid"] !== undefined ? _data["isReschedulePaymentPaid"] : <any>null;
            this.isRescheduleFailedPaymentPaid = _data["isRescheduleFailedPaymentPaid"] !== undefined ? _data["isRescheduleFailedPaymentPaid"] : <any>null;
        }
    }

    static fromJS(data: any): Payment {
        data = typeof data === 'object' ? data : {};
        let result = new Payment();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["scheduledDate"] = this.scheduledDate ? this.scheduledDate.format('YYYY-MM-DD') : <any>null;
        data["paidDate"] = this.paidDate ? this.paidDate.format('YYYY-MM-DD') : <any>null;
        data["failedPayDateTime"] = this.failedPayDateTime ? this.failedPayDateTime.format('YYYY-MM-DD') : <any>null;
        data["dateAdded"] = this.dateAdded ? this.dateAdded.toISOString() : <any>null;
        data["paymentBankInfo"] = this.paymentBankInfo ? this.paymentBankInfo.toJSON() : <any>null;
        data["addedBy"] = this.addedBy ? this.addedBy.toJSON() : <any>null;
        data["addedById"] = this.addedById !== undefined ? this.addedById : <any>null;
        data["isManuallyAdded"] = this.isManuallyAdded !== undefined ? this.isManuallyAdded : <any>null;
        data["paymentAmount"] = this.paymentAmount !== undefined ? this.paymentAmount : <any>null;
        data["isCreatedDueToNsf"] = this.isCreatedDueToNsf !== undefined ? this.isCreatedDueToNsf : <any>null;
        data["paymentState"] = this.paymentState !== undefined ? this.paymentState : <any>null;
        data["contract"] = this.contract ? this.contract.toJSON() : <any>null;
        data["contractID"] = this.contractID !== undefined ? this.contractID : <any>null;
        data["linkedPayment"] = this.linkedPayment ? this.linkedPayment.toJSON() : <any>null;
        data["linkedPaymentID"] = this.linkedPaymentID !== undefined ? this.linkedPaymentID : <any>null;
        data["nsfFeeFromNsf"] = this.nsfFeeFromNsf ? this.nsfFeeFromNsf.toJSON() : <any>null;
        data["nsfFeeFromNsfId"] = this.nsfFeeFromNsfId !== undefined ? this.nsfFeeFromNsfId : <any>null;
        data["createdNsfFee"] = this.createdNsfFee ? this.createdNsfFee.toJSON() : <any>null;
        if (Array.isArray(this.clientPaymentDateChanges)) {
            data["clientPaymentDateChanges"] = [];
            for (let item of this.clientPaymentDateChanges)
                data["clientPaymentDateChanges"].push(item.toJSON());
        }
        if (Array.isArray(this.linkedPayments)) {
            data["linkedPayments"] = [];
            for (let item of this.linkedPayments)
                data["linkedPayments"].push(item.toJSON());
        }
        data["isSyncedToERP"] = this.isSyncedToERP !== undefined ? this.isSyncedToERP : <any>null;
        data["erpSyncStatus"] = this.erpSyncStatus !== undefined ? this.erpSyncStatus : <any>null;
        data["erpSyncError"] = this.erpSyncError !== undefined ? this.erpSyncError : <any>null;
        data["erpPaymentRef"] = this.erpPaymentRef !== undefined ? this.erpPaymentRef : <any>null;
        if (Array.isArray(this.eftRecords)) {
            data["eftRecords"] = [];
            for (let item of this.eftRecords)
                data["eftRecords"].push(item.toJSON());
        }
        data["paymentType"] = this.paymentType !== undefined ? this.paymentType : <any>null;
        data["isNsfFeeNotCredited"] = this.isNsfFeeNotCredited !== undefined ? this.isNsfFeeNotCredited : <any>null;
        data["isNsfFeePartiallyCredited"] = this.isNsfFeePartiallyCredited !== undefined ? this.isNsfFeePartiallyCredited : <any>null;
        data["isNsfFeeRescheduledWithPartialCredit"] = this.isNsfFeeRescheduledWithPartialCredit !== undefined ? this.isNsfFeeRescheduledWithPartialCredit : <any>null;
        data["isNsfFeeFullyCredited"] = this.isNsfFeeFullyCredited !== undefined ? this.isNsfFeeFullyCredited : <any>null;
        data["canChangePayment"] = this.canChangePayment !== undefined ? this.canChangePayment : <any>null;
        if (Array.isArray(this.eftRecordPayments)) {
            data["eftRecordPayments"] = [];
            for (let item of this.eftRecordPayments)
                data["eftRecordPayments"].push(item.toJSON());
        }
        data["isNsfFee"] = this.isNsfFee !== undefined ? this.isNsfFee : <any>null;
        data["isNsf"] = this.isNsf !== undefined ? this.isNsf : <any>null;
        data["customPaymentState"] = this.customPaymentState !== undefined ? this.customPaymentState : <any>null;
        data["isReschedulePaymentPaid"] = this.isReschedulePaymentPaid !== undefined ? this.isReschedulePaymentPaid : <any>null;
        data["isRescheduleFailedPaymentPaid"] = this.isRescheduleFailedPaymentPaid !== undefined ? this.isRescheduleFailedPaymentPaid : <any>null;
        return data;
    }
}

export interface IPayment {
    id?: number;
    scheduledDate: moment.Moment;
    paidDate?: moment.Moment | null;
    failedPayDateTime?: moment.Moment | null;
    dateAdded?: moment.Moment | null;
    paymentBankInfo?: BankInfo | null;
    addedBy?: Employee | null;
    addedById?: string | null;
    isManuallyAdded?: boolean;
    paymentAmount: number;
    isCreatedDueToNsf?: boolean;
    paymentState?: PaymentState;
    contract: Contract;
    contractID?: number;
    linkedPayment?: Payment | null;
    linkedPaymentID?: number | null;
    nsfFeeFromNsf?: NsfFee | null;
    nsfFeeFromNsfId?: number | null;
    createdNsfFee?: NsfFee | null;
    clientPaymentDateChanges?: ClientPaymentDateChange[] | null;
    linkedPayments?: Payment[] | null;
    isSyncedToERP?: boolean;
    erpSyncStatus?: ErpSyncStatus;
    erpSyncError?: string | null;
    erpPaymentRef?: string | null;
    eftRecords?: EftRecord[] | null;
    paymentType?: PaymentType;
    isNsfFeeNotCredited?: boolean;
    isNsfFeePartiallyCredited?: boolean;
    isNsfFeeRescheduledWithPartialCredit?: boolean;
    isNsfFeeFullyCredited?: boolean;
    canChangePayment?: boolean;
    eftRecordPayments?: EftRecordPayment[] | null;
    isNsfFee?: boolean;
    isNsf?: boolean;
    customPaymentState?: string | null;
    isReschedulePaymentPaid?: boolean;
    isRescheduleFailedPaymentPaid?: boolean;
}

export enum PaymentState {
    NotPaid = "notPaid",
    SentToBankPendingAcceptance = "sentToBankPendingAcceptance",
    SentToBankPendingPaymentPeriod = "sentToBankPendingPaymentPeriod",
    Paid = "paid",
    Nsf = "nsf",
    AckNsf = "ackNsf",
    RejectedByClientsBank = "rejectedByClientsBank",
    InvalidInformationSentToBank = "invalidInformationSentToBank",
    CreditedFees = "creditedFees",
    AmendCanceled = "amendCanceled",
    Canceled = "canceled",
    ContractPaymentFrequencyShiftCanceled = "contractPaymentFrequencyShiftCanceled",
    Unknown = "unknown",
}

export class NsfFee extends EntityOfInteger implements INsfFee {
    nsfPayments?: Payment[] | null;
    createdNsfFeePayment?: Payment | null;
    createdNsfFeePaymentId?: number;
    eftRecordId?: number | null;
    eftRecord?: EftRecord | null;
    paymentStateChangeNsfCreditRecord?: PaymentStateChangeRecord | null;
    paymentStateChangeNsfCreditRecordId?: number | null;
    createdDateTime?: moment.Moment | null;
    creditType?: NsfFeeCreditType;
    creditGivenDateTime?: moment.Moment | null;
    creditGivenByEmployee?: Employee | null;
    creditGivenByEmployeeId?: string | null;
    paymentAmountBeforePartialCredit?: number | null;

    constructor(data?: INsfFee) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["nsfPayments"])) {
                this.nsfPayments = [] as any;
                for (let item of _data["nsfPayments"])
                    this.nsfPayments!.push(Payment.fromJS(item));
            }
            else {
                this.nsfPayments = <any>null;
            }
            this.createdNsfFeePayment = _data["createdNsfFeePayment"] ? Payment.fromJS(_data["createdNsfFeePayment"]) : <any>null;
            this.createdNsfFeePaymentId = _data["createdNsfFeePaymentId"] !== undefined ? _data["createdNsfFeePaymentId"] : <any>null;
            this.eftRecordId = _data["eftRecordId"] !== undefined ? _data["eftRecordId"] : <any>null;
            this.eftRecord = _data["eftRecord"] ? EftRecord.fromJS(_data["eftRecord"]) : <any>null;
            this.paymentStateChangeNsfCreditRecord = _data["paymentStateChangeNsfCreditRecord"] ? PaymentStateChangeRecord.fromJS(_data["paymentStateChangeNsfCreditRecord"]) : <any>null;
            this.paymentStateChangeNsfCreditRecordId = _data["paymentStateChangeNsfCreditRecordId"] !== undefined ? _data["paymentStateChangeNsfCreditRecordId"] : <any>null;
            this.createdDateTime = _data["createdDateTime"] ? moment(_data["createdDateTime"].toString()) : <any>null;
            this.creditType = _data["creditType"] !== undefined ? _data["creditType"] : <any>null;
            this.creditGivenDateTime = _data["creditGivenDateTime"] ? moment(_data["creditGivenDateTime"].toString()) : <any>null;
            this.creditGivenByEmployee = _data["creditGivenByEmployee"] ? Employee.fromJS(_data["creditGivenByEmployee"]) : <any>null;
            this.creditGivenByEmployeeId = _data["creditGivenByEmployeeId"] !== undefined ? _data["creditGivenByEmployeeId"] : <any>null;
            this.paymentAmountBeforePartialCredit = _data["paymentAmountBeforePartialCredit"] !== undefined ? _data["paymentAmountBeforePartialCredit"] : <any>null;
        }
    }

    static override fromJS(data: any): NsfFee {
        data = typeof data === 'object' ? data : {};
        let result = new NsfFee();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.nsfPayments)) {
            data["nsfPayments"] = [];
            for (let item of this.nsfPayments)
                data["nsfPayments"].push(item.toJSON());
        }
        data["createdNsfFeePayment"] = this.createdNsfFeePayment ? this.createdNsfFeePayment.toJSON() : <any>null;
        data["createdNsfFeePaymentId"] = this.createdNsfFeePaymentId !== undefined ? this.createdNsfFeePaymentId : <any>null;
        data["eftRecordId"] = this.eftRecordId !== undefined ? this.eftRecordId : <any>null;
        data["eftRecord"] = this.eftRecord ? this.eftRecord.toJSON() : <any>null;
        data["paymentStateChangeNsfCreditRecord"] = this.paymentStateChangeNsfCreditRecord ? this.paymentStateChangeNsfCreditRecord.toJSON() : <any>null;
        data["paymentStateChangeNsfCreditRecordId"] = this.paymentStateChangeNsfCreditRecordId !== undefined ? this.paymentStateChangeNsfCreditRecordId : <any>null;
        data["createdDateTime"] = this.createdDateTime ? this.createdDateTime.toISOString() : <any>null;
        data["creditType"] = this.creditType !== undefined ? this.creditType : <any>null;
        data["creditGivenDateTime"] = this.creditGivenDateTime ? this.creditGivenDateTime.toISOString() : <any>null;
        data["creditGivenByEmployee"] = this.creditGivenByEmployee ? this.creditGivenByEmployee.toJSON() : <any>null;
        data["creditGivenByEmployeeId"] = this.creditGivenByEmployeeId !== undefined ? this.creditGivenByEmployeeId : <any>null;
        data["paymentAmountBeforePartialCredit"] = this.paymentAmountBeforePartialCredit !== undefined ? this.paymentAmountBeforePartialCredit : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface INsfFee extends IEntityOfInteger {
    nsfPayments?: Payment[] | null;
    createdNsfFeePayment?: Payment | null;
    createdNsfFeePaymentId?: number;
    eftRecordId?: number | null;
    eftRecord?: EftRecord | null;
    paymentStateChangeNsfCreditRecord?: PaymentStateChangeRecord | null;
    paymentStateChangeNsfCreditRecordId?: number | null;
    createdDateTime?: moment.Moment | null;
    creditType?: NsfFeeCreditType;
    creditGivenDateTime?: moment.Moment | null;
    creditGivenByEmployee?: Employee | null;
    creditGivenByEmployeeId?: string | null;
    paymentAmountBeforePartialCredit?: number | null;
}

export class EftRecord extends EntityOfInteger implements IEftRecord {
    contract?: Contract | null;
    contractId?: number | null;
    clientNo?: number | null;
    recordType?: string;
    eft?: Eft | null;
    eftID?: number | null;
    recordSequenceCount?: number;
    cpaCode?: string | null;
    amount?: number;
    dueDate?: moment.Moment;
    rejectionReason?: string | null;
    returnTransactionCode?: string | null;
    recordSequenceCountFormatted?: string | null;
    financialInstitutionNumber?: string | null;
    financialInstitutionBranchNumber?: string | null;
    accountNumber?: string | null;
    shortName?: string | null;
    payeeName?: string | null;
    transactionOriginationXref?: string | null;
    longName?: string | null;
    oldPaymentState?: PaymentState | null;
    newPaymentState?: PaymentState | null;
    payment?: Payment | null;
    eftRecordPayments?: EftRecordPayment[] | null;
    itemTraceNumber?: string | null;
    storedTransType?: string | null;
    originatorSundryInfo?: string | null;
    storedTraceNumber?: string | null;
    settlementCode?: string | null;
    invalidDataElement?: string | null;
    nsfFees?: NsfFee[] | null;
    transactionReturnFinancialInstitution?: string | null;
    transactionReturnAccount?: string | null;
    transactionStatus?: EftTransactionStatus | null;
    rejectionReasonDescription?: string | null;
    returnValueDescription?: string | null;

    constructor(data?: IEftRecord) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.contract = _data["contract"] ? Contract.fromJS(_data["contract"]) : <any>null;
            this.contractId = _data["contractId"] !== undefined ? _data["contractId"] : <any>null;
            this.clientNo = _data["clientNo"] !== undefined ? _data["clientNo"] : <any>null;
            this.recordType = _data["recordType"] !== undefined ? _data["recordType"] : <any>null;
            this.eft = _data["eft"] ? Eft.fromJS(_data["eft"]) : <any>null;
            this.eftID = _data["eftID"] !== undefined ? _data["eftID"] : <any>null;
            this.recordSequenceCount = _data["recordSequenceCount"] !== undefined ? _data["recordSequenceCount"] : <any>null;
            this.cpaCode = _data["cpaCode"] !== undefined ? _data["cpaCode"] : <any>null;
            this.amount = _data["amount"] !== undefined ? _data["amount"] : <any>null;
            this.dueDate = _data["dueDate"] ? moment(_data["dueDate"].toString()) : <any>null;
            this.rejectionReason = _data["rejectionReason"] !== undefined ? _data["rejectionReason"] : <any>null;
            this.returnTransactionCode = _data["returnTransactionCode"] !== undefined ? _data["returnTransactionCode"] : <any>null;
            this.recordSequenceCountFormatted = _data["recordSequenceCountFormatted"] !== undefined ? _data["recordSequenceCountFormatted"] : <any>null;
            this.financialInstitutionNumber = _data["financialInstitutionNumber"] !== undefined ? _data["financialInstitutionNumber"] : <any>null;
            this.financialInstitutionBranchNumber = _data["financialInstitutionBranchNumber"] !== undefined ? _data["financialInstitutionBranchNumber"] : <any>null;
            this.accountNumber = _data["accountNumber"] !== undefined ? _data["accountNumber"] : <any>null;
            this.shortName = _data["shortName"] !== undefined ? _data["shortName"] : <any>null;
            this.payeeName = _data["payeeName"] !== undefined ? _data["payeeName"] : <any>null;
            this.transactionOriginationXref = _data["transactionOriginationXref"] !== undefined ? _data["transactionOriginationXref"] : <any>null;
            this.longName = _data["longName"] !== undefined ? _data["longName"] : <any>null;
            this.oldPaymentState = _data["oldPaymentState"] !== undefined ? _data["oldPaymentState"] : <any>null;
            this.newPaymentState = _data["newPaymentState"] !== undefined ? _data["newPaymentState"] : <any>null;
            this.payment = _data["payment"] ? Payment.fromJS(_data["payment"]) : <any>null;
            if (Array.isArray(_data["eftRecordPayments"])) {
                this.eftRecordPayments = [] as any;
                for (let item of _data["eftRecordPayments"])
                    this.eftRecordPayments!.push(EftRecordPayment.fromJS(item));
            }
            else {
                this.eftRecordPayments = <any>null;
            }
            this.itemTraceNumber = _data["itemTraceNumber"] !== undefined ? _data["itemTraceNumber"] : <any>null;
            this.storedTransType = _data["storedTransType"] !== undefined ? _data["storedTransType"] : <any>null;
            this.originatorSundryInfo = _data["originatorSundryInfo"] !== undefined ? _data["originatorSundryInfo"] : <any>null;
            this.storedTraceNumber = _data["storedTraceNumber"] !== undefined ? _data["storedTraceNumber"] : <any>null;
            this.settlementCode = _data["settlementCode"] !== undefined ? _data["settlementCode"] : <any>null;
            this.invalidDataElement = _data["invalidDataElement"] !== undefined ? _data["invalidDataElement"] : <any>null;
            if (Array.isArray(_data["nsfFees"])) {
                this.nsfFees = [] as any;
                for (let item of _data["nsfFees"])
                    this.nsfFees!.push(NsfFee.fromJS(item));
            }
            else {
                this.nsfFees = <any>null;
            }
            this.transactionReturnFinancialInstitution = _data["transactionReturnFinancialInstitution"] !== undefined ? _data["transactionReturnFinancialInstitution"] : <any>null;
            this.transactionReturnAccount = _data["transactionReturnAccount"] !== undefined ? _data["transactionReturnAccount"] : <any>null;
            this.transactionStatus = _data["transactionStatus"] !== undefined ? _data["transactionStatus"] : <any>null;
            this.rejectionReasonDescription = _data["rejectionReasonDescription"] !== undefined ? _data["rejectionReasonDescription"] : <any>null;
            this.returnValueDescription = _data["returnValueDescription"] !== undefined ? _data["returnValueDescription"] : <any>null;
        }
    }

    static override fromJS(data: any): EftRecord {
        data = typeof data === 'object' ? data : {};
        let result = new EftRecord();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contract"] = this.contract ? this.contract.toJSON() : <any>null;
        data["contractId"] = this.contractId !== undefined ? this.contractId : <any>null;
        data["clientNo"] = this.clientNo !== undefined ? this.clientNo : <any>null;
        data["recordType"] = this.recordType !== undefined ? this.recordType : <any>null;
        data["eft"] = this.eft ? this.eft.toJSON() : <any>null;
        data["eftID"] = this.eftID !== undefined ? this.eftID : <any>null;
        data["recordSequenceCount"] = this.recordSequenceCount !== undefined ? this.recordSequenceCount : <any>null;
        data["cpaCode"] = this.cpaCode !== undefined ? this.cpaCode : <any>null;
        data["amount"] = this.amount !== undefined ? this.amount : <any>null;
        data["dueDate"] = this.dueDate ? this.dueDate.toISOString() : <any>null;
        data["rejectionReason"] = this.rejectionReason !== undefined ? this.rejectionReason : <any>null;
        data["returnTransactionCode"] = this.returnTransactionCode !== undefined ? this.returnTransactionCode : <any>null;
        data["recordSequenceCountFormatted"] = this.recordSequenceCountFormatted !== undefined ? this.recordSequenceCountFormatted : <any>null;
        data["financialInstitutionNumber"] = this.financialInstitutionNumber !== undefined ? this.financialInstitutionNumber : <any>null;
        data["financialInstitutionBranchNumber"] = this.financialInstitutionBranchNumber !== undefined ? this.financialInstitutionBranchNumber : <any>null;
        data["accountNumber"] = this.accountNumber !== undefined ? this.accountNumber : <any>null;
        data["shortName"] = this.shortName !== undefined ? this.shortName : <any>null;
        data["payeeName"] = this.payeeName !== undefined ? this.payeeName : <any>null;
        data["transactionOriginationXref"] = this.transactionOriginationXref !== undefined ? this.transactionOriginationXref : <any>null;
        data["longName"] = this.longName !== undefined ? this.longName : <any>null;
        data["oldPaymentState"] = this.oldPaymentState !== undefined ? this.oldPaymentState : <any>null;
        data["newPaymentState"] = this.newPaymentState !== undefined ? this.newPaymentState : <any>null;
        data["payment"] = this.payment ? this.payment.toJSON() : <any>null;
        if (Array.isArray(this.eftRecordPayments)) {
            data["eftRecordPayments"] = [];
            for (let item of this.eftRecordPayments)
                data["eftRecordPayments"].push(item.toJSON());
        }
        data["itemTraceNumber"] = this.itemTraceNumber !== undefined ? this.itemTraceNumber : <any>null;
        data["storedTransType"] = this.storedTransType !== undefined ? this.storedTransType : <any>null;
        data["originatorSundryInfo"] = this.originatorSundryInfo !== undefined ? this.originatorSundryInfo : <any>null;
        data["storedTraceNumber"] = this.storedTraceNumber !== undefined ? this.storedTraceNumber : <any>null;
        data["settlementCode"] = this.settlementCode !== undefined ? this.settlementCode : <any>null;
        data["invalidDataElement"] = this.invalidDataElement !== undefined ? this.invalidDataElement : <any>null;
        if (Array.isArray(this.nsfFees)) {
            data["nsfFees"] = [];
            for (let item of this.nsfFees)
                data["nsfFees"].push(item.toJSON());
        }
        data["transactionReturnFinancialInstitution"] = this.transactionReturnFinancialInstitution !== undefined ? this.transactionReturnFinancialInstitution : <any>null;
        data["transactionReturnAccount"] = this.transactionReturnAccount !== undefined ? this.transactionReturnAccount : <any>null;
        data["transactionStatus"] = this.transactionStatus !== undefined ? this.transactionStatus : <any>null;
        data["rejectionReasonDescription"] = this.rejectionReasonDescription !== undefined ? this.rejectionReasonDescription : <any>null;
        data["returnValueDescription"] = this.returnValueDescription !== undefined ? this.returnValueDescription : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IEftRecord extends IEntityOfInteger {
    contract?: Contract | null;
    contractId?: number | null;
    clientNo?: number | null;
    recordType?: string;
    eft?: Eft | null;
    eftID?: number | null;
    recordSequenceCount?: number;
    cpaCode?: string | null;
    amount?: number;
    dueDate?: moment.Moment;
    rejectionReason?: string | null;
    returnTransactionCode?: string | null;
    recordSequenceCountFormatted?: string | null;
    financialInstitutionNumber?: string | null;
    financialInstitutionBranchNumber?: string | null;
    accountNumber?: string | null;
    shortName?: string | null;
    payeeName?: string | null;
    transactionOriginationXref?: string | null;
    longName?: string | null;
    oldPaymentState?: PaymentState | null;
    newPaymentState?: PaymentState | null;
    payment?: Payment | null;
    eftRecordPayments?: EftRecordPayment[] | null;
    itemTraceNumber?: string | null;
    storedTransType?: string | null;
    originatorSundryInfo?: string | null;
    storedTraceNumber?: string | null;
    settlementCode?: string | null;
    invalidDataElement?: string | null;
    nsfFees?: NsfFee[] | null;
    transactionReturnFinancialInstitution?: string | null;
    transactionReturnAccount?: string | null;
    transactionStatus?: EftTransactionStatus | null;
    rejectionReasonDescription?: string | null;
    returnValueDescription?: string | null;
}

export class Eft extends EntityOfInteger implements IEft {
    recordSequenceCount?: number;
    bankType?: BankType;
    fileCreationNumber?: number;
    eftFileStatus?: EftFileStatus;
    humanReadableRejectedDetection?: boolean;
    humanReadableAcceptedDetection?: boolean | null;
    humanReadableDetectionDateTime?: moment.Moment | null;
    fileRejectionReason?: string | null;
    wasUploadedToFtpServer?: boolean;
    fileCreationNumberFormatted?: string | null;
    eftOriginatorId?: string | null;
    fileCreationDate?: moment.Moment;
    payDate?: moment.Moment;
    institutionId?: number;
    currency?: string | null;
    routingRecord?: string | null;
    eftDebitRecords?: EftRecord[] | null;
    invalidTransactionRejectionReason?: EftRejectionReason | null;
    filePath?: string | null;
    institutionIdFormat?: string | null;
    recordType?: string;
    trailerRecordType?: string;
    filler?: string | null;
    recordSequenceCountFormatted?: string | null;
    lastRecordSequenceCountFormatted?: string | null;
    reserved?: string | null;
    valueOfDebitsFormatted?: string | null;
    valueOfDebits?: number;
    numberOfDebits?: string | null;
    numberOfCredits?: string | null;
    valueOfCredits?: string | null;
    valueOfErrCorrE?: string | null;
    numberofErrCorrE?: string | null;
    valueofErrCorrF?: string | null;
    numberOfErrCorrF?: string | null;
    trailerFiller?: string | null;
    groupedPayments?: GroupedPayments[] | null;
    payments?: Payment[] | null;
    invalidPayments?: Payment[] | null;
    valueOfDebitsAfterInvalidTransactions?: number;

    constructor(data?: IEft) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.recordSequenceCount = _data["recordSequenceCount"] !== undefined ? _data["recordSequenceCount"] : <any>null;
            this.bankType = _data["bankType"] !== undefined ? _data["bankType"] : <any>null;
            this.fileCreationNumber = _data["fileCreationNumber"] !== undefined ? _data["fileCreationNumber"] : <any>null;
            this.eftFileStatus = _data["eftFileStatus"] !== undefined ? _data["eftFileStatus"] : <any>null;
            this.humanReadableRejectedDetection = _data["humanReadableRejectedDetection"] !== undefined ? _data["humanReadableRejectedDetection"] : <any>null;
            this.humanReadableAcceptedDetection = _data["humanReadableAcceptedDetection"] !== undefined ? _data["humanReadableAcceptedDetection"] : <any>null;
            this.humanReadableDetectionDateTime = _data["humanReadableDetectionDateTime"] ? moment(_data["humanReadableDetectionDateTime"].toString()) : <any>null;
            this.fileRejectionReason = _data["fileRejectionReason"] !== undefined ? _data["fileRejectionReason"] : <any>null;
            this.wasUploadedToFtpServer = _data["wasUploadedToFtpServer"] !== undefined ? _data["wasUploadedToFtpServer"] : <any>null;
            this.fileCreationNumberFormatted = _data["fileCreationNumberFormatted"] !== undefined ? _data["fileCreationNumberFormatted"] : <any>null;
            this.eftOriginatorId = _data["eftOriginatorId"] !== undefined ? _data["eftOriginatorId"] : <any>null;
            this.fileCreationDate = _data["fileCreationDate"] ? moment(_data["fileCreationDate"].toString()) : <any>null;
            this.payDate = _data["payDate"] ? moment(_data["payDate"].toString()) : <any>null;
            this.institutionId = _data["institutionId"] !== undefined ? _data["institutionId"] : <any>null;
            this.currency = _data["currency"] !== undefined ? _data["currency"] : <any>null;
            this.routingRecord = _data["routingRecord"] !== undefined ? _data["routingRecord"] : <any>null;
            if (Array.isArray(_data["eftDebitRecords"])) {
                this.eftDebitRecords = [] as any;
                for (let item of _data["eftDebitRecords"])
                    this.eftDebitRecords!.push(EftRecord.fromJS(item));
            }
            else {
                this.eftDebitRecords = <any>null;
            }
            this.invalidTransactionRejectionReason = _data["invalidTransactionRejectionReason"] !== undefined ? _data["invalidTransactionRejectionReason"] : <any>null;
            this.filePath = _data["filePath"] !== undefined ? _data["filePath"] : <any>null;
            this.institutionIdFormat = _data["institutionIdFormat"] !== undefined ? _data["institutionIdFormat"] : <any>null;
            this.recordType = _data["recordType"] !== undefined ? _data["recordType"] : <any>null;
            this.trailerRecordType = _data["trailerRecordType"] !== undefined ? _data["trailerRecordType"] : <any>null;
            this.filler = _data["filler"] !== undefined ? _data["filler"] : <any>null;
            this.recordSequenceCountFormatted = _data["recordSequenceCountFormatted"] !== undefined ? _data["recordSequenceCountFormatted"] : <any>null;
            this.lastRecordSequenceCountFormatted = _data["lastRecordSequenceCountFormatted"] !== undefined ? _data["lastRecordSequenceCountFormatted"] : <any>null;
            this.reserved = _data["reserved"] !== undefined ? _data["reserved"] : <any>null;
            this.valueOfDebitsFormatted = _data["valueOfDebitsFormatted"] !== undefined ? _data["valueOfDebitsFormatted"] : <any>null;
            this.valueOfDebits = _data["valueOfDebits"] !== undefined ? _data["valueOfDebits"] : <any>null;
            this.numberOfDebits = _data["numberOfDebits"] !== undefined ? _data["numberOfDebits"] : <any>null;
            this.numberOfCredits = _data["numberOfCredits"] !== undefined ? _data["numberOfCredits"] : <any>null;
            this.valueOfCredits = _data["valueOfCredits"] !== undefined ? _data["valueOfCredits"] : <any>null;
            this.valueOfErrCorrE = _data["valueOfErrCorrE"] !== undefined ? _data["valueOfErrCorrE"] : <any>null;
            this.numberofErrCorrE = _data["numberofErrCorrE"] !== undefined ? _data["numberofErrCorrE"] : <any>null;
            this.valueofErrCorrF = _data["valueofErrCorrF"] !== undefined ? _data["valueofErrCorrF"] : <any>null;
            this.numberOfErrCorrF = _data["numberOfErrCorrF"] !== undefined ? _data["numberOfErrCorrF"] : <any>null;
            this.trailerFiller = _data["trailerFiller"] !== undefined ? _data["trailerFiller"] : <any>null;
            if (Array.isArray(_data["groupedPayments"])) {
                this.groupedPayments = [] as any;
                for (let item of _data["groupedPayments"])
                    this.groupedPayments!.push(GroupedPayments.fromJS(item));
            }
            else {
                this.groupedPayments = <any>null;
            }
            if (Array.isArray(_data["payments"])) {
                this.payments = [] as any;
                for (let item of _data["payments"])
                    this.payments!.push(Payment.fromJS(item));
            }
            else {
                this.payments = <any>null;
            }
            if (Array.isArray(_data["invalidPayments"])) {
                this.invalidPayments = [] as any;
                for (let item of _data["invalidPayments"])
                    this.invalidPayments!.push(Payment.fromJS(item));
            }
            else {
                this.invalidPayments = <any>null;
            }
            this.valueOfDebitsAfterInvalidTransactions = _data["valueOfDebitsAfterInvalidTransactions"] !== undefined ? _data["valueOfDebitsAfterInvalidTransactions"] : <any>null;
        }
    }

    static override fromJS(data: any): Eft {
        data = typeof data === 'object' ? data : {};
        let result = new Eft();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["recordSequenceCount"] = this.recordSequenceCount !== undefined ? this.recordSequenceCount : <any>null;
        data["bankType"] = this.bankType !== undefined ? this.bankType : <any>null;
        data["fileCreationNumber"] = this.fileCreationNumber !== undefined ? this.fileCreationNumber : <any>null;
        data["eftFileStatus"] = this.eftFileStatus !== undefined ? this.eftFileStatus : <any>null;
        data["humanReadableRejectedDetection"] = this.humanReadableRejectedDetection !== undefined ? this.humanReadableRejectedDetection : <any>null;
        data["humanReadableAcceptedDetection"] = this.humanReadableAcceptedDetection !== undefined ? this.humanReadableAcceptedDetection : <any>null;
        data["humanReadableDetectionDateTime"] = this.humanReadableDetectionDateTime ? this.humanReadableDetectionDateTime.toISOString() : <any>null;
        data["fileRejectionReason"] = this.fileRejectionReason !== undefined ? this.fileRejectionReason : <any>null;
        data["wasUploadedToFtpServer"] = this.wasUploadedToFtpServer !== undefined ? this.wasUploadedToFtpServer : <any>null;
        data["fileCreationNumberFormatted"] = this.fileCreationNumberFormatted !== undefined ? this.fileCreationNumberFormatted : <any>null;
        data["eftOriginatorId"] = this.eftOriginatorId !== undefined ? this.eftOriginatorId : <any>null;
        data["fileCreationDate"] = this.fileCreationDate ? this.fileCreationDate.toISOString() : <any>null;
        data["payDate"] = this.payDate ? this.payDate.toISOString() : <any>null;
        data["institutionId"] = this.institutionId !== undefined ? this.institutionId : <any>null;
        data["currency"] = this.currency !== undefined ? this.currency : <any>null;
        data["routingRecord"] = this.routingRecord !== undefined ? this.routingRecord : <any>null;
        if (Array.isArray(this.eftDebitRecords)) {
            data["eftDebitRecords"] = [];
            for (let item of this.eftDebitRecords)
                data["eftDebitRecords"].push(item.toJSON());
        }
        data["invalidTransactionRejectionReason"] = this.invalidTransactionRejectionReason !== undefined ? this.invalidTransactionRejectionReason : <any>null;
        data["filePath"] = this.filePath !== undefined ? this.filePath : <any>null;
        data["institutionIdFormat"] = this.institutionIdFormat !== undefined ? this.institutionIdFormat : <any>null;
        data["recordType"] = this.recordType !== undefined ? this.recordType : <any>null;
        data["trailerRecordType"] = this.trailerRecordType !== undefined ? this.trailerRecordType : <any>null;
        data["filler"] = this.filler !== undefined ? this.filler : <any>null;
        data["recordSequenceCountFormatted"] = this.recordSequenceCountFormatted !== undefined ? this.recordSequenceCountFormatted : <any>null;
        data["lastRecordSequenceCountFormatted"] = this.lastRecordSequenceCountFormatted !== undefined ? this.lastRecordSequenceCountFormatted : <any>null;
        data["reserved"] = this.reserved !== undefined ? this.reserved : <any>null;
        data["valueOfDebitsFormatted"] = this.valueOfDebitsFormatted !== undefined ? this.valueOfDebitsFormatted : <any>null;
        data["valueOfDebits"] = this.valueOfDebits !== undefined ? this.valueOfDebits : <any>null;
        data["numberOfDebits"] = this.numberOfDebits !== undefined ? this.numberOfDebits : <any>null;
        data["numberOfCredits"] = this.numberOfCredits !== undefined ? this.numberOfCredits : <any>null;
        data["valueOfCredits"] = this.valueOfCredits !== undefined ? this.valueOfCredits : <any>null;
        data["valueOfErrCorrE"] = this.valueOfErrCorrE !== undefined ? this.valueOfErrCorrE : <any>null;
        data["numberofErrCorrE"] = this.numberofErrCorrE !== undefined ? this.numberofErrCorrE : <any>null;
        data["valueofErrCorrF"] = this.valueofErrCorrF !== undefined ? this.valueofErrCorrF : <any>null;
        data["numberOfErrCorrF"] = this.numberOfErrCorrF !== undefined ? this.numberOfErrCorrF : <any>null;
        data["trailerFiller"] = this.trailerFiller !== undefined ? this.trailerFiller : <any>null;
        if (Array.isArray(this.groupedPayments)) {
            data["groupedPayments"] = [];
            for (let item of this.groupedPayments)
                data["groupedPayments"].push(item.toJSON());
        }
        if (Array.isArray(this.payments)) {
            data["payments"] = [];
            for (let item of this.payments)
                data["payments"].push(item.toJSON());
        }
        if (Array.isArray(this.invalidPayments)) {
            data["invalidPayments"] = [];
            for (let item of this.invalidPayments)
                data["invalidPayments"].push(item.toJSON());
        }
        data["valueOfDebitsAfterInvalidTransactions"] = this.valueOfDebitsAfterInvalidTransactions !== undefined ? this.valueOfDebitsAfterInvalidTransactions : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IEft extends IEntityOfInteger {
    recordSequenceCount?: number;
    bankType?: BankType;
    fileCreationNumber?: number;
    eftFileStatus?: EftFileStatus;
    humanReadableRejectedDetection?: boolean;
    humanReadableAcceptedDetection?: boolean | null;
    humanReadableDetectionDateTime?: moment.Moment | null;
    fileRejectionReason?: string | null;
    wasUploadedToFtpServer?: boolean;
    fileCreationNumberFormatted?: string | null;
    eftOriginatorId?: string | null;
    fileCreationDate?: moment.Moment;
    payDate?: moment.Moment;
    institutionId?: number;
    currency?: string | null;
    routingRecord?: string | null;
    eftDebitRecords?: EftRecord[] | null;
    invalidTransactionRejectionReason?: EftRejectionReason | null;
    filePath?: string | null;
    institutionIdFormat?: string | null;
    recordType?: string;
    trailerRecordType?: string;
    filler?: string | null;
    recordSequenceCountFormatted?: string | null;
    lastRecordSequenceCountFormatted?: string | null;
    reserved?: string | null;
    valueOfDebitsFormatted?: string | null;
    valueOfDebits?: number;
    numberOfDebits?: string | null;
    numberOfCredits?: string | null;
    valueOfCredits?: string | null;
    valueOfErrCorrE?: string | null;
    numberofErrCorrE?: string | null;
    valueofErrCorrF?: string | null;
    numberOfErrCorrF?: string | null;
    trailerFiller?: string | null;
    groupedPayments?: GroupedPayments[] | null;
    payments?: Payment[] | null;
    invalidPayments?: Payment[] | null;
    valueOfDebitsAfterInvalidTransactions?: number;
}

export enum BankType {
    HSBC = "hsbc",
    RBC = "rbc",
}

export enum EftFileStatus {
    FilePendingAcceptance = "filePendingAcceptance",
    FileAccepted = "fileAccepted",
    FileAcceptedWithInvalidTrans = "fileAcceptedWithInvalidTrans",
    FileAcceptedPendingSufficientFunds = "fileAcceptedPendingSufficientFunds",
    FileAccpetedInvalidTransPendingSufficientFunds = "fileAccpetedInvalidTransPendingSufficientFunds",
    FilePendingOverlimitAuthorization = "filePendingOverlimitAuthorization",
    FileRejected = "fileRejected",
    NullFile = "nullFile",
    FileBlocked = "fileBlocked",
    PendingFtpUpload = "pendingFtpUpload",
}

export enum EftRejectionReason {
    InvalidCpaTransactionCode = "invalidCpaTransactionCode",
    TransactionAmountNotNumberic = "transactionAmountNotNumberic",
    InvalidDueDateCentury = "invalidDueDateCentury",
    InvalidDueDateYear = "invalidDueDateYear",
    InvalidDueDateDay = "invalidDueDateDay",
    ItemFutureDatedGreaterThan100CalenderDays = "itemFutureDatedGreaterThan100CalenderDays",
    CreditStaleDatedGreaterThan30CalenderDays = "creditStaleDatedGreaterThan30CalenderDays",
    DebititStaleDatedGreaterThan30CalenderDays = "debititStaleDatedGreaterThan30CalenderDays",
    InvalidFinancialInstitionDateNumber = "invalidFinancialInstitionDateNumber",
    InvalidFinancialInstitionBranchNumber = "invalidFinancialInstitionBranchNumber",
    AccountNumberNonNumeric = "accountNumberNonNumeric",
    TransactionPayeePayorNameBlank = "transactionPayeePayorNameBlank",
    TransactionReturnFieldsMayOnlyContainDigits = "transactionReturnFieldsMayOnlyContainDigits",
    TransactionReturnFinancialinstitutionMustBe0016 = "transactionReturnFinancialinstitutionMustBe0016",
    OffsetRecordrejectedDueToValueDateRejection = "offsetRecordrejectedDueToValueDateRejection",
    CpaCodeNotSupported = "cpaCodeNotSupported",
    TransactionAmountMustNotBeZero = "transactionAmountMustNotBeZero",
}

export class GroupedPayments implements IGroupedPayments {
    paymentIds?: number[] | null;
    payments?: Payment[] | null;
    contractIds?: number[] | null;
    contracts?: Contract[] | null;
    contract?: Contract | null;
    contractId?: number;
    clientNo?: number | null;
    allPaymentsAmount?: number;

    constructor(data?: IGroupedPayments) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["paymentIds"])) {
                this.paymentIds = [] as any;
                for (let item of _data["paymentIds"])
                    this.paymentIds!.push(item);
            }
            else {
                this.paymentIds = <any>null;
            }
            if (Array.isArray(_data["payments"])) {
                this.payments = [] as any;
                for (let item of _data["payments"])
                    this.payments!.push(Payment.fromJS(item));
            }
            else {
                this.payments = <any>null;
            }
            if (Array.isArray(_data["contractIds"])) {
                this.contractIds = [] as any;
                for (let item of _data["contractIds"])
                    this.contractIds!.push(item);
            }
            else {
                this.contractIds = <any>null;
            }
            if (Array.isArray(_data["contracts"])) {
                this.contracts = [] as any;
                for (let item of _data["contracts"])
                    this.contracts!.push(Contract.fromJS(item));
            }
            else {
                this.contracts = <any>null;
            }
            this.contract = _data["contract"] ? Contract.fromJS(_data["contract"]) : <any>null;
            this.contractId = _data["contractId"] !== undefined ? _data["contractId"] : <any>null;
            this.clientNo = _data["clientNo"] !== undefined ? _data["clientNo"] : <any>null;
            this.allPaymentsAmount = _data["allPaymentsAmount"] !== undefined ? _data["allPaymentsAmount"] : <any>null;
        }
    }

    static fromJS(data: any): GroupedPayments {
        data = typeof data === 'object' ? data : {};
        let result = new GroupedPayments();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.paymentIds)) {
            data["paymentIds"] = [];
            for (let item of this.paymentIds)
                data["paymentIds"].push(item);
        }
        if (Array.isArray(this.payments)) {
            data["payments"] = [];
            for (let item of this.payments)
                data["payments"].push(item.toJSON());
        }
        if (Array.isArray(this.contractIds)) {
            data["contractIds"] = [];
            for (let item of this.contractIds)
                data["contractIds"].push(item);
        }
        if (Array.isArray(this.contracts)) {
            data["contracts"] = [];
            for (let item of this.contracts)
                data["contracts"].push(item.toJSON());
        }
        data["contract"] = this.contract ? this.contract.toJSON() : <any>null;
        data["contractId"] = this.contractId !== undefined ? this.contractId : <any>null;
        data["clientNo"] = this.clientNo !== undefined ? this.clientNo : <any>null;
        data["allPaymentsAmount"] = this.allPaymentsAmount !== undefined ? this.allPaymentsAmount : <any>null;
        return data;
    }
}

export interface IGroupedPayments {
    paymentIds?: number[] | null;
    payments?: Payment[] | null;
    contractIds?: number[] | null;
    contracts?: Contract[] | null;
    contract?: Contract | null;
    contractId?: number;
    clientNo?: number | null;
    allPaymentsAmount?: number;
}

export class EftRecordPayment implements IEftRecordPayment {
    oldPaymentState?: PaymentState | null;
    newPaymentState?: PaymentState | null;
    rejectedPaymentState?: PaymentState | null;
    payment?: Payment | null;
    paymentId?: number;
    eftRecord?: EftRecord | null;
    eftRecordId?: number;
    isRejected?: boolean;

    constructor(data?: IEftRecordPayment) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.oldPaymentState = _data["oldPaymentState"] !== undefined ? _data["oldPaymentState"] : <any>null;
            this.newPaymentState = _data["newPaymentState"] !== undefined ? _data["newPaymentState"] : <any>null;
            this.rejectedPaymentState = _data["rejectedPaymentState"] !== undefined ? _data["rejectedPaymentState"] : <any>null;
            this.payment = _data["payment"] ? Payment.fromJS(_data["payment"]) : <any>null;
            this.paymentId = _data["paymentId"] !== undefined ? _data["paymentId"] : <any>null;
            this.eftRecord = _data["eftRecord"] ? EftRecord.fromJS(_data["eftRecord"]) : <any>null;
            this.eftRecordId = _data["eftRecordId"] !== undefined ? _data["eftRecordId"] : <any>null;
            this.isRejected = _data["isRejected"] !== undefined ? _data["isRejected"] : <any>null;
        }
    }

    static fromJS(data: any): EftRecordPayment {
        data = typeof data === 'object' ? data : {};
        let result = new EftRecordPayment();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["oldPaymentState"] = this.oldPaymentState !== undefined ? this.oldPaymentState : <any>null;
        data["newPaymentState"] = this.newPaymentState !== undefined ? this.newPaymentState : <any>null;
        data["rejectedPaymentState"] = this.rejectedPaymentState !== undefined ? this.rejectedPaymentState : <any>null;
        data["payment"] = this.payment ? this.payment.toJSON() : <any>null;
        data["paymentId"] = this.paymentId !== undefined ? this.paymentId : <any>null;
        data["eftRecord"] = this.eftRecord ? this.eftRecord.toJSON() : <any>null;
        data["eftRecordId"] = this.eftRecordId !== undefined ? this.eftRecordId : <any>null;
        data["isRejected"] = this.isRejected !== undefined ? this.isRejected : <any>null;
        return data;
    }
}

export interface IEftRecordPayment {
    oldPaymentState?: PaymentState | null;
    newPaymentState?: PaymentState | null;
    rejectedPaymentState?: PaymentState | null;
    payment?: Payment | null;
    paymentId?: number;
    eftRecord?: EftRecord | null;
    eftRecordId?: number;
    isRejected?: boolean;
}

export enum EftTransactionStatus {
    PendingUpdate = "pendingUpdate",
    Valid = "valid",
    Invalid = "invalid",
    ReturnedByReceivingFinancialInstitution = "returnedByReceivingFinancialInstitution",
    RejectedByReceivingFinancialInstitution = "rejectedByReceivingFinancialInstitution",
    ToBeRePresented = "toBeRePresented",
    ItemRepresented = "itemRepresented",
    EftFileRejected = "eftFileRejected",
}

export class PaymentStateChangeRecord extends WriteAuditRecord implements IPaymentStateChangeRecord {
    payment?: Payment | null;
    paymentId?: number;
    oldPaymentState?: PaymentState;
    newPaymentState?: PaymentState;

    constructor(data?: IPaymentStateChangeRecord) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.payment = _data["payment"] ? Payment.fromJS(_data["payment"]) : <any>null;
            this.paymentId = _data["paymentId"] !== undefined ? _data["paymentId"] : <any>null;
            this.oldPaymentState = _data["oldPaymentState"] !== undefined ? _data["oldPaymentState"] : <any>null;
            this.newPaymentState = _data["newPaymentState"] !== undefined ? _data["newPaymentState"] : <any>null;
        }
    }

    static override fromJS(data: any): PaymentStateChangeRecord {
        data = typeof data === 'object' ? data : {};
        let result = new PaymentStateChangeRecord();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["payment"] = this.payment ? this.payment.toJSON() : <any>null;
        data["paymentId"] = this.paymentId !== undefined ? this.paymentId : <any>null;
        data["oldPaymentState"] = this.oldPaymentState !== undefined ? this.oldPaymentState : <any>null;
        data["newPaymentState"] = this.newPaymentState !== undefined ? this.newPaymentState : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IPaymentStateChangeRecord extends IWriteAuditRecord {
    payment?: Payment | null;
    paymentId?: number;
    oldPaymentState?: PaymentState;
    newPaymentState?: PaymentState;
}

export enum NsfFeeCreditType {
    NotCredited = "notCredited",
    FullyCredited = "fullyCredited",
    PartiallyCredited = "partiallyCredited",
    Reversed = "reversed",
}

export enum ErpSyncStatus {
    NotSynced = "notSynced",
    Synced = "synced",
    FailedSync = "failedSync",
}

export enum PaymentType {
    Regular = "regular",
    NsfReschedule = "nsfReschedule",
    NsfFee = "nsfFee",
    RejectReschedule = "rejectReschedule",
    NsfFeeReschedule = "nsfFeeReschedule",
    NsfFeeRejectReschedule = "nsfFeeRejectReschedule",
}

export class Amendment extends EntityOfInteger implements IAmendment {
    amount!: number;
    description?: string | null;
    amendedDate?: moment.Moment;
    contract!: Contract;
    contractID?: number;
    amendPaymentType?: AmendPaymentType;
    amendType?: AmendType;
    amendedBy?: Employee | null;

    constructor(data?: IAmendment) {
        super(data);
        if (!data) {
            this.contract = new Contract();
        }
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.amount = _data["amount"] !== undefined ? _data["amount"] : <any>null;
            this.description = _data["description"] !== undefined ? _data["description"] : <any>null;
            this.amendedDate = _data["amendedDate"] ? moment(_data["amendedDate"].toString()) : <any>null;
            this.contract = _data["contract"] ? Contract.fromJS(_data["contract"]) : new Contract();
            this.contractID = _data["contractID"] !== undefined ? _data["contractID"] : <any>null;
            this.amendPaymentType = _data["amendPaymentType"] !== undefined ? _data["amendPaymentType"] : <any>null;
            this.amendType = _data["amendType"] !== undefined ? _data["amendType"] : <any>null;
            this.amendedBy = _data["amendedBy"] ? Employee.fromJS(_data["amendedBy"]) : <any>null;
        }
    }

    static override fromJS(data: any): Amendment {
        data = typeof data === 'object' ? data : {};
        let result = new Amendment();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["amount"] = this.amount !== undefined ? this.amount : <any>null;
        data["description"] = this.description !== undefined ? this.description : <any>null;
        data["amendedDate"] = this.amendedDate ? this.amendedDate.format('YYYY-MM-DD') : <any>null;
        data["contract"] = this.contract ? this.contract.toJSON() : <any>null;
        data["contractID"] = this.contractID !== undefined ? this.contractID : <any>null;
        data["amendPaymentType"] = this.amendPaymentType !== undefined ? this.amendPaymentType : <any>null;
        data["amendType"] = this.amendType !== undefined ? this.amendType : <any>null;
        data["amendedBy"] = this.amendedBy ? this.amendedBy.toJSON() : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IAmendment extends IEntityOfInteger {
    amount: number;
    description?: string | null;
    amendedDate?: moment.Moment;
    contract: Contract;
    contractID?: number;
    amendPaymentType?: AmendPaymentType;
    amendType?: AmendType;
    amendedBy?: Employee | null;
}

export enum AmendPaymentType {
    AddAmountToAllActivePayments = "addAmountToAllActivePayments",
    AddAmountToNextPayment = "addAmountToNextPayment",
    ChangeContractValue = "changeContractValue",
}

export enum AmendType {
    NonSufficientFunds = "nonSufficientFunds",
    ServiceCharge = "serviceCharge",
    Addons = "addons",
    Other = "other",
    PayDateChange = "payDateChange",
    Freezer = "freezer",
    Credit = "credit",
    Modification = "modification",
    Appliance = "appliance",
}

export class CreditTaskAgentAssignmentRecord extends EntityOfInteger implements ICreditTaskAgentAssignmentRecord {
    contractId?: number;
    assignedCreditAgentId?: string | null;
    assignedCreditAgent?: Employee | null;
    assignedDateTime?: moment.Moment;
    resolvedDateTime?: moment.Moment;

    constructor(data?: ICreditTaskAgentAssignmentRecord) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.contractId = _data["contractId"] !== undefined ? _data["contractId"] : <any>null;
            this.assignedCreditAgentId = _data["assignedCreditAgentId"] !== undefined ? _data["assignedCreditAgentId"] : <any>null;
            this.assignedCreditAgent = _data["assignedCreditAgent"] ? Employee.fromJS(_data["assignedCreditAgent"]) : <any>null;
            this.assignedDateTime = _data["assignedDateTime"] ? moment(_data["assignedDateTime"].toString()) : <any>null;
            this.resolvedDateTime = _data["resolvedDateTime"] ? moment(_data["resolvedDateTime"].toString()) : <any>null;
        }
    }

    static override fromJS(data: any): CreditTaskAgentAssignmentRecord {
        data = typeof data === 'object' ? data : {};
        let result = new CreditTaskAgentAssignmentRecord();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contractId"] = this.contractId !== undefined ? this.contractId : <any>null;
        data["assignedCreditAgentId"] = this.assignedCreditAgentId !== undefined ? this.assignedCreditAgentId : <any>null;
        data["assignedCreditAgent"] = this.assignedCreditAgent ? this.assignedCreditAgent.toJSON() : <any>null;
        data["assignedDateTime"] = this.assignedDateTime ? this.assignedDateTime.toISOString() : <any>null;
        data["resolvedDateTime"] = this.resolvedDateTime ? this.resolvedDateTime.toISOString() : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface ICreditTaskAgentAssignmentRecord extends IEntityOfInteger {
    contractId?: number;
    assignedCreditAgentId?: string | null;
    assignedCreditAgent?: Employee | null;
    assignedDateTime?: moment.Moment;
    resolvedDateTime?: moment.Moment;
}

export class CreditTask extends EntityOfInteger implements ICreditTask {
    contractId?: number;
    contract?: Contract | null;
    type?: CreditTaskType;
    collectionsUpgrade?: boolean;
    status?: CreditTaskStatus;
    data?: string | null;
    createdDateTime?: moment.Moment;
    createdByEmployeeId?: string | null;
    createdByEmployee?: Employee | null;
    resolvedByEmployeeId?: string | null;
    resolvedByEmployee?: Employee | null;
    resolvedDateTime?: moment.Moment;
    creditTaskStateChangeRecord?: CreditTaskStateChangeRecord | null;
    canManuallyAcknowledge?: boolean;

    constructor(data?: ICreditTask) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.contractId = _data["contractId"] !== undefined ? _data["contractId"] : <any>null;
            this.contract = _data["contract"] ? Contract.fromJS(_data["contract"]) : <any>null;
            this.type = _data["type"] !== undefined ? _data["type"] : <any>null;
            this.collectionsUpgrade = _data["collectionsUpgrade"] !== undefined ? _data["collectionsUpgrade"] : <any>null;
            this.status = _data["status"] !== undefined ? _data["status"] : <any>null;
            this.data = _data["data"] !== undefined ? _data["data"] : <any>null;
            this.createdDateTime = _data["createdDateTime"] ? moment(_data["createdDateTime"].toString()) : <any>null;
            this.createdByEmployeeId = _data["createdByEmployeeId"] !== undefined ? _data["createdByEmployeeId"] : <any>null;
            this.createdByEmployee = _data["createdByEmployee"] ? Employee.fromJS(_data["createdByEmployee"]) : <any>null;
            this.resolvedByEmployeeId = _data["resolvedByEmployeeId"] !== undefined ? _data["resolvedByEmployeeId"] : <any>null;
            this.resolvedByEmployee = _data["resolvedByEmployee"] ? Employee.fromJS(_data["resolvedByEmployee"]) : <any>null;
            this.resolvedDateTime = _data["resolvedDateTime"] ? moment(_data["resolvedDateTime"].toString()) : <any>null;
            this.creditTaskStateChangeRecord = _data["creditTaskStateChangeRecord"] ? CreditTaskStateChangeRecord.fromJS(_data["creditTaskStateChangeRecord"]) : <any>null;
            this.canManuallyAcknowledge = _data["canManuallyAcknowledge"] !== undefined ? _data["canManuallyAcknowledge"] : <any>null;
        }
    }

    static override fromJS(data: any): CreditTask {
        data = typeof data === 'object' ? data : {};
        let result = new CreditTask();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contractId"] = this.contractId !== undefined ? this.contractId : <any>null;
        data["contract"] = this.contract ? this.contract.toJSON() : <any>null;
        data["type"] = this.type !== undefined ? this.type : <any>null;
        data["collectionsUpgrade"] = this.collectionsUpgrade !== undefined ? this.collectionsUpgrade : <any>null;
        data["status"] = this.status !== undefined ? this.status : <any>null;
        data["data"] = this.data !== undefined ? this.data : <any>null;
        data["createdDateTime"] = this.createdDateTime ? this.createdDateTime.toISOString() : <any>null;
        data["createdByEmployeeId"] = this.createdByEmployeeId !== undefined ? this.createdByEmployeeId : <any>null;
        data["createdByEmployee"] = this.createdByEmployee ? this.createdByEmployee.toJSON() : <any>null;
        data["resolvedByEmployeeId"] = this.resolvedByEmployeeId !== undefined ? this.resolvedByEmployeeId : <any>null;
        data["resolvedByEmployee"] = this.resolvedByEmployee ? this.resolvedByEmployee.toJSON() : <any>null;
        data["resolvedDateTime"] = this.resolvedDateTime ? this.resolvedDateTime.toISOString() : <any>null;
        data["creditTaskStateChangeRecord"] = this.creditTaskStateChangeRecord ? this.creditTaskStateChangeRecord.toJSON() : <any>null;
        data["canManuallyAcknowledge"] = this.canManuallyAcknowledge !== undefined ? this.canManuallyAcknowledge : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface ICreditTask extends IEntityOfInteger {
    contractId?: number;
    contract?: Contract | null;
    type?: CreditTaskType;
    collectionsUpgrade?: boolean;
    status?: CreditTaskStatus;
    data?: string | null;
    createdDateTime?: moment.Moment;
    createdByEmployeeId?: string | null;
    createdByEmployee?: Employee | null;
    resolvedByEmployeeId?: string | null;
    resolvedByEmployee?: Employee | null;
    resolvedDateTime?: moment.Moment;
    creditTaskStateChangeRecord?: CreditTaskStateChangeRecord | null;
    canManuallyAcknowledge?: boolean;
}

export enum CreditTaskType {
    Collections = "collections",
    LockedContract = "lockedContract",
    Nsf = "nsf",
    FailedPayment = "failedPayment",
    MissingBankInfo = "missingBankInfo",
}

export enum CreditTaskStatus {
    Open = "open",
    StandBy = "standBy",
    Resolved = "resolved",
    AutomatedClosed = "automatedClosed",
}

export class CreditTaskStateChangeRecord extends EntityOfInteger implements ICreditTaskStateChangeRecord {
    contractId?: number;
    creditTaskId?: number;
    updatedDateTime?: moment.Moment;
    type?: CreditTaskType;
    oldStatus?: CreditTaskStatus;
    newStatus?: CreditTaskStatus;

    constructor(data?: ICreditTaskStateChangeRecord) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.contractId = _data["contractId"] !== undefined ? _data["contractId"] : <any>null;
            this.creditTaskId = _data["creditTaskId"] !== undefined ? _data["creditTaskId"] : <any>null;
            this.updatedDateTime = _data["updatedDateTime"] ? moment(_data["updatedDateTime"].toString()) : <any>null;
            this.type = _data["type"] !== undefined ? _data["type"] : <any>null;
            this.oldStatus = _data["oldStatus"] !== undefined ? _data["oldStatus"] : <any>null;
            this.newStatus = _data["newStatus"] !== undefined ? _data["newStatus"] : <any>null;
        }
    }

    static override fromJS(data: any): CreditTaskStateChangeRecord {
        data = typeof data === 'object' ? data : {};
        let result = new CreditTaskStateChangeRecord();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contractId"] = this.contractId !== undefined ? this.contractId : <any>null;
        data["creditTaskId"] = this.creditTaskId !== undefined ? this.creditTaskId : <any>null;
        data["updatedDateTime"] = this.updatedDateTime ? this.updatedDateTime.toISOString() : <any>null;
        data["type"] = this.type !== undefined ? this.type : <any>null;
        data["oldStatus"] = this.oldStatus !== undefined ? this.oldStatus : <any>null;
        data["newStatus"] = this.newStatus !== undefined ? this.newStatus : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface ICreditTaskStateChangeRecord extends IEntityOfInteger {
    contractId?: number;
    creditTaskId?: number;
    updatedDateTime?: moment.Moment;
    type?: CreditTaskType;
    oldStatus?: CreditTaskStatus;
    newStatus?: CreditTaskStatus;
}

export class ContractRecycles extends EntityOfInteger implements IContractRecycles {
    contractId?: number;
    recycleDateTime?: moment.Moment;

    constructor(data?: IContractRecycles) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.contractId = _data["contractId"] !== undefined ? _data["contractId"] : <any>null;
            this.recycleDateTime = _data["recycleDateTime"] ? moment(_data["recycleDateTime"].toString()) : <any>null;
        }
    }

    static override fromJS(data: any): ContractRecycles {
        data = typeof data === 'object' ? data : {};
        let result = new ContractRecycles();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contractId"] = this.contractId !== undefined ? this.contractId : <any>null;
        data["recycleDateTime"] = this.recycleDateTime ? this.recycleDateTime.toISOString() : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IContractRecycles extends IEntityOfInteger {
    contractId?: number;
    recycleDateTime?: moment.Moment;
}

export enum ContractType {
    Contract = "contract",
    FreezerContract = "freezerContract",
    ApplianceContract = "applianceContract",
}

export class ChangePaymentFrequencyViewModel implements IChangePaymentFrequencyViewModel {
    id?: number;
    paymentFrequency!: PaymentFrequency;
    numberOfPayments!: number;
    firstPaymentDate!: moment.Moment;
    secondPaymentDate?: moment.Moment;
    useLastDayOfMonth?: boolean;

    constructor(data?: IChangePaymentFrequencyViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.paymentFrequency = _data["paymentFrequency"] !== undefined ? _data["paymentFrequency"] : <any>null;
            this.numberOfPayments = _data["numberOfPayments"] !== undefined ? _data["numberOfPayments"] : <any>null;
            this.firstPaymentDate = _data["firstPaymentDate"] ? moment(_data["firstPaymentDate"].toString()) : <any>null;
            this.secondPaymentDate = _data["secondPaymentDate"] ? moment(_data["secondPaymentDate"].toString()) : <any>null;
            this.useLastDayOfMonth = _data["useLastDayOfMonth"] !== undefined ? _data["useLastDayOfMonth"] : <any>null;
        }
    }

    static fromJS(data: any): ChangePaymentFrequencyViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ChangePaymentFrequencyViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["paymentFrequency"] = this.paymentFrequency !== undefined ? this.paymentFrequency : <any>null;
        data["numberOfPayments"] = this.numberOfPayments !== undefined ? this.numberOfPayments : <any>null;
        data["firstPaymentDate"] = this.firstPaymentDate ? this.firstPaymentDate.toISOString() : <any>null;
        data["secondPaymentDate"] = this.secondPaymentDate ? this.secondPaymentDate.toISOString() : <any>null;
        data["useLastDayOfMonth"] = this.useLastDayOfMonth !== undefined ? this.useLastDayOfMonth : <any>null;
        return data;
    }
}

export interface IChangePaymentFrequencyViewModel {
    id?: number;
    paymentFrequency: PaymentFrequency;
    numberOfPayments: number;
    firstPaymentDate: moment.Moment;
    secondPaymentDate?: moment.Moment;
    useLastDayOfMonth?: boolean;
}

export class ContractContainerBalance extends EntityOfInteger implements IContractContainerBalance {
    nsfFeesPaid?: number;
    creditedFees?: number;
    amountPaid?: number;
    originalValueWithFreezer?: number;
    isHidden?: boolean;
    contractValue?: number;
    amendmentAmount?: number;
    amendmentAndFeeAmount?: number;
    freezerAmendmentAmount?: number;
    contract?: Contract | null;
    remainingFeesToBePaid?: number;
    remainingAmountToBePaid?: number;
    remainingAmountToBePaidWithFees?: number;
    failedToLoad?: boolean;

    constructor(data?: IContractContainerBalance) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.nsfFeesPaid = _data["nsfFeesPaid"] !== undefined ? _data["nsfFeesPaid"] : <any>null;
            this.creditedFees = _data["creditedFees"] !== undefined ? _data["creditedFees"] : <any>null;
            this.amountPaid = _data["amountPaid"] !== undefined ? _data["amountPaid"] : <any>null;
            this.originalValueWithFreezer = _data["originalValueWithFreezer"] !== undefined ? _data["originalValueWithFreezer"] : <any>null;
            this.isHidden = _data["isHidden"] !== undefined ? _data["isHidden"] : <any>null;
            this.contractValue = _data["contractValue"] !== undefined ? _data["contractValue"] : <any>null;
            this.amendmentAmount = _data["amendmentAmount"] !== undefined ? _data["amendmentAmount"] : <any>null;
            this.amendmentAndFeeAmount = _data["amendmentAndFeeAmount"] !== undefined ? _data["amendmentAndFeeAmount"] : <any>null;
            this.freezerAmendmentAmount = _data["freezerAmendmentAmount"] !== undefined ? _data["freezerAmendmentAmount"] : <any>null;
            this.contract = _data["contract"] ? Contract.fromJS(_data["contract"]) : <any>null;
            this.remainingFeesToBePaid = _data["remainingFeesToBePaid"] !== undefined ? _data["remainingFeesToBePaid"] : <any>null;
            this.remainingAmountToBePaid = _data["remainingAmountToBePaid"] !== undefined ? _data["remainingAmountToBePaid"] : <any>null;
            this.remainingAmountToBePaidWithFees = _data["remainingAmountToBePaidWithFees"] !== undefined ? _data["remainingAmountToBePaidWithFees"] : <any>null;
            this.failedToLoad = _data["failedToLoad"] !== undefined ? _data["failedToLoad"] : <any>null;
        }
    }

    static override fromJS(data: any): ContractContainerBalance {
        data = typeof data === 'object' ? data : {};
        let result = new ContractContainerBalance();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nsfFeesPaid"] = this.nsfFeesPaid !== undefined ? this.nsfFeesPaid : <any>null;
        data["creditedFees"] = this.creditedFees !== undefined ? this.creditedFees : <any>null;
        data["amountPaid"] = this.amountPaid !== undefined ? this.amountPaid : <any>null;
        data["originalValueWithFreezer"] = this.originalValueWithFreezer !== undefined ? this.originalValueWithFreezer : <any>null;
        data["isHidden"] = this.isHidden !== undefined ? this.isHidden : <any>null;
        data["contractValue"] = this.contractValue !== undefined ? this.contractValue : <any>null;
        data["amendmentAmount"] = this.amendmentAmount !== undefined ? this.amendmentAmount : <any>null;
        data["amendmentAndFeeAmount"] = this.amendmentAndFeeAmount !== undefined ? this.amendmentAndFeeAmount : <any>null;
        data["freezerAmendmentAmount"] = this.freezerAmendmentAmount !== undefined ? this.freezerAmendmentAmount : <any>null;
        data["contract"] = this.contract ? this.contract.toJSON() : <any>null;
        data["remainingFeesToBePaid"] = this.remainingFeesToBePaid !== undefined ? this.remainingFeesToBePaid : <any>null;
        data["remainingAmountToBePaid"] = this.remainingAmountToBePaid !== undefined ? this.remainingAmountToBePaid : <any>null;
        data["remainingAmountToBePaidWithFees"] = this.remainingAmountToBePaidWithFees !== undefined ? this.remainingAmountToBePaidWithFees : <any>null;
        data["failedToLoad"] = this.failedToLoad !== undefined ? this.failedToLoad : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IContractContainerBalance extends IEntityOfInteger {
    nsfFeesPaid?: number;
    creditedFees?: number;
    amountPaid?: number;
    originalValueWithFreezer?: number;
    isHidden?: boolean;
    contractValue?: number;
    amendmentAmount?: number;
    amendmentAndFeeAmount?: number;
    freezerAmendmentAmount?: number;
    contract?: Contract | null;
    remainingFeesToBePaid?: number;
    remainingAmountToBePaid?: number;
    remainingAmountToBePaidWithFees?: number;
    failedToLoad?: boolean;
}

export class ClientRegisterCode extends EntityOfInteger implements IClientRegisterCode {
    code?: string | null;
    selfRegisterSmsCode?: string | null;
    selfRegisterSmsVerificationCode?: string | null;
    selfRegisterEmailCode?: string | null;
    phoneNumberUsed?: string | null;
    registerDateTime?: moment.Moment | null;
    createdDateTime?: moment.Moment;
    client?: Client | null;
    clientId?: string | null;
    sentByEmail?: boolean;
    sentBySms?: boolean;
    hasRegistered?: boolean;
    hasLoggedIn?: boolean;
    clientRegisterType?: ClientRegisterType;
    hasSentEmailLink?: boolean | null;

    constructor(data?: IClientRegisterCode) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.code = _data["code"] !== undefined ? _data["code"] : <any>null;
            this.selfRegisterSmsCode = _data["selfRegisterSmsCode"] !== undefined ? _data["selfRegisterSmsCode"] : <any>null;
            this.selfRegisterSmsVerificationCode = _data["selfRegisterSmsVerificationCode"] !== undefined ? _data["selfRegisterSmsVerificationCode"] : <any>null;
            this.selfRegisterEmailCode = _data["selfRegisterEmailCode"] !== undefined ? _data["selfRegisterEmailCode"] : <any>null;
            this.phoneNumberUsed = _data["phoneNumberUsed"] !== undefined ? _data["phoneNumberUsed"] : <any>null;
            this.registerDateTime = _data["registerDateTime"] ? moment(_data["registerDateTime"].toString()) : <any>null;
            this.createdDateTime = _data["createdDateTime"] ? moment(_data["createdDateTime"].toString()) : <any>null;
            this.client = _data["client"] ? Client.fromJS(_data["client"]) : <any>null;
            this.clientId = _data["clientId"] !== undefined ? _data["clientId"] : <any>null;
            this.sentByEmail = _data["sentByEmail"] !== undefined ? _data["sentByEmail"] : <any>null;
            this.sentBySms = _data["sentBySms"] !== undefined ? _data["sentBySms"] : <any>null;
            this.hasRegistered = _data["hasRegistered"] !== undefined ? _data["hasRegistered"] : <any>null;
            this.hasLoggedIn = _data["hasLoggedIn"] !== undefined ? _data["hasLoggedIn"] : <any>null;
            this.clientRegisterType = _data["clientRegisterType"] !== undefined ? _data["clientRegisterType"] : <any>null;
            this.hasSentEmailLink = _data["hasSentEmailLink"] !== undefined ? _data["hasSentEmailLink"] : <any>null;
        }
    }

    static override fromJS(data: any): ClientRegisterCode {
        data = typeof data === 'object' ? data : {};
        let result = new ClientRegisterCode();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code !== undefined ? this.code : <any>null;
        data["selfRegisterSmsCode"] = this.selfRegisterSmsCode !== undefined ? this.selfRegisterSmsCode : <any>null;
        data["selfRegisterSmsVerificationCode"] = this.selfRegisterSmsVerificationCode !== undefined ? this.selfRegisterSmsVerificationCode : <any>null;
        data["selfRegisterEmailCode"] = this.selfRegisterEmailCode !== undefined ? this.selfRegisterEmailCode : <any>null;
        data["phoneNumberUsed"] = this.phoneNumberUsed !== undefined ? this.phoneNumberUsed : <any>null;
        data["registerDateTime"] = this.registerDateTime ? this.registerDateTime.toISOString() : <any>null;
        data["createdDateTime"] = this.createdDateTime ? this.createdDateTime.toISOString() : <any>null;
        data["client"] = this.client ? this.client.toJSON() : <any>null;
        data["clientId"] = this.clientId !== undefined ? this.clientId : <any>null;
        data["sentByEmail"] = this.sentByEmail !== undefined ? this.sentByEmail : <any>null;
        data["sentBySms"] = this.sentBySms !== undefined ? this.sentBySms : <any>null;
        data["hasRegistered"] = this.hasRegistered !== undefined ? this.hasRegistered : <any>null;
        data["hasLoggedIn"] = this.hasLoggedIn !== undefined ? this.hasLoggedIn : <any>null;
        data["clientRegisterType"] = this.clientRegisterType !== undefined ? this.clientRegisterType : <any>null;
        data["hasSentEmailLink"] = this.hasSentEmailLink !== undefined ? this.hasSentEmailLink : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IClientRegisterCode extends IEntityOfInteger {
    code?: string | null;
    selfRegisterSmsCode?: string | null;
    selfRegisterSmsVerificationCode?: string | null;
    selfRegisterEmailCode?: string | null;
    phoneNumberUsed?: string | null;
    registerDateTime?: moment.Moment | null;
    createdDateTime?: moment.Moment;
    client?: Client | null;
    clientId?: string | null;
    sentByEmail?: boolean;
    sentBySms?: boolean;
    hasRegistered?: boolean;
    hasLoggedIn?: boolean;
    clientRegisterType?: ClientRegisterType;
    hasSentEmailLink?: boolean | null;
}

export enum ClientRegisterType {
    LinkFromEmailRegister = "linkFromEmailRegister",
    SelfEmailRegister = "selfEmailRegister",
    SelfSmsRegister = "selfSmsRegister",
}

export enum NotificationType {
    None = "none",
    Sms = "sms",
    Email = "email",
    Phone = "phone",
}

export class ClientChangeRequest extends EntityOfInteger implements IClientChangeRequest {
    phoneNumber?: string | null;
    mobilePhoneNumber?: string | null;
    extensionPhoneNumber?: string | null;
    workPhoneNumber?: string | null;
    workExtensionPhoneNumber?: string | null;
    email?: string | null;
    title?: Title | null;
    bankInfo?: BankInfo | null;
    address?: Address | null;
    notificationType?: NotificationType | null;
    client!: Client;
    requestedByUser?: ApplicationUser | null;
    changeRequestStatus?: ChangeRequestStatus;
    createdAt?: moment.Moment;
    notificationTypes?: NotificationType[] | null;

    constructor(data?: IClientChangeRequest) {
        super(data);
        if (!data) {
            this.client = new Client();
        }
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.phoneNumber = _data["phoneNumber"] !== undefined ? _data["phoneNumber"] : <any>null;
            this.mobilePhoneNumber = _data["mobilePhoneNumber"] !== undefined ? _data["mobilePhoneNumber"] : <any>null;
            this.extensionPhoneNumber = _data["extensionPhoneNumber"] !== undefined ? _data["extensionPhoneNumber"] : <any>null;
            this.workPhoneNumber = _data["workPhoneNumber"] !== undefined ? _data["workPhoneNumber"] : <any>null;
            this.workExtensionPhoneNumber = _data["workExtensionPhoneNumber"] !== undefined ? _data["workExtensionPhoneNumber"] : <any>null;
            this.email = _data["email"] !== undefined ? _data["email"] : <any>null;
            this.title = _data["title"] !== undefined ? _data["title"] : <any>null;
            this.bankInfo = _data["bankInfo"] ? BankInfo.fromJS(_data["bankInfo"]) : <any>null;
            this.address = _data["address"] ? Address.fromJS(_data["address"]) : <any>null;
            this.notificationType = _data["notificationType"] !== undefined ? _data["notificationType"] : <any>null;
            this.client = _data["client"] ? Client.fromJS(_data["client"]) : new Client();
            this.requestedByUser = _data["requestedByUser"] ? ApplicationUser.fromJS(_data["requestedByUser"]) : <any>null;
            this.changeRequestStatus = _data["changeRequestStatus"] !== undefined ? _data["changeRequestStatus"] : <any>null;
            this.createdAt = _data["createdAt"] ? moment(_data["createdAt"].toString()) : <any>null;
            if (Array.isArray(_data["notificationTypes"])) {
                this.notificationTypes = [] as any;
                for (let item of _data["notificationTypes"])
                    this.notificationTypes!.push(item);
            }
            else {
                this.notificationTypes = <any>null;
            }
        }
    }

    static override fromJS(data: any): ClientChangeRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ClientChangeRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["phoneNumber"] = this.phoneNumber !== undefined ? this.phoneNumber : <any>null;
        data["mobilePhoneNumber"] = this.mobilePhoneNumber !== undefined ? this.mobilePhoneNumber : <any>null;
        data["extensionPhoneNumber"] = this.extensionPhoneNumber !== undefined ? this.extensionPhoneNumber : <any>null;
        data["workPhoneNumber"] = this.workPhoneNumber !== undefined ? this.workPhoneNumber : <any>null;
        data["workExtensionPhoneNumber"] = this.workExtensionPhoneNumber !== undefined ? this.workExtensionPhoneNumber : <any>null;
        data["email"] = this.email !== undefined ? this.email : <any>null;
        data["title"] = this.title !== undefined ? this.title : <any>null;
        data["bankInfo"] = this.bankInfo ? this.bankInfo.toJSON() : <any>null;
        data["address"] = this.address ? this.address.toJSON() : <any>null;
        data["notificationType"] = this.notificationType !== undefined ? this.notificationType : <any>null;
        data["client"] = this.client ? this.client.toJSON() : <any>null;
        data["requestedByUser"] = this.requestedByUser ? this.requestedByUser.toJSON() : <any>null;
        data["changeRequestStatus"] = this.changeRequestStatus !== undefined ? this.changeRequestStatus : <any>null;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>null;
        if (Array.isArray(this.notificationTypes)) {
            data["notificationTypes"] = [];
            for (let item of this.notificationTypes)
                data["notificationTypes"].push(item);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IClientChangeRequest extends IEntityOfInteger {
    phoneNumber?: string | null;
    mobilePhoneNumber?: string | null;
    extensionPhoneNumber?: string | null;
    workPhoneNumber?: string | null;
    workExtensionPhoneNumber?: string | null;
    email?: string | null;
    title?: Title | null;
    bankInfo?: BankInfo | null;
    address?: Address | null;
    notificationType?: NotificationType | null;
    client: Client;
    requestedByUser?: ApplicationUser | null;
    changeRequestStatus?: ChangeRequestStatus;
    createdAt?: moment.Moment;
    notificationTypes?: NotificationType[] | null;
}

export enum ChangeRequestStatus {
    Pending = "pending",
    Approved = "approved",
    Denied = "denied",
}

export class ClientSatisfactionResponse extends EntityOfInteger implements IClientSatisfactionResponse {
    clientId?: string | null;
    ratingDelivery?: number;
    ratingService?: number;
    ratingConsultant?: number;
    ratingQuality?: number;
    ratingGeneral?: number;
    comment?: string | null;
    emailRecipientConfigKey?: string | null;
    submitDateTime?: moment.Moment;
    averageRating?: number;

    constructor(data?: IClientSatisfactionResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.clientId = _data["clientId"] !== undefined ? _data["clientId"] : <any>null;
            this.ratingDelivery = _data["ratingDelivery"] !== undefined ? _data["ratingDelivery"] : <any>null;
            this.ratingService = _data["ratingService"] !== undefined ? _data["ratingService"] : <any>null;
            this.ratingConsultant = _data["ratingConsultant"] !== undefined ? _data["ratingConsultant"] : <any>null;
            this.ratingQuality = _data["ratingQuality"] !== undefined ? _data["ratingQuality"] : <any>null;
            this.ratingGeneral = _data["ratingGeneral"] !== undefined ? _data["ratingGeneral"] : <any>null;
            this.comment = _data["comment"] !== undefined ? _data["comment"] : <any>null;
            this.emailRecipientConfigKey = _data["emailRecipientConfigKey"] !== undefined ? _data["emailRecipientConfigKey"] : <any>null;
            this.submitDateTime = _data["submitDateTime"] ? moment(_data["submitDateTime"].toString()) : <any>null;
            this.averageRating = _data["averageRating"] !== undefined ? _data["averageRating"] : <any>null;
        }
    }

    static override fromJS(data: any): ClientSatisfactionResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ClientSatisfactionResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clientId"] = this.clientId !== undefined ? this.clientId : <any>null;
        data["ratingDelivery"] = this.ratingDelivery !== undefined ? this.ratingDelivery : <any>null;
        data["ratingService"] = this.ratingService !== undefined ? this.ratingService : <any>null;
        data["ratingConsultant"] = this.ratingConsultant !== undefined ? this.ratingConsultant : <any>null;
        data["ratingQuality"] = this.ratingQuality !== undefined ? this.ratingQuality : <any>null;
        data["ratingGeneral"] = this.ratingGeneral !== undefined ? this.ratingGeneral : <any>null;
        data["comment"] = this.comment !== undefined ? this.comment : <any>null;
        data["emailRecipientConfigKey"] = this.emailRecipientConfigKey !== undefined ? this.emailRecipientConfigKey : <any>null;
        data["submitDateTime"] = this.submitDateTime ? this.submitDateTime.format('YYYY-MM-DD') : <any>null;
        data["averageRating"] = this.averageRating !== undefined ? this.averageRating : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IClientSatisfactionResponse extends IEntityOfInteger {
    clientId?: string | null;
    ratingDelivery?: number;
    ratingService?: number;
    ratingConsultant?: number;
    ratingQuality?: number;
    ratingGeneral?: number;
    comment?: string | null;
    emailRecipientConfigKey?: string | null;
    submitDateTime?: moment.Moment;
    averageRating?: number;
}

export class NsfNotification implements INsfNotification {
    client?: Client | null;
    clientId?: string | null;
    rescheduledDate?: moment.Moment | null;

    constructor(data?: INsfNotification) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.client = _data["client"] ? Client.fromJS(_data["client"]) : <any>null;
            this.clientId = _data["clientId"] !== undefined ? _data["clientId"] : <any>null;
            this.rescheduledDate = _data["rescheduledDate"] ? moment(_data["rescheduledDate"].toString()) : <any>null;
        }
    }

    static fromJS(data: any): NsfNotification {
        data = typeof data === 'object' ? data : {};
        let result = new NsfNotification();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["client"] = this.client ? this.client.toJSON() : <any>null;
        data["clientId"] = this.clientId !== undefined ? this.clientId : <any>null;
        data["rescheduledDate"] = this.rescheduledDate ? this.rescheduledDate.toISOString() : <any>null;
        return data;
    }
}

export interface INsfNotification {
    client?: Client | null;
    clientId?: string | null;
    rescheduledDate?: moment.Moment | null;
}

export class ImportedClientLeadsFromOrdersRecord extends PrivateEntityOfInteger implements IImportedClientLeadsFromOrdersRecord {
    dateImportPerformed?: moment.Moment;
    fromDate?: moment.Moment | null;
    toDate?: moment.Moment | null;
    importOrderType?: ImportOrderType;
    importedClientLeadsOrdersRecord?: ImportedClientLeadsOrdersRecord[] | null;
    numberOfOrdersImported?: number;

    constructor(data?: IImportedClientLeadsFromOrdersRecord) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.dateImportPerformed = _data["dateImportPerformed"] ? moment(_data["dateImportPerformed"].toString()) : <any>null;
            this.fromDate = _data["fromDate"] ? moment(_data["fromDate"].toString()) : <any>null;
            this.toDate = _data["toDate"] ? moment(_data["toDate"].toString()) : <any>null;
            this.importOrderType = _data["importOrderType"] !== undefined ? _data["importOrderType"] : <any>null;
            if (Array.isArray(_data["importedClientLeadsOrdersRecord"])) {
                this.importedClientLeadsOrdersRecord = [] as any;
                for (let item of _data["importedClientLeadsOrdersRecord"])
                    this.importedClientLeadsOrdersRecord!.push(ImportedClientLeadsOrdersRecord.fromJS(item));
            }
            else {
                this.importedClientLeadsOrdersRecord = <any>null;
            }
            this.numberOfOrdersImported = _data["numberOfOrdersImported"] !== undefined ? _data["numberOfOrdersImported"] : <any>null;
        }
    }

    static override fromJS(data: any): ImportedClientLeadsFromOrdersRecord {
        data = typeof data === 'object' ? data : {};
        let result = new ImportedClientLeadsFromOrdersRecord();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dateImportPerformed"] = this.dateImportPerformed ? this.dateImportPerformed.toISOString() : <any>null;
        data["fromDate"] = this.fromDate ? this.fromDate.toISOString() : <any>null;
        data["toDate"] = this.toDate ? this.toDate.toISOString() : <any>null;
        data["importOrderType"] = this.importOrderType !== undefined ? this.importOrderType : <any>null;
        if (Array.isArray(this.importedClientLeadsOrdersRecord)) {
            data["importedClientLeadsOrdersRecord"] = [];
            for (let item of this.importedClientLeadsOrdersRecord)
                data["importedClientLeadsOrdersRecord"].push(item.toJSON());
        }
        data["numberOfOrdersImported"] = this.numberOfOrdersImported !== undefined ? this.numberOfOrdersImported : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IImportedClientLeadsFromOrdersRecord extends IPrivateEntityOfInteger {
    dateImportPerformed?: moment.Moment;
    fromDate?: moment.Moment | null;
    toDate?: moment.Moment | null;
    importOrderType?: ImportOrderType;
    importedClientLeadsOrdersRecord?: ImportedClientLeadsOrdersRecord[] | null;
    numberOfOrdersImported?: number;
}

export class ClientLeadSourceType implements IClientLeadSourceType {
    id?: number;
    nameEn?: string | null;
    nameFr?: string | null;
    isActive?: boolean;
    isOptIn?: boolean;
    sendSmsNotificationOnNewLead?: boolean;
    createdClientLeads?: ClientLead[] | null;

    constructor(data?: IClientLeadSourceType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.nameEn = _data["nameEn"] !== undefined ? _data["nameEn"] : <any>null;
            this.nameFr = _data["nameFr"] !== undefined ? _data["nameFr"] : <any>null;
            this.isActive = _data["isActive"] !== undefined ? _data["isActive"] : <any>null;
            this.isOptIn = _data["isOptIn"] !== undefined ? _data["isOptIn"] : <any>null;
            this.sendSmsNotificationOnNewLead = _data["sendSmsNotificationOnNewLead"] !== undefined ? _data["sendSmsNotificationOnNewLead"] : <any>null;
            if (Array.isArray(_data["createdClientLeads"])) {
                this.createdClientLeads = [] as any;
                for (let item of _data["createdClientLeads"])
                    this.createdClientLeads!.push(ClientLead.fromJS(item));
            }
            else {
                this.createdClientLeads = <any>null;
            }
        }
    }

    static fromJS(data: any): ClientLeadSourceType {
        data = typeof data === 'object' ? data : {};
        let result = new ClientLeadSourceType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["nameEn"] = this.nameEn !== undefined ? this.nameEn : <any>null;
        data["nameFr"] = this.nameFr !== undefined ? this.nameFr : <any>null;
        data["isActive"] = this.isActive !== undefined ? this.isActive : <any>null;
        data["isOptIn"] = this.isOptIn !== undefined ? this.isOptIn : <any>null;
        data["sendSmsNotificationOnNewLead"] = this.sendSmsNotificationOnNewLead !== undefined ? this.sendSmsNotificationOnNewLead : <any>null;
        if (Array.isArray(this.createdClientLeads)) {
            data["createdClientLeads"] = [];
            for (let item of this.createdClientLeads)
                data["createdClientLeads"].push(item.toJSON());
        }
        return data;
    }
}

export interface IClientLeadSourceType {
    id?: number;
    nameEn?: string | null;
    nameFr?: string | null;
    isActive?: boolean;
    isOptIn?: boolean;
    sendSmsNotificationOnNewLead?: boolean;
    createdClientLeads?: ClientLead[] | null;
}

export class CrmAppointment extends EntityOfString implements ICrmAppointment {
    callNo?: number;
    tabletDispatchedAppointmentId?: string | null;
    activeDirectoryUsername?: string | null;
    createdOn?: moment.Moment;
    createdByEmployee?: Employee | null;
    createdByEmployeeId?: string | null;
    tabletDispatchToSalesRepId?: string | null;
    tabletDispatchToSalesRep?: Employee | null;
    createdFromClientLead?: ClientLead | null;
    createdFromClientLeadId?: number | null;
    appointmentDispatchedRecords?: AppointmentDispatchedRecord[] | null;

    constructor(data?: ICrmAppointment) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.callNo = _data["callNo"] !== undefined ? _data["callNo"] : <any>null;
            this.tabletDispatchedAppointmentId = _data["tabletDispatchedAppointmentId"] !== undefined ? _data["tabletDispatchedAppointmentId"] : <any>null;
            this.activeDirectoryUsername = _data["activeDirectoryUsername"] !== undefined ? _data["activeDirectoryUsername"] : <any>null;
            this.createdOn = _data["createdOn"] ? moment(_data["createdOn"].toString()) : <any>null;
            this.createdByEmployee = _data["createdByEmployee"] ? Employee.fromJS(_data["createdByEmployee"]) : <any>null;
            this.createdByEmployeeId = _data["createdByEmployeeId"] !== undefined ? _data["createdByEmployeeId"] : <any>null;
            this.tabletDispatchToSalesRepId = _data["tabletDispatchToSalesRepId"] !== undefined ? _data["tabletDispatchToSalesRepId"] : <any>null;
            this.tabletDispatchToSalesRep = _data["tabletDispatchToSalesRep"] ? Employee.fromJS(_data["tabletDispatchToSalesRep"]) : <any>null;
            this.createdFromClientLead = _data["createdFromClientLead"] ? ClientLead.fromJS(_data["createdFromClientLead"]) : <any>null;
            this.createdFromClientLeadId = _data["createdFromClientLeadId"] !== undefined ? _data["createdFromClientLeadId"] : <any>null;
            if (Array.isArray(_data["appointmentDispatchedRecords"])) {
                this.appointmentDispatchedRecords = [] as any;
                for (let item of _data["appointmentDispatchedRecords"])
                    this.appointmentDispatchedRecords!.push(AppointmentDispatchedRecord.fromJS(item));
            }
            else {
                this.appointmentDispatchedRecords = <any>null;
            }
        }
    }

    static override fromJS(data: any): CrmAppointment {
        data = typeof data === 'object' ? data : {};
        let result = new CrmAppointment();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["callNo"] = this.callNo !== undefined ? this.callNo : <any>null;
        data["tabletDispatchedAppointmentId"] = this.tabletDispatchedAppointmentId !== undefined ? this.tabletDispatchedAppointmentId : <any>null;
        data["activeDirectoryUsername"] = this.activeDirectoryUsername !== undefined ? this.activeDirectoryUsername : <any>null;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>null;
        data["createdByEmployee"] = this.createdByEmployee ? this.createdByEmployee.toJSON() : <any>null;
        data["createdByEmployeeId"] = this.createdByEmployeeId !== undefined ? this.createdByEmployeeId : <any>null;
        data["tabletDispatchToSalesRepId"] = this.tabletDispatchToSalesRepId !== undefined ? this.tabletDispatchToSalesRepId : <any>null;
        data["tabletDispatchToSalesRep"] = this.tabletDispatchToSalesRep ? this.tabletDispatchToSalesRep.toJSON() : <any>null;
        data["createdFromClientLead"] = this.createdFromClientLead ? this.createdFromClientLead.toJSON() : <any>null;
        data["createdFromClientLeadId"] = this.createdFromClientLeadId !== undefined ? this.createdFromClientLeadId : <any>null;
        if (Array.isArray(this.appointmentDispatchedRecords)) {
            data["appointmentDispatchedRecords"] = [];
            for (let item of this.appointmentDispatchedRecords)
                data["appointmentDispatchedRecords"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface ICrmAppointment extends IEntityOfString {
    callNo?: number;
    tabletDispatchedAppointmentId?: string | null;
    activeDirectoryUsername?: string | null;
    createdOn?: moment.Moment;
    createdByEmployee?: Employee | null;
    createdByEmployeeId?: string | null;
    tabletDispatchToSalesRepId?: string | null;
    tabletDispatchToSalesRep?: Employee | null;
    createdFromClientLead?: ClientLead | null;
    createdFromClientLeadId?: number | null;
    appointmentDispatchedRecords?: AppointmentDispatchedRecord[] | null;
}

export class AppointmentDispatchedRecord extends EntityOfString implements IAppointmentDispatchedRecord {
    crmAppointment?: CrmAppointment | null;
    crmAppointmentId?: string | null;
    dispatchType?: AppointmentDispatchType;
    performedByEmployee?: Employee | null;
    performedByEmployeeId?: string | null;
    confirmedSalesRep?: Employee | null;
    confirmedSalesRepId?: string | null;
    performedOnDateTime?: moment.Moment;
    tabletDispatchedAppointmentId?: string;
    isRemoteOrder?: boolean | null;

    constructor(data?: IAppointmentDispatchedRecord) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.crmAppointment = _data["crmAppointment"] ? CrmAppointment.fromJS(_data["crmAppointment"]) : <any>null;
            this.crmAppointmentId = _data["crmAppointmentId"] !== undefined ? _data["crmAppointmentId"] : <any>null;
            this.dispatchType = _data["dispatchType"] !== undefined ? _data["dispatchType"] : <any>null;
            this.performedByEmployee = _data["performedByEmployee"] ? Employee.fromJS(_data["performedByEmployee"]) : <any>null;
            this.performedByEmployeeId = _data["performedByEmployeeId"] !== undefined ? _data["performedByEmployeeId"] : <any>null;
            this.confirmedSalesRep = _data["confirmedSalesRep"] ? Employee.fromJS(_data["confirmedSalesRep"]) : <any>null;
            this.confirmedSalesRepId = _data["confirmedSalesRepId"] !== undefined ? _data["confirmedSalesRepId"] : <any>null;
            this.performedOnDateTime = _data["performedOnDateTime"] ? moment(_data["performedOnDateTime"].toString()) : <any>null;
            this.tabletDispatchedAppointmentId = _data["tabletDispatchedAppointmentId"] !== undefined ? _data["tabletDispatchedAppointmentId"] : <any>null;
            this.isRemoteOrder = _data["isRemoteOrder"] !== undefined ? _data["isRemoteOrder"] : <any>null;
        }
    }

    static override fromJS(data: any): AppointmentDispatchedRecord {
        data = typeof data === 'object' ? data : {};
        let result = new AppointmentDispatchedRecord();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["crmAppointment"] = this.crmAppointment ? this.crmAppointment.toJSON() : <any>null;
        data["crmAppointmentId"] = this.crmAppointmentId !== undefined ? this.crmAppointmentId : <any>null;
        data["dispatchType"] = this.dispatchType !== undefined ? this.dispatchType : <any>null;
        data["performedByEmployee"] = this.performedByEmployee ? this.performedByEmployee.toJSON() : <any>null;
        data["performedByEmployeeId"] = this.performedByEmployeeId !== undefined ? this.performedByEmployeeId : <any>null;
        data["confirmedSalesRep"] = this.confirmedSalesRep ? this.confirmedSalesRep.toJSON() : <any>null;
        data["confirmedSalesRepId"] = this.confirmedSalesRepId !== undefined ? this.confirmedSalesRepId : <any>null;
        data["performedOnDateTime"] = this.performedOnDateTime ? this.performedOnDateTime.toISOString() : <any>null;
        data["tabletDispatchedAppointmentId"] = this.tabletDispatchedAppointmentId !== undefined ? this.tabletDispatchedAppointmentId : <any>null;
        data["isRemoteOrder"] = this.isRemoteOrder !== undefined ? this.isRemoteOrder : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IAppointmentDispatchedRecord extends IEntityOfString {
    crmAppointment?: CrmAppointment | null;
    crmAppointmentId?: string | null;
    dispatchType?: AppointmentDispatchType;
    performedByEmployee?: Employee | null;
    performedByEmployeeId?: string | null;
    confirmedSalesRep?: Employee | null;
    confirmedSalesRepId?: string | null;
    performedOnDateTime?: moment.Moment;
    tabletDispatchedAppointmentId?: string;
    isRemoteOrder?: boolean | null;
}

export class Zone extends EntityOfInteger implements IZone {
    name?: string | null;
    clientLeads?: ClientLead[] | null;

    constructor(data?: IZone) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            if (Array.isArray(_data["clientLeads"])) {
                this.clientLeads = [] as any;
                for (let item of _data["clientLeads"])
                    this.clientLeads!.push(ClientLead.fromJS(item));
            }
            else {
                this.clientLeads = <any>null;
            }
        }
    }

    static override fromJS(data: any): Zone {
        data = typeof data === 'object' ? data : {};
        let result = new Zone();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : <any>null;
        if (Array.isArray(this.clientLeads)) {
            data["clientLeads"] = [];
            for (let item of this.clientLeads)
                data["clientLeads"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IZone extends IEntityOfInteger {
    name?: string | null;
    clientLeads?: ClientLead[] | null;
}

export class Campaign extends EntityOfInteger implements ICampaign {
    name?: string | null;
    priority?: number;
    includeAllAgents?: boolean;
    createdDate?: moment.Moment;
    createdByEmployeeId?: string | null;
    createdByEmployee?: Employee | null;
    status?: CampaignStatus;
    clientLeads?: ClientLead[] | null;
    associatedAgents?: CampaignAssociatedAgents[] | null;

    constructor(data?: ICampaign) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.priority = _data["priority"] !== undefined ? _data["priority"] : <any>null;
            this.includeAllAgents = _data["includeAllAgents"] !== undefined ? _data["includeAllAgents"] : <any>null;
            this.createdDate = _data["createdDate"] ? moment(_data["createdDate"].toString()) : <any>null;
            this.createdByEmployeeId = _data["createdByEmployeeId"] !== undefined ? _data["createdByEmployeeId"] : <any>null;
            this.createdByEmployee = _data["createdByEmployee"] ? Employee.fromJS(_data["createdByEmployee"]) : <any>null;
            this.status = _data["status"] !== undefined ? _data["status"] : <any>null;
            if (Array.isArray(_data["clientLeads"])) {
                this.clientLeads = [] as any;
                for (let item of _data["clientLeads"])
                    this.clientLeads!.push(ClientLead.fromJS(item));
            }
            else {
                this.clientLeads = <any>null;
            }
            if (Array.isArray(_data["associatedAgents"])) {
                this.associatedAgents = [] as any;
                for (let item of _data["associatedAgents"])
                    this.associatedAgents!.push(CampaignAssociatedAgents.fromJS(item));
            }
            else {
                this.associatedAgents = <any>null;
            }
        }
    }

    static override fromJS(data: any): Campaign {
        data = typeof data === 'object' ? data : {};
        let result = new Campaign();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["priority"] = this.priority !== undefined ? this.priority : <any>null;
        data["includeAllAgents"] = this.includeAllAgents !== undefined ? this.includeAllAgents : <any>null;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>null;
        data["createdByEmployeeId"] = this.createdByEmployeeId !== undefined ? this.createdByEmployeeId : <any>null;
        data["createdByEmployee"] = this.createdByEmployee ? this.createdByEmployee.toJSON() : <any>null;
        data["status"] = this.status !== undefined ? this.status : <any>null;
        if (Array.isArray(this.clientLeads)) {
            data["clientLeads"] = [];
            for (let item of this.clientLeads)
                data["clientLeads"].push(item.toJSON());
        }
        if (Array.isArray(this.associatedAgents)) {
            data["associatedAgents"] = [];
            for (let item of this.associatedAgents)
                data["associatedAgents"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface ICampaign extends IEntityOfInteger {
    name?: string | null;
    priority?: number;
    includeAllAgents?: boolean;
    createdDate?: moment.Moment;
    createdByEmployeeId?: string | null;
    createdByEmployee?: Employee | null;
    status?: CampaignStatus;
    clientLeads?: ClientLead[] | null;
    associatedAgents?: CampaignAssociatedAgents[] | null;
}

export class CampaignAssociatedAgents extends EntityOfInteger implements ICampaignAssociatedAgents {
    campaignId?: number;
    campaign?: Campaign | null;
    employeeId?: string | null;
    employee?: Employee | null;

    constructor(data?: ICampaignAssociatedAgents) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.campaignId = _data["campaignId"] !== undefined ? _data["campaignId"] : <any>null;
            this.campaign = _data["campaign"] ? Campaign.fromJS(_data["campaign"]) : <any>null;
            this.employeeId = _data["employeeId"] !== undefined ? _data["employeeId"] : <any>null;
            this.employee = _data["employee"] ? Employee.fromJS(_data["employee"]) : <any>null;
        }
    }

    static override fromJS(data: any): CampaignAssociatedAgents {
        data = typeof data === 'object' ? data : {};
        let result = new CampaignAssociatedAgents();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["campaignId"] = this.campaignId !== undefined ? this.campaignId : <any>null;
        data["campaign"] = this.campaign ? this.campaign.toJSON() : <any>null;
        data["employeeId"] = this.employeeId !== undefined ? this.employeeId : <any>null;
        data["employee"] = this.employee ? this.employee.toJSON() : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface ICampaignAssociatedAgents extends IEntityOfInteger {
    campaignId?: number;
    campaign?: Campaign | null;
    employeeId?: string | null;
    employee?: Employee | null;
}

export class ClientLeadRecycles extends EntityOfInteger implements IClientLeadRecycles {
    clientLeadId?: number;
    clientLead?: ClientLead | null;
    recycleDateTime?: moment.Moment;

    constructor(data?: IClientLeadRecycles) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.clientLeadId = _data["clientLeadId"] !== undefined ? _data["clientLeadId"] : <any>null;
            this.clientLead = _data["clientLead"] ? ClientLead.fromJS(_data["clientLead"]) : <any>null;
            this.recycleDateTime = _data["recycleDateTime"] ? moment(_data["recycleDateTime"].toString()) : <any>null;
        }
    }

    static override fromJS(data: any): ClientLeadRecycles {
        data = typeof data === 'object' ? data : {};
        let result = new ClientLeadRecycles();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clientLeadId"] = this.clientLeadId !== undefined ? this.clientLeadId : <any>null;
        data["clientLead"] = this.clientLead ? this.clientLead.toJSON() : <any>null;
        data["recycleDateTime"] = this.recycleDateTime ? this.recycleDateTime.toISOString() : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IClientLeadRecycles extends IEntityOfInteger {
    clientLeadId?: number;
    clientLead?: ClientLead | null;
    recycleDateTime?: moment.Moment;
}

export class ClientLeadNoteCommand implements IClientLeadNoteCommand {
    clientLeadNote?: ClientLeadNoteDto | null;

    constructor(data?: IClientLeadNoteCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.clientLeadNote = _data["clientLeadNote"] ? ClientLeadNoteDto.fromJS(_data["clientLeadNote"]) : <any>null;
        }
    }

    static fromJS(data: any): ClientLeadNoteCommand {
        data = typeof data === 'object' ? data : {};
        let result = new ClientLeadNoteCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clientLeadNote"] = this.clientLeadNote ? this.clientLeadNote.toJSON() : <any>null;
        return data;
    }
}

export interface IClientLeadNoteCommand {
    clientLeadNote?: ClientLeadNoteDto | null;
}

export class AddClientLeadNoteCommand extends ClientLeadNoteCommand implements IAddClientLeadNoteCommand {
    agentId?: string | null;

    constructor(data?: IAddClientLeadNoteCommand) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.agentId = _data["agentId"] !== undefined ? _data["agentId"] : <any>null;
        }
    }

    static override fromJS(data: any): AddClientLeadNoteCommand {
        data = typeof data === 'object' ? data : {};
        let result = new AddClientLeadNoteCommand();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["agentId"] = this.agentId !== undefined ? this.agentId : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IAddClientLeadNoteCommand extends IClientLeadNoteCommand {
    agentId?: string | null;
}

export class EditClientLeadNoteCommand extends ClientLeadNoteCommand implements IEditClientLeadNoteCommand {

    constructor(data?: IEditClientLeadNoteCommand) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): EditClientLeadNoteCommand {
        data = typeof data === 'object' ? data : {};
        let result = new EditClientLeadNoteCommand();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IEditClientLeadNoteCommand extends IClientLeadNoteCommand {
}

export class AssignEmployeeToClientLeadCommand implements IAssignEmployeeToClientLeadCommand {
    employeeId?: string | null;
    clientLeadsId?: number[] | null;

    constructor(data?: IAssignEmployeeToClientLeadCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.employeeId = _data["employeeId"] !== undefined ? _data["employeeId"] : <any>null;
            if (Array.isArray(_data["clientLeadsId"])) {
                this.clientLeadsId = [] as any;
                for (let item of _data["clientLeadsId"])
                    this.clientLeadsId!.push(item);
            }
            else {
                this.clientLeadsId = <any>null;
            }
        }
    }

    static fromJS(data: any): AssignEmployeeToClientLeadCommand {
        data = typeof data === 'object' ? data : {};
        let result = new AssignEmployeeToClientLeadCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["employeeId"] = this.employeeId !== undefined ? this.employeeId : <any>null;
        if (Array.isArray(this.clientLeadsId)) {
            data["clientLeadsId"] = [];
            for (let item of this.clientLeadsId)
                data["clientLeadsId"].push(item);
        }
        return data;
    }
}

export interface IAssignEmployeeToClientLeadCommand {
    employeeId?: string | null;
    clientLeadsId?: number[] | null;
}

export class UnassignEmployeeToClientLeadCommand implements IUnassignEmployeeToClientLeadCommand {
    clientLeadsId?: number[] | null;

    constructor(data?: IUnassignEmployeeToClientLeadCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["clientLeadsId"])) {
                this.clientLeadsId = [] as any;
                for (let item of _data["clientLeadsId"])
                    this.clientLeadsId!.push(item);
            }
            else {
                this.clientLeadsId = <any>null;
            }
        }
    }

    static fromJS(data: any): UnassignEmployeeToClientLeadCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UnassignEmployeeToClientLeadCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.clientLeadsId)) {
            data["clientLeadsId"] = [];
            for (let item of this.clientLeadsId)
                data["clientLeadsId"].push(item);
        }
        return data;
    }
}

export interface IUnassignEmployeeToClientLeadCommand {
    clientLeadsId?: number[] | null;
}

export class ChangeClientLeadsStatusCommand implements IChangeClientLeadsStatusCommand {
    clientLeadsId?: number[] | null;
    newStatus?: ClientLeadStatus;
    unbookableReason?: UnbookableReason | null;

    constructor(data?: IChangeClientLeadsStatusCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["clientLeadsId"])) {
                this.clientLeadsId = [] as any;
                for (let item of _data["clientLeadsId"])
                    this.clientLeadsId!.push(item);
            }
            else {
                this.clientLeadsId = <any>null;
            }
            this.newStatus = _data["newStatus"] !== undefined ? _data["newStatus"] : <any>null;
            this.unbookableReason = _data["unbookableReason"] !== undefined ? _data["unbookableReason"] : <any>null;
        }
    }

    static fromJS(data: any): ChangeClientLeadsStatusCommand {
        data = typeof data === 'object' ? data : {};
        let result = new ChangeClientLeadsStatusCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.clientLeadsId)) {
            data["clientLeadsId"] = [];
            for (let item of this.clientLeadsId)
                data["clientLeadsId"].push(item);
        }
        data["newStatus"] = this.newStatus !== undefined ? this.newStatus : <any>null;
        data["unbookableReason"] = this.unbookableReason !== undefined ? this.unbookableReason : <any>null;
        return data;
    }
}

export interface IChangeClientLeadsStatusCommand {
    clientLeadsId?: number[] | null;
    newStatus?: ClientLeadStatus;
    unbookableReason?: UnbookableReason | null;
}

export class NotInterestedClientLeadCommand implements INotInterestedClientLeadCommand {
    clientLeadId?: number | null;
    appointment?: AppointmentDto | null;
    notInterestedReasons?: NotInterestedReason[] | null;
    postalCode?: string | null;
    sid?: string | null;
    doNotCreatedLeadProfile?: boolean | null;

    constructor(data?: INotInterestedClientLeadCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.clientLeadId = _data["clientLeadId"] !== undefined ? _data["clientLeadId"] : <any>null;
            this.appointment = _data["appointment"] ? AppointmentDto.fromJS(_data["appointment"]) : <any>null;
            if (Array.isArray(_data["notInterestedReasons"])) {
                this.notInterestedReasons = [] as any;
                for (let item of _data["notInterestedReasons"])
                    this.notInterestedReasons!.push(item);
            }
            else {
                this.notInterestedReasons = <any>null;
            }
            this.postalCode = _data["postalCode"] !== undefined ? _data["postalCode"] : <any>null;
            this.sid = _data["sid"] !== undefined ? _data["sid"] : <any>null;
            this.doNotCreatedLeadProfile = _data["doNotCreatedLeadProfile"] !== undefined ? _data["doNotCreatedLeadProfile"] : <any>null;
        }
    }

    static fromJS(data: any): NotInterestedClientLeadCommand {
        data = typeof data === 'object' ? data : {};
        let result = new NotInterestedClientLeadCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clientLeadId"] = this.clientLeadId !== undefined ? this.clientLeadId : <any>null;
        data["appointment"] = this.appointment ? this.appointment.toJSON() : <any>null;
        if (Array.isArray(this.notInterestedReasons)) {
            data["notInterestedReasons"] = [];
            for (let item of this.notInterestedReasons)
                data["notInterestedReasons"].push(item);
        }
        data["postalCode"] = this.postalCode !== undefined ? this.postalCode : <any>null;
        data["sid"] = this.sid !== undefined ? this.sid : <any>null;
        data["doNotCreatedLeadProfile"] = this.doNotCreatedLeadProfile !== undefined ? this.doNotCreatedLeadProfile : <any>null;
        return data;
    }
}

export interface INotInterestedClientLeadCommand {
    clientLeadId?: number | null;
    appointment?: AppointmentDto | null;
    notInterestedReasons?: NotInterestedReason[] | null;
    postalCode?: string | null;
    sid?: string | null;
    doNotCreatedLeadProfile?: boolean | null;
}

export class ImportedClientLeadsFromOrdersRecordDto implements IImportedClientLeadsFromOrdersRecordDto {
    id?: number;
    dateImportPerformed?: moment.Moment;
    numberOfClientLeadsImported?: number;
    importOrderType?: ImportOrderType;
    fromDate?: moment.Moment | null;
    toDate?: moment.Moment | null;
    formattedFromAndToDate?: string | null;

    constructor(data?: IImportedClientLeadsFromOrdersRecordDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.dateImportPerformed = _data["dateImportPerformed"] ? moment(_data["dateImportPerformed"].toString()) : <any>null;
            this.numberOfClientLeadsImported = _data["numberOfClientLeadsImported"] !== undefined ? _data["numberOfClientLeadsImported"] : <any>null;
            this.importOrderType = _data["importOrderType"] !== undefined ? _data["importOrderType"] : <any>null;
            this.fromDate = _data["fromDate"] ? moment(_data["fromDate"].toString()) : <any>null;
            this.toDate = _data["toDate"] ? moment(_data["toDate"].toString()) : <any>null;
            this.formattedFromAndToDate = _data["formattedFromAndToDate"] !== undefined ? _data["formattedFromAndToDate"] : <any>null;
        }
    }

    static fromJS(data: any): ImportedClientLeadsFromOrdersRecordDto {
        data = typeof data === 'object' ? data : {};
        let result = new ImportedClientLeadsFromOrdersRecordDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["dateImportPerformed"] = this.dateImportPerformed ? this.dateImportPerformed.toISOString() : <any>null;
        data["numberOfClientLeadsImported"] = this.numberOfClientLeadsImported !== undefined ? this.numberOfClientLeadsImported : <any>null;
        data["importOrderType"] = this.importOrderType !== undefined ? this.importOrderType : <any>null;
        data["fromDate"] = this.fromDate ? this.fromDate.toISOString() : <any>null;
        data["toDate"] = this.toDate ? this.toDate.toISOString() : <any>null;
        data["formattedFromAndToDate"] = this.formattedFromAndToDate !== undefined ? this.formattedFromAndToDate : <any>null;
        return data;
    }
}

export interface IImportedClientLeadsFromOrdersRecordDto {
    id?: number;
    dateImportPerformed?: moment.Moment;
    numberOfClientLeadsImported?: number;
    importOrderType?: ImportOrderType;
    fromDate?: moment.Moment | null;
    toDate?: moment.Moment | null;
    formattedFromAndToDate?: string | null;
}

export class GetImportedClientLeadsFromOrdersRecordListQuery implements IGetImportedClientLeadsFromOrdersRecordListQuery {

    constructor(data?: IGetImportedClientLeadsFromOrdersRecordListQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): GetImportedClientLeadsFromOrdersRecordListQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetImportedClientLeadsFromOrdersRecordListQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IGetImportedClientLeadsFromOrdersRecordListQuery {
}

export class ImportClientLeadsFromOrderReferencesCommand implements IImportClientLeadsFromOrderReferencesCommand {
    fromDate?: moment.Moment;
    toDate?: moment.Moment;
    importedOrderType?: ImportOrderType;

    constructor(data?: IImportClientLeadsFromOrderReferencesCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fromDate = _data["fromDate"] ? moment(_data["fromDate"].toString()) : <any>null;
            this.toDate = _data["toDate"] ? moment(_data["toDate"].toString()) : <any>null;
            this.importedOrderType = _data["importedOrderType"] !== undefined ? _data["importedOrderType"] : <any>null;
        }
    }

    static fromJS(data: any): ImportClientLeadsFromOrderReferencesCommand {
        data = typeof data === 'object' ? data : {};
        let result = new ImportClientLeadsFromOrderReferencesCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fromDate"] = this.fromDate ? this.fromDate.toISOString() : <any>null;
        data["toDate"] = this.toDate ? this.toDate.toISOString() : <any>null;
        data["importedOrderType"] = this.importedOrderType !== undefined ? this.importedOrderType : <any>null;
        return data;
    }
}

export interface IImportClientLeadsFromOrderReferencesCommand {
    fromDate?: moment.Moment;
    toDate?: moment.Moment;
    importedOrderType?: ImportOrderType;
}

export class RemoveOrderReferencesCommand implements IRemoveOrderReferencesCommand {
    orderNo?: number;

    constructor(data?: IRemoveOrderReferencesCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.orderNo = _data["orderNo"] !== undefined ? _data["orderNo"] : <any>null;
        }
    }

    static fromJS(data: any): RemoveOrderReferencesCommand {
        data = typeof data === 'object' ? data : {};
        let result = new RemoveOrderReferencesCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["orderNo"] = this.orderNo !== undefined ? this.orderNo : <any>null;
        return data;
    }
}

export interface IRemoveOrderReferencesCommand {
    orderNo?: number;
}

export class SetAsUnbookableCommand implements ISetAsUnbookableCommand {
    clientLeadsId?: number[] | null;

    constructor(data?: ISetAsUnbookableCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["clientLeadsId"])) {
                this.clientLeadsId = [] as any;
                for (let item of _data["clientLeadsId"])
                    this.clientLeadsId!.push(item);
            }
            else {
                this.clientLeadsId = <any>null;
            }
        }
    }

    static fromJS(data: any): SetAsUnbookableCommand {
        data = typeof data === 'object' ? data : {};
        let result = new SetAsUnbookableCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.clientLeadsId)) {
            data["clientLeadsId"] = [];
            for (let item of this.clientLeadsId)
                data["clientLeadsId"].push(item);
        }
        return data;
    }
}

export interface ISetAsUnbookableCommand {
    clientLeadsId?: number[] | null;
}

export class AssignCampaignToClientLeadCommand implements IAssignCampaignToClientLeadCommand {
    campaignId?: number;
    clientLeadsId?: number[] | null;

    constructor(data?: IAssignCampaignToClientLeadCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.campaignId = _data["campaignId"] !== undefined ? _data["campaignId"] : <any>null;
            if (Array.isArray(_data["clientLeadsId"])) {
                this.clientLeadsId = [] as any;
                for (let item of _data["clientLeadsId"])
                    this.clientLeadsId!.push(item);
            }
            else {
                this.clientLeadsId = <any>null;
            }
        }
    }

    static fromJS(data: any): AssignCampaignToClientLeadCommand {
        data = typeof data === 'object' ? data : {};
        let result = new AssignCampaignToClientLeadCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["campaignId"] = this.campaignId !== undefined ? this.campaignId : <any>null;
        if (Array.isArray(this.clientLeadsId)) {
            data["clientLeadsId"] = [];
            for (let item of this.clientLeadsId)
                data["clientLeadsId"].push(item);
        }
        return data;
    }
}

export interface IAssignCampaignToClientLeadCommand {
    campaignId?: number;
    clientLeadsId?: number[] | null;
}

export class ReleaseClientLeadFromCampaignCommand implements IReleaseClientLeadFromCampaignCommand {
    clientLeadsId?: number[] | null;

    constructor(data?: IReleaseClientLeadFromCampaignCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["clientLeadsId"])) {
                this.clientLeadsId = [] as any;
                for (let item of _data["clientLeadsId"])
                    this.clientLeadsId!.push(item);
            }
            else {
                this.clientLeadsId = <any>null;
            }
        }
    }

    static fromJS(data: any): ReleaseClientLeadFromCampaignCommand {
        data = typeof data === 'object' ? data : {};
        let result = new ReleaseClientLeadFromCampaignCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.clientLeadsId)) {
            data["clientLeadsId"] = [];
            for (let item of this.clientLeadsId)
                data["clientLeadsId"].push(item);
        }
        return data;
    }
}

export interface IReleaseClientLeadFromCampaignCommand {
    clientLeadsId?: number[] | null;
}

export class ImportClientLeadsFromSmsReferralCommand implements IImportClientLeadsFromSmsReferralCommand {
    fromDate?: moment.Moment;
    toDate?: moment.Moment;
    sendReportEmail?: boolean;

    constructor(data?: IImportClientLeadsFromSmsReferralCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fromDate = _data["fromDate"] ? moment(_data["fromDate"].toString()) : <any>null;
            this.toDate = _data["toDate"] ? moment(_data["toDate"].toString()) : <any>null;
            this.sendReportEmail = _data["sendReportEmail"] !== undefined ? _data["sendReportEmail"] : <any>null;
        }
    }

    static fromJS(data: any): ImportClientLeadsFromSmsReferralCommand {
        data = typeof data === 'object' ? data : {};
        let result = new ImportClientLeadsFromSmsReferralCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fromDate"] = this.fromDate ? this.fromDate.toISOString() : <any>null;
        data["toDate"] = this.toDate ? this.toDate.toISOString() : <any>null;
        data["sendReportEmail"] = this.sendReportEmail !== undefined ? this.sendReportEmail : <any>null;
        return data;
    }
}

export interface IImportClientLeadsFromSmsReferralCommand {
    fromDate?: moment.Moment;
    toDate?: moment.Moment;
    sendReportEmail?: boolean;
}

export class ImportedClientLeadsFromSMSRecordDto implements IImportedClientLeadsFromSMSRecordDto {
    id?: number;
    dateImportPerformed?: moment.Moment;
    numberOfClientLeadsImported?: number;
    fromDate?: moment.Moment | null;
    toDate?: moment.Moment | null;
    formattedFromAndToDate?: string | null;

    constructor(data?: IImportedClientLeadsFromSMSRecordDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.dateImportPerformed = _data["dateImportPerformed"] ? moment(_data["dateImportPerformed"].toString()) : <any>null;
            this.numberOfClientLeadsImported = _data["numberOfClientLeadsImported"] !== undefined ? _data["numberOfClientLeadsImported"] : <any>null;
            this.fromDate = _data["fromDate"] ? moment(_data["fromDate"].toString()) : <any>null;
            this.toDate = _data["toDate"] ? moment(_data["toDate"].toString()) : <any>null;
            this.formattedFromAndToDate = _data["formattedFromAndToDate"] !== undefined ? _data["formattedFromAndToDate"] : <any>null;
        }
    }

    static fromJS(data: any): ImportedClientLeadsFromSMSRecordDto {
        data = typeof data === 'object' ? data : {};
        let result = new ImportedClientLeadsFromSMSRecordDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["dateImportPerformed"] = this.dateImportPerformed ? this.dateImportPerformed.toISOString() : <any>null;
        data["numberOfClientLeadsImported"] = this.numberOfClientLeadsImported !== undefined ? this.numberOfClientLeadsImported : <any>null;
        data["fromDate"] = this.fromDate ? this.fromDate.toISOString() : <any>null;
        data["toDate"] = this.toDate ? this.toDate.toISOString() : <any>null;
        data["formattedFromAndToDate"] = this.formattedFromAndToDate !== undefined ? this.formattedFromAndToDate : <any>null;
        return data;
    }
}

export interface IImportedClientLeadsFromSMSRecordDto {
    id?: number;
    dateImportPerformed?: moment.Moment;
    numberOfClientLeadsImported?: number;
    fromDate?: moment.Moment | null;
    toDate?: moment.Moment | null;
    formattedFromAndToDate?: string | null;
}

export class GetImportedClientLeadsFromSMSRecordListQuery implements IGetImportedClientLeadsFromSMSRecordListQuery {

    constructor(data?: IGetImportedClientLeadsFromSMSRecordListQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): GetImportedClientLeadsFromSMSRecordListQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetImportedClientLeadsFromSMSRecordListQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IGetImportedClientLeadsFromSMSRecordListQuery {
}

export class PaginatedResultOfClientNextDeliveryTaskLookupDto extends PaginatedResult implements IPaginatedResultOfClientNextDeliveryTaskLookupDto {
    entities?: ClientNextDeliveryTaskLookupDto[] | null;

    constructor(data?: IPaginatedResultOfClientNextDeliveryTaskLookupDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["entities"])) {
                this.entities = [] as any;
                for (let item of _data["entities"])
                    this.entities!.push(ClientNextDeliveryTaskLookupDto.fromJS(item));
            }
            else {
                this.entities = <any>null;
            }
        }
    }

    static override fromJS(data: any): PaginatedResultOfClientNextDeliveryTaskLookupDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResultOfClientNextDeliveryTaskLookupDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.entities)) {
            data["entities"] = [];
            for (let item of this.entities)
                data["entities"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IPaginatedResultOfClientNextDeliveryTaskLookupDto extends IPaginatedResult {
    entities?: ClientNextDeliveryTaskLookupDto[] | null;
}

export class ClientNextDeliveryTaskLookupDto implements IClientNextDeliveryTaskLookupDto {
    id?: number;
    index?: number;
    assignedEmployeeId?: string | null;
    assignedEmployeeName?: string | null;
    assignedByEmployeeId?: string | null;
    assignedByEmployeeName?: string | null;
    assignedEmployeeDateTime?: moment.Moment | null;
    createdDateTime?: moment.Moment;
    clientNo?: number;
    city?: string | null;
    rang?: number;
    numberOfPlannedDeliveries?: number;
    percentOfPaidOrder?: number;
    hasUnpaidNsfs?: boolean;
    lastDeliveryDate?: moment.Moment;
    orderNo?: number;
    receivedPatch?: boolean;
    status?: ClientNextDeliveryTaskStatus;
    nextDeliveryReminderDate?: moment.Moment;
    callBackDateTime?: moment.Moment | null;
    wantsNextDelivery?: boolean | null;
    wantsChanges?: boolean | null;
    wantsNextDeliveryConfirmedDateTime?: moment.Moment | null;

    constructor(data?: IClientNextDeliveryTaskLookupDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.index = _data["index"] !== undefined ? _data["index"] : <any>null;
            this.assignedEmployeeId = _data["assignedEmployeeId"] !== undefined ? _data["assignedEmployeeId"] : <any>null;
            this.assignedEmployeeName = _data["assignedEmployeeName"] !== undefined ? _data["assignedEmployeeName"] : <any>null;
            this.assignedByEmployeeId = _data["assignedByEmployeeId"] !== undefined ? _data["assignedByEmployeeId"] : <any>null;
            this.assignedByEmployeeName = _data["assignedByEmployeeName"] !== undefined ? _data["assignedByEmployeeName"] : <any>null;
            this.assignedEmployeeDateTime = _data["assignedEmployeeDateTime"] ? moment(_data["assignedEmployeeDateTime"].toString()) : <any>null;
            this.createdDateTime = _data["createdDateTime"] ? moment(_data["createdDateTime"].toString()) : <any>null;
            this.clientNo = _data["clientNo"] !== undefined ? _data["clientNo"] : <any>null;
            this.city = _data["city"] !== undefined ? _data["city"] : <any>null;
            this.rang = _data["rang"] !== undefined ? _data["rang"] : <any>null;
            this.numberOfPlannedDeliveries = _data["numberOfPlannedDeliveries"] !== undefined ? _data["numberOfPlannedDeliveries"] : <any>null;
            this.percentOfPaidOrder = _data["percentOfPaidOrder"] !== undefined ? _data["percentOfPaidOrder"] : <any>null;
            this.hasUnpaidNsfs = _data["hasUnpaidNsfs"] !== undefined ? _data["hasUnpaidNsfs"] : <any>null;
            this.lastDeliveryDate = _data["lastDeliveryDate"] ? moment(_data["lastDeliveryDate"].toString()) : <any>null;
            this.orderNo = _data["orderNo"] !== undefined ? _data["orderNo"] : <any>null;
            this.receivedPatch = _data["receivedPatch"] !== undefined ? _data["receivedPatch"] : <any>null;
            this.status = _data["status"] !== undefined ? _data["status"] : <any>null;
            this.nextDeliveryReminderDate = _data["nextDeliveryReminderDate"] ? moment(_data["nextDeliveryReminderDate"].toString()) : <any>null;
            this.callBackDateTime = _data["callBackDateTime"] ? moment(_data["callBackDateTime"].toString()) : <any>null;
            this.wantsNextDelivery = _data["wantsNextDelivery"] !== undefined ? _data["wantsNextDelivery"] : <any>null;
            this.wantsChanges = _data["wantsChanges"] !== undefined ? _data["wantsChanges"] : <any>null;
            this.wantsNextDeliveryConfirmedDateTime = _data["wantsNextDeliveryConfirmedDateTime"] ? moment(_data["wantsNextDeliveryConfirmedDateTime"].toString()) : <any>null;
        }
    }

    static fromJS(data: any): ClientNextDeliveryTaskLookupDto {
        data = typeof data === 'object' ? data : {};
        let result = new ClientNextDeliveryTaskLookupDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["index"] = this.index !== undefined ? this.index : <any>null;
        data["assignedEmployeeId"] = this.assignedEmployeeId !== undefined ? this.assignedEmployeeId : <any>null;
        data["assignedEmployeeName"] = this.assignedEmployeeName !== undefined ? this.assignedEmployeeName : <any>null;
        data["assignedByEmployeeId"] = this.assignedByEmployeeId !== undefined ? this.assignedByEmployeeId : <any>null;
        data["assignedByEmployeeName"] = this.assignedByEmployeeName !== undefined ? this.assignedByEmployeeName : <any>null;
        data["assignedEmployeeDateTime"] = this.assignedEmployeeDateTime ? this.assignedEmployeeDateTime.toISOString() : <any>null;
        data["createdDateTime"] = this.createdDateTime ? this.createdDateTime.toISOString() : <any>null;
        data["clientNo"] = this.clientNo !== undefined ? this.clientNo : <any>null;
        data["city"] = this.city !== undefined ? this.city : <any>null;
        data["rang"] = this.rang !== undefined ? this.rang : <any>null;
        data["numberOfPlannedDeliveries"] = this.numberOfPlannedDeliveries !== undefined ? this.numberOfPlannedDeliveries : <any>null;
        data["percentOfPaidOrder"] = this.percentOfPaidOrder !== undefined ? this.percentOfPaidOrder : <any>null;
        data["hasUnpaidNsfs"] = this.hasUnpaidNsfs !== undefined ? this.hasUnpaidNsfs : <any>null;
        data["lastDeliveryDate"] = this.lastDeliveryDate ? this.lastDeliveryDate.toISOString() : <any>null;
        data["orderNo"] = this.orderNo !== undefined ? this.orderNo : <any>null;
        data["receivedPatch"] = this.receivedPatch !== undefined ? this.receivedPatch : <any>null;
        data["status"] = this.status !== undefined ? this.status : <any>null;
        data["nextDeliveryReminderDate"] = this.nextDeliveryReminderDate ? this.nextDeliveryReminderDate.toISOString() : <any>null;
        data["callBackDateTime"] = this.callBackDateTime ? this.callBackDateTime.toISOString() : <any>null;
        data["wantsNextDelivery"] = this.wantsNextDelivery !== undefined ? this.wantsNextDelivery : <any>null;
        data["wantsChanges"] = this.wantsChanges !== undefined ? this.wantsChanges : <any>null;
        data["wantsNextDeliveryConfirmedDateTime"] = this.wantsNextDeliveryConfirmedDateTime ? this.wantsNextDeliveryConfirmedDateTime.toISOString() : <any>null;
        return data;
    }
}

export interface IClientNextDeliveryTaskLookupDto {
    id?: number;
    index?: number;
    assignedEmployeeId?: string | null;
    assignedEmployeeName?: string | null;
    assignedByEmployeeId?: string | null;
    assignedByEmployeeName?: string | null;
    assignedEmployeeDateTime?: moment.Moment | null;
    createdDateTime?: moment.Moment;
    clientNo?: number;
    city?: string | null;
    rang?: number;
    numberOfPlannedDeliveries?: number;
    percentOfPaidOrder?: number;
    hasUnpaidNsfs?: boolean;
    lastDeliveryDate?: moment.Moment;
    orderNo?: number;
    receivedPatch?: boolean;
    status?: ClientNextDeliveryTaskStatus;
    nextDeliveryReminderDate?: moment.Moment;
    callBackDateTime?: moment.Moment | null;
    wantsNextDelivery?: boolean | null;
    wantsChanges?: boolean | null;
    wantsNextDeliveryConfirmedDateTime?: moment.Moment | null;
}

export enum ClientNextDeliveryTaskStatus {
    Invalid = "invalid",
    Open = "open",
    Closed = "closed",
    StandBy = "standBy",
    AutomatedClosed = "automatedClosed",
}

export class GetClientNextDeliveryTasksQuery extends PaginationModel implements IGetClientNextDeliveryTasksQuery {
    hasAssignedEmployee?: boolean;
    hasNoAssignedEmployee?: boolean;
    hasFollowUp?: boolean;
    hasNoFollowUp?: boolean;
    isOpen?: boolean;
    isClosed?: boolean;
    isStandBy?: boolean;
    isAutomatedClosed?: boolean;
    wantsNextDelivery?: boolean;
    wantsChanges?: boolean;
    assignedEmployeesById?: string[] | null;
    searchDateUtcRange?: (moment.Moment | null)[] | null;
    ignoreDateRange?: boolean;

    constructor(data?: IGetClientNextDeliveryTasksQuery) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.hasAssignedEmployee = _data["hasAssignedEmployee"] !== undefined ? _data["hasAssignedEmployee"] : <any>null;
            this.hasNoAssignedEmployee = _data["hasNoAssignedEmployee"] !== undefined ? _data["hasNoAssignedEmployee"] : <any>null;
            this.hasFollowUp = _data["hasFollowUp"] !== undefined ? _data["hasFollowUp"] : <any>null;
            this.hasNoFollowUp = _data["hasNoFollowUp"] !== undefined ? _data["hasNoFollowUp"] : <any>null;
            this.isOpen = _data["isOpen"] !== undefined ? _data["isOpen"] : <any>null;
            this.isClosed = _data["isClosed"] !== undefined ? _data["isClosed"] : <any>null;
            this.isStandBy = _data["isStandBy"] !== undefined ? _data["isStandBy"] : <any>null;
            this.isAutomatedClosed = _data["isAutomatedClosed"] !== undefined ? _data["isAutomatedClosed"] : <any>null;
            this.wantsNextDelivery = _data["wantsNextDelivery"] !== undefined ? _data["wantsNextDelivery"] : <any>null;
            this.wantsChanges = _data["wantsChanges"] !== undefined ? _data["wantsChanges"] : <any>null;
            if (Array.isArray(_data["assignedEmployeesById"])) {
                this.assignedEmployeesById = [] as any;
                for (let item of _data["assignedEmployeesById"])
                    this.assignedEmployeesById!.push(item);
            }
            else {
                this.assignedEmployeesById = <any>null;
            }
            if (Array.isArray(_data["searchDateUtcRange"])) {
                this.searchDateUtcRange = [] as any;
                for (let item of _data["searchDateUtcRange"])
                    this.searchDateUtcRange!.push(moment(item));
            }
            else {
                this.searchDateUtcRange = <any>null;
            }
            this.ignoreDateRange = _data["ignoreDateRange"] !== undefined ? _data["ignoreDateRange"] : <any>null;
        }
    }

    static override fromJS(data: any): GetClientNextDeliveryTasksQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetClientNextDeliveryTasksQuery();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["hasAssignedEmployee"] = this.hasAssignedEmployee !== undefined ? this.hasAssignedEmployee : <any>null;
        data["hasNoAssignedEmployee"] = this.hasNoAssignedEmployee !== undefined ? this.hasNoAssignedEmployee : <any>null;
        data["hasFollowUp"] = this.hasFollowUp !== undefined ? this.hasFollowUp : <any>null;
        data["hasNoFollowUp"] = this.hasNoFollowUp !== undefined ? this.hasNoFollowUp : <any>null;
        data["isOpen"] = this.isOpen !== undefined ? this.isOpen : <any>null;
        data["isClosed"] = this.isClosed !== undefined ? this.isClosed : <any>null;
        data["isStandBy"] = this.isStandBy !== undefined ? this.isStandBy : <any>null;
        data["isAutomatedClosed"] = this.isAutomatedClosed !== undefined ? this.isAutomatedClosed : <any>null;
        data["wantsNextDelivery"] = this.wantsNextDelivery !== undefined ? this.wantsNextDelivery : <any>null;
        data["wantsChanges"] = this.wantsChanges !== undefined ? this.wantsChanges : <any>null;
        if (Array.isArray(this.assignedEmployeesById)) {
            data["assignedEmployeesById"] = [];
            for (let item of this.assignedEmployeesById)
                data["assignedEmployeesById"].push(item);
        }
        if (Array.isArray(this.searchDateUtcRange)) {
            data["searchDateUtcRange"] = [];
            for (let item of this.searchDateUtcRange)
                data["searchDateUtcRange"].push(item.toISOString());
        }
        data["ignoreDateRange"] = this.ignoreDateRange !== undefined ? this.ignoreDateRange : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IGetClientNextDeliveryTasksQuery extends IPaginationModel {
    hasAssignedEmployee?: boolean;
    hasNoAssignedEmployee?: boolean;
    hasFollowUp?: boolean;
    hasNoFollowUp?: boolean;
    isOpen?: boolean;
    isClosed?: boolean;
    isStandBy?: boolean;
    isAutomatedClosed?: boolean;
    wantsNextDelivery?: boolean;
    wantsChanges?: boolean;
    assignedEmployeesById?: string[] | null;
    searchDateUtcRange?: (moment.Moment | null)[] | null;
    ignoreDateRange?: boolean;
}

export class GetMyAssignedClientNextDeliveryTasksQuery extends PaginationModel implements IGetMyAssignedClientNextDeliveryTasksQuery {
    hasFollowUp?: boolean;
    hasNoFollowUp?: boolean;
    searchDateUtcRange?: (moment.Moment | null)[] | null;
    ignoreDateRange?: boolean;
    hasAssignedEmployee?: boolean;
    hasNoAssignedEmployee?: boolean;
    wantsNextDelivery?: boolean;
    wantsChanges?: boolean;
    isOpen?: boolean;
    isStandBy?: boolean;

    constructor(data?: IGetMyAssignedClientNextDeliveryTasksQuery) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.hasFollowUp = _data["hasFollowUp"] !== undefined ? _data["hasFollowUp"] : <any>null;
            this.hasNoFollowUp = _data["hasNoFollowUp"] !== undefined ? _data["hasNoFollowUp"] : <any>null;
            if (Array.isArray(_data["searchDateUtcRange"])) {
                this.searchDateUtcRange = [] as any;
                for (let item of _data["searchDateUtcRange"])
                    this.searchDateUtcRange!.push(moment(item));
            }
            else {
                this.searchDateUtcRange = <any>null;
            }
            this.ignoreDateRange = _data["ignoreDateRange"] !== undefined ? _data["ignoreDateRange"] : <any>null;
            this.hasAssignedEmployee = _data["hasAssignedEmployee"] !== undefined ? _data["hasAssignedEmployee"] : <any>null;
            this.hasNoAssignedEmployee = _data["hasNoAssignedEmployee"] !== undefined ? _data["hasNoAssignedEmployee"] : <any>null;
            this.wantsNextDelivery = _data["wantsNextDelivery"] !== undefined ? _data["wantsNextDelivery"] : <any>null;
            this.wantsChanges = _data["wantsChanges"] !== undefined ? _data["wantsChanges"] : <any>null;
            this.isOpen = _data["isOpen"] !== undefined ? _data["isOpen"] : <any>null;
            this.isStandBy = _data["isStandBy"] !== undefined ? _data["isStandBy"] : <any>null;
        }
    }

    static override fromJS(data: any): GetMyAssignedClientNextDeliveryTasksQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetMyAssignedClientNextDeliveryTasksQuery();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["hasFollowUp"] = this.hasFollowUp !== undefined ? this.hasFollowUp : <any>null;
        data["hasNoFollowUp"] = this.hasNoFollowUp !== undefined ? this.hasNoFollowUp : <any>null;
        if (Array.isArray(this.searchDateUtcRange)) {
            data["searchDateUtcRange"] = [];
            for (let item of this.searchDateUtcRange)
                data["searchDateUtcRange"].push(item.toISOString());
        }
        data["ignoreDateRange"] = this.ignoreDateRange !== undefined ? this.ignoreDateRange : <any>null;
        data["hasAssignedEmployee"] = this.hasAssignedEmployee !== undefined ? this.hasAssignedEmployee : <any>null;
        data["hasNoAssignedEmployee"] = this.hasNoAssignedEmployee !== undefined ? this.hasNoAssignedEmployee : <any>null;
        data["wantsNextDelivery"] = this.wantsNextDelivery !== undefined ? this.wantsNextDelivery : <any>null;
        data["wantsChanges"] = this.wantsChanges !== undefined ? this.wantsChanges : <any>null;
        data["isOpen"] = this.isOpen !== undefined ? this.isOpen : <any>null;
        data["isStandBy"] = this.isStandBy !== undefined ? this.isStandBy : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IGetMyAssignedClientNextDeliveryTasksQuery extends IPaginationModel {
    hasFollowUp?: boolean;
    hasNoFollowUp?: boolean;
    searchDateUtcRange?: (moment.Moment | null)[] | null;
    ignoreDateRange?: boolean;
    hasAssignedEmployee?: boolean;
    hasNoAssignedEmployee?: boolean;
    wantsNextDelivery?: boolean;
    wantsChanges?: boolean;
    isOpen?: boolean;
    isStandBy?: boolean;
}

export class GetActiveAndAssignedNextDeliveryTaskAgentsQuery implements IGetActiveAndAssignedNextDeliveryTaskAgentsQuery {

    constructor(data?: IGetActiveAndAssignedNextDeliveryTaskAgentsQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): GetActiveAndAssignedNextDeliveryTaskAgentsQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetActiveAndAssignedNextDeliveryTaskAgentsQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IGetActiveAndAssignedNextDeliveryTaskAgentsQuery {
}

export class NextDeliveryTaskDto implements INextDeliveryTaskDto {
    clientNo?: number;
    orderNo?: number;
    city?: string | null;
    rang?: number;
    name?: string | null;
    email?: string | null;
    numberOfPlannedDeliveries?: number;
    lastDeliveryDate?: moment.Moment;
    receivedAPatch?: boolean;
    orderDate?: moment.Moment;
    firstDeliveryDate?: moment.Moment;
    numberOfMonths?: number;
    numberOfMonthsForNextDelivery?: number;
    percentOfPaidOrder?: number;
    ppmContractNotFound?: boolean;
    hasUnpaidNsfs?: boolean;
    nextDeliveryDueDate?: moment.Moment;

    constructor(data?: INextDeliveryTaskDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.clientNo = _data["clientNo"] !== undefined ? _data["clientNo"] : <any>null;
            this.orderNo = _data["orderNo"] !== undefined ? _data["orderNo"] : <any>null;
            this.city = _data["city"] !== undefined ? _data["city"] : <any>null;
            this.rang = _data["rang"] !== undefined ? _data["rang"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.email = _data["email"] !== undefined ? _data["email"] : <any>null;
            this.numberOfPlannedDeliveries = _data["numberOfPlannedDeliveries"] !== undefined ? _data["numberOfPlannedDeliveries"] : <any>null;
            this.lastDeliveryDate = _data["lastDeliveryDate"] ? moment(_data["lastDeliveryDate"].toString()) : <any>null;
            this.receivedAPatch = _data["receivedAPatch"] !== undefined ? _data["receivedAPatch"] : <any>null;
            this.orderDate = _data["orderDate"] ? moment(_data["orderDate"].toString()) : <any>null;
            this.firstDeliveryDate = _data["firstDeliveryDate"] ? moment(_data["firstDeliveryDate"].toString()) : <any>null;
            this.numberOfMonths = _data["numberOfMonths"] !== undefined ? _data["numberOfMonths"] : <any>null;
            this.numberOfMonthsForNextDelivery = _data["numberOfMonthsForNextDelivery"] !== undefined ? _data["numberOfMonthsForNextDelivery"] : <any>null;
            this.percentOfPaidOrder = _data["percentOfPaidOrder"] !== undefined ? _data["percentOfPaidOrder"] : <any>null;
            this.ppmContractNotFound = _data["ppmContractNotFound"] !== undefined ? _data["ppmContractNotFound"] : <any>null;
            this.hasUnpaidNsfs = _data["hasUnpaidNsfs"] !== undefined ? _data["hasUnpaidNsfs"] : <any>null;
            this.nextDeliveryDueDate = _data["nextDeliveryDueDate"] ? moment(_data["nextDeliveryDueDate"].toString()) : <any>null;
        }
    }

    static fromJS(data: any): NextDeliveryTaskDto {
        data = typeof data === 'object' ? data : {};
        let result = new NextDeliveryTaskDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clientNo"] = this.clientNo !== undefined ? this.clientNo : <any>null;
        data["orderNo"] = this.orderNo !== undefined ? this.orderNo : <any>null;
        data["city"] = this.city !== undefined ? this.city : <any>null;
        data["rang"] = this.rang !== undefined ? this.rang : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["email"] = this.email !== undefined ? this.email : <any>null;
        data["numberOfPlannedDeliveries"] = this.numberOfPlannedDeliveries !== undefined ? this.numberOfPlannedDeliveries : <any>null;
        data["lastDeliveryDate"] = this.lastDeliveryDate ? this.lastDeliveryDate.toISOString() : <any>null;
        data["receivedAPatch"] = this.receivedAPatch !== undefined ? this.receivedAPatch : <any>null;
        data["orderDate"] = this.orderDate ? this.orderDate.toISOString() : <any>null;
        data["firstDeliveryDate"] = this.firstDeliveryDate ? this.firstDeliveryDate.toISOString() : <any>null;
        data["numberOfMonths"] = this.numberOfMonths !== undefined ? this.numberOfMonths : <any>null;
        data["numberOfMonthsForNextDelivery"] = this.numberOfMonthsForNextDelivery !== undefined ? this.numberOfMonthsForNextDelivery : <any>null;
        data["percentOfPaidOrder"] = this.percentOfPaidOrder !== undefined ? this.percentOfPaidOrder : <any>null;
        data["ppmContractNotFound"] = this.ppmContractNotFound !== undefined ? this.ppmContractNotFound : <any>null;
        data["hasUnpaidNsfs"] = this.hasUnpaidNsfs !== undefined ? this.hasUnpaidNsfs : <any>null;
        data["nextDeliveryDueDate"] = this.nextDeliveryDueDate ? this.nextDeliveryDueDate.toISOString() : <any>null;
        return data;
    }
}

export interface INextDeliveryTaskDto {
    clientNo?: number;
    orderNo?: number;
    city?: string | null;
    rang?: number;
    name?: string | null;
    email?: string | null;
    numberOfPlannedDeliveries?: number;
    lastDeliveryDate?: moment.Moment;
    receivedAPatch?: boolean;
    orderDate?: moment.Moment;
    firstDeliveryDate?: moment.Moment;
    numberOfMonths?: number;
    numberOfMonthsForNextDelivery?: number;
    percentOfPaidOrder?: number;
    ppmContractNotFound?: boolean;
    hasUnpaidNsfs?: boolean;
    nextDeliveryDueDate?: moment.Moment;
}

export class GetNextDeliveryTasksWithinDateRangeQuery implements IGetNextDeliveryTasksWithinDateRangeQuery {
    fromDueDate?: moment.Moment;
    toDueDate?: moment.Moment;

    constructor(data?: IGetNextDeliveryTasksWithinDateRangeQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fromDueDate = _data["fromDueDate"] ? moment(_data["fromDueDate"].toString()) : <any>null;
            this.toDueDate = _data["toDueDate"] ? moment(_data["toDueDate"].toString()) : <any>null;
        }
    }

    static fromJS(data: any): GetNextDeliveryTasksWithinDateRangeQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetNextDeliveryTasksWithinDateRangeQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fromDueDate"] = this.fromDueDate ? this.fromDueDate.toISOString() : <any>null;
        data["toDueDate"] = this.toDueDate ? this.toDueDate.toISOString() : <any>null;
        return data;
    }
}

export interface IGetNextDeliveryTasksWithinDateRangeQuery {
    fromDueDate?: moment.Moment;
    toDueDate?: moment.Moment;
}

export class ImportNextDeliveryTasksCommand implements IImportNextDeliveryTasksCommand {
    nextDeliveryTasks?: NextDeliveryTaskDto[] | null;

    constructor(data?: IImportNextDeliveryTasksCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["nextDeliveryTasks"])) {
                this.nextDeliveryTasks = [] as any;
                for (let item of _data["nextDeliveryTasks"])
                    this.nextDeliveryTasks!.push(NextDeliveryTaskDto.fromJS(item));
            }
            else {
                this.nextDeliveryTasks = <any>null;
            }
        }
    }

    static fromJS(data: any): ImportNextDeliveryTasksCommand {
        data = typeof data === 'object' ? data : {};
        let result = new ImportNextDeliveryTasksCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.nextDeliveryTasks)) {
            data["nextDeliveryTasks"] = [];
            for (let item of this.nextDeliveryTasks)
                data["nextDeliveryTasks"].push(item.toJSON());
        }
        return data;
    }
}

export interface IImportNextDeliveryTasksCommand {
    nextDeliveryTasks?: NextDeliveryTaskDto[] | null;
}

export class ClientNextDeliveryTaskDto extends BaseClientLeadDto implements IClientNextDeliveryTaskDto {
    id?: number;
    clientNo?: number;
    city?: string | null;
    rang?: number;
    numberOfPlannedDeliveries?: number;
    percentOfPaidOrder?: number;
    hasUnpaidNsfs?: boolean;
    lastDeliveryDate?: moment.Moment;
    receivedPatch?: boolean;
    status?: ClientNextDeliveryTaskStatus;
    nextDeliveryReminderDate?: moment.Moment;

    constructor(data?: IClientNextDeliveryTaskDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.clientNo = _data["clientNo"] !== undefined ? _data["clientNo"] : <any>null;
            this.city = _data["city"] !== undefined ? _data["city"] : <any>null;
            this.rang = _data["rang"] !== undefined ? _data["rang"] : <any>null;
            this.numberOfPlannedDeliveries = _data["numberOfPlannedDeliveries"] !== undefined ? _data["numberOfPlannedDeliveries"] : <any>null;
            this.percentOfPaidOrder = _data["percentOfPaidOrder"] !== undefined ? _data["percentOfPaidOrder"] : <any>null;
            this.hasUnpaidNsfs = _data["hasUnpaidNsfs"] !== undefined ? _data["hasUnpaidNsfs"] : <any>null;
            this.lastDeliveryDate = _data["lastDeliveryDate"] ? moment(_data["lastDeliveryDate"].toString()) : <any>null;
            this.receivedPatch = _data["receivedPatch"] !== undefined ? _data["receivedPatch"] : <any>null;
            this.status = _data["status"] !== undefined ? _data["status"] : <any>null;
            this.nextDeliveryReminderDate = _data["nextDeliveryReminderDate"] ? moment(_data["nextDeliveryReminderDate"].toString()) : <any>null;
        }
    }

    static override fromJS(data: any): ClientNextDeliveryTaskDto {
        data = typeof data === 'object' ? data : {};
        let result = new ClientNextDeliveryTaskDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["clientNo"] = this.clientNo !== undefined ? this.clientNo : <any>null;
        data["city"] = this.city !== undefined ? this.city : <any>null;
        data["rang"] = this.rang !== undefined ? this.rang : <any>null;
        data["numberOfPlannedDeliveries"] = this.numberOfPlannedDeliveries !== undefined ? this.numberOfPlannedDeliveries : <any>null;
        data["percentOfPaidOrder"] = this.percentOfPaidOrder !== undefined ? this.percentOfPaidOrder : <any>null;
        data["hasUnpaidNsfs"] = this.hasUnpaidNsfs !== undefined ? this.hasUnpaidNsfs : <any>null;
        data["lastDeliveryDate"] = this.lastDeliveryDate ? this.lastDeliveryDate.toISOString() : <any>null;
        data["receivedPatch"] = this.receivedPatch !== undefined ? this.receivedPatch : <any>null;
        data["status"] = this.status !== undefined ? this.status : <any>null;
        data["nextDeliveryReminderDate"] = this.nextDeliveryReminderDate ? this.nextDeliveryReminderDate.toISOString() : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IClientNextDeliveryTaskDto extends IBaseClientLeadDto {
    id?: number;
    clientNo?: number;
    city?: string | null;
    rang?: number;
    numberOfPlannedDeliveries?: number;
    percentOfPaidOrder?: number;
    hasUnpaidNsfs?: boolean;
    lastDeliveryDate?: moment.Moment;
    receivedPatch?: boolean;
    status?: ClientNextDeliveryTaskStatus;
    nextDeliveryReminderDate?: moment.Moment;
}

export class AssignEmployeeClientNextDeliveryTaskCommand implements IAssignEmployeeClientNextDeliveryTaskCommand {
    employeeId?: string | null;
    clientNextDeliveryTasksId?: number[] | null;

    constructor(data?: IAssignEmployeeClientNextDeliveryTaskCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.employeeId = _data["employeeId"] !== undefined ? _data["employeeId"] : <any>null;
            if (Array.isArray(_data["clientNextDeliveryTasksId"])) {
                this.clientNextDeliveryTasksId = [] as any;
                for (let item of _data["clientNextDeliveryTasksId"])
                    this.clientNextDeliveryTasksId!.push(item);
            }
            else {
                this.clientNextDeliveryTasksId = <any>null;
            }
        }
    }

    static fromJS(data: any): AssignEmployeeClientNextDeliveryTaskCommand {
        data = typeof data === 'object' ? data : {};
        let result = new AssignEmployeeClientNextDeliveryTaskCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["employeeId"] = this.employeeId !== undefined ? this.employeeId : <any>null;
        if (Array.isArray(this.clientNextDeliveryTasksId)) {
            data["clientNextDeliveryTasksId"] = [];
            for (let item of this.clientNextDeliveryTasksId)
                data["clientNextDeliveryTasksId"].push(item);
        }
        return data;
    }
}

export interface IAssignEmployeeClientNextDeliveryTaskCommand {
    employeeId?: string | null;
    clientNextDeliveryTasksId?: number[] | null;
}

export class UnassignEmployeeClientNextDeliveryTaskCommand implements IUnassignEmployeeClientNextDeliveryTaskCommand {
    clientNextDeliveryTasksId?: number[] | null;

    constructor(data?: IUnassignEmployeeClientNextDeliveryTaskCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["clientNextDeliveryTasksId"])) {
                this.clientNextDeliveryTasksId = [] as any;
                for (let item of _data["clientNextDeliveryTasksId"])
                    this.clientNextDeliveryTasksId!.push(item);
            }
            else {
                this.clientNextDeliveryTasksId = <any>null;
            }
        }
    }

    static fromJS(data: any): UnassignEmployeeClientNextDeliveryTaskCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UnassignEmployeeClientNextDeliveryTaskCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.clientNextDeliveryTasksId)) {
            data["clientNextDeliveryTasksId"] = [];
            for (let item of this.clientNextDeliveryTasksId)
                data["clientNextDeliveryTasksId"].push(item);
        }
        return data;
    }
}

export interface IUnassignEmployeeClientNextDeliveryTaskCommand {
    clientNextDeliveryTasksId?: number[] | null;
}

export class ClientNextDeliveryTaskNoteDto implements IClientNextDeliveryTaskNoteDto {
    id?: string | null;
    noteType?: ClientNextDeliveryTaskNoteType;
    subject?: string | null;
    description?: string | null;
    createdByEmployee?: LookUpEmployeeViewModel | null;
    createdByEmployeeId?: string | null;
    followUpDateTime?: moment.Moment | null;
    createdDateTime?: moment.Moment;
    lastUpdatedById?: string | null;
    clientNextDeliveryTaskId?: number;

    constructor(data?: IClientNextDeliveryTaskNoteDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.noteType = _data["noteType"] !== undefined ? _data["noteType"] : <any>null;
            this.subject = _data["subject"] !== undefined ? _data["subject"] : <any>null;
            this.description = _data["description"] !== undefined ? _data["description"] : <any>null;
            this.createdByEmployee = _data["createdByEmployee"] ? LookUpEmployeeViewModel.fromJS(_data["createdByEmployee"]) : <any>null;
            this.createdByEmployeeId = _data["createdByEmployeeId"] !== undefined ? _data["createdByEmployeeId"] : <any>null;
            this.followUpDateTime = _data["followUpDateTime"] ? moment(_data["followUpDateTime"].toString()) : <any>null;
            this.createdDateTime = _data["createdDateTime"] ? moment(_data["createdDateTime"].toString()) : <any>null;
            this.lastUpdatedById = _data["lastUpdatedById"] !== undefined ? _data["lastUpdatedById"] : <any>null;
            this.clientNextDeliveryTaskId = _data["clientNextDeliveryTaskId"] !== undefined ? _data["clientNextDeliveryTaskId"] : <any>null;
        }
    }

    static fromJS(data: any): ClientNextDeliveryTaskNoteDto {
        data = typeof data === 'object' ? data : {};
        let result = new ClientNextDeliveryTaskNoteDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["noteType"] = this.noteType !== undefined ? this.noteType : <any>null;
        data["subject"] = this.subject !== undefined ? this.subject : <any>null;
        data["description"] = this.description !== undefined ? this.description : <any>null;
        data["createdByEmployee"] = this.createdByEmployee ? this.createdByEmployee.toJSON() : <any>null;
        data["createdByEmployeeId"] = this.createdByEmployeeId !== undefined ? this.createdByEmployeeId : <any>null;
        data["followUpDateTime"] = this.followUpDateTime ? this.followUpDateTime.toISOString() : <any>null;
        data["createdDateTime"] = this.createdDateTime ? this.createdDateTime.toISOString() : <any>null;
        data["lastUpdatedById"] = this.lastUpdatedById !== undefined ? this.lastUpdatedById : <any>null;
        data["clientNextDeliveryTaskId"] = this.clientNextDeliveryTaskId !== undefined ? this.clientNextDeliveryTaskId : <any>null;
        return data;
    }
}

export interface IClientNextDeliveryTaskNoteDto {
    id?: string | null;
    noteType?: ClientNextDeliveryTaskNoteType;
    subject?: string | null;
    description?: string | null;
    createdByEmployee?: LookUpEmployeeViewModel | null;
    createdByEmployeeId?: string | null;
    followUpDateTime?: moment.Moment | null;
    createdDateTime?: moment.Moment;
    lastUpdatedById?: string | null;
    clientNextDeliveryTaskId?: number;
}

export enum ClientNextDeliveryTaskNoteType {
    FollowUp = "followUp",
    Comment = "comment",
    StandBy = "standBy",
}

export class AddClientNextDeliveryTaskNoteCommand implements IAddClientNextDeliveryTaskNoteCommand {
    description?: string | null;
    subject?: string | null;
    noteType?: ClientNextDeliveryTaskNoteType;
    insertLegacyNote?: boolean;
    followUpDateTime?: moment.Moment | null;

    constructor(data?: IAddClientNextDeliveryTaskNoteCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.description = _data["description"] !== undefined ? _data["description"] : <any>null;
            this.subject = _data["subject"] !== undefined ? _data["subject"] : <any>null;
            this.noteType = _data["noteType"] !== undefined ? _data["noteType"] : <any>null;
            this.insertLegacyNote = _data["insertLegacyNote"] !== undefined ? _data["insertLegacyNote"] : <any>null;
            this.followUpDateTime = _data["followUpDateTime"] ? moment(_data["followUpDateTime"].toString()) : <any>null;
        }
    }

    static fromJS(data: any): AddClientNextDeliveryTaskNoteCommand {
        data = typeof data === 'object' ? data : {};
        let result = new AddClientNextDeliveryTaskNoteCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description !== undefined ? this.description : <any>null;
        data["subject"] = this.subject !== undefined ? this.subject : <any>null;
        data["noteType"] = this.noteType !== undefined ? this.noteType : <any>null;
        data["insertLegacyNote"] = this.insertLegacyNote !== undefined ? this.insertLegacyNote : <any>null;
        data["followUpDateTime"] = this.followUpDateTime ? this.followUpDateTime.toISOString() : <any>null;
        return data;
    }
}

export interface IAddClientNextDeliveryTaskNoteCommand {
    description?: string | null;
    subject?: string | null;
    noteType?: ClientNextDeliveryTaskNoteType;
    insertLegacyNote?: boolean;
    followUpDateTime?: moment.Moment | null;
}

export class EditClientNextDeliveryTaskNoteCommand implements IEditClientNextDeliveryTaskNoteCommand {
    description?: string | null;
    subject?: string | null;
    noteType?: ClientNextDeliveryTaskNoteType;
    followUpDateTime?: moment.Moment | null;

    constructor(data?: IEditClientNextDeliveryTaskNoteCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.description = _data["description"] !== undefined ? _data["description"] : <any>null;
            this.subject = _data["subject"] !== undefined ? _data["subject"] : <any>null;
            this.noteType = _data["noteType"] !== undefined ? _data["noteType"] : <any>null;
            this.followUpDateTime = _data["followUpDateTime"] ? moment(_data["followUpDateTime"].toString()) : <any>null;
        }
    }

    static fromJS(data: any): EditClientNextDeliveryTaskNoteCommand {
        data = typeof data === 'object' ? data : {};
        let result = new EditClientNextDeliveryTaskNoteCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description !== undefined ? this.description : <any>null;
        data["subject"] = this.subject !== undefined ? this.subject : <any>null;
        data["noteType"] = this.noteType !== undefined ? this.noteType : <any>null;
        data["followUpDateTime"] = this.followUpDateTime ? this.followUpDateTime.toISOString() : <any>null;
        return data;
    }
}

export interface IEditClientNextDeliveryTaskNoteCommand {
    description?: string | null;
    subject?: string | null;
    noteType?: ClientNextDeliveryTaskNoteType;
    followUpDateTime?: moment.Moment | null;
}

export class PaginatedResultOfClientLookupDto extends PaginatedResult implements IPaginatedResultOfClientLookupDto {
    entities?: ClientLookupDto[] | null;

    constructor(data?: IPaginatedResultOfClientLookupDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["entities"])) {
                this.entities = [] as any;
                for (let item of _data["entities"])
                    this.entities!.push(ClientLookupDto.fromJS(item));
            }
            else {
                this.entities = <any>null;
            }
        }
    }

    static override fromJS(data: any): PaginatedResultOfClientLookupDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResultOfClientLookupDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.entities)) {
            data["entities"] = [];
            for (let item of this.entities)
                data["entities"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IPaginatedResultOfClientLookupDto extends IPaginatedResult {
    entities?: ClientLookupDto[] | null;
}

export class ClientLookupDto implements IClientLookupDto {
    index?: number;
    id?: string | null;
    clientNo?: number | null;
    name?: string | null;
    email?: string | null;
    phoneNumber?: string | null;

    constructor(data?: IClientLookupDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.index = _data["index"] !== undefined ? _data["index"] : <any>null;
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.clientNo = _data["clientNo"] !== undefined ? _data["clientNo"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.email = _data["email"] !== undefined ? _data["email"] : <any>null;
            this.phoneNumber = _data["phoneNumber"] !== undefined ? _data["phoneNumber"] : <any>null;
        }
    }

    static fromJS(data: any): ClientLookupDto {
        data = typeof data === 'object' ? data : {};
        let result = new ClientLookupDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["index"] = this.index !== undefined ? this.index : <any>null;
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["clientNo"] = this.clientNo !== undefined ? this.clientNo : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["email"] = this.email !== undefined ? this.email : <any>null;
        data["phoneNumber"] = this.phoneNumber !== undefined ? this.phoneNumber : <any>null;
        return data;
    }
}

export interface IClientLookupDto {
    index?: number;
    id?: string | null;
    clientNo?: number | null;
    name?: string | null;
    email?: string | null;
    phoneNumber?: string | null;
}

export class GetClientsListQuery extends PaginationModel implements IGetClientsListQuery {
    user?: ClaimsPrincipal | null;

    constructor(data?: IGetClientsListQuery) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.user = _data["user"] ? ClaimsPrincipal.fromJS(_data["user"]) : <any>null;
        }
    }

    static override fromJS(data: any): GetClientsListQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetClientsListQuery();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["user"] = this.user ? this.user.toJSON() : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IGetClientsListQuery extends IPaginationModel {
    user?: ClaimsPrincipal | null;
}

export class ClientDto extends UserDto implements IClientDto {
    clientNumber!: number;
    notes?: string | null;
    languageType?: LanguageType;
    hasNoEmail?: boolean | null;
    conjoint?: ConjointDto | null;
    specialInstructions?: string | null;
    deliveryComments?: string | null;
    confirmationNotes?: string | null;
    workPhoneNumber?: string | null;
    cellPhoneNumber?: string | null;
    occupation?: string | null;

    constructor(data?: IClientDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.clientNumber = _data["clientNumber"] !== undefined ? _data["clientNumber"] : <any>null;
            this.notes = _data["notes"] !== undefined ? _data["notes"] : <any>null;
            this.languageType = _data["languageType"] !== undefined ? _data["languageType"] : <any>null;
            this.hasNoEmail = _data["hasNoEmail"] !== undefined ? _data["hasNoEmail"] : <any>null;
            this.conjoint = _data["conjoint"] ? ConjointDto.fromJS(_data["conjoint"]) : <any>null;
            this.specialInstructions = _data["specialInstructions"] !== undefined ? _data["specialInstructions"] : <any>null;
            this.deliveryComments = _data["deliveryComments"] !== undefined ? _data["deliveryComments"] : <any>null;
            this.confirmationNotes = _data["confirmationNotes"] !== undefined ? _data["confirmationNotes"] : <any>null;
            this.workPhoneNumber = _data["workPhoneNumber"] !== undefined ? _data["workPhoneNumber"] : <any>null;
            this.cellPhoneNumber = _data["cellPhoneNumber"] !== undefined ? _data["cellPhoneNumber"] : <any>null;
            this.occupation = _data["occupation"] !== undefined ? _data["occupation"] : <any>null;
        }
    }

    static override fromJS(data: any): ClientDto {
        data = typeof data === 'object' ? data : {};
        let result = new ClientDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clientNumber"] = this.clientNumber !== undefined ? this.clientNumber : <any>null;
        data["notes"] = this.notes !== undefined ? this.notes : <any>null;
        data["languageType"] = this.languageType !== undefined ? this.languageType : <any>null;
        data["hasNoEmail"] = this.hasNoEmail !== undefined ? this.hasNoEmail : <any>null;
        data["conjoint"] = this.conjoint ? this.conjoint.toJSON() : <any>null;
        data["specialInstructions"] = this.specialInstructions !== undefined ? this.specialInstructions : <any>null;
        data["deliveryComments"] = this.deliveryComments !== undefined ? this.deliveryComments : <any>null;
        data["confirmationNotes"] = this.confirmationNotes !== undefined ? this.confirmationNotes : <any>null;
        data["workPhoneNumber"] = this.workPhoneNumber !== undefined ? this.workPhoneNumber : <any>null;
        data["cellPhoneNumber"] = this.cellPhoneNumber !== undefined ? this.cellPhoneNumber : <any>null;
        data["occupation"] = this.occupation !== undefined ? this.occupation : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IClientDto extends IUserDto {
    clientNumber: number;
    notes?: string | null;
    languageType?: LanguageType;
    hasNoEmail?: boolean | null;
    conjoint?: ConjointDto | null;
    specialInstructions?: string | null;
    deliveryComments?: string | null;
    confirmationNotes?: string | null;
    workPhoneNumber?: string | null;
    cellPhoneNumber?: string | null;
    occupation?: string | null;
}

export class ConjointDto implements IConjointDto {
    phoneNumber?: string | null;
    name?: string | null;
    extensionPhoneNumber?: string | null;
    email?: string | null;
    hasNoEmail?: boolean | null;
    language?: LanguageType;
    occupation?: string | null;

    constructor(data?: IConjointDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.phoneNumber = _data["phoneNumber"] !== undefined ? _data["phoneNumber"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.extensionPhoneNumber = _data["extensionPhoneNumber"] !== undefined ? _data["extensionPhoneNumber"] : <any>null;
            this.email = _data["email"] !== undefined ? _data["email"] : <any>null;
            this.hasNoEmail = _data["hasNoEmail"] !== undefined ? _data["hasNoEmail"] : <any>null;
            this.language = _data["language"] !== undefined ? _data["language"] : <any>null;
            this.occupation = _data["occupation"] !== undefined ? _data["occupation"] : <any>null;
        }
    }

    static fromJS(data: any): ConjointDto {
        data = typeof data === 'object' ? data : {};
        let result = new ConjointDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["phoneNumber"] = this.phoneNumber !== undefined ? this.phoneNumber : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["extensionPhoneNumber"] = this.extensionPhoneNumber !== undefined ? this.extensionPhoneNumber : <any>null;
        data["email"] = this.email !== undefined ? this.email : <any>null;
        data["hasNoEmail"] = this.hasNoEmail !== undefined ? this.hasNoEmail : <any>null;
        data["language"] = this.language !== undefined ? this.language : <any>null;
        data["occupation"] = this.occupation !== undefined ? this.occupation : <any>null;
        return data;
    }
}

export interface IConjointDto {
    phoneNumber?: string | null;
    name?: string | null;
    extensionPhoneNumber?: string | null;
    email?: string | null;
    hasNoEmail?: boolean | null;
    language?: LanguageType;
    occupation?: string | null;
}

export class ClientAndLastRepDto implements IClientAndLastRepDto {
    client?: ClientDto | null;
    lastRep?: SalesRepDto | null;

    constructor(data?: IClientAndLastRepDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.client = _data["client"] ? ClientDto.fromJS(_data["client"]) : <any>null;
            this.lastRep = _data["lastRep"] ? SalesRepDto.fromJS(_data["lastRep"]) : <any>null;
        }
    }

    static fromJS(data: any): ClientAndLastRepDto {
        data = typeof data === 'object' ? data : {};
        let result = new ClientAndLastRepDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["client"] = this.client ? this.client.toJSON() : <any>null;
        data["lastRep"] = this.lastRep ? this.lastRep.toJSON() : <any>null;
        return data;
    }
}

export interface IClientAndLastRepDto {
    client?: ClientDto | null;
    lastRep?: SalesRepDto | null;
}

export class PaginatedResultOfCreditTaskCampaignLookUpDto extends PaginatedResult implements IPaginatedResultOfCreditTaskCampaignLookUpDto {
    entities?: CreditTaskCampaignLookUpDto[] | null;

    constructor(data?: IPaginatedResultOfCreditTaskCampaignLookUpDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["entities"])) {
                this.entities = [] as any;
                for (let item of _data["entities"])
                    this.entities!.push(CreditTaskCampaignLookUpDto.fromJS(item));
            }
            else {
                this.entities = <any>null;
            }
        }
    }

    static override fromJS(data: any): PaginatedResultOfCreditTaskCampaignLookUpDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResultOfCreditTaskCampaignLookUpDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.entities)) {
            data["entities"] = [];
            for (let item of this.entities)
                data["entities"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IPaginatedResultOfCreditTaskCampaignLookUpDto extends IPaginatedResult {
    entities?: CreditTaskCampaignLookUpDto[] | null;
}

export class CreditTaskCampaignLookUpDto implements ICreditTaskCampaignLookUpDto {
    index?: number;
    type?: CreditTaskType;
    totalCreditTasks?: number;
    totalOpenCreditTasks?: number;
    percentageOfOpenCreditTasks?: number;
    totalResolvedCreditTasks?: number;
    percentageOfResolvedClientLeads?: number;
    totalAgents?: number;

    constructor(data?: ICreditTaskCampaignLookUpDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.index = _data["index"] !== undefined ? _data["index"] : <any>null;
            this.type = _data["type"] !== undefined ? _data["type"] : <any>null;
            this.totalCreditTasks = _data["totalCreditTasks"] !== undefined ? _data["totalCreditTasks"] : <any>null;
            this.totalOpenCreditTasks = _data["totalOpenCreditTasks"] !== undefined ? _data["totalOpenCreditTasks"] : <any>null;
            this.percentageOfOpenCreditTasks = _data["percentageOfOpenCreditTasks"] !== undefined ? _data["percentageOfOpenCreditTasks"] : <any>null;
            this.totalResolvedCreditTasks = _data["totalResolvedCreditTasks"] !== undefined ? _data["totalResolvedCreditTasks"] : <any>null;
            this.percentageOfResolvedClientLeads = _data["percentageOfResolvedClientLeads"] !== undefined ? _data["percentageOfResolvedClientLeads"] : <any>null;
            this.totalAgents = _data["totalAgents"] !== undefined ? _data["totalAgents"] : <any>null;
        }
    }

    static fromJS(data: any): CreditTaskCampaignLookUpDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreditTaskCampaignLookUpDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["index"] = this.index !== undefined ? this.index : <any>null;
        data["type"] = this.type !== undefined ? this.type : <any>null;
        data["totalCreditTasks"] = this.totalCreditTasks !== undefined ? this.totalCreditTasks : <any>null;
        data["totalOpenCreditTasks"] = this.totalOpenCreditTasks !== undefined ? this.totalOpenCreditTasks : <any>null;
        data["percentageOfOpenCreditTasks"] = this.percentageOfOpenCreditTasks !== undefined ? this.percentageOfOpenCreditTasks : <any>null;
        data["totalResolvedCreditTasks"] = this.totalResolvedCreditTasks !== undefined ? this.totalResolvedCreditTasks : <any>null;
        data["percentageOfResolvedClientLeads"] = this.percentageOfResolvedClientLeads !== undefined ? this.percentageOfResolvedClientLeads : <any>null;
        data["totalAgents"] = this.totalAgents !== undefined ? this.totalAgents : <any>null;
        return data;
    }
}

export interface ICreditTaskCampaignLookUpDto {
    index?: number;
    type?: CreditTaskType;
    totalCreditTasks?: number;
    totalOpenCreditTasks?: number;
    percentageOfOpenCreditTasks?: number;
    totalResolvedCreditTasks?: number;
    percentageOfResolvedClientLeads?: number;
    totalAgents?: number;
}

export class GetCreditTaskCampaignListQuery extends PaginationModel implements IGetCreditTaskCampaignListQuery {
    hasOpenCreditTasks?: boolean;
    hasResolvedCreditTasks?: boolean;
    hasAssociatedAgents?: boolean;
    hasNoAssociatedAgents?: boolean;
    hasNoCreditTasks?: boolean;

    constructor(data?: IGetCreditTaskCampaignListQuery) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.hasOpenCreditTasks = _data["hasOpenCreditTasks"] !== undefined ? _data["hasOpenCreditTasks"] : <any>null;
            this.hasResolvedCreditTasks = _data["hasResolvedCreditTasks"] !== undefined ? _data["hasResolvedCreditTasks"] : <any>null;
            this.hasAssociatedAgents = _data["hasAssociatedAgents"] !== undefined ? _data["hasAssociatedAgents"] : <any>null;
            this.hasNoAssociatedAgents = _data["hasNoAssociatedAgents"] !== undefined ? _data["hasNoAssociatedAgents"] : <any>null;
            this.hasNoCreditTasks = _data["hasNoCreditTasks"] !== undefined ? _data["hasNoCreditTasks"] : <any>null;
        }
    }

    static override fromJS(data: any): GetCreditTaskCampaignListQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetCreditTaskCampaignListQuery();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["hasOpenCreditTasks"] = this.hasOpenCreditTasks !== undefined ? this.hasOpenCreditTasks : <any>null;
        data["hasResolvedCreditTasks"] = this.hasResolvedCreditTasks !== undefined ? this.hasResolvedCreditTasks : <any>null;
        data["hasAssociatedAgents"] = this.hasAssociatedAgents !== undefined ? this.hasAssociatedAgents : <any>null;
        data["hasNoAssociatedAgents"] = this.hasNoAssociatedAgents !== undefined ? this.hasNoAssociatedAgents : <any>null;
        data["hasNoCreditTasks"] = this.hasNoCreditTasks !== undefined ? this.hasNoCreditTasks : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IGetCreditTaskCampaignListQuery extends IPaginationModel {
    hasOpenCreditTasks?: boolean;
    hasResolvedCreditTasks?: boolean;
    hasAssociatedAgents?: boolean;
    hasNoAssociatedAgents?: boolean;
    hasNoCreditTasks?: boolean;
}

export class PaginatedResultOfAgentCreditTasksDto extends PaginatedResult implements IPaginatedResultOfAgentCreditTasksDto {
    entities?: AgentCreditTasksDto[] | null;

    constructor(data?: IPaginatedResultOfAgentCreditTasksDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["entities"])) {
                this.entities = [] as any;
                for (let item of _data["entities"])
                    this.entities!.push(AgentCreditTasksDto.fromJS(item));
            }
            else {
                this.entities = <any>null;
            }
        }
    }

    static override fromJS(data: any): PaginatedResultOfAgentCreditTasksDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResultOfAgentCreditTasksDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.entities)) {
            data["entities"] = [];
            for (let item of this.entities)
                data["entities"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IPaginatedResultOfAgentCreditTasksDto extends IPaginatedResult {
    entities?: AgentCreditTasksDto[] | null;
}

export class AgentCreditTasksDto implements IAgentCreditTasksDto {
    index?: number;
    id?: string | null;
    name?: string | null;
    totalCreditTasks?: number;

    constructor(data?: IAgentCreditTasksDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.index = _data["index"] !== undefined ? _data["index"] : <any>null;
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.totalCreditTasks = _data["totalCreditTasks"] !== undefined ? _data["totalCreditTasks"] : <any>null;
        }
    }

    static fromJS(data: any): AgentCreditTasksDto {
        data = typeof data === 'object' ? data : {};
        let result = new AgentCreditTasksDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["index"] = this.index !== undefined ? this.index : <any>null;
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["totalCreditTasks"] = this.totalCreditTasks !== undefined ? this.totalCreditTasks : <any>null;
        return data;
    }
}

export interface IAgentCreditTasksDto {
    index?: number;
    id?: string | null;
    name?: string | null;
    totalCreditTasks?: number;
}

export class GetAgentCreditTaskListQuery extends PaginationModel implements IGetAgentCreditTaskListQuery {

    constructor(data?: IGetAgentCreditTaskListQuery) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): GetAgentCreditTaskListQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetAgentCreditTaskListQuery();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IGetAgentCreditTaskListQuery extends IPaginationModel {
}

export class CreditTaskCampaignAgentsDto implements ICreditTaskCampaignAgentsDto {
    type?: CreditTaskType;
    associatedAgents?: EmployeeDto[] | null;

    constructor(data?: ICreditTaskCampaignAgentsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"] !== undefined ? _data["type"] : <any>null;
            if (Array.isArray(_data["associatedAgents"])) {
                this.associatedAgents = [] as any;
                for (let item of _data["associatedAgents"])
                    this.associatedAgents!.push(EmployeeDto.fromJS(item));
            }
            else {
                this.associatedAgents = <any>null;
            }
        }
    }

    static fromJS(data: any): CreditTaskCampaignAgentsDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreditTaskCampaignAgentsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type !== undefined ? this.type : <any>null;
        if (Array.isArray(this.associatedAgents)) {
            data["associatedAgents"] = [];
            for (let item of this.associatedAgents)
                data["associatedAgents"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICreditTaskCampaignAgentsDto {
    type?: CreditTaskType;
    associatedAgents?: EmployeeDto[] | null;
}

export class AssignAgentsToCreditTaskCampaignCommand implements IAssignAgentsToCreditTaskCampaignCommand {
    type?: CreditTaskType;
    associatedAgents?: EmployeeDto[] | null;

    constructor(data?: IAssignAgentsToCreditTaskCampaignCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"] !== undefined ? _data["type"] : <any>null;
            if (Array.isArray(_data["associatedAgents"])) {
                this.associatedAgents = [] as any;
                for (let item of _data["associatedAgents"])
                    this.associatedAgents!.push(EmployeeDto.fromJS(item));
            }
            else {
                this.associatedAgents = <any>null;
            }
        }
    }

    static fromJS(data: any): AssignAgentsToCreditTaskCampaignCommand {
        data = typeof data === 'object' ? data : {};
        let result = new AssignAgentsToCreditTaskCampaignCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type !== undefined ? this.type : <any>null;
        if (Array.isArray(this.associatedAgents)) {
            data["associatedAgents"] = [];
            for (let item of this.associatedAgents)
                data["associatedAgents"].push(item.toJSON());
        }
        return data;
    }
}

export interface IAssignAgentsToCreditTaskCampaignCommand {
    type?: CreditTaskType;
    associatedAgents?: EmployeeDto[] | null;
}

export class ConsolidateAllFailedOrNsfCreditTasksCommand implements IConsolidateAllFailedOrNsfCreditTasksCommand {

    constructor(data?: IConsolidateAllFailedOrNsfCreditTasksCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): ConsolidateAllFailedOrNsfCreditTasksCommand {
        data = typeof data === 'object' ? data : {};
        let result = new ConsolidateAllFailedOrNsfCreditTasksCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IConsolidateAllFailedOrNsfCreditTasksCommand {
}

export class DispatchedAppointmentCommand implements IDispatchedAppointmentCommand {
    callNo?: number;
    dispatchType?: AppointmentDispatchType;
    isRemoteOrder?: boolean;
    isSnowBirdOrder?: boolean;

    constructor(data?: IDispatchedAppointmentCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.callNo = _data["callNo"] !== undefined ? _data["callNo"] : <any>null;
            this.dispatchType = _data["dispatchType"] !== undefined ? _data["dispatchType"] : <any>null;
            this.isRemoteOrder = _data["isRemoteOrder"] !== undefined ? _data["isRemoteOrder"] : <any>null;
            this.isSnowBirdOrder = _data["isSnowBirdOrder"] !== undefined ? _data["isSnowBirdOrder"] : <any>null;
        }
    }

    static fromJS(data: any): DispatchedAppointmentCommand {
        data = typeof data === 'object' ? data : {};
        let result = new DispatchedAppointmentCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["callNo"] = this.callNo !== undefined ? this.callNo : <any>null;
        data["dispatchType"] = this.dispatchType !== undefined ? this.dispatchType : <any>null;
        data["isRemoteOrder"] = this.isRemoteOrder !== undefined ? this.isRemoteOrder : <any>null;
        data["isSnowBirdOrder"] = this.isSnowBirdOrder !== undefined ? this.isSnowBirdOrder : <any>null;
        return data;
    }
}

export interface IDispatchedAppointmentCommand {
    callNo?: number;
    dispatchType?: AppointmentDispatchType;
    isRemoteOrder?: boolean;
    isSnowBirdOrder?: boolean;
}

export class GetEmployeesListQuery implements IGetEmployeesListQuery {
    assignedRoles?: string[] | null;

    constructor(data?: IGetEmployeesListQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["assignedRoles"])) {
                this.assignedRoles = [] as any;
                for (let item of _data["assignedRoles"])
                    this.assignedRoles!.push(item);
            }
            else {
                this.assignedRoles = <any>null;
            }
        }
    }

    static fromJS(data: any): GetEmployeesListQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetEmployeesListQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.assignedRoles)) {
            data["assignedRoles"] = [];
            for (let item of this.assignedRoles)
                data["assignedRoles"].push(item);
        }
        return data;
    }
}

export interface IGetEmployeesListQuery {
    assignedRoles?: string[] | null;
}

export class EditEmployeeCommand implements IEditEmployeeCommand {
    employeeDto?: EmployeeDto | null;

    constructor(data?: IEditEmployeeCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.employeeDto = _data["employeeDto"] ? EmployeeDto.fromJS(_data["employeeDto"]) : <any>null;
        }
    }

    static fromJS(data: any): EditEmployeeCommand {
        data = typeof data === 'object' ? data : {};
        let result = new EditEmployeeCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["employeeDto"] = this.employeeDto ? this.employeeDto.toJSON() : <any>null;
        return data;
    }
}

export interface IEditEmployeeCommand {
    employeeDto?: EmployeeDto | null;
}

export class PaginatedResultOfCommandeErpStatusDto extends PaginatedResult implements IPaginatedResultOfCommandeErpStatusDto {
    entities?: CommandeErpStatusDto[] | null;

    constructor(data?: IPaginatedResultOfCommandeErpStatusDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["entities"])) {
                this.entities = [] as any;
                for (let item of _data["entities"])
                    this.entities!.push(CommandeErpStatusDto.fromJS(item));
            }
            else {
                this.entities = <any>null;
            }
        }
    }

    static override fromJS(data: any): PaginatedResultOfCommandeErpStatusDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResultOfCommandeErpStatusDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.entities)) {
            data["entities"] = [];
            for (let item of this.entities)
                data["entities"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IPaginatedResultOfCommandeErpStatusDto extends IPaginatedResult {
    entities?: CommandeErpStatusDto[] | null;
}

export class CommandeErpStatusDto implements ICommandeErpStatusDto {
    noCommande?: number;
    noClient?: number;
    dateCommande?: moment.Moment | null;
    erpCommandeImports?: ERPCommandeImportDto[] | null;
    tenantErpCommandeImport?: ERPCommandeImportDto | null;
    confFinancement?: boolean | null;

    constructor(data?: ICommandeErpStatusDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.noCommande = _data["noCommande"] !== undefined ? _data["noCommande"] : <any>null;
            this.noClient = _data["noClient"] !== undefined ? _data["noClient"] : <any>null;
            this.dateCommande = _data["dateCommande"] ? moment(_data["dateCommande"].toString()) : <any>null;
            if (Array.isArray(_data["erpCommandeImports"])) {
                this.erpCommandeImports = [] as any;
                for (let item of _data["erpCommandeImports"])
                    this.erpCommandeImports!.push(ERPCommandeImportDto.fromJS(item));
            }
            else {
                this.erpCommandeImports = <any>null;
            }
            this.tenantErpCommandeImport = _data["tenantErpCommandeImport"] ? ERPCommandeImportDto.fromJS(_data["tenantErpCommandeImport"]) : <any>null;
            this.confFinancement = _data["confFinancement"] !== undefined ? _data["confFinancement"] : <any>null;
        }
    }

    static fromJS(data: any): CommandeErpStatusDto {
        data = typeof data === 'object' ? data : {};
        let result = new CommandeErpStatusDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["noCommande"] = this.noCommande !== undefined ? this.noCommande : <any>null;
        data["noClient"] = this.noClient !== undefined ? this.noClient : <any>null;
        data["dateCommande"] = this.dateCommande ? this.dateCommande.toISOString() : <any>null;
        if (Array.isArray(this.erpCommandeImports)) {
            data["erpCommandeImports"] = [];
            for (let item of this.erpCommandeImports)
                data["erpCommandeImports"].push(item.toJSON());
        }
        data["tenantErpCommandeImport"] = this.tenantErpCommandeImport ? this.tenantErpCommandeImport.toJSON() : <any>null;
        data["confFinancement"] = this.confFinancement !== undefined ? this.confFinancement : <any>null;
        return data;
    }
}

export interface ICommandeErpStatusDto {
    noCommande?: number;
    noClient?: number;
    dateCommande?: moment.Moment | null;
    erpCommandeImports?: ERPCommandeImportDto[] | null;
    tenantErpCommandeImport?: ERPCommandeImportDto | null;
    confFinancement?: boolean | null;
}

export class ERPCommandeImportDto implements IERPCommandeImportDto {
    id?: number;
    importException?: string | null;
    importSucceeded?: boolean;
    importedDateTime?: moment.Moment | null;
    importedIntoTenant?: string | null;
    commande?: Commande | null;
    noCommande?: number;
    noRoute?: number;

    constructor(data?: IERPCommandeImportDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.importException = _data["importException"] !== undefined ? _data["importException"] : <any>null;
            this.importSucceeded = _data["importSucceeded"] !== undefined ? _data["importSucceeded"] : <any>null;
            this.importedDateTime = _data["importedDateTime"] ? moment(_data["importedDateTime"].toString()) : <any>null;
            this.importedIntoTenant = _data["importedIntoTenant"] !== undefined ? _data["importedIntoTenant"] : <any>null;
            this.commande = _data["commande"] ? Commande.fromJS(_data["commande"]) : <any>null;
            this.noCommande = _data["noCommande"] !== undefined ? _data["noCommande"] : <any>null;
            this.noRoute = _data["noRoute"] !== undefined ? _data["noRoute"] : <any>null;
        }
    }

    static fromJS(data: any): ERPCommandeImportDto {
        data = typeof data === 'object' ? data : {};
        let result = new ERPCommandeImportDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["importException"] = this.importException !== undefined ? this.importException : <any>null;
        data["importSucceeded"] = this.importSucceeded !== undefined ? this.importSucceeded : <any>null;
        data["importedDateTime"] = this.importedDateTime ? this.importedDateTime.toISOString() : <any>null;
        data["importedIntoTenant"] = this.importedIntoTenant !== undefined ? this.importedIntoTenant : <any>null;
        data["commande"] = this.commande ? this.commande.toJSON() : <any>null;
        data["noCommande"] = this.noCommande !== undefined ? this.noCommande : <any>null;
        data["noRoute"] = this.noRoute !== undefined ? this.noRoute : <any>null;
        return data;
    }
}

export interface IERPCommandeImportDto {
    id?: number;
    importException?: string | null;
    importSucceeded?: boolean;
    importedDateTime?: moment.Moment | null;
    importedIntoTenant?: string | null;
    commande?: Commande | null;
    noCommande?: number;
    noRoute?: number;
}

export class Commande implements ICommande {
    noCommande?: number;
    noClient?: number;
    client?: Client2 | null;
    noVendeur?: number;
    dateCommande?: moment.Moment | null;
    nbremois?: number | null;
    renouvellement?: number | null;
    nbrelivraison?: string | null;
    tauxfraisfinancier?: number | null;
    livraisons?: Livraison[] | null;
    cie?: string | null;
    noAutorisation?: string | null;
    tauxfraisfincongel?: number | null;
    ciecongel?: string | null;
    manutention?: number | null;
    achatcoupon?: number | null;
    coupon?: number | null;
    couponcommentaire?: string | null;
    promotion?: number | null;
    promcommentaire?: string | null;
    escompte?: number | null;
    rachat?: number | null;
    rachatcommentaire?: string | null;
    rabaisPromosDescription?: string | null;
    paiementmensuel?: number | null;
    cadeauvendeur?: number | null;
    promotionvendeur?: number | null;
    tauxcommission?: number | null;
    reductionComm?: number | null;
    totalcommande?: number | null;
    estimateTotalCommande?: number | null;
    totalLv1?: number | null;
    totalLv2?: number | null;
    totalLv3?: number | null;
    totalLv4?: number | null;
    totalLv5?: number | null;
    totalLv6?: number | null;
    datePaiement?: string | null;
    tm?: string | null;
    dateTm?: moment.Moment | null;
    typeTm?: string | null;
    confType?: boolean | null;
    confTypeNom?: string | null;
    confTm?: boolean | null;
    confTmnom?: string | null;
    confFinancement?: boolean | null;
    confFinancementNom?: string | null;
    confVendeur?: boolean | null;
    confVendeurNom?: string | null;
    refTm?: string | null;
    dernierelivraison?: moment.Moment | null;
    commentaires?: string | null;
    annuler?: boolean;
    demi?: boolean | null;
    accepte?: number | null;
    accepteN?: number | null;
    confAccepteN?: boolean | null;
    confAccepteNnom?: string | null;
    ranglivraison?: number | null;
    estPatch?: boolean | null;
    nomtm?: string | null;
    vincent?: boolean | null;
    commisionrecu?: boolean | null;
    appontcommisionrecu?: boolean | null;
    noDistribution?: number | null;
    confDist?: boolean | null;
    confDistNom?: string | null;
    commentairePpa?: string | null;
    commentaireLivraison?: string | null;
    estNs?: boolean | null;
    enAttenteSc?: boolean | null;
    enAttenteApprobation?: boolean | null;
    changementPpa?: boolean | null;
    courrielLivr?: boolean | null;
    estImporteDansWebCrm?: boolean | null;
    selectedMenuId?: string | null;
    commItems?: CommItem[] | null;
    commCongelateurs?: CommCongelateur[] | null;
    commAppliances?: CommAppliance[] | null;
    estRemote?: boolean | null;
    docusignEnvelopeId?: string | null;
    envelopeStatus?: string | null;
    dateSigneParClient?: moment.Moment | null;
    estSigneParClient?: boolean;
    dateSigneParConjoint?: moment.Moment | null;
    signeParConjoint?: boolean;
    referencesGiven?: ReferencesTablette[] | null;
    referencesFromClientPortal?: boolean | null;
    appelTm?: AppelTm | null;
    tabletOrderNo?: number | null;
    tabletOrderId?: string | null;
    noAppelOrigin?: number | null;
    lastModified?: moment.Moment | null;
    estNouveauMenuSystem?: boolean | null;
    estClassique?: boolean;
    erpCommandeImports?: ERPCommandeImport[] | null;

    constructor(data?: ICommande) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.noCommande = _data["noCommande"] !== undefined ? _data["noCommande"] : <any>null;
            this.noClient = _data["noClient"] !== undefined ? _data["noClient"] : <any>null;
            this.client = _data["client"] ? Client2.fromJS(_data["client"]) : <any>null;
            this.noVendeur = _data["noVendeur"] !== undefined ? _data["noVendeur"] : <any>null;
            this.dateCommande = _data["dateCommande"] ? moment(_data["dateCommande"].toString()) : <any>null;
            this.nbremois = _data["nbremois"] !== undefined ? _data["nbremois"] : <any>null;
            this.renouvellement = _data["renouvellement"] !== undefined ? _data["renouvellement"] : <any>null;
            this.nbrelivraison = _data["nbrelivraison"] !== undefined ? _data["nbrelivraison"] : <any>null;
            this.tauxfraisfinancier = _data["tauxfraisfinancier"] !== undefined ? _data["tauxfraisfinancier"] : <any>null;
            if (Array.isArray(_data["livraisons"])) {
                this.livraisons = [] as any;
                for (let item of _data["livraisons"])
                    this.livraisons!.push(Livraison.fromJS(item));
            }
            else {
                this.livraisons = <any>null;
            }
            this.cie = _data["cie"] !== undefined ? _data["cie"] : <any>null;
            this.noAutorisation = _data["noAutorisation"] !== undefined ? _data["noAutorisation"] : <any>null;
            this.tauxfraisfincongel = _data["tauxfraisfincongel"] !== undefined ? _data["tauxfraisfincongel"] : <any>null;
            this.ciecongel = _data["ciecongel"] !== undefined ? _data["ciecongel"] : <any>null;
            this.manutention = _data["manutention"] !== undefined ? _data["manutention"] : <any>null;
            this.achatcoupon = _data["achatcoupon"] !== undefined ? _data["achatcoupon"] : <any>null;
            this.coupon = _data["coupon"] !== undefined ? _data["coupon"] : <any>null;
            this.couponcommentaire = _data["couponcommentaire"] !== undefined ? _data["couponcommentaire"] : <any>null;
            this.promotion = _data["promotion"] !== undefined ? _data["promotion"] : <any>null;
            this.promcommentaire = _data["promcommentaire"] !== undefined ? _data["promcommentaire"] : <any>null;
            this.escompte = _data["escompte"] !== undefined ? _data["escompte"] : <any>null;
            this.rachat = _data["rachat"] !== undefined ? _data["rachat"] : <any>null;
            this.rachatcommentaire = _data["rachatcommentaire"] !== undefined ? _data["rachatcommentaire"] : <any>null;
            this.rabaisPromosDescription = _data["rabaisPromosDescription"] !== undefined ? _data["rabaisPromosDescription"] : <any>null;
            this.paiementmensuel = _data["paiementmensuel"] !== undefined ? _data["paiementmensuel"] : <any>null;
            this.cadeauvendeur = _data["cadeauvendeur"] !== undefined ? _data["cadeauvendeur"] : <any>null;
            this.promotionvendeur = _data["promotionvendeur"] !== undefined ? _data["promotionvendeur"] : <any>null;
            this.tauxcommission = _data["tauxcommission"] !== undefined ? _data["tauxcommission"] : <any>null;
            this.reductionComm = _data["reductionComm"] !== undefined ? _data["reductionComm"] : <any>null;
            this.totalcommande = _data["totalcommande"] !== undefined ? _data["totalcommande"] : <any>null;
            this.estimateTotalCommande = _data["estimateTotalCommande"] !== undefined ? _data["estimateTotalCommande"] : <any>null;
            this.totalLv1 = _data["totalLv1"] !== undefined ? _data["totalLv1"] : <any>null;
            this.totalLv2 = _data["totalLv2"] !== undefined ? _data["totalLv2"] : <any>null;
            this.totalLv3 = _data["totalLv3"] !== undefined ? _data["totalLv3"] : <any>null;
            this.totalLv4 = _data["totalLv4"] !== undefined ? _data["totalLv4"] : <any>null;
            this.totalLv5 = _data["totalLv5"] !== undefined ? _data["totalLv5"] : <any>null;
            this.totalLv6 = _data["totalLv6"] !== undefined ? _data["totalLv6"] : <any>null;
            this.datePaiement = _data["datePaiement"] !== undefined ? _data["datePaiement"] : <any>null;
            this.tm = _data["tm"] !== undefined ? _data["tm"] : <any>null;
            this.dateTm = _data["dateTm"] ? moment(_data["dateTm"].toString()) : <any>null;
            this.typeTm = _data["typeTm"] !== undefined ? _data["typeTm"] : <any>null;
            this.confType = _data["confType"] !== undefined ? _data["confType"] : <any>null;
            this.confTypeNom = _data["confTypeNom"] !== undefined ? _data["confTypeNom"] : <any>null;
            this.confTm = _data["confTm"] !== undefined ? _data["confTm"] : <any>null;
            this.confTmnom = _data["confTmnom"] !== undefined ? _data["confTmnom"] : <any>null;
            this.confFinancement = _data["confFinancement"] !== undefined ? _data["confFinancement"] : <any>null;
            this.confFinancementNom = _data["confFinancementNom"] !== undefined ? _data["confFinancementNom"] : <any>null;
            this.confVendeur = _data["confVendeur"] !== undefined ? _data["confVendeur"] : <any>null;
            this.confVendeurNom = _data["confVendeurNom"] !== undefined ? _data["confVendeurNom"] : <any>null;
            this.refTm = _data["refTm"] !== undefined ? _data["refTm"] : <any>null;
            this.dernierelivraison = _data["dernierelivraison"] ? moment(_data["dernierelivraison"].toString()) : <any>null;
            this.commentaires = _data["commentaires"] !== undefined ? _data["commentaires"] : <any>null;
            this.annuler = _data["annuler"] !== undefined ? _data["annuler"] : <any>null;
            this.demi = _data["demi"] !== undefined ? _data["demi"] : <any>null;
            this.accepte = _data["accepte"] !== undefined ? _data["accepte"] : <any>null;
            this.accepteN = _data["accepteN"] !== undefined ? _data["accepteN"] : <any>null;
            this.confAccepteN = _data["confAccepteN"] !== undefined ? _data["confAccepteN"] : <any>null;
            this.confAccepteNnom = _data["confAccepteNnom"] !== undefined ? _data["confAccepteNnom"] : <any>null;
            this.ranglivraison = _data["ranglivraison"] !== undefined ? _data["ranglivraison"] : <any>null;
            this.estPatch = _data["estPatch"] !== undefined ? _data["estPatch"] : <any>null;
            this.nomtm = _data["nomtm"] !== undefined ? _data["nomtm"] : <any>null;
            this.vincent = _data["vincent"] !== undefined ? _data["vincent"] : <any>null;
            this.commisionrecu = _data["commisionrecu"] !== undefined ? _data["commisionrecu"] : <any>null;
            this.appontcommisionrecu = _data["appontcommisionrecu"] !== undefined ? _data["appontcommisionrecu"] : <any>null;
            this.noDistribution = _data["noDistribution"] !== undefined ? _data["noDistribution"] : <any>null;
            this.confDist = _data["confDist"] !== undefined ? _data["confDist"] : <any>null;
            this.confDistNom = _data["confDistNom"] !== undefined ? _data["confDistNom"] : <any>null;
            this.commentairePpa = _data["commentairePpa"] !== undefined ? _data["commentairePpa"] : <any>null;
            this.commentaireLivraison = _data["commentaireLivraison"] !== undefined ? _data["commentaireLivraison"] : <any>null;
            this.estNs = _data["estNs"] !== undefined ? _data["estNs"] : <any>null;
            this.enAttenteSc = _data["enAttenteSc"] !== undefined ? _data["enAttenteSc"] : <any>null;
            this.enAttenteApprobation = _data["enAttenteApprobation"] !== undefined ? _data["enAttenteApprobation"] : <any>null;
            this.changementPpa = _data["changementPpa"] !== undefined ? _data["changementPpa"] : <any>null;
            this.courrielLivr = _data["courrielLivr"] !== undefined ? _data["courrielLivr"] : <any>null;
            this.estImporteDansWebCrm = _data["estImporteDansWebCrm"] !== undefined ? _data["estImporteDansWebCrm"] : <any>null;
            this.selectedMenuId = _data["selectedMenuId"] !== undefined ? _data["selectedMenuId"] : <any>null;
            if (Array.isArray(_data["commItems"])) {
                this.commItems = [] as any;
                for (let item of _data["commItems"])
                    this.commItems!.push(CommItem.fromJS(item));
            }
            else {
                this.commItems = <any>null;
            }
            if (Array.isArray(_data["commCongelateurs"])) {
                this.commCongelateurs = [] as any;
                for (let item of _data["commCongelateurs"])
                    this.commCongelateurs!.push(CommCongelateur.fromJS(item));
            }
            else {
                this.commCongelateurs = <any>null;
            }
            if (Array.isArray(_data["commAppliances"])) {
                this.commAppliances = [] as any;
                for (let item of _data["commAppliances"])
                    this.commAppliances!.push(CommAppliance.fromJS(item));
            }
            else {
                this.commAppliances = <any>null;
            }
            this.estRemote = _data["estRemote"] !== undefined ? _data["estRemote"] : <any>null;
            this.docusignEnvelopeId = _data["docusignEnvelopeId"] !== undefined ? _data["docusignEnvelopeId"] : <any>null;
            this.envelopeStatus = _data["envelopeStatus"] !== undefined ? _data["envelopeStatus"] : <any>null;
            this.dateSigneParClient = _data["dateSigneParClient"] ? moment(_data["dateSigneParClient"].toString()) : <any>null;
            this.estSigneParClient = _data["estSigneParClient"] !== undefined ? _data["estSigneParClient"] : <any>null;
            this.dateSigneParConjoint = _data["dateSigneParConjoint"] ? moment(_data["dateSigneParConjoint"].toString()) : <any>null;
            this.signeParConjoint = _data["signeParConjoint"] !== undefined ? _data["signeParConjoint"] : <any>null;
            if (Array.isArray(_data["referencesGiven"])) {
                this.referencesGiven = [] as any;
                for (let item of _data["referencesGiven"])
                    this.referencesGiven!.push(ReferencesTablette.fromJS(item));
            }
            else {
                this.referencesGiven = <any>null;
            }
            this.referencesFromClientPortal = _data["referencesFromClientPortal"] !== undefined ? _data["referencesFromClientPortal"] : <any>null;
            this.appelTm = _data["appelTm"] ? AppelTm.fromJS(_data["appelTm"]) : <any>null;
            this.tabletOrderNo = _data["tabletOrderNo"] !== undefined ? _data["tabletOrderNo"] : <any>null;
            this.tabletOrderId = _data["tabletOrderId"] !== undefined ? _data["tabletOrderId"] : <any>null;
            this.noAppelOrigin = _data["noAppelOrigin"] !== undefined ? _data["noAppelOrigin"] : <any>null;
            this.lastModified = _data["lastModified"] ? moment(_data["lastModified"].toString()) : <any>null;
            this.estNouveauMenuSystem = _data["estNouveauMenuSystem"] !== undefined ? _data["estNouveauMenuSystem"] : <any>null;
            this.estClassique = _data["estClassique"] !== undefined ? _data["estClassique"] : <any>null;
            if (Array.isArray(_data["erpCommandeImports"])) {
                this.erpCommandeImports = [] as any;
                for (let item of _data["erpCommandeImports"])
                    this.erpCommandeImports!.push(ERPCommandeImport.fromJS(item));
            }
            else {
                this.erpCommandeImports = <any>null;
            }
        }
    }

    static fromJS(data: any): Commande {
        data = typeof data === 'object' ? data : {};
        let result = new Commande();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["noCommande"] = this.noCommande !== undefined ? this.noCommande : <any>null;
        data["noClient"] = this.noClient !== undefined ? this.noClient : <any>null;
        data["client"] = this.client ? this.client.toJSON() : <any>null;
        data["noVendeur"] = this.noVendeur !== undefined ? this.noVendeur : <any>null;
        data["dateCommande"] = this.dateCommande ? this.dateCommande.toISOString() : <any>null;
        data["nbremois"] = this.nbremois !== undefined ? this.nbremois : <any>null;
        data["renouvellement"] = this.renouvellement !== undefined ? this.renouvellement : <any>null;
        data["nbrelivraison"] = this.nbrelivraison !== undefined ? this.nbrelivraison : <any>null;
        data["tauxfraisfinancier"] = this.tauxfraisfinancier !== undefined ? this.tauxfraisfinancier : <any>null;
        if (Array.isArray(this.livraisons)) {
            data["livraisons"] = [];
            for (let item of this.livraisons)
                data["livraisons"].push(item.toJSON());
        }
        data["cie"] = this.cie !== undefined ? this.cie : <any>null;
        data["noAutorisation"] = this.noAutorisation !== undefined ? this.noAutorisation : <any>null;
        data["tauxfraisfincongel"] = this.tauxfraisfincongel !== undefined ? this.tauxfraisfincongel : <any>null;
        data["ciecongel"] = this.ciecongel !== undefined ? this.ciecongel : <any>null;
        data["manutention"] = this.manutention !== undefined ? this.manutention : <any>null;
        data["achatcoupon"] = this.achatcoupon !== undefined ? this.achatcoupon : <any>null;
        data["coupon"] = this.coupon !== undefined ? this.coupon : <any>null;
        data["couponcommentaire"] = this.couponcommentaire !== undefined ? this.couponcommentaire : <any>null;
        data["promotion"] = this.promotion !== undefined ? this.promotion : <any>null;
        data["promcommentaire"] = this.promcommentaire !== undefined ? this.promcommentaire : <any>null;
        data["escompte"] = this.escompte !== undefined ? this.escompte : <any>null;
        data["rachat"] = this.rachat !== undefined ? this.rachat : <any>null;
        data["rachatcommentaire"] = this.rachatcommentaire !== undefined ? this.rachatcommentaire : <any>null;
        data["rabaisPromosDescription"] = this.rabaisPromosDescription !== undefined ? this.rabaisPromosDescription : <any>null;
        data["paiementmensuel"] = this.paiementmensuel !== undefined ? this.paiementmensuel : <any>null;
        data["cadeauvendeur"] = this.cadeauvendeur !== undefined ? this.cadeauvendeur : <any>null;
        data["promotionvendeur"] = this.promotionvendeur !== undefined ? this.promotionvendeur : <any>null;
        data["tauxcommission"] = this.tauxcommission !== undefined ? this.tauxcommission : <any>null;
        data["reductionComm"] = this.reductionComm !== undefined ? this.reductionComm : <any>null;
        data["totalcommande"] = this.totalcommande !== undefined ? this.totalcommande : <any>null;
        data["estimateTotalCommande"] = this.estimateTotalCommande !== undefined ? this.estimateTotalCommande : <any>null;
        data["totalLv1"] = this.totalLv1 !== undefined ? this.totalLv1 : <any>null;
        data["totalLv2"] = this.totalLv2 !== undefined ? this.totalLv2 : <any>null;
        data["totalLv3"] = this.totalLv3 !== undefined ? this.totalLv3 : <any>null;
        data["totalLv4"] = this.totalLv4 !== undefined ? this.totalLv4 : <any>null;
        data["totalLv5"] = this.totalLv5 !== undefined ? this.totalLv5 : <any>null;
        data["totalLv6"] = this.totalLv6 !== undefined ? this.totalLv6 : <any>null;
        data["datePaiement"] = this.datePaiement !== undefined ? this.datePaiement : <any>null;
        data["tm"] = this.tm !== undefined ? this.tm : <any>null;
        data["dateTm"] = this.dateTm ? this.dateTm.toISOString() : <any>null;
        data["typeTm"] = this.typeTm !== undefined ? this.typeTm : <any>null;
        data["confType"] = this.confType !== undefined ? this.confType : <any>null;
        data["confTypeNom"] = this.confTypeNom !== undefined ? this.confTypeNom : <any>null;
        data["confTm"] = this.confTm !== undefined ? this.confTm : <any>null;
        data["confTmnom"] = this.confTmnom !== undefined ? this.confTmnom : <any>null;
        data["confFinancement"] = this.confFinancement !== undefined ? this.confFinancement : <any>null;
        data["confFinancementNom"] = this.confFinancementNom !== undefined ? this.confFinancementNom : <any>null;
        data["confVendeur"] = this.confVendeur !== undefined ? this.confVendeur : <any>null;
        data["confVendeurNom"] = this.confVendeurNom !== undefined ? this.confVendeurNom : <any>null;
        data["refTm"] = this.refTm !== undefined ? this.refTm : <any>null;
        data["dernierelivraison"] = this.dernierelivraison ? this.dernierelivraison.toISOString() : <any>null;
        data["commentaires"] = this.commentaires !== undefined ? this.commentaires : <any>null;
        data["annuler"] = this.annuler !== undefined ? this.annuler : <any>null;
        data["demi"] = this.demi !== undefined ? this.demi : <any>null;
        data["accepte"] = this.accepte !== undefined ? this.accepte : <any>null;
        data["accepteN"] = this.accepteN !== undefined ? this.accepteN : <any>null;
        data["confAccepteN"] = this.confAccepteN !== undefined ? this.confAccepteN : <any>null;
        data["confAccepteNnom"] = this.confAccepteNnom !== undefined ? this.confAccepteNnom : <any>null;
        data["ranglivraison"] = this.ranglivraison !== undefined ? this.ranglivraison : <any>null;
        data["estPatch"] = this.estPatch !== undefined ? this.estPatch : <any>null;
        data["nomtm"] = this.nomtm !== undefined ? this.nomtm : <any>null;
        data["vincent"] = this.vincent !== undefined ? this.vincent : <any>null;
        data["commisionrecu"] = this.commisionrecu !== undefined ? this.commisionrecu : <any>null;
        data["appontcommisionrecu"] = this.appontcommisionrecu !== undefined ? this.appontcommisionrecu : <any>null;
        data["noDistribution"] = this.noDistribution !== undefined ? this.noDistribution : <any>null;
        data["confDist"] = this.confDist !== undefined ? this.confDist : <any>null;
        data["confDistNom"] = this.confDistNom !== undefined ? this.confDistNom : <any>null;
        data["commentairePpa"] = this.commentairePpa !== undefined ? this.commentairePpa : <any>null;
        data["commentaireLivraison"] = this.commentaireLivraison !== undefined ? this.commentaireLivraison : <any>null;
        data["estNs"] = this.estNs !== undefined ? this.estNs : <any>null;
        data["enAttenteSc"] = this.enAttenteSc !== undefined ? this.enAttenteSc : <any>null;
        data["enAttenteApprobation"] = this.enAttenteApprobation !== undefined ? this.enAttenteApprobation : <any>null;
        data["changementPpa"] = this.changementPpa !== undefined ? this.changementPpa : <any>null;
        data["courrielLivr"] = this.courrielLivr !== undefined ? this.courrielLivr : <any>null;
        data["estImporteDansWebCrm"] = this.estImporteDansWebCrm !== undefined ? this.estImporteDansWebCrm : <any>null;
        data["selectedMenuId"] = this.selectedMenuId !== undefined ? this.selectedMenuId : <any>null;
        if (Array.isArray(this.commItems)) {
            data["commItems"] = [];
            for (let item of this.commItems)
                data["commItems"].push(item.toJSON());
        }
        if (Array.isArray(this.commCongelateurs)) {
            data["commCongelateurs"] = [];
            for (let item of this.commCongelateurs)
                data["commCongelateurs"].push(item.toJSON());
        }
        if (Array.isArray(this.commAppliances)) {
            data["commAppliances"] = [];
            for (let item of this.commAppliances)
                data["commAppliances"].push(item.toJSON());
        }
        data["estRemote"] = this.estRemote !== undefined ? this.estRemote : <any>null;
        data["docusignEnvelopeId"] = this.docusignEnvelopeId !== undefined ? this.docusignEnvelopeId : <any>null;
        data["envelopeStatus"] = this.envelopeStatus !== undefined ? this.envelopeStatus : <any>null;
        data["dateSigneParClient"] = this.dateSigneParClient ? this.dateSigneParClient.toISOString() : <any>null;
        data["estSigneParClient"] = this.estSigneParClient !== undefined ? this.estSigneParClient : <any>null;
        data["dateSigneParConjoint"] = this.dateSigneParConjoint ? this.dateSigneParConjoint.toISOString() : <any>null;
        data["signeParConjoint"] = this.signeParConjoint !== undefined ? this.signeParConjoint : <any>null;
        if (Array.isArray(this.referencesGiven)) {
            data["referencesGiven"] = [];
            for (let item of this.referencesGiven)
                data["referencesGiven"].push(item.toJSON());
        }
        data["referencesFromClientPortal"] = this.referencesFromClientPortal !== undefined ? this.referencesFromClientPortal : <any>null;
        data["appelTm"] = this.appelTm ? this.appelTm.toJSON() : <any>null;
        data["tabletOrderNo"] = this.tabletOrderNo !== undefined ? this.tabletOrderNo : <any>null;
        data["tabletOrderId"] = this.tabletOrderId !== undefined ? this.tabletOrderId : <any>null;
        data["noAppelOrigin"] = this.noAppelOrigin !== undefined ? this.noAppelOrigin : <any>null;
        data["lastModified"] = this.lastModified ? this.lastModified.toISOString() : <any>null;
        data["estNouveauMenuSystem"] = this.estNouveauMenuSystem !== undefined ? this.estNouveauMenuSystem : <any>null;
        data["estClassique"] = this.estClassique !== undefined ? this.estClassique : <any>null;
        if (Array.isArray(this.erpCommandeImports)) {
            data["erpCommandeImports"] = [];
            for (let item of this.erpCommandeImports)
                data["erpCommandeImports"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICommande {
    noCommande?: number;
    noClient?: number;
    client?: Client2 | null;
    noVendeur?: number;
    dateCommande?: moment.Moment | null;
    nbremois?: number | null;
    renouvellement?: number | null;
    nbrelivraison?: string | null;
    tauxfraisfinancier?: number | null;
    livraisons?: Livraison[] | null;
    cie?: string | null;
    noAutorisation?: string | null;
    tauxfraisfincongel?: number | null;
    ciecongel?: string | null;
    manutention?: number | null;
    achatcoupon?: number | null;
    coupon?: number | null;
    couponcommentaire?: string | null;
    promotion?: number | null;
    promcommentaire?: string | null;
    escompte?: number | null;
    rachat?: number | null;
    rachatcommentaire?: string | null;
    rabaisPromosDescription?: string | null;
    paiementmensuel?: number | null;
    cadeauvendeur?: number | null;
    promotionvendeur?: number | null;
    tauxcommission?: number | null;
    reductionComm?: number | null;
    totalcommande?: number | null;
    estimateTotalCommande?: number | null;
    totalLv1?: number | null;
    totalLv2?: number | null;
    totalLv3?: number | null;
    totalLv4?: number | null;
    totalLv5?: number | null;
    totalLv6?: number | null;
    datePaiement?: string | null;
    tm?: string | null;
    dateTm?: moment.Moment | null;
    typeTm?: string | null;
    confType?: boolean | null;
    confTypeNom?: string | null;
    confTm?: boolean | null;
    confTmnom?: string | null;
    confFinancement?: boolean | null;
    confFinancementNom?: string | null;
    confVendeur?: boolean | null;
    confVendeurNom?: string | null;
    refTm?: string | null;
    dernierelivraison?: moment.Moment | null;
    commentaires?: string | null;
    annuler?: boolean;
    demi?: boolean | null;
    accepte?: number | null;
    accepteN?: number | null;
    confAccepteN?: boolean | null;
    confAccepteNnom?: string | null;
    ranglivraison?: number | null;
    estPatch?: boolean | null;
    nomtm?: string | null;
    vincent?: boolean | null;
    commisionrecu?: boolean | null;
    appontcommisionrecu?: boolean | null;
    noDistribution?: number | null;
    confDist?: boolean | null;
    confDistNom?: string | null;
    commentairePpa?: string | null;
    commentaireLivraison?: string | null;
    estNs?: boolean | null;
    enAttenteSc?: boolean | null;
    enAttenteApprobation?: boolean | null;
    changementPpa?: boolean | null;
    courrielLivr?: boolean | null;
    estImporteDansWebCrm?: boolean | null;
    selectedMenuId?: string | null;
    commItems?: CommItem[] | null;
    commCongelateurs?: CommCongelateur[] | null;
    commAppliances?: CommAppliance[] | null;
    estRemote?: boolean | null;
    docusignEnvelopeId?: string | null;
    envelopeStatus?: string | null;
    dateSigneParClient?: moment.Moment | null;
    estSigneParClient?: boolean;
    dateSigneParConjoint?: moment.Moment | null;
    signeParConjoint?: boolean;
    referencesGiven?: ReferencesTablette[] | null;
    referencesFromClientPortal?: boolean | null;
    appelTm?: AppelTm | null;
    tabletOrderNo?: number | null;
    tabletOrderId?: string | null;
    noAppelOrigin?: number | null;
    lastModified?: moment.Moment | null;
    estNouveauMenuSystem?: boolean | null;
    estClassique?: boolean;
    erpCommandeImports?: ERPCommandeImport[] | null;
}

export class Client2 implements IClient2 {
    noClient?: number;
    commandes?: Commande[] | null;
    appelTms?: AppelTm[] | null;
    nom?: string | null;
    adr1?: string | null;
    appartement?: string | null;
    ville?: string | null;
    quartier?: string | null;
    latitude?: string | null;
    longitude?: string | null;
    cdProv?: string | null;
    cdPost?: string | null;
    noSecteur?: number | null;
    telMais?: number | null;
    telBur?: number | null;
    telAutre?: number | null;
    courriel?: string | null;
    envoiCourriel?: boolean | null;
    aucunCourriel?: boolean | null;
    dateAnniversaire?: moment.Moment | null;
    nas?: string | null;
    conjoint?: string | null;
    telConjoint?: number | null;
    telBurConjoint?: number | null;
    burPoste?: string | null;
    conjBurPoste?: string | null;
    telAutreConjoint?: number | null;
    courrielConjoint?: string | null;
    envoiCourrielConjoint?: boolean | null;
    substitutionItemsAllowed?: boolean | null;
    dateAnniverConjoint?: moment.Moment | null;
    nasconjoint?: string | null;
    seqAlpha?: string | null;
    dtCree?: moment.Moment | null;
    dtLivraison?: moment.Moment | null;
    dtSac?: moment.Moment | null;
    notes?: string | null;
    nomenu?: string | null;
    noteImportante?: string | null;
    detenteurDossier?: string | null;
    dateVente?: moment.Moment | null;
    typecommande?: CommandeType | null;
    dateEntree?: moment.Moment | null;
    statusCommande?: number | null;
    etatCommande?: number | null;
    datePoste?: moment.Moment | null;
    montantCommande?: number | null;
    accepte?: number | null;
    accepteNouveau?: number | null;
    accepteNouveauErpString?: string | null;
    financement?: number | null;
    sequencePaiement?: string | null;
    financementTablette?: number | null;
    sequencePaiementTablette?: number | null;
    modalitePaiementTablette?: string | null;
    accountNo?: string | null;
    institutionNo?: string | null;
    transitNo?: string | null;
    notesCadeaux?: string | null;
    dateDebutPaiment?: moment.Moment | null;
    dateFinPaiment?: moment.Moment | null;
    noAutorisation?: string | null;
    livraison?: number | null;
    coupon?: number | null;
    reference?: number | null;
    noDist?: number | null;
    noVendeur?: number | null;
    noTm?: number | null;
    chauffeurDejaSpecimen?: boolean | null;
    chauffeurRamSpecimen?: boolean | null;
    chauffeurSigneForm?: boolean | null;
    chauffeurDejaForm?: boolean | null;
    majacombaAfaire?: boolean;
    nouvclient?: boolean | null;
    enDefautPaiement?: boolean | null;
    rachat?: string | null;
    commApprobation?: string | null;
    estBureau?: boolean | null;
    estWinback?: boolean | null;
    estGrocerShop?: boolean | null;
    anglais?: boolean | null;
    langConfirme?: boolean;
    taxesAutre?: boolean | null;
    estTablette?: boolean | null;
    noAppelTm?: number | null;
    ficheTu?: boolean | null;
    dossierDg?: boolean | null;
    dossierFm?: boolean | null;
    veutCanceller?: boolean | null;
    veutModifier?: boolean | null;
    valider?: boolean;
    lastModified?: moment.Moment | null;
    referencesGiven?: ReferencesTablette[] | null;
    contractInfos?: ContratInfo[] | null;
    address?: string | null;
    erpClientImports?: ERPClientImport[] | null;

    constructor(data?: IClient2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.noClient = _data["noClient"] !== undefined ? _data["noClient"] : <any>null;
            if (Array.isArray(_data["commandes"])) {
                this.commandes = [] as any;
                for (let item of _data["commandes"])
                    this.commandes!.push(Commande.fromJS(item));
            }
            else {
                this.commandes = <any>null;
            }
            if (Array.isArray(_data["appelTms"])) {
                this.appelTms = [] as any;
                for (let item of _data["appelTms"])
                    this.appelTms!.push(AppelTm.fromJS(item));
            }
            else {
                this.appelTms = <any>null;
            }
            this.nom = _data["nom"] !== undefined ? _data["nom"] : <any>null;
            this.adr1 = _data["adr1"] !== undefined ? _data["adr1"] : <any>null;
            this.appartement = _data["appartement"] !== undefined ? _data["appartement"] : <any>null;
            this.ville = _data["ville"] !== undefined ? _data["ville"] : <any>null;
            this.quartier = _data["quartier"] !== undefined ? _data["quartier"] : <any>null;
            this.latitude = _data["latitude"] !== undefined ? _data["latitude"] : <any>null;
            this.longitude = _data["longitude"] !== undefined ? _data["longitude"] : <any>null;
            this.cdProv = _data["cdProv"] !== undefined ? _data["cdProv"] : <any>null;
            this.cdPost = _data["cdPost"] !== undefined ? _data["cdPost"] : <any>null;
            this.noSecteur = _data["noSecteur"] !== undefined ? _data["noSecteur"] : <any>null;
            this.telMais = _data["telMais"] !== undefined ? _data["telMais"] : <any>null;
            this.telBur = _data["telBur"] !== undefined ? _data["telBur"] : <any>null;
            this.telAutre = _data["telAutre"] !== undefined ? _data["telAutre"] : <any>null;
            this.courriel = _data["courriel"] !== undefined ? _data["courriel"] : <any>null;
            this.envoiCourriel = _data["envoiCourriel"] !== undefined ? _data["envoiCourriel"] : <any>null;
            this.aucunCourriel = _data["aucunCourriel"] !== undefined ? _data["aucunCourriel"] : <any>null;
            this.dateAnniversaire = _data["dateAnniversaire"] ? moment(_data["dateAnniversaire"].toString()) : <any>null;
            this.nas = _data["nas"] !== undefined ? _data["nas"] : <any>null;
            this.conjoint = _data["conjoint"] !== undefined ? _data["conjoint"] : <any>null;
            this.telConjoint = _data["telConjoint"] !== undefined ? _data["telConjoint"] : <any>null;
            this.telBurConjoint = _data["telBurConjoint"] !== undefined ? _data["telBurConjoint"] : <any>null;
            this.burPoste = _data["burPoste"] !== undefined ? _data["burPoste"] : <any>null;
            this.conjBurPoste = _data["conjBurPoste"] !== undefined ? _data["conjBurPoste"] : <any>null;
            this.telAutreConjoint = _data["telAutreConjoint"] !== undefined ? _data["telAutreConjoint"] : <any>null;
            this.courrielConjoint = _data["courrielConjoint"] !== undefined ? _data["courrielConjoint"] : <any>null;
            this.envoiCourrielConjoint = _data["envoiCourrielConjoint"] !== undefined ? _data["envoiCourrielConjoint"] : <any>null;
            this.substitutionItemsAllowed = _data["substitutionItemsAllowed"] !== undefined ? _data["substitutionItemsAllowed"] : <any>null;
            this.dateAnniverConjoint = _data["dateAnniverConjoint"] ? moment(_data["dateAnniverConjoint"].toString()) : <any>null;
            this.nasconjoint = _data["nasconjoint"] !== undefined ? _data["nasconjoint"] : <any>null;
            this.seqAlpha = _data["seqAlpha"] !== undefined ? _data["seqAlpha"] : <any>null;
            this.dtCree = _data["dtCree"] ? moment(_data["dtCree"].toString()) : <any>null;
            this.dtLivraison = _data["dtLivraison"] ? moment(_data["dtLivraison"].toString()) : <any>null;
            this.dtSac = _data["dtSac"] ? moment(_data["dtSac"].toString()) : <any>null;
            this.notes = _data["notes"] !== undefined ? _data["notes"] : <any>null;
            this.nomenu = _data["nomenu"] !== undefined ? _data["nomenu"] : <any>null;
            this.noteImportante = _data["noteImportante"] !== undefined ? _data["noteImportante"] : <any>null;
            this.detenteurDossier = _data["detenteurDossier"] !== undefined ? _data["detenteurDossier"] : <any>null;
            this.dateVente = _data["dateVente"] ? moment(_data["dateVente"].toString()) : <any>null;
            this.typecommande = _data["typecommande"] !== undefined ? _data["typecommande"] : <any>null;
            this.dateEntree = _data["dateEntree"] ? moment(_data["dateEntree"].toString()) : <any>null;
            this.statusCommande = _data["statusCommande"] !== undefined ? _data["statusCommande"] : <any>null;
            this.etatCommande = _data["etatCommande"] !== undefined ? _data["etatCommande"] : <any>null;
            this.datePoste = _data["datePoste"] ? moment(_data["datePoste"].toString()) : <any>null;
            this.montantCommande = _data["montantCommande"] !== undefined ? _data["montantCommande"] : <any>null;
            this.accepte = _data["accepte"] !== undefined ? _data["accepte"] : <any>null;
            this.accepteNouveau = _data["accepteNouveau"] !== undefined ? _data["accepteNouveau"] : <any>null;
            this.accepteNouveauErpString = _data["accepteNouveauErpString"] !== undefined ? _data["accepteNouveauErpString"] : <any>null;
            this.financement = _data["financement"] !== undefined ? _data["financement"] : <any>null;
            this.sequencePaiement = _data["sequencePaiement"] !== undefined ? _data["sequencePaiement"] : <any>null;
            this.financementTablette = _data["financementTablette"] !== undefined ? _data["financementTablette"] : <any>null;
            this.sequencePaiementTablette = _data["sequencePaiementTablette"] !== undefined ? _data["sequencePaiementTablette"] : <any>null;
            this.modalitePaiementTablette = _data["modalitePaiementTablette"] !== undefined ? _data["modalitePaiementTablette"] : <any>null;
            this.accountNo = _data["accountNo"] !== undefined ? _data["accountNo"] : <any>null;
            this.institutionNo = _data["institutionNo"] !== undefined ? _data["institutionNo"] : <any>null;
            this.transitNo = _data["transitNo"] !== undefined ? _data["transitNo"] : <any>null;
            this.notesCadeaux = _data["notesCadeaux"] !== undefined ? _data["notesCadeaux"] : <any>null;
            this.dateDebutPaiment = _data["dateDebutPaiment"] ? moment(_data["dateDebutPaiment"].toString()) : <any>null;
            this.dateFinPaiment = _data["dateFinPaiment"] ? moment(_data["dateFinPaiment"].toString()) : <any>null;
            this.noAutorisation = _data["noAutorisation"] !== undefined ? _data["noAutorisation"] : <any>null;
            this.livraison = _data["livraison"] !== undefined ? _data["livraison"] : <any>null;
            this.coupon = _data["coupon"] !== undefined ? _data["coupon"] : <any>null;
            this.reference = _data["reference"] !== undefined ? _data["reference"] : <any>null;
            this.noDist = _data["noDist"] !== undefined ? _data["noDist"] : <any>null;
            this.noVendeur = _data["noVendeur"] !== undefined ? _data["noVendeur"] : <any>null;
            this.noTm = _data["noTm"] !== undefined ? _data["noTm"] : <any>null;
            this.chauffeurDejaSpecimen = _data["chauffeurDejaSpecimen"] !== undefined ? _data["chauffeurDejaSpecimen"] : <any>null;
            this.chauffeurRamSpecimen = _data["chauffeurRamSpecimen"] !== undefined ? _data["chauffeurRamSpecimen"] : <any>null;
            this.chauffeurSigneForm = _data["chauffeurSigneForm"] !== undefined ? _data["chauffeurSigneForm"] : <any>null;
            this.chauffeurDejaForm = _data["chauffeurDejaForm"] !== undefined ? _data["chauffeurDejaForm"] : <any>null;
            this.majacombaAfaire = _data["majacombaAfaire"] !== undefined ? _data["majacombaAfaire"] : <any>null;
            this.nouvclient = _data["nouvclient"] !== undefined ? _data["nouvclient"] : <any>null;
            this.enDefautPaiement = _data["enDefautPaiement"] !== undefined ? _data["enDefautPaiement"] : <any>null;
            this.rachat = _data["rachat"] !== undefined ? _data["rachat"] : <any>null;
            this.commApprobation = _data["commApprobation"] !== undefined ? _data["commApprobation"] : <any>null;
            this.estBureau = _data["estBureau"] !== undefined ? _data["estBureau"] : <any>null;
            this.estWinback = _data["estWinback"] !== undefined ? _data["estWinback"] : <any>null;
            this.estGrocerShop = _data["estGrocerShop"] !== undefined ? _data["estGrocerShop"] : <any>null;
            this.anglais = _data["anglais"] !== undefined ? _data["anglais"] : <any>null;
            this.langConfirme = _data["langConfirme"] !== undefined ? _data["langConfirme"] : <any>null;
            this.taxesAutre = _data["taxesAutre"] !== undefined ? _data["taxesAutre"] : <any>null;
            this.estTablette = _data["estTablette"] !== undefined ? _data["estTablette"] : <any>null;
            this.noAppelTm = _data["noAppelTm"] !== undefined ? _data["noAppelTm"] : <any>null;
            this.ficheTu = _data["ficheTu"] !== undefined ? _data["ficheTu"] : <any>null;
            this.dossierDg = _data["dossierDg"] !== undefined ? _data["dossierDg"] : <any>null;
            this.dossierFm = _data["dossierFm"] !== undefined ? _data["dossierFm"] : <any>null;
            this.veutCanceller = _data["veutCanceller"] !== undefined ? _data["veutCanceller"] : <any>null;
            this.veutModifier = _data["veutModifier"] !== undefined ? _data["veutModifier"] : <any>null;
            this.valider = _data["valider"] !== undefined ? _data["valider"] : <any>null;
            this.lastModified = _data["lastModified"] ? moment(_data["lastModified"].toString()) : <any>null;
            if (Array.isArray(_data["referencesGiven"])) {
                this.referencesGiven = [] as any;
                for (let item of _data["referencesGiven"])
                    this.referencesGiven!.push(ReferencesTablette.fromJS(item));
            }
            else {
                this.referencesGiven = <any>null;
            }
            if (Array.isArray(_data["contractInfos"])) {
                this.contractInfos = [] as any;
                for (let item of _data["contractInfos"])
                    this.contractInfos!.push(ContratInfo.fromJS(item));
            }
            else {
                this.contractInfos = <any>null;
            }
            this.address = _data["address"] !== undefined ? _data["address"] : <any>null;
            if (Array.isArray(_data["erpClientImports"])) {
                this.erpClientImports = [] as any;
                for (let item of _data["erpClientImports"])
                    this.erpClientImports!.push(ERPClientImport.fromJS(item));
            }
            else {
                this.erpClientImports = <any>null;
            }
        }
    }

    static fromJS(data: any): Client2 {
        data = typeof data === 'object' ? data : {};
        let result = new Client2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["noClient"] = this.noClient !== undefined ? this.noClient : <any>null;
        if (Array.isArray(this.commandes)) {
            data["commandes"] = [];
            for (let item of this.commandes)
                data["commandes"].push(item.toJSON());
        }
        if (Array.isArray(this.appelTms)) {
            data["appelTms"] = [];
            for (let item of this.appelTms)
                data["appelTms"].push(item.toJSON());
        }
        data["nom"] = this.nom !== undefined ? this.nom : <any>null;
        data["adr1"] = this.adr1 !== undefined ? this.adr1 : <any>null;
        data["appartement"] = this.appartement !== undefined ? this.appartement : <any>null;
        data["ville"] = this.ville !== undefined ? this.ville : <any>null;
        data["quartier"] = this.quartier !== undefined ? this.quartier : <any>null;
        data["latitude"] = this.latitude !== undefined ? this.latitude : <any>null;
        data["longitude"] = this.longitude !== undefined ? this.longitude : <any>null;
        data["cdProv"] = this.cdProv !== undefined ? this.cdProv : <any>null;
        data["cdPost"] = this.cdPost !== undefined ? this.cdPost : <any>null;
        data["noSecteur"] = this.noSecteur !== undefined ? this.noSecteur : <any>null;
        data["telMais"] = this.telMais !== undefined ? this.telMais : <any>null;
        data["telBur"] = this.telBur !== undefined ? this.telBur : <any>null;
        data["telAutre"] = this.telAutre !== undefined ? this.telAutre : <any>null;
        data["courriel"] = this.courriel !== undefined ? this.courriel : <any>null;
        data["envoiCourriel"] = this.envoiCourriel !== undefined ? this.envoiCourriel : <any>null;
        data["aucunCourriel"] = this.aucunCourriel !== undefined ? this.aucunCourriel : <any>null;
        data["dateAnniversaire"] = this.dateAnniversaire ? this.dateAnniversaire.toISOString() : <any>null;
        data["nas"] = this.nas !== undefined ? this.nas : <any>null;
        data["conjoint"] = this.conjoint !== undefined ? this.conjoint : <any>null;
        data["telConjoint"] = this.telConjoint !== undefined ? this.telConjoint : <any>null;
        data["telBurConjoint"] = this.telBurConjoint !== undefined ? this.telBurConjoint : <any>null;
        data["burPoste"] = this.burPoste !== undefined ? this.burPoste : <any>null;
        data["conjBurPoste"] = this.conjBurPoste !== undefined ? this.conjBurPoste : <any>null;
        data["telAutreConjoint"] = this.telAutreConjoint !== undefined ? this.telAutreConjoint : <any>null;
        data["courrielConjoint"] = this.courrielConjoint !== undefined ? this.courrielConjoint : <any>null;
        data["envoiCourrielConjoint"] = this.envoiCourrielConjoint !== undefined ? this.envoiCourrielConjoint : <any>null;
        data["substitutionItemsAllowed"] = this.substitutionItemsAllowed !== undefined ? this.substitutionItemsAllowed : <any>null;
        data["dateAnniverConjoint"] = this.dateAnniverConjoint ? this.dateAnniverConjoint.toISOString() : <any>null;
        data["nasconjoint"] = this.nasconjoint !== undefined ? this.nasconjoint : <any>null;
        data["seqAlpha"] = this.seqAlpha !== undefined ? this.seqAlpha : <any>null;
        data["dtCree"] = this.dtCree ? this.dtCree.toISOString() : <any>null;
        data["dtLivraison"] = this.dtLivraison ? this.dtLivraison.toISOString() : <any>null;
        data["dtSac"] = this.dtSac ? this.dtSac.toISOString() : <any>null;
        data["notes"] = this.notes !== undefined ? this.notes : <any>null;
        data["nomenu"] = this.nomenu !== undefined ? this.nomenu : <any>null;
        data["noteImportante"] = this.noteImportante !== undefined ? this.noteImportante : <any>null;
        data["detenteurDossier"] = this.detenteurDossier !== undefined ? this.detenteurDossier : <any>null;
        data["dateVente"] = this.dateVente ? this.dateVente.toISOString() : <any>null;
        data["typecommande"] = this.typecommande !== undefined ? this.typecommande : <any>null;
        data["dateEntree"] = this.dateEntree ? this.dateEntree.toISOString() : <any>null;
        data["statusCommande"] = this.statusCommande !== undefined ? this.statusCommande : <any>null;
        data["etatCommande"] = this.etatCommande !== undefined ? this.etatCommande : <any>null;
        data["datePoste"] = this.datePoste ? this.datePoste.toISOString() : <any>null;
        data["montantCommande"] = this.montantCommande !== undefined ? this.montantCommande : <any>null;
        data["accepte"] = this.accepte !== undefined ? this.accepte : <any>null;
        data["accepteNouveau"] = this.accepteNouveau !== undefined ? this.accepteNouveau : <any>null;
        data["accepteNouveauErpString"] = this.accepteNouveauErpString !== undefined ? this.accepteNouveauErpString : <any>null;
        data["financement"] = this.financement !== undefined ? this.financement : <any>null;
        data["sequencePaiement"] = this.sequencePaiement !== undefined ? this.sequencePaiement : <any>null;
        data["financementTablette"] = this.financementTablette !== undefined ? this.financementTablette : <any>null;
        data["sequencePaiementTablette"] = this.sequencePaiementTablette !== undefined ? this.sequencePaiementTablette : <any>null;
        data["modalitePaiementTablette"] = this.modalitePaiementTablette !== undefined ? this.modalitePaiementTablette : <any>null;
        data["accountNo"] = this.accountNo !== undefined ? this.accountNo : <any>null;
        data["institutionNo"] = this.institutionNo !== undefined ? this.institutionNo : <any>null;
        data["transitNo"] = this.transitNo !== undefined ? this.transitNo : <any>null;
        data["notesCadeaux"] = this.notesCadeaux !== undefined ? this.notesCadeaux : <any>null;
        data["dateDebutPaiment"] = this.dateDebutPaiment ? this.dateDebutPaiment.toISOString() : <any>null;
        data["dateFinPaiment"] = this.dateFinPaiment ? this.dateFinPaiment.toISOString() : <any>null;
        data["noAutorisation"] = this.noAutorisation !== undefined ? this.noAutorisation : <any>null;
        data["livraison"] = this.livraison !== undefined ? this.livraison : <any>null;
        data["coupon"] = this.coupon !== undefined ? this.coupon : <any>null;
        data["reference"] = this.reference !== undefined ? this.reference : <any>null;
        data["noDist"] = this.noDist !== undefined ? this.noDist : <any>null;
        data["noVendeur"] = this.noVendeur !== undefined ? this.noVendeur : <any>null;
        data["noTm"] = this.noTm !== undefined ? this.noTm : <any>null;
        data["chauffeurDejaSpecimen"] = this.chauffeurDejaSpecimen !== undefined ? this.chauffeurDejaSpecimen : <any>null;
        data["chauffeurRamSpecimen"] = this.chauffeurRamSpecimen !== undefined ? this.chauffeurRamSpecimen : <any>null;
        data["chauffeurSigneForm"] = this.chauffeurSigneForm !== undefined ? this.chauffeurSigneForm : <any>null;
        data["chauffeurDejaForm"] = this.chauffeurDejaForm !== undefined ? this.chauffeurDejaForm : <any>null;
        data["majacombaAfaire"] = this.majacombaAfaire !== undefined ? this.majacombaAfaire : <any>null;
        data["nouvclient"] = this.nouvclient !== undefined ? this.nouvclient : <any>null;
        data["enDefautPaiement"] = this.enDefautPaiement !== undefined ? this.enDefautPaiement : <any>null;
        data["rachat"] = this.rachat !== undefined ? this.rachat : <any>null;
        data["commApprobation"] = this.commApprobation !== undefined ? this.commApprobation : <any>null;
        data["estBureau"] = this.estBureau !== undefined ? this.estBureau : <any>null;
        data["estWinback"] = this.estWinback !== undefined ? this.estWinback : <any>null;
        data["estGrocerShop"] = this.estGrocerShop !== undefined ? this.estGrocerShop : <any>null;
        data["anglais"] = this.anglais !== undefined ? this.anglais : <any>null;
        data["langConfirme"] = this.langConfirme !== undefined ? this.langConfirme : <any>null;
        data["taxesAutre"] = this.taxesAutre !== undefined ? this.taxesAutre : <any>null;
        data["estTablette"] = this.estTablette !== undefined ? this.estTablette : <any>null;
        data["noAppelTm"] = this.noAppelTm !== undefined ? this.noAppelTm : <any>null;
        data["ficheTu"] = this.ficheTu !== undefined ? this.ficheTu : <any>null;
        data["dossierDg"] = this.dossierDg !== undefined ? this.dossierDg : <any>null;
        data["dossierFm"] = this.dossierFm !== undefined ? this.dossierFm : <any>null;
        data["veutCanceller"] = this.veutCanceller !== undefined ? this.veutCanceller : <any>null;
        data["veutModifier"] = this.veutModifier !== undefined ? this.veutModifier : <any>null;
        data["valider"] = this.valider !== undefined ? this.valider : <any>null;
        data["lastModified"] = this.lastModified ? this.lastModified.toISOString() : <any>null;
        if (Array.isArray(this.referencesGiven)) {
            data["referencesGiven"] = [];
            for (let item of this.referencesGiven)
                data["referencesGiven"].push(item.toJSON());
        }
        if (Array.isArray(this.contractInfos)) {
            data["contractInfos"] = [];
            for (let item of this.contractInfos)
                data["contractInfos"].push(item.toJSON());
        }
        data["address"] = this.address !== undefined ? this.address : <any>null;
        if (Array.isArray(this.erpClientImports)) {
            data["erpClientImports"] = [];
            for (let item of this.erpClientImports)
                data["erpClientImports"].push(item.toJSON());
        }
        return data;
    }
}

export interface IClient2 {
    noClient?: number;
    commandes?: Commande[] | null;
    appelTms?: AppelTm[] | null;
    nom?: string | null;
    adr1?: string | null;
    appartement?: string | null;
    ville?: string | null;
    quartier?: string | null;
    latitude?: string | null;
    longitude?: string | null;
    cdProv?: string | null;
    cdPost?: string | null;
    noSecteur?: number | null;
    telMais?: number | null;
    telBur?: number | null;
    telAutre?: number | null;
    courriel?: string | null;
    envoiCourriel?: boolean | null;
    aucunCourriel?: boolean | null;
    dateAnniversaire?: moment.Moment | null;
    nas?: string | null;
    conjoint?: string | null;
    telConjoint?: number | null;
    telBurConjoint?: number | null;
    burPoste?: string | null;
    conjBurPoste?: string | null;
    telAutreConjoint?: number | null;
    courrielConjoint?: string | null;
    envoiCourrielConjoint?: boolean | null;
    substitutionItemsAllowed?: boolean | null;
    dateAnniverConjoint?: moment.Moment | null;
    nasconjoint?: string | null;
    seqAlpha?: string | null;
    dtCree?: moment.Moment | null;
    dtLivraison?: moment.Moment | null;
    dtSac?: moment.Moment | null;
    notes?: string | null;
    nomenu?: string | null;
    noteImportante?: string | null;
    detenteurDossier?: string | null;
    dateVente?: moment.Moment | null;
    typecommande?: CommandeType | null;
    dateEntree?: moment.Moment | null;
    statusCommande?: number | null;
    etatCommande?: number | null;
    datePoste?: moment.Moment | null;
    montantCommande?: number | null;
    accepte?: number | null;
    accepteNouveau?: number | null;
    accepteNouveauErpString?: string | null;
    financement?: number | null;
    sequencePaiement?: string | null;
    financementTablette?: number | null;
    sequencePaiementTablette?: number | null;
    modalitePaiementTablette?: string | null;
    accountNo?: string | null;
    institutionNo?: string | null;
    transitNo?: string | null;
    notesCadeaux?: string | null;
    dateDebutPaiment?: moment.Moment | null;
    dateFinPaiment?: moment.Moment | null;
    noAutorisation?: string | null;
    livraison?: number | null;
    coupon?: number | null;
    reference?: number | null;
    noDist?: number | null;
    noVendeur?: number | null;
    noTm?: number | null;
    chauffeurDejaSpecimen?: boolean | null;
    chauffeurRamSpecimen?: boolean | null;
    chauffeurSigneForm?: boolean | null;
    chauffeurDejaForm?: boolean | null;
    majacombaAfaire?: boolean;
    nouvclient?: boolean | null;
    enDefautPaiement?: boolean | null;
    rachat?: string | null;
    commApprobation?: string | null;
    estBureau?: boolean | null;
    estWinback?: boolean | null;
    estGrocerShop?: boolean | null;
    anglais?: boolean | null;
    langConfirme?: boolean;
    taxesAutre?: boolean | null;
    estTablette?: boolean | null;
    noAppelTm?: number | null;
    ficheTu?: boolean | null;
    dossierDg?: boolean | null;
    dossierFm?: boolean | null;
    veutCanceller?: boolean | null;
    veutModifier?: boolean | null;
    valider?: boolean;
    lastModified?: moment.Moment | null;
    referencesGiven?: ReferencesTablette[] | null;
    contractInfos?: ContratInfo[] | null;
    address?: string | null;
    erpClientImports?: ERPClientImport[] | null;
}

export class AppelTm implements IAppelTm {
    noAppel?: number;
    grocerShop?: boolean;
    sexe?: number | null;
    iga?: boolean | null;
    metro?: boolean | null;
    maxi?: boolean | null;
    superc?: boolean | null;
    loblaws?: boolean | null;
    costco?: boolean | null;
    walmart?: boolean | null;
    autreSupermarche?: string | null;
    enLigneIga?: boolean | null;
    enLigneMetro?: boolean | null;
    enLigneMaxi?: boolean | null;
    enLigneWalmart?: boolean | null;
    enLigneGoodfood?: boolean | null;
    enLigneAutre?: boolean | null;
    viandeAcheteSupermarche?: boolean | null;
    viandeAcheteBoucherie?: boolean | null;
    budget?: number | null;
    adulte?: number | null;
    enfant?: number | null;
    animauxDomestiques?: number | null;
    typeAnimauxDeCompagnieChien?: boolean | null;
    typeAnimauxDeCompagnieChat?: boolean | null;
    typeAnimauxDeCompagniePoisson?: boolean | null;
    typeAnimauxDeCompagnieOiseau?: boolean | null;
    typeAnimauxDeCompagnieRongeur?: boolean | null;
    typeAnimauxDeCompagnieReptile?: boolean | null;
    typeAnimauxDeCompagnieLapin?: boolean | null;
    typeAnimauxDeCompagnieAutreOuExotique?: boolean | null;
    congelateur?: boolean | null;
    placeCongelateur?: boolean | null;
    grosseurCongel?: number | null;
    niveauCongel?: number | null;
    rendezVousDate?: moment.Moment | null;
    rendezVousHre?: string | null;
    nom?: string | null;
    prenom?: string | null;
    fullName?: string | null;
    conjoint?: string | null;
    prenomConjoint?: string | null;
    telephoneMaison?: number | null;
    cellulaire?: number | null;
    telephoneTravail?: number | null;
    posteTravail?: string | null;
    travailMonsieur?: string | null;
    travailMadame?: string | null;
    adresse?: string | null;
    ville?: string | null;
    code?: string | null;
    noSecteur?: number | null;
    courriel?: string | null;
    pasCourriel?: boolean | null;
    idOrigine?: string | null;
    pasIDOrigine?: boolean | null;
    proprietaire?: boolean | null;
    rueTransversale?: string | null;
    visa?: boolean | null;
    mastercard?: boolean | null;
    americanexpress?: boolean | null;
    autreCredit?: string | null;
    commentaire?: string | null;
    nomTm?: string | null;
    dateAppel?: moment.Moment | null;
    confirme?: boolean | null;
    confirmePar?: string | null;
    annuler?: boolean | null;
    annulerPar?: string | null;
    noVendeurReference?: number | null;
    vendeurReference?: Vendeur | null;
    noVendeurOrigine?: number | null;
    vendeurOrigine?: Vendeur | null;
    noVendeur?: number | null;
    vendeur?: Vendeur | null;
    noVendeurAd?: string | null;
    courrielEnvoye?: boolean | null;
    dateCourrielEnvoye?: moment.Moment | null;
    distCourrielEnvoye?: boolean | null;
    dateDistCourrielEnvoye?: moment.Moment | null;
    nomVendeur?: string | null;
    reference?: string | null;
    noClient?: number;
    client?: Client2 | null;
    noCommande?: number | null;
    noCampaign?: string | null;
    noIndexCampaign?: number | null;
    estRenouvellement?: boolean | null;
    estWinback?: boolean | null;
    estMajtablette?: boolean | null;
    statusAppel?: number | null;
    dateReporte?: moment.Moment | null;
    raisonConfirmation?: string | null;
    nbreReference?: number | null;
    montantCommande?: number | null;
    noMenu?: string | null;
    commentaireDistributeur?: string | null;
    noRoute?: number | null;
    qualifie?: boolean | null;
    nqualifie?: boolean | null;
    promos?: boolean | null;
    modifiePar?: string | null;
    modifieDate?: moment.Moment | null;
    vendeurConfirme?: boolean | null;
    enFaute?: boolean | null;
    dossierTraite?: boolean | null;
    veutCanceller?: boolean | null;
    veutModifier?: boolean | null;
    typeAppelWinBack?: number | null;
    langue?: boolean;
    langConfirme?: boolean;
    commande?: Commande | null;
    isVirtual?: boolean | null;
    appelEntrant?: boolean | null;
    ageRange?: number | null;
    viandeAcheteAutre?: boolean | null;
    viandeAcheteExotic?: boolean | null;
    viandeAcheteHalal?: boolean | null;
    appointmentConfirmed?: boolean | null;

    constructor(data?: IAppelTm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.noAppel = _data["noAppel"] !== undefined ? _data["noAppel"] : <any>null;
            this.grocerShop = _data["grocerShop"] !== undefined ? _data["grocerShop"] : <any>null;
            this.sexe = _data["sexe"] !== undefined ? _data["sexe"] : <any>null;
            this.iga = _data["iga"] !== undefined ? _data["iga"] : <any>null;
            this.metro = _data["metro"] !== undefined ? _data["metro"] : <any>null;
            this.maxi = _data["maxi"] !== undefined ? _data["maxi"] : <any>null;
            this.superc = _data["superc"] !== undefined ? _data["superc"] : <any>null;
            this.loblaws = _data["loblaws"] !== undefined ? _data["loblaws"] : <any>null;
            this.costco = _data["costco"] !== undefined ? _data["costco"] : <any>null;
            this.walmart = _data["walmart"] !== undefined ? _data["walmart"] : <any>null;
            this.autreSupermarche = _data["autreSupermarche"] !== undefined ? _data["autreSupermarche"] : <any>null;
            this.enLigneIga = _data["enLigneIga"] !== undefined ? _data["enLigneIga"] : <any>null;
            this.enLigneMetro = _data["enLigneMetro"] !== undefined ? _data["enLigneMetro"] : <any>null;
            this.enLigneMaxi = _data["enLigneMaxi"] !== undefined ? _data["enLigneMaxi"] : <any>null;
            this.enLigneWalmart = _data["enLigneWalmart"] !== undefined ? _data["enLigneWalmart"] : <any>null;
            this.enLigneGoodfood = _data["enLigneGoodfood"] !== undefined ? _data["enLigneGoodfood"] : <any>null;
            this.enLigneAutre = _data["enLigneAutre"] !== undefined ? _data["enLigneAutre"] : <any>null;
            this.viandeAcheteSupermarche = _data["viandeAcheteSupermarche"] !== undefined ? _data["viandeAcheteSupermarche"] : <any>null;
            this.viandeAcheteBoucherie = _data["viandeAcheteBoucherie"] !== undefined ? _data["viandeAcheteBoucherie"] : <any>null;
            this.budget = _data["budget"] !== undefined ? _data["budget"] : <any>null;
            this.adulte = _data["adulte"] !== undefined ? _data["adulte"] : <any>null;
            this.enfant = _data["enfant"] !== undefined ? _data["enfant"] : <any>null;
            this.animauxDomestiques = _data["animauxDomestiques"] !== undefined ? _data["animauxDomestiques"] : <any>null;
            this.typeAnimauxDeCompagnieChien = _data["typeAnimauxDeCompagnieChien"] !== undefined ? _data["typeAnimauxDeCompagnieChien"] : <any>null;
            this.typeAnimauxDeCompagnieChat = _data["typeAnimauxDeCompagnieChat"] !== undefined ? _data["typeAnimauxDeCompagnieChat"] : <any>null;
            this.typeAnimauxDeCompagniePoisson = _data["typeAnimauxDeCompagniePoisson"] !== undefined ? _data["typeAnimauxDeCompagniePoisson"] : <any>null;
            this.typeAnimauxDeCompagnieOiseau = _data["typeAnimauxDeCompagnieOiseau"] !== undefined ? _data["typeAnimauxDeCompagnieOiseau"] : <any>null;
            this.typeAnimauxDeCompagnieRongeur = _data["typeAnimauxDeCompagnieRongeur"] !== undefined ? _data["typeAnimauxDeCompagnieRongeur"] : <any>null;
            this.typeAnimauxDeCompagnieReptile = _data["typeAnimauxDeCompagnieReptile"] !== undefined ? _data["typeAnimauxDeCompagnieReptile"] : <any>null;
            this.typeAnimauxDeCompagnieLapin = _data["typeAnimauxDeCompagnieLapin"] !== undefined ? _data["typeAnimauxDeCompagnieLapin"] : <any>null;
            this.typeAnimauxDeCompagnieAutreOuExotique = _data["typeAnimauxDeCompagnieAutreOuExotique"] !== undefined ? _data["typeAnimauxDeCompagnieAutreOuExotique"] : <any>null;
            this.congelateur = _data["congelateur"] !== undefined ? _data["congelateur"] : <any>null;
            this.placeCongelateur = _data["placeCongelateur"] !== undefined ? _data["placeCongelateur"] : <any>null;
            this.grosseurCongel = _data["grosseurCongel"] !== undefined ? _data["grosseurCongel"] : <any>null;
            this.niveauCongel = _data["niveauCongel"] !== undefined ? _data["niveauCongel"] : <any>null;
            this.rendezVousDate = _data["rendezVousDate"] ? moment(_data["rendezVousDate"].toString()) : <any>null;
            this.rendezVousHre = _data["rendezVousHre"] !== undefined ? _data["rendezVousHre"] : <any>null;
            this.nom = _data["nom"] !== undefined ? _data["nom"] : <any>null;
            this.prenom = _data["prenom"] !== undefined ? _data["prenom"] : <any>null;
            this.fullName = _data["fullName"] !== undefined ? _data["fullName"] : <any>null;
            this.conjoint = _data["conjoint"] !== undefined ? _data["conjoint"] : <any>null;
            this.prenomConjoint = _data["prenomConjoint"] !== undefined ? _data["prenomConjoint"] : <any>null;
            this.telephoneMaison = _data["telephoneMaison"] !== undefined ? _data["telephoneMaison"] : <any>null;
            this.cellulaire = _data["cellulaire"] !== undefined ? _data["cellulaire"] : <any>null;
            this.telephoneTravail = _data["telephoneTravail"] !== undefined ? _data["telephoneTravail"] : <any>null;
            this.posteTravail = _data["posteTravail"] !== undefined ? _data["posteTravail"] : <any>null;
            this.travailMonsieur = _data["travailMonsieur"] !== undefined ? _data["travailMonsieur"] : <any>null;
            this.travailMadame = _data["travailMadame"] !== undefined ? _data["travailMadame"] : <any>null;
            this.adresse = _data["adresse"] !== undefined ? _data["adresse"] : <any>null;
            this.ville = _data["ville"] !== undefined ? _data["ville"] : <any>null;
            this.code = _data["code"] !== undefined ? _data["code"] : <any>null;
            this.noSecteur = _data["noSecteur"] !== undefined ? _data["noSecteur"] : <any>null;
            this.courriel = _data["courriel"] !== undefined ? _data["courriel"] : <any>null;
            this.pasCourriel = _data["pasCourriel"] !== undefined ? _data["pasCourriel"] : <any>null;
            this.idOrigine = _data["idOrigine"] !== undefined ? _data["idOrigine"] : <any>null;
            this.pasIDOrigine = _data["pasIDOrigine"] !== undefined ? _data["pasIDOrigine"] : <any>null;
            this.proprietaire = _data["proprietaire"] !== undefined ? _data["proprietaire"] : <any>null;
            this.rueTransversale = _data["rueTransversale"] !== undefined ? _data["rueTransversale"] : <any>null;
            this.visa = _data["visa"] !== undefined ? _data["visa"] : <any>null;
            this.mastercard = _data["mastercard"] !== undefined ? _data["mastercard"] : <any>null;
            this.americanexpress = _data["americanexpress"] !== undefined ? _data["americanexpress"] : <any>null;
            this.autreCredit = _data["autreCredit"] !== undefined ? _data["autreCredit"] : <any>null;
            this.commentaire = _data["commentaire"] !== undefined ? _data["commentaire"] : <any>null;
            this.nomTm = _data["nomTm"] !== undefined ? _data["nomTm"] : <any>null;
            this.dateAppel = _data["dateAppel"] ? moment(_data["dateAppel"].toString()) : <any>null;
            this.confirme = _data["confirme"] !== undefined ? _data["confirme"] : <any>null;
            this.confirmePar = _data["confirmePar"] !== undefined ? _data["confirmePar"] : <any>null;
            this.annuler = _data["annuler"] !== undefined ? _data["annuler"] : <any>null;
            this.annulerPar = _data["annulerPar"] !== undefined ? _data["annulerPar"] : <any>null;
            this.noVendeurReference = _data["noVendeurReference"] !== undefined ? _data["noVendeurReference"] : <any>null;
            this.vendeurReference = _data["vendeurReference"] ? Vendeur.fromJS(_data["vendeurReference"]) : <any>null;
            this.noVendeurOrigine = _data["noVendeurOrigine"] !== undefined ? _data["noVendeurOrigine"] : <any>null;
            this.vendeurOrigine = _data["vendeurOrigine"] ? Vendeur.fromJS(_data["vendeurOrigine"]) : <any>null;
            this.noVendeur = _data["noVendeur"] !== undefined ? _data["noVendeur"] : <any>null;
            this.vendeur = _data["vendeur"] ? Vendeur.fromJS(_data["vendeur"]) : <any>null;
            this.noVendeurAd = _data["noVendeurAd"] !== undefined ? _data["noVendeurAd"] : <any>null;
            this.courrielEnvoye = _data["courrielEnvoye"] !== undefined ? _data["courrielEnvoye"] : <any>null;
            this.dateCourrielEnvoye = _data["dateCourrielEnvoye"] ? moment(_data["dateCourrielEnvoye"].toString()) : <any>null;
            this.distCourrielEnvoye = _data["distCourrielEnvoye"] !== undefined ? _data["distCourrielEnvoye"] : <any>null;
            this.dateDistCourrielEnvoye = _data["dateDistCourrielEnvoye"] ? moment(_data["dateDistCourrielEnvoye"].toString()) : <any>null;
            this.nomVendeur = _data["nomVendeur"] !== undefined ? _data["nomVendeur"] : <any>null;
            this.reference = _data["reference"] !== undefined ? _data["reference"] : <any>null;
            this.noClient = _data["noClient"] !== undefined ? _data["noClient"] : <any>null;
            this.client = _data["client"] ? Client2.fromJS(_data["client"]) : <any>null;
            this.noCommande = _data["noCommande"] !== undefined ? _data["noCommande"] : <any>null;
            this.noCampaign = _data["noCampaign"] !== undefined ? _data["noCampaign"] : <any>null;
            this.noIndexCampaign = _data["noIndexCampaign"] !== undefined ? _data["noIndexCampaign"] : <any>null;
            this.estRenouvellement = _data["estRenouvellement"] !== undefined ? _data["estRenouvellement"] : <any>null;
            this.estWinback = _data["estWinback"] !== undefined ? _data["estWinback"] : <any>null;
            this.estMajtablette = _data["estMajtablette"] !== undefined ? _data["estMajtablette"] : <any>null;
            this.statusAppel = _data["statusAppel"] !== undefined ? _data["statusAppel"] : <any>null;
            this.dateReporte = _data["dateReporte"] ? moment(_data["dateReporte"].toString()) : <any>null;
            this.raisonConfirmation = _data["raisonConfirmation"] !== undefined ? _data["raisonConfirmation"] : <any>null;
            this.nbreReference = _data["nbreReference"] !== undefined ? _data["nbreReference"] : <any>null;
            this.montantCommande = _data["montantCommande"] !== undefined ? _data["montantCommande"] : <any>null;
            this.noMenu = _data["noMenu"] !== undefined ? _data["noMenu"] : <any>null;
            this.commentaireDistributeur = _data["commentaireDistributeur"] !== undefined ? _data["commentaireDistributeur"] : <any>null;
            this.noRoute = _data["noRoute"] !== undefined ? _data["noRoute"] : <any>null;
            this.qualifie = _data["qualifie"] !== undefined ? _data["qualifie"] : <any>null;
            this.nqualifie = _data["nqualifie"] !== undefined ? _data["nqualifie"] : <any>null;
            this.promos = _data["promos"] !== undefined ? _data["promos"] : <any>null;
            this.modifiePar = _data["modifiePar"] !== undefined ? _data["modifiePar"] : <any>null;
            this.modifieDate = _data["modifieDate"] ? moment(_data["modifieDate"].toString()) : <any>null;
            this.vendeurConfirme = _data["vendeurConfirme"] !== undefined ? _data["vendeurConfirme"] : <any>null;
            this.enFaute = _data["enFaute"] !== undefined ? _data["enFaute"] : <any>null;
            this.dossierTraite = _data["dossierTraite"] !== undefined ? _data["dossierTraite"] : <any>null;
            this.veutCanceller = _data["veutCanceller"] !== undefined ? _data["veutCanceller"] : <any>null;
            this.veutModifier = _data["veutModifier"] !== undefined ? _data["veutModifier"] : <any>null;
            this.typeAppelWinBack = _data["typeAppelWinBack"] !== undefined ? _data["typeAppelWinBack"] : <any>null;
            this.langue = _data["langue"] !== undefined ? _data["langue"] : <any>null;
            this.langConfirme = _data["langConfirme"] !== undefined ? _data["langConfirme"] : <any>null;
            this.commande = _data["commande"] ? Commande.fromJS(_data["commande"]) : <any>null;
            this.isVirtual = _data["isVirtual"] !== undefined ? _data["isVirtual"] : <any>null;
            this.appelEntrant = _data["appelEntrant"] !== undefined ? _data["appelEntrant"] : <any>null;
            this.ageRange = _data["ageRange"] !== undefined ? _data["ageRange"] : <any>null;
            this.viandeAcheteAutre = _data["viandeAcheteAutre"] !== undefined ? _data["viandeAcheteAutre"] : <any>null;
            this.viandeAcheteExotic = _data["viandeAcheteExotic"] !== undefined ? _data["viandeAcheteExotic"] : <any>null;
            this.viandeAcheteHalal = _data["viandeAcheteHalal"] !== undefined ? _data["viandeAcheteHalal"] : <any>null;
            this.appointmentConfirmed = _data["appointmentConfirmed"] !== undefined ? _data["appointmentConfirmed"] : <any>null;
        }
    }

    static fromJS(data: any): AppelTm {
        data = typeof data === 'object' ? data : {};
        let result = new AppelTm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["noAppel"] = this.noAppel !== undefined ? this.noAppel : <any>null;
        data["grocerShop"] = this.grocerShop !== undefined ? this.grocerShop : <any>null;
        data["sexe"] = this.sexe !== undefined ? this.sexe : <any>null;
        data["iga"] = this.iga !== undefined ? this.iga : <any>null;
        data["metro"] = this.metro !== undefined ? this.metro : <any>null;
        data["maxi"] = this.maxi !== undefined ? this.maxi : <any>null;
        data["superc"] = this.superc !== undefined ? this.superc : <any>null;
        data["loblaws"] = this.loblaws !== undefined ? this.loblaws : <any>null;
        data["costco"] = this.costco !== undefined ? this.costco : <any>null;
        data["walmart"] = this.walmart !== undefined ? this.walmart : <any>null;
        data["autreSupermarche"] = this.autreSupermarche !== undefined ? this.autreSupermarche : <any>null;
        data["enLigneIga"] = this.enLigneIga !== undefined ? this.enLigneIga : <any>null;
        data["enLigneMetro"] = this.enLigneMetro !== undefined ? this.enLigneMetro : <any>null;
        data["enLigneMaxi"] = this.enLigneMaxi !== undefined ? this.enLigneMaxi : <any>null;
        data["enLigneWalmart"] = this.enLigneWalmart !== undefined ? this.enLigneWalmart : <any>null;
        data["enLigneGoodfood"] = this.enLigneGoodfood !== undefined ? this.enLigneGoodfood : <any>null;
        data["enLigneAutre"] = this.enLigneAutre !== undefined ? this.enLigneAutre : <any>null;
        data["viandeAcheteSupermarche"] = this.viandeAcheteSupermarche !== undefined ? this.viandeAcheteSupermarche : <any>null;
        data["viandeAcheteBoucherie"] = this.viandeAcheteBoucherie !== undefined ? this.viandeAcheteBoucherie : <any>null;
        data["budget"] = this.budget !== undefined ? this.budget : <any>null;
        data["adulte"] = this.adulte !== undefined ? this.adulte : <any>null;
        data["enfant"] = this.enfant !== undefined ? this.enfant : <any>null;
        data["animauxDomestiques"] = this.animauxDomestiques !== undefined ? this.animauxDomestiques : <any>null;
        data["typeAnimauxDeCompagnieChien"] = this.typeAnimauxDeCompagnieChien !== undefined ? this.typeAnimauxDeCompagnieChien : <any>null;
        data["typeAnimauxDeCompagnieChat"] = this.typeAnimauxDeCompagnieChat !== undefined ? this.typeAnimauxDeCompagnieChat : <any>null;
        data["typeAnimauxDeCompagniePoisson"] = this.typeAnimauxDeCompagniePoisson !== undefined ? this.typeAnimauxDeCompagniePoisson : <any>null;
        data["typeAnimauxDeCompagnieOiseau"] = this.typeAnimauxDeCompagnieOiseau !== undefined ? this.typeAnimauxDeCompagnieOiseau : <any>null;
        data["typeAnimauxDeCompagnieRongeur"] = this.typeAnimauxDeCompagnieRongeur !== undefined ? this.typeAnimauxDeCompagnieRongeur : <any>null;
        data["typeAnimauxDeCompagnieReptile"] = this.typeAnimauxDeCompagnieReptile !== undefined ? this.typeAnimauxDeCompagnieReptile : <any>null;
        data["typeAnimauxDeCompagnieLapin"] = this.typeAnimauxDeCompagnieLapin !== undefined ? this.typeAnimauxDeCompagnieLapin : <any>null;
        data["typeAnimauxDeCompagnieAutreOuExotique"] = this.typeAnimauxDeCompagnieAutreOuExotique !== undefined ? this.typeAnimauxDeCompagnieAutreOuExotique : <any>null;
        data["congelateur"] = this.congelateur !== undefined ? this.congelateur : <any>null;
        data["placeCongelateur"] = this.placeCongelateur !== undefined ? this.placeCongelateur : <any>null;
        data["grosseurCongel"] = this.grosseurCongel !== undefined ? this.grosseurCongel : <any>null;
        data["niveauCongel"] = this.niveauCongel !== undefined ? this.niveauCongel : <any>null;
        data["rendezVousDate"] = this.rendezVousDate ? this.rendezVousDate.toISOString() : <any>null;
        data["rendezVousHre"] = this.rendezVousHre !== undefined ? this.rendezVousHre : <any>null;
        data["nom"] = this.nom !== undefined ? this.nom : <any>null;
        data["prenom"] = this.prenom !== undefined ? this.prenom : <any>null;
        data["fullName"] = this.fullName !== undefined ? this.fullName : <any>null;
        data["conjoint"] = this.conjoint !== undefined ? this.conjoint : <any>null;
        data["prenomConjoint"] = this.prenomConjoint !== undefined ? this.prenomConjoint : <any>null;
        data["telephoneMaison"] = this.telephoneMaison !== undefined ? this.telephoneMaison : <any>null;
        data["cellulaire"] = this.cellulaire !== undefined ? this.cellulaire : <any>null;
        data["telephoneTravail"] = this.telephoneTravail !== undefined ? this.telephoneTravail : <any>null;
        data["posteTravail"] = this.posteTravail !== undefined ? this.posteTravail : <any>null;
        data["travailMonsieur"] = this.travailMonsieur !== undefined ? this.travailMonsieur : <any>null;
        data["travailMadame"] = this.travailMadame !== undefined ? this.travailMadame : <any>null;
        data["adresse"] = this.adresse !== undefined ? this.adresse : <any>null;
        data["ville"] = this.ville !== undefined ? this.ville : <any>null;
        data["code"] = this.code !== undefined ? this.code : <any>null;
        data["noSecteur"] = this.noSecteur !== undefined ? this.noSecteur : <any>null;
        data["courriel"] = this.courriel !== undefined ? this.courriel : <any>null;
        data["pasCourriel"] = this.pasCourriel !== undefined ? this.pasCourriel : <any>null;
        data["idOrigine"] = this.idOrigine !== undefined ? this.idOrigine : <any>null;
        data["pasIDOrigine"] = this.pasIDOrigine !== undefined ? this.pasIDOrigine : <any>null;
        data["proprietaire"] = this.proprietaire !== undefined ? this.proprietaire : <any>null;
        data["rueTransversale"] = this.rueTransversale !== undefined ? this.rueTransversale : <any>null;
        data["visa"] = this.visa !== undefined ? this.visa : <any>null;
        data["mastercard"] = this.mastercard !== undefined ? this.mastercard : <any>null;
        data["americanexpress"] = this.americanexpress !== undefined ? this.americanexpress : <any>null;
        data["autreCredit"] = this.autreCredit !== undefined ? this.autreCredit : <any>null;
        data["commentaire"] = this.commentaire !== undefined ? this.commentaire : <any>null;
        data["nomTm"] = this.nomTm !== undefined ? this.nomTm : <any>null;
        data["dateAppel"] = this.dateAppel ? this.dateAppel.toISOString() : <any>null;
        data["confirme"] = this.confirme !== undefined ? this.confirme : <any>null;
        data["confirmePar"] = this.confirmePar !== undefined ? this.confirmePar : <any>null;
        data["annuler"] = this.annuler !== undefined ? this.annuler : <any>null;
        data["annulerPar"] = this.annulerPar !== undefined ? this.annulerPar : <any>null;
        data["noVendeurReference"] = this.noVendeurReference !== undefined ? this.noVendeurReference : <any>null;
        data["vendeurReference"] = this.vendeurReference ? this.vendeurReference.toJSON() : <any>null;
        data["noVendeurOrigine"] = this.noVendeurOrigine !== undefined ? this.noVendeurOrigine : <any>null;
        data["vendeurOrigine"] = this.vendeurOrigine ? this.vendeurOrigine.toJSON() : <any>null;
        data["noVendeur"] = this.noVendeur !== undefined ? this.noVendeur : <any>null;
        data["vendeur"] = this.vendeur ? this.vendeur.toJSON() : <any>null;
        data["noVendeurAd"] = this.noVendeurAd !== undefined ? this.noVendeurAd : <any>null;
        data["courrielEnvoye"] = this.courrielEnvoye !== undefined ? this.courrielEnvoye : <any>null;
        data["dateCourrielEnvoye"] = this.dateCourrielEnvoye ? this.dateCourrielEnvoye.toISOString() : <any>null;
        data["distCourrielEnvoye"] = this.distCourrielEnvoye !== undefined ? this.distCourrielEnvoye : <any>null;
        data["dateDistCourrielEnvoye"] = this.dateDistCourrielEnvoye ? this.dateDistCourrielEnvoye.toISOString() : <any>null;
        data["nomVendeur"] = this.nomVendeur !== undefined ? this.nomVendeur : <any>null;
        data["reference"] = this.reference !== undefined ? this.reference : <any>null;
        data["noClient"] = this.noClient !== undefined ? this.noClient : <any>null;
        data["client"] = this.client ? this.client.toJSON() : <any>null;
        data["noCommande"] = this.noCommande !== undefined ? this.noCommande : <any>null;
        data["noCampaign"] = this.noCampaign !== undefined ? this.noCampaign : <any>null;
        data["noIndexCampaign"] = this.noIndexCampaign !== undefined ? this.noIndexCampaign : <any>null;
        data["estRenouvellement"] = this.estRenouvellement !== undefined ? this.estRenouvellement : <any>null;
        data["estWinback"] = this.estWinback !== undefined ? this.estWinback : <any>null;
        data["estMajtablette"] = this.estMajtablette !== undefined ? this.estMajtablette : <any>null;
        data["statusAppel"] = this.statusAppel !== undefined ? this.statusAppel : <any>null;
        data["dateReporte"] = this.dateReporte ? this.dateReporte.toISOString() : <any>null;
        data["raisonConfirmation"] = this.raisonConfirmation !== undefined ? this.raisonConfirmation : <any>null;
        data["nbreReference"] = this.nbreReference !== undefined ? this.nbreReference : <any>null;
        data["montantCommande"] = this.montantCommande !== undefined ? this.montantCommande : <any>null;
        data["noMenu"] = this.noMenu !== undefined ? this.noMenu : <any>null;
        data["commentaireDistributeur"] = this.commentaireDistributeur !== undefined ? this.commentaireDistributeur : <any>null;
        data["noRoute"] = this.noRoute !== undefined ? this.noRoute : <any>null;
        data["qualifie"] = this.qualifie !== undefined ? this.qualifie : <any>null;
        data["nqualifie"] = this.nqualifie !== undefined ? this.nqualifie : <any>null;
        data["promos"] = this.promos !== undefined ? this.promos : <any>null;
        data["modifiePar"] = this.modifiePar !== undefined ? this.modifiePar : <any>null;
        data["modifieDate"] = this.modifieDate ? this.modifieDate.toISOString() : <any>null;
        data["vendeurConfirme"] = this.vendeurConfirme !== undefined ? this.vendeurConfirme : <any>null;
        data["enFaute"] = this.enFaute !== undefined ? this.enFaute : <any>null;
        data["dossierTraite"] = this.dossierTraite !== undefined ? this.dossierTraite : <any>null;
        data["veutCanceller"] = this.veutCanceller !== undefined ? this.veutCanceller : <any>null;
        data["veutModifier"] = this.veutModifier !== undefined ? this.veutModifier : <any>null;
        data["typeAppelWinBack"] = this.typeAppelWinBack !== undefined ? this.typeAppelWinBack : <any>null;
        data["langue"] = this.langue !== undefined ? this.langue : <any>null;
        data["langConfirme"] = this.langConfirme !== undefined ? this.langConfirme : <any>null;
        data["commande"] = this.commande ? this.commande.toJSON() : <any>null;
        data["isVirtual"] = this.isVirtual !== undefined ? this.isVirtual : <any>null;
        data["appelEntrant"] = this.appelEntrant !== undefined ? this.appelEntrant : <any>null;
        data["ageRange"] = this.ageRange !== undefined ? this.ageRange : <any>null;
        data["viandeAcheteAutre"] = this.viandeAcheteAutre !== undefined ? this.viandeAcheteAutre : <any>null;
        data["viandeAcheteExotic"] = this.viandeAcheteExotic !== undefined ? this.viandeAcheteExotic : <any>null;
        data["viandeAcheteHalal"] = this.viandeAcheteHalal !== undefined ? this.viandeAcheteHalal : <any>null;
        data["appointmentConfirmed"] = this.appointmentConfirmed !== undefined ? this.appointmentConfirmed : <any>null;
        return data;
    }
}

export interface IAppelTm {
    noAppel?: number;
    grocerShop?: boolean;
    sexe?: number | null;
    iga?: boolean | null;
    metro?: boolean | null;
    maxi?: boolean | null;
    superc?: boolean | null;
    loblaws?: boolean | null;
    costco?: boolean | null;
    walmart?: boolean | null;
    autreSupermarche?: string | null;
    enLigneIga?: boolean | null;
    enLigneMetro?: boolean | null;
    enLigneMaxi?: boolean | null;
    enLigneWalmart?: boolean | null;
    enLigneGoodfood?: boolean | null;
    enLigneAutre?: boolean | null;
    viandeAcheteSupermarche?: boolean | null;
    viandeAcheteBoucherie?: boolean | null;
    budget?: number | null;
    adulte?: number | null;
    enfant?: number | null;
    animauxDomestiques?: number | null;
    typeAnimauxDeCompagnieChien?: boolean | null;
    typeAnimauxDeCompagnieChat?: boolean | null;
    typeAnimauxDeCompagniePoisson?: boolean | null;
    typeAnimauxDeCompagnieOiseau?: boolean | null;
    typeAnimauxDeCompagnieRongeur?: boolean | null;
    typeAnimauxDeCompagnieReptile?: boolean | null;
    typeAnimauxDeCompagnieLapin?: boolean | null;
    typeAnimauxDeCompagnieAutreOuExotique?: boolean | null;
    congelateur?: boolean | null;
    placeCongelateur?: boolean | null;
    grosseurCongel?: number | null;
    niveauCongel?: number | null;
    rendezVousDate?: moment.Moment | null;
    rendezVousHre?: string | null;
    nom?: string | null;
    prenom?: string | null;
    fullName?: string | null;
    conjoint?: string | null;
    prenomConjoint?: string | null;
    telephoneMaison?: number | null;
    cellulaire?: number | null;
    telephoneTravail?: number | null;
    posteTravail?: string | null;
    travailMonsieur?: string | null;
    travailMadame?: string | null;
    adresse?: string | null;
    ville?: string | null;
    code?: string | null;
    noSecteur?: number | null;
    courriel?: string | null;
    pasCourriel?: boolean | null;
    idOrigine?: string | null;
    pasIDOrigine?: boolean | null;
    proprietaire?: boolean | null;
    rueTransversale?: string | null;
    visa?: boolean | null;
    mastercard?: boolean | null;
    americanexpress?: boolean | null;
    autreCredit?: string | null;
    commentaire?: string | null;
    nomTm?: string | null;
    dateAppel?: moment.Moment | null;
    confirme?: boolean | null;
    confirmePar?: string | null;
    annuler?: boolean | null;
    annulerPar?: string | null;
    noVendeurReference?: number | null;
    vendeurReference?: Vendeur | null;
    noVendeurOrigine?: number | null;
    vendeurOrigine?: Vendeur | null;
    noVendeur?: number | null;
    vendeur?: Vendeur | null;
    noVendeurAd?: string | null;
    courrielEnvoye?: boolean | null;
    dateCourrielEnvoye?: moment.Moment | null;
    distCourrielEnvoye?: boolean | null;
    dateDistCourrielEnvoye?: moment.Moment | null;
    nomVendeur?: string | null;
    reference?: string | null;
    noClient?: number;
    client?: Client2 | null;
    noCommande?: number | null;
    noCampaign?: string | null;
    noIndexCampaign?: number | null;
    estRenouvellement?: boolean | null;
    estWinback?: boolean | null;
    estMajtablette?: boolean | null;
    statusAppel?: number | null;
    dateReporte?: moment.Moment | null;
    raisonConfirmation?: string | null;
    nbreReference?: number | null;
    montantCommande?: number | null;
    noMenu?: string | null;
    commentaireDistributeur?: string | null;
    noRoute?: number | null;
    qualifie?: boolean | null;
    nqualifie?: boolean | null;
    promos?: boolean | null;
    modifiePar?: string | null;
    modifieDate?: moment.Moment | null;
    vendeurConfirme?: boolean | null;
    enFaute?: boolean | null;
    dossierTraite?: boolean | null;
    veutCanceller?: boolean | null;
    veutModifier?: boolean | null;
    typeAppelWinBack?: number | null;
    langue?: boolean;
    langConfirme?: boolean;
    commande?: Commande | null;
    isVirtual?: boolean | null;
    appelEntrant?: boolean | null;
    ageRange?: number | null;
    viandeAcheteAutre?: boolean | null;
    viandeAcheteExotic?: boolean | null;
    viandeAcheteHalal?: boolean | null;
    appointmentConfirmed?: boolean | null;
}

export class Vendeur implements IVendeur {
    noVendeur?: number;
    nom?: string | null;
    taxes?: boolean | null;
    notps?: string | null;
    notvq?: string | null;
    accesliste?: boolean | null;
    motdepass?: string | null;
    distribution?: number | null;
    courriel?: string | null;
    inactif?: boolean | null;
    noRegion?: number | null;
    listeVente?: boolean | null;
    estGrocerShop?: boolean | null;
    accesTablette?: boolean | null;
    estEmploye?: boolean | null;
    assignedAppels?: AppelTm[] | null;
    referredAppels?: AppelTm[] | null;
    assignedByAgentAppels?: AppelTm[] | null;

    constructor(data?: IVendeur) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.noVendeur = _data["noVendeur"] !== undefined ? _data["noVendeur"] : <any>null;
            this.nom = _data["nom"] !== undefined ? _data["nom"] : <any>null;
            this.taxes = _data["taxes"] !== undefined ? _data["taxes"] : <any>null;
            this.notps = _data["notps"] !== undefined ? _data["notps"] : <any>null;
            this.notvq = _data["notvq"] !== undefined ? _data["notvq"] : <any>null;
            this.accesliste = _data["accesliste"] !== undefined ? _data["accesliste"] : <any>null;
            this.motdepass = _data["motdepass"] !== undefined ? _data["motdepass"] : <any>null;
            this.distribution = _data["distribution"] !== undefined ? _data["distribution"] : <any>null;
            this.courriel = _data["courriel"] !== undefined ? _data["courriel"] : <any>null;
            this.inactif = _data["inactif"] !== undefined ? _data["inactif"] : <any>null;
            this.noRegion = _data["noRegion"] !== undefined ? _data["noRegion"] : <any>null;
            this.listeVente = _data["listeVente"] !== undefined ? _data["listeVente"] : <any>null;
            this.estGrocerShop = _data["estGrocerShop"] !== undefined ? _data["estGrocerShop"] : <any>null;
            this.accesTablette = _data["accesTablette"] !== undefined ? _data["accesTablette"] : <any>null;
            this.estEmploye = _data["estEmploye"] !== undefined ? _data["estEmploye"] : <any>null;
            if (Array.isArray(_data["assignedAppels"])) {
                this.assignedAppels = [] as any;
                for (let item of _data["assignedAppels"])
                    this.assignedAppels!.push(AppelTm.fromJS(item));
            }
            else {
                this.assignedAppels = <any>null;
            }
            if (Array.isArray(_data["referredAppels"])) {
                this.referredAppels = [] as any;
                for (let item of _data["referredAppels"])
                    this.referredAppels!.push(AppelTm.fromJS(item));
            }
            else {
                this.referredAppels = <any>null;
            }
            if (Array.isArray(_data["assignedByAgentAppels"])) {
                this.assignedByAgentAppels = [] as any;
                for (let item of _data["assignedByAgentAppels"])
                    this.assignedByAgentAppels!.push(AppelTm.fromJS(item));
            }
            else {
                this.assignedByAgentAppels = <any>null;
            }
        }
    }

    static fromJS(data: any): Vendeur {
        data = typeof data === 'object' ? data : {};
        let result = new Vendeur();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["noVendeur"] = this.noVendeur !== undefined ? this.noVendeur : <any>null;
        data["nom"] = this.nom !== undefined ? this.nom : <any>null;
        data["taxes"] = this.taxes !== undefined ? this.taxes : <any>null;
        data["notps"] = this.notps !== undefined ? this.notps : <any>null;
        data["notvq"] = this.notvq !== undefined ? this.notvq : <any>null;
        data["accesliste"] = this.accesliste !== undefined ? this.accesliste : <any>null;
        data["motdepass"] = this.motdepass !== undefined ? this.motdepass : <any>null;
        data["distribution"] = this.distribution !== undefined ? this.distribution : <any>null;
        data["courriel"] = this.courriel !== undefined ? this.courriel : <any>null;
        data["inactif"] = this.inactif !== undefined ? this.inactif : <any>null;
        data["noRegion"] = this.noRegion !== undefined ? this.noRegion : <any>null;
        data["listeVente"] = this.listeVente !== undefined ? this.listeVente : <any>null;
        data["estGrocerShop"] = this.estGrocerShop !== undefined ? this.estGrocerShop : <any>null;
        data["accesTablette"] = this.accesTablette !== undefined ? this.accesTablette : <any>null;
        data["estEmploye"] = this.estEmploye !== undefined ? this.estEmploye : <any>null;
        if (Array.isArray(this.assignedAppels)) {
            data["assignedAppels"] = [];
            for (let item of this.assignedAppels)
                data["assignedAppels"].push(item.toJSON());
        }
        if (Array.isArray(this.referredAppels)) {
            data["referredAppels"] = [];
            for (let item of this.referredAppels)
                data["referredAppels"].push(item.toJSON());
        }
        if (Array.isArray(this.assignedByAgentAppels)) {
            data["assignedByAgentAppels"] = [];
            for (let item of this.assignedByAgentAppels)
                data["assignedByAgentAppels"].push(item.toJSON());
        }
        return data;
    }
}

export interface IVendeur {
    noVendeur?: number;
    nom?: string | null;
    taxes?: boolean | null;
    notps?: string | null;
    notvq?: string | null;
    accesliste?: boolean | null;
    motdepass?: string | null;
    distribution?: number | null;
    courriel?: string | null;
    inactif?: boolean | null;
    noRegion?: number | null;
    listeVente?: boolean | null;
    estGrocerShop?: boolean | null;
    accesTablette?: boolean | null;
    estEmploye?: boolean | null;
    assignedAppels?: AppelTm[] | null;
    referredAppels?: AppelTm[] | null;
    assignedByAgentAppels?: AppelTm[] | null;
}

export enum CommandeType {
    New = "new",
    Renewal = "renewal",
    Second = "second",
}

export class ReferencesTablette implements IReferencesTablette {
    noReference?: number;
    noClient?: number | null;
    client?: Client2 | null;
    noCommande?: number | null;
    nom?: string | null;
    ville?: string | null;
    telephone?: string | null;
    relation?: string | null;
    commande?: Commande | null;

    constructor(data?: IReferencesTablette) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.noReference = _data["noReference"] !== undefined ? _data["noReference"] : <any>null;
            this.noClient = _data["noClient"] !== undefined ? _data["noClient"] : <any>null;
            this.client = _data["client"] ? Client2.fromJS(_data["client"]) : <any>null;
            this.noCommande = _data["noCommande"] !== undefined ? _data["noCommande"] : <any>null;
            this.nom = _data["nom"] !== undefined ? _data["nom"] : <any>null;
            this.ville = _data["ville"] !== undefined ? _data["ville"] : <any>null;
            this.telephone = _data["telephone"] !== undefined ? _data["telephone"] : <any>null;
            this.relation = _data["relation"] !== undefined ? _data["relation"] : <any>null;
            this.commande = _data["commande"] ? Commande.fromJS(_data["commande"]) : <any>null;
        }
    }

    static fromJS(data: any): ReferencesTablette {
        data = typeof data === 'object' ? data : {};
        let result = new ReferencesTablette();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["noReference"] = this.noReference !== undefined ? this.noReference : <any>null;
        data["noClient"] = this.noClient !== undefined ? this.noClient : <any>null;
        data["client"] = this.client ? this.client.toJSON() : <any>null;
        data["noCommande"] = this.noCommande !== undefined ? this.noCommande : <any>null;
        data["nom"] = this.nom !== undefined ? this.nom : <any>null;
        data["ville"] = this.ville !== undefined ? this.ville : <any>null;
        data["telephone"] = this.telephone !== undefined ? this.telephone : <any>null;
        data["relation"] = this.relation !== undefined ? this.relation : <any>null;
        data["commande"] = this.commande ? this.commande.toJSON() : <any>null;
        return data;
    }
}

export interface IReferencesTablette {
    noReference?: number;
    noClient?: number | null;
    client?: Client2 | null;
    noCommande?: number | null;
    nom?: string | null;
    ville?: string | null;
    telephone?: string | null;
    relation?: string | null;
    commande?: Commande | null;
}

export class ContratInfo implements IContratInfo {
    noContratInfo?: number;
    noClient?: number | null;
    client?: Client2 | null;
    noAppelTm?: number | null;
    dateEntree?: moment.Moment | null;
    dateVente?: moment.Moment | null;
    typeCommande?: number | null;
    noVendeur?: number | null;
    noDist?: number | null;
    noTm?: number | null;
    nbreReference?: number | null;
    noMenu?: string | null;
    anglais?: boolean | null;
    nbrLivraison?: number | null;
    coutOperation?: number | null;
    couponRenou?: boolean | null;
    coupon?: number | null;
    paiement?: number | null;
    sequencePaiement?: string | null;
    chequePostDate?: boolean | null;
    sequence?: number | null;
    utilisateur?: string | null;

    constructor(data?: IContratInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.noContratInfo = _data["noContratInfo"] !== undefined ? _data["noContratInfo"] : <any>null;
            this.noClient = _data["noClient"] !== undefined ? _data["noClient"] : <any>null;
            this.client = _data["client"] ? Client2.fromJS(_data["client"]) : <any>null;
            this.noAppelTm = _data["noAppelTm"] !== undefined ? _data["noAppelTm"] : <any>null;
            this.dateEntree = _data["dateEntree"] ? moment(_data["dateEntree"].toString()) : <any>null;
            this.dateVente = _data["dateVente"] ? moment(_data["dateVente"].toString()) : <any>null;
            this.typeCommande = _data["typeCommande"] !== undefined ? _data["typeCommande"] : <any>null;
            this.noVendeur = _data["noVendeur"] !== undefined ? _data["noVendeur"] : <any>null;
            this.noDist = _data["noDist"] !== undefined ? _data["noDist"] : <any>null;
            this.noTm = _data["noTm"] !== undefined ? _data["noTm"] : <any>null;
            this.nbreReference = _data["nbreReference"] !== undefined ? _data["nbreReference"] : <any>null;
            this.noMenu = _data["noMenu"] !== undefined ? _data["noMenu"] : <any>null;
            this.anglais = _data["anglais"] !== undefined ? _data["anglais"] : <any>null;
            this.nbrLivraison = _data["nbrLivraison"] !== undefined ? _data["nbrLivraison"] : <any>null;
            this.coutOperation = _data["coutOperation"] !== undefined ? _data["coutOperation"] : <any>null;
            this.couponRenou = _data["couponRenou"] !== undefined ? _data["couponRenou"] : <any>null;
            this.coupon = _data["coupon"] !== undefined ? _data["coupon"] : <any>null;
            this.paiement = _data["paiement"] !== undefined ? _data["paiement"] : <any>null;
            this.sequencePaiement = _data["sequencePaiement"] !== undefined ? _data["sequencePaiement"] : <any>null;
            this.chequePostDate = _data["chequePostDate"] !== undefined ? _data["chequePostDate"] : <any>null;
            this.sequence = _data["sequence"] !== undefined ? _data["sequence"] : <any>null;
            this.utilisateur = _data["utilisateur"] !== undefined ? _data["utilisateur"] : <any>null;
        }
    }

    static fromJS(data: any): ContratInfo {
        data = typeof data === 'object' ? data : {};
        let result = new ContratInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["noContratInfo"] = this.noContratInfo !== undefined ? this.noContratInfo : <any>null;
        data["noClient"] = this.noClient !== undefined ? this.noClient : <any>null;
        data["client"] = this.client ? this.client.toJSON() : <any>null;
        data["noAppelTm"] = this.noAppelTm !== undefined ? this.noAppelTm : <any>null;
        data["dateEntree"] = this.dateEntree ? this.dateEntree.toISOString() : <any>null;
        data["dateVente"] = this.dateVente ? this.dateVente.toISOString() : <any>null;
        data["typeCommande"] = this.typeCommande !== undefined ? this.typeCommande : <any>null;
        data["noVendeur"] = this.noVendeur !== undefined ? this.noVendeur : <any>null;
        data["noDist"] = this.noDist !== undefined ? this.noDist : <any>null;
        data["noTm"] = this.noTm !== undefined ? this.noTm : <any>null;
        data["nbreReference"] = this.nbreReference !== undefined ? this.nbreReference : <any>null;
        data["noMenu"] = this.noMenu !== undefined ? this.noMenu : <any>null;
        data["anglais"] = this.anglais !== undefined ? this.anglais : <any>null;
        data["nbrLivraison"] = this.nbrLivraison !== undefined ? this.nbrLivraison : <any>null;
        data["coutOperation"] = this.coutOperation !== undefined ? this.coutOperation : <any>null;
        data["couponRenou"] = this.couponRenou !== undefined ? this.couponRenou : <any>null;
        data["coupon"] = this.coupon !== undefined ? this.coupon : <any>null;
        data["paiement"] = this.paiement !== undefined ? this.paiement : <any>null;
        data["sequencePaiement"] = this.sequencePaiement !== undefined ? this.sequencePaiement : <any>null;
        data["chequePostDate"] = this.chequePostDate !== undefined ? this.chequePostDate : <any>null;
        data["sequence"] = this.sequence !== undefined ? this.sequence : <any>null;
        data["utilisateur"] = this.utilisateur !== undefined ? this.utilisateur : <any>null;
        return data;
    }
}

export interface IContratInfo {
    noContratInfo?: number;
    noClient?: number | null;
    client?: Client2 | null;
    noAppelTm?: number | null;
    dateEntree?: moment.Moment | null;
    dateVente?: moment.Moment | null;
    typeCommande?: number | null;
    noVendeur?: number | null;
    noDist?: number | null;
    noTm?: number | null;
    nbreReference?: number | null;
    noMenu?: string | null;
    anglais?: boolean | null;
    nbrLivraison?: number | null;
    coutOperation?: number | null;
    couponRenou?: boolean | null;
    coupon?: number | null;
    paiement?: number | null;
    sequencePaiement?: string | null;
    chequePostDate?: boolean | null;
    sequence?: number | null;
    utilisateur?: string | null;
}

export class ERPClientImport implements IERPClientImport {
    id?: number;
    importException?: string | null;
    importSucceeded?: boolean;
    importedDateTime?: moment.Moment | null;
    importedIntoTenant?: string | null;
    client?: Client2 | null;
    noClient?: number;
    importDuration?: number;

    constructor(data?: IERPClientImport) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.importException = _data["importException"] !== undefined ? _data["importException"] : <any>null;
            this.importSucceeded = _data["importSucceeded"] !== undefined ? _data["importSucceeded"] : <any>null;
            this.importedDateTime = _data["importedDateTime"] ? moment(_data["importedDateTime"].toString()) : <any>null;
            this.importedIntoTenant = _data["importedIntoTenant"] !== undefined ? _data["importedIntoTenant"] : <any>null;
            this.client = _data["client"] ? Client2.fromJS(_data["client"]) : <any>null;
            this.noClient = _data["noClient"] !== undefined ? _data["noClient"] : <any>null;
            this.importDuration = _data["importDuration"] !== undefined ? _data["importDuration"] : <any>null;
        }
    }

    static fromJS(data: any): ERPClientImport {
        data = typeof data === 'object' ? data : {};
        let result = new ERPClientImport();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["importException"] = this.importException !== undefined ? this.importException : <any>null;
        data["importSucceeded"] = this.importSucceeded !== undefined ? this.importSucceeded : <any>null;
        data["importedDateTime"] = this.importedDateTime ? this.importedDateTime.toISOString() : <any>null;
        data["importedIntoTenant"] = this.importedIntoTenant !== undefined ? this.importedIntoTenant : <any>null;
        data["client"] = this.client ? this.client.toJSON() : <any>null;
        data["noClient"] = this.noClient !== undefined ? this.noClient : <any>null;
        data["importDuration"] = this.importDuration !== undefined ? this.importDuration : <any>null;
        return data;
    }
}

export interface IERPClientImport {
    id?: number;
    importException?: string | null;
    importSucceeded?: boolean;
    importedDateTime?: moment.Moment | null;
    importedIntoTenant?: string | null;
    client?: Client2 | null;
    noClient?: number;
    importDuration?: number;
}

export class Livraison implements ILivraison {
    noLivraison?: number;
    noCommande?: number;
    commande?: Commande | null;
    dateLivraison?: moment.Moment;
    dateMiseJour?: moment.Moment | null;
    majfaitePar?: string | null;
    noRoute?: number | null;
    nbreLivraisonAt?: number | null;

    constructor(data?: ILivraison) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.noLivraison = _data["noLivraison"] !== undefined ? _data["noLivraison"] : <any>null;
            this.noCommande = _data["noCommande"] !== undefined ? _data["noCommande"] : <any>null;
            this.commande = _data["commande"] ? Commande.fromJS(_data["commande"]) : <any>null;
            this.dateLivraison = _data["dateLivraison"] ? moment(_data["dateLivraison"].toString()) : <any>null;
            this.dateMiseJour = _data["dateMiseJour"] ? moment(_data["dateMiseJour"].toString()) : <any>null;
            this.majfaitePar = _data["majfaitePar"] !== undefined ? _data["majfaitePar"] : <any>null;
            this.noRoute = _data["noRoute"] !== undefined ? _data["noRoute"] : <any>null;
            this.nbreLivraisonAt = _data["nbreLivraisonAt"] !== undefined ? _data["nbreLivraisonAt"] : <any>null;
        }
    }

    static fromJS(data: any): Livraison {
        data = typeof data === 'object' ? data : {};
        let result = new Livraison();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["noLivraison"] = this.noLivraison !== undefined ? this.noLivraison : <any>null;
        data["noCommande"] = this.noCommande !== undefined ? this.noCommande : <any>null;
        data["commande"] = this.commande ? this.commande.toJSON() : <any>null;
        data["dateLivraison"] = this.dateLivraison ? this.dateLivraison.toISOString() : <any>null;
        data["dateMiseJour"] = this.dateMiseJour ? this.dateMiseJour.toISOString() : <any>null;
        data["majfaitePar"] = this.majfaitePar !== undefined ? this.majfaitePar : <any>null;
        data["noRoute"] = this.noRoute !== undefined ? this.noRoute : <any>null;
        data["nbreLivraisonAt"] = this.nbreLivraisonAt !== undefined ? this.nbreLivraisonAt : <any>null;
        return data;
    }
}

export interface ILivraison {
    noLivraison?: number;
    noCommande?: number;
    commande?: Commande | null;
    dateLivraison?: moment.Moment;
    dateMiseJour?: moment.Moment | null;
    majfaitePar?: string | null;
    noRoute?: number | null;
    nbreLivraisonAt?: number | null;
}

export class CommItem implements ICommItem {
    noCommItem?: number;
    noCommande?: number;
    commande?: Commande | null;
    noItem?: string | null;
    item?: Item | null;
    qtee?: number | null;
    ql1?: number | null;
    ql2?: number | null;
    ql3?: number | null;
    ql4?: number | null;
    ql5?: number | null;
    ql6?: number | null;
    liv1?: number | null;
    liv2?: number | null;
    liv3?: number | null;
    liv4?: number | null;
    liv5?: number | null;
    liv6?: number | null;
    qteeLivre?: number | null;
    qteeAlivrer?: number | null;
    vendant?: number | null;
    typeChangement?: number | null;
    qteeReferral?: number | null;
    sortOrder?: number | null;
    qteeALivreEtLivre?: number;

    constructor(data?: ICommItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.noCommItem = _data["noCommItem"] !== undefined ? _data["noCommItem"] : <any>null;
            this.noCommande = _data["noCommande"] !== undefined ? _data["noCommande"] : <any>null;
            this.commande = _data["commande"] ? Commande.fromJS(_data["commande"]) : <any>null;
            this.noItem = _data["noItem"] !== undefined ? _data["noItem"] : <any>null;
            this.item = _data["item"] ? Item.fromJS(_data["item"]) : <any>null;
            this.qtee = _data["qtee"] !== undefined ? _data["qtee"] : <any>null;
            this.ql1 = _data["ql1"] !== undefined ? _data["ql1"] : <any>null;
            this.ql2 = _data["ql2"] !== undefined ? _data["ql2"] : <any>null;
            this.ql3 = _data["ql3"] !== undefined ? _data["ql3"] : <any>null;
            this.ql4 = _data["ql4"] !== undefined ? _data["ql4"] : <any>null;
            this.ql5 = _data["ql5"] !== undefined ? _data["ql5"] : <any>null;
            this.ql6 = _data["ql6"] !== undefined ? _data["ql6"] : <any>null;
            this.liv1 = _data["liv1"] !== undefined ? _data["liv1"] : <any>null;
            this.liv2 = _data["liv2"] !== undefined ? _data["liv2"] : <any>null;
            this.liv3 = _data["liv3"] !== undefined ? _data["liv3"] : <any>null;
            this.liv4 = _data["liv4"] !== undefined ? _data["liv4"] : <any>null;
            this.liv5 = _data["liv5"] !== undefined ? _data["liv5"] : <any>null;
            this.liv6 = _data["liv6"] !== undefined ? _data["liv6"] : <any>null;
            this.qteeLivre = _data["qteeLivre"] !== undefined ? _data["qteeLivre"] : <any>null;
            this.qteeAlivrer = _data["qteeAlivrer"] !== undefined ? _data["qteeAlivrer"] : <any>null;
            this.vendant = _data["vendant"] !== undefined ? _data["vendant"] : <any>null;
            this.typeChangement = _data["typeChangement"] !== undefined ? _data["typeChangement"] : <any>null;
            this.qteeReferral = _data["qteeReferral"] !== undefined ? _data["qteeReferral"] : <any>null;
            this.sortOrder = _data["sortOrder"] !== undefined ? _data["sortOrder"] : <any>null;
            this.qteeALivreEtLivre = _data["qteeALivreEtLivre"] !== undefined ? _data["qteeALivreEtLivre"] : <any>null;
        }
    }

    static fromJS(data: any): CommItem {
        data = typeof data === 'object' ? data : {};
        let result = new CommItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["noCommItem"] = this.noCommItem !== undefined ? this.noCommItem : <any>null;
        data["noCommande"] = this.noCommande !== undefined ? this.noCommande : <any>null;
        data["commande"] = this.commande ? this.commande.toJSON() : <any>null;
        data["noItem"] = this.noItem !== undefined ? this.noItem : <any>null;
        data["item"] = this.item ? this.item.toJSON() : <any>null;
        data["qtee"] = this.qtee !== undefined ? this.qtee : <any>null;
        data["ql1"] = this.ql1 !== undefined ? this.ql1 : <any>null;
        data["ql2"] = this.ql2 !== undefined ? this.ql2 : <any>null;
        data["ql3"] = this.ql3 !== undefined ? this.ql3 : <any>null;
        data["ql4"] = this.ql4 !== undefined ? this.ql4 : <any>null;
        data["ql5"] = this.ql5 !== undefined ? this.ql5 : <any>null;
        data["ql6"] = this.ql6 !== undefined ? this.ql6 : <any>null;
        data["liv1"] = this.liv1 !== undefined ? this.liv1 : <any>null;
        data["liv2"] = this.liv2 !== undefined ? this.liv2 : <any>null;
        data["liv3"] = this.liv3 !== undefined ? this.liv3 : <any>null;
        data["liv4"] = this.liv4 !== undefined ? this.liv4 : <any>null;
        data["liv5"] = this.liv5 !== undefined ? this.liv5 : <any>null;
        data["liv6"] = this.liv6 !== undefined ? this.liv6 : <any>null;
        data["qteeLivre"] = this.qteeLivre !== undefined ? this.qteeLivre : <any>null;
        data["qteeAlivrer"] = this.qteeAlivrer !== undefined ? this.qteeAlivrer : <any>null;
        data["vendant"] = this.vendant !== undefined ? this.vendant : <any>null;
        data["typeChangement"] = this.typeChangement !== undefined ? this.typeChangement : <any>null;
        data["qteeReferral"] = this.qteeReferral !== undefined ? this.qteeReferral : <any>null;
        data["sortOrder"] = this.sortOrder !== undefined ? this.sortOrder : <any>null;
        data["qteeALivreEtLivre"] = this.qteeALivreEtLivre !== undefined ? this.qteeALivreEtLivre : <any>null;
        return data;
    }
}

export interface ICommItem {
    noCommItem?: number;
    noCommande?: number;
    commande?: Commande | null;
    noItem?: string | null;
    item?: Item | null;
    qtee?: number | null;
    ql1?: number | null;
    ql2?: number | null;
    ql3?: number | null;
    ql4?: number | null;
    ql5?: number | null;
    ql6?: number | null;
    liv1?: number | null;
    liv2?: number | null;
    liv3?: number | null;
    liv4?: number | null;
    liv5?: number | null;
    liv6?: number | null;
    qteeLivre?: number | null;
    qteeAlivrer?: number | null;
    vendant?: number | null;
    typeChangement?: number | null;
    qteeReferral?: number | null;
    sortOrder?: number | null;
    qteeALivreEtLivre?: number;
}

export class Item implements IItem {
    noItem?: string | null;
    noAutre?: string | null;
    detail?: string | null;
    detailen?: string | null;
    dpt?: string | null;
    dpten?: string | null;
    format?: string | null;
    pVente?: number | null;
    pCoutant?: number | null;
    qteSuggere?: number | null;
    qte?: number | null;
    actif?: string | null;
    tps?: string | null;
    tvq?: string | null;
    isTps?: boolean;
    isTvq?: boolean;
    estViande?: boolean;
    estVRiendeau?: boolean;
    estVDivers?: boolean;
    estSurgele?: boolean;
    estEpicierie?: boolean;
    estEpicierieP?: boolean;
    noFournisseurInventaire?: number;
    categoryId?: string | null;
    itemOrder?: number | null;
    uniteCaisse?: number | null;
    commItems?: CommItem[] | null;
    circuitOrder?: number | null;

    constructor(data?: IItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.noItem = _data["noItem"] !== undefined ? _data["noItem"] : <any>null;
            this.noAutre = _data["noAutre"] !== undefined ? _data["noAutre"] : <any>null;
            this.detail = _data["detail"] !== undefined ? _data["detail"] : <any>null;
            this.detailen = _data["detailen"] !== undefined ? _data["detailen"] : <any>null;
            this.dpt = _data["dpt"] !== undefined ? _data["dpt"] : <any>null;
            this.dpten = _data["dpten"] !== undefined ? _data["dpten"] : <any>null;
            this.format = _data["format"] !== undefined ? _data["format"] : <any>null;
            this.pVente = _data["pVente"] !== undefined ? _data["pVente"] : <any>null;
            this.pCoutant = _data["pCoutant"] !== undefined ? _data["pCoutant"] : <any>null;
            this.qteSuggere = _data["qteSuggere"] !== undefined ? _data["qteSuggere"] : <any>null;
            this.qte = _data["qte"] !== undefined ? _data["qte"] : <any>null;
            this.actif = _data["actif"] !== undefined ? _data["actif"] : <any>null;
            this.tps = _data["tps"] !== undefined ? _data["tps"] : <any>null;
            this.tvq = _data["tvq"] !== undefined ? _data["tvq"] : <any>null;
            this.isTps = _data["isTps"] !== undefined ? _data["isTps"] : <any>null;
            this.isTvq = _data["isTvq"] !== undefined ? _data["isTvq"] : <any>null;
            this.estViande = _data["estViande"] !== undefined ? _data["estViande"] : <any>null;
            this.estVRiendeau = _data["estVRiendeau"] !== undefined ? _data["estVRiendeau"] : <any>null;
            this.estVDivers = _data["estVDivers"] !== undefined ? _data["estVDivers"] : <any>null;
            this.estSurgele = _data["estSurgele"] !== undefined ? _data["estSurgele"] : <any>null;
            this.estEpicierie = _data["estEpicierie"] !== undefined ? _data["estEpicierie"] : <any>null;
            this.estEpicierieP = _data["estEpicierieP"] !== undefined ? _data["estEpicierieP"] : <any>null;
            this.noFournisseurInventaire = _data["noFournisseurInventaire"] !== undefined ? _data["noFournisseurInventaire"] : <any>null;
            this.categoryId = _data["categoryId"] !== undefined ? _data["categoryId"] : <any>null;
            this.itemOrder = _data["itemOrder"] !== undefined ? _data["itemOrder"] : <any>null;
            this.uniteCaisse = _data["uniteCaisse"] !== undefined ? _data["uniteCaisse"] : <any>null;
            if (Array.isArray(_data["commItems"])) {
                this.commItems = [] as any;
                for (let item of _data["commItems"])
                    this.commItems!.push(CommItem.fromJS(item));
            }
            else {
                this.commItems = <any>null;
            }
            this.circuitOrder = _data["circuitOrder"] !== undefined ? _data["circuitOrder"] : <any>null;
        }
    }

    static fromJS(data: any): Item {
        data = typeof data === 'object' ? data : {};
        let result = new Item();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["noItem"] = this.noItem !== undefined ? this.noItem : <any>null;
        data["noAutre"] = this.noAutre !== undefined ? this.noAutre : <any>null;
        data["detail"] = this.detail !== undefined ? this.detail : <any>null;
        data["detailen"] = this.detailen !== undefined ? this.detailen : <any>null;
        data["dpt"] = this.dpt !== undefined ? this.dpt : <any>null;
        data["dpten"] = this.dpten !== undefined ? this.dpten : <any>null;
        data["format"] = this.format !== undefined ? this.format : <any>null;
        data["pVente"] = this.pVente !== undefined ? this.pVente : <any>null;
        data["pCoutant"] = this.pCoutant !== undefined ? this.pCoutant : <any>null;
        data["qteSuggere"] = this.qteSuggere !== undefined ? this.qteSuggere : <any>null;
        data["qte"] = this.qte !== undefined ? this.qte : <any>null;
        data["actif"] = this.actif !== undefined ? this.actif : <any>null;
        data["tps"] = this.tps !== undefined ? this.tps : <any>null;
        data["tvq"] = this.tvq !== undefined ? this.tvq : <any>null;
        data["isTps"] = this.isTps !== undefined ? this.isTps : <any>null;
        data["isTvq"] = this.isTvq !== undefined ? this.isTvq : <any>null;
        data["estViande"] = this.estViande !== undefined ? this.estViande : <any>null;
        data["estVRiendeau"] = this.estVRiendeau !== undefined ? this.estVRiendeau : <any>null;
        data["estVDivers"] = this.estVDivers !== undefined ? this.estVDivers : <any>null;
        data["estSurgele"] = this.estSurgele !== undefined ? this.estSurgele : <any>null;
        data["estEpicierie"] = this.estEpicierie !== undefined ? this.estEpicierie : <any>null;
        data["estEpicierieP"] = this.estEpicierieP !== undefined ? this.estEpicierieP : <any>null;
        data["noFournisseurInventaire"] = this.noFournisseurInventaire !== undefined ? this.noFournisseurInventaire : <any>null;
        data["categoryId"] = this.categoryId !== undefined ? this.categoryId : <any>null;
        data["itemOrder"] = this.itemOrder !== undefined ? this.itemOrder : <any>null;
        data["uniteCaisse"] = this.uniteCaisse !== undefined ? this.uniteCaisse : <any>null;
        if (Array.isArray(this.commItems)) {
            data["commItems"] = [];
            for (let item of this.commItems)
                data["commItems"].push(item.toJSON());
        }
        data["circuitOrder"] = this.circuitOrder !== undefined ? this.circuitOrder : <any>null;
        return data;
    }
}

export interface IItem {
    noItem?: string | null;
    noAutre?: string | null;
    detail?: string | null;
    detailen?: string | null;
    dpt?: string | null;
    dpten?: string | null;
    format?: string | null;
    pVente?: number | null;
    pCoutant?: number | null;
    qteSuggere?: number | null;
    qte?: number | null;
    actif?: string | null;
    tps?: string | null;
    tvq?: string | null;
    isTps?: boolean;
    isTvq?: boolean;
    estViande?: boolean;
    estVRiendeau?: boolean;
    estVDivers?: boolean;
    estSurgele?: boolean;
    estEpicierie?: boolean;
    estEpicierieP?: boolean;
    noFournisseurInventaire?: number;
    categoryId?: string | null;
    itemOrder?: number | null;
    uniteCaisse?: number | null;
    commItems?: CommItem[] | null;
    circuitOrder?: number | null;
}

export class CommCongelateur implements ICommCongelateur {
    noCommCongelateur?: number;
    noCommande?: number;
    commande?: Commande | null;
    type?: number | null;
    qtee?: number | null;
    vendant?: number | null;
    freezerTerm?: number;

    constructor(data?: ICommCongelateur) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.noCommCongelateur = _data["noCommCongelateur"] !== undefined ? _data["noCommCongelateur"] : <any>null;
            this.noCommande = _data["noCommande"] !== undefined ? _data["noCommande"] : <any>null;
            this.commande = _data["commande"] ? Commande.fromJS(_data["commande"]) : <any>null;
            this.type = _data["type"] !== undefined ? _data["type"] : <any>null;
            this.qtee = _data["qtee"] !== undefined ? _data["qtee"] : <any>null;
            this.vendant = _data["vendant"] !== undefined ? _data["vendant"] : <any>null;
            this.freezerTerm = _data["freezerTerm"] !== undefined ? _data["freezerTerm"] : <any>null;
        }
    }

    static fromJS(data: any): CommCongelateur {
        data = typeof data === 'object' ? data : {};
        let result = new CommCongelateur();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["noCommCongelateur"] = this.noCommCongelateur !== undefined ? this.noCommCongelateur : <any>null;
        data["noCommande"] = this.noCommande !== undefined ? this.noCommande : <any>null;
        data["commande"] = this.commande ? this.commande.toJSON() : <any>null;
        data["type"] = this.type !== undefined ? this.type : <any>null;
        data["qtee"] = this.qtee !== undefined ? this.qtee : <any>null;
        data["vendant"] = this.vendant !== undefined ? this.vendant : <any>null;
        data["freezerTerm"] = this.freezerTerm !== undefined ? this.freezerTerm : <any>null;
        return data;
    }
}

export interface ICommCongelateur {
    noCommCongelateur?: number;
    noCommande?: number;
    commande?: Commande | null;
    type?: number | null;
    qtee?: number | null;
    vendant?: number | null;
    freezerTerm?: number;
}

export class CommAppliance implements ICommAppliance {
    noCommAppliance?: number;
    noCommande?: number;
    commande?: Commande | null;
    type?: string | null;
    code?: string | null;
    qtee?: number | null;
    vendant?: number | null;
    applianceTerm?: number;
    epicierApplianceId?: string | null;
    epicierApplianceRegionId?: string | null;

    constructor(data?: ICommAppliance) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.noCommAppliance = _data["noCommAppliance"] !== undefined ? _data["noCommAppliance"] : <any>null;
            this.noCommande = _data["noCommande"] !== undefined ? _data["noCommande"] : <any>null;
            this.commande = _data["commande"] ? Commande.fromJS(_data["commande"]) : <any>null;
            this.type = _data["type"] !== undefined ? _data["type"] : <any>null;
            this.code = _data["code"] !== undefined ? _data["code"] : <any>null;
            this.qtee = _data["qtee"] !== undefined ? _data["qtee"] : <any>null;
            this.vendant = _data["vendant"] !== undefined ? _data["vendant"] : <any>null;
            this.applianceTerm = _data["applianceTerm"] !== undefined ? _data["applianceTerm"] : <any>null;
            this.epicierApplianceId = _data["epicierApplianceId"] !== undefined ? _data["epicierApplianceId"] : <any>null;
            this.epicierApplianceRegionId = _data["epicierApplianceRegionId"] !== undefined ? _data["epicierApplianceRegionId"] : <any>null;
        }
    }

    static fromJS(data: any): CommAppliance {
        data = typeof data === 'object' ? data : {};
        let result = new CommAppliance();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["noCommAppliance"] = this.noCommAppliance !== undefined ? this.noCommAppliance : <any>null;
        data["noCommande"] = this.noCommande !== undefined ? this.noCommande : <any>null;
        data["commande"] = this.commande ? this.commande.toJSON() : <any>null;
        data["type"] = this.type !== undefined ? this.type : <any>null;
        data["code"] = this.code !== undefined ? this.code : <any>null;
        data["qtee"] = this.qtee !== undefined ? this.qtee : <any>null;
        data["vendant"] = this.vendant !== undefined ? this.vendant : <any>null;
        data["applianceTerm"] = this.applianceTerm !== undefined ? this.applianceTerm : <any>null;
        data["epicierApplianceId"] = this.epicierApplianceId !== undefined ? this.epicierApplianceId : <any>null;
        data["epicierApplianceRegionId"] = this.epicierApplianceRegionId !== undefined ? this.epicierApplianceRegionId : <any>null;
        return data;
    }
}

export interface ICommAppliance {
    noCommAppliance?: number;
    noCommande?: number;
    commande?: Commande | null;
    type?: string | null;
    code?: string | null;
    qtee?: number | null;
    vendant?: number | null;
    applianceTerm?: number;
    epicierApplianceId?: string | null;
    epicierApplianceRegionId?: string | null;
}

export class ERPCommandeImport implements IERPCommandeImport {
    id?: number;
    importException?: string | null;
    importSucceeded?: boolean;
    importedDateTime?: moment.Moment | null;
    importedIntoTenant?: string | null;
    commande?: Commande | null;
    noCommande?: number;
    noRoute?: number;
    importDuration?: number;

    constructor(data?: IERPCommandeImport) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.importException = _data["importException"] !== undefined ? _data["importException"] : <any>null;
            this.importSucceeded = _data["importSucceeded"] !== undefined ? _data["importSucceeded"] : <any>null;
            this.importedDateTime = _data["importedDateTime"] ? moment(_data["importedDateTime"].toString()) : <any>null;
            this.importedIntoTenant = _data["importedIntoTenant"] !== undefined ? _data["importedIntoTenant"] : <any>null;
            this.commande = _data["commande"] ? Commande.fromJS(_data["commande"]) : <any>null;
            this.noCommande = _data["noCommande"] !== undefined ? _data["noCommande"] : <any>null;
            this.noRoute = _data["noRoute"] !== undefined ? _data["noRoute"] : <any>null;
            this.importDuration = _data["importDuration"] !== undefined ? _data["importDuration"] : <any>null;
        }
    }

    static fromJS(data: any): ERPCommandeImport {
        data = typeof data === 'object' ? data : {};
        let result = new ERPCommandeImport();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["importException"] = this.importException !== undefined ? this.importException : <any>null;
        data["importSucceeded"] = this.importSucceeded !== undefined ? this.importSucceeded : <any>null;
        data["importedDateTime"] = this.importedDateTime ? this.importedDateTime.toISOString() : <any>null;
        data["importedIntoTenant"] = this.importedIntoTenant !== undefined ? this.importedIntoTenant : <any>null;
        data["commande"] = this.commande ? this.commande.toJSON() : <any>null;
        data["noCommande"] = this.noCommande !== undefined ? this.noCommande : <any>null;
        data["noRoute"] = this.noRoute !== undefined ? this.noRoute : <any>null;
        data["importDuration"] = this.importDuration !== undefined ? this.importDuration : <any>null;
        return data;
    }
}

export interface IERPCommandeImport {
    id?: number;
    importException?: string | null;
    importSucceeded?: boolean;
    importedDateTime?: moment.Moment | null;
    importedIntoTenant?: string | null;
    commande?: Commande | null;
    noCommande?: number;
    noRoute?: number;
    importDuration?: number;
}

export class GetErpOrdersSyncStatusQuery extends PaginationModel implements IGetErpOrdersSyncStatusQuery {
    startDate?: moment.Moment;
    endDate?: moment.Moment | null;
    hasOrderImported?: boolean;
    hasOrderNotImported?: boolean;

    constructor(data?: IGetErpOrdersSyncStatusQuery) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.startDate = _data["startDate"] ? moment(_data["startDate"].toString()) : <any>null;
            this.endDate = _data["endDate"] ? moment(_data["endDate"].toString()) : <any>null;
            this.hasOrderImported = _data["hasOrderImported"] !== undefined ? _data["hasOrderImported"] : <any>null;
            this.hasOrderNotImported = _data["hasOrderNotImported"] !== undefined ? _data["hasOrderNotImported"] : <any>null;
        }
    }

    static override fromJS(data: any): GetErpOrdersSyncStatusQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetErpOrdersSyncStatusQuery();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>null;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>null;
        data["hasOrderImported"] = this.hasOrderImported !== undefined ? this.hasOrderImported : <any>null;
        data["hasOrderNotImported"] = this.hasOrderNotImported !== undefined ? this.hasOrderNotImported : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IGetErpOrdersSyncStatusQuery extends IPaginationModel {
    startDate?: moment.Moment;
    endDate?: moment.Moment | null;
    hasOrderImported?: boolean;
    hasOrderNotImported?: boolean;
}

export class BaseResponseOfBoolean extends BaseResponseDto implements IBaseResponseOfBoolean {
    data?: boolean;

    constructor(data?: IBaseResponseOfBoolean) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"] !== undefined ? _data["data"] : <any>null;
        }
    }

    static override fromJS(data: any): BaseResponseOfBoolean {
        data = typeof data === 'object' ? data : {};
        let result = new BaseResponseOfBoolean();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data !== undefined ? this.data : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IBaseResponseOfBoolean extends IBaseResponseDto {
    data?: boolean;
}

export class PushSalesOrdersToOptimoRouteCommand implements IPushSalesOrdersToOptimoRouteCommand {
    syncStartDate?: moment.Moment | null;
    salesOrderNo?: string | null;

    constructor(data?: IPushSalesOrdersToOptimoRouteCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.syncStartDate = _data["syncStartDate"] ? moment(_data["syncStartDate"].toString()) : <any>null;
            this.salesOrderNo = _data["salesOrderNo"] !== undefined ? _data["salesOrderNo"] : <any>null;
        }
    }

    static fromJS(data: any): PushSalesOrdersToOptimoRouteCommand {
        data = typeof data === 'object' ? data : {};
        let result = new PushSalesOrdersToOptimoRouteCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["syncStartDate"] = this.syncStartDate ? this.syncStartDate.toISOString() : <any>null;
        data["salesOrderNo"] = this.salesOrderNo !== undefined ? this.salesOrderNo : <any>null;
        return data;
    }
}

export interface IPushSalesOrdersToOptimoRouteCommand {
    syncStartDate?: moment.Moment | null;
    salesOrderNo?: string | null;
}

export class PushOptimoRoutesToERPCommand implements IPushOptimoRoutesToERPCommand {
    downloadRoutesOnDateTime?: moment.Moment | null;

    constructor(data?: IPushOptimoRoutesToERPCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.downloadRoutesOnDateTime = _data["downloadRoutesOnDateTime"] ? moment(_data["downloadRoutesOnDateTime"].toString()) : <any>null;
        }
    }

    static fromJS(data: any): PushOptimoRoutesToERPCommand {
        data = typeof data === 'object' ? data : {};
        let result = new PushOptimoRoutesToERPCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["downloadRoutesOnDateTime"] = this.downloadRoutesOnDateTime ? this.downloadRoutesOnDateTime.toISOString() : <any>null;
        return data;
    }
}

export interface IPushOptimoRoutesToERPCommand {
    downloadRoutesOnDateTime?: moment.Moment | null;
}

export class ProcessCompletedOrdersCommand implements IProcessCompletedOrdersCommand {
    processCompletedOrdersOnDateTime?: moment.Moment | null;

    constructor(data?: IProcessCompletedOrdersCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.processCompletedOrdersOnDateTime = _data["processCompletedOrdersOnDateTime"] ? moment(_data["processCompletedOrdersOnDateTime"].toString()) : <any>null;
        }
    }

    static fromJS(data: any): ProcessCompletedOrdersCommand {
        data = typeof data === 'object' ? data : {};
        let result = new ProcessCompletedOrdersCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["processCompletedOrdersOnDateTime"] = this.processCompletedOrdersOnDateTime ? this.processCompletedOrdersOnDateTime.toISOString() : <any>null;
        return data;
    }
}

export interface IProcessCompletedOrdersCommand {
    processCompletedOrdersOnDateTime?: moment.Moment | null;
}

export class ImportOrdersInERPCommand implements IImportOrdersInERPCommand {
    noCommandes?: number[] | null;
    maxNumberOfOrdersToImport?: number | null;

    constructor(data?: IImportOrdersInERPCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["noCommandes"])) {
                this.noCommandes = [] as any;
                for (let item of _data["noCommandes"])
                    this.noCommandes!.push(item);
            }
            else {
                this.noCommandes = <any>null;
            }
            this.maxNumberOfOrdersToImport = _data["maxNumberOfOrdersToImport"] !== undefined ? _data["maxNumberOfOrdersToImport"] : <any>null;
        }
    }

    static fromJS(data: any): ImportOrdersInERPCommand {
        data = typeof data === 'object' ? data : {};
        let result = new ImportOrdersInERPCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.noCommandes)) {
            data["noCommandes"] = [];
            for (let item of this.noCommandes)
                data["noCommandes"].push(item);
        }
        data["maxNumberOfOrdersToImport"] = this.maxNumberOfOrdersToImport !== undefined ? this.maxNumberOfOrdersToImport : <any>null;
        return data;
    }
}

export interface IImportOrdersInERPCommand {
    noCommandes?: number[] | null;
    maxNumberOfOrdersToImport?: number | null;
}

export class ReimportOrdersInERPCommand implements IReimportOrdersInERPCommand {
    orderNbr?: string | null;

    constructor(data?: IReimportOrdersInERPCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.orderNbr = _data["orderNbr"] !== undefined ? _data["orderNbr"] : <any>null;
        }
    }

    static fromJS(data: any): ReimportOrdersInERPCommand {
        data = typeof data === 'object' ? data : {};
        let result = new ReimportOrdersInERPCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["orderNbr"] = this.orderNbr !== undefined ? this.orderNbr : <any>null;
        return data;
    }
}

export interface IReimportOrdersInERPCommand {
    orderNbr?: string | null;
}

export class DeleteClientAndOrdersCommand implements IDeleteClientAndOrdersCommand {
    clientId?: string | null;
    noCommande?: string | null;
    deletAllOrders?: boolean;

    constructor(data?: IDeleteClientAndOrdersCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.clientId = _data["clientId"] !== undefined ? _data["clientId"] : <any>null;
            this.noCommande = _data["noCommande"] !== undefined ? _data["noCommande"] : <any>null;
            this.deletAllOrders = _data["deletAllOrders"] !== undefined ? _data["deletAllOrders"] : <any>null;
        }
    }

    static fromJS(data: any): DeleteClientAndOrdersCommand {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteClientAndOrdersCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clientId"] = this.clientId !== undefined ? this.clientId : <any>null;
        data["noCommande"] = this.noCommande !== undefined ? this.noCommande : <any>null;
        data["deletAllOrders"] = this.deletAllOrders !== undefined ? this.deletAllOrders : <any>null;
        return data;
    }
}

export interface IDeleteClientAndOrdersCommand {
    clientId?: string | null;
    noCommande?: string | null;
    deletAllOrders?: boolean;
}

export class UploadPaymentsToERPCommand implements IUploadPaymentsToERPCommand {
    contractNumber?: number | null;
    paidDate?: moment.Moment | null;

    constructor(data?: IUploadPaymentsToERPCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.contractNumber = _data["contractNumber"] !== undefined ? _data["contractNumber"] : <any>null;
            this.paidDate = _data["paidDate"] ? moment(_data["paidDate"].toString()) : <any>null;
        }
    }

    static fromJS(data: any): UploadPaymentsToERPCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UploadPaymentsToERPCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contractNumber"] = this.contractNumber !== undefined ? this.contractNumber : <any>null;
        data["paidDate"] = this.paidDate ? this.paidDate.toISOString() : <any>null;
        return data;
    }
}

export interface IUploadPaymentsToERPCommand {
    contractNumber?: number | null;
    paidDate?: moment.Moment | null;
}

export class StressTestPaymentsCommand implements IStressTestPaymentsCommand {
    numberOfPaymentsToCreate?: number;
    customerID?: string | null;

    constructor(data?: IStressTestPaymentsCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.numberOfPaymentsToCreate = _data["numberOfPaymentsToCreate"] !== undefined ? _data["numberOfPaymentsToCreate"] : <any>null;
            this.customerID = _data["customerID"] !== undefined ? _data["customerID"] : <any>null;
        }
    }

    static fromJS(data: any): StressTestPaymentsCommand {
        data = typeof data === 'object' ? data : {};
        let result = new StressTestPaymentsCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["numberOfPaymentsToCreate"] = this.numberOfPaymentsToCreate !== undefined ? this.numberOfPaymentsToCreate : <any>null;
        data["customerID"] = this.customerID !== undefined ? this.customerID : <any>null;
        return data;
    }
}

export interface IStressTestPaymentsCommand {
    numberOfPaymentsToCreate?: number;
    customerID?: string | null;
}

export class RemoveStressTestDataCommand implements IRemoveStressTestDataCommand {
    referenceNbrsStart?: string | null;
    referenceNbrsEnd?: string | null;

    constructor(data?: IRemoveStressTestDataCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.referenceNbrsStart = _data["referenceNbrsStart"] !== undefined ? _data["referenceNbrsStart"] : <any>null;
            this.referenceNbrsEnd = _data["referenceNbrsEnd"] !== undefined ? _data["referenceNbrsEnd"] : <any>null;
        }
    }

    static fromJS(data: any): RemoveStressTestDataCommand {
        data = typeof data === 'object' ? data : {};
        let result = new RemoveStressTestDataCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["referenceNbrsStart"] = this.referenceNbrsStart !== undefined ? this.referenceNbrsStart : <any>null;
        data["referenceNbrsEnd"] = this.referenceNbrsEnd !== undefined ? this.referenceNbrsEnd : <any>null;
        return data;
    }
}

export interface IRemoveStressTestDataCommand {
    referenceNbrsStart?: string | null;
    referenceNbrsEnd?: string | null;
}

export class GetRouteOrdersERPSyncStatusQuery extends PaginationModel implements IGetRouteOrdersERPSyncStatusQuery {
    hasOrderImported?: boolean;
    hasOrderNotImported?: boolean;

    constructor(data?: IGetRouteOrdersERPSyncStatusQuery) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.hasOrderImported = _data["hasOrderImported"] !== undefined ? _data["hasOrderImported"] : <any>null;
            this.hasOrderNotImported = _data["hasOrderNotImported"] !== undefined ? _data["hasOrderNotImported"] : <any>null;
        }
    }

    static override fromJS(data: any): GetRouteOrdersERPSyncStatusQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetRouteOrdersERPSyncStatusQuery();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["hasOrderImported"] = this.hasOrderImported !== undefined ? this.hasOrderImported : <any>null;
        data["hasOrderNotImported"] = this.hasOrderNotImported !== undefined ? this.hasOrderNotImported : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IGetRouteOrdersERPSyncStatusQuery extends IPaginationModel {
    hasOrderImported?: boolean;
    hasOrderNotImported?: boolean;
}

export class ImportLastOrdersByClientStatusCommand implements IImportLastOrdersByClientStatusCommand {
    clientNo?: number | null;

    constructor(data?: IImportLastOrdersByClientStatusCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.clientNo = _data["clientNo"] !== undefined ? _data["clientNo"] : <any>null;
        }
    }

    static fromJS(data: any): ImportLastOrdersByClientStatusCommand {
        data = typeof data === 'object' ? data : {};
        let result = new ImportLastOrdersByClientStatusCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clientNo"] = this.clientNo !== undefined ? this.clientNo : <any>null;
        return data;
    }
}

export interface IImportLastOrdersByClientStatusCommand {
    clientNo?: number | null;
}

export class GetEligibleClientsToImportCommand implements IGetEligibleClientsToImportCommand {

    constructor(data?: IGetEligibleClientsToImportCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): GetEligibleClientsToImportCommand {
        data = typeof data === 'object' ? data : {};
        let result = new GetEligibleClientsToImportCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IGetEligibleClientsToImportCommand {
}

export class ImportRouteOrdersInERPCommand implements IImportRouteOrdersInERPCommand {
    noRoute?: number | null;
    noCommande?: number | null;

    constructor(data?: IImportRouteOrdersInERPCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.noRoute = _data["noRoute"] !== undefined ? _data["noRoute"] : <any>null;
            this.noCommande = _data["noCommande"] !== undefined ? _data["noCommande"] : <any>null;
        }
    }

    static fromJS(data: any): ImportRouteOrdersInERPCommand {
        data = typeof data === 'object' ? data : {};
        let result = new ImportRouteOrdersInERPCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["noRoute"] = this.noRoute !== undefined ? this.noRoute : <any>null;
        data["noCommande"] = this.noCommande !== undefined ? this.noCommande : <any>null;
        return data;
    }
}

export interface IImportRouteOrdersInERPCommand {
    noRoute?: number | null;
    noCommande?: number | null;
}

export class CommandeDto implements ICommandeDto {
    noCommande?: number;
    noClient?: number;
    tabletOrderId?: string | null;
    dateCommande?: moment.Moment | null;
    client?: Client2 | null;
    livraisons?: Livraison[] | null;
    commItems?: CommItem[] | null;
    commCongelateurs?: CommCongelateur[] | null;

    constructor(data?: ICommandeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.noCommande = _data["noCommande"] !== undefined ? _data["noCommande"] : <any>null;
            this.noClient = _data["noClient"] !== undefined ? _data["noClient"] : <any>null;
            this.tabletOrderId = _data["tabletOrderId"] !== undefined ? _data["tabletOrderId"] : <any>null;
            this.dateCommande = _data["dateCommande"] ? moment(_data["dateCommande"].toString()) : <any>null;
            this.client = _data["client"] ? Client2.fromJS(_data["client"]) : <any>null;
            if (Array.isArray(_data["livraisons"])) {
                this.livraisons = [] as any;
                for (let item of _data["livraisons"])
                    this.livraisons!.push(Livraison.fromJS(item));
            }
            else {
                this.livraisons = <any>null;
            }
            if (Array.isArray(_data["commItems"])) {
                this.commItems = [] as any;
                for (let item of _data["commItems"])
                    this.commItems!.push(CommItem.fromJS(item));
            }
            else {
                this.commItems = <any>null;
            }
            if (Array.isArray(_data["commCongelateurs"])) {
                this.commCongelateurs = [] as any;
                for (let item of _data["commCongelateurs"])
                    this.commCongelateurs!.push(CommCongelateur.fromJS(item));
            }
            else {
                this.commCongelateurs = <any>null;
            }
        }
    }

    static fromJS(data: any): CommandeDto {
        data = typeof data === 'object' ? data : {};
        let result = new CommandeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["noCommande"] = this.noCommande !== undefined ? this.noCommande : <any>null;
        data["noClient"] = this.noClient !== undefined ? this.noClient : <any>null;
        data["tabletOrderId"] = this.tabletOrderId !== undefined ? this.tabletOrderId : <any>null;
        data["dateCommande"] = this.dateCommande ? this.dateCommande.toISOString() : <any>null;
        data["client"] = this.client ? this.client.toJSON() : <any>null;
        if (Array.isArray(this.livraisons)) {
            data["livraisons"] = [];
            for (let item of this.livraisons)
                data["livraisons"].push(item.toJSON());
        }
        if (Array.isArray(this.commItems)) {
            data["commItems"] = [];
            for (let item of this.commItems)
                data["commItems"].push(item.toJSON());
        }
        if (Array.isArray(this.commCongelateurs)) {
            data["commCongelateurs"] = [];
            for (let item of this.commCongelateurs)
                data["commCongelateurs"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICommandeDto {
    noCommande?: number;
    noClient?: number;
    tabletOrderId?: string | null;
    dateCommande?: moment.Moment | null;
    client?: Client2 | null;
    livraisons?: Livraison[] | null;
    commItems?: CommItem[] | null;
    commCongelateurs?: CommCongelateur[] | null;
}

export class GetOrderContentCommand implements IGetOrderContentCommand {
    noCommande?: number;

    constructor(data?: IGetOrderContentCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.noCommande = _data["noCommande"] !== undefined ? _data["noCommande"] : <any>null;
        }
    }

    static fromJS(data: any): GetOrderContentCommand {
        data = typeof data === 'object' ? data : {};
        let result = new GetOrderContentCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["noCommande"] = this.noCommande !== undefined ? this.noCommande : <any>null;
        return data;
    }
}

export interface IGetOrderContentCommand {
    noCommande?: number;
}

export class GetUnimportedOrdersCommand implements IGetUnimportedOrdersCommand {

    constructor(data?: IGetUnimportedOrdersCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): GetUnimportedOrdersCommand {
        data = typeof data === 'object' ? data : {};
        let result = new GetUnimportedOrdersCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IGetUnimportedOrdersCommand {
}

export class PaginatedResultOfFederalDnclDto extends PaginatedResult implements IPaginatedResultOfFederalDnclDto {
    entities?: FederalDnclDto[] | null;

    constructor(data?: IPaginatedResultOfFederalDnclDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["entities"])) {
                this.entities = [] as any;
                for (let item of _data["entities"])
                    this.entities!.push(FederalDnclDto.fromJS(item));
            }
            else {
                this.entities = <any>null;
            }
        }
    }

    static override fromJS(data: any): PaginatedResultOfFederalDnclDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResultOfFederalDnclDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.entities)) {
            data["entities"] = [];
            for (let item of this.entities)
                data["entities"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IPaginatedResultOfFederalDnclDto extends IPaginatedResult {
    entities?: FederalDnclDto[] | null;
}

export class FederalDnclDto implements IFederalDnclDto {
    phoneNumber?: string | null;

    constructor(data?: IFederalDnclDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.phoneNumber = _data["phoneNumber"] !== undefined ? _data["phoneNumber"] : <any>null;
        }
    }

    static fromJS(data: any): FederalDnclDto {
        data = typeof data === 'object' ? data : {};
        let result = new FederalDnclDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["phoneNumber"] = this.phoneNumber !== undefined ? this.phoneNumber : <any>null;
        return data;
    }
}

export interface IFederalDnclDto {
    phoneNumber?: string | null;
}

export class GetFederalDnclListQuery extends PaginationModel implements IGetFederalDnclListQuery {

    constructor(data?: IGetFederalDnclListQuery) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): GetFederalDnclListQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetFederalDnclListQuery();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IGetFederalDnclListQuery extends IPaginationModel {
}

export class PaginatedResultOfFreezerRegionDto extends PaginatedResult implements IPaginatedResultOfFreezerRegionDto {
    entities?: FreezerRegionDto[] | null;

    constructor(data?: IPaginatedResultOfFreezerRegionDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["entities"])) {
                this.entities = [] as any;
                for (let item of _data["entities"])
                    this.entities!.push(FreezerRegionDto.fromJS(item));
            }
            else {
                this.entities = <any>null;
            }
        }
    }

    static override fromJS(data: any): PaginatedResultOfFreezerRegionDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResultOfFreezerRegionDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.entities)) {
            data["entities"] = [];
            for (let item of this.entities)
                data["entities"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IPaginatedResultOfFreezerRegionDto extends IPaginatedResult {
    entities?: FreezerRegionDto[] | null;
}

export class FreezerRegionDto implements IFreezerRegionDto {
    index?: number;
    id?: number;
    name?: string | null;
    isActive?: boolean;
    numberOfSectors?: number;
    sectors?: FreezerRegionSectorsDto[] | null;

    constructor(data?: IFreezerRegionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.index = _data["index"] !== undefined ? _data["index"] : <any>null;
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.isActive = _data["isActive"] !== undefined ? _data["isActive"] : <any>null;
            this.numberOfSectors = _data["numberOfSectors"] !== undefined ? _data["numberOfSectors"] : <any>null;
            if (Array.isArray(_data["sectors"])) {
                this.sectors = [] as any;
                for (let item of _data["sectors"])
                    this.sectors!.push(FreezerRegionSectorsDto.fromJS(item));
            }
            else {
                this.sectors = <any>null;
            }
        }
    }

    static fromJS(data: any): FreezerRegionDto {
        data = typeof data === 'object' ? data : {};
        let result = new FreezerRegionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["index"] = this.index !== undefined ? this.index : <any>null;
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["isActive"] = this.isActive !== undefined ? this.isActive : <any>null;
        data["numberOfSectors"] = this.numberOfSectors !== undefined ? this.numberOfSectors : <any>null;
        if (Array.isArray(this.sectors)) {
            data["sectors"] = [];
            for (let item of this.sectors)
                data["sectors"].push(item.toJSON());
        }
        return data;
    }
}

export interface IFreezerRegionDto {
    index?: number;
    id?: number;
    name?: string | null;
    isActive?: boolean;
    numberOfSectors?: number;
    sectors?: FreezerRegionSectorsDto[] | null;
}

export class FreezerRegionSectorsDto implements IFreezerRegionSectorsDto {
    sector?: FreezerSectors;

    constructor(data?: IFreezerRegionSectorsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sector = _data["sector"] !== undefined ? _data["sector"] : <any>null;
        }
    }

    static fromJS(data: any): FreezerRegionSectorsDto {
        data = typeof data === 'object' ? data : {};
        let result = new FreezerRegionSectorsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sector"] = this.sector !== undefined ? this.sector : <any>null;
        return data;
    }
}

export interface IFreezerRegionSectorsDto {
    sector?: FreezerSectors;
}

export enum FreezerSectors {
    Abitibi = "abitibi",
    CoteNord = "coteNord",
    NewBrunswick = "newBrunswick",
    Montreal = "montreal",
    Quebec = "quebec",
    OttawaAndGatineau = "ottawaAndGatineau",
    GaspesieAndBasStlaurent = "gaspesieAndBasStlaurent",
    Saguenay = "saguenay",
}

export class GetFreezerRegionsQuery extends PaginationModel implements IGetFreezerRegionsQuery {
    isActive?: boolean;
    isDeactivated?: boolean;

    constructor(data?: IGetFreezerRegionsQuery) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.isActive = _data["isActive"] !== undefined ? _data["isActive"] : <any>null;
            this.isDeactivated = _data["isDeactivated"] !== undefined ? _data["isDeactivated"] : <any>null;
        }
    }

    static override fromJS(data: any): GetFreezerRegionsQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetFreezerRegionsQuery();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isActive"] = this.isActive !== undefined ? this.isActive : <any>null;
        data["isDeactivated"] = this.isDeactivated !== undefined ? this.isDeactivated : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IGetFreezerRegionsQuery extends IPaginationModel {
    isActive?: boolean;
    isDeactivated?: boolean;
}

export class CreateFreezerRegionCommand implements ICreateFreezerRegionCommand {
    name?: string | null;

    constructor(data?: ICreateFreezerRegionCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
        }
    }

    static fromJS(data: any): CreateFreezerRegionCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateFreezerRegionCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : <any>null;
        return data;
    }
}

export interface ICreateFreezerRegionCommand {
    name?: string | null;
}

export class EditFreezerRegionCommand implements IEditFreezerRegionCommand {
    id?: number;
    name?: string | null;

    constructor(data?: IEditFreezerRegionCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
        }
    }

    static fromJS(data: any): EditFreezerRegionCommand {
        data = typeof data === 'object' ? data : {};
        let result = new EditFreezerRegionCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        return data;
    }
}

export interface IEditFreezerRegionCommand {
    id?: number;
    name?: string | null;
}

export class AddSectorToFreezerRegionCommand implements IAddSectorToFreezerRegionCommand {
    freezerRegionId?: number;
    sector?: FreezerSectors;

    constructor(data?: IAddSectorToFreezerRegionCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.freezerRegionId = _data["freezerRegionId"] !== undefined ? _data["freezerRegionId"] : <any>null;
            this.sector = _data["sector"] !== undefined ? _data["sector"] : <any>null;
        }
    }

    static fromJS(data: any): AddSectorToFreezerRegionCommand {
        data = typeof data === 'object' ? data : {};
        let result = new AddSectorToFreezerRegionCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["freezerRegionId"] = this.freezerRegionId !== undefined ? this.freezerRegionId : <any>null;
        data["sector"] = this.sector !== undefined ? this.sector : <any>null;
        return data;
    }
}

export interface IAddSectorToFreezerRegionCommand {
    freezerRegionId?: number;
    sector?: FreezerSectors;
}

export class ChangeFreezerRegionActiveCommand implements IChangeFreezerRegionActiveCommand {
    freezerRegionId?: number;

    constructor(data?: IChangeFreezerRegionActiveCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.freezerRegionId = _data["freezerRegionId"] !== undefined ? _data["freezerRegionId"] : <any>null;
        }
    }

    static fromJS(data: any): ChangeFreezerRegionActiveCommand {
        data = typeof data === 'object' ? data : {};
        let result = new ChangeFreezerRegionActiveCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["freezerRegionId"] = this.freezerRegionId !== undefined ? this.freezerRegionId : <any>null;
        return data;
    }
}

export interface IChangeFreezerRegionActiveCommand {
    freezerRegionId?: number;
}

export class PaginatedResultOfFreezerLookupDto extends PaginatedResult implements IPaginatedResultOfFreezerLookupDto {
    entities?: FreezerLookupDto[] | null;

    constructor(data?: IPaginatedResultOfFreezerLookupDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["entities"])) {
                this.entities = [] as any;
                for (let item of _data["entities"])
                    this.entities!.push(FreezerLookupDto.fromJS(item));
            }
            else {
                this.entities = <any>null;
            }
        }
    }

    static override fromJS(data: any): PaginatedResultOfFreezerLookupDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResultOfFreezerLookupDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.entities)) {
            data["entities"] = [];
            for (let item of this.entities)
                data["entities"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IPaginatedResultOfFreezerLookupDto extends IPaginatedResult {
    entities?: FreezerLookupDto[] | null;
}

export class FreezerLookupDto implements IFreezerLookupDto {
    index?: number;
    id?: string | null;
    crmLegacyFreezerCode?: string | null;
    freezerNo?: number;
    brand?: string | null;
    model?: string | null;
    capacity?: number;
    heightInches?: number;
    widthInches?: number;
    depthInches?: number;
    description?: string | null;
    cost?: number;
    price?: number;
    freezerRegionName?: string | null;
    active?: boolean;
    defaultForRegion?: boolean;

    constructor(data?: IFreezerLookupDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.index = _data["index"] !== undefined ? _data["index"] : <any>null;
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.crmLegacyFreezerCode = _data["crmLegacyFreezerCode"] !== undefined ? _data["crmLegacyFreezerCode"] : <any>null;
            this.freezerNo = _data["freezerNo"] !== undefined ? _data["freezerNo"] : <any>null;
            this.brand = _data["brand"] !== undefined ? _data["brand"] : <any>null;
            this.model = _data["model"] !== undefined ? _data["model"] : <any>null;
            this.capacity = _data["capacity"] !== undefined ? _data["capacity"] : <any>null;
            this.heightInches = _data["heightInches"] !== undefined ? _data["heightInches"] : <any>null;
            this.widthInches = _data["widthInches"] !== undefined ? _data["widthInches"] : <any>null;
            this.depthInches = _data["depthInches"] !== undefined ? _data["depthInches"] : <any>null;
            this.description = _data["description"] !== undefined ? _data["description"] : <any>null;
            this.cost = _data["cost"] !== undefined ? _data["cost"] : <any>null;
            this.price = _data["price"] !== undefined ? _data["price"] : <any>null;
            this.freezerRegionName = _data["freezerRegionName"] !== undefined ? _data["freezerRegionName"] : <any>null;
            this.active = _data["active"] !== undefined ? _data["active"] : <any>null;
            this.defaultForRegion = _data["defaultForRegion"] !== undefined ? _data["defaultForRegion"] : <any>null;
        }
    }

    static fromJS(data: any): FreezerLookupDto {
        data = typeof data === 'object' ? data : {};
        let result = new FreezerLookupDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["index"] = this.index !== undefined ? this.index : <any>null;
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["crmLegacyFreezerCode"] = this.crmLegacyFreezerCode !== undefined ? this.crmLegacyFreezerCode : <any>null;
        data["freezerNo"] = this.freezerNo !== undefined ? this.freezerNo : <any>null;
        data["brand"] = this.brand !== undefined ? this.brand : <any>null;
        data["model"] = this.model !== undefined ? this.model : <any>null;
        data["capacity"] = this.capacity !== undefined ? this.capacity : <any>null;
        data["heightInches"] = this.heightInches !== undefined ? this.heightInches : <any>null;
        data["widthInches"] = this.widthInches !== undefined ? this.widthInches : <any>null;
        data["depthInches"] = this.depthInches !== undefined ? this.depthInches : <any>null;
        data["description"] = this.description !== undefined ? this.description : <any>null;
        data["cost"] = this.cost !== undefined ? this.cost : <any>null;
        data["price"] = this.price !== undefined ? this.price : <any>null;
        data["freezerRegionName"] = this.freezerRegionName !== undefined ? this.freezerRegionName : <any>null;
        data["active"] = this.active !== undefined ? this.active : <any>null;
        data["defaultForRegion"] = this.defaultForRegion !== undefined ? this.defaultForRegion : <any>null;
        return data;
    }
}

export interface IFreezerLookupDto {
    index?: number;
    id?: string | null;
    crmLegacyFreezerCode?: string | null;
    freezerNo?: number;
    brand?: string | null;
    model?: string | null;
    capacity?: number;
    heightInches?: number;
    widthInches?: number;
    depthInches?: number;
    description?: string | null;
    cost?: number;
    price?: number;
    freezerRegionName?: string | null;
    active?: boolean;
    defaultForRegion?: boolean;
}

export class GetFreezerListQuery extends PaginationModel implements IGetFreezerListQuery {
    isActive?: boolean;
    isDeactivated?: boolean;

    constructor(data?: IGetFreezerListQuery) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.isActive = _data["isActive"] !== undefined ? _data["isActive"] : <any>null;
            this.isDeactivated = _data["isDeactivated"] !== undefined ? _data["isDeactivated"] : <any>null;
        }
    }

    static override fromJS(data: any): GetFreezerListQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetFreezerListQuery();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isActive"] = this.isActive !== undefined ? this.isActive : <any>null;
        data["isDeactivated"] = this.isDeactivated !== undefined ? this.isDeactivated : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IGetFreezerListQuery extends IPaginationModel {
    isActive?: boolean;
    isDeactivated?: boolean;
}

export class FreezerDto implements IFreezerDto {
    id?: string | null;
    legacyCrmCode?: string | null;
    freezerNo?: number;
    brand?: string | null;
    model?: string | null;
    capacity?: number;
    heightInches?: number;
    widthInches?: number;
    depthInches?: number;
    description?: string | null;
    descriptionEn?: string | null;
    cost?: number;
    price?: number;
    priceDetails?: FreezerPriceDto | null;
    freezerRegion?: FreezerRegionDto2 | null;
    active?: boolean;
    defaultForRegion?: boolean;
    image?: ImageMediaDto | null;

    constructor(data?: IFreezerDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.legacyCrmCode = _data["legacyCrmCode"] !== undefined ? _data["legacyCrmCode"] : <any>null;
            this.freezerNo = _data["freezerNo"] !== undefined ? _data["freezerNo"] : <any>null;
            this.brand = _data["brand"] !== undefined ? _data["brand"] : <any>null;
            this.model = _data["model"] !== undefined ? _data["model"] : <any>null;
            this.capacity = _data["capacity"] !== undefined ? _data["capacity"] : <any>null;
            this.heightInches = _data["heightInches"] !== undefined ? _data["heightInches"] : <any>null;
            this.widthInches = _data["widthInches"] !== undefined ? _data["widthInches"] : <any>null;
            this.depthInches = _data["depthInches"] !== undefined ? _data["depthInches"] : <any>null;
            this.description = _data["description"] !== undefined ? _data["description"] : <any>null;
            this.descriptionEn = _data["descriptionEn"] !== undefined ? _data["descriptionEn"] : <any>null;
            this.cost = _data["cost"] !== undefined ? _data["cost"] : <any>null;
            this.price = _data["price"] !== undefined ? _data["price"] : <any>null;
            this.priceDetails = _data["priceDetails"] ? FreezerPriceDto.fromJS(_data["priceDetails"]) : <any>null;
            this.freezerRegion = _data["freezerRegion"] ? FreezerRegionDto2.fromJS(_data["freezerRegion"]) : <any>null;
            this.active = _data["active"] !== undefined ? _data["active"] : <any>null;
            this.defaultForRegion = _data["defaultForRegion"] !== undefined ? _data["defaultForRegion"] : <any>null;
            this.image = _data["image"] ? ImageMediaDto.fromJS(_data["image"]) : <any>null;
        }
    }

    static fromJS(data: any): FreezerDto {
        data = typeof data === 'object' ? data : {};
        let result = new FreezerDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["legacyCrmCode"] = this.legacyCrmCode !== undefined ? this.legacyCrmCode : <any>null;
        data["freezerNo"] = this.freezerNo !== undefined ? this.freezerNo : <any>null;
        data["brand"] = this.brand !== undefined ? this.brand : <any>null;
        data["model"] = this.model !== undefined ? this.model : <any>null;
        data["capacity"] = this.capacity !== undefined ? this.capacity : <any>null;
        data["heightInches"] = this.heightInches !== undefined ? this.heightInches : <any>null;
        data["widthInches"] = this.widthInches !== undefined ? this.widthInches : <any>null;
        data["depthInches"] = this.depthInches !== undefined ? this.depthInches : <any>null;
        data["description"] = this.description !== undefined ? this.description : <any>null;
        data["descriptionEn"] = this.descriptionEn !== undefined ? this.descriptionEn : <any>null;
        data["cost"] = this.cost !== undefined ? this.cost : <any>null;
        data["price"] = this.price !== undefined ? this.price : <any>null;
        data["priceDetails"] = this.priceDetails ? this.priceDetails.toJSON() : <any>null;
        data["freezerRegion"] = this.freezerRegion ? this.freezerRegion.toJSON() : <any>null;
        data["active"] = this.active !== undefined ? this.active : <any>null;
        data["defaultForRegion"] = this.defaultForRegion !== undefined ? this.defaultForRegion : <any>null;
        data["image"] = this.image ? this.image.toJSON() : <any>null;
        return data;
    }
}

export interface IFreezerDto {
    id?: string | null;
    legacyCrmCode?: string | null;
    freezerNo?: number;
    brand?: string | null;
    model?: string | null;
    capacity?: number;
    heightInches?: number;
    widthInches?: number;
    depthInches?: number;
    description?: string | null;
    descriptionEn?: string | null;
    cost?: number;
    price?: number;
    priceDetails?: FreezerPriceDto | null;
    freezerRegion?: FreezerRegionDto2 | null;
    active?: boolean;
    defaultForRegion?: boolean;
    image?: ImageMediaDto | null;
}

export class FreezerPriceDto implements IFreezerPriceDto {
    id?: string | null;
    fullPrice?: number;
    term12Price?: number;
    term24Price?: number;
    term36Price?: number;
    enableFullPrice?: boolean;
    enableTerm12Price?: boolean;
    enableTerm24Price?: boolean;
    enableTerm36Price?: boolean;

    constructor(data?: IFreezerPriceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.fullPrice = _data["fullPrice"] !== undefined ? _data["fullPrice"] : <any>null;
            this.term12Price = _data["term12Price"] !== undefined ? _data["term12Price"] : <any>null;
            this.term24Price = _data["term24Price"] !== undefined ? _data["term24Price"] : <any>null;
            this.term36Price = _data["term36Price"] !== undefined ? _data["term36Price"] : <any>null;
            this.enableFullPrice = _data["enableFullPrice"] !== undefined ? _data["enableFullPrice"] : <any>null;
            this.enableTerm12Price = _data["enableTerm12Price"] !== undefined ? _data["enableTerm12Price"] : <any>null;
            this.enableTerm24Price = _data["enableTerm24Price"] !== undefined ? _data["enableTerm24Price"] : <any>null;
            this.enableTerm36Price = _data["enableTerm36Price"] !== undefined ? _data["enableTerm36Price"] : <any>null;
        }
    }

    static fromJS(data: any): FreezerPriceDto {
        data = typeof data === 'object' ? data : {};
        let result = new FreezerPriceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["fullPrice"] = this.fullPrice !== undefined ? this.fullPrice : <any>null;
        data["term12Price"] = this.term12Price !== undefined ? this.term12Price : <any>null;
        data["term24Price"] = this.term24Price !== undefined ? this.term24Price : <any>null;
        data["term36Price"] = this.term36Price !== undefined ? this.term36Price : <any>null;
        data["enableFullPrice"] = this.enableFullPrice !== undefined ? this.enableFullPrice : <any>null;
        data["enableTerm12Price"] = this.enableTerm12Price !== undefined ? this.enableTerm12Price : <any>null;
        data["enableTerm24Price"] = this.enableTerm24Price !== undefined ? this.enableTerm24Price : <any>null;
        data["enableTerm36Price"] = this.enableTerm36Price !== undefined ? this.enableTerm36Price : <any>null;
        return data;
    }
}

export interface IFreezerPriceDto {
    id?: string | null;
    fullPrice?: number;
    term12Price?: number;
    term24Price?: number;
    term36Price?: number;
    enableFullPrice?: boolean;
    enableTerm12Price?: boolean;
    enableTerm24Price?: boolean;
    enableTerm36Price?: boolean;
}

export class FreezerRegionDto2 implements IFreezerRegionDto2 {
    id?: number;
    name?: string | null;
    value?: number | null;

    constructor(data?: IFreezerRegionDto2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.value = _data["value"] !== undefined ? _data["value"] : <any>null;
        }
    }

    static fromJS(data: any): FreezerRegionDto2 {
        data = typeof data === 'object' ? data : {};
        let result = new FreezerRegionDto2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["value"] = this.value !== undefined ? this.value : <any>null;
        return data;
    }
}

export interface IFreezerRegionDto2 {
    id?: number;
    name?: string | null;
    value?: number | null;
}

export class EditFreezerCommand implements IEditFreezerCommand {
    freezerDto?: FreezerDto | null;

    constructor(data?: IEditFreezerCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.freezerDto = _data["freezerDto"] ? FreezerDto.fromJS(_data["freezerDto"]) : <any>null;
        }
    }

    static fromJS(data: any): EditFreezerCommand {
        data = typeof data === 'object' ? data : {};
        let result = new EditFreezerCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["freezerDto"] = this.freezerDto ? this.freezerDto.toJSON() : <any>null;
        return data;
    }
}

export interface IEditFreezerCommand {
    freezerDto?: FreezerDto | null;
}

export class CreateFreezerCommand implements ICreateFreezerCommand {
    freezerDto?: FreezerDto | null;

    constructor(data?: ICreateFreezerCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.freezerDto = _data["freezerDto"] ? FreezerDto.fromJS(_data["freezerDto"]) : <any>null;
        }
    }

    static fromJS(data: any): CreateFreezerCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateFreezerCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["freezerDto"] = this.freezerDto ? this.freezerDto.toJSON() : <any>null;
        return data;
    }
}

export interface ICreateFreezerCommand {
    freezerDto?: FreezerDto | null;
}

export class ActivateFreezerCommand implements IActivateFreezerCommand {
    id?: string | null;

    constructor(data?: IActivateFreezerCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
        }
    }

    static fromJS(data: any): ActivateFreezerCommand {
        data = typeof data === 'object' ? data : {};
        let result = new ActivateFreezerCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        return data;
    }
}

export interface IActivateFreezerCommand {
    id?: string | null;
}

export class DeactivateFreezerCommand implements IDeactivateFreezerCommand {
    id?: string | null;

    constructor(data?: IDeactivateFreezerCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
        }
    }

    static fromJS(data: any): DeactivateFreezerCommand {
        data = typeof data === 'object' ? data : {};
        let result = new DeactivateFreezerCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        return data;
    }
}

export interface IDeactivateFreezerCommand {
    id?: string | null;
}

export class SendTemplateEmailCommand implements ISendTemplateEmailCommand {
    templateInfo?: MultiRecipientsTemplate | null;

    constructor(data?: ISendTemplateEmailCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.templateInfo = _data["templateInfo"] ? MultiRecipientsTemplate.fromJS(_data["templateInfo"]) : <any>null;
        }
    }

    static fromJS(data: any): SendTemplateEmailCommand {
        data = typeof data === 'object' ? data : {};
        let result = new SendTemplateEmailCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["templateInfo"] = this.templateInfo ? this.templateInfo.toJSON() : <any>null;
        return data;
    }
}

export interface ISendTemplateEmailCommand {
    templateInfo?: MultiRecipientsTemplate | null;
}

export abstract class BaseMessage implements IBaseMessage {
    recipientInfos?: RecipientInfo[] | null;
    fromInfo?: FromInfo | null;

    constructor(data?: IBaseMessage) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["recipientInfos"])) {
                this.recipientInfos = [] as any;
                for (let item of _data["recipientInfos"])
                    this.recipientInfos!.push(RecipientInfo.fromJS(item));
            }
            else {
                this.recipientInfos = <any>null;
            }
            this.fromInfo = _data["fromInfo"] ? FromInfo.fromJS(_data["fromInfo"]) : <any>null;
        }
    }

    static fromJS(data: any): BaseMessage {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'BaseMessage' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.recipientInfos)) {
            data["recipientInfos"] = [];
            for (let item of this.recipientInfos)
                data["recipientInfos"].push(item.toJSON());
        }
        data["fromInfo"] = this.fromInfo ? this.fromInfo.toJSON() : <any>null;
        return data;
    }
}

export interface IBaseMessage {
    recipientInfos?: RecipientInfo[] | null;
    fromInfo?: FromInfo | null;
}

export abstract class MessageTemplate extends BaseMessage implements IMessageTemplate {
    subject?: string | null;
    templateData?: any | null;
    templateId?: string | null;
    messageAttachments?: MessageAttachment[] | null;
    addAttachments?: boolean;
    emailRefId?: string | null;
    emailType?: SendGridEmailType;

    constructor(data?: IMessageTemplate) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.subject = _data["subject"] !== undefined ? _data["subject"] : <any>null;
            this.templateData = _data["templateData"] !== undefined ? _data["templateData"] : <any>null;
            this.templateId = _data["templateId"] !== undefined ? _data["templateId"] : <any>null;
            if (Array.isArray(_data["messageAttachments"])) {
                this.messageAttachments = [] as any;
                for (let item of _data["messageAttachments"])
                    this.messageAttachments!.push(MessageAttachment.fromJS(item));
            }
            else {
                this.messageAttachments = <any>null;
            }
            this.addAttachments = _data["addAttachments"] !== undefined ? _data["addAttachments"] : <any>null;
            this.emailRefId = _data["emailRefId"] !== undefined ? _data["emailRefId"] : <any>null;
            this.emailType = _data["emailType"] !== undefined ? _data["emailType"] : <any>null;
        }
    }

    static override fromJS(data: any): MessageTemplate {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'MessageTemplate' cannot be instantiated.");
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["subject"] = this.subject !== undefined ? this.subject : <any>null;
        data["templateData"] = this.templateData !== undefined ? this.templateData : <any>null;
        data["templateId"] = this.templateId !== undefined ? this.templateId : <any>null;
        if (Array.isArray(this.messageAttachments)) {
            data["messageAttachments"] = [];
            for (let item of this.messageAttachments)
                data["messageAttachments"].push(item.toJSON());
        }
        data["addAttachments"] = this.addAttachments !== undefined ? this.addAttachments : <any>null;
        data["emailRefId"] = this.emailRefId !== undefined ? this.emailRefId : <any>null;
        data["emailType"] = this.emailType !== undefined ? this.emailType : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IMessageTemplate extends IBaseMessage {
    subject?: string | null;
    templateData?: any | null;
    templateId?: string | null;
    messageAttachments?: MessageAttachment[] | null;
    addAttachments?: boolean;
    emailRefId?: string | null;
    emailType?: SendGridEmailType;
}

export class MultiRecipientsTemplate extends MessageTemplate implements IMultiRecipientsTemplate {

    constructor(data?: IMultiRecipientsTemplate) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): MultiRecipientsTemplate {
        data = typeof data === 'object' ? data : {};
        let result = new MultiRecipientsTemplate();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IMultiRecipientsTemplate extends IMessageTemplate {
}

export class MessageAttachment implements IMessageAttachment {
    filename?: string | null;
    content?: string | null;

    constructor(data?: IMessageAttachment) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.filename = _data["filename"] !== undefined ? _data["filename"] : <any>null;
            this.content = _data["content"] !== undefined ? _data["content"] : <any>null;
        }
    }

    static fromJS(data: any): MessageAttachment {
        data = typeof data === 'object' ? data : {};
        let result = new MessageAttachment();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["filename"] = this.filename !== undefined ? this.filename : <any>null;
        data["content"] = this.content !== undefined ? this.content : <any>null;
        return data;
    }
}

export interface IMessageAttachment {
    filename?: string | null;
    content?: string | null;
}

export enum SendGridEmailType {
    CreateLegacyAppointment = "createLegacyAppointment",
    SendAppointmentDetail = "sendAppointmentDetail",
    SendAppointmentRemoved = "sendAppointmentRemoved",
    ImportCallbackClientLeads = "importCallbackClientLeads",
    SendCallbackRenewal = "sendCallbackRenewal",
    ImportClientLeadsFromOrderReferences = "importClientLeadsFromOrderReferences",
    RemoveOrderReferences = "removeOrderReferences",
    ImportNextDeliveryTasks = "importNextDeliveryTasks",
    SendSelfRegistrationConfirmation = "sendSelfRegistrationConfirmation",
    SendWelcome = "sendWelcome",
    SendClientInvoice = "sendClientInvoice",
    EftInternalNotificationService = "eftInternalNotificationService",
    AutomationService = "automationService",
    NotifyService = "notifyService",
    SendOrderInProgress = "sendOrderInProgress",
    SendDeliveryOnCurrentDateReminder = "sendDeliveryOnCurrentDateReminder",
    SendOrderAssembled = "sendOrderAssembled",
    SendRoutePurchaseOrder = "sendRoutePurchaseOrder",
    SendOrderArrivedAndClientPortalLink = "sendOrderArrivedAndClientPortalLink",
    AssignEmployeeToServiceTicket = "assignEmployeeToServiceTicket",
    ChangeServiceTicketStatus = "changeServiceTicketStatus",
    CreateServiceTicket = "createServiceTicket",
    CreateServiceTicketNote = "createServiceTicketNote",
    AccountController = "accountController",
    HomeController = "homeController",
    ContractImportProcess = "contractImportProcess",
    SendWelcomeToEpicier = "sendWelcomeToEpicier",
    RouteDeliveryConfirmationRequest = "routeDeliveryConfirmationRequest",
    CancelledOrderNotification = "cancelledOrderNotification",
    ImportClientLeadsFromSmsReferral = "importClientLeadsFromSmsReferral",
}

export abstract class UserMessageInfo implements IUserMessageInfo {
    name?: string | null;
    email?: string | null;

    constructor(data?: IUserMessageInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.email = _data["email"] !== undefined ? _data["email"] : <any>null;
        }
    }

    static fromJS(data: any): UserMessageInfo {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'UserMessageInfo' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["email"] = this.email !== undefined ? this.email : <any>null;
        return data;
    }
}

export interface IUserMessageInfo {
    name?: string | null;
    email?: string | null;
}

export class RecipientInfo extends UserMessageInfo implements IRecipientInfo {

    constructor(data?: IRecipientInfo) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): RecipientInfo {
        data = typeof data === 'object' ? data : {};
        let result = new RecipientInfo();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IRecipientInfo extends IUserMessageInfo {
}

export class FromInfo extends UserMessageInfo implements IFromInfo {

    constructor(data?: IFromInfo) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): FromInfo {
        data = typeof data === 'object' ? data : {};
        let result = new FromInfo();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IFromInfo extends IUserMessageInfo {
}

export class CommonMediaCommand implements ICommonMediaCommand {
    hasCaptions?: boolean;
    mediaCaptions?: MediaCaption[] | null;
    fileType?: string | null;
    internalDescription?: string | null;
    filename?: string | null;
    fileSize?: number;
    uploadedByUserId?: string | null;
    uploadedUrl?: string | null;

    constructor(data?: ICommonMediaCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.hasCaptions = _data["hasCaptions"] !== undefined ? _data["hasCaptions"] : <any>null;
            if (Array.isArray(_data["mediaCaptions"])) {
                this.mediaCaptions = [] as any;
                for (let item of _data["mediaCaptions"])
                    this.mediaCaptions!.push(MediaCaption.fromJS(item));
            }
            else {
                this.mediaCaptions = <any>null;
            }
            this.fileType = _data["fileType"] !== undefined ? _data["fileType"] : <any>null;
            this.internalDescription = _data["internalDescription"] !== undefined ? _data["internalDescription"] : <any>null;
            this.filename = _data["filename"] !== undefined ? _data["filename"] : <any>null;
            this.fileSize = _data["fileSize"] !== undefined ? _data["fileSize"] : <any>null;
            this.uploadedByUserId = _data["uploadedByUserId"] !== undefined ? _data["uploadedByUserId"] : <any>null;
            this.uploadedUrl = _data["uploadedUrl"] !== undefined ? _data["uploadedUrl"] : <any>null;
        }
    }

    static fromJS(data: any): CommonMediaCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CommonMediaCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["hasCaptions"] = this.hasCaptions !== undefined ? this.hasCaptions : <any>null;
        if (Array.isArray(this.mediaCaptions)) {
            data["mediaCaptions"] = [];
            for (let item of this.mediaCaptions)
                data["mediaCaptions"].push(item.toJSON());
        }
        data["fileType"] = this.fileType !== undefined ? this.fileType : <any>null;
        data["internalDescription"] = this.internalDescription !== undefined ? this.internalDescription : <any>null;
        data["filename"] = this.filename !== undefined ? this.filename : <any>null;
        data["fileSize"] = this.fileSize !== undefined ? this.fileSize : <any>null;
        data["uploadedByUserId"] = this.uploadedByUserId !== undefined ? this.uploadedByUserId : <any>null;
        data["uploadedUrl"] = this.uploadedUrl !== undefined ? this.uploadedUrl : <any>null;
        return data;
    }
}

export interface ICommonMediaCommand {
    hasCaptions?: boolean;
    mediaCaptions?: MediaCaption[] | null;
    fileType?: string | null;
    internalDescription?: string | null;
    filename?: string | null;
    fileSize?: number;
    uploadedByUserId?: string | null;
    uploadedUrl?: string | null;
}

export class CreateImageCommand extends CommonMediaCommand implements ICreateImageCommand {

    constructor(data?: ICreateImageCommand) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): CreateImageCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateImageCommand();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface ICreateImageCommand extends ICommonMediaCommand {
}

export class MediaCaption extends EntityOfString implements IMediaCaption {
    caption?: string | null;

    constructor(data?: IMediaCaption) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.caption = _data["caption"] !== undefined ? _data["caption"] : <any>null;
        }
    }

    static override fromJS(data: any): MediaCaption {
        data = typeof data === 'object' ? data : {};
        let result = new MediaCaption();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caption"] = this.caption !== undefined ? this.caption : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IMediaCaption extends IEntityOfString {
    caption?: string | null;
}

export class PaginatedResultOfLocalDnclDto extends PaginatedResult implements IPaginatedResultOfLocalDnclDto {
    entities?: LocalDnclDto[] | null;

    constructor(data?: IPaginatedResultOfLocalDnclDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["entities"])) {
                this.entities = [] as any;
                for (let item of _data["entities"])
                    this.entities!.push(LocalDnclDto.fromJS(item));
            }
            else {
                this.entities = <any>null;
            }
        }
    }

    static override fromJS(data: any): PaginatedResultOfLocalDnclDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResultOfLocalDnclDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.entities)) {
            data["entities"] = [];
            for (let item of this.entities)
                data["entities"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IPaginatedResultOfLocalDnclDto extends IPaginatedResult {
    entities?: LocalDnclDto[] | null;
}

export class LocalDnclDto implements ILocalDnclDto {
    phoneNumber?: string | null;

    constructor(data?: ILocalDnclDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.phoneNumber = _data["phoneNumber"] !== undefined ? _data["phoneNumber"] : <any>null;
        }
    }

    static fromJS(data: any): LocalDnclDto {
        data = typeof data === 'object' ? data : {};
        let result = new LocalDnclDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["phoneNumber"] = this.phoneNumber !== undefined ? this.phoneNumber : <any>null;
        return data;
    }
}

export interface ILocalDnclDto {
    phoneNumber?: string | null;
}

export class GetLocalDnclListQuery extends PaginationModel implements IGetLocalDnclListQuery {

    constructor(data?: IGetLocalDnclListQuery) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): GetLocalDnclListQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetLocalDnclListQuery();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IGetLocalDnclListQuery extends IPaginationModel {
}

export class LoginPageDto implements ILoginPageDto {
    id?: string | null;
    title?: string | null;
    text?: string | null;
    hasVideoBackground?: boolean;
    backgroundImageId?: string | null;
    backgroundImage?: ImageMediaDto | null;
    backgroundVideoId?: string | null;
    backgroundVideo?: VideoMediaDto | null;
    lastModifiedDateTime?: moment.Moment;
    lastModifiedDateById?: string | null;
    lastModifiedDateBy?: EmployeeDto | null;

    constructor(data?: ILoginPageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.title = _data["title"] !== undefined ? _data["title"] : <any>null;
            this.text = _data["text"] !== undefined ? _data["text"] : <any>null;
            this.hasVideoBackground = _data["hasVideoBackground"] !== undefined ? _data["hasVideoBackground"] : <any>null;
            this.backgroundImageId = _data["backgroundImageId"] !== undefined ? _data["backgroundImageId"] : <any>null;
            this.backgroundImage = _data["backgroundImage"] ? ImageMediaDto.fromJS(_data["backgroundImage"]) : <any>null;
            this.backgroundVideoId = _data["backgroundVideoId"] !== undefined ? _data["backgroundVideoId"] : <any>null;
            this.backgroundVideo = _data["backgroundVideo"] ? VideoMediaDto.fromJS(_data["backgroundVideo"]) : <any>null;
            this.lastModifiedDateTime = _data["lastModifiedDateTime"] ? moment(_data["lastModifiedDateTime"].toString()) : <any>null;
            this.lastModifiedDateById = _data["lastModifiedDateById"] !== undefined ? _data["lastModifiedDateById"] : <any>null;
            this.lastModifiedDateBy = _data["lastModifiedDateBy"] ? EmployeeDto.fromJS(_data["lastModifiedDateBy"]) : <any>null;
        }
    }

    static fromJS(data: any): LoginPageDto {
        data = typeof data === 'object' ? data : {};
        let result = new LoginPageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["title"] = this.title !== undefined ? this.title : <any>null;
        data["text"] = this.text !== undefined ? this.text : <any>null;
        data["hasVideoBackground"] = this.hasVideoBackground !== undefined ? this.hasVideoBackground : <any>null;
        data["backgroundImageId"] = this.backgroundImageId !== undefined ? this.backgroundImageId : <any>null;
        data["backgroundImage"] = this.backgroundImage ? this.backgroundImage.toJSON() : <any>null;
        data["backgroundVideoId"] = this.backgroundVideoId !== undefined ? this.backgroundVideoId : <any>null;
        data["backgroundVideo"] = this.backgroundVideo ? this.backgroundVideo.toJSON() : <any>null;
        data["lastModifiedDateTime"] = this.lastModifiedDateTime ? this.lastModifiedDateTime.toISOString() : <any>null;
        data["lastModifiedDateById"] = this.lastModifiedDateById !== undefined ? this.lastModifiedDateById : <any>null;
        data["lastModifiedDateBy"] = this.lastModifiedDateBy ? this.lastModifiedDateBy.toJSON() : <any>null;
        return data;
    }
}

export interface ILoginPageDto {
    id?: string | null;
    title?: string | null;
    text?: string | null;
    hasVideoBackground?: boolean;
    backgroundImageId?: string | null;
    backgroundImage?: ImageMediaDto | null;
    backgroundVideoId?: string | null;
    backgroundVideo?: VideoMediaDto | null;
    lastModifiedDateTime?: moment.Moment;
    lastModifiedDateById?: string | null;
    lastModifiedDateBy?: EmployeeDto | null;
}

export class VideoMediaDto implements IVideoMediaDto {
    id?: string | null;
    videoUrl?: string | null;

    constructor(data?: IVideoMediaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.videoUrl = _data["videoUrl"] !== undefined ? _data["videoUrl"] : <any>null;
        }
    }

    static fromJS(data: any): VideoMediaDto {
        data = typeof data === 'object' ? data : {};
        let result = new VideoMediaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["videoUrl"] = this.videoUrl !== undefined ? this.videoUrl : <any>null;
        return data;
    }
}

export interface IVideoMediaDto {
    id?: string | null;
    videoUrl?: string | null;
}

export class UpdateLoginPageCommand implements IUpdateLoginPageCommand {
    id?: string | null;
    title?: string | null;
    text?: string | null;
    hasVideoBackground?: boolean;
    backgroundImageId?: string | null;
    backgroundImage?: ImageMedia | null;
    backgroundVideoId?: string | null;
    backgroundVideo?: VideoMedia | null;
    lastModifiedDateTime?: moment.Moment;
    lastModifiedDateById?: string | null;
    lastModifiedDateBy?: EmployeeDto | null;

    constructor(data?: IUpdateLoginPageCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.title = _data["title"] !== undefined ? _data["title"] : <any>null;
            this.text = _data["text"] !== undefined ? _data["text"] : <any>null;
            this.hasVideoBackground = _data["hasVideoBackground"] !== undefined ? _data["hasVideoBackground"] : <any>null;
            this.backgroundImageId = _data["backgroundImageId"] !== undefined ? _data["backgroundImageId"] : <any>null;
            this.backgroundImage = _data["backgroundImage"] ? ImageMedia.fromJS(_data["backgroundImage"]) : <any>null;
            this.backgroundVideoId = _data["backgroundVideoId"] !== undefined ? _data["backgroundVideoId"] : <any>null;
            this.backgroundVideo = _data["backgroundVideo"] ? VideoMedia.fromJS(_data["backgroundVideo"]) : <any>null;
            this.lastModifiedDateTime = _data["lastModifiedDateTime"] ? moment(_data["lastModifiedDateTime"].toString()) : <any>null;
            this.lastModifiedDateById = _data["lastModifiedDateById"] !== undefined ? _data["lastModifiedDateById"] : <any>null;
            this.lastModifiedDateBy = _data["lastModifiedDateBy"] ? EmployeeDto.fromJS(_data["lastModifiedDateBy"]) : <any>null;
        }
    }

    static fromJS(data: any): UpdateLoginPageCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateLoginPageCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["title"] = this.title !== undefined ? this.title : <any>null;
        data["text"] = this.text !== undefined ? this.text : <any>null;
        data["hasVideoBackground"] = this.hasVideoBackground !== undefined ? this.hasVideoBackground : <any>null;
        data["backgroundImageId"] = this.backgroundImageId !== undefined ? this.backgroundImageId : <any>null;
        data["backgroundImage"] = this.backgroundImage ? this.backgroundImage.toJSON() : <any>null;
        data["backgroundVideoId"] = this.backgroundVideoId !== undefined ? this.backgroundVideoId : <any>null;
        data["backgroundVideo"] = this.backgroundVideo ? this.backgroundVideo.toJSON() : <any>null;
        data["lastModifiedDateTime"] = this.lastModifiedDateTime ? this.lastModifiedDateTime.toISOString() : <any>null;
        data["lastModifiedDateById"] = this.lastModifiedDateById !== undefined ? this.lastModifiedDateById : <any>null;
        data["lastModifiedDateBy"] = this.lastModifiedDateBy ? this.lastModifiedDateBy.toJSON() : <any>null;
        return data;
    }
}

export interface IUpdateLoginPageCommand {
    id?: string | null;
    title?: string | null;
    text?: string | null;
    hasVideoBackground?: boolean;
    backgroundImageId?: string | null;
    backgroundImage?: ImageMedia | null;
    backgroundVideoId?: string | null;
    backgroundVideo?: VideoMedia | null;
    lastModifiedDateTime?: moment.Moment;
    lastModifiedDateById?: string | null;
    lastModifiedDateBy?: EmployeeDto | null;
}

export class VideoMedia extends CommonMedia implements IVideoMedia {
    mediaId?: string | null;

    constructor(data?: IVideoMedia) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.mediaId = _data["mediaId"] !== undefined ? _data["mediaId"] : <any>null;
        }
    }

    static override fromJS(data: any): VideoMedia {
        data = typeof data === 'object' ? data : {};
        let result = new VideoMedia();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mediaId"] = this.mediaId !== undefined ? this.mediaId : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IVideoMedia extends ICommonMedia {
    mediaId?: string | null;
}

export class SendAppointmentDetailEmailsCommand implements ISendAppointmentDetailEmailsCommand {
    sendToSalesRep?: boolean;
    sendToSalesManager?: boolean;
    callNoListToSend?: number[] | null;
    url?: string | null;

    constructor(data?: ISendAppointmentDetailEmailsCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sendToSalesRep = _data["sendToSalesRep"] !== undefined ? _data["sendToSalesRep"] : <any>null;
            this.sendToSalesManager = _data["sendToSalesManager"] !== undefined ? _data["sendToSalesManager"] : <any>null;
            if (Array.isArray(_data["callNoListToSend"])) {
                this.callNoListToSend = [] as any;
                for (let item of _data["callNoListToSend"])
                    this.callNoListToSend!.push(item);
            }
            else {
                this.callNoListToSend = <any>null;
            }
            this.url = _data["url"] !== undefined ? _data["url"] : <any>null;
        }
    }

    static fromJS(data: any): SendAppointmentDetailEmailsCommand {
        data = typeof data === 'object' ? data : {};
        let result = new SendAppointmentDetailEmailsCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sendToSalesRep"] = this.sendToSalesRep !== undefined ? this.sendToSalesRep : <any>null;
        data["sendToSalesManager"] = this.sendToSalesManager !== undefined ? this.sendToSalesManager : <any>null;
        if (Array.isArray(this.callNoListToSend)) {
            data["callNoListToSend"] = [];
            for (let item of this.callNoListToSend)
                data["callNoListToSend"].push(item);
        }
        data["url"] = this.url !== undefined ? this.url : <any>null;
        return data;
    }
}

export interface ISendAppointmentDetailEmailsCommand {
    sendToSalesRep?: boolean;
    sendToSalesManager?: boolean;
    callNoListToSend?: number[] | null;
    url?: string | null;
}

export class PaginatedResultOfAppointmentManagementLookupDto extends PaginatedResult implements IPaginatedResultOfAppointmentManagementLookupDto {
    entities?: AppointmentManagementLookupDto[] | null;

    constructor(data?: IPaginatedResultOfAppointmentManagementLookupDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["entities"])) {
                this.entities = [] as any;
                for (let item of _data["entities"])
                    this.entities!.push(AppointmentManagementLookupDto.fromJS(item));
            }
            else {
                this.entities = <any>null;
            }
        }
    }

    static override fromJS(data: any): PaginatedResultOfAppointmentManagementLookupDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResultOfAppointmentManagementLookupDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.entities)) {
            data["entities"] = [];
            for (let item of this.entities)
                data["entities"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IPaginatedResultOfAppointmentManagementLookupDto extends IPaginatedResult {
    entities?: AppointmentManagementLookupDto[] | null;
}

export class AppointmentManagementLookupDto implements IAppointmentManagementLookupDto {
    index?: number;
    noAppel?: number;
    name?: string | null;
    spouse?: string | null;
    spouseFirstName?: string | null;
    spouseLastName?: string | null;
    address?: string | null;
    callDate?: moment.Moment | null;
    homePhone?: string | null;
    cellPhone?: string | null;
    references?: number;
    firstName?: string | null;
    lastName?: string | null;
    appointmentDateTime?: moment.Moment | null;
    tmName?: string | null;
    vendorNo?: number | null;
    vendorName?: string | null;
    vendorConfirmed?: boolean;
    appointmentTypeDisplay?: string | null;
    appointmentType?: AppointmentType;
    appointmentLanguage?: string | null;
    referenceVendorNo?: number | null;
    referenceVendorName?: string | null;
    city?: string | null;
    originalVendorNo?: number | null;
    originalVendorName?: string | null;
    salesRepAppointmentEmailSentDateTime?: moment.Moment | null;
    salesRepAppointmentEmailWasSent?: boolean | null;
    distributorAppointmentEmailSentDateTime?: moment.Moment | null;
    distributorAppointmentEmailWasSent?: boolean | null;
    appointmentStatus?: AppointmentStatus;
    rating?: number | null;
    ratingPercent?: number | null;
    isQualified?: boolean;
    isDisqualified?: boolean;
    isUnderReview?: boolean;
    isVirtual?: boolean | null;

    constructor(data?: IAppointmentManagementLookupDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.index = _data["index"] !== undefined ? _data["index"] : <any>null;
            this.noAppel = _data["noAppel"] !== undefined ? _data["noAppel"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.spouse = _data["spouse"] !== undefined ? _data["spouse"] : <any>null;
            this.spouseFirstName = _data["spouseFirstName"] !== undefined ? _data["spouseFirstName"] : <any>null;
            this.spouseLastName = _data["spouseLastName"] !== undefined ? _data["spouseLastName"] : <any>null;
            this.address = _data["address"] !== undefined ? _data["address"] : <any>null;
            this.callDate = _data["callDate"] ? moment(_data["callDate"].toString()) : <any>null;
            this.homePhone = _data["homePhone"] !== undefined ? _data["homePhone"] : <any>null;
            this.cellPhone = _data["cellPhone"] !== undefined ? _data["cellPhone"] : <any>null;
            this.references = _data["references"] !== undefined ? _data["references"] : <any>null;
            this.firstName = _data["firstName"] !== undefined ? _data["firstName"] : <any>null;
            this.lastName = _data["lastName"] !== undefined ? _data["lastName"] : <any>null;
            this.appointmentDateTime = _data["appointmentDateTime"] ? moment(_data["appointmentDateTime"].toString()) : <any>null;
            this.tmName = _data["tmName"] !== undefined ? _data["tmName"] : <any>null;
            this.vendorNo = _data["vendorNo"] !== undefined ? _data["vendorNo"] : <any>null;
            this.vendorName = _data["vendorName"] !== undefined ? _data["vendorName"] : <any>null;
            this.vendorConfirmed = _data["vendorConfirmed"] !== undefined ? _data["vendorConfirmed"] : <any>null;
            this.appointmentTypeDisplay = _data["appointmentTypeDisplay"] !== undefined ? _data["appointmentTypeDisplay"] : <any>null;
            this.appointmentType = _data["appointmentType"] !== undefined ? _data["appointmentType"] : <any>null;
            this.appointmentLanguage = _data["appointmentLanguage"] !== undefined ? _data["appointmentLanguage"] : <any>null;
            this.referenceVendorNo = _data["referenceVendorNo"] !== undefined ? _data["referenceVendorNo"] : <any>null;
            this.referenceVendorName = _data["referenceVendorName"] !== undefined ? _data["referenceVendorName"] : <any>null;
            this.city = _data["city"] !== undefined ? _data["city"] : <any>null;
            this.originalVendorNo = _data["originalVendorNo"] !== undefined ? _data["originalVendorNo"] : <any>null;
            this.originalVendorName = _data["originalVendorName"] !== undefined ? _data["originalVendorName"] : <any>null;
            this.salesRepAppointmentEmailSentDateTime = _data["salesRepAppointmentEmailSentDateTime"] ? moment(_data["salesRepAppointmentEmailSentDateTime"].toString()) : <any>null;
            this.salesRepAppointmentEmailWasSent = _data["salesRepAppointmentEmailWasSent"] !== undefined ? _data["salesRepAppointmentEmailWasSent"] : <any>null;
            this.distributorAppointmentEmailSentDateTime = _data["distributorAppointmentEmailSentDateTime"] ? moment(_data["distributorAppointmentEmailSentDateTime"].toString()) : <any>null;
            this.distributorAppointmentEmailWasSent = _data["distributorAppointmentEmailWasSent"] !== undefined ? _data["distributorAppointmentEmailWasSent"] : <any>null;
            this.appointmentStatus = _data["appointmentStatus"] !== undefined ? _data["appointmentStatus"] : <any>null;
            this.rating = _data["rating"] !== undefined ? _data["rating"] : <any>null;
            this.ratingPercent = _data["ratingPercent"] !== undefined ? _data["ratingPercent"] : <any>null;
            this.isQualified = _data["isQualified"] !== undefined ? _data["isQualified"] : <any>null;
            this.isDisqualified = _data["isDisqualified"] !== undefined ? _data["isDisqualified"] : <any>null;
            this.isUnderReview = _data["isUnderReview"] !== undefined ? _data["isUnderReview"] : <any>null;
            this.isVirtual = _data["isVirtual"] !== undefined ? _data["isVirtual"] : <any>null;
        }
    }

    static fromJS(data: any): AppointmentManagementLookupDto {
        data = typeof data === 'object' ? data : {};
        let result = new AppointmentManagementLookupDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["index"] = this.index !== undefined ? this.index : <any>null;
        data["noAppel"] = this.noAppel !== undefined ? this.noAppel : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["spouse"] = this.spouse !== undefined ? this.spouse : <any>null;
        data["spouseFirstName"] = this.spouseFirstName !== undefined ? this.spouseFirstName : <any>null;
        data["spouseLastName"] = this.spouseLastName !== undefined ? this.spouseLastName : <any>null;
        data["address"] = this.address !== undefined ? this.address : <any>null;
        data["callDate"] = this.callDate ? this.callDate.toISOString() : <any>null;
        data["homePhone"] = this.homePhone !== undefined ? this.homePhone : <any>null;
        data["cellPhone"] = this.cellPhone !== undefined ? this.cellPhone : <any>null;
        data["references"] = this.references !== undefined ? this.references : <any>null;
        data["firstName"] = this.firstName !== undefined ? this.firstName : <any>null;
        data["lastName"] = this.lastName !== undefined ? this.lastName : <any>null;
        data["appointmentDateTime"] = this.appointmentDateTime ? this.appointmentDateTime.toISOString() : <any>null;
        data["tmName"] = this.tmName !== undefined ? this.tmName : <any>null;
        data["vendorNo"] = this.vendorNo !== undefined ? this.vendorNo : <any>null;
        data["vendorName"] = this.vendorName !== undefined ? this.vendorName : <any>null;
        data["vendorConfirmed"] = this.vendorConfirmed !== undefined ? this.vendorConfirmed : <any>null;
        data["appointmentTypeDisplay"] = this.appointmentTypeDisplay !== undefined ? this.appointmentTypeDisplay : <any>null;
        data["appointmentType"] = this.appointmentType !== undefined ? this.appointmentType : <any>null;
        data["appointmentLanguage"] = this.appointmentLanguage !== undefined ? this.appointmentLanguage : <any>null;
        data["referenceVendorNo"] = this.referenceVendorNo !== undefined ? this.referenceVendorNo : <any>null;
        data["referenceVendorName"] = this.referenceVendorName !== undefined ? this.referenceVendorName : <any>null;
        data["city"] = this.city !== undefined ? this.city : <any>null;
        data["originalVendorNo"] = this.originalVendorNo !== undefined ? this.originalVendorNo : <any>null;
        data["originalVendorName"] = this.originalVendorName !== undefined ? this.originalVendorName : <any>null;
        data["salesRepAppointmentEmailSentDateTime"] = this.salesRepAppointmentEmailSentDateTime ? this.salesRepAppointmentEmailSentDateTime.toISOString() : <any>null;
        data["salesRepAppointmentEmailWasSent"] = this.salesRepAppointmentEmailWasSent !== undefined ? this.salesRepAppointmentEmailWasSent : <any>null;
        data["distributorAppointmentEmailSentDateTime"] = this.distributorAppointmentEmailSentDateTime ? this.distributorAppointmentEmailSentDateTime.toISOString() : <any>null;
        data["distributorAppointmentEmailWasSent"] = this.distributorAppointmentEmailWasSent !== undefined ? this.distributorAppointmentEmailWasSent : <any>null;
        data["appointmentStatus"] = this.appointmentStatus !== undefined ? this.appointmentStatus : <any>null;
        data["rating"] = this.rating !== undefined ? this.rating : <any>null;
        data["ratingPercent"] = this.ratingPercent !== undefined ? this.ratingPercent : <any>null;
        data["isQualified"] = this.isQualified !== undefined ? this.isQualified : <any>null;
        data["isDisqualified"] = this.isDisqualified !== undefined ? this.isDisqualified : <any>null;
        data["isUnderReview"] = this.isUnderReview !== undefined ? this.isUnderReview : <any>null;
        data["isVirtual"] = this.isVirtual !== undefined ? this.isVirtual : <any>null;
        return data;
    }
}

export interface IAppointmentManagementLookupDto {
    index?: number;
    noAppel?: number;
    name?: string | null;
    spouse?: string | null;
    spouseFirstName?: string | null;
    spouseLastName?: string | null;
    address?: string | null;
    callDate?: moment.Moment | null;
    homePhone?: string | null;
    cellPhone?: string | null;
    references?: number;
    firstName?: string | null;
    lastName?: string | null;
    appointmentDateTime?: moment.Moment | null;
    tmName?: string | null;
    vendorNo?: number | null;
    vendorName?: string | null;
    vendorConfirmed?: boolean;
    appointmentTypeDisplay?: string | null;
    appointmentType?: AppointmentType;
    appointmentLanguage?: string | null;
    referenceVendorNo?: number | null;
    referenceVendorName?: string | null;
    city?: string | null;
    originalVendorNo?: number | null;
    originalVendorName?: string | null;
    salesRepAppointmentEmailSentDateTime?: moment.Moment | null;
    salesRepAppointmentEmailWasSent?: boolean | null;
    distributorAppointmentEmailSentDateTime?: moment.Moment | null;
    distributorAppointmentEmailWasSent?: boolean | null;
    appointmentStatus?: AppointmentStatus;
    rating?: number | null;
    ratingPercent?: number | null;
    isQualified?: boolean;
    isDisqualified?: boolean;
    isUnderReview?: boolean;
    isVirtual?: boolean | null;
}

export abstract class BaseAppointmentListQuery extends PaginationModel implements IBaseAppointmentListQuery {
    searchDateUtcRange?: (moment.Moment | null)[] | null;

    constructor(data?: IBaseAppointmentListQuery) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["searchDateUtcRange"])) {
                this.searchDateUtcRange = [] as any;
                for (let item of _data["searchDateUtcRange"])
                    this.searchDateUtcRange!.push(moment(item));
            }
            else {
                this.searchDateUtcRange = <any>null;
            }
        }
    }

    static override fromJS(data: any): BaseAppointmentListQuery {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'BaseAppointmentListQuery' cannot be instantiated.");
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.searchDateUtcRange)) {
            data["searchDateUtcRange"] = [];
            for (let item of this.searchDateUtcRange)
                data["searchDateUtcRange"].push(item.toISOString());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IBaseAppointmentListQuery extends IPaginationModel {
    searchDateUtcRange?: (moment.Moment | null)[] | null;
}

export class AppointmentManagementFilters extends BaseAppointmentListQuery implements IAppointmentManagementFilters {
    statusFilters?: (AppointmentStatus | null)[] | null;
    new?: boolean;
    renew?: boolean;
    winback?: boolean;
    useAppointmentTypeFilter?: boolean;
    isModalSearch?: boolean;
    viewAsId?: number | null;
    onlyShowQualified?: boolean;
    virtual?: boolean;
    physical?: boolean;

    constructor(data?: IAppointmentManagementFilters) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["statusFilters"])) {
                this.statusFilters = [] as any;
                for (let item of _data["statusFilters"])
                    this.statusFilters!.push(item);
            }
            else {
                this.statusFilters = <any>null;
            }
            this.new = _data["new"] !== undefined ? _data["new"] : <any>null;
            this.renew = _data["renew"] !== undefined ? _data["renew"] : <any>null;
            this.winback = _data["winback"] !== undefined ? _data["winback"] : <any>null;
            this.useAppointmentTypeFilter = _data["useAppointmentTypeFilter"] !== undefined ? _data["useAppointmentTypeFilter"] : <any>null;
            this.isModalSearch = _data["isModalSearch"] !== undefined ? _data["isModalSearch"] : <any>null;
            this.viewAsId = _data["viewAsId"] !== undefined ? _data["viewAsId"] : <any>null;
            this.onlyShowQualified = _data["onlyShowQualified"] !== undefined ? _data["onlyShowQualified"] : <any>null;
            this.virtual = _data["virtual"] !== undefined ? _data["virtual"] : <any>null;
            this.physical = _data["physical"] !== undefined ? _data["physical"] : <any>null;
        }
    }

    static override fromJS(data: any): AppointmentManagementFilters {
        data = typeof data === 'object' ? data : {};
        let result = new AppointmentManagementFilters();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.statusFilters)) {
            data["statusFilters"] = [];
            for (let item of this.statusFilters)
                data["statusFilters"].push(item);
        }
        data["new"] = this.new !== undefined ? this.new : <any>null;
        data["renew"] = this.renew !== undefined ? this.renew : <any>null;
        data["winback"] = this.winback !== undefined ? this.winback : <any>null;
        data["useAppointmentTypeFilter"] = this.useAppointmentTypeFilter !== undefined ? this.useAppointmentTypeFilter : <any>null;
        data["isModalSearch"] = this.isModalSearch !== undefined ? this.isModalSearch : <any>null;
        data["viewAsId"] = this.viewAsId !== undefined ? this.viewAsId : <any>null;
        data["onlyShowQualified"] = this.onlyShowQualified !== undefined ? this.onlyShowQualified : <any>null;
        data["virtual"] = this.virtual !== undefined ? this.virtual : <any>null;
        data["physical"] = this.physical !== undefined ? this.physical : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IAppointmentManagementFilters extends IBaseAppointmentListQuery {
    statusFilters?: (AppointmentStatus | null)[] | null;
    new?: boolean;
    renew?: boolean;
    winback?: boolean;
    useAppointmentTypeFilter?: boolean;
    isModalSearch?: boolean;
    viewAsId?: number | null;
    onlyShowQualified?: boolean;
    virtual?: boolean;
    physical?: boolean;
}

export class GetAppointmentManagementListQuery extends AppointmentManagementFilters implements IGetAppointmentManagementListQuery {
    fromTmId?: string | null;

    constructor(data?: IGetAppointmentManagementListQuery) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.fromTmId = _data["fromTmId"] !== undefined ? _data["fromTmId"] : <any>null;
        }
    }

    static override fromJS(data: any): GetAppointmentManagementListQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetAppointmentManagementListQuery();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fromTmId"] = this.fromTmId !== undefined ? this.fromTmId : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IGetAppointmentManagementListQuery extends IAppointmentManagementFilters {
    fromTmId?: string | null;
}

export class ConfirmAppointmentCommand implements IConfirmAppointmentCommand {
    callNo?: number;
    confirmedSalesRep?: SalesRepDto | null;
    appointmentDateTime?: moment.Moment | null;
    postPonedDate?: moment.Moment;
    appointmentStatus?: AppointmentStatus;
    comments?: string | null;
    distributorComments?: string | null;
    statusComments?: string | null;
    employeeId?: string | null;
    isVirtual?: boolean;

    constructor(data?: IConfirmAppointmentCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.callNo = _data["callNo"] !== undefined ? _data["callNo"] : <any>null;
            this.confirmedSalesRep = _data["confirmedSalesRep"] ? SalesRepDto.fromJS(_data["confirmedSalesRep"]) : <any>null;
            this.appointmentDateTime = _data["appointmentDateTime"] ? moment(_data["appointmentDateTime"].toString()) : <any>null;
            this.postPonedDate = _data["postPonedDate"] ? moment(_data["postPonedDate"].toString()) : <any>null;
            this.appointmentStatus = _data["appointmentStatus"] !== undefined ? _data["appointmentStatus"] : <any>null;
            this.comments = _data["comments"] !== undefined ? _data["comments"] : <any>null;
            this.distributorComments = _data["distributorComments"] !== undefined ? _data["distributorComments"] : <any>null;
            this.statusComments = _data["statusComments"] !== undefined ? _data["statusComments"] : <any>null;
            this.employeeId = _data["employeeId"] !== undefined ? _data["employeeId"] : <any>null;
            this.isVirtual = _data["isVirtual"] !== undefined ? _data["isVirtual"] : <any>null;
        }
    }

    static fromJS(data: any): ConfirmAppointmentCommand {
        data = typeof data === 'object' ? data : {};
        let result = new ConfirmAppointmentCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["callNo"] = this.callNo !== undefined ? this.callNo : <any>null;
        data["confirmedSalesRep"] = this.confirmedSalesRep ? this.confirmedSalesRep.toJSON() : <any>null;
        data["appointmentDateTime"] = this.appointmentDateTime ? this.appointmentDateTime.toISOString() : <any>null;
        data["postPonedDate"] = this.postPonedDate ? this.postPonedDate.toISOString() : <any>null;
        data["appointmentStatus"] = this.appointmentStatus !== undefined ? this.appointmentStatus : <any>null;
        data["comments"] = this.comments !== undefined ? this.comments : <any>null;
        data["distributorComments"] = this.distributorComments !== undefined ? this.distributorComments : <any>null;
        data["statusComments"] = this.statusComments !== undefined ? this.statusComments : <any>null;
        data["employeeId"] = this.employeeId !== undefined ? this.employeeId : <any>null;
        data["isVirtual"] = this.isVirtual !== undefined ? this.isVirtual : <any>null;
        return data;
    }
}

export interface IConfirmAppointmentCommand {
    callNo?: number;
    confirmedSalesRep?: SalesRepDto | null;
    appointmentDateTime?: moment.Moment | null;
    postPonedDate?: moment.Moment;
    appointmentStatus?: AppointmentStatus;
    comments?: string | null;
    distributorComments?: string | null;
    statusComments?: string | null;
    employeeId?: string | null;
    isVirtual?: boolean;
}

export class PastAppointmentDto implements IPastAppointmentDto {
    orderNo?: number;
    clientNo?: number;
    orderCreated?: moment.Moment | null;
    appointmentRepName?: string | null;
    appointmentDirectorName?: string | null;
    telemarketerName?: string | null;

    constructor(data?: IPastAppointmentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.orderNo = _data["orderNo"] !== undefined ? _data["orderNo"] : <any>null;
            this.clientNo = _data["clientNo"] !== undefined ? _data["clientNo"] : <any>null;
            this.orderCreated = _data["orderCreated"] ? moment(_data["orderCreated"].toString()) : <any>null;
            this.appointmentRepName = _data["appointmentRepName"] !== undefined ? _data["appointmentRepName"] : <any>null;
            this.appointmentDirectorName = _data["appointmentDirectorName"] !== undefined ? _data["appointmentDirectorName"] : <any>null;
            this.telemarketerName = _data["telemarketerName"] !== undefined ? _data["telemarketerName"] : <any>null;
        }
    }

    static fromJS(data: any): PastAppointmentDto {
        data = typeof data === 'object' ? data : {};
        let result = new PastAppointmentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["orderNo"] = this.orderNo !== undefined ? this.orderNo : <any>null;
        data["clientNo"] = this.clientNo !== undefined ? this.clientNo : <any>null;
        data["orderCreated"] = this.orderCreated ? this.orderCreated.toISOString() : <any>null;
        data["appointmentRepName"] = this.appointmentRepName !== undefined ? this.appointmentRepName : <any>null;
        data["appointmentDirectorName"] = this.appointmentDirectorName !== undefined ? this.appointmentDirectorName : <any>null;
        data["telemarketerName"] = this.telemarketerName !== undefined ? this.telemarketerName : <any>null;
        return data;
    }
}

export interface IPastAppointmentDto {
    orderNo?: number;
    clientNo?: number;
    orderCreated?: moment.Moment | null;
    appointmentRepName?: string | null;
    appointmentDirectorName?: string | null;
    telemarketerName?: string | null;
}

export class AppointmentSearchFilterCountsDto implements IAppointmentSearchFilterCountsDto {
    appointmentStatusCounts?: { [key in keyof typeof AppointmentStatus]?: number; } | null;
    appointmentTypeCounts?: { [key in keyof typeof AppointmentType]?: number; } | null;
    appointmentLocationCounts?: { [key: string]: number; } | null;

    constructor(data?: IAppointmentSearchFilterCountsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (_data["appointmentStatusCounts"]) {
                this.appointmentStatusCounts = {} as any;
                for (let key in _data["appointmentStatusCounts"]) {
                    if (_data["appointmentStatusCounts"].hasOwnProperty(key))
                        (<any>this.appointmentStatusCounts)![key] = _data["appointmentStatusCounts"][key] !== undefined ? _data["appointmentStatusCounts"][key] : <any>null;
                }
            }
            else {
                this.appointmentStatusCounts = <any>null;
            }
            if (_data["appointmentTypeCounts"]) {
                this.appointmentTypeCounts = {} as any;
                for (let key in _data["appointmentTypeCounts"]) {
                    if (_data["appointmentTypeCounts"].hasOwnProperty(key))
                        (<any>this.appointmentTypeCounts)![key] = _data["appointmentTypeCounts"][key] !== undefined ? _data["appointmentTypeCounts"][key] : <any>null;
                }
            }
            else {
                this.appointmentTypeCounts = <any>null;
            }
            if (_data["appointmentLocationCounts"]) {
                this.appointmentLocationCounts = {} as any;
                for (let key in _data["appointmentLocationCounts"]) {
                    if (_data["appointmentLocationCounts"].hasOwnProperty(key))
                        (<any>this.appointmentLocationCounts)![key] = _data["appointmentLocationCounts"][key] !== undefined ? _data["appointmentLocationCounts"][key] : <any>null;
                }
            }
            else {
                this.appointmentLocationCounts = <any>null;
            }
        }
    }

    static fromJS(data: any): AppointmentSearchFilterCountsDto {
        data = typeof data === 'object' ? data : {};
        let result = new AppointmentSearchFilterCountsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.appointmentStatusCounts) {
            data["appointmentStatusCounts"] = {};
            for (let key in this.appointmentStatusCounts) {
                if (this.appointmentStatusCounts.hasOwnProperty(key))
                    (<any>data["appointmentStatusCounts"])[key] = this.appointmentStatusCounts[key] !== undefined ? this.appointmentStatusCounts[key] : <any>null;
            }
        }
        if (this.appointmentTypeCounts) {
            data["appointmentTypeCounts"] = {};
            for (let key in this.appointmentTypeCounts) {
                if (this.appointmentTypeCounts.hasOwnProperty(key))
                    (<any>data["appointmentTypeCounts"])[key] = this.appointmentTypeCounts[key] !== undefined ? this.appointmentTypeCounts[key] : <any>null;
            }
        }
        if (this.appointmentLocationCounts) {
            data["appointmentLocationCounts"] = {};
            for (let key in this.appointmentLocationCounts) {
                if (this.appointmentLocationCounts.hasOwnProperty(key))
                    (<any>data["appointmentLocationCounts"])[key] = this.appointmentLocationCounts[key] !== undefined ? this.appointmentLocationCounts[key] : <any>null;
            }
        }
        return data;
    }
}

export interface IAppointmentSearchFilterCountsDto {
    appointmentStatusCounts?: { [key in keyof typeof AppointmentStatus]?: number; } | null;
    appointmentTypeCounts?: { [key in keyof typeof AppointmentType]?: number; } | null;
    appointmentLocationCounts?: { [key: string]: number; } | null;
}

export class GetFilterCountsQuery extends AppointmentManagementFilters implements IGetFilterCountsQuery {
    isManagement?: boolean;

    constructor(data?: IGetFilterCountsQuery) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.isManagement = _data["isManagement"] !== undefined ? _data["isManagement"] : <any>null;
        }
    }

    static override fromJS(data: any): GetFilterCountsQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetFilterCountsQuery();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isManagement"] = this.isManagement !== undefined ? this.isManagement : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IGetFilterCountsQuery extends IAppointmentManagementFilters {
    isManagement?: boolean;
}

export class PaginatedResultOfMediaDto extends PaginatedResult implements IPaginatedResultOfMediaDto {
    entities?: MediaDto[] | null;

    constructor(data?: IPaginatedResultOfMediaDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["entities"])) {
                this.entities = [] as any;
                for (let item of _data["entities"])
                    this.entities!.push(MediaDto.fromJS(item));
            }
            else {
                this.entities = <any>null;
            }
        }
    }

    static override fromJS(data: any): PaginatedResultOfMediaDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResultOfMediaDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.entities)) {
            data["entities"] = [];
            for (let item of this.entities)
                data["entities"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IPaginatedResultOfMediaDto extends IPaginatedResult {
    entities?: MediaDto[] | null;
}

export class MediaDto implements IMediaDto {
    id?: string | null;
    mediaType?: MediaType;
    thumbnailPath?: string | null;
    uploadedFileName?: string | null;
    fileType?: string | null;
    fileSize?: number;
    height?: number;
    width?: number;
    filePath?: string | null;
    fileExtension?: string | null;

    constructor(data?: IMediaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.mediaType = _data["mediaType"] !== undefined ? _data["mediaType"] : <any>null;
            this.thumbnailPath = _data["thumbnailPath"] !== undefined ? _data["thumbnailPath"] : <any>null;
            this.uploadedFileName = _data["uploadedFileName"] !== undefined ? _data["uploadedFileName"] : <any>null;
            this.fileType = _data["fileType"] !== undefined ? _data["fileType"] : <any>null;
            this.fileSize = _data["fileSize"] !== undefined ? _data["fileSize"] : <any>null;
            this.height = _data["height"] !== undefined ? _data["height"] : <any>null;
            this.width = _data["width"] !== undefined ? _data["width"] : <any>null;
            this.filePath = _data["filePath"] !== undefined ? _data["filePath"] : <any>null;
            this.fileExtension = _data["fileExtension"] !== undefined ? _data["fileExtension"] : <any>null;
        }
    }

    static fromJS(data: any): MediaDto {
        data = typeof data === 'object' ? data : {};
        let result = new MediaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["mediaType"] = this.mediaType !== undefined ? this.mediaType : <any>null;
        data["thumbnailPath"] = this.thumbnailPath !== undefined ? this.thumbnailPath : <any>null;
        data["uploadedFileName"] = this.uploadedFileName !== undefined ? this.uploadedFileName : <any>null;
        data["fileType"] = this.fileType !== undefined ? this.fileType : <any>null;
        data["fileSize"] = this.fileSize !== undefined ? this.fileSize : <any>null;
        data["height"] = this.height !== undefined ? this.height : <any>null;
        data["width"] = this.width !== undefined ? this.width : <any>null;
        data["filePath"] = this.filePath !== undefined ? this.filePath : <any>null;
        data["fileExtension"] = this.fileExtension !== undefined ? this.fileExtension : <any>null;
        return data;
    }
}

export interface IMediaDto {
    id?: string | null;
    mediaType?: MediaType;
    thumbnailPath?: string | null;
    uploadedFileName?: string | null;
    fileType?: string | null;
    fileSize?: number;
    height?: number;
    width?: number;
    filePath?: string | null;
    fileExtension?: string | null;
}

export enum MediaType {
    Image = "image",
    Document = "document",
    Misc = "misc",
}

export class GetAllMediaListQuery extends PaginationModel implements IGetAllMediaListQuery {
    getDocuments?: boolean;
    getImages?: boolean;
    createdByUserId?: string | null;
    fromDateTime?: moment.Moment | null;
    toDateTime?: moment.Moment | null;
    requireExactImageDimensions?: boolean;
    requiredImageHeight?: number;
    requiredImageWidth?: number;

    constructor(data?: IGetAllMediaListQuery) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.getDocuments = _data["getDocuments"] !== undefined ? _data["getDocuments"] : <any>null;
            this.getImages = _data["getImages"] !== undefined ? _data["getImages"] : <any>null;
            this.createdByUserId = _data["createdByUserId"] !== undefined ? _data["createdByUserId"] : <any>null;
            this.fromDateTime = _data["fromDateTime"] ? moment(_data["fromDateTime"].toString()) : <any>null;
            this.toDateTime = _data["toDateTime"] ? moment(_data["toDateTime"].toString()) : <any>null;
            this.requireExactImageDimensions = _data["requireExactImageDimensions"] !== undefined ? _data["requireExactImageDimensions"] : <any>null;
            this.requiredImageHeight = _data["requiredImageHeight"] !== undefined ? _data["requiredImageHeight"] : <any>null;
            this.requiredImageWidth = _data["requiredImageWidth"] !== undefined ? _data["requiredImageWidth"] : <any>null;
        }
    }

    static override fromJS(data: any): GetAllMediaListQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllMediaListQuery();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["getDocuments"] = this.getDocuments !== undefined ? this.getDocuments : <any>null;
        data["getImages"] = this.getImages !== undefined ? this.getImages : <any>null;
        data["createdByUserId"] = this.createdByUserId !== undefined ? this.createdByUserId : <any>null;
        data["fromDateTime"] = this.fromDateTime ? this.fromDateTime.toISOString() : <any>null;
        data["toDateTime"] = this.toDateTime ? this.toDateTime.toISOString() : <any>null;
        data["requireExactImageDimensions"] = this.requireExactImageDimensions !== undefined ? this.requireExactImageDimensions : <any>null;
        data["requiredImageHeight"] = this.requiredImageHeight !== undefined ? this.requiredImageHeight : <any>null;
        data["requiredImageWidth"] = this.requiredImageWidth !== undefined ? this.requiredImageWidth : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IGetAllMediaListQuery extends IPaginationModel {
    getDocuments?: boolean;
    getImages?: boolean;
    createdByUserId?: string | null;
    fromDateTime?: moment.Moment | null;
    toDateTime?: moment.Moment | null;
    requireExactImageDimensions?: boolean;
    requiredImageHeight?: number;
    requiredImageWidth?: number;
}

export class PaginatedResultOfMenuLookupDto extends PaginatedResult implements IPaginatedResultOfMenuLookupDto {
    entities?: MenuLookupDto[] | null;

    constructor(data?: IPaginatedResultOfMenuLookupDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["entities"])) {
                this.entities = [] as any;
                for (let item of _data["entities"])
                    this.entities!.push(MenuLookupDto.fromJS(item));
            }
            else {
                this.entities = <any>null;
            }
        }
    }

    static override fromJS(data: any): PaginatedResultOfMenuLookupDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResultOfMenuLookupDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.entities)) {
            data["entities"] = [];
            for (let item of this.entities)
                data["entities"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IPaginatedResultOfMenuLookupDto extends IPaginatedResult {
    entities?: MenuLookupDto[] | null;
}

export class MenuLookupDto implements IMenuLookupDto {
    index?: number;
    id?: string | null;
    menuNo?: number;
    name?: string | null;
    isClassic?: boolean | null;
    operationCost?: number | null;
    variableAmount?: number | null;
    terms?: number | null;
    totalProductPrice?: number;
    totalProductPriceWithTaxes?: number;
    totalTaxes?: number;
    productProfit?: number;
    productProfitPercentage?: number;
    active?: boolean;
    totalProducts?: number;

    constructor(data?: IMenuLookupDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.index = _data["index"] !== undefined ? _data["index"] : <any>null;
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.menuNo = _data["menuNo"] !== undefined ? _data["menuNo"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.isClassic = _data["isClassic"] !== undefined ? _data["isClassic"] : <any>null;
            this.operationCost = _data["operationCost"] !== undefined ? _data["operationCost"] : <any>null;
            this.variableAmount = _data["variableAmount"] !== undefined ? _data["variableAmount"] : <any>null;
            this.terms = _data["terms"] !== undefined ? _data["terms"] : <any>null;
            this.totalProductPrice = _data["totalProductPrice"] !== undefined ? _data["totalProductPrice"] : <any>null;
            this.totalProductPriceWithTaxes = _data["totalProductPriceWithTaxes"] !== undefined ? _data["totalProductPriceWithTaxes"] : <any>null;
            this.totalTaxes = _data["totalTaxes"] !== undefined ? _data["totalTaxes"] : <any>null;
            this.productProfit = _data["productProfit"] !== undefined ? _data["productProfit"] : <any>null;
            this.productProfitPercentage = _data["productProfitPercentage"] !== undefined ? _data["productProfitPercentage"] : <any>null;
            this.active = _data["active"] !== undefined ? _data["active"] : <any>null;
            this.totalProducts = _data["totalProducts"] !== undefined ? _data["totalProducts"] : <any>null;
        }
    }

    static fromJS(data: any): MenuLookupDto {
        data = typeof data === 'object' ? data : {};
        let result = new MenuLookupDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["index"] = this.index !== undefined ? this.index : <any>null;
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["menuNo"] = this.menuNo !== undefined ? this.menuNo : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["isClassic"] = this.isClassic !== undefined ? this.isClassic : <any>null;
        data["operationCost"] = this.operationCost !== undefined ? this.operationCost : <any>null;
        data["variableAmount"] = this.variableAmount !== undefined ? this.variableAmount : <any>null;
        data["terms"] = this.terms !== undefined ? this.terms : <any>null;
        data["totalProductPrice"] = this.totalProductPrice !== undefined ? this.totalProductPrice : <any>null;
        data["totalProductPriceWithTaxes"] = this.totalProductPriceWithTaxes !== undefined ? this.totalProductPriceWithTaxes : <any>null;
        data["totalTaxes"] = this.totalTaxes !== undefined ? this.totalTaxes : <any>null;
        data["productProfit"] = this.productProfit !== undefined ? this.productProfit : <any>null;
        data["productProfitPercentage"] = this.productProfitPercentage !== undefined ? this.productProfitPercentage : <any>null;
        data["active"] = this.active !== undefined ? this.active : <any>null;
        data["totalProducts"] = this.totalProducts !== undefined ? this.totalProducts : <any>null;
        return data;
    }
}

export interface IMenuLookupDto {
    index?: number;
    id?: string | null;
    menuNo?: number;
    name?: string | null;
    isClassic?: boolean | null;
    operationCost?: number | null;
    variableAmount?: number | null;
    terms?: number | null;
    totalProductPrice?: number;
    totalProductPriceWithTaxes?: number;
    totalTaxes?: number;
    productProfit?: number;
    productProfitPercentage?: number;
    active?: boolean;
    totalProducts?: number;
}

export class GetMenusListQuery extends PaginationModel implements IGetMenusListQuery {
    user?: ClaimsPrincipal | null;

    constructor(data?: IGetMenusListQuery) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.user = _data["user"] ? ClaimsPrincipal.fromJS(_data["user"]) : <any>null;
        }
    }

    static override fromJS(data: any): GetMenusListQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetMenusListQuery();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["user"] = this.user ? this.user.toJSON() : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IGetMenusListQuery extends IPaginationModel {
    user?: ClaimsPrincipal | null;
}

export class MenuDto implements IMenuDto {
    id?: string | null;
    menuNo?: number;
    name?: string | null;
    isClassic?: boolean | null;
    variableAmount?: number | null;
    canModifyTerm?: boolean;
    operationCost?: number | null;
    totalProductPriceWithTaxes?: number;
    totalProductCost?: number;
    totalProductPrice?: number;
    terms?: number | null;
    totalWeeklyAmount?: number;
    categories?: CategoryDto[] | null;
    categoriesVisibleInDigitalMenu?: CategoryDto[] | null;
    selectedCategory?: CategoryDto | null;
    active?: boolean;
    isManualSelectionOnly?: boolean;
    extraOperationCostFee?: number;
    shortId?: string | null;

    constructor(data?: IMenuDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.menuNo = _data["menuNo"] !== undefined ? _data["menuNo"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.isClassic = _data["isClassic"] !== undefined ? _data["isClassic"] : <any>null;
            this.variableAmount = _data["variableAmount"] !== undefined ? _data["variableAmount"] : <any>null;
            this.canModifyTerm = _data["canModifyTerm"] !== undefined ? _data["canModifyTerm"] : <any>null;
            this.operationCost = _data["operationCost"] !== undefined ? _data["operationCost"] : <any>null;
            this.totalProductPriceWithTaxes = _data["totalProductPriceWithTaxes"] !== undefined ? _data["totalProductPriceWithTaxes"] : <any>null;
            this.totalProductCost = _data["totalProductCost"] !== undefined ? _data["totalProductCost"] : <any>null;
            this.totalProductPrice = _data["totalProductPrice"] !== undefined ? _data["totalProductPrice"] : <any>null;
            this.terms = _data["terms"] !== undefined ? _data["terms"] : <any>null;
            this.totalWeeklyAmount = _data["totalWeeklyAmount"] !== undefined ? _data["totalWeeklyAmount"] : <any>null;
            if (Array.isArray(_data["categories"])) {
                this.categories = [] as any;
                for (let item of _data["categories"])
                    this.categories!.push(CategoryDto.fromJS(item));
            }
            else {
                this.categories = <any>null;
            }
            if (Array.isArray(_data["categoriesVisibleInDigitalMenu"])) {
                this.categoriesVisibleInDigitalMenu = [] as any;
                for (let item of _data["categoriesVisibleInDigitalMenu"])
                    this.categoriesVisibleInDigitalMenu!.push(CategoryDto.fromJS(item));
            }
            else {
                this.categoriesVisibleInDigitalMenu = <any>null;
            }
            this.selectedCategory = _data["selectedCategory"] ? CategoryDto.fromJS(_data["selectedCategory"]) : <any>null;
            this.active = _data["active"] !== undefined ? _data["active"] : <any>null;
            this.isManualSelectionOnly = _data["isManualSelectionOnly"] !== undefined ? _data["isManualSelectionOnly"] : <any>null;
            this.extraOperationCostFee = _data["extraOperationCostFee"] !== undefined ? _data["extraOperationCostFee"] : <any>null;
            this.shortId = _data["shortId"] !== undefined ? _data["shortId"] : <any>null;
        }
    }

    static fromJS(data: any): MenuDto {
        data = typeof data === 'object' ? data : {};
        let result = new MenuDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["menuNo"] = this.menuNo !== undefined ? this.menuNo : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["isClassic"] = this.isClassic !== undefined ? this.isClassic : <any>null;
        data["variableAmount"] = this.variableAmount !== undefined ? this.variableAmount : <any>null;
        data["canModifyTerm"] = this.canModifyTerm !== undefined ? this.canModifyTerm : <any>null;
        data["operationCost"] = this.operationCost !== undefined ? this.operationCost : <any>null;
        data["totalProductPriceWithTaxes"] = this.totalProductPriceWithTaxes !== undefined ? this.totalProductPriceWithTaxes : <any>null;
        data["totalProductCost"] = this.totalProductCost !== undefined ? this.totalProductCost : <any>null;
        data["totalProductPrice"] = this.totalProductPrice !== undefined ? this.totalProductPrice : <any>null;
        data["terms"] = this.terms !== undefined ? this.terms : <any>null;
        data["totalWeeklyAmount"] = this.totalWeeklyAmount !== undefined ? this.totalWeeklyAmount : <any>null;
        if (Array.isArray(this.categories)) {
            data["categories"] = [];
            for (let item of this.categories)
                data["categories"].push(item.toJSON());
        }
        if (Array.isArray(this.categoriesVisibleInDigitalMenu)) {
            data["categoriesVisibleInDigitalMenu"] = [];
            for (let item of this.categoriesVisibleInDigitalMenu)
                data["categoriesVisibleInDigitalMenu"].push(item.toJSON());
        }
        data["selectedCategory"] = this.selectedCategory ? this.selectedCategory.toJSON() : <any>null;
        data["active"] = this.active !== undefined ? this.active : <any>null;
        data["isManualSelectionOnly"] = this.isManualSelectionOnly !== undefined ? this.isManualSelectionOnly : <any>null;
        data["extraOperationCostFee"] = this.extraOperationCostFee !== undefined ? this.extraOperationCostFee : <any>null;
        data["shortId"] = this.shortId !== undefined ? this.shortId : <any>null;
        return data;
    }
}

export interface IMenuDto {
    id?: string | null;
    menuNo?: number;
    name?: string | null;
    isClassic?: boolean | null;
    variableAmount?: number | null;
    canModifyTerm?: boolean;
    operationCost?: number | null;
    totalProductPriceWithTaxes?: number;
    totalProductCost?: number;
    totalProductPrice?: number;
    terms?: number | null;
    totalWeeklyAmount?: number;
    categories?: CategoryDto[] | null;
    categoriesVisibleInDigitalMenu?: CategoryDto[] | null;
    selectedCategory?: CategoryDto | null;
    active?: boolean;
    isManualSelectionOnly?: boolean;
    extraOperationCostFee?: number;
    shortId?: string | null;
}

export class CreateMenuCommand implements ICreateMenuCommand {
    menu?: MenuDto | null;

    constructor(data?: ICreateMenuCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.menu = _data["menu"] ? MenuDto.fromJS(_data["menu"]) : <any>null;
        }
    }

    static fromJS(data: any): CreateMenuCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateMenuCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["menu"] = this.menu ? this.menu.toJSON() : <any>null;
        return data;
    }
}

export interface ICreateMenuCommand {
    menu?: MenuDto | null;
}

export class EditMenuCommand implements IEditMenuCommand {
    menu?: MenuDto | null;

    constructor(data?: IEditMenuCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.menu = _data["menu"] ? MenuDto.fromJS(_data["menu"]) : <any>null;
        }
    }

    static fromJS(data: any): EditMenuCommand {
        data = typeof data === 'object' ? data : {};
        let result = new EditMenuCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["menu"] = this.menu ? this.menu.toJSON() : <any>null;
        return data;
    }
}

export interface IEditMenuCommand {
    menu?: MenuDto | null;
}

export class ToggleActiveStatusCommand implements IToggleActiveStatusCommand {
    id?: string | null;

    constructor(data?: IToggleActiveStatusCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
        }
    }

    static fromJS(data: any): ToggleActiveStatusCommand {
        data = typeof data === 'object' ? data : {};
        let result = new ToggleActiveStatusCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        return data;
    }
}

export interface IToggleActiveStatusCommand {
    id?: string | null;
}

export class NotificationContacts extends EntityOfInteger implements INotificationContacts {
    key?: string | null;
    recipientEmails?: string[] | null;
    recipientPhoneNumbers?: string[] | null;
    notificationEmployeeContacts?: NotificationEmployeeContact[] | null;
    notificationType?: NotificationContactType;

    constructor(data?: INotificationContacts) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.key = _data["key"] !== undefined ? _data["key"] : <any>null;
            if (Array.isArray(_data["recipientEmails"])) {
                this.recipientEmails = [] as any;
                for (let item of _data["recipientEmails"])
                    this.recipientEmails!.push(item);
            }
            else {
                this.recipientEmails = <any>null;
            }
            if (Array.isArray(_data["recipientPhoneNumbers"])) {
                this.recipientPhoneNumbers = [] as any;
                for (let item of _data["recipientPhoneNumbers"])
                    this.recipientPhoneNumbers!.push(item);
            }
            else {
                this.recipientPhoneNumbers = <any>null;
            }
            if (Array.isArray(_data["notificationEmployeeContacts"])) {
                this.notificationEmployeeContacts = [] as any;
                for (let item of _data["notificationEmployeeContacts"])
                    this.notificationEmployeeContacts!.push(NotificationEmployeeContact.fromJS(item));
            }
            else {
                this.notificationEmployeeContacts = <any>null;
            }
            this.notificationType = _data["notificationType"] !== undefined ? _data["notificationType"] : <any>null;
        }
    }

    static override fromJS(data: any): NotificationContacts {
        data = typeof data === 'object' ? data : {};
        let result = new NotificationContacts();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key !== undefined ? this.key : <any>null;
        if (Array.isArray(this.recipientEmails)) {
            data["recipientEmails"] = [];
            for (let item of this.recipientEmails)
                data["recipientEmails"].push(item);
        }
        if (Array.isArray(this.recipientPhoneNumbers)) {
            data["recipientPhoneNumbers"] = [];
            for (let item of this.recipientPhoneNumbers)
                data["recipientPhoneNumbers"].push(item);
        }
        if (Array.isArray(this.notificationEmployeeContacts)) {
            data["notificationEmployeeContacts"] = [];
            for (let item of this.notificationEmployeeContacts)
                data["notificationEmployeeContacts"].push(item.toJSON());
        }
        data["notificationType"] = this.notificationType !== undefined ? this.notificationType : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface INotificationContacts extends IEntityOfInteger {
    key?: string | null;
    recipientEmails?: string[] | null;
    recipientPhoneNumbers?: string[] | null;
    notificationEmployeeContacts?: NotificationEmployeeContact[] | null;
    notificationType?: NotificationContactType;
}

export class NotificationEmployeeContact extends EntityOfInteger implements INotificationEmployeeContact {
    notificationContactsId?: number;
    notificationContacts?: NotificationContacts | null;
    employeeId?: string | null;
    employee?: Employee | null;

    constructor(data?: INotificationEmployeeContact) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.notificationContactsId = _data["notificationContactsId"] !== undefined ? _data["notificationContactsId"] : <any>null;
            this.notificationContacts = _data["notificationContacts"] ? NotificationContacts.fromJS(_data["notificationContacts"]) : <any>null;
            this.employeeId = _data["employeeId"] !== undefined ? _data["employeeId"] : <any>null;
            this.employee = _data["employee"] ? Employee.fromJS(_data["employee"]) : <any>null;
        }
    }

    static override fromJS(data: any): NotificationEmployeeContact {
        data = typeof data === 'object' ? data : {};
        let result = new NotificationEmployeeContact();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["notificationContactsId"] = this.notificationContactsId !== undefined ? this.notificationContactsId : <any>null;
        data["notificationContacts"] = this.notificationContacts ? this.notificationContacts.toJSON() : <any>null;
        data["employeeId"] = this.employeeId !== undefined ? this.employeeId : <any>null;
        data["employee"] = this.employee ? this.employee.toJSON() : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface INotificationEmployeeContact extends IEntityOfInteger {
    notificationContactsId?: number;
    notificationContacts?: NotificationContacts | null;
    employeeId?: string | null;
    employee?: Employee | null;
}

export enum NotificationContactType {
    Email = "email",
    Sms = "sms",
    SmsAny = "smsAny",
}

export class AddEmployeeInNotificationConfigurationCommand implements IAddEmployeeInNotificationConfigurationCommand {
    key?: string | null;
    employeeId?: string | null;

    constructor(data?: IAddEmployeeInNotificationConfigurationCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.key = _data["key"] !== undefined ? _data["key"] : <any>null;
            this.employeeId = _data["employeeId"] !== undefined ? _data["employeeId"] : <any>null;
        }
    }

    static fromJS(data: any): AddEmployeeInNotificationConfigurationCommand {
        data = typeof data === 'object' ? data : {};
        let result = new AddEmployeeInNotificationConfigurationCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key !== undefined ? this.key : <any>null;
        data["employeeId"] = this.employeeId !== undefined ? this.employeeId : <any>null;
        return data;
    }
}

export interface IAddEmployeeInNotificationConfigurationCommand {
    key?: string | null;
    employeeId?: string | null;
}

export class AddPhoneNumberInNotificationConfigurationCommand implements IAddPhoneNumberInNotificationConfigurationCommand {
    key?: string | null;
    phoneNumbers?: string[] | null;

    constructor(data?: IAddPhoneNumberInNotificationConfigurationCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.key = _data["key"] !== undefined ? _data["key"] : <any>null;
            if (Array.isArray(_data["phoneNumbers"])) {
                this.phoneNumbers = [] as any;
                for (let item of _data["phoneNumbers"])
                    this.phoneNumbers!.push(item);
            }
            else {
                this.phoneNumbers = <any>null;
            }
        }
    }

    static fromJS(data: any): AddPhoneNumberInNotificationConfigurationCommand {
        data = typeof data === 'object' ? data : {};
        let result = new AddPhoneNumberInNotificationConfigurationCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key !== undefined ? this.key : <any>null;
        if (Array.isArray(this.phoneNumbers)) {
            data["phoneNumbers"] = [];
            for (let item of this.phoneNumbers)
                data["phoneNumbers"].push(item);
        }
        return data;
    }
}

export interface IAddPhoneNumberInNotificationConfigurationCommand {
    key?: string | null;
    phoneNumbers?: string[] | null;
}

export class DeleteEmailFromNotificationConfigurationCommand implements IDeleteEmailFromNotificationConfigurationCommand {
    notificationContactId?: number;
    email?: string | null;

    constructor(data?: IDeleteEmailFromNotificationConfigurationCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.notificationContactId = _data["notificationContactId"] !== undefined ? _data["notificationContactId"] : <any>null;
            this.email = _data["email"] !== undefined ? _data["email"] : <any>null;
        }
    }

    static fromJS(data: any): DeleteEmailFromNotificationConfigurationCommand {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteEmailFromNotificationConfigurationCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["notificationContactId"] = this.notificationContactId !== undefined ? this.notificationContactId : <any>null;
        data["email"] = this.email !== undefined ? this.email : <any>null;
        return data;
    }
}

export interface IDeleteEmailFromNotificationConfigurationCommand {
    notificationContactId?: number;
    email?: string | null;
}

export class DeletePhoneNumberFromNotificationConfigurationCommand implements IDeletePhoneNumberFromNotificationConfigurationCommand {
    key?: string | null;
    phoneNumber?: string | null;

    constructor(data?: IDeletePhoneNumberFromNotificationConfigurationCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.key = _data["key"] !== undefined ? _data["key"] : <any>null;
            this.phoneNumber = _data["phoneNumber"] !== undefined ? _data["phoneNumber"] : <any>null;
        }
    }

    static fromJS(data: any): DeletePhoneNumberFromNotificationConfigurationCommand {
        data = typeof data === 'object' ? data : {};
        let result = new DeletePhoneNumberFromNotificationConfigurationCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key !== undefined ? this.key : <any>null;
        data["phoneNumber"] = this.phoneNumber !== undefined ? this.phoneNumber : <any>null;
        return data;
    }
}

export interface IDeletePhoneNumberFromNotificationConfigurationCommand {
    key?: string | null;
    phoneNumber?: string | null;
}

export class OptimoConfigDto implements IOptimoConfigDto {
    id?: number;
    baseDeliveryTime?: number;
    viande?: number;
    vDivers?: number;
    surgele?: number;
    epicerie?: number;
    viandeBox?: number;
    vDiversBox?: number;
    surgeleBox?: number;
    epicerieBox?: number;
    newDeliveryType?: number;
    renewDeliveryType?: number;
    patchDeliveryType?: number;

    constructor(data?: IOptimoConfigDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.baseDeliveryTime = _data["baseDeliveryTime"] !== undefined ? _data["baseDeliveryTime"] : <any>null;
            this.viande = _data["viande"] !== undefined ? _data["viande"] : <any>null;
            this.vDivers = _data["vDivers"] !== undefined ? _data["vDivers"] : <any>null;
            this.surgele = _data["surgele"] !== undefined ? _data["surgele"] : <any>null;
            this.epicerie = _data["epicerie"] !== undefined ? _data["epicerie"] : <any>null;
            this.viandeBox = _data["viandeBox"] !== undefined ? _data["viandeBox"] : <any>null;
            this.vDiversBox = _data["vDiversBox"] !== undefined ? _data["vDiversBox"] : <any>null;
            this.surgeleBox = _data["surgeleBox"] !== undefined ? _data["surgeleBox"] : <any>null;
            this.epicerieBox = _data["epicerieBox"] !== undefined ? _data["epicerieBox"] : <any>null;
            this.newDeliveryType = _data["newDeliveryType"] !== undefined ? _data["newDeliveryType"] : <any>null;
            this.renewDeliveryType = _data["renewDeliveryType"] !== undefined ? _data["renewDeliveryType"] : <any>null;
            this.patchDeliveryType = _data["patchDeliveryType"] !== undefined ? _data["patchDeliveryType"] : <any>null;
        }
    }

    static fromJS(data: any): OptimoConfigDto {
        data = typeof data === 'object' ? data : {};
        let result = new OptimoConfigDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["baseDeliveryTime"] = this.baseDeliveryTime !== undefined ? this.baseDeliveryTime : <any>null;
        data["viande"] = this.viande !== undefined ? this.viande : <any>null;
        data["vDivers"] = this.vDivers !== undefined ? this.vDivers : <any>null;
        data["surgele"] = this.surgele !== undefined ? this.surgele : <any>null;
        data["epicerie"] = this.epicerie !== undefined ? this.epicerie : <any>null;
        data["viandeBox"] = this.viandeBox !== undefined ? this.viandeBox : <any>null;
        data["vDiversBox"] = this.vDiversBox !== undefined ? this.vDiversBox : <any>null;
        data["surgeleBox"] = this.surgeleBox !== undefined ? this.surgeleBox : <any>null;
        data["epicerieBox"] = this.epicerieBox !== undefined ? this.epicerieBox : <any>null;
        data["newDeliveryType"] = this.newDeliveryType !== undefined ? this.newDeliveryType : <any>null;
        data["renewDeliveryType"] = this.renewDeliveryType !== undefined ? this.renewDeliveryType : <any>null;
        data["patchDeliveryType"] = this.patchDeliveryType !== undefined ? this.patchDeliveryType : <any>null;
        return data;
    }
}

export interface IOptimoConfigDto {
    id?: number;
    baseDeliveryTime?: number;
    viande?: number;
    vDivers?: number;
    surgele?: number;
    epicerie?: number;
    viandeBox?: number;
    vDiversBox?: number;
    surgeleBox?: number;
    epicerieBox?: number;
    newDeliveryType?: number;
    renewDeliveryType?: number;
    patchDeliveryType?: number;
}

export class UpdateOptimoConfigCommand implements IUpdateOptimoConfigCommand {
    optimoConfig?: OptimoConfigDto | null;

    constructor(data?: IUpdateOptimoConfigCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.optimoConfig = _data["optimoConfig"] ? OptimoConfigDto.fromJS(_data["optimoConfig"]) : <any>null;
        }
    }

    static fromJS(data: any): UpdateOptimoConfigCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateOptimoConfigCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["optimoConfig"] = this.optimoConfig ? this.optimoConfig.toJSON() : <any>null;
        return data;
    }
}

export interface IUpdateOptimoConfigCommand {
    optimoConfig?: OptimoConfigDto | null;
}

export class ZoneDto implements IZoneDto {
    id?: number;
    name?: string | null;

    constructor(data?: IZoneDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
        }
    }

    static fromJS(data: any): ZoneDto {
        data = typeof data === 'object' ? data : {};
        let result = new ZoneDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        return data;
    }
}

export interface IZoneDto {
    id?: number;
    name?: string | null;
}

export class ProductGroupDto implements IProductGroupDto {
    id?: string | null;
    name?: string | null;
    nameEn?: string | null;
    description?: string | null;
    descriptionEn?: string | null;
    image?: string | null;
    preselectedProducts?: PreselectedProductDto[] | null;
    shortPackageIdentifier?: string;

    constructor(data?: IProductGroupDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.nameEn = _data["nameEn"] !== undefined ? _data["nameEn"] : <any>null;
            this.description = _data["description"] !== undefined ? _data["description"] : <any>null;
            this.descriptionEn = _data["descriptionEn"] !== undefined ? _data["descriptionEn"] : <any>null;
            this.image = _data["image"] !== undefined ? _data["image"] : <any>null;
            if (Array.isArray(_data["preselectedProducts"])) {
                this.preselectedProducts = [] as any;
                for (let item of _data["preselectedProducts"])
                    this.preselectedProducts!.push(PreselectedProductDto.fromJS(item));
            }
            else {
                this.preselectedProducts = <any>null;
            }
            this.shortPackageIdentifier = _data["shortPackageIdentifier"] !== undefined ? _data["shortPackageIdentifier"] : <any>null;
        }
    }

    static fromJS(data: any): ProductGroupDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProductGroupDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["nameEn"] = this.nameEn !== undefined ? this.nameEn : <any>null;
        data["description"] = this.description !== undefined ? this.description : <any>null;
        data["descriptionEn"] = this.descriptionEn !== undefined ? this.descriptionEn : <any>null;
        data["image"] = this.image !== undefined ? this.image : <any>null;
        if (Array.isArray(this.preselectedProducts)) {
            data["preselectedProducts"] = [];
            for (let item of this.preselectedProducts)
                data["preselectedProducts"].push(item.toJSON());
        }
        data["shortPackageIdentifier"] = this.shortPackageIdentifier !== undefined ? this.shortPackageIdentifier : <any>null;
        return data;
    }
}

export interface IProductGroupDto {
    id?: string | null;
    name?: string | null;
    nameEn?: string | null;
    description?: string | null;
    descriptionEn?: string | null;
    image?: string | null;
    preselectedProducts?: PreselectedProductDto[] | null;
    shortPackageIdentifier?: string;
}

export class PreselectedProductDto implements IPreselectedProductDto {
    id?: string | null;
    product?: NestedProductDto | null;
    quantity?: number;

    constructor(data?: IPreselectedProductDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.product = _data["product"] ? NestedProductDto.fromJS(_data["product"]) : <any>null;
            this.quantity = _data["quantity"] !== undefined ? _data["quantity"] : <any>null;
        }
    }

    static fromJS(data: any): PreselectedProductDto {
        data = typeof data === 'object' ? data : {};
        let result = new PreselectedProductDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["product"] = this.product ? this.product.toJSON() : <any>null;
        data["quantity"] = this.quantity !== undefined ? this.quantity : <any>null;
        return data;
    }
}

export interface IPreselectedProductDto {
    id?: string | null;
    product?: NestedProductDto | null;
    quantity?: number;
}

export class NestedProductDto implements INestedProductDto {
    id?: string | null;
    productNo?: string | null;
    name?: string | null;
    unitSalePrice?: number;
    tps?: boolean;
    tvq?: boolean;

    constructor(data?: INestedProductDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.productNo = _data["productNo"] !== undefined ? _data["productNo"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.unitSalePrice = _data["unitSalePrice"] !== undefined ? _data["unitSalePrice"] : <any>null;
            this.tps = _data["tps"] !== undefined ? _data["tps"] : <any>null;
            this.tvq = _data["tvq"] !== undefined ? _data["tvq"] : <any>null;
        }
    }

    static fromJS(data: any): NestedProductDto {
        data = typeof data === 'object' ? data : {};
        let result = new NestedProductDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["productNo"] = this.productNo !== undefined ? this.productNo : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["unitSalePrice"] = this.unitSalePrice !== undefined ? this.unitSalePrice : <any>null;
        data["tps"] = this.tps !== undefined ? this.tps : <any>null;
        data["tvq"] = this.tvq !== undefined ? this.tvq : <any>null;
        return data;
    }
}

export interface INestedProductDto {
    id?: string | null;
    productNo?: string | null;
    name?: string | null;
    unitSalePrice?: number;
    tps?: boolean;
    tvq?: boolean;
}

export class PaginatedResultOfProductGroupsLookupViewModel extends PaginatedResult implements IPaginatedResultOfProductGroupsLookupViewModel {
    entities?: ProductGroupsLookupViewModel[] | null;

    constructor(data?: IPaginatedResultOfProductGroupsLookupViewModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["entities"])) {
                this.entities = [] as any;
                for (let item of _data["entities"])
                    this.entities!.push(ProductGroupsLookupViewModel.fromJS(item));
            }
            else {
                this.entities = <any>null;
            }
        }
    }

    static override fromJS(data: any): PaginatedResultOfProductGroupsLookupViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResultOfProductGroupsLookupViewModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.entities)) {
            data["entities"] = [];
            for (let item of this.entities)
                data["entities"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IPaginatedResultOfProductGroupsLookupViewModel extends IPaginatedResult {
    entities?: ProductGroupsLookupViewModel[] | null;
}

export class ProductGroupsLookupViewModel implements IProductGroupsLookupViewModel {
    index?: number;
    id?: string | null;
    name?: string | null;
    shortPackageIdentifier?: string;

    constructor(data?: IProductGroupsLookupViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.index = _data["index"] !== undefined ? _data["index"] : <any>null;
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.shortPackageIdentifier = _data["shortPackageIdentifier"] !== undefined ? _data["shortPackageIdentifier"] : <any>null;
        }
    }

    static fromJS(data: any): ProductGroupsLookupViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ProductGroupsLookupViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["index"] = this.index !== undefined ? this.index : <any>null;
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["shortPackageIdentifier"] = this.shortPackageIdentifier !== undefined ? this.shortPackageIdentifier : <any>null;
        return data;
    }
}

export interface IProductGroupsLookupViewModel {
    index?: number;
    id?: string | null;
    name?: string | null;
    shortPackageIdentifier?: string;
}

export class GetProductGroupsListQuery extends PaginationModel implements IGetProductGroupsListQuery {
    user?: ClaimsPrincipal | null;
    isActive?: boolean;
    isDeactivated?: boolean;

    constructor(data?: IGetProductGroupsListQuery) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.user = _data["user"] ? ClaimsPrincipal.fromJS(_data["user"]) : <any>null;
            this.isActive = _data["isActive"] !== undefined ? _data["isActive"] : <any>null;
            this.isDeactivated = _data["isDeactivated"] !== undefined ? _data["isDeactivated"] : <any>null;
        }
    }

    static override fromJS(data: any): GetProductGroupsListQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetProductGroupsListQuery();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["user"] = this.user ? this.user.toJSON() : <any>null;
        data["isActive"] = this.isActive !== undefined ? this.isActive : <any>null;
        data["isDeactivated"] = this.isDeactivated !== undefined ? this.isDeactivated : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IGetProductGroupsListQuery extends IPaginationModel {
    user?: ClaimsPrincipal | null;
    isActive?: boolean;
    isDeactivated?: boolean;
}

export class BaseProductGroupCommand implements IBaseProductGroupCommand {
    productGroup?: ProductGroupDto | null;

    constructor(data?: IBaseProductGroupCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.productGroup = _data["productGroup"] ? ProductGroupDto.fromJS(_data["productGroup"]) : <any>null;
        }
    }

    static fromJS(data: any): BaseProductGroupCommand {
        data = typeof data === 'object' ? data : {};
        let result = new BaseProductGroupCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productGroup"] = this.productGroup ? this.productGroup.toJSON() : <any>null;
        return data;
    }
}

export interface IBaseProductGroupCommand {
    productGroup?: ProductGroupDto | null;
}

export class EditProductGroupCommand extends BaseProductGroupCommand implements IEditProductGroupCommand {

    constructor(data?: IEditProductGroupCommand) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): EditProductGroupCommand {
        data = typeof data === 'object' ? data : {};
        let result = new EditProductGroupCommand();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IEditProductGroupCommand extends IBaseProductGroupCommand {
}

export class CreateProductGroupCommand extends BaseProductGroupCommand implements ICreateProductGroupCommand {

    constructor(data?: ICreateProductGroupCommand) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): CreateProductGroupCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateProductGroupCommand();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface ICreateProductGroupCommand extends IBaseProductGroupCommand {
}

export class GetProductsListQuery extends PaginationModel implements IGetProductsListQuery {
    user?: ClaimsPrincipal | null;
    isActive?: boolean;
    isDeactivated?: boolean;

    constructor(data?: IGetProductsListQuery) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.user = _data["user"] ? ClaimsPrincipal.fromJS(_data["user"]) : <any>null;
            this.isActive = _data["isActive"] !== undefined ? _data["isActive"] : <any>null;
            this.isDeactivated = _data["isDeactivated"] !== undefined ? _data["isDeactivated"] : <any>null;
        }
    }

    static override fromJS(data: any): GetProductsListQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetProductsListQuery();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["user"] = this.user ? this.user.toJSON() : <any>null;
        data["isActive"] = this.isActive !== undefined ? this.isActive : <any>null;
        data["isDeactivated"] = this.isDeactivated !== undefined ? this.isDeactivated : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IGetProductsListQuery extends IPaginationModel {
    user?: ClaimsPrincipal | null;
    isActive?: boolean;
    isDeactivated?: boolean;
}

export class BaseProductCommand implements IBaseProductCommand {
    product?: ProductDto | null;

    constructor(data?: IBaseProductCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.product = _data["product"] ? ProductDto.fromJS(_data["product"]) : <any>null;
        }
    }

    static fromJS(data: any): BaseProductCommand {
        data = typeof data === 'object' ? data : {};
        let result = new BaseProductCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["product"] = this.product ? this.product.toJSON() : <any>null;
        return data;
    }
}

export interface IBaseProductCommand {
    product?: ProductDto | null;
}

export class CreateProductCommand extends BaseProductCommand implements ICreateProductCommand {

    constructor(data?: ICreateProductCommand) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): CreateProductCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateProductCommand();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface ICreateProductCommand extends IBaseProductCommand {
}

export class EditProductCommand extends BaseProductCommand implements IEditProductCommand {
    turnOffTransaction?: boolean;

    constructor(data?: IEditProductCommand) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.turnOffTransaction = _data["turnOffTransaction"] !== undefined ? _data["turnOffTransaction"] : <any>null;
        }
    }

    static override fromJS(data: any): EditProductCommand {
        data = typeof data === 'object' ? data : {};
        let result = new EditProductCommand();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["turnOffTransaction"] = this.turnOffTransaction !== undefined ? this.turnOffTransaction : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IEditProductCommand extends IBaseProductCommand {
    turnOffTransaction?: boolean;
}

export class ActivateProductAndAddToMenuCommand implements IActivateProductAndAddToMenuCommand {
    productId?: string | null;
    updateCrmProduct?: boolean;

    constructor(data?: IActivateProductAndAddToMenuCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.productId = _data["productId"] !== undefined ? _data["productId"] : <any>null;
            this.updateCrmProduct = _data["updateCrmProduct"] !== undefined ? _data["updateCrmProduct"] : <any>null;
        }
    }

    static fromJS(data: any): ActivateProductAndAddToMenuCommand {
        data = typeof data === 'object' ? data : {};
        let result = new ActivateProductAndAddToMenuCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productId"] = this.productId !== undefined ? this.productId : <any>null;
        data["updateCrmProduct"] = this.updateCrmProduct !== undefined ? this.updateCrmProduct : <any>null;
        return data;
    }
}

export interface IActivateProductAndAddToMenuCommand {
    productId?: string | null;
    updateCrmProduct?: boolean;
}

export class DeactivateProductAndRemoveFromMenusCommand implements IDeactivateProductAndRemoveFromMenusCommand {
    productId?: string | null;
    hasExplanation?: boolean;
    explanation?: string | null;
    hasProductSuggestion?: boolean;
    suggestedProductId?: string | null;
    deactivatedBy?: string | null;
    deactivateProduct?: boolean;
    updateCrmProduct?: boolean;

    constructor(data?: IDeactivateProductAndRemoveFromMenusCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.productId = _data["productId"] !== undefined ? _data["productId"] : <any>null;
            this.hasExplanation = _data["hasExplanation"] !== undefined ? _data["hasExplanation"] : <any>null;
            this.explanation = _data["explanation"] !== undefined ? _data["explanation"] : <any>null;
            this.hasProductSuggestion = _data["hasProductSuggestion"] !== undefined ? _data["hasProductSuggestion"] : <any>null;
            this.suggestedProductId = _data["suggestedProductId"] !== undefined ? _data["suggestedProductId"] : <any>null;
            this.deactivatedBy = _data["deactivatedBy"] !== undefined ? _data["deactivatedBy"] : <any>null;
            this.deactivateProduct = _data["deactivateProduct"] !== undefined ? _data["deactivateProduct"] : <any>null;
            this.updateCrmProduct = _data["updateCrmProduct"] !== undefined ? _data["updateCrmProduct"] : <any>null;
        }
    }

    static fromJS(data: any): DeactivateProductAndRemoveFromMenusCommand {
        data = typeof data === 'object' ? data : {};
        let result = new DeactivateProductAndRemoveFromMenusCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productId"] = this.productId !== undefined ? this.productId : <any>null;
        data["hasExplanation"] = this.hasExplanation !== undefined ? this.hasExplanation : <any>null;
        data["explanation"] = this.explanation !== undefined ? this.explanation : <any>null;
        data["hasProductSuggestion"] = this.hasProductSuggestion !== undefined ? this.hasProductSuggestion : <any>null;
        data["suggestedProductId"] = this.suggestedProductId !== undefined ? this.suggestedProductId : <any>null;
        data["deactivatedBy"] = this.deactivatedBy !== undefined ? this.deactivatedBy : <any>null;
        data["deactivateProduct"] = this.deactivateProduct !== undefined ? this.deactivateProduct : <any>null;
        data["updateCrmProduct"] = this.updateCrmProduct !== undefined ? this.updateCrmProduct : <any>null;
        return data;
    }
}

export interface IDeactivateProductAndRemoveFromMenusCommand {
    productId?: string | null;
    hasExplanation?: boolean;
    explanation?: string | null;
    hasProductSuggestion?: boolean;
    suggestedProductId?: string | null;
    deactivatedBy?: string | null;
    deactivateProduct?: boolean;
    updateCrmProduct?: boolean;
}

export class ProductReorderDto implements IProductReorderDto {
    productNo?: string | null;
    productNameEn?: string | null;
    productNameFr?: string | null;
    productReorderMenuPlacements?: ProductReorderMenuPlacementDto[] | null;

    constructor(data?: IProductReorderDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.productNo = _data["productNo"] !== undefined ? _data["productNo"] : <any>null;
            this.productNameEn = _data["productNameEn"] !== undefined ? _data["productNameEn"] : <any>null;
            this.productNameFr = _data["productNameFr"] !== undefined ? _data["productNameFr"] : <any>null;
            if (Array.isArray(_data["productReorderMenuPlacements"])) {
                this.productReorderMenuPlacements = [] as any;
                for (let item of _data["productReorderMenuPlacements"])
                    this.productReorderMenuPlacements!.push(ProductReorderMenuPlacementDto.fromJS(item));
            }
            else {
                this.productReorderMenuPlacements = <any>null;
            }
        }
    }

    static fromJS(data: any): ProductReorderDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProductReorderDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productNo"] = this.productNo !== undefined ? this.productNo : <any>null;
        data["productNameEn"] = this.productNameEn !== undefined ? this.productNameEn : <any>null;
        data["productNameFr"] = this.productNameFr !== undefined ? this.productNameFr : <any>null;
        if (Array.isArray(this.productReorderMenuPlacements)) {
            data["productReorderMenuPlacements"] = [];
            for (let item of this.productReorderMenuPlacements)
                data["productReorderMenuPlacements"].push(item.toJSON());
        }
        return data;
    }
}

export interface IProductReorderDto {
    productNo?: string | null;
    productNameEn?: string | null;
    productNameFr?: string | null;
    productReorderMenuPlacements?: ProductReorderMenuPlacementDto[] | null;
}

export class ProductReorderMenuPlacementDto implements IProductReorderMenuPlacementDto {
    categoryProductId?: string | null;
    menuCategoryId?: string | null;
    categoryId?: string | null;
    categoryName?: string | null;
    menuId?: string | null;
    menuName?: string | null;
    productOrderIndex?: number;

    constructor(data?: IProductReorderMenuPlacementDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.categoryProductId = _data["categoryProductId"] !== undefined ? _data["categoryProductId"] : <any>null;
            this.menuCategoryId = _data["menuCategoryId"] !== undefined ? _data["menuCategoryId"] : <any>null;
            this.categoryId = _data["categoryId"] !== undefined ? _data["categoryId"] : <any>null;
            this.categoryName = _data["categoryName"] !== undefined ? _data["categoryName"] : <any>null;
            this.menuId = _data["menuId"] !== undefined ? _data["menuId"] : <any>null;
            this.menuName = _data["menuName"] !== undefined ? _data["menuName"] : <any>null;
            this.productOrderIndex = _data["productOrderIndex"] !== undefined ? _data["productOrderIndex"] : <any>null;
        }
    }

    static fromJS(data: any): ProductReorderMenuPlacementDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProductReorderMenuPlacementDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["categoryProductId"] = this.categoryProductId !== undefined ? this.categoryProductId : <any>null;
        data["menuCategoryId"] = this.menuCategoryId !== undefined ? this.menuCategoryId : <any>null;
        data["categoryId"] = this.categoryId !== undefined ? this.categoryId : <any>null;
        data["categoryName"] = this.categoryName !== undefined ? this.categoryName : <any>null;
        data["menuId"] = this.menuId !== undefined ? this.menuId : <any>null;
        data["menuName"] = this.menuName !== undefined ? this.menuName : <any>null;
        data["productOrderIndex"] = this.productOrderIndex !== undefined ? this.productOrderIndex : <any>null;
        return data;
    }
}

export interface IProductReorderMenuPlacementDto {
    categoryProductId?: string | null;
    menuCategoryId?: string | null;
    categoryId?: string | null;
    categoryName?: string | null;
    menuId?: string | null;
    menuName?: string | null;
    productOrderIndex?: number;
}

export class GetProductReorderingListQuery implements IGetProductReorderingListQuery {
    productId?: string | null;

    constructor(data?: IGetProductReorderingListQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.productId = _data["productId"] !== undefined ? _data["productId"] : <any>null;
        }
    }

    static fromJS(data: any): GetProductReorderingListQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetProductReorderingListQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productId"] = this.productId !== undefined ? this.productId : <any>null;
        return data;
    }
}

export interface IGetProductReorderingListQuery {
    productId?: string | null;
}

export class ReorderProductsCommand implements IReorderProductsCommand {
    productReorderMenuPlacements?: ProductReorderMenuPlacementDto[] | null;

    constructor(data?: IReorderProductsCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["productReorderMenuPlacements"])) {
                this.productReorderMenuPlacements = [] as any;
                for (let item of _data["productReorderMenuPlacements"])
                    this.productReorderMenuPlacements!.push(ProductReorderMenuPlacementDto.fromJS(item));
            }
            else {
                this.productReorderMenuPlacements = <any>null;
            }
        }
    }

    static fromJS(data: any): ReorderProductsCommand {
        data = typeof data === 'object' ? data : {};
        let result = new ReorderProductsCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.productReorderMenuPlacements)) {
            data["productReorderMenuPlacements"] = [];
            for (let item of this.productReorderMenuPlacements)
                data["productReorderMenuPlacements"].push(item.toJSON());
        }
        return data;
    }
}

export interface IReorderProductsCommand {
    productReorderMenuPlacements?: ProductReorderMenuPlacementDto[] | null;
}

export class PaginatedResultOfReferralCatalogLookupViewModel extends PaginatedResult implements IPaginatedResultOfReferralCatalogLookupViewModel {
    entities?: ReferralCatalogLookupViewModel[] | null;

    constructor(data?: IPaginatedResultOfReferralCatalogLookupViewModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["entities"])) {
                this.entities = [] as any;
                for (let item of _data["entities"])
                    this.entities!.push(ReferralCatalogLookupViewModel.fromJS(item));
            }
            else {
                this.entities = <any>null;
            }
        }
    }

    static override fromJS(data: any): PaginatedResultOfReferralCatalogLookupViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResultOfReferralCatalogLookupViewModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.entities)) {
            data["entities"] = [];
            for (let item of this.entities)
                data["entities"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IPaginatedResultOfReferralCatalogLookupViewModel extends IPaginatedResult {
    entities?: ReferralCatalogLookupViewModel[] | null;
}

export class ReferralCatalogLookupViewModel implements IReferralCatalogLookupViewModel {
    index?: number;
    id?: string | null;
    name?: string | null;
    isActive?: boolean;

    constructor(data?: IReferralCatalogLookupViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.index = _data["index"] !== undefined ? _data["index"] : <any>null;
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.isActive = _data["isActive"] !== undefined ? _data["isActive"] : <any>null;
        }
    }

    static fromJS(data: any): ReferralCatalogLookupViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ReferralCatalogLookupViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["index"] = this.index !== undefined ? this.index : <any>null;
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["isActive"] = this.isActive !== undefined ? this.isActive : <any>null;
        return data;
    }
}

export interface IReferralCatalogLookupViewModel {
    index?: number;
    id?: string | null;
    name?: string | null;
    isActive?: boolean;
}

export class GetReferralCatalogListQuery extends PaginationModel implements IGetReferralCatalogListQuery {
    user?: ClaimsPrincipal | null;

    constructor(data?: IGetReferralCatalogListQuery) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.user = _data["user"] ? ClaimsPrincipal.fromJS(_data["user"]) : <any>null;
        }
    }

    static override fromJS(data: any): GetReferralCatalogListQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetReferralCatalogListQuery();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["user"] = this.user ? this.user.toJSON() : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IGetReferralCatalogListQuery extends IPaginationModel {
    user?: ClaimsPrincipal | null;
}

export class ReferralCatalogDto implements IReferralCatalogDto {
    id?: string | null;
    name?: string | null;
    isActive?: boolean;
    referralProductGroups?: ReferralProductGroupDto[] | null;
    rawByte64?: string | null;
    rules?: string | null;

    constructor(data?: IReferralCatalogDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.isActive = _data["isActive"] !== undefined ? _data["isActive"] : <any>null;
            if (Array.isArray(_data["referralProductGroups"])) {
                this.referralProductGroups = [] as any;
                for (let item of _data["referralProductGroups"])
                    this.referralProductGroups!.push(ReferralProductGroupDto.fromJS(item));
            }
            else {
                this.referralProductGroups = <any>null;
            }
            this.rawByte64 = _data["rawByte64"] !== undefined ? _data["rawByte64"] : <any>null;
            this.rules = _data["rules"] !== undefined ? _data["rules"] : <any>null;
        }
    }

    static fromJS(data: any): ReferralCatalogDto {
        data = typeof data === 'object' ? data : {};
        let result = new ReferralCatalogDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["isActive"] = this.isActive !== undefined ? this.isActive : <any>null;
        if (Array.isArray(this.referralProductGroups)) {
            data["referralProductGroups"] = [];
            for (let item of this.referralProductGroups)
                data["referralProductGroups"].push(item.toJSON());
        }
        data["rawByte64"] = this.rawByte64 !== undefined ? this.rawByte64 : <any>null;
        data["rules"] = this.rules !== undefined ? this.rules : <any>null;
        return data;
    }
}

export interface IReferralCatalogDto {
    id?: string | null;
    name?: string | null;
    isActive?: boolean;
    referralProductGroups?: ReferralProductGroupDto[] | null;
    rawByte64?: string | null;
    rules?: string | null;
}

export class ReferralProductGroupDto implements IReferralProductGroupDto {
    id?: string | null;
    minimumReferencesRequired?: number;
    maximumReferencesRequired?: number;
    productSelectionGroup?: ProductSelectionGroupDto[] | null;

    constructor(data?: IReferralProductGroupDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.minimumReferencesRequired = _data["minimumReferencesRequired"] !== undefined ? _data["minimumReferencesRequired"] : <any>null;
            this.maximumReferencesRequired = _data["maximumReferencesRequired"] !== undefined ? _data["maximumReferencesRequired"] : <any>null;
            if (Array.isArray(_data["productSelectionGroup"])) {
                this.productSelectionGroup = [] as any;
                for (let item of _data["productSelectionGroup"])
                    this.productSelectionGroup!.push(ProductSelectionGroupDto.fromJS(item));
            }
            else {
                this.productSelectionGroup = <any>null;
            }
        }
    }

    static fromJS(data: any): ReferralProductGroupDto {
        data = typeof data === 'object' ? data : {};
        let result = new ReferralProductGroupDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["minimumReferencesRequired"] = this.minimumReferencesRequired !== undefined ? this.minimumReferencesRequired : <any>null;
        data["maximumReferencesRequired"] = this.maximumReferencesRequired !== undefined ? this.maximumReferencesRequired : <any>null;
        if (Array.isArray(this.productSelectionGroup)) {
            data["productSelectionGroup"] = [];
            for (let item of this.productSelectionGroup)
                data["productSelectionGroup"].push(item.toJSON());
        }
        return data;
    }
}

export interface IReferralProductGroupDto {
    id?: string | null;
    minimumReferencesRequired?: number;
    maximumReferencesRequired?: number;
    productSelectionGroup?: ProductSelectionGroupDto[] | null;
}

export class ProductSelectionGroupDto implements IProductSelectionGroupDto {
    id?: string | null;
    productGroups?: ProductGroupDto[] | null;

    constructor(data?: IProductSelectionGroupDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            if (Array.isArray(_data["productGroups"])) {
                this.productGroups = [] as any;
                for (let item of _data["productGroups"])
                    this.productGroups!.push(ProductGroupDto.fromJS(item));
            }
            else {
                this.productGroups = <any>null;
            }
        }
    }

    static fromJS(data: any): ProductSelectionGroupDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProductSelectionGroupDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        if (Array.isArray(this.productGroups)) {
            data["productGroups"] = [];
            for (let item of this.productGroups)
                data["productGroups"].push(item.toJSON());
        }
        return data;
    }
}

export interface IProductSelectionGroupDto {
    id?: string | null;
    productGroups?: ProductGroupDto[] | null;
}

export class EditReferralCatalogCommand implements IEditReferralCatalogCommand {
    referralCatalog?: ReferralCatalogDto | null;

    constructor(data?: IEditReferralCatalogCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.referralCatalog = _data["referralCatalog"] ? ReferralCatalogDto.fromJS(_data["referralCatalog"]) : <any>null;
        }
    }

    static fromJS(data: any): EditReferralCatalogCommand {
        data = typeof data === 'object' ? data : {};
        let result = new EditReferralCatalogCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["referralCatalog"] = this.referralCatalog ? this.referralCatalog.toJSON() : <any>null;
        return data;
    }
}

export interface IEditReferralCatalogCommand {
    referralCatalog?: ReferralCatalogDto | null;
}

export class CreateReferralCatalogCommand implements ICreateReferralCatalogCommand {
    referralCatalog?: ReferralCatalogDto | null;

    constructor(data?: ICreateReferralCatalogCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.referralCatalog = _data["referralCatalog"] ? ReferralCatalogDto.fromJS(_data["referralCatalog"]) : <any>null;
        }
    }

    static fromJS(data: any): CreateReferralCatalogCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateReferralCatalogCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["referralCatalog"] = this.referralCatalog ? this.referralCatalog.toJSON() : <any>null;
        return data;
    }
}

export interface ICreateReferralCatalogCommand {
    referralCatalog?: ReferralCatalogDto | null;
}

export class SelectListItem implements ISelectListItem {
    disabled?: boolean;
    group?: SelectListGroup | null;
    selected?: boolean;
    text?: string | null;
    value?: string | null;

    constructor(data?: ISelectListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.disabled = _data["disabled"] !== undefined ? _data["disabled"] : <any>null;
            this.group = _data["group"] ? SelectListGroup.fromJS(_data["group"]) : <any>null;
            this.selected = _data["selected"] !== undefined ? _data["selected"] : <any>null;
            this.text = _data["text"] !== undefined ? _data["text"] : <any>null;
            this.value = _data["value"] !== undefined ? _data["value"] : <any>null;
        }
    }

    static fromJS(data: any): SelectListItem {
        data = typeof data === 'object' ? data : {};
        let result = new SelectListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["disabled"] = this.disabled !== undefined ? this.disabled : <any>null;
        data["group"] = this.group ? this.group.toJSON() : <any>null;
        data["selected"] = this.selected !== undefined ? this.selected : <any>null;
        data["text"] = this.text !== undefined ? this.text : <any>null;
        data["value"] = this.value !== undefined ? this.value : <any>null;
        return data;
    }
}

export interface ISelectListItem {
    disabled?: boolean;
    group?: SelectListGroup | null;
    selected?: boolean;
    text?: string | null;
    value?: string | null;
}

export class SelectListGroup implements ISelectListGroup {
    disabled?: boolean;
    name?: string | null;

    constructor(data?: ISelectListGroup) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.disabled = _data["disabled"] !== undefined ? _data["disabled"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
        }
    }

    static fromJS(data: any): SelectListGroup {
        data = typeof data === 'object' ? data : {};
        let result = new SelectListGroup();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["disabled"] = this.disabled !== undefined ? this.disabled : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        return data;
    }
}

export interface ISelectListGroup {
    disabled?: boolean;
    name?: string | null;
}

export class RolePoliciesMapping implements IRolePoliciesMapping {
    roleName?: string | null;
    policies?: string[] | null;

    constructor(data?: IRolePoliciesMapping) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.roleName = _data["roleName"] !== undefined ? _data["roleName"] : <any>null;
            if (Array.isArray(_data["policies"])) {
                this.policies = [] as any;
                for (let item of _data["policies"])
                    this.policies!.push(item);
            }
            else {
                this.policies = <any>null;
            }
        }
    }

    static fromJS(data: any): RolePoliciesMapping {
        data = typeof data === 'object' ? data : {};
        let result = new RolePoliciesMapping();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["roleName"] = this.roleName !== undefined ? this.roleName : <any>null;
        if (Array.isArray(this.policies)) {
            data["policies"] = [];
            for (let item of this.policies)
                data["policies"].push(item);
        }
        return data;
    }
}

export interface IRolePoliciesMapping {
    roleName?: string | null;
    policies?: string[] | null;
}

export class SalesRepAppointmentDto extends AppointmentManagementDto implements ISalesRepAppointmentDto {
    orderNo?: number;
    orderDate?: moment.Moment;
    coupon?: number;
    duration?: number | null;
    pastAppointments?: NestedAppointmentDetailsDto[] | null;
    lastOrder?: SalesRepOrderDetailsDto | null;

    constructor(data?: ISalesRepAppointmentDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.orderNo = _data["orderNo"] !== undefined ? _data["orderNo"] : <any>null;
            this.orderDate = _data["orderDate"] ? moment(_data["orderDate"].toString()) : <any>null;
            this.coupon = _data["coupon"] !== undefined ? _data["coupon"] : <any>null;
            this.duration = _data["duration"] !== undefined ? _data["duration"] : <any>null;
            if (Array.isArray(_data["pastAppointments"])) {
                this.pastAppointments = [] as any;
                for (let item of _data["pastAppointments"])
                    this.pastAppointments!.push(NestedAppointmentDetailsDto.fromJS(item));
            }
            else {
                this.pastAppointments = <any>null;
            }
            this.lastOrder = _data["lastOrder"] ? SalesRepOrderDetailsDto.fromJS(_data["lastOrder"]) : <any>null;
        }
    }

    static override fromJS(data: any): SalesRepAppointmentDto {
        data = typeof data === 'object' ? data : {};
        let result = new SalesRepAppointmentDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["orderNo"] = this.orderNo !== undefined ? this.orderNo : <any>null;
        data["orderDate"] = this.orderDate ? this.orderDate.toISOString() : <any>null;
        data["coupon"] = this.coupon !== undefined ? this.coupon : <any>null;
        data["duration"] = this.duration !== undefined ? this.duration : <any>null;
        if (Array.isArray(this.pastAppointments)) {
            data["pastAppointments"] = [];
            for (let item of this.pastAppointments)
                data["pastAppointments"].push(item.toJSON());
        }
        data["lastOrder"] = this.lastOrder ? this.lastOrder.toJSON() : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface ISalesRepAppointmentDto extends IAppointmentManagementDto {
    orderNo?: number;
    orderDate?: moment.Moment;
    coupon?: number;
    duration?: number | null;
    pastAppointments?: NestedAppointmentDetailsDto[] | null;
    lastOrder?: SalesRepOrderDetailsDto | null;
}

export class NestedAppointmentDetailsDto implements INestedAppointmentDetailsDto {
    orderNo?: number | null;
    appointmentDate?: moment.Moment;
    appointmentRep?: SalesRepDto | null;

    constructor(data?: INestedAppointmentDetailsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.orderNo = _data["orderNo"] !== undefined ? _data["orderNo"] : <any>null;
            this.appointmentDate = _data["appointmentDate"] ? moment(_data["appointmentDate"].toString()) : <any>null;
            this.appointmentRep = _data["appointmentRep"] ? SalesRepDto.fromJS(_data["appointmentRep"]) : <any>null;
        }
    }

    static fromJS(data: any): NestedAppointmentDetailsDto {
        data = typeof data === 'object' ? data : {};
        let result = new NestedAppointmentDetailsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["orderNo"] = this.orderNo !== undefined ? this.orderNo : <any>null;
        data["appointmentDate"] = this.appointmentDate ? this.appointmentDate.toISOString() : <any>null;
        data["appointmentRep"] = this.appointmentRep ? this.appointmentRep.toJSON() : <any>null;
        return data;
    }
}

export interface INestedAppointmentDetailsDto {
    orderNo?: number | null;
    appointmentDate?: moment.Moment;
    appointmentRep?: SalesRepDto | null;
}

export class SalesRepOrderDetailsDto implements ISalesRepOrderDetailsDto {
    clientNo?: number;
    orderNo?: number;
    orderItems?: SalesRepOrderItemDetailsDto[] | null;

    constructor(data?: ISalesRepOrderDetailsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.clientNo = _data["clientNo"] !== undefined ? _data["clientNo"] : <any>null;
            this.orderNo = _data["orderNo"] !== undefined ? _data["orderNo"] : <any>null;
            if (Array.isArray(_data["orderItems"])) {
                this.orderItems = [] as any;
                for (let item of _data["orderItems"])
                    this.orderItems!.push(SalesRepOrderItemDetailsDto.fromJS(item));
            }
            else {
                this.orderItems = <any>null;
            }
        }
    }

    static fromJS(data: any): SalesRepOrderDetailsDto {
        data = typeof data === 'object' ? data : {};
        let result = new SalesRepOrderDetailsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clientNo"] = this.clientNo !== undefined ? this.clientNo : <any>null;
        data["orderNo"] = this.orderNo !== undefined ? this.orderNo : <any>null;
        if (Array.isArray(this.orderItems)) {
            data["orderItems"] = [];
            for (let item of this.orderItems)
                data["orderItems"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISalesRepOrderDetailsDto {
    clientNo?: number;
    orderNo?: number;
    orderItems?: SalesRepOrderItemDetailsDto[] | null;
}

export class SalesRepOrderItemDetailsDto implements ISalesRepOrderItemDetailsDto {
    productNo?: string | null;
    descEn?: string | null;
    descFr?: string | null;
    format?: string | null;
    quantityTotal?: number;

    constructor(data?: ISalesRepOrderItemDetailsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.productNo = _data["productNo"] !== undefined ? _data["productNo"] : <any>null;
            this.descEn = _data["descEn"] !== undefined ? _data["descEn"] : <any>null;
            this.descFr = _data["descFr"] !== undefined ? _data["descFr"] : <any>null;
            this.format = _data["format"] !== undefined ? _data["format"] : <any>null;
            this.quantityTotal = _data["quantityTotal"] !== undefined ? _data["quantityTotal"] : <any>null;
        }
    }

    static fromJS(data: any): SalesRepOrderItemDetailsDto {
        data = typeof data === 'object' ? data : {};
        let result = new SalesRepOrderItemDetailsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productNo"] = this.productNo !== undefined ? this.productNo : <any>null;
        data["descEn"] = this.descEn !== undefined ? this.descEn : <any>null;
        data["descFr"] = this.descFr !== undefined ? this.descFr : <any>null;
        data["format"] = this.format !== undefined ? this.format : <any>null;
        data["quantityTotal"] = this.quantityTotal !== undefined ? this.quantityTotal : <any>null;
        return data;
    }
}

export interface ISalesRepOrderItemDetailsDto {
    productNo?: string | null;
    descEn?: string | null;
    descFr?: string | null;
    format?: string | null;
    quantityTotal?: number;
}

export class GetUsersAssignedAppointmentListQuery extends BaseAppointmentListQuery implements IGetUsersAssignedAppointmentListQuery {

    constructor(data?: IGetUsersAssignedAppointmentListQuery) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): GetUsersAssignedAppointmentListQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetUsersAssignedAppointmentListQuery();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IGetUsersAssignedAppointmentListQuery extends IBaseAppointmentListQuery {
}

export class SalesRepDashboardDto implements ISalesRepDashboardDto {
    salesRepPerformances?: SalesRepPerformanceDto[] | null;
    currentUserSalesRepPerformance?: SalesRepPerformanceDto | null;
    topSalesRepByRevenue?: TopSalesRepRankDto[] | null;
    topSalesRepByConversionPercent?: TopSalesRepRankDto[] | null;
    topSalesRepByAverageOrderAmount?: TopSalesRepRankDto[] | null;

    constructor(data?: ISalesRepDashboardDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["salesRepPerformances"])) {
                this.salesRepPerformances = [] as any;
                for (let item of _data["salesRepPerformances"])
                    this.salesRepPerformances!.push(SalesRepPerformanceDto.fromJS(item));
            }
            else {
                this.salesRepPerformances = <any>null;
            }
            this.currentUserSalesRepPerformance = _data["currentUserSalesRepPerformance"] ? SalesRepPerformanceDto.fromJS(_data["currentUserSalesRepPerformance"]) : <any>null;
            if (Array.isArray(_data["topSalesRepByRevenue"])) {
                this.topSalesRepByRevenue = [] as any;
                for (let item of _data["topSalesRepByRevenue"])
                    this.topSalesRepByRevenue!.push(TopSalesRepRankDto.fromJS(item));
            }
            else {
                this.topSalesRepByRevenue = <any>null;
            }
            if (Array.isArray(_data["topSalesRepByConversionPercent"])) {
                this.topSalesRepByConversionPercent = [] as any;
                for (let item of _data["topSalesRepByConversionPercent"])
                    this.topSalesRepByConversionPercent!.push(TopSalesRepRankDto.fromJS(item));
            }
            else {
                this.topSalesRepByConversionPercent = <any>null;
            }
            if (Array.isArray(_data["topSalesRepByAverageOrderAmount"])) {
                this.topSalesRepByAverageOrderAmount = [] as any;
                for (let item of _data["topSalesRepByAverageOrderAmount"])
                    this.topSalesRepByAverageOrderAmount!.push(TopSalesRepRankDto.fromJS(item));
            }
            else {
                this.topSalesRepByAverageOrderAmount = <any>null;
            }
        }
    }

    static fromJS(data: any): SalesRepDashboardDto {
        data = typeof data === 'object' ? data : {};
        let result = new SalesRepDashboardDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.salesRepPerformances)) {
            data["salesRepPerformances"] = [];
            for (let item of this.salesRepPerformances)
                data["salesRepPerformances"].push(item.toJSON());
        }
        data["currentUserSalesRepPerformance"] = this.currentUserSalesRepPerformance ? this.currentUserSalesRepPerformance.toJSON() : <any>null;
        if (Array.isArray(this.topSalesRepByRevenue)) {
            data["topSalesRepByRevenue"] = [];
            for (let item of this.topSalesRepByRevenue)
                data["topSalesRepByRevenue"].push(item.toJSON());
        }
        if (Array.isArray(this.topSalesRepByConversionPercent)) {
            data["topSalesRepByConversionPercent"] = [];
            for (let item of this.topSalesRepByConversionPercent)
                data["topSalesRepByConversionPercent"].push(item.toJSON());
        }
        if (Array.isArray(this.topSalesRepByAverageOrderAmount)) {
            data["topSalesRepByAverageOrderAmount"] = [];
            for (let item of this.topSalesRepByAverageOrderAmount)
                data["topSalesRepByAverageOrderAmount"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISalesRepDashboardDto {
    salesRepPerformances?: SalesRepPerformanceDto[] | null;
    currentUserSalesRepPerformance?: SalesRepPerformanceDto | null;
    topSalesRepByRevenue?: TopSalesRepRankDto[] | null;
    topSalesRepByConversionPercent?: TopSalesRepRankDto[] | null;
    topSalesRepByAverageOrderAmount?: TopSalesRepRankDto[] | null;
}

export class SalesRepPerformanceDto implements ISalesRepPerformanceDto {
    repName?: string | null;
    currentPeriod?: SalesRepPerformancePeriodMetricsDto | null;
    previousPeriod?: SalesRepPerformancePeriodMetricsDto | null;
    revenueRanking?: number;
    conversionRanking?: number;
    averageOrderAmountRanking?: number;
    salesWithTwentyPlusRefsRanking?: number;
    yearOfYearRevenue?: number;
    yearOfYearTotalSales?: number;
    yearOfYearTwentyPlusReferences?: number;
    averageConversionPercent?: number;
    employeeId?: string | null;

    constructor(data?: ISalesRepPerformanceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.repName = _data["repName"] !== undefined ? _data["repName"] : <any>null;
            this.currentPeriod = _data["currentPeriod"] ? SalesRepPerformancePeriodMetricsDto.fromJS(_data["currentPeriod"]) : <any>null;
            this.previousPeriod = _data["previousPeriod"] ? SalesRepPerformancePeriodMetricsDto.fromJS(_data["previousPeriod"]) : <any>null;
            this.revenueRanking = _data["revenueRanking"] !== undefined ? _data["revenueRanking"] : <any>null;
            this.conversionRanking = _data["conversionRanking"] !== undefined ? _data["conversionRanking"] : <any>null;
            this.averageOrderAmountRanking = _data["averageOrderAmountRanking"] !== undefined ? _data["averageOrderAmountRanking"] : <any>null;
            this.salesWithTwentyPlusRefsRanking = _data["salesWithTwentyPlusRefsRanking"] !== undefined ? _data["salesWithTwentyPlusRefsRanking"] : <any>null;
            this.yearOfYearRevenue = _data["yearOfYearRevenue"] !== undefined ? _data["yearOfYearRevenue"] : <any>null;
            this.yearOfYearTotalSales = _data["yearOfYearTotalSales"] !== undefined ? _data["yearOfYearTotalSales"] : <any>null;
            this.yearOfYearTwentyPlusReferences = _data["yearOfYearTwentyPlusReferences"] !== undefined ? _data["yearOfYearTwentyPlusReferences"] : <any>null;
            this.averageConversionPercent = _data["averageConversionPercent"] !== undefined ? _data["averageConversionPercent"] : <any>null;
            this.employeeId = _data["employeeId"] !== undefined ? _data["employeeId"] : <any>null;
        }
    }

    static fromJS(data: any): SalesRepPerformanceDto {
        data = typeof data === 'object' ? data : {};
        let result = new SalesRepPerformanceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["repName"] = this.repName !== undefined ? this.repName : <any>null;
        data["currentPeriod"] = this.currentPeriod ? this.currentPeriod.toJSON() : <any>null;
        data["previousPeriod"] = this.previousPeriod ? this.previousPeriod.toJSON() : <any>null;
        data["revenueRanking"] = this.revenueRanking !== undefined ? this.revenueRanking : <any>null;
        data["conversionRanking"] = this.conversionRanking !== undefined ? this.conversionRanking : <any>null;
        data["averageOrderAmountRanking"] = this.averageOrderAmountRanking !== undefined ? this.averageOrderAmountRanking : <any>null;
        data["salesWithTwentyPlusRefsRanking"] = this.salesWithTwentyPlusRefsRanking !== undefined ? this.salesWithTwentyPlusRefsRanking : <any>null;
        data["yearOfYearRevenue"] = this.yearOfYearRevenue !== undefined ? this.yearOfYearRevenue : <any>null;
        data["yearOfYearTotalSales"] = this.yearOfYearTotalSales !== undefined ? this.yearOfYearTotalSales : <any>null;
        data["yearOfYearTwentyPlusReferences"] = this.yearOfYearTwentyPlusReferences !== undefined ? this.yearOfYearTwentyPlusReferences : <any>null;
        data["averageConversionPercent"] = this.averageConversionPercent !== undefined ? this.averageConversionPercent : <any>null;
        data["employeeId"] = this.employeeId !== undefined ? this.employeeId : <any>null;
        return data;
    }
}

export interface ISalesRepPerformanceDto {
    repName?: string | null;
    currentPeriod?: SalesRepPerformancePeriodMetricsDto | null;
    previousPeriod?: SalesRepPerformancePeriodMetricsDto | null;
    revenueRanking?: number;
    conversionRanking?: number;
    averageOrderAmountRanking?: number;
    salesWithTwentyPlusRefsRanking?: number;
    yearOfYearRevenue?: number;
    yearOfYearTotalSales?: number;
    yearOfYearTwentyPlusReferences?: number;
    averageConversionPercent?: number;
    employeeId?: string | null;
}

export class SalesRepPerformancePeriodMetricsDto implements ISalesRepPerformancePeriodMetricsDto {
    totalItemAmount?: number;
    revenue?: number;
    totalSales?: number;
    conversionPercent?: number;
    averageOrder?: number;
    zeroReferences?: number;
    oneToNineTeenReferences?: number;
    twentyToThirtyNineReferences?: number;
    fortyPlusReferences?: number;
    percentageOfSalesWithTwentyPlusRefs?: number;
    teamsPercentageOfSalesWithTwentyPlusRefs?: number;
    totalMeatAmount?: number;
    totalMeatPercent?: number;
    totalGroceryAmount?: number;
    totalGroceryPercent?: number;
    totalVDiversAmount?: number;
    totalVDiversPercent?: number;

    constructor(data?: ISalesRepPerformancePeriodMetricsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalItemAmount = _data["totalItemAmount"] !== undefined ? _data["totalItemAmount"] : <any>null;
            this.revenue = _data["revenue"] !== undefined ? _data["revenue"] : <any>null;
            this.totalSales = _data["totalSales"] !== undefined ? _data["totalSales"] : <any>null;
            this.conversionPercent = _data["conversionPercent"] !== undefined ? _data["conversionPercent"] : <any>null;
            this.averageOrder = _data["averageOrder"] !== undefined ? _data["averageOrder"] : <any>null;
            this.zeroReferences = _data["zeroReferences"] !== undefined ? _data["zeroReferences"] : <any>null;
            this.oneToNineTeenReferences = _data["oneToNineTeenReferences"] !== undefined ? _data["oneToNineTeenReferences"] : <any>null;
            this.twentyToThirtyNineReferences = _data["twentyToThirtyNineReferences"] !== undefined ? _data["twentyToThirtyNineReferences"] : <any>null;
            this.fortyPlusReferences = _data["fortyPlusReferences"] !== undefined ? _data["fortyPlusReferences"] : <any>null;
            this.percentageOfSalesWithTwentyPlusRefs = _data["percentageOfSalesWithTwentyPlusRefs"] !== undefined ? _data["percentageOfSalesWithTwentyPlusRefs"] : <any>null;
            this.teamsPercentageOfSalesWithTwentyPlusRefs = _data["teamsPercentageOfSalesWithTwentyPlusRefs"] !== undefined ? _data["teamsPercentageOfSalesWithTwentyPlusRefs"] : <any>null;
            this.totalMeatAmount = _data["totalMeatAmount"] !== undefined ? _data["totalMeatAmount"] : <any>null;
            this.totalMeatPercent = _data["totalMeatPercent"] !== undefined ? _data["totalMeatPercent"] : <any>null;
            this.totalGroceryAmount = _data["totalGroceryAmount"] !== undefined ? _data["totalGroceryAmount"] : <any>null;
            this.totalGroceryPercent = _data["totalGroceryPercent"] !== undefined ? _data["totalGroceryPercent"] : <any>null;
            this.totalVDiversAmount = _data["totalVDiversAmount"] !== undefined ? _data["totalVDiversAmount"] : <any>null;
            this.totalVDiversPercent = _data["totalVDiversPercent"] !== undefined ? _data["totalVDiversPercent"] : <any>null;
        }
    }

    static fromJS(data: any): SalesRepPerformancePeriodMetricsDto {
        data = typeof data === 'object' ? data : {};
        let result = new SalesRepPerformancePeriodMetricsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalItemAmount"] = this.totalItemAmount !== undefined ? this.totalItemAmount : <any>null;
        data["revenue"] = this.revenue !== undefined ? this.revenue : <any>null;
        data["totalSales"] = this.totalSales !== undefined ? this.totalSales : <any>null;
        data["conversionPercent"] = this.conversionPercent !== undefined ? this.conversionPercent : <any>null;
        data["averageOrder"] = this.averageOrder !== undefined ? this.averageOrder : <any>null;
        data["zeroReferences"] = this.zeroReferences !== undefined ? this.zeroReferences : <any>null;
        data["oneToNineTeenReferences"] = this.oneToNineTeenReferences !== undefined ? this.oneToNineTeenReferences : <any>null;
        data["twentyToThirtyNineReferences"] = this.twentyToThirtyNineReferences !== undefined ? this.twentyToThirtyNineReferences : <any>null;
        data["fortyPlusReferences"] = this.fortyPlusReferences !== undefined ? this.fortyPlusReferences : <any>null;
        data["percentageOfSalesWithTwentyPlusRefs"] = this.percentageOfSalesWithTwentyPlusRefs !== undefined ? this.percentageOfSalesWithTwentyPlusRefs : <any>null;
        data["teamsPercentageOfSalesWithTwentyPlusRefs"] = this.teamsPercentageOfSalesWithTwentyPlusRefs !== undefined ? this.teamsPercentageOfSalesWithTwentyPlusRefs : <any>null;
        data["totalMeatAmount"] = this.totalMeatAmount !== undefined ? this.totalMeatAmount : <any>null;
        data["totalMeatPercent"] = this.totalMeatPercent !== undefined ? this.totalMeatPercent : <any>null;
        data["totalGroceryAmount"] = this.totalGroceryAmount !== undefined ? this.totalGroceryAmount : <any>null;
        data["totalGroceryPercent"] = this.totalGroceryPercent !== undefined ? this.totalGroceryPercent : <any>null;
        data["totalVDiversAmount"] = this.totalVDiversAmount !== undefined ? this.totalVDiversAmount : <any>null;
        data["totalVDiversPercent"] = this.totalVDiversPercent !== undefined ? this.totalVDiversPercent : <any>null;
        return data;
    }
}

export interface ISalesRepPerformancePeriodMetricsDto {
    totalItemAmount?: number;
    revenue?: number;
    totalSales?: number;
    conversionPercent?: number;
    averageOrder?: number;
    zeroReferences?: number;
    oneToNineTeenReferences?: number;
    twentyToThirtyNineReferences?: number;
    fortyPlusReferences?: number;
    percentageOfSalesWithTwentyPlusRefs?: number;
    teamsPercentageOfSalesWithTwentyPlusRefs?: number;
    totalMeatAmount?: number;
    totalMeatPercent?: number;
    totalGroceryAmount?: number;
    totalGroceryPercent?: number;
    totalVDiversAmount?: number;
    totalVDiversPercent?: number;
}

export class TopSalesRepRankDto implements ITopSalesRepRankDto {
    repName?: string | null;
    currentPeriodMetricValue?: number;
    previousPeriodMetricValue?: number;

    constructor(data?: ITopSalesRepRankDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.repName = _data["repName"] !== undefined ? _data["repName"] : <any>null;
            this.currentPeriodMetricValue = _data["currentPeriodMetricValue"] !== undefined ? _data["currentPeriodMetricValue"] : <any>null;
            this.previousPeriodMetricValue = _data["previousPeriodMetricValue"] !== undefined ? _data["previousPeriodMetricValue"] : <any>null;
        }
    }

    static fromJS(data: any): TopSalesRepRankDto {
        data = typeof data === 'object' ? data : {};
        let result = new TopSalesRepRankDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["repName"] = this.repName !== undefined ? this.repName : <any>null;
        data["currentPeriodMetricValue"] = this.currentPeriodMetricValue !== undefined ? this.currentPeriodMetricValue : <any>null;
        data["previousPeriodMetricValue"] = this.previousPeriodMetricValue !== undefined ? this.previousPeriodMetricValue : <any>null;
        return data;
    }
}

export interface ITopSalesRepRankDto {
    repName?: string | null;
    currentPeriodMetricValue?: number;
    previousPeriodMetricValue?: number;
}

export class GetSalesRepDashboardMetricQuery implements IGetSalesRepDashboardMetricQuery {
    year?: number;
    months?: number[] | null;
    includeRenewalSales?: boolean;
    includeNewSales?: boolean;

    constructor(data?: IGetSalesRepDashboardMetricQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.year = _data["year"] !== undefined ? _data["year"] : <any>null;
            if (Array.isArray(_data["months"])) {
                this.months = [] as any;
                for (let item of _data["months"])
                    this.months!.push(item);
            }
            else {
                this.months = <any>null;
            }
            this.includeRenewalSales = _data["includeRenewalSales"] !== undefined ? _data["includeRenewalSales"] : <any>null;
            this.includeNewSales = _data["includeNewSales"] !== undefined ? _data["includeNewSales"] : <any>null;
        }
    }

    static fromJS(data: any): GetSalesRepDashboardMetricQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetSalesRepDashboardMetricQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["year"] = this.year !== undefined ? this.year : <any>null;
        if (Array.isArray(this.months)) {
            data["months"] = [];
            for (let item of this.months)
                data["months"].push(item);
        }
        data["includeRenewalSales"] = this.includeRenewalSales !== undefined ? this.includeRenewalSales : <any>null;
        data["includeNewSales"] = this.includeNewSales !== undefined ? this.includeNewSales : <any>null;
        return data;
    }
}

export interface IGetSalesRepDashboardMetricQuery {
    year?: number;
    months?: number[] | null;
    includeRenewalSales?: boolean;
    includeNewSales?: boolean;
}

export class RepsSaleDto implements IRepsSaleDto {
    orderNo?: number;
    clientNo?: number;
    amount?: number;
    noReferences?: number;
    totalMeatAmount?: number;
    totalMeatPercent?: number;
    totalGroceryAmount?: number;
    totalGroceryPercent?: number;
    totalVDiversAmount?: number;
    totalVDiversPercent?: number;
    totalItemAmount?: number;

    constructor(data?: IRepsSaleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.orderNo = _data["orderNo"] !== undefined ? _data["orderNo"] : <any>null;
            this.clientNo = _data["clientNo"] !== undefined ? _data["clientNo"] : <any>null;
            this.amount = _data["amount"] !== undefined ? _data["amount"] : <any>null;
            this.noReferences = _data["noReferences"] !== undefined ? _data["noReferences"] : <any>null;
            this.totalMeatAmount = _data["totalMeatAmount"] !== undefined ? _data["totalMeatAmount"] : <any>null;
            this.totalMeatPercent = _data["totalMeatPercent"] !== undefined ? _data["totalMeatPercent"] : <any>null;
            this.totalGroceryAmount = _data["totalGroceryAmount"] !== undefined ? _data["totalGroceryAmount"] : <any>null;
            this.totalGroceryPercent = _data["totalGroceryPercent"] !== undefined ? _data["totalGroceryPercent"] : <any>null;
            this.totalVDiversAmount = _data["totalVDiversAmount"] !== undefined ? _data["totalVDiversAmount"] : <any>null;
            this.totalVDiversPercent = _data["totalVDiversPercent"] !== undefined ? _data["totalVDiversPercent"] : <any>null;
            this.totalItemAmount = _data["totalItemAmount"] !== undefined ? _data["totalItemAmount"] : <any>null;
        }
    }

    static fromJS(data: any): RepsSaleDto {
        data = typeof data === 'object' ? data : {};
        let result = new RepsSaleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["orderNo"] = this.orderNo !== undefined ? this.orderNo : <any>null;
        data["clientNo"] = this.clientNo !== undefined ? this.clientNo : <any>null;
        data["amount"] = this.amount !== undefined ? this.amount : <any>null;
        data["noReferences"] = this.noReferences !== undefined ? this.noReferences : <any>null;
        data["totalMeatAmount"] = this.totalMeatAmount !== undefined ? this.totalMeatAmount : <any>null;
        data["totalMeatPercent"] = this.totalMeatPercent !== undefined ? this.totalMeatPercent : <any>null;
        data["totalGroceryAmount"] = this.totalGroceryAmount !== undefined ? this.totalGroceryAmount : <any>null;
        data["totalGroceryPercent"] = this.totalGroceryPercent !== undefined ? this.totalGroceryPercent : <any>null;
        data["totalVDiversAmount"] = this.totalVDiversAmount !== undefined ? this.totalVDiversAmount : <any>null;
        data["totalVDiversPercent"] = this.totalVDiversPercent !== undefined ? this.totalVDiversPercent : <any>null;
        data["totalItemAmount"] = this.totalItemAmount !== undefined ? this.totalItemAmount : <any>null;
        return data;
    }
}

export interface IRepsSaleDto {
    orderNo?: number;
    clientNo?: number;
    amount?: number;
    noReferences?: number;
    totalMeatAmount?: number;
    totalMeatPercent?: number;
    totalGroceryAmount?: number;
    totalGroceryPercent?: number;
    totalVDiversAmount?: number;
    totalVDiversPercent?: number;
    totalItemAmount?: number;
}

export class GetSalesForRepByMonth implements IGetSalesForRepByMonth {
    year?: number;
    months?: number[] | null;

    constructor(data?: IGetSalesForRepByMonth) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.year = _data["year"] !== undefined ? _data["year"] : <any>null;
            if (Array.isArray(_data["months"])) {
                this.months = [] as any;
                for (let item of _data["months"])
                    this.months!.push(item);
            }
            else {
                this.months = <any>null;
            }
        }
    }

    static fromJS(data: any): GetSalesForRepByMonth {
        data = typeof data === 'object' ? data : {};
        let result = new GetSalesForRepByMonth();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["year"] = this.year !== undefined ? this.year : <any>null;
        if (Array.isArray(this.months)) {
            data["months"] = [];
            for (let item of this.months)
                data["months"].push(item);
        }
        return data;
    }
}

export interface IGetSalesForRepByMonth {
    year?: number;
    months?: number[] | null;
}

export class SalesDirectorDto implements ISalesDirectorDto {
    id?: number;
    name?: string | null;

    constructor(data?: ISalesDirectorDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
        }
    }

    static fromJS(data: any): SalesDirectorDto {
        data = typeof data === 'object' ? data : {};
        let result = new SalesDirectorDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        return data;
    }
}

export interface ISalesDirectorDto {
    id?: number;
    name?: string | null;
}

export class ScheduledJobsDto implements IScheduledJobsDto {
    id?: number;
    name?: string | null;
    enable?: boolean;

    constructor(data?: IScheduledJobsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.enable = _data["enable"] !== undefined ? _data["enable"] : <any>null;
        }
    }

    static fromJS(data: any): ScheduledJobsDto {
        data = typeof data === 'object' ? data : {};
        let result = new ScheduledJobsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["enable"] = this.enable !== undefined ? this.enable : <any>null;
        return data;
    }
}

export interface IScheduledJobsDto {
    id?: number;
    name?: string | null;
    enable?: boolean;
}

export class UpdateScheduledJobCommand implements IUpdateScheduledJobCommand {
    name?: string | null;
    enable?: boolean;

    constructor(data?: IUpdateScheduledJobCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.enable = _data["enable"] !== undefined ? _data["enable"] : <any>null;
        }
    }

    static fromJS(data: any): UpdateScheduledJobCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateScheduledJobCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["enable"] = this.enable !== undefined ? this.enable : <any>null;
        return data;
    }
}

export interface IUpdateScheduledJobCommand {
    name?: string | null;
    enable?: boolean;
}

export class SalesRepScheduleDto implements ISalesRepScheduleDto {
    scheduleNo?: number | null;
    salesRepNo?: number;
    date?: moment.Moment | null;
    h0912?: boolean | null;
    h1215?: boolean | null;
    h1518?: boolean | null;
    h1821?: boolean | null;
    regionNo?: number | null;
    lastModifiedDate?: moment.Moment | null;

    constructor(data?: ISalesRepScheduleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.scheduleNo = _data["scheduleNo"] !== undefined ? _data["scheduleNo"] : <any>null;
            this.salesRepNo = _data["salesRepNo"] !== undefined ? _data["salesRepNo"] : <any>null;
            this.date = _data["date"] ? moment(_data["date"].toString()) : <any>null;
            this.h0912 = _data["h0912"] !== undefined ? _data["h0912"] : <any>null;
            this.h1215 = _data["h1215"] !== undefined ? _data["h1215"] : <any>null;
            this.h1518 = _data["h1518"] !== undefined ? _data["h1518"] : <any>null;
            this.h1821 = _data["h1821"] !== undefined ? _data["h1821"] : <any>null;
            this.regionNo = _data["regionNo"] !== undefined ? _data["regionNo"] : <any>null;
            this.lastModifiedDate = _data["lastModifiedDate"] ? moment(_data["lastModifiedDate"].toString()) : <any>null;
        }
    }

    static fromJS(data: any): SalesRepScheduleDto {
        data = typeof data === 'object' ? data : {};
        let result = new SalesRepScheduleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["scheduleNo"] = this.scheduleNo !== undefined ? this.scheduleNo : <any>null;
        data["salesRepNo"] = this.salesRepNo !== undefined ? this.salesRepNo : <any>null;
        data["date"] = this.date ? this.date.toISOString() : <any>null;
        data["h0912"] = this.h0912 !== undefined ? this.h0912 : <any>null;
        data["h1215"] = this.h1215 !== undefined ? this.h1215 : <any>null;
        data["h1518"] = this.h1518 !== undefined ? this.h1518 : <any>null;
        data["h1821"] = this.h1821 !== undefined ? this.h1821 : <any>null;
        data["regionNo"] = this.regionNo !== undefined ? this.regionNo : <any>null;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : <any>null;
        return data;
    }
}

export interface ISalesRepScheduleDto {
    scheduleNo?: number | null;
    salesRepNo?: number;
    date?: moment.Moment | null;
    h0912?: boolean | null;
    h1215?: boolean | null;
    h1518?: boolean | null;
    h1821?: boolean | null;
    regionNo?: number | null;
    lastModifiedDate?: moment.Moment | null;
}

export class GetSalesRepScheduleQuery implements IGetSalesRepScheduleQuery {
    salesRepNumber?: number;
    startOfWeek?: moment.Moment;

    constructor(data?: IGetSalesRepScheduleQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.salesRepNumber = _data["salesRepNumber"] !== undefined ? _data["salesRepNumber"] : <any>null;
            this.startOfWeek = _data["startOfWeek"] ? moment(_data["startOfWeek"].toString()) : <any>null;
        }
    }

    static fromJS(data: any): GetSalesRepScheduleQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetSalesRepScheduleQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["salesRepNumber"] = this.salesRepNumber !== undefined ? this.salesRepNumber : <any>null;
        data["startOfWeek"] = this.startOfWeek ? this.startOfWeek.toISOString() : <any>null;
        return data;
    }
}

export interface IGetSalesRepScheduleQuery {
    salesRepNumber?: number;
    startOfWeek?: moment.Moment;
}

export class SalesRepLocationDto implements ISalesRepLocationDto {
    regionNo?: number | null;
    region?: string | null;

    constructor(data?: ISalesRepLocationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.regionNo = _data["regionNo"] !== undefined ? _data["regionNo"] : <any>null;
            this.region = _data["region"] !== undefined ? _data["region"] : <any>null;
        }
    }

    static fromJS(data: any): SalesRepLocationDto {
        data = typeof data === 'object' ? data : {};
        let result = new SalesRepLocationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["regionNo"] = this.regionNo !== undefined ? this.regionNo : <any>null;
        data["region"] = this.region !== undefined ? this.region : <any>null;
        return data;
    }
}

export interface ISalesRepLocationDto {
    regionNo?: number | null;
    region?: string | null;
}

export class GetMySalesRepDefaultLocationQuery implements IGetMySalesRepDefaultLocationQuery {
    salesRepNo?: number;

    constructor(data?: IGetMySalesRepDefaultLocationQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.salesRepNo = _data["salesRepNo"] !== undefined ? _data["salesRepNo"] : <any>null;
        }
    }

    static fromJS(data: any): GetMySalesRepDefaultLocationQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetMySalesRepDefaultLocationQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["salesRepNo"] = this.salesRepNo !== undefined ? this.salesRepNo : <any>null;
        return data;
    }
}

export interface IGetMySalesRepDefaultLocationQuery {
    salesRepNo?: number;
}

export class UpdateSalesRepScheduleCommand implements IUpdateSalesRepScheduleCommand {
    schedules?: SalesRepScheduleDto[] | null;

    constructor(data?: IUpdateSalesRepScheduleCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["schedules"])) {
                this.schedules = [] as any;
                for (let item of _data["schedules"])
                    this.schedules!.push(SalesRepScheduleDto.fromJS(item));
            }
            else {
                this.schedules = <any>null;
            }
        }
    }

    static fromJS(data: any): UpdateSalesRepScheduleCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateSalesRepScheduleCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.schedules)) {
            data["schedules"] = [];
            for (let item of this.schedules)
                data["schedules"].push(item.toJSON());
        }
        return data;
    }
}

export interface IUpdateSalesRepScheduleCommand {
    schedules?: SalesRepScheduleDto[] | null;
}

export class GetSalesRepLocationsQuery implements IGetSalesRepLocationsQuery {

    constructor(data?: IGetSalesRepLocationsQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): GetSalesRepLocationsQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetSalesRepLocationsQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IGetSalesRepLocationsQuery {
}

export class SalesRepLocationGroupDto implements ISalesRepLocationGroupDto {
    regionNos?: number[] | null;
    name?: string | null;

    constructor(data?: ISalesRepLocationGroupDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["regionNos"])) {
                this.regionNos = [] as any;
                for (let item of _data["regionNos"])
                    this.regionNos!.push(item);
            }
            else {
                this.regionNos = <any>null;
            }
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
        }
    }

    static fromJS(data: any): SalesRepLocationGroupDto {
        data = typeof data === 'object' ? data : {};
        let result = new SalesRepLocationGroupDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.regionNos)) {
            data["regionNos"] = [];
            for (let item of this.regionNos)
                data["regionNos"].push(item);
        }
        data["name"] = this.name !== undefined ? this.name : <any>null;
        return data;
    }
}

export interface ISalesRepLocationGroupDto {
    regionNos?: number[] | null;
    name?: string | null;
}

export class GetSalesRepLocationGroupsQuery implements IGetSalesRepLocationGroupsQuery {

    constructor(data?: IGetSalesRepLocationGroupsQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): GetSalesRepLocationGroupsQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetSalesRepLocationGroupsQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IGetSalesRepLocationGroupsQuery {
}

export class SalesRepProfileDto implements ISalesRepProfileDto {
    employeeId?: string | null;
    employeeName?: string | null;
    salesRepNumber?: number;

    constructor(data?: ISalesRepProfileDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.employeeId = _data["employeeId"] !== undefined ? _data["employeeId"] : <any>null;
            this.employeeName = _data["employeeName"] !== undefined ? _data["employeeName"] : <any>null;
            this.salesRepNumber = _data["salesRepNumber"] !== undefined ? _data["salesRepNumber"] : <any>null;
        }
    }

    static fromJS(data: any): SalesRepProfileDto {
        data = typeof data === 'object' ? data : {};
        let result = new SalesRepProfileDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["employeeId"] = this.employeeId !== undefined ? this.employeeId : <any>null;
        data["employeeName"] = this.employeeName !== undefined ? this.employeeName : <any>null;
        data["salesRepNumber"] = this.salesRepNumber !== undefined ? this.salesRepNumber : <any>null;
        return data;
    }
}

export interface ISalesRepProfileDto {
    employeeId?: string | null;
    employeeName?: string | null;
    salesRepNumber?: number;
}

export class GetMySalesRepProfileQuery implements IGetMySalesRepProfileQuery {
    userId?: string | null;

    constructor(data?: IGetMySalesRepProfileQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"] !== undefined ? _data["userId"] : <any>null;
        }
    }

    static fromJS(data: any): GetMySalesRepProfileQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetMySalesRepProfileQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId !== undefined ? this.userId : <any>null;
        return data;
    }
}

export interface IGetMySalesRepProfileQuery {
    userId?: string | null;
}

export class GetAllSalesRepProfileQuery implements IGetAllSalesRepProfileQuery {

    constructor(data?: IGetAllSalesRepProfileQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): GetAllSalesRepProfileQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllSalesRepProfileQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IGetAllSalesRepProfileQuery {
}

export class GetSalesRepUnderManagementQuery implements IGetSalesRepUnderManagementQuery {
    managerId?: string | null;
    weekStartDate?: moment.Moment;
    regionGroupName?: string | null;

    constructor(data?: IGetSalesRepUnderManagementQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.managerId = _data["managerId"] !== undefined ? _data["managerId"] : <any>null;
            this.weekStartDate = _data["weekStartDate"] ? moment(_data["weekStartDate"].toString()) : <any>null;
            this.regionGroupName = _data["regionGroupName"] !== undefined ? _data["regionGroupName"] : <any>null;
        }
    }

    static fromJS(data: any): GetSalesRepUnderManagementQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetSalesRepUnderManagementQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["managerId"] = this.managerId !== undefined ? this.managerId : <any>null;
        data["weekStartDate"] = this.weekStartDate ? this.weekStartDate.toISOString() : <any>null;
        data["regionGroupName"] = this.regionGroupName !== undefined ? this.regionGroupName : <any>null;
        return data;
    }
}

export interface IGetSalesRepUnderManagementQuery {
    managerId?: string | null;
    weekStartDate?: moment.Moment;
    regionGroupName?: string | null;
}

export class ScheduledAppointmentDto implements IScheduledAppointmentDto {
    date?: moment.Moment;
    h0912?: boolean;
    h1215?: boolean;
    h1518?: boolean;
    h1821?: boolean;

    constructor(data?: IScheduledAppointmentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.date = _data["date"] ? moment(_data["date"].toString()) : <any>null;
            this.h0912 = _data["h0912"] !== undefined ? _data["h0912"] : <any>null;
            this.h1215 = _data["h1215"] !== undefined ? _data["h1215"] : <any>null;
            this.h1518 = _data["h1518"] !== undefined ? _data["h1518"] : <any>null;
            this.h1821 = _data["h1821"] !== undefined ? _data["h1821"] : <any>null;
        }
    }

    static fromJS(data: any): ScheduledAppointmentDto {
        data = typeof data === 'object' ? data : {};
        let result = new ScheduledAppointmentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["date"] = this.date ? this.date.toISOString() : <any>null;
        data["h0912"] = this.h0912 !== undefined ? this.h0912 : <any>null;
        data["h1215"] = this.h1215 !== undefined ? this.h1215 : <any>null;
        data["h1518"] = this.h1518 !== undefined ? this.h1518 : <any>null;
        data["h1821"] = this.h1821 !== undefined ? this.h1821 : <any>null;
        return data;
    }
}

export interface IScheduledAppointmentDto {
    date?: moment.Moment;
    h0912?: boolean;
    h1215?: boolean;
    h1518?: boolean;
    h1821?: boolean;
}

export class GetScheduledAppointmentsQuery implements IGetScheduledAppointmentsQuery {
    salesRepNumber?: number | null;
    regionNos?: number[] | null;
    startOfWeek?: moment.Moment;
    showAll?: boolean;
    isStandby?: boolean | null;
    isConfirmed?: boolean | null;
    isPostponed?: boolean | null;
    isSold?: boolean | null;
    isCancelled?: boolean | null;
    isDelivered?: boolean | null;
    isCallback?: boolean | null;
    isShownNotSold?: boolean | null;
    isShownToBeFinalized?: boolean | null;
    isNotShown?: boolean | null;
    isRefused?: boolean | null;
    isNew?: boolean | null;
    isRenewal?: boolean | null;
    isWinback?: boolean | null;
    isQualifiedOnly?: boolean | null;
    isVirtual?: boolean | null;
    isPhysical?: boolean | null;

    constructor(data?: IGetScheduledAppointmentsQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.salesRepNumber = _data["salesRepNumber"] !== undefined ? _data["salesRepNumber"] : <any>null;
            if (Array.isArray(_data["regionNos"])) {
                this.regionNos = [] as any;
                for (let item of _data["regionNos"])
                    this.regionNos!.push(item);
            }
            else {
                this.regionNos = <any>null;
            }
            this.startOfWeek = _data["startOfWeek"] ? moment(_data["startOfWeek"].toString()) : <any>null;
            this.showAll = _data["showAll"] !== undefined ? _data["showAll"] : <any>null;
            this.isStandby = _data["isStandby"] !== undefined ? _data["isStandby"] : <any>null;
            this.isConfirmed = _data["isConfirmed"] !== undefined ? _data["isConfirmed"] : <any>null;
            this.isPostponed = _data["isPostponed"] !== undefined ? _data["isPostponed"] : <any>null;
            this.isSold = _data["isSold"] !== undefined ? _data["isSold"] : <any>null;
            this.isCancelled = _data["isCancelled"] !== undefined ? _data["isCancelled"] : <any>null;
            this.isDelivered = _data["isDelivered"] !== undefined ? _data["isDelivered"] : <any>null;
            this.isCallback = _data["isCallback"] !== undefined ? _data["isCallback"] : <any>null;
            this.isShownNotSold = _data["isShownNotSold"] !== undefined ? _data["isShownNotSold"] : <any>null;
            this.isShownToBeFinalized = _data["isShownToBeFinalized"] !== undefined ? _data["isShownToBeFinalized"] : <any>null;
            this.isNotShown = _data["isNotShown"] !== undefined ? _data["isNotShown"] : <any>null;
            this.isRefused = _data["isRefused"] !== undefined ? _data["isRefused"] : <any>null;
            this.isNew = _data["isNew"] !== undefined ? _data["isNew"] : <any>null;
            this.isRenewal = _data["isRenewal"] !== undefined ? _data["isRenewal"] : <any>null;
            this.isWinback = _data["isWinback"] !== undefined ? _data["isWinback"] : <any>null;
            this.isQualifiedOnly = _data["isQualifiedOnly"] !== undefined ? _data["isQualifiedOnly"] : <any>null;
            this.isVirtual = _data["isVirtual"] !== undefined ? _data["isVirtual"] : <any>null;
            this.isPhysical = _data["isPhysical"] !== undefined ? _data["isPhysical"] : <any>null;
        }
    }

    static fromJS(data: any): GetScheduledAppointmentsQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetScheduledAppointmentsQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["salesRepNumber"] = this.salesRepNumber !== undefined ? this.salesRepNumber : <any>null;
        if (Array.isArray(this.regionNos)) {
            data["regionNos"] = [];
            for (let item of this.regionNos)
                data["regionNos"].push(item);
        }
        data["startOfWeek"] = this.startOfWeek ? this.startOfWeek.toISOString() : <any>null;
        data["showAll"] = this.showAll !== undefined ? this.showAll : <any>null;
        data["isStandby"] = this.isStandby !== undefined ? this.isStandby : <any>null;
        data["isConfirmed"] = this.isConfirmed !== undefined ? this.isConfirmed : <any>null;
        data["isPostponed"] = this.isPostponed !== undefined ? this.isPostponed : <any>null;
        data["isSold"] = this.isSold !== undefined ? this.isSold : <any>null;
        data["isCancelled"] = this.isCancelled !== undefined ? this.isCancelled : <any>null;
        data["isDelivered"] = this.isDelivered !== undefined ? this.isDelivered : <any>null;
        data["isCallback"] = this.isCallback !== undefined ? this.isCallback : <any>null;
        data["isShownNotSold"] = this.isShownNotSold !== undefined ? this.isShownNotSold : <any>null;
        data["isShownToBeFinalized"] = this.isShownToBeFinalized !== undefined ? this.isShownToBeFinalized : <any>null;
        data["isNotShown"] = this.isNotShown !== undefined ? this.isNotShown : <any>null;
        data["isRefused"] = this.isRefused !== undefined ? this.isRefused : <any>null;
        data["isNew"] = this.isNew !== undefined ? this.isNew : <any>null;
        data["isRenewal"] = this.isRenewal !== undefined ? this.isRenewal : <any>null;
        data["isWinback"] = this.isWinback !== undefined ? this.isWinback : <any>null;
        data["isQualifiedOnly"] = this.isQualifiedOnly !== undefined ? this.isQualifiedOnly : <any>null;
        data["isVirtual"] = this.isVirtual !== undefined ? this.isVirtual : <any>null;
        data["isPhysical"] = this.isPhysical !== undefined ? this.isPhysical : <any>null;
        return data;
    }
}

export interface IGetScheduledAppointmentsQuery {
    salesRepNumber?: number | null;
    regionNos?: number[] | null;
    startOfWeek?: moment.Moment;
    showAll?: boolean;
    isStandby?: boolean | null;
    isConfirmed?: boolean | null;
    isPostponed?: boolean | null;
    isSold?: boolean | null;
    isCancelled?: boolean | null;
    isDelivered?: boolean | null;
    isCallback?: boolean | null;
    isShownNotSold?: boolean | null;
    isShownToBeFinalized?: boolean | null;
    isNotShown?: boolean | null;
    isRefused?: boolean | null;
    isNew?: boolean | null;
    isRenewal?: boolean | null;
    isWinback?: boolean | null;
    isQualifiedOnly?: boolean | null;
    isVirtual?: boolean | null;
    isPhysical?: boolean | null;
}

export class GetScheduledAppointmentsFromRepsUnderMgmtQuery implements IGetScheduledAppointmentsFromRepsUnderMgmtQuery {
    salesRepNumber?: number | null;
    startOfWeek?: moment.Moment;
    managerId?: string | null;

    constructor(data?: IGetScheduledAppointmentsFromRepsUnderMgmtQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.salesRepNumber = _data["salesRepNumber"] !== undefined ? _data["salesRepNumber"] : <any>null;
            this.startOfWeek = _data["startOfWeek"] ? moment(_data["startOfWeek"].toString()) : <any>null;
            this.managerId = _data["managerId"] !== undefined ? _data["managerId"] : <any>null;
        }
    }

    static fromJS(data: any): GetScheduledAppointmentsFromRepsUnderMgmtQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetScheduledAppointmentsFromRepsUnderMgmtQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["salesRepNumber"] = this.salesRepNumber !== undefined ? this.salesRepNumber : <any>null;
        data["startOfWeek"] = this.startOfWeek ? this.startOfWeek.toISOString() : <any>null;
        data["managerId"] = this.managerId !== undefined ? this.managerId : <any>null;
        return data;
    }
}

export interface IGetScheduledAppointmentsFromRepsUnderMgmtQuery {
    salesRepNumber?: number | null;
    startOfWeek?: moment.Moment;
    managerId?: string | null;
}

export class GetAllSalesRepInRegionByWeekQuery implements IGetAllSalesRepInRegionByWeekQuery {
    weekStartDate?: moment.Moment;
    regionGroupName?: string | null;

    constructor(data?: IGetAllSalesRepInRegionByWeekQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.weekStartDate = _data["weekStartDate"] ? moment(_data["weekStartDate"].toString()) : <any>null;
            this.regionGroupName = _data["regionGroupName"] !== undefined ? _data["regionGroupName"] : <any>null;
        }
    }

    static fromJS(data: any): GetAllSalesRepInRegionByWeekQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllSalesRepInRegionByWeekQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["weekStartDate"] = this.weekStartDate ? this.weekStartDate.toISOString() : <any>null;
        data["regionGroupName"] = this.regionGroupName !== undefined ? this.regionGroupName : <any>null;
        return data;
    }
}

export interface IGetAllSalesRepInRegionByWeekQuery {
    weekStartDate?: moment.Moment;
    regionGroupName?: string | null;
}

export class PaginatedResultOfServiceTicketLookupDto extends PaginatedResult implements IPaginatedResultOfServiceTicketLookupDto {
    entities?: ServiceTicketLookupDto[] | null;

    constructor(data?: IPaginatedResultOfServiceTicketLookupDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["entities"])) {
                this.entities = [] as any;
                for (let item of _data["entities"])
                    this.entities!.push(ServiceTicketLookupDto.fromJS(item));
            }
            else {
                this.entities = <any>null;
            }
        }
    }

    static override fromJS(data: any): PaginatedResultOfServiceTicketLookupDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResultOfServiceTicketLookupDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.entities)) {
            data["entities"] = [];
            for (let item of this.entities)
                data["entities"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IPaginatedResultOfServiceTicketLookupDto extends IPaginatedResult {
    entities?: ServiceTicketLookupDto[] | null;
}

export class ServiceTicketLookupDto implements IServiceTicketLookupDto {
    id?: number;
    subject?: string | null;
    assignedEmployeeName?: string | null;
    createdByEmployeeName?: string | null;
    status?: ServiceTicketStatus;
    priority?: ServiceTicketPriority;
    lastUpdatedDateTime?: moment.Moment | null;
    createdDateTime?: moment.Moment;
    index?: number;
    categoryName?: string | null;
    assignedEmployeeId?: string | null;
    timeEstimate?: number | null;
    deadline?: moment.Moment | null;

    constructor(data?: IServiceTicketLookupDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.subject = _data["subject"] !== undefined ? _data["subject"] : <any>null;
            this.assignedEmployeeName = _data["assignedEmployeeName"] !== undefined ? _data["assignedEmployeeName"] : <any>null;
            this.createdByEmployeeName = _data["createdByEmployeeName"] !== undefined ? _data["createdByEmployeeName"] : <any>null;
            this.status = _data["status"] !== undefined ? _data["status"] : <any>null;
            this.priority = _data["priority"] !== undefined ? _data["priority"] : <any>null;
            this.lastUpdatedDateTime = _data["lastUpdatedDateTime"] ? moment(_data["lastUpdatedDateTime"].toString()) : <any>null;
            this.createdDateTime = _data["createdDateTime"] ? moment(_data["createdDateTime"].toString()) : <any>null;
            this.index = _data["index"] !== undefined ? _data["index"] : <any>null;
            this.categoryName = _data["categoryName"] !== undefined ? _data["categoryName"] : <any>null;
            this.assignedEmployeeId = _data["assignedEmployeeId"] !== undefined ? _data["assignedEmployeeId"] : <any>null;
            this.timeEstimate = _data["timeEstimate"] !== undefined ? _data["timeEstimate"] : <any>null;
            this.deadline = _data["deadline"] ? moment(_data["deadline"].toString()) : <any>null;
        }
    }

    static fromJS(data: any): ServiceTicketLookupDto {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceTicketLookupDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["subject"] = this.subject !== undefined ? this.subject : <any>null;
        data["assignedEmployeeName"] = this.assignedEmployeeName !== undefined ? this.assignedEmployeeName : <any>null;
        data["createdByEmployeeName"] = this.createdByEmployeeName !== undefined ? this.createdByEmployeeName : <any>null;
        data["status"] = this.status !== undefined ? this.status : <any>null;
        data["priority"] = this.priority !== undefined ? this.priority : <any>null;
        data["lastUpdatedDateTime"] = this.lastUpdatedDateTime ? this.lastUpdatedDateTime.toISOString() : <any>null;
        data["createdDateTime"] = this.createdDateTime ? this.createdDateTime.toISOString() : <any>null;
        data["index"] = this.index !== undefined ? this.index : <any>null;
        data["categoryName"] = this.categoryName !== undefined ? this.categoryName : <any>null;
        data["assignedEmployeeId"] = this.assignedEmployeeId !== undefined ? this.assignedEmployeeId : <any>null;
        data["timeEstimate"] = this.timeEstimate !== undefined ? this.timeEstimate : <any>null;
        data["deadline"] = this.deadline ? this.deadline.toISOString() : <any>null;
        return data;
    }
}

export interface IServiceTicketLookupDto {
    id?: number;
    subject?: string | null;
    assignedEmployeeName?: string | null;
    createdByEmployeeName?: string | null;
    status?: ServiceTicketStatus;
    priority?: ServiceTicketPriority;
    lastUpdatedDateTime?: moment.Moment | null;
    createdDateTime?: moment.Moment;
    index?: number;
    categoryName?: string | null;
    assignedEmployeeId?: string | null;
    timeEstimate?: number | null;
    deadline?: moment.Moment | null;
}

export enum ServiceTicketStatus {
    PendingAssignment = "pendingAssignment",
    InProgress = "inProgress",
    Resolved = "resolved",
    Canceled = "canceled",
    Expired = "expired",
    Assigned = "assigned",
    WorkingOn = "workingOn",
    ContactedPartner = "contactedPartner",
    WontFix = "wontFix",
    PendingApproval = "pendingApproval",
}

export enum ServiceTicketPriority {
    Unknown = "unknown",
    Low = "low",
    Medium = "medium",
    High = "high",
    Urgent = "urgent",
    Request = "request",
}

export class GetServiceTicketListQuery extends PaginationModel implements IGetServiceTicketListQuery {
    hasAssignedEmployee?: boolean;
    hasNoAssignedEmployee?: boolean;
    assignedToMe?: boolean;
    isOpen?: boolean;
    employeeAssignedToIds?: string[] | null;

    constructor(data?: IGetServiceTicketListQuery) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.hasAssignedEmployee = _data["hasAssignedEmployee"] !== undefined ? _data["hasAssignedEmployee"] : <any>null;
            this.hasNoAssignedEmployee = _data["hasNoAssignedEmployee"] !== undefined ? _data["hasNoAssignedEmployee"] : <any>null;
            this.assignedToMe = _data["assignedToMe"] !== undefined ? _data["assignedToMe"] : <any>null;
            this.isOpen = _data["isOpen"] !== undefined ? _data["isOpen"] : <any>null;
            if (Array.isArray(_data["employeeAssignedToIds"])) {
                this.employeeAssignedToIds = [] as any;
                for (let item of _data["employeeAssignedToIds"])
                    this.employeeAssignedToIds!.push(item);
            }
            else {
                this.employeeAssignedToIds = <any>null;
            }
        }
    }

    static override fromJS(data: any): GetServiceTicketListQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetServiceTicketListQuery();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["hasAssignedEmployee"] = this.hasAssignedEmployee !== undefined ? this.hasAssignedEmployee : <any>null;
        data["hasNoAssignedEmployee"] = this.hasNoAssignedEmployee !== undefined ? this.hasNoAssignedEmployee : <any>null;
        data["assignedToMe"] = this.assignedToMe !== undefined ? this.assignedToMe : <any>null;
        data["isOpen"] = this.isOpen !== undefined ? this.isOpen : <any>null;
        if (Array.isArray(this.employeeAssignedToIds)) {
            data["employeeAssignedToIds"] = [];
            for (let item of this.employeeAssignedToIds)
                data["employeeAssignedToIds"].push(item);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IGetServiceTicketListQuery extends IPaginationModel {
    hasAssignedEmployee?: boolean;
    hasNoAssignedEmployee?: boolean;
    assignedToMe?: boolean;
    isOpen?: boolean;
    employeeAssignedToIds?: string[] | null;
}

export class GetMyServiceTicketsListQuery extends PaginationModel implements IGetMyServiceTicketsListQuery {
    hasAssignedEmployee?: boolean;
    hasNoAssignedEmployee?: boolean;
    showAllTickets?: boolean;

    constructor(data?: IGetMyServiceTicketsListQuery) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.hasAssignedEmployee = _data["hasAssignedEmployee"] !== undefined ? _data["hasAssignedEmployee"] : <any>null;
            this.hasNoAssignedEmployee = _data["hasNoAssignedEmployee"] !== undefined ? _data["hasNoAssignedEmployee"] : <any>null;
            this.showAllTickets = _data["showAllTickets"] !== undefined ? _data["showAllTickets"] : <any>null;
        }
    }

    static override fromJS(data: any): GetMyServiceTicketsListQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetMyServiceTicketsListQuery();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["hasAssignedEmployee"] = this.hasAssignedEmployee !== undefined ? this.hasAssignedEmployee : <any>null;
        data["hasNoAssignedEmployee"] = this.hasNoAssignedEmployee !== undefined ? this.hasNoAssignedEmployee : <any>null;
        data["showAllTickets"] = this.showAllTickets !== undefined ? this.showAllTickets : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IGetMyServiceTicketsListQuery extends IPaginationModel {
    hasAssignedEmployee?: boolean;
    hasNoAssignedEmployee?: boolean;
    showAllTickets?: boolean;
}

export class CreateServiceTicketCommand implements ICreateServiceTicketCommand {
    subject?: string | null;
    description?: string | null;
    categoryId?: number;
    priority?: ServiceTicketPriority;

    constructor(data?: ICreateServiceTicketCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.subject = _data["subject"] !== undefined ? _data["subject"] : <any>null;
            this.description = _data["description"] !== undefined ? _data["description"] : <any>null;
            this.categoryId = _data["categoryId"] !== undefined ? _data["categoryId"] : <any>null;
            this.priority = _data["priority"] !== undefined ? _data["priority"] : <any>null;
        }
    }

    static fromJS(data: any): CreateServiceTicketCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateServiceTicketCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["subject"] = this.subject !== undefined ? this.subject : <any>null;
        data["description"] = this.description !== undefined ? this.description : <any>null;
        data["categoryId"] = this.categoryId !== undefined ? this.categoryId : <any>null;
        data["priority"] = this.priority !== undefined ? this.priority : <any>null;
        return data;
    }
}

export interface ICreateServiceTicketCommand {
    subject?: string | null;
    description?: string | null;
    categoryId?: number;
    priority?: ServiceTicketPriority;
}

export class EditServiceTicketCommand implements IEditServiceTicketCommand {
    subject?: string | null;
    description?: string | null;
    categoryId?: number | null;
    priority?: ServiceTicketPriority;
    timeEstimate?: number | null;
    deadline?: moment.Moment | null;
    note?: string | null;
    status?: ServiceTicketStatus | null;

    constructor(data?: IEditServiceTicketCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.subject = _data["subject"] !== undefined ? _data["subject"] : <any>null;
            this.description = _data["description"] !== undefined ? _data["description"] : <any>null;
            this.categoryId = _data["categoryId"] !== undefined ? _data["categoryId"] : <any>null;
            this.priority = _data["priority"] !== undefined ? _data["priority"] : <any>null;
            this.timeEstimate = _data["timeEstimate"] !== undefined ? _data["timeEstimate"] : <any>null;
            this.deadline = _data["deadline"] ? moment(_data["deadline"].toString()) : <any>null;
            this.note = _data["note"] !== undefined ? _data["note"] : <any>null;
            this.status = _data["status"] !== undefined ? _data["status"] : <any>null;
        }
    }

    static fromJS(data: any): EditServiceTicketCommand {
        data = typeof data === 'object' ? data : {};
        let result = new EditServiceTicketCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["subject"] = this.subject !== undefined ? this.subject : <any>null;
        data["description"] = this.description !== undefined ? this.description : <any>null;
        data["categoryId"] = this.categoryId !== undefined ? this.categoryId : <any>null;
        data["priority"] = this.priority !== undefined ? this.priority : <any>null;
        data["timeEstimate"] = this.timeEstimate !== undefined ? this.timeEstimate : <any>null;
        data["deadline"] = this.deadline ? this.deadline.toISOString() : <any>null;
        data["note"] = this.note !== undefined ? this.note : <any>null;
        data["status"] = this.status !== undefined ? this.status : <any>null;
        return data;
    }
}

export interface IEditServiceTicketCommand {
    subject?: string | null;
    description?: string | null;
    categoryId?: number | null;
    priority?: ServiceTicketPriority;
    timeEstimate?: number | null;
    deadline?: moment.Moment | null;
    note?: string | null;
    status?: ServiceTicketStatus | null;
}

export class ServiceTicketDto implements IServiceTicketDto {
    id?: number;
    subject?: string | null;
    description?: string | null;
    createdByEmployeeId?: string | null;
    createdByEmployeeName?: string | null;
    timeEstimate?: number | null;
    deadline?: moment.Moment | null;
    lastUpdatedDateTime?: moment.Moment | null;
    status?: ServiceTicketStatus;
    priority?: ServiceTicketPriority;
    attachedFiles?: FileAttachmentDto[] | null;
    assignedEmployeeName?: string | null;
    assignedEmployeeId?: string | null;
    categoryName?: string | null;
    categoryId?: number;

    constructor(data?: IServiceTicketDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.subject = _data["subject"] !== undefined ? _data["subject"] : <any>null;
            this.description = _data["description"] !== undefined ? _data["description"] : <any>null;
            this.createdByEmployeeId = _data["createdByEmployeeId"] !== undefined ? _data["createdByEmployeeId"] : <any>null;
            this.createdByEmployeeName = _data["createdByEmployeeName"] !== undefined ? _data["createdByEmployeeName"] : <any>null;
            this.timeEstimate = _data["timeEstimate"] !== undefined ? _data["timeEstimate"] : <any>null;
            this.deadline = _data["deadline"] ? moment(_data["deadline"].toString()) : <any>null;
            this.lastUpdatedDateTime = _data["lastUpdatedDateTime"] ? moment(_data["lastUpdatedDateTime"].toString()) : <any>null;
            this.status = _data["status"] !== undefined ? _data["status"] : <any>null;
            this.priority = _data["priority"] !== undefined ? _data["priority"] : <any>null;
            if (Array.isArray(_data["attachedFiles"])) {
                this.attachedFiles = [] as any;
                for (let item of _data["attachedFiles"])
                    this.attachedFiles!.push(FileAttachmentDto.fromJS(item));
            }
            else {
                this.attachedFiles = <any>null;
            }
            this.assignedEmployeeName = _data["assignedEmployeeName"] !== undefined ? _data["assignedEmployeeName"] : <any>null;
            this.assignedEmployeeId = _data["assignedEmployeeId"] !== undefined ? _data["assignedEmployeeId"] : <any>null;
            this.categoryName = _data["categoryName"] !== undefined ? _data["categoryName"] : <any>null;
            this.categoryId = _data["categoryId"] !== undefined ? _data["categoryId"] : <any>null;
        }
    }

    static fromJS(data: any): ServiceTicketDto {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceTicketDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["subject"] = this.subject !== undefined ? this.subject : <any>null;
        data["description"] = this.description !== undefined ? this.description : <any>null;
        data["createdByEmployeeId"] = this.createdByEmployeeId !== undefined ? this.createdByEmployeeId : <any>null;
        data["createdByEmployeeName"] = this.createdByEmployeeName !== undefined ? this.createdByEmployeeName : <any>null;
        data["timeEstimate"] = this.timeEstimate !== undefined ? this.timeEstimate : <any>null;
        data["deadline"] = this.deadline ? this.deadline.toISOString() : <any>null;
        data["lastUpdatedDateTime"] = this.lastUpdatedDateTime ? this.lastUpdatedDateTime.toISOString() : <any>null;
        data["status"] = this.status !== undefined ? this.status : <any>null;
        data["priority"] = this.priority !== undefined ? this.priority : <any>null;
        if (Array.isArray(this.attachedFiles)) {
            data["attachedFiles"] = [];
            for (let item of this.attachedFiles)
                data["attachedFiles"].push(item.toJSON());
        }
        data["assignedEmployeeName"] = this.assignedEmployeeName !== undefined ? this.assignedEmployeeName : <any>null;
        data["assignedEmployeeId"] = this.assignedEmployeeId !== undefined ? this.assignedEmployeeId : <any>null;
        data["categoryName"] = this.categoryName !== undefined ? this.categoryName : <any>null;
        data["categoryId"] = this.categoryId !== undefined ? this.categoryId : <any>null;
        return data;
    }
}

export interface IServiceTicketDto {
    id?: number;
    subject?: string | null;
    description?: string | null;
    createdByEmployeeId?: string | null;
    createdByEmployeeName?: string | null;
    timeEstimate?: number | null;
    deadline?: moment.Moment | null;
    lastUpdatedDateTime?: moment.Moment | null;
    status?: ServiceTicketStatus;
    priority?: ServiceTicketPriority;
    attachedFiles?: FileAttachmentDto[] | null;
    assignedEmployeeName?: string | null;
    assignedEmployeeId?: string | null;
    categoryName?: string | null;
    categoryId?: number;
}

export class FileAttachmentDto implements IFileAttachmentDto {
    id?: number;
    fileName?: string | null;

    constructor(data?: IFileAttachmentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.fileName = _data["fileName"] !== undefined ? _data["fileName"] : <any>null;
        }
    }

    static fromJS(data: any): FileAttachmentDto {
        data = typeof data === 'object' ? data : {};
        let result = new FileAttachmentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["fileName"] = this.fileName !== undefined ? this.fileName : <any>null;
        return data;
    }
}

export interface IFileAttachmentDto {
    id?: number;
    fileName?: string | null;
}

export class CreateServiceTicketNoteCommand implements ICreateServiceTicketNoteCommand {
    serviceTicketId?: number;
    description?: string | null;
    noteType?: ServiceTicketNoteType | null;

    constructor(data?: ICreateServiceTicketNoteCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.serviceTicketId = _data["serviceTicketId"] !== undefined ? _data["serviceTicketId"] : <any>null;
            this.description = _data["description"] !== undefined ? _data["description"] : <any>null;
            this.noteType = _data["noteType"] !== undefined ? _data["noteType"] : <any>null;
        }
    }

    static fromJS(data: any): CreateServiceTicketNoteCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateServiceTicketNoteCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["serviceTicketId"] = this.serviceTicketId !== undefined ? this.serviceTicketId : <any>null;
        data["description"] = this.description !== undefined ? this.description : <any>null;
        data["noteType"] = this.noteType !== undefined ? this.noteType : <any>null;
        return data;
    }
}

export interface ICreateServiceTicketNoteCommand {
    serviceTicketId?: number;
    description?: string | null;
    noteType?: ServiceTicketNoteType | null;
}

export enum ServiceTicketNoteType {
    Comment = "comment",
    StatusChange = "statusChange",
    TicketUpdated = "ticketUpdated",
}

export class ServiceTicketNoteDto implements IServiceTicketNoteDto {
    id?: number;
    description?: string | null;
    createdDateTime?: moment.Moment;
    noteType?: ServiceTicketNoteType;
    attachedFiles?: FileAttachmentDto[] | null;
    createdByEmployeeFirstName?: string | null;
    createdByEmployeeLastName?: string | null;

    constructor(data?: IServiceTicketNoteDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.description = _data["description"] !== undefined ? _data["description"] : <any>null;
            this.createdDateTime = _data["createdDateTime"] ? moment(_data["createdDateTime"].toString()) : <any>null;
            this.noteType = _data["noteType"] !== undefined ? _data["noteType"] : <any>null;
            if (Array.isArray(_data["attachedFiles"])) {
                this.attachedFiles = [] as any;
                for (let item of _data["attachedFiles"])
                    this.attachedFiles!.push(FileAttachmentDto.fromJS(item));
            }
            else {
                this.attachedFiles = <any>null;
            }
            this.createdByEmployeeFirstName = _data["createdByEmployeeFirstName"] !== undefined ? _data["createdByEmployeeFirstName"] : <any>null;
            this.createdByEmployeeLastName = _data["createdByEmployeeLastName"] !== undefined ? _data["createdByEmployeeLastName"] : <any>null;
        }
    }

    static fromJS(data: any): ServiceTicketNoteDto {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceTicketNoteDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["description"] = this.description !== undefined ? this.description : <any>null;
        data["createdDateTime"] = this.createdDateTime ? this.createdDateTime.toISOString() : <any>null;
        data["noteType"] = this.noteType !== undefined ? this.noteType : <any>null;
        if (Array.isArray(this.attachedFiles)) {
            data["attachedFiles"] = [];
            for (let item of this.attachedFiles)
                data["attachedFiles"].push(item.toJSON());
        }
        data["createdByEmployeeFirstName"] = this.createdByEmployeeFirstName !== undefined ? this.createdByEmployeeFirstName : <any>null;
        data["createdByEmployeeLastName"] = this.createdByEmployeeLastName !== undefined ? this.createdByEmployeeLastName : <any>null;
        return data;
    }
}

export interface IServiceTicketNoteDto {
    id?: number;
    description?: string | null;
    createdDateTime?: moment.Moment;
    noteType?: ServiceTicketNoteType;
    attachedFiles?: FileAttachmentDto[] | null;
    createdByEmployeeFirstName?: string | null;
    createdByEmployeeLastName?: string | null;
}

export class ServiceTicketCategoryDto implements IServiceTicketCategoryDto {
    id?: number;
    name?: string | null;
    isArchived?: boolean;

    constructor(data?: IServiceTicketCategoryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.isArchived = _data["isArchived"] !== undefined ? _data["isArchived"] : <any>null;
        }
    }

    static fromJS(data: any): ServiceTicketCategoryDto {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceTicketCategoryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["isArchived"] = this.isArchived !== undefined ? this.isArchived : <any>null;
        return data;
    }
}

export interface IServiceTicketCategoryDto {
    id?: number;
    name?: string | null;
    isArchived?: boolean;
}

export class AssignEmployeeToServiceTicketCommand implements IAssignEmployeeToServiceTicketCommand {
    employeeId?: string | null;
    serviceTicketIds?: number[] | null;

    constructor(data?: IAssignEmployeeToServiceTicketCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.employeeId = _data["employeeId"] !== undefined ? _data["employeeId"] : <any>null;
            if (Array.isArray(_data["serviceTicketIds"])) {
                this.serviceTicketIds = [] as any;
                for (let item of _data["serviceTicketIds"])
                    this.serviceTicketIds!.push(item);
            }
            else {
                this.serviceTicketIds = <any>null;
            }
        }
    }

    static fromJS(data: any): AssignEmployeeToServiceTicketCommand {
        data = typeof data === 'object' ? data : {};
        let result = new AssignEmployeeToServiceTicketCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["employeeId"] = this.employeeId !== undefined ? this.employeeId : <any>null;
        if (Array.isArray(this.serviceTicketIds)) {
            data["serviceTicketIds"] = [];
            for (let item of this.serviceTicketIds)
                data["serviceTicketIds"].push(item);
        }
        return data;
    }
}

export interface IAssignEmployeeToServiceTicketCommand {
    employeeId?: string | null;
    serviceTicketIds?: number[] | null;
}

export class UnassignEmployeeOnServiceTicketCommand implements IUnassignEmployeeOnServiceTicketCommand {
    serviceTicketIds?: number[] | null;

    constructor(data?: IUnassignEmployeeOnServiceTicketCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["serviceTicketIds"])) {
                this.serviceTicketIds = [] as any;
                for (let item of _data["serviceTicketIds"])
                    this.serviceTicketIds!.push(item);
            }
            else {
                this.serviceTicketIds = <any>null;
            }
        }
    }

    static fromJS(data: any): UnassignEmployeeOnServiceTicketCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UnassignEmployeeOnServiceTicketCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.serviceTicketIds)) {
            data["serviceTicketIds"] = [];
            for (let item of this.serviceTicketIds)
                data["serviceTicketIds"].push(item);
        }
        return data;
    }
}

export interface IUnassignEmployeeOnServiceTicketCommand {
    serviceTicketIds?: number[] | null;
}

export class ChangeServiceTicketStatusCommand implements IChangeServiceTicketStatusCommand {
    id?: number;
    status?: ServiceTicketStatus;
    comment?: string | null;

    constructor(data?: IChangeServiceTicketStatusCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.status = _data["status"] !== undefined ? _data["status"] : <any>null;
            this.comment = _data["comment"] !== undefined ? _data["comment"] : <any>null;
        }
    }

    static fromJS(data: any): ChangeServiceTicketStatusCommand {
        data = typeof data === 'object' ? data : {};
        let result = new ChangeServiceTicketStatusCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["status"] = this.status !== undefined ? this.status : <any>null;
        data["comment"] = this.comment !== undefined ? this.comment : <any>null;
        return data;
    }
}

export interface IChangeServiceTicketStatusCommand {
    id?: number;
    status?: ServiceTicketStatus;
    comment?: string | null;
}

export class CancelServiceTicketCommand extends ChangeServiceTicketStatusCommand implements ICancelServiceTicketCommand {
    toChangeServiceTicketStatusCommand?: ChangeServiceTicketStatusCommand | null;

    constructor(data?: ICancelServiceTicketCommand) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.toChangeServiceTicketStatusCommand = _data["toChangeServiceTicketStatusCommand"] ? ChangeServiceTicketStatusCommand.fromJS(_data["toChangeServiceTicketStatusCommand"]) : <any>null;
        }
    }

    static override fromJS(data: any): CancelServiceTicketCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CancelServiceTicketCommand();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["toChangeServiceTicketStatusCommand"] = this.toChangeServiceTicketStatusCommand ? this.toChangeServiceTicketStatusCommand.toJSON() : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface ICancelServiceTicketCommand extends IChangeServiceTicketStatusCommand {
    toChangeServiceTicketStatusCommand?: ChangeServiceTicketStatusCommand | null;
}

export class SendSmsToSpecifiedNumbersCommand implements ISendSmsToSpecifiedNumbersCommand {
    fromPhoneNumber?: string | null;
    phoneNumbers?: string[] | null;
    message?: string | null;

    constructor(data?: ISendSmsToSpecifiedNumbersCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fromPhoneNumber = _data["fromPhoneNumber"] !== undefined ? _data["fromPhoneNumber"] : <any>null;
            if (Array.isArray(_data["phoneNumbers"])) {
                this.phoneNumbers = [] as any;
                for (let item of _data["phoneNumbers"])
                    this.phoneNumbers!.push(item);
            }
            else {
                this.phoneNumbers = <any>null;
            }
            this.message = _data["message"] !== undefined ? _data["message"] : <any>null;
        }
    }

    static fromJS(data: any): SendSmsToSpecifiedNumbersCommand {
        data = typeof data === 'object' ? data : {};
        let result = new SendSmsToSpecifiedNumbersCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fromPhoneNumber"] = this.fromPhoneNumber !== undefined ? this.fromPhoneNumber : <any>null;
        if (Array.isArray(this.phoneNumbers)) {
            data["phoneNumbers"] = [];
            for (let item of this.phoneNumbers)
                data["phoneNumbers"].push(item);
        }
        data["message"] = this.message !== undefined ? this.message : <any>null;
        return data;
    }
}

export interface ISendSmsToSpecifiedNumbersCommand {
    fromPhoneNumber?: string | null;
    phoneNumbers?: string[] | null;
    message?: string | null;
}

export class ConvertNumbersCSVToJsonCommand implements IConvertNumbersCSVToJsonCommand {
    fileBytes?: string | null;

    constructor(data?: IConvertNumbersCSVToJsonCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileBytes = _data["fileBytes"] !== undefined ? _data["fileBytes"] : <any>null;
        }
    }

    static fromJS(data: any): ConvertNumbersCSVToJsonCommand {
        data = typeof data === 'object' ? data : {};
        let result = new ConvertNumbersCSVToJsonCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileBytes"] = this.fileBytes !== undefined ? this.fileBytes : <any>null;
        return data;
    }
}

export interface IConvertNumbersCSVToJsonCommand {
    fileBytes?: string | null;
}

export class TmDashboardDto implements ITmDashboardDto {
    rdvPrisPerformance?: TmRdvPrisPerformanceDto | null;
    topAppointments?: TopTmRankDto[] | null;
    topAppels?: TopTmRankDto[] | null;
    topConversionPercents?: TopTmRankDto[] | null;
    tmPerformances?: TmPerformanceDto[] | null;
    totalOnlineAgents?: number;
    agentsWith100PlusAppointments?: number;
    totalCalls?: number;
    totalAgentsWithAppointments?: number;

    constructor(data?: ITmDashboardDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.rdvPrisPerformance = _data["rdvPrisPerformance"] ? TmRdvPrisPerformanceDto.fromJS(_data["rdvPrisPerformance"]) : <any>null;
            if (Array.isArray(_data["topAppointments"])) {
                this.topAppointments = [] as any;
                for (let item of _data["topAppointments"])
                    this.topAppointments!.push(TopTmRankDto.fromJS(item));
            }
            else {
                this.topAppointments = <any>null;
            }
            if (Array.isArray(_data["topAppels"])) {
                this.topAppels = [] as any;
                for (let item of _data["topAppels"])
                    this.topAppels!.push(TopTmRankDto.fromJS(item));
            }
            else {
                this.topAppels = <any>null;
            }
            if (Array.isArray(_data["topConversionPercents"])) {
                this.topConversionPercents = [] as any;
                for (let item of _data["topConversionPercents"])
                    this.topConversionPercents!.push(TopTmRankDto.fromJS(item));
            }
            else {
                this.topConversionPercents = <any>null;
            }
            if (Array.isArray(_data["tmPerformances"])) {
                this.tmPerformances = [] as any;
                for (let item of _data["tmPerformances"])
                    this.tmPerformances!.push(TmPerformanceDto.fromJS(item));
            }
            else {
                this.tmPerformances = <any>null;
            }
            this.totalOnlineAgents = _data["totalOnlineAgents"] !== undefined ? _data["totalOnlineAgents"] : <any>null;
            this.agentsWith100PlusAppointments = _data["agentsWith100PlusAppointments"] !== undefined ? _data["agentsWith100PlusAppointments"] : <any>null;
            this.totalCalls = _data["totalCalls"] !== undefined ? _data["totalCalls"] : <any>null;
            this.totalAgentsWithAppointments = _data["totalAgentsWithAppointments"] !== undefined ? _data["totalAgentsWithAppointments"] : <any>null;
        }
    }

    static fromJS(data: any): TmDashboardDto {
        data = typeof data === 'object' ? data : {};
        let result = new TmDashboardDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["rdvPrisPerformance"] = this.rdvPrisPerformance ? this.rdvPrisPerformance.toJSON() : <any>null;
        if (Array.isArray(this.topAppointments)) {
            data["topAppointments"] = [];
            for (let item of this.topAppointments)
                data["topAppointments"].push(item.toJSON());
        }
        if (Array.isArray(this.topAppels)) {
            data["topAppels"] = [];
            for (let item of this.topAppels)
                data["topAppels"].push(item.toJSON());
        }
        if (Array.isArray(this.topConversionPercents)) {
            data["topConversionPercents"] = [];
            for (let item of this.topConversionPercents)
                data["topConversionPercents"].push(item.toJSON());
        }
        if (Array.isArray(this.tmPerformances)) {
            data["tmPerformances"] = [];
            for (let item of this.tmPerformances)
                data["tmPerformances"].push(item.toJSON());
        }
        data["totalOnlineAgents"] = this.totalOnlineAgents !== undefined ? this.totalOnlineAgents : <any>null;
        data["agentsWith100PlusAppointments"] = this.agentsWith100PlusAppointments !== undefined ? this.agentsWith100PlusAppointments : <any>null;
        data["totalCalls"] = this.totalCalls !== undefined ? this.totalCalls : <any>null;
        data["totalAgentsWithAppointments"] = this.totalAgentsWithAppointments !== undefined ? this.totalAgentsWithAppointments : <any>null;
        return data;
    }
}

export interface ITmDashboardDto {
    rdvPrisPerformance?: TmRdvPrisPerformanceDto | null;
    topAppointments?: TopTmRankDto[] | null;
    topAppels?: TopTmRankDto[] | null;
    topConversionPercents?: TopTmRankDto[] | null;
    tmPerformances?: TmPerformanceDto[] | null;
    totalOnlineAgents?: number;
    agentsWith100PlusAppointments?: number;
    totalCalls?: number;
    totalAgentsWithAppointments?: number;
}

export class TmRdvPrisPerformanceDto implements ITmRdvPrisPerformanceDto {
    totalTodayAppointments?: number;
    totalNextdayAppointments?: number;
    totalFutureAppointments?: number;
    totalAppointments?: number;

    constructor(data?: ITmRdvPrisPerformanceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalTodayAppointments = _data["totalTodayAppointments"] !== undefined ? _data["totalTodayAppointments"] : <any>null;
            this.totalNextdayAppointments = _data["totalNextdayAppointments"] !== undefined ? _data["totalNextdayAppointments"] : <any>null;
            this.totalFutureAppointments = _data["totalFutureAppointments"] !== undefined ? _data["totalFutureAppointments"] : <any>null;
            this.totalAppointments = _data["totalAppointments"] !== undefined ? _data["totalAppointments"] : <any>null;
        }
    }

    static fromJS(data: any): TmRdvPrisPerformanceDto {
        data = typeof data === 'object' ? data : {};
        let result = new TmRdvPrisPerformanceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalTodayAppointments"] = this.totalTodayAppointments !== undefined ? this.totalTodayAppointments : <any>null;
        data["totalNextdayAppointments"] = this.totalNextdayAppointments !== undefined ? this.totalNextdayAppointments : <any>null;
        data["totalFutureAppointments"] = this.totalFutureAppointments !== undefined ? this.totalFutureAppointments : <any>null;
        data["totalAppointments"] = this.totalAppointments !== undefined ? this.totalAppointments : <any>null;
        return data;
    }
}

export interface ITmRdvPrisPerformanceDto {
    totalTodayAppointments?: number;
    totalNextdayAppointments?: number;
    totalFutureAppointments?: number;
    totalAppointments?: number;
}

export class TopTmRankDto implements ITopTmRankDto {
    tmName?: string | null;
    tmUsername?: string | null;
    metricValue?: number;

    constructor(data?: ITopTmRankDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tmName = _data["tmName"] !== undefined ? _data["tmName"] : <any>null;
            this.tmUsername = _data["tmUsername"] !== undefined ? _data["tmUsername"] : <any>null;
            this.metricValue = _data["metricValue"] !== undefined ? _data["metricValue"] : <any>null;
        }
    }

    static fromJS(data: any): TopTmRankDto {
        data = typeof data === 'object' ? data : {};
        let result = new TopTmRankDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tmName"] = this.tmName !== undefined ? this.tmName : <any>null;
        data["tmUsername"] = this.tmUsername !== undefined ? this.tmUsername : <any>null;
        data["metricValue"] = this.metricValue !== undefined ? this.metricValue : <any>null;
        return data;
    }
}

export interface ITopTmRankDto {
    tmName?: string | null;
    tmUsername?: string | null;
    metricValue?: number;
}

export class TmPerformanceDto implements ITmPerformanceDto {
    tmUsername?: string | null;
    tmName?: string | null;
    totalAppointments?: number;
    totalTodayAppointments?: number;
    totalNextdayAppointments?: number;
    totalFutureAppointments?: number;
    totalCalls?: number;
    conversionPercent?: number;
    appointmentRanking?: number;
    conversionRanking?: number;
    callRanking?: number;
    twilioTaskPerformance?: TmTwilioTaskPerformanceDto | null;

    constructor(data?: ITmPerformanceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tmUsername = _data["tmUsername"] !== undefined ? _data["tmUsername"] : <any>null;
            this.tmName = _data["tmName"] !== undefined ? _data["tmName"] : <any>null;
            this.totalAppointments = _data["totalAppointments"] !== undefined ? _data["totalAppointments"] : <any>null;
            this.totalTodayAppointments = _data["totalTodayAppointments"] !== undefined ? _data["totalTodayAppointments"] : <any>null;
            this.totalNextdayAppointments = _data["totalNextdayAppointments"] !== undefined ? _data["totalNextdayAppointments"] : <any>null;
            this.totalFutureAppointments = _data["totalFutureAppointments"] !== undefined ? _data["totalFutureAppointments"] : <any>null;
            this.totalCalls = _data["totalCalls"] !== undefined ? _data["totalCalls"] : <any>null;
            this.conversionPercent = _data["conversionPercent"] !== undefined ? _data["conversionPercent"] : <any>null;
            this.appointmentRanking = _data["appointmentRanking"] !== undefined ? _data["appointmentRanking"] : <any>null;
            this.conversionRanking = _data["conversionRanking"] !== undefined ? _data["conversionRanking"] : <any>null;
            this.callRanking = _data["callRanking"] !== undefined ? _data["callRanking"] : <any>null;
            this.twilioTaskPerformance = _data["twilioTaskPerformance"] ? TmTwilioTaskPerformanceDto.fromJS(_data["twilioTaskPerformance"]) : <any>null;
        }
    }

    static fromJS(data: any): TmPerformanceDto {
        data = typeof data === 'object' ? data : {};
        let result = new TmPerformanceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tmUsername"] = this.tmUsername !== undefined ? this.tmUsername : <any>null;
        data["tmName"] = this.tmName !== undefined ? this.tmName : <any>null;
        data["totalAppointments"] = this.totalAppointments !== undefined ? this.totalAppointments : <any>null;
        data["totalTodayAppointments"] = this.totalTodayAppointments !== undefined ? this.totalTodayAppointments : <any>null;
        data["totalNextdayAppointments"] = this.totalNextdayAppointments !== undefined ? this.totalNextdayAppointments : <any>null;
        data["totalFutureAppointments"] = this.totalFutureAppointments !== undefined ? this.totalFutureAppointments : <any>null;
        data["totalCalls"] = this.totalCalls !== undefined ? this.totalCalls : <any>null;
        data["conversionPercent"] = this.conversionPercent !== undefined ? this.conversionPercent : <any>null;
        data["appointmentRanking"] = this.appointmentRanking !== undefined ? this.appointmentRanking : <any>null;
        data["conversionRanking"] = this.conversionRanking !== undefined ? this.conversionRanking : <any>null;
        data["callRanking"] = this.callRanking !== undefined ? this.callRanking : <any>null;
        data["twilioTaskPerformance"] = this.twilioTaskPerformance ? this.twilioTaskPerformance.toJSON() : <any>null;
        return data;
    }
}

export interface ITmPerformanceDto {
    tmUsername?: string | null;
    tmName?: string | null;
    totalAppointments?: number;
    totalTodayAppointments?: number;
    totalNextdayAppointments?: number;
    totalFutureAppointments?: number;
    totalCalls?: number;
    conversionPercent?: number;
    appointmentRanking?: number;
    conversionRanking?: number;
    callRanking?: number;
    twilioTaskPerformance?: TmTwilioTaskPerformanceDto | null;
}

export class TmTwilioTaskPerformanceDto implements ITmTwilioTaskPerformanceDto {
    totalInCalls?: number;
    totalOutCalls?: number;
    totalCalls?: number;
    totalDurations?: number;
    averageDurations?: number;
    averageDurationsFormatted?: string | null;

    constructor(data?: ITmTwilioTaskPerformanceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalInCalls = _data["totalInCalls"] !== undefined ? _data["totalInCalls"] : <any>null;
            this.totalOutCalls = _data["totalOutCalls"] !== undefined ? _data["totalOutCalls"] : <any>null;
            this.totalCalls = _data["totalCalls"] !== undefined ? _data["totalCalls"] : <any>null;
            this.totalDurations = _data["totalDurations"] !== undefined ? _data["totalDurations"] : <any>null;
            this.averageDurations = _data["averageDurations"] !== undefined ? _data["averageDurations"] : <any>null;
            this.averageDurationsFormatted = _data["averageDurationsFormatted"] !== undefined ? _data["averageDurationsFormatted"] : <any>null;
        }
    }

    static fromJS(data: any): TmTwilioTaskPerformanceDto {
        data = typeof data === 'object' ? data : {};
        let result = new TmTwilioTaskPerformanceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalInCalls"] = this.totalInCalls !== undefined ? this.totalInCalls : <any>null;
        data["totalOutCalls"] = this.totalOutCalls !== undefined ? this.totalOutCalls : <any>null;
        data["totalCalls"] = this.totalCalls !== undefined ? this.totalCalls : <any>null;
        data["totalDurations"] = this.totalDurations !== undefined ? this.totalDurations : <any>null;
        data["averageDurations"] = this.averageDurations !== undefined ? this.averageDurations : <any>null;
        data["averageDurationsFormatted"] = this.averageDurationsFormatted !== undefined ? this.averageDurationsFormatted : <any>null;
        return data;
    }
}

export interface ITmTwilioTaskPerformanceDto {
    totalInCalls?: number;
    totalOutCalls?: number;
    totalCalls?: number;
    totalDurations?: number;
    averageDurations?: number;
    averageDurationsFormatted?: string | null;
}

export class GetTmDashboardMetricQuery implements IGetTmDashboardMetricQuery {

    constructor(data?: IGetTmDashboardMetricQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): GetTmDashboardMetricQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetTmDashboardMetricQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IGetTmDashboardMetricQuery {
}

export class CreateVideoCommand extends CommonMediaCommand implements ICreateVideoCommand {

    constructor(data?: ICreateVideoCommand) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): CreateVideoCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateVideoCommand();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface ICreateVideoCommand extends ICommonMediaCommand {
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class SwaggerException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isSwaggerException = true;

    static isSwaggerException(obj: any): obj is SwaggerException {
        return obj.isSwaggerException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if (result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new SwaggerException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader();
            reader.onload = event => {
                observer.next((event.target as any).result);
                observer.complete();
            };
            reader.readAsText(blob);
        }
    });
}